
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff7f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff7f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ho8Ig", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $ca8b6fc20fde6bea$export$ffb0004e005737fa, (v) => $ca8b6fc20fde6bea$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $ca8b6fc20fde6bea$export$34b9dba7ce09269b, (v) => $ca8b6fc20fde6bea$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $ca8b6fc20fde6bea$export$25062201e9e25d76, (v) => $ca8b6fc20fde6bea$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ca8b6fc20fde6bea$export$ffb0004e005737fa;
var $ca8b6fc20fde6bea$export$34b9dba7ce09269b;
var $ca8b6fc20fde6bea$export$25062201e9e25d76;
"use strict";
var $ca8b6fc20fde6bea$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ca8b6fc20fde6bea$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $ca8b6fc20fde6bea$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $ca8b6fc20fde6bea$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$ca8b6fc20fde6bea$export$ffb0004e005737fa = $ca8b6fc20fde6bea$var$REACT_FRAGMENT_TYPE;
$ca8b6fc20fde6bea$export$34b9dba7ce09269b = $ca8b6fc20fde6bea$var$jsxProd;
$ca8b6fc20fde6bea$export$25062201e9e25d76 = $ca8b6fc20fde6bea$var$jsxProd;

});

parcelRegister("j7kdz", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $deae5a9825218b42$export$9c16c1426311996d, (v) => $deae5a9825218b42$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $deae5a9825218b42$export$dca3b0875bd9a954, (v) => $deae5a9825218b42$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $deae5a9825218b42$export$16fa2f45be04daa8, (v) => $deae5a9825218b42$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $deae5a9825218b42$export$ffb0004e005737fa, (v) => $deae5a9825218b42$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $deae5a9825218b42$export$e2c29f18771995cb, (v) => $deae5a9825218b42$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $deae5a9825218b42$export$221d75b3f55bb0bd, (v) => $deae5a9825218b42$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $deae5a9825218b42$export$5f8d39834fd61797, (v) => $deae5a9825218b42$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $deae5a9825218b42$export$74bf444e3cd11ea5, (v) => $deae5a9825218b42$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $deae5a9825218b42$export$1ced07cd6b1985ce, (v) => $deae5a9825218b42$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $deae5a9825218b42$export$abd8e32b826d7ea7, (v) => $deae5a9825218b42$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $deae5a9825218b42$export$69a3209f1a06c04d, (v) => $deae5a9825218b42$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $deae5a9825218b42$export$8c538325882c7eec, (v) => $deae5a9825218b42$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $deae5a9825218b42$export$e530037191fcd5d7, (v) => $deae5a9825218b42$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $deae5a9825218b42$export$fd42f52fd3ae1109, (v) => $deae5a9825218b42$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $deae5a9825218b42$export$c8a8987d4410bf2d, (v) => $deae5a9825218b42$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $deae5a9825218b42$export$7d1e3a5e95ceca43, (v) => $deae5a9825218b42$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $deae5a9825218b42$export$257a8862b851cb5b, (v) => $deae5a9825218b42$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $deae5a9825218b42$export$a8257692ac88316c, (v) => $deae5a9825218b42$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $deae5a9825218b42$export$488013bae63b21da, (v) => $deae5a9825218b42$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $deae5a9825218b42$export$7c73462e0d25e514, (v) => $deae5a9825218b42$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $deae5a9825218b42$export$7568632d0d33d16d, (v) => $deae5a9825218b42$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $deae5a9825218b42$export$f93f40ac0ca7e3a8, (v) => $deae5a9825218b42$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $deae5a9825218b42$export$1f96ae73734a86cc, (v) => $deae5a9825218b42$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $deae5a9825218b42$export$9a47ced3238df325, (v) => $deae5a9825218b42$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $deae5a9825218b42$export$35808ee640e87ca7, (v) => $deae5a9825218b42$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $deae5a9825218b42$export$fae74005e78b1a27, (v) => $deae5a9825218b42$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $deae5a9825218b42$export$dc8fbce3eb94dc1e, (v) => $deae5a9825218b42$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $deae5a9825218b42$export$6a7bc4e911dc01cf, (v) => $deae5a9825218b42$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $deae5a9825218b42$export$6d9c69b0de29b591, (v) => $deae5a9825218b42$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $deae5a9825218b42$export$7f54fc3180508a52, (v) => $deae5a9825218b42$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $deae5a9825218b42$export$f680877a34711e37, (v) => $deae5a9825218b42$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $deae5a9825218b42$export$d5a552a76deda3c2, (v) => $deae5a9825218b42$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $deae5a9825218b42$export$aaabe4eda9ed9969, (v) => $deae5a9825218b42$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $deae5a9825218b42$export$e5c5a5f917a5871c, (v) => $deae5a9825218b42$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $deae5a9825218b42$export$1538c33de8887b59, (v) => $deae5a9825218b42$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $deae5a9825218b42$export$fca7f784ae7a249a, (v) => $deae5a9825218b42$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $deae5a9825218b42$export$13e3392192263954, (v) => $deae5a9825218b42$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $deae5a9825218b42$export$b8f5890fc79d6aca, (v) => $deae5a9825218b42$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $deae5a9825218b42$export$60241385465d0a34, (v) => $deae5a9825218b42$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $deae5a9825218b42$export$306c0aa65ff9ec16, (v) => $deae5a9825218b42$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $deae5a9825218b42$export$7b286972b8d8ccbf, (v) => $deae5a9825218b42$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $deae5a9825218b42$export$83d89fbfd8236492, (v) => $deae5a9825218b42$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $deae5a9825218b42$export$9c16c1426311996d;
var $deae5a9825218b42$export$dca3b0875bd9a954;
var $deae5a9825218b42$export$16fa2f45be04daa8;
var $deae5a9825218b42$export$ffb0004e005737fa;
var $deae5a9825218b42$export$e2c29f18771995cb;
var $deae5a9825218b42$export$221d75b3f55bb0bd;
var $deae5a9825218b42$export$5f8d39834fd61797;
var $deae5a9825218b42$export$74bf444e3cd11ea5;
var $deae5a9825218b42$export$1ced07cd6b1985ce;
var $deae5a9825218b42$export$abd8e32b826d7ea7;
var $deae5a9825218b42$export$69a3209f1a06c04d;
var $deae5a9825218b42$export$8c538325882c7eec;
var $deae5a9825218b42$export$e530037191fcd5d7;
var $deae5a9825218b42$export$fd42f52fd3ae1109;
var $deae5a9825218b42$export$c8a8987d4410bf2d;
var $deae5a9825218b42$export$7d1e3a5e95ceca43;
var $deae5a9825218b42$export$257a8862b851cb5b;
var $deae5a9825218b42$export$a8257692ac88316c;
var $deae5a9825218b42$export$488013bae63b21da;
var $deae5a9825218b42$export$7c73462e0d25e514;
var $deae5a9825218b42$export$7568632d0d33d16d;
var $deae5a9825218b42$export$f93f40ac0ca7e3a8;
var $deae5a9825218b42$export$1f96ae73734a86cc;
var $deae5a9825218b42$export$9a47ced3238df325;
var $deae5a9825218b42$export$35808ee640e87ca7;
var $deae5a9825218b42$export$fae74005e78b1a27;
var $deae5a9825218b42$export$dc8fbce3eb94dc1e;
var $deae5a9825218b42$export$6a7bc4e911dc01cf;
var $deae5a9825218b42$export$6d9c69b0de29b591;
var $deae5a9825218b42$export$7f54fc3180508a52;
var $deae5a9825218b42$export$f680877a34711e37;
var $deae5a9825218b42$export$d5a552a76deda3c2;
var $deae5a9825218b42$export$aaabe4eda9ed9969;
var $deae5a9825218b42$export$e5c5a5f917a5871c;
var $deae5a9825218b42$export$1538c33de8887b59;
var $deae5a9825218b42$export$fca7f784ae7a249a;
var $deae5a9825218b42$export$13e3392192263954;
var $deae5a9825218b42$export$b8f5890fc79d6aca;
var $deae5a9825218b42$export$60241385465d0a34;
var $deae5a9825218b42$export$306c0aa65ff9ec16;
var $deae5a9825218b42$export$7b286972b8d8ccbf;
var $deae5a9825218b42$export$83d89fbfd8236492;
"use strict";
var $deae5a9825218b42$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $deae5a9825218b42$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $deae5a9825218b42$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $deae5a9825218b42$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $deae5a9825218b42$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $deae5a9825218b42$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $deae5a9825218b42$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $deae5a9825218b42$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $deae5a9825218b42$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $deae5a9825218b42$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $deae5a9825218b42$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $deae5a9825218b42$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $deae5a9825218b42$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $deae5a9825218b42$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $deae5a9825218b42$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$deae5a9825218b42$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $deae5a9825218b42$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $deae5a9825218b42$var$assign = Object.assign, $deae5a9825218b42$var$emptyObject = {};
function $deae5a9825218b42$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $deae5a9825218b42$var$emptyObject;
    this.updater = updater || $deae5a9825218b42$var$ReactNoopUpdateQueue;
}
$deae5a9825218b42$var$Component.prototype.isReactComponent = {};
$deae5a9825218b42$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$deae5a9825218b42$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $deae5a9825218b42$var$ComponentDummy() {}
$deae5a9825218b42$var$ComponentDummy.prototype = $deae5a9825218b42$var$Component.prototype;
function $deae5a9825218b42$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $deae5a9825218b42$var$emptyObject;
    this.updater = updater || $deae5a9825218b42$var$ReactNoopUpdateQueue;
}
var $deae5a9825218b42$var$pureComponentPrototype = $deae5a9825218b42$var$PureComponent.prototype = new $deae5a9825218b42$var$ComponentDummy();
$deae5a9825218b42$var$pureComponentPrototype.constructor = $deae5a9825218b42$var$PureComponent;
$deae5a9825218b42$var$assign($deae5a9825218b42$var$pureComponentPrototype, $deae5a9825218b42$var$Component.prototype);
$deae5a9825218b42$var$pureComponentPrototype.isPureReactComponent = !0;
var $deae5a9825218b42$var$isArrayImpl = Array.isArray;
function $deae5a9825218b42$var$noop() {}
var $deae5a9825218b42$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $deae5a9825218b42$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $deae5a9825218b42$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $deae5a9825218b42$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $deae5a9825218b42$var$cloneAndReplaceKey(oldElement, newKey) {
    return $deae5a9825218b42$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $deae5a9825218b42$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $deae5a9825218b42$var$REACT_ELEMENT_TYPE;
}
function $deae5a9825218b42$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $deae5a9825218b42$var$userProvidedKeyEscapeRegex = /\/+/g;
function $deae5a9825218b42$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $deae5a9825218b42$var$escape("" + element.key) : index.toString(36);
}
function $deae5a9825218b42$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($deae5a9825218b42$var$noop, $deae5a9825218b42$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $deae5a9825218b42$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $deae5a9825218b42$var$REACT_ELEMENT_TYPE:
                case $deae5a9825218b42$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $deae5a9825218b42$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $deae5a9825218b42$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $deae5a9825218b42$var$getElementKey(children, 0) : nameSoFar, $deae5a9825218b42$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($deae5a9825218b42$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $deae5a9825218b42$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($deae5a9825218b42$var$isValidElement(callback) && (callback = $deae5a9825218b42$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($deae5a9825218b42$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($deae5a9825218b42$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $deae5a9825218b42$var$getElementKey(nameSoFar, i), invokeCallback += $deae5a9825218b42$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $deae5a9825218b42$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $deae5a9825218b42$var$getElementKey(nameSoFar, i++), invokeCallback += $deae5a9825218b42$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $deae5a9825218b42$var$mapIntoArray($deae5a9825218b42$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $deae5a9825218b42$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $deae5a9825218b42$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $deae5a9825218b42$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $deae5a9825218b42$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $deae5a9825218b42$var$Children = {
    map: $deae5a9825218b42$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $deae5a9825218b42$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $deae5a9825218b42$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $deae5a9825218b42$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$deae5a9825218b42$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$deae5a9825218b42$export$9c16c1426311996d = $deae5a9825218b42$var$REACT_ACTIVITY_TYPE;
$deae5a9825218b42$export$dca3b0875bd9a954 = $deae5a9825218b42$var$Children;
$deae5a9825218b42$export$16fa2f45be04daa8 = $deae5a9825218b42$var$Component;
$deae5a9825218b42$export$ffb0004e005737fa = $deae5a9825218b42$var$REACT_FRAGMENT_TYPE;
$deae5a9825218b42$export$e2c29f18771995cb = $deae5a9825218b42$var$REACT_PROFILER_TYPE;
$deae5a9825218b42$export$221d75b3f55bb0bd = $deae5a9825218b42$var$PureComponent;
$deae5a9825218b42$export$5f8d39834fd61797 = $deae5a9825218b42$var$REACT_STRICT_MODE_TYPE;
$deae5a9825218b42$export$74bf444e3cd11ea5 = $deae5a9825218b42$var$REACT_SUSPENSE_TYPE;
$deae5a9825218b42$export$1ced07cd6b1985ce = $deae5a9825218b42$var$ReactSharedInternals;
$deae5a9825218b42$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $deae5a9825218b42$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$deae5a9825218b42$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$deae5a9825218b42$export$8c538325882c7eec = function() {
    return null;
};
$deae5a9825218b42$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $deae5a9825218b42$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$deae5a9825218b42$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $deae5a9825218b42$var$ReactElement(element.type, key, props);
};
$deae5a9825218b42$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $deae5a9825218b42$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $deae5a9825218b42$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$deae5a9825218b42$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$deae5a9825218b42$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $deae5a9825218b42$var$ReactElement(type, key, props);
};
$deae5a9825218b42$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$deae5a9825218b42$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $deae5a9825218b42$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$deae5a9825218b42$export$a8257692ac88316c = $deae5a9825218b42$var$isValidElement;
$deae5a9825218b42$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $deae5a9825218b42$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $deae5a9825218b42$var$lazyInitializer
    };
};
$deae5a9825218b42$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $deae5a9825218b42$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$deae5a9825218b42$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $deae5a9825218b42$var$ReactSharedInternals.T, currentTransition = {};
    $deae5a9825218b42$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $deae5a9825218b42$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($deae5a9825218b42$var$noop, $deae5a9825218b42$var$reportGlobalError);
    } catch (error) {
        $deae5a9825218b42$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $deae5a9825218b42$var$ReactSharedInternals.T = prevTransition;
    }
};
$deae5a9825218b42$export$f93f40ac0ca7e3a8 = function() {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useCacheRefresh();
};
$deae5a9825218b42$export$1f96ae73734a86cc = function(usable) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.use(usable);
};
$deae5a9825218b42$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$deae5a9825218b42$export$35808ee640e87ca7 = function(callback, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$deae5a9825218b42$export$fae74005e78b1a27 = function(Context) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useContext(Context);
};
$deae5a9825218b42$export$dc8fbce3eb94dc1e = function() {};
$deae5a9825218b42$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$deae5a9825218b42$export$6d9c69b0de29b591 = function(create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useEffect(create, deps);
};
$deae5a9825218b42$export$7f54fc3180508a52 = function(callback) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$deae5a9825218b42$export$f680877a34711e37 = function() {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useId();
};
$deae5a9825218b42$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$deae5a9825218b42$export$aaabe4eda9ed9969 = function(create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$deae5a9825218b42$export$e5c5a5f917a5871c = function(create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$deae5a9825218b42$export$1538c33de8887b59 = function(create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useMemo(create, deps);
};
$deae5a9825218b42$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$deae5a9825218b42$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$deae5a9825218b42$export$b8f5890fc79d6aca = function(initialValue) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useRef(initialValue);
};
$deae5a9825218b42$export$60241385465d0a34 = function(initialState) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useState(initialState);
};
$deae5a9825218b42$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$deae5a9825218b42$export$7b286972b8d8ccbf = function() {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useTransition();
};
$deae5a9825218b42$export$83d89fbfd8236492 = "19.2.3";

});

parcelRegister("fbV55", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $b0f42935ea826c41$export$882461b6382ed46c, (v) => $b0f42935ea826c41$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $b0f42935ea826c41$export$757ceba2d55c277e, (v) => $b0f42935ea826c41$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $b0f42935ea826c41$export$83d89fbfd8236492, (v) => $b0f42935ea826c41$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b0f42935ea826c41$export$882461b6382ed46c;
var $b0f42935ea826c41$export$757ceba2d55c277e;
var $b0f42935ea826c41$export$83d89fbfd8236492;
"use strict";

var $bIbqH = parcelRequire("bIbqH");

var $jXEQt = parcelRequire("jXEQt");

var $8vWo2 = parcelRequire("8vWo2");
function $b0f42935ea826c41$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b0f42935ea826c41$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $b0f42935ea826c41$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $b0f42935ea826c41$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $b0f42935ea826c41$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $b0f42935ea826c41$var$assertIsMounted(fiber) {
    if ($b0f42935ea826c41$var$getNearestMountedFiber(fiber) !== fiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
}
function $b0f42935ea826c41$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $b0f42935ea826c41$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $b0f42935ea826c41$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $b0f42935ea826c41$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $b0f42935ea826c41$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $b0f42935ea826c41$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $b0f42935ea826c41$var$assign = Object.assign, $b0f42935ea826c41$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $b0f42935ea826c41$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b0f42935ea826c41$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b0f42935ea826c41$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b0f42935ea826c41$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b0f42935ea826c41$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b0f42935ea826c41$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b0f42935ea826c41$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b0f42935ea826c41$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b0f42935ea826c41$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b0f42935ea826c41$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b0f42935ea826c41$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $b0f42935ea826c41$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $b0f42935ea826c41$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $b0f42935ea826c41$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b0f42935ea826c41$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b0f42935ea826c41$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b0f42935ea826c41$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b0f42935ea826c41$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b0f42935ea826c41$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $b0f42935ea826c41$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $b0f42935ea826c41$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $b0f42935ea826c41$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $b0f42935ea826c41$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $b0f42935ea826c41$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $b0f42935ea826c41$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $b0f42935ea826c41$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $b0f42935ea826c41$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $b0f42935ea826c41$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $b0f42935ea826c41$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $b0f42935ea826c41$var$getComponentNameFromType(type.type) || "Memo";
        case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $b0f42935ea826c41$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $b0f42935ea826c41$var$isArrayImpl = Array.isArray, $b0f42935ea826c41$var$ReactSharedInternals = $jXEQt.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b0f42935ea826c41$var$ReactDOMSharedInternals = $8vWo2.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b0f42935ea826c41$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $b0f42935ea826c41$var$valueStack = [], $b0f42935ea826c41$var$index = -1;
function $b0f42935ea826c41$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $b0f42935ea826c41$var$pop(cursor) {
    0 > $b0f42935ea826c41$var$index || (cursor.current = $b0f42935ea826c41$var$valueStack[$b0f42935ea826c41$var$index], $b0f42935ea826c41$var$valueStack[$b0f42935ea826c41$var$index] = null, $b0f42935ea826c41$var$index--);
}
function $b0f42935ea826c41$var$push(cursor, value) {
    $b0f42935ea826c41$var$index++;
    $b0f42935ea826c41$var$valueStack[$b0f42935ea826c41$var$index] = cursor.current;
    cursor.current = value;
}
var $b0f42935ea826c41$var$contextStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$contextFiberStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$rootInstanceStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$hostTransitionProviderCursor = $b0f42935ea826c41$var$createCursor(null);
function $b0f42935ea826c41$var$pushHostContainer(fiber, nextRootInstance) {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$rootInstanceStackCursor, nextRootInstance);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextFiberStackCursor, fiber);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $b0f42935ea826c41$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $b0f42935ea826c41$var$getOwnHostContext(nextRootInstance), fiber = $b0f42935ea826c41$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextStackCursor);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextStackCursor, fiber);
}
function $b0f42935ea826c41$var$popHostContainer() {
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextStackCursor);
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextFiberStackCursor);
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$rootInstanceStackCursor);
}
function $b0f42935ea826c41$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $b0f42935ea826c41$var$push($b0f42935ea826c41$var$hostTransitionProviderCursor, fiber);
    var context = $b0f42935ea826c41$var$contextStackCursor.current;
    var JSCompiler_inline_result = $b0f42935ea826c41$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextFiberStackCursor, fiber), $b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextStackCursor, JSCompiler_inline_result));
}
function $b0f42935ea826c41$var$popHostContext(fiber) {
    $b0f42935ea826c41$var$contextFiberStackCursor.current === fiber && ($b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextStackCursor), $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextFiberStackCursor));
    $b0f42935ea826c41$var$hostTransitionProviderCursor.current === fiber && ($b0f42935ea826c41$var$pop($b0f42935ea826c41$var$hostTransitionProviderCursor), $b0f42935ea826c41$var$HostTransitionContext._currentValue = $b0f42935ea826c41$var$sharedNotPendingObject);
}
var $b0f42935ea826c41$var$prefix, $b0f42935ea826c41$var$suffix;
function $b0f42935ea826c41$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $b0f42935ea826c41$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $b0f42935ea826c41$var$prefix = match && match[1] || "";
        $b0f42935ea826c41$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $b0f42935ea826c41$var$prefix + name + $b0f42935ea826c41$var$suffix;
}
var $b0f42935ea826c41$var$reentry = !1;
function $b0f42935ea826c41$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $b0f42935ea826c41$var$reentry) return "";
    $b0f42935ea826c41$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $b0f42935ea826c41$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $b0f42935ea826c41$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $b0f42935ea826c41$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $b0f42935ea826c41$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $b0f42935ea826c41$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $b0f42935ea826c41$var$describeBuiltInComponentFrame("Suspense Fallback") : $b0f42935ea826c41$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $b0f42935ea826c41$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $b0f42935ea826c41$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $b0f42935ea826c41$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $b0f42935ea826c41$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $b0f42935ea826c41$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $b0f42935ea826c41$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $b0f42935ea826c41$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $b0f42935ea826c41$var$hasOwnProperty = Object.prototype.hasOwnProperty, $b0f42935ea826c41$var$scheduleCallback$3 = $bIbqH.unstable_scheduleCallback, $b0f42935ea826c41$var$cancelCallback$1 = $bIbqH.unstable_cancelCallback, $b0f42935ea826c41$var$shouldYield = $bIbqH.unstable_shouldYield, $b0f42935ea826c41$var$requestPaint = $bIbqH.unstable_requestPaint, $b0f42935ea826c41$var$now = $bIbqH.unstable_now, $b0f42935ea826c41$var$getCurrentPriorityLevel = $bIbqH.unstable_getCurrentPriorityLevel, $b0f42935ea826c41$var$ImmediatePriority = $bIbqH.unstable_ImmediatePriority, $b0f42935ea826c41$var$UserBlockingPriority = $bIbqH.unstable_UserBlockingPriority, $b0f42935ea826c41$var$NormalPriority$1 = $bIbqH.unstable_NormalPriority, $b0f42935ea826c41$var$LowPriority = $bIbqH.unstable_LowPriority, $b0f42935ea826c41$var$IdlePriority = $bIbqH.unstable_IdlePriority, $b0f42935ea826c41$var$log$1 = $bIbqH.log, $b0f42935ea826c41$var$unstable_setDisableYieldValue = $bIbqH.unstable_setDisableYieldValue, $b0f42935ea826c41$var$rendererID = null, $b0f42935ea826c41$var$injectedHook = null;
function $b0f42935ea826c41$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $b0f42935ea826c41$var$log$1 && $b0f42935ea826c41$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($b0f42935ea826c41$var$injectedHook && "function" === typeof $b0f42935ea826c41$var$injectedHook.setStrictMode) try {
        $b0f42935ea826c41$var$injectedHook.setStrictMode($b0f42935ea826c41$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $b0f42935ea826c41$var$clz32 = Math.clz32 ? Math.clz32 : $b0f42935ea826c41$var$clz32Fallback, $b0f42935ea826c41$var$log = Math.log, $b0f42935ea826c41$var$LN2 = Math.LN2;
function $b0f42935ea826c41$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($b0f42935ea826c41$var$log(x) / $b0f42935ea826c41$var$LN2 | 0) | 0;
}
var $b0f42935ea826c41$var$nextTransitionUpdateLane = 256, $b0f42935ea826c41$var$nextTransitionDeferredLane = 262144, $b0f42935ea826c41$var$nextRetryLane = 4194304;
function $b0f42935ea826c41$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $b0f42935ea826c41$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $b0f42935ea826c41$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $b0f42935ea826c41$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b0f42935ea826c41$var$claimNextRetryLane() {
    var lane = $b0f42935ea826c41$var$nextRetryLane;
    $b0f42935ea826c41$var$nextRetryLane <<= 1;
    0 === ($b0f42935ea826c41$var$nextRetryLane & 62914560) && ($b0f42935ea826c41$var$nextRetryLane = 4194304);
    return lane;
}
function $b0f42935ea826c41$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $b0f42935ea826c41$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $b0f42935ea826c41$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $b0f42935ea826c41$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $b0f42935ea826c41$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $b0f42935ea826c41$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $b0f42935ea826c41$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $b0f42935ea826c41$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $b0f42935ea826c41$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $b0f42935ea826c41$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $b0f42935ea826c41$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $b0f42935ea826c41$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $b0f42935ea826c41$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $b0f42935ea826c41$var$resolveUpdatePriority() {
    var updatePriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $b0f42935ea826c41$var$getEventPriority(updatePriority.type);
}
function $b0f42935ea826c41$var$runWithPriority(priority, fn) {
    var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    try {
        return $b0f42935ea826c41$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $b0f42935ea826c41$var$randomKey = Math.random().toString(36).slice(2), $b0f42935ea826c41$var$internalInstanceKey = "__reactFiber$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalPropsKey = "__reactProps$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalContainerInstanceKey = "__reactContainer$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalEventHandlersKey = "__reactEvents$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalEventHandlerListenersKey = "__reactListeners$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalEventHandlesSetKey = "__reactHandles$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalRootNodeResourcesKey = "__reactResources$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalHoistableMarker = "__reactMarker$" + $b0f42935ea826c41$var$randomKey;
function $b0f42935ea826c41$var$detachDeletedInstance(node) {
    delete node[$b0f42935ea826c41$var$internalInstanceKey];
    delete node[$b0f42935ea826c41$var$internalPropsKey];
    delete node[$b0f42935ea826c41$var$internalEventHandlersKey];
    delete node[$b0f42935ea826c41$var$internalEventHandlerListenersKey];
    delete node[$b0f42935ea826c41$var$internalEventHandlesSetKey];
}
function $b0f42935ea826c41$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$b0f42935ea826c41$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$b0f42935ea826c41$var$internalContainerInstanceKey] || parentNode[$b0f42935ea826c41$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $b0f42935ea826c41$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$b0f42935ea826c41$var$internalInstanceKey]) return parentNode;
                targetNode = $b0f42935ea826c41$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $b0f42935ea826c41$var$getInstanceFromNode(node) {
    if (node = node[$b0f42935ea826c41$var$internalInstanceKey] || node[$b0f42935ea826c41$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $b0f42935ea826c41$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(33));
}
function $b0f42935ea826c41$var$getResourcesFromRoot(root) {
    var resources = root[$b0f42935ea826c41$var$internalRootNodeResourcesKey];
    resources || (resources = root[$b0f42935ea826c41$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $b0f42935ea826c41$var$markNodeAsHoistable(node) {
    node[$b0f42935ea826c41$var$internalHoistableMarker] = !0;
}
var $b0f42935ea826c41$var$allNativeEvents = new Set(), $b0f42935ea826c41$var$registrationNameDependencies = {};
function $b0f42935ea826c41$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $b0f42935ea826c41$var$registerDirectEvent(registrationName, dependencies);
    $b0f42935ea826c41$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $b0f42935ea826c41$var$registerDirectEvent(registrationName, dependencies) {
    $b0f42935ea826c41$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$b0f42935ea826c41$var$allNativeEvents.add(dependencies[registrationName]);
}
var $b0f42935ea826c41$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $b0f42935ea826c41$var$illegalAttributeNameCache = {}, $b0f42935ea826c41$var$validatedAttributeNameCache = {};
function $b0f42935ea826c41$var$isAttributeNameSafe(attributeName) {
    if ($b0f42935ea826c41$var$hasOwnProperty.call($b0f42935ea826c41$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($b0f42935ea826c41$var$hasOwnProperty.call($b0f42935ea826c41$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($b0f42935ea826c41$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $b0f42935ea826c41$var$validatedAttributeNameCache[attributeName] = !0;
    $b0f42935ea826c41$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $b0f42935ea826c41$var$setValueForAttribute(node, name, value) {
    if ($b0f42935ea826c41$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $b0f42935ea826c41$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $b0f42935ea826c41$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $b0f42935ea826c41$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $b0f42935ea826c41$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $b0f42935ea826c41$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $b0f42935ea826c41$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $b0f42935ea826c41$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $b0f42935ea826c41$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $b0f42935ea826c41$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $b0f42935ea826c41$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $b0f42935ea826c41$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $b0f42935ea826c41$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $b0f42935ea826c41$var$getToStringValue(value);
        } else element.value !== "" + $b0f42935ea826c41$var$getToStringValue(value) && (element.value = "" + $b0f42935ea826c41$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $b0f42935ea826c41$var$setDefaultValue(element, type, $b0f42935ea826c41$var$getToStringValue(value)) : null != defaultValue ? $b0f42935ea826c41$var$setDefaultValue(element, type, $b0f42935ea826c41$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $b0f42935ea826c41$var$getToStringValue(name) : element.removeAttribute("name");
}
function $b0f42935ea826c41$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $b0f42935ea826c41$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $b0f42935ea826c41$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $b0f42935ea826c41$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $b0f42935ea826c41$var$track(element);
}
function $b0f42935ea826c41$var$setDefaultValue(node, type, value) {
    "number" === type && $b0f42935ea826c41$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $b0f42935ea826c41$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $b0f42935ea826c41$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $b0f42935ea826c41$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $b0f42935ea826c41$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $b0f42935ea826c41$var$getToStringValue(defaultValue) : "";
}
function $b0f42935ea826c41$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(92));
            if ($b0f42935ea826c41$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $b0f42935ea826c41$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $b0f42935ea826c41$var$track(element);
}
function $b0f42935ea826c41$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $b0f42935ea826c41$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $b0f42935ea826c41$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $b0f42935ea826c41$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $b0f42935ea826c41$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $b0f42935ea826c41$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $b0f42935ea826c41$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $b0f42935ea826c41$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b0f42935ea826c41$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $b0f42935ea826c41$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $b0f42935ea826c41$var$sanitizeURL(url) {
    return $b0f42935ea826c41$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $b0f42935ea826c41$var$noop$1() {}
var $b0f42935ea826c41$var$currentReplayingEvent = null;
function $b0f42935ea826c41$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $b0f42935ea826c41$var$restoreTarget = null, $b0f42935ea826c41$var$restoreQueue = null;
function $b0f42935ea826c41$var$restoreStateOfTarget(target) {
    var internalInstance = $b0f42935ea826c41$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$b0f42935ea826c41$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $b0f42935ea826c41$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$b0f42935ea826c41$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(90));
                            $b0f42935ea826c41$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $b0f42935ea826c41$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $b0f42935ea826c41$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $b0f42935ea826c41$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $b0f42935ea826c41$var$isInsideEventHandler = !1;
function $b0f42935ea826c41$var$batchedUpdates$1(fn, a, b) {
    if ($b0f42935ea826c41$var$isInsideEventHandler) return fn(a, b);
    $b0f42935ea826c41$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($b0f42935ea826c41$var$isInsideEventHandler = !1, null !== $b0f42935ea826c41$var$restoreTarget || null !== $b0f42935ea826c41$var$restoreQueue) {
            if ($b0f42935ea826c41$var$flushSyncWork$1(), $b0f42935ea826c41$var$restoreTarget && (a = $b0f42935ea826c41$var$restoreTarget, fn = $b0f42935ea826c41$var$restoreQueue, $b0f42935ea826c41$var$restoreQueue = $b0f42935ea826c41$var$restoreTarget = null, $b0f42935ea826c41$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$b0f42935ea826c41$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $b0f42935ea826c41$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$b0f42935ea826c41$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $b0f42935ea826c41$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b0f42935ea826c41$var$passiveBrowserEventsSupported = !1;
if ($b0f42935ea826c41$var$canUseDOM) try {
    var $b0f42935ea826c41$var$options = {};
    Object.defineProperty($b0f42935ea826c41$var$options, "passive", {
        get: function() {
            $b0f42935ea826c41$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $b0f42935ea826c41$var$options, $b0f42935ea826c41$var$options);
    window.removeEventListener("test", $b0f42935ea826c41$var$options, $b0f42935ea826c41$var$options);
} catch (e) {
    $b0f42935ea826c41$var$passiveBrowserEventsSupported = !1;
}
var $b0f42935ea826c41$var$root = null, $b0f42935ea826c41$var$startText = null, $b0f42935ea826c41$var$fallbackText = null;
function $b0f42935ea826c41$var$getData() {
    if ($b0f42935ea826c41$var$fallbackText) return $b0f42935ea826c41$var$fallbackText;
    var start, startValue = $b0f42935ea826c41$var$startText, startLength = startValue.length, end, endValue = "value" in $b0f42935ea826c41$var$root ? $b0f42935ea826c41$var$root.value : $b0f42935ea826c41$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $b0f42935ea826c41$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $b0f42935ea826c41$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $b0f42935ea826c41$var$functionThatReturnsTrue() {
    return !0;
}
function $b0f42935ea826c41$var$functionThatReturnsFalse() {
    return !1;
}
function $b0f42935ea826c41$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $b0f42935ea826c41$var$functionThatReturnsTrue : $b0f42935ea826c41$var$functionThatReturnsFalse;
        this.isPropagationStopped = $b0f42935ea826c41$var$functionThatReturnsFalse;
        return this;
    }
    $b0f42935ea826c41$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $b0f42935ea826c41$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $b0f42935ea826c41$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $b0f42935ea826c41$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $b0f42935ea826c41$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b0f42935ea826c41$var$SyntheticEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$EventInterface), $b0f42935ea826c41$var$UIEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    view: 0,
    detail: 0
}), $b0f42935ea826c41$var$SyntheticUIEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$UIEventInterface), $b0f42935ea826c41$var$lastMovementX, $b0f42935ea826c41$var$lastMovementY, $b0f42935ea826c41$var$lastMouseEvent, $b0f42935ea826c41$var$MouseEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b0f42935ea826c41$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $b0f42935ea826c41$var$lastMouseEvent && ($b0f42935ea826c41$var$lastMouseEvent && "mousemove" === event.type ? ($b0f42935ea826c41$var$lastMovementX = event.screenX - $b0f42935ea826c41$var$lastMouseEvent.screenX, $b0f42935ea826c41$var$lastMovementY = event.screenY - $b0f42935ea826c41$var$lastMouseEvent.screenY) : $b0f42935ea826c41$var$lastMovementY = $b0f42935ea826c41$var$lastMovementX = 0, $b0f42935ea826c41$var$lastMouseEvent = event);
        return $b0f42935ea826c41$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $b0f42935ea826c41$var$lastMovementY;
    }
}), $b0f42935ea826c41$var$SyntheticMouseEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$MouseEventInterface), $b0f42935ea826c41$var$DragEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$MouseEventInterface, {
    dataTransfer: 0
}), $b0f42935ea826c41$var$SyntheticDragEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$DragEventInterface), $b0f42935ea826c41$var$FocusEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$UIEventInterface, {
    relatedTarget: 0
}), $b0f42935ea826c41$var$SyntheticFocusEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$FocusEventInterface), $b0f42935ea826c41$var$AnimationEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b0f42935ea826c41$var$SyntheticAnimationEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$AnimationEventInterface), $b0f42935ea826c41$var$ClipboardEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $b0f42935ea826c41$var$SyntheticClipboardEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$ClipboardEventInterface), $b0f42935ea826c41$var$CompositionEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    data: 0
}), $b0f42935ea826c41$var$SyntheticCompositionEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$CompositionEventInterface), $b0f42935ea826c41$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b0f42935ea826c41$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b0f42935ea826c41$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b0f42935ea826c41$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $b0f42935ea826c41$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $b0f42935ea826c41$var$getEventModifierState() {
    return $b0f42935ea826c41$var$modifierStateGetter;
}
var $b0f42935ea826c41$var$KeyboardEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $b0f42935ea826c41$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $b0f42935ea826c41$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $b0f42935ea826c41$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b0f42935ea826c41$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $b0f42935ea826c41$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $b0f42935ea826c41$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $b0f42935ea826c41$var$SyntheticKeyboardEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$KeyboardEventInterface), $b0f42935ea826c41$var$PointerEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b0f42935ea826c41$var$SyntheticPointerEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$PointerEventInterface), $b0f42935ea826c41$var$TouchEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b0f42935ea826c41$var$getEventModifierState
}), $b0f42935ea826c41$var$SyntheticTouchEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$TouchEventInterface), $b0f42935ea826c41$var$TransitionEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b0f42935ea826c41$var$SyntheticTransitionEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$TransitionEventInterface), $b0f42935ea826c41$var$WheelEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b0f42935ea826c41$var$SyntheticWheelEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$WheelEventInterface), $b0f42935ea826c41$var$ToggleEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $b0f42935ea826c41$var$SyntheticToggleEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$ToggleEventInterface), $b0f42935ea826c41$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $b0f42935ea826c41$var$canUseCompositionEvent = $b0f42935ea826c41$var$canUseDOM && "CompositionEvent" in window, $b0f42935ea826c41$var$documentMode = null;
$b0f42935ea826c41$var$canUseDOM && "documentMode" in document && ($b0f42935ea826c41$var$documentMode = document.documentMode);
var $b0f42935ea826c41$var$canUseTextInputEvent = $b0f42935ea826c41$var$canUseDOM && "TextEvent" in window && !$b0f42935ea826c41$var$documentMode, $b0f42935ea826c41$var$useFallbackCompositionData = $b0f42935ea826c41$var$canUseDOM && (!$b0f42935ea826c41$var$canUseCompositionEvent || $b0f42935ea826c41$var$documentMode && 8 < $b0f42935ea826c41$var$documentMode && 11 >= $b0f42935ea826c41$var$documentMode), $b0f42935ea826c41$var$SPACEBAR_CHAR = String.fromCharCode(32), $b0f42935ea826c41$var$hasSpaceKeypress = !1;
function $b0f42935ea826c41$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $b0f42935ea826c41$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b0f42935ea826c41$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $b0f42935ea826c41$var$isComposing = !1;
function $b0f42935ea826c41$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $b0f42935ea826c41$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $b0f42935ea826c41$var$hasSpaceKeypress = !0;
            return $b0f42935ea826c41$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $b0f42935ea826c41$var$SPACEBAR_CHAR && $b0f42935ea826c41$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $b0f42935ea826c41$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($b0f42935ea826c41$var$isComposing) return "compositionend" === domEventName || !$b0f42935ea826c41$var$canUseCompositionEvent && $b0f42935ea826c41$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $b0f42935ea826c41$var$getData(), $b0f42935ea826c41$var$fallbackText = $b0f42935ea826c41$var$startText = $b0f42935ea826c41$var$root = null, $b0f42935ea826c41$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $b0f42935ea826c41$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $b0f42935ea826c41$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b0f42935ea826c41$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$b0f42935ea826c41$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $b0f42935ea826c41$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $b0f42935ea826c41$var$restoreTarget ? $b0f42935ea826c41$var$restoreQueue ? $b0f42935ea826c41$var$restoreQueue.push(target) : $b0f42935ea826c41$var$restoreQueue = [
        target
    ] : $b0f42935ea826c41$var$restoreTarget = target;
    inst = $b0f42935ea826c41$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $b0f42935ea826c41$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $b0f42935ea826c41$var$activeElement$1 = null, $b0f42935ea826c41$var$activeElementInst$1 = null;
function $b0f42935ea826c41$var$runEventInBatch(dispatchQueue) {
    $b0f42935ea826c41$var$processDispatchQueue(dispatchQueue, 0);
}
function $b0f42935ea826c41$var$getInstIfValueChanged(targetInst) {
    var targetNode = $b0f42935ea826c41$var$getNodeFromInstance(targetInst);
    if ($b0f42935ea826c41$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $b0f42935ea826c41$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $b0f42935ea826c41$var$isInputEventSupported = !1;
if ($b0f42935ea826c41$var$canUseDOM) {
    var $b0f42935ea826c41$var$JSCompiler_inline_result$jscomp$286;
    if ($b0f42935ea826c41$var$canUseDOM) {
        var $b0f42935ea826c41$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$b0f42935ea826c41$var$isSupported$jscomp$inline_427) {
            var $b0f42935ea826c41$var$element$jscomp$inline_428 = document.createElement("div");
            $b0f42935ea826c41$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $b0f42935ea826c41$var$isSupported$jscomp$inline_427 = "function" === typeof $b0f42935ea826c41$var$element$jscomp$inline_428.oninput;
        }
        $b0f42935ea826c41$var$JSCompiler_inline_result$jscomp$286 = $b0f42935ea826c41$var$isSupported$jscomp$inline_427;
    } else $b0f42935ea826c41$var$JSCompiler_inline_result$jscomp$286 = !1;
    $b0f42935ea826c41$var$isInputEventSupported = $b0f42935ea826c41$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $b0f42935ea826c41$var$stopWatchingForValueChange() {
    $b0f42935ea826c41$var$activeElement$1 && ($b0f42935ea826c41$var$activeElement$1.detachEvent("onpropertychange", $b0f42935ea826c41$var$handlePropertyChange), $b0f42935ea826c41$var$activeElementInst$1 = $b0f42935ea826c41$var$activeElement$1 = null);
}
function $b0f42935ea826c41$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $b0f42935ea826c41$var$getInstIfValueChanged($b0f42935ea826c41$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $b0f42935ea826c41$var$createAndAccumulateChangeEvent(dispatchQueue, $b0f42935ea826c41$var$activeElementInst$1, nativeEvent, $b0f42935ea826c41$var$getEventTarget(nativeEvent));
        $b0f42935ea826c41$var$batchedUpdates$1($b0f42935ea826c41$var$runEventInBatch, dispatchQueue);
    }
}
function $b0f42935ea826c41$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($b0f42935ea826c41$var$stopWatchingForValueChange(), $b0f42935ea826c41$var$activeElement$1 = target, $b0f42935ea826c41$var$activeElementInst$1 = targetInst, $b0f42935ea826c41$var$activeElement$1.attachEvent("onpropertychange", $b0f42935ea826c41$var$handlePropertyChange)) : "focusout" === domEventName && $b0f42935ea826c41$var$stopWatchingForValueChange();
}
function $b0f42935ea826c41$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $b0f42935ea826c41$var$getInstIfValueChanged($b0f42935ea826c41$var$activeElementInst$1);
}
function $b0f42935ea826c41$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $b0f42935ea826c41$var$getInstIfValueChanged(targetInst);
}
function $b0f42935ea826c41$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $b0f42935ea826c41$var$getInstIfValueChanged(targetInst);
}
function $b0f42935ea826c41$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b0f42935ea826c41$var$objectIs = "function" === typeof Object.is ? Object.is : $b0f42935ea826c41$var$is;
function $b0f42935ea826c41$var$shallowEqual(objA, objB) {
    if ($b0f42935ea826c41$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$b0f42935ea826c41$var$hasOwnProperty.call(objB, currentKey) || !$b0f42935ea826c41$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $b0f42935ea826c41$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $b0f42935ea826c41$var$getNodeForCharacterOffset(root, offset) {
    var node = $b0f42935ea826c41$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $b0f42935ea826c41$var$getLeafNode(node);
    }
}
function $b0f42935ea826c41$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $b0f42935ea826c41$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $b0f42935ea826c41$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $b0f42935ea826c41$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $b0f42935ea826c41$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $b0f42935ea826c41$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $b0f42935ea826c41$var$skipSelectionChangeEvent = $b0f42935ea826c41$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $b0f42935ea826c41$var$activeElement = null, $b0f42935ea826c41$var$activeElementInst = null, $b0f42935ea826c41$var$lastSelection = null, $b0f42935ea826c41$var$mouseDown = !1;
function $b0f42935ea826c41$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $b0f42935ea826c41$var$mouseDown || null == $b0f42935ea826c41$var$activeElement || $b0f42935ea826c41$var$activeElement !== $b0f42935ea826c41$var$getActiveElement(doc) || (doc = $b0f42935ea826c41$var$activeElement, "selectionStart" in doc && $b0f42935ea826c41$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $b0f42935ea826c41$var$lastSelection && $b0f42935ea826c41$var$shallowEqual($b0f42935ea826c41$var$lastSelection, doc) || ($b0f42935ea826c41$var$lastSelection = doc, doc = $b0f42935ea826c41$var$accumulateTwoPhaseListeners($b0f42935ea826c41$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $b0f42935ea826c41$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $b0f42935ea826c41$var$activeElement)));
}
function $b0f42935ea826c41$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $b0f42935ea826c41$var$vendorPrefixes = {
    animationend: $b0f42935ea826c41$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $b0f42935ea826c41$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $b0f42935ea826c41$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $b0f42935ea826c41$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $b0f42935ea826c41$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $b0f42935ea826c41$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $b0f42935ea826c41$var$makePrefixMap("Transition", "TransitionEnd")
}, $b0f42935ea826c41$var$prefixedEventNames = {}, $b0f42935ea826c41$var$style = {};
$b0f42935ea826c41$var$canUseDOM && ($b0f42935ea826c41$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $b0f42935ea826c41$var$vendorPrefixes.animationend.animation, delete $b0f42935ea826c41$var$vendorPrefixes.animationiteration.animation, delete $b0f42935ea826c41$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $b0f42935ea826c41$var$vendorPrefixes.transitionend.transition);
function $b0f42935ea826c41$var$getVendorPrefixedEventName(eventName) {
    if ($b0f42935ea826c41$var$prefixedEventNames[eventName]) return $b0f42935ea826c41$var$prefixedEventNames[eventName];
    if (!$b0f42935ea826c41$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $b0f42935ea826c41$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $b0f42935ea826c41$var$style) return $b0f42935ea826c41$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $b0f42935ea826c41$var$ANIMATION_END = $b0f42935ea826c41$var$getVendorPrefixedEventName("animationend"), $b0f42935ea826c41$var$ANIMATION_ITERATION = $b0f42935ea826c41$var$getVendorPrefixedEventName("animationiteration"), $b0f42935ea826c41$var$ANIMATION_START = $b0f42935ea826c41$var$getVendorPrefixedEventName("animationstart"), $b0f42935ea826c41$var$TRANSITION_RUN = $b0f42935ea826c41$var$getVendorPrefixedEventName("transitionrun"), $b0f42935ea826c41$var$TRANSITION_START = $b0f42935ea826c41$var$getVendorPrefixedEventName("transitionstart"), $b0f42935ea826c41$var$TRANSITION_CANCEL = $b0f42935ea826c41$var$getVendorPrefixedEventName("transitioncancel"), $b0f42935ea826c41$var$TRANSITION_END = $b0f42935ea826c41$var$getVendorPrefixedEventName("transitionend"), $b0f42935ea826c41$var$topLevelEventsToReactNames = new Map(), $b0f42935ea826c41$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$b0f42935ea826c41$var$simpleEventPluginEvents.push("scrollEnd");
function $b0f42935ea826c41$var$registerSimpleEvent(domEventName, reactName) {
    $b0f42935ea826c41$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $b0f42935ea826c41$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $b0f42935ea826c41$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $b0f42935ea826c41$var$concurrentQueues = [], $b0f42935ea826c41$var$concurrentQueuesIndex = 0, $b0f42935ea826c41$var$concurrentlyUpdatedLanes = 0;
function $b0f42935ea826c41$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $b0f42935ea826c41$var$concurrentQueuesIndex, i = $b0f42935ea826c41$var$concurrentlyUpdatedLanes = $b0f42935ea826c41$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $b0f42935ea826c41$var$concurrentQueues[i];
        $b0f42935ea826c41$var$concurrentQueues[i++] = null;
        var queue = $b0f42935ea826c41$var$concurrentQueues[i];
        $b0f42935ea826c41$var$concurrentQueues[i++] = null;
        var update = $b0f42935ea826c41$var$concurrentQueues[i];
        $b0f42935ea826c41$var$concurrentQueues[i++] = null;
        var lane = $b0f42935ea826c41$var$concurrentQueues[i];
        $b0f42935ea826c41$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $b0f42935ea826c41$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $b0f42935ea826c41$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $b0f42935ea826c41$var$concurrentQueues[$b0f42935ea826c41$var$concurrentQueuesIndex++] = fiber;
    $b0f42935ea826c41$var$concurrentQueues[$b0f42935ea826c41$var$concurrentQueuesIndex++] = queue;
    $b0f42935ea826c41$var$concurrentQueues[$b0f42935ea826c41$var$concurrentQueuesIndex++] = update;
    $b0f42935ea826c41$var$concurrentQueues[$b0f42935ea826c41$var$concurrentQueuesIndex++] = lane;
    $b0f42935ea826c41$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $b0f42935ea826c41$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $b0f42935ea826c41$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $b0f42935ea826c41$var$getRootForUpdatedFiber(fiber);
}
function $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $b0f42935ea826c41$var$enqueueUpdate$1(fiber, null, null, lane);
    return $b0f42935ea826c41$var$getRootForUpdatedFiber(fiber);
}
function $b0f42935ea826c41$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $b0f42935ea826c41$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $b0f42935ea826c41$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $b0f42935ea826c41$var$nestedUpdateCount) throw $b0f42935ea826c41$var$nestedUpdateCount = 0, $b0f42935ea826c41$var$rootWithNestedUpdates = null, Error($b0f42935ea826c41$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $b0f42935ea826c41$var$emptyContextObject = {};
function $b0f42935ea826c41$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b0f42935ea826c41$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $b0f42935ea826c41$var$FiberNode(tag, pendingProps, key, mode);
}
function $b0f42935ea826c41$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $b0f42935ea826c41$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $b0f42935ea826c41$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $b0f42935ea826c41$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $b0f42935ea826c41$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $b0f42935ea826c41$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $b0f42935ea826c41$var$isHostHoistableType(type, pendingProps, $b0f42935ea826c41$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $b0f42935ea826c41$var$REACT_ACTIVITY_TYPE:
            return type = $b0f42935ea826c41$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $b0f42935ea826c41$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE:
            return $b0f42935ea826c41$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $b0f42935ea826c41$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $b0f42935ea826c41$var$REACT_PROFILER_TYPE:
            return type = $b0f42935ea826c41$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $b0f42935ea826c41$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $b0f42935ea826c41$var$REACT_SUSPENSE_TYPE:
            return type = $b0f42935ea826c41$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $b0f42935ea826c41$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $b0f42935ea826c41$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $b0f42935ea826c41$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $b0f42935ea826c41$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $b0f42935ea826c41$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $b0f42935ea826c41$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $b0f42935ea826c41$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $b0f42935ea826c41$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($b0f42935ea826c41$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $b0f42935ea826c41$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $b0f42935ea826c41$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $b0f42935ea826c41$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $b0f42935ea826c41$var$createFiberFromText(content, mode, lanes) {
    content = $b0f42935ea826c41$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $b0f42935ea826c41$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $b0f42935ea826c41$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $b0f42935ea826c41$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $b0f42935ea826c41$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $b0f42935ea826c41$var$CapturedStacks = new WeakMap();
function $b0f42935ea826c41$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $b0f42935ea826c41$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $b0f42935ea826c41$var$getStackByFiberInDevAndProd(source)
        };
        $b0f42935ea826c41$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $b0f42935ea826c41$var$getStackByFiberInDevAndProd(source)
    };
}
var $b0f42935ea826c41$var$forkStack = [], $b0f42935ea826c41$var$forkStackIndex = 0, $b0f42935ea826c41$var$treeForkProvider = null, $b0f42935ea826c41$var$treeForkCount = 0, $b0f42935ea826c41$var$idStack = [], $b0f42935ea826c41$var$idStackIndex = 0, $b0f42935ea826c41$var$treeContextProvider = null, $b0f42935ea826c41$var$treeContextId = 1, $b0f42935ea826c41$var$treeContextOverflow = "";
function $b0f42935ea826c41$var$pushTreeFork(workInProgress, totalChildren) {
    $b0f42935ea826c41$var$forkStack[$b0f42935ea826c41$var$forkStackIndex++] = $b0f42935ea826c41$var$treeForkCount;
    $b0f42935ea826c41$var$forkStack[$b0f42935ea826c41$var$forkStackIndex++] = $b0f42935ea826c41$var$treeForkProvider;
    $b0f42935ea826c41$var$treeForkProvider = workInProgress;
    $b0f42935ea826c41$var$treeForkCount = totalChildren;
}
function $b0f42935ea826c41$var$pushTreeId(workInProgress, totalChildren, index) {
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextId;
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextOverflow;
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextProvider;
    $b0f42935ea826c41$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $b0f42935ea826c41$var$treeContextId;
    workInProgress = $b0f42935ea826c41$var$treeContextOverflow;
    var baseLength = 32 - $b0f42935ea826c41$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $b0f42935ea826c41$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $b0f42935ea826c41$var$treeContextId = 1 << 32 - $b0f42935ea826c41$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $b0f42935ea826c41$var$treeContextOverflow = length + workInProgress;
    } else $b0f42935ea826c41$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $b0f42935ea826c41$var$treeContextOverflow = workInProgress;
}
function $b0f42935ea826c41$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($b0f42935ea826c41$var$pushTreeFork(workInProgress, 1), $b0f42935ea826c41$var$pushTreeId(workInProgress, 1, 0));
}
function $b0f42935ea826c41$var$popTreeContext(workInProgress) {
    for(; workInProgress === $b0f42935ea826c41$var$treeForkProvider;)$b0f42935ea826c41$var$treeForkProvider = $b0f42935ea826c41$var$forkStack[--$b0f42935ea826c41$var$forkStackIndex], $b0f42935ea826c41$var$forkStack[$b0f42935ea826c41$var$forkStackIndex] = null, $b0f42935ea826c41$var$treeForkCount = $b0f42935ea826c41$var$forkStack[--$b0f42935ea826c41$var$forkStackIndex], $b0f42935ea826c41$var$forkStack[$b0f42935ea826c41$var$forkStackIndex] = null;
    for(; workInProgress === $b0f42935ea826c41$var$treeContextProvider;)$b0f42935ea826c41$var$treeContextProvider = $b0f42935ea826c41$var$idStack[--$b0f42935ea826c41$var$idStackIndex], $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex] = null, $b0f42935ea826c41$var$treeContextOverflow = $b0f42935ea826c41$var$idStack[--$b0f42935ea826c41$var$idStackIndex], $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex] = null, $b0f42935ea826c41$var$treeContextId = $b0f42935ea826c41$var$idStack[--$b0f42935ea826c41$var$idStackIndex], $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex] = null;
}
function $b0f42935ea826c41$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextId;
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextOverflow;
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextProvider;
    $b0f42935ea826c41$var$treeContextId = suspendedContext.id;
    $b0f42935ea826c41$var$treeContextOverflow = suspendedContext.overflow;
    $b0f42935ea826c41$var$treeContextProvider = workInProgress;
}
var $b0f42935ea826c41$var$hydrationParentFiber = null, $b0f42935ea826c41$var$nextHydratableInstance = null, $b0f42935ea826c41$var$isHydrating = !1, $b0f42935ea826c41$var$hydrationErrors = null, $b0f42935ea826c41$var$rootOrSingletonContext = !1, $b0f42935ea826c41$var$HydrationMismatchException = Error($b0f42935ea826c41$var$formatProdErrorMessage(519));
function $b0f42935ea826c41$var$throwOnHydrationMismatch(fiber) {
    var error = Error($b0f42935ea826c41$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $b0f42935ea826c41$var$queueHydrationError($b0f42935ea826c41$var$createCapturedValueAtFiber(error, fiber));
    throw $b0f42935ea826c41$var$HydrationMismatchException;
}
function $b0f42935ea826c41$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$b0f42935ea826c41$var$internalInstanceKey] = fiber;
    instance[$b0f42935ea826c41$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("cancel", instance);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $b0f42935ea826c41$var$mediaEventTypes.length; type++)$b0f42935ea826c41$var$listenToNonDelegatedEvent($b0f42935ea826c41$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", instance);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", instance);
            $b0f42935ea826c41$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", instance), $b0f42935ea826c41$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $b0f42935ea826c41$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($b0f42935ea826c41$var$listenToNonDelegatedEvent("beforetoggle", instance), $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $b0f42935ea826c41$var$noop$1), instance = !0) : instance = !1;
    instance || $b0f42935ea826c41$var$throwOnHydrationMismatch(fiber, !0);
}
function $b0f42935ea826c41$var$popToNextHostParent(fiber) {
    for($b0f42935ea826c41$var$hydrationParentFiber = fiber.return; $b0f42935ea826c41$var$hydrationParentFiber;)switch($b0f42935ea826c41$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $b0f42935ea826c41$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $b0f42935ea826c41$var$rootOrSingletonContext = !0;
            return;
        default:
            $b0f42935ea826c41$var$hydrationParentFiber = $b0f42935ea826c41$var$hydrationParentFiber.return;
    }
}
function $b0f42935ea826c41$var$popHydrationState(fiber) {
    if (fiber !== $b0f42935ea826c41$var$hydrationParentFiber) return !1;
    if (!$b0f42935ea826c41$var$isHydrating) return $b0f42935ea826c41$var$popToNextHostParent(fiber), $b0f42935ea826c41$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $b0f42935ea826c41$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $b0f42935ea826c41$var$nextHydratableInstance && $b0f42935ea826c41$var$throwOnHydrationMismatch(fiber);
    $b0f42935ea826c41$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(317));
        $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(317));
        $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $b0f42935ea826c41$var$nextHydratableInstance, $b0f42935ea826c41$var$isSingletonScope(fiber.type) ? (fiber = $b0f42935ea826c41$var$previousHydratableOnEnteringScopedSingleton, $b0f42935ea826c41$var$previousHydratableOnEnteringScopedSingleton = null, $b0f42935ea826c41$var$nextHydratableInstance = fiber) : $b0f42935ea826c41$var$nextHydratableInstance = tag) : $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$hydrationParentFiber ? $b0f42935ea826c41$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $b0f42935ea826c41$var$resetHydrationState() {
    $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$hydrationParentFiber = null;
    $b0f42935ea826c41$var$isHydrating = !1;
}
function $b0f42935ea826c41$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $b0f42935ea826c41$var$hydrationErrors;
    null !== queuedErrors && (null === $b0f42935ea826c41$var$workInProgressRootRecoverableErrors ? $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = queuedErrors : $b0f42935ea826c41$var$workInProgressRootRecoverableErrors.push.apply($b0f42935ea826c41$var$workInProgressRootRecoverableErrors, queuedErrors), $b0f42935ea826c41$var$hydrationErrors = null);
    return queuedErrors;
}
function $b0f42935ea826c41$var$queueHydrationError(error) {
    null === $b0f42935ea826c41$var$hydrationErrors ? $b0f42935ea826c41$var$hydrationErrors = [
        error
    ] : $b0f42935ea826c41$var$hydrationErrors.push(error);
}
var $b0f42935ea826c41$var$valueCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null, $b0f42935ea826c41$var$lastContextDependency = null;
function $b0f42935ea826c41$var$pushProvider(providerFiber, context, nextValue) {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $b0f42935ea826c41$var$popProvider(context) {
    context._currentValue = $b0f42935ea826c41$var$valueCursor.current;
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$valueCursor);
}
function $b0f42935ea826c41$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $b0f42935ea826c41$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $b0f42935ea826c41$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $b0f42935ea826c41$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $b0f42935ea826c41$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $b0f42935ea826c41$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($b0f42935ea826c41$var$HostTransitionContext) : current = [
                $b0f42935ea826c41$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $b0f42935ea826c41$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $b0f42935ea826c41$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$b0f42935ea826c41$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $b0f42935ea826c41$var$prepareToReadContext(workInProgress) {
    $b0f42935ea826c41$var$currentlyRenderingFiber$1 = workInProgress;
    $b0f42935ea826c41$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $b0f42935ea826c41$var$readContext(context) {
    return $b0f42935ea826c41$var$readContextForConsumer($b0f42935ea826c41$var$currentlyRenderingFiber$1, context);
}
function $b0f42935ea826c41$var$readContextDuringReconciliation(consumer, context) {
    null === $b0f42935ea826c41$var$currentlyRenderingFiber$1 && $b0f42935ea826c41$var$prepareToReadContext(consumer);
    return $b0f42935ea826c41$var$readContextForConsumer(consumer, context);
}
function $b0f42935ea826c41$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $b0f42935ea826c41$var$lastContextDependency) {
        if (null === consumer) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(308));
        $b0f42935ea826c41$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$lastContextDependency.next = context;
    return value;
}
var $b0f42935ea826c41$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $b0f42935ea826c41$var$scheduleCallback$2 = $bIbqH.unstable_scheduleCallback, $b0f42935ea826c41$var$NormalPriority = $bIbqH.unstable_NormalPriority, $b0f42935ea826c41$var$CacheContext = {
    $$typeof: $b0f42935ea826c41$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $b0f42935ea826c41$var$createCache() {
    return {
        controller: new $b0f42935ea826c41$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $b0f42935ea826c41$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $b0f42935ea826c41$var$scheduleCallback$2($b0f42935ea826c41$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $b0f42935ea826c41$var$currentEntangledListeners = null, $b0f42935ea826c41$var$currentEntangledPendingCount = 0, $b0f42935ea826c41$var$currentEntangledLane = 0, $b0f42935ea826c41$var$currentEntangledActionThenable = null;
function $b0f42935ea826c41$var$entangleAsyncAction(transition, thenable) {
    if (null === $b0f42935ea826c41$var$currentEntangledListeners) {
        var entangledListeners = $b0f42935ea826c41$var$currentEntangledListeners = [];
        $b0f42935ea826c41$var$currentEntangledPendingCount = 0;
        $b0f42935ea826c41$var$currentEntangledLane = $b0f42935ea826c41$var$requestTransitionLane();
        $b0f42935ea826c41$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $b0f42935ea826c41$var$currentEntangledPendingCount++;
    thenable.then($b0f42935ea826c41$var$pingEngtangledActionScope, $b0f42935ea826c41$var$pingEngtangledActionScope);
    return thenable;
}
function $b0f42935ea826c41$var$pingEngtangledActionScope() {
    if (0 === --$b0f42935ea826c41$var$currentEntangledPendingCount && null !== $b0f42935ea826c41$var$currentEntangledListeners) {
        null !== $b0f42935ea826c41$var$currentEntangledActionThenable && ($b0f42935ea826c41$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $b0f42935ea826c41$var$currentEntangledListeners;
        $b0f42935ea826c41$var$currentEntangledListeners = null;
        $b0f42935ea826c41$var$currentEntangledLane = 0;
        $b0f42935ea826c41$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $b0f42935ea826c41$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $b0f42935ea826c41$var$prevOnStartTransitionFinish = $b0f42935ea826c41$var$ReactSharedInternals.S;
$b0f42935ea826c41$var$ReactSharedInternals.S = function(transition, returnValue) {
    $b0f42935ea826c41$var$globalMostRecentTransitionTime = $b0f42935ea826c41$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $b0f42935ea826c41$var$entangleAsyncAction(transition, returnValue);
    null !== $b0f42935ea826c41$var$prevOnStartTransitionFinish && $b0f42935ea826c41$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $b0f42935ea826c41$var$resumedCache = $b0f42935ea826c41$var$createCursor(null);
function $b0f42935ea826c41$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $b0f42935ea826c41$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $b0f42935ea826c41$var$workInProgressRoot.pooledCache;
}
function $b0f42935ea826c41$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $b0f42935ea826c41$var$push($b0f42935ea826c41$var$resumedCache, $b0f42935ea826c41$var$resumedCache.current) : $b0f42935ea826c41$var$push($b0f42935ea826c41$var$resumedCache, prevCachePool.pool);
}
function $b0f42935ea826c41$var$getSuspendedCache() {
    var cacheFromPool = $b0f42935ea826c41$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $b0f42935ea826c41$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $b0f42935ea826c41$var$SuspenseException = Error($b0f42935ea826c41$var$formatProdErrorMessage(460)), $b0f42935ea826c41$var$SuspenseyCommitException = Error($b0f42935ea826c41$var$formatProdErrorMessage(474)), $b0f42935ea826c41$var$SuspenseActionException = Error($b0f42935ea826c41$var$formatProdErrorMessage(542)), $b0f42935ea826c41$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $b0f42935ea826c41$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $b0f42935ea826c41$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($b0f42935ea826c41$var$noop$1, $b0f42935ea826c41$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $b0f42935ea826c41$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($b0f42935ea826c41$var$noop$1, $b0f42935ea826c41$var$noop$1);
            else {
                thenableState = $b0f42935ea826c41$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $b0f42935ea826c41$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $b0f42935ea826c41$var$suspendedThenable = thenable;
            throw $b0f42935ea826c41$var$SuspenseException;
    }
}
function $b0f42935ea826c41$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $b0f42935ea826c41$var$suspendedThenable = x, $b0f42935ea826c41$var$SuspenseException;
        throw x;
    }
}
var $b0f42935ea826c41$var$suspendedThenable = null;
function $b0f42935ea826c41$var$getSuspendedThenable() {
    if (null === $b0f42935ea826c41$var$suspendedThenable) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(459));
    var thenable = $b0f42935ea826c41$var$suspendedThenable;
    $b0f42935ea826c41$var$suspendedThenable = null;
    return thenable;
}
function $b0f42935ea826c41$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $b0f42935ea826c41$var$SuspenseException || rejectedReason === $b0f42935ea826c41$var$SuspenseActionException) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(483));
}
var $b0f42935ea826c41$var$thenableState$1 = null, $b0f42935ea826c41$var$thenableIndexCounter$1 = 0;
function $b0f42935ea826c41$var$unwrapThenable(thenable) {
    var index = $b0f42935ea826c41$var$thenableIndexCounter$1;
    $b0f42935ea826c41$var$thenableIndexCounter$1 += 1;
    null === $b0f42935ea826c41$var$thenableState$1 && ($b0f42935ea826c41$var$thenableState$1 = []);
    return $b0f42935ea826c41$var$trackUsedThenable($b0f42935ea826c41$var$thenableState$1, thenable, index);
}
function $b0f42935ea826c41$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $b0f42935ea826c41$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $b0f42935ea826c41$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $b0f42935ea826c41$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $b0f42935ea826c41$var$REACT_LAZY_TYPE && $b0f42935ea826c41$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $b0f42935ea826c41$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $b0f42935ea826c41$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $b0f42935ea826c41$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $b0f42935ea826c41$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $b0f42935ea826c41$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $b0f42935ea826c41$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b0f42935ea826c41$var$REACT_ELEMENT_TYPE:
                    return lanes = $b0f42935ea826c41$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b0f42935ea826c41$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
                    return newChild = $b0f42935ea826c41$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    return newChild = $b0f42935ea826c41$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($b0f42935ea826c41$var$isArrayImpl(newChild) || $b0f42935ea826c41$var$getIteratorFn(newChild)) return newChild = $b0f42935ea826c41$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $b0f42935ea826c41$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $b0f42935ea826c41$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b0f42935ea826c41$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    return newChild = $b0f42935ea826c41$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($b0f42935ea826c41$var$isArrayImpl(newChild) || $b0f42935ea826c41$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $b0f42935ea826c41$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $b0f42935ea826c41$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b0f42935ea826c41$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    return newChild = $b0f42935ea826c41$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($b0f42935ea826c41$var$isArrayImpl(newChild) || $b0f42935ea826c41$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $b0f42935ea826c41$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $b0f42935ea826c41$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b0f42935ea826c41$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $b0f42935ea826c41$var$REACT_LAZY_TYPE && $b0f42935ea826c41$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $b0f42935ea826c41$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE ? (lanes = $b0f42935ea826c41$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $b0f42935ea826c41$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b0f42935ea826c41$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $b0f42935ea826c41$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    return newChild = $b0f42935ea826c41$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($b0f42935ea826c41$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($b0f42935ea826c41$var$getIteratorFn(newChild)) {
                key = $b0f42935ea826c41$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b0f42935ea826c41$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b0f42935ea826c41$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $b0f42935ea826c41$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $b0f42935ea826c41$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $b0f42935ea826c41$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $b0f42935ea826c41$var$SuspenseException || x === $b0f42935ea826c41$var$SuspenseActionException) throw x;
            var fiber = $b0f42935ea826c41$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $b0f42935ea826c41$var$reconcileChildFibers = $b0f42935ea826c41$var$createChildReconciler(!0), $b0f42935ea826c41$var$mountChildFibers = $b0f42935ea826c41$var$createChildReconciler(!1), $b0f42935ea826c41$var$hasForceUpdate = !1;
function $b0f42935ea826c41$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $b0f42935ea826c41$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $b0f42935ea826c41$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b0f42935ea826c41$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($b0f42935ea826c41$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $b0f42935ea826c41$var$getRootForUpdatedFiber(fiber);
        $b0f42935ea826c41$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $b0f42935ea826c41$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $b0f42935ea826c41$var$getRootForUpdatedFiber(fiber);
}
function $b0f42935ea826c41$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $b0f42935ea826c41$var$markRootEntangled(root, lane);
    }
}
function $b0f42935ea826c41$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $b0f42935ea826c41$var$didReadFromEntangledAsyncAction = !1;
function $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($b0f42935ea826c41$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $b0f42935ea826c41$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $b0f42935ea826c41$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $b0f42935ea826c41$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $b0f42935ea826c41$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($b0f42935ea826c41$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $b0f42935ea826c41$var$currentEntangledLane && ($b0f42935ea826c41$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $b0f42935ea826c41$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $b0f42935ea826c41$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $b0f42935ea826c41$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $b0f42935ea826c41$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$b0f42935ea826c41$var$callCallback(callbacks[updateQueue], context);
}
var $b0f42935ea826c41$var$currentTreeHiddenStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$prevEntangledRenderLanesCursor = $b0f42935ea826c41$var$createCursor(0);
function $b0f42935ea826c41$var$pushHiddenContext(fiber, context) {
    fiber = $b0f42935ea826c41$var$entangledRenderLanes;
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$prevEntangledRenderLanesCursor, fiber);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$currentTreeHiddenStackCursor, context);
    $b0f42935ea826c41$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $b0f42935ea826c41$var$reuseHiddenContextOnStack() {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$prevEntangledRenderLanesCursor, $b0f42935ea826c41$var$entangledRenderLanes);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$currentTreeHiddenStackCursor, $b0f42935ea826c41$var$currentTreeHiddenStackCursor.current);
}
function $b0f42935ea826c41$var$popHiddenContext() {
    $b0f42935ea826c41$var$entangledRenderLanes = $b0f42935ea826c41$var$prevEntangledRenderLanesCursor.current;
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$currentTreeHiddenStackCursor);
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$prevEntangledRenderLanesCursor);
}
var $b0f42935ea826c41$var$suspenseHandlerStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$shellBoundary = null;
function $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current & 1);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseHandlerStackCursor, handler);
    null === $b0f42935ea826c41$var$shellBoundary && (null === current || null !== $b0f42935ea826c41$var$currentTreeHiddenStackCursor.current ? $b0f42935ea826c41$var$shellBoundary = handler : null !== current.memoizedState && ($b0f42935ea826c41$var$shellBoundary = handler));
}
function $b0f42935ea826c41$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseHandlerStackCursor, fiber);
    null === $b0f42935ea826c41$var$shellBoundary && ($b0f42935ea826c41$var$shellBoundary = fiber);
}
function $b0f42935ea826c41$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current), $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseHandlerStackCursor, fiber), null === $b0f42935ea826c41$var$shellBoundary && ($b0f42935ea826c41$var$shellBoundary = fiber)) : $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(fiber);
}
function $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack() {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseHandlerStackCursor, $b0f42935ea826c41$var$suspenseHandlerStackCursor.current);
}
function $b0f42935ea826c41$var$popSuspenseHandler(fiber) {
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseHandlerStackCursor);
    $b0f42935ea826c41$var$shellBoundary === fiber && ($b0f42935ea826c41$var$shellBoundary = null);
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseStackCursor);
}
var $b0f42935ea826c41$var$suspenseStackCursor = $b0f42935ea826c41$var$createCursor(0);
function $b0f42935ea826c41$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $b0f42935ea826c41$var$isSuspenseInstancePending(state) || $b0f42935ea826c41$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $b0f42935ea826c41$var$renderLanes = 0, $b0f42935ea826c41$var$currentlyRenderingFiber = null, $b0f42935ea826c41$var$currentHook = null, $b0f42935ea826c41$var$workInProgressHook = null, $b0f42935ea826c41$var$didScheduleRenderPhaseUpdate = !1, $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $b0f42935ea826c41$var$localIdCounter = 0, $b0f42935ea826c41$var$thenableIndexCounter = 0, $b0f42935ea826c41$var$thenableState = null, $b0f42935ea826c41$var$globalClientIdCounter = 0;
function $b0f42935ea826c41$var$throwInvalidHookError() {
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(321));
}
function $b0f42935ea826c41$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$b0f42935ea826c41$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $b0f42935ea826c41$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $b0f42935ea826c41$var$renderLanes = nextRenderLanes;
    $b0f42935ea826c41$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $b0f42935ea826c41$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $b0f42935ea826c41$var$HooksDispatcherOnMount : $b0f42935ea826c41$var$HooksDispatcherOnUpdate;
    $b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $b0f42935ea826c41$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $b0f42935ea826c41$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $b0f42935ea826c41$var$finishRenderingHooks(current) {
    $b0f42935ea826c41$var$ReactSharedInternals.H = $b0f42935ea826c41$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $b0f42935ea826c41$var$currentHook && null !== $b0f42935ea826c41$var$currentHook.next;
    $b0f42935ea826c41$var$renderLanes = 0;
    $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$currentHook = $b0f42935ea826c41$var$currentlyRenderingFiber = null;
    $b0f42935ea826c41$var$didScheduleRenderPhaseUpdate = !1;
    $b0f42935ea826c41$var$thenableIndexCounter = 0;
    $b0f42935ea826c41$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(300));
    null === current || $b0f42935ea826c41$var$didReceiveUpdate || (current = current.dependencies, null !== current && $b0f42935ea826c41$var$checkIfContextChanged(current) && ($b0f42935ea826c41$var$didReceiveUpdate = !0));
}
function $b0f42935ea826c41$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $b0f42935ea826c41$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass && ($b0f42935ea826c41$var$thenableState = null);
        $b0f42935ea826c41$var$thenableIndexCounter = 0;
        $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $b0f42935ea826c41$var$ReactSharedInternals.H = $b0f42935ea826c41$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $b0f42935ea826c41$var$TransitionAwareHostComponent() {
    var dispatcher = $b0f42935ea826c41$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $b0f42935ea826c41$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $b0f42935ea826c41$var$currentHook ? $b0f42935ea826c41$var$currentHook.memoizedState : null) !== dispatcher && ($b0f42935ea826c41$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $b0f42935ea826c41$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $b0f42935ea826c41$var$localIdCounter;
    $b0f42935ea826c41$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $b0f42935ea826c41$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $b0f42935ea826c41$var$resetHooksOnUnwind(workInProgress) {
    if ($b0f42935ea826c41$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $b0f42935ea826c41$var$didScheduleRenderPhaseUpdate = !1;
    }
    $b0f42935ea826c41$var$renderLanes = 0;
    $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$currentHook = $b0f42935ea826c41$var$currentlyRenderingFiber = null;
    $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $b0f42935ea826c41$var$thenableIndexCounter = $b0f42935ea826c41$var$localIdCounter = 0;
    $b0f42935ea826c41$var$thenableState = null;
}
function $b0f42935ea826c41$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b0f42935ea826c41$var$workInProgressHook ? $b0f42935ea826c41$var$currentlyRenderingFiber.memoizedState = $b0f42935ea826c41$var$workInProgressHook = hook : $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$workInProgressHook.next = hook;
    return $b0f42935ea826c41$var$workInProgressHook;
}
function $b0f42935ea826c41$var$updateWorkInProgressHook() {
    if (null === $b0f42935ea826c41$var$currentHook) {
        var nextCurrentHook = $b0f42935ea826c41$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $b0f42935ea826c41$var$currentHook.next;
    var nextWorkInProgressHook = null === $b0f42935ea826c41$var$workInProgressHook ? $b0f42935ea826c41$var$currentlyRenderingFiber.memoizedState : $b0f42935ea826c41$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $b0f42935ea826c41$var$workInProgressHook = nextWorkInProgressHook, $b0f42935ea826c41$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $b0f42935ea826c41$var$currentlyRenderingFiber.alternate) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(467));
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(310));
        }
        $b0f42935ea826c41$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $b0f42935ea826c41$var$currentHook.memoizedState,
            baseState: $b0f42935ea826c41$var$currentHook.baseState,
            baseQueue: $b0f42935ea826c41$var$currentHook.baseQueue,
            queue: $b0f42935ea826c41$var$currentHook.queue,
            next: null
        };
        null === $b0f42935ea826c41$var$workInProgressHook ? $b0f42935ea826c41$var$currentlyRenderingFiber.memoizedState = $b0f42935ea826c41$var$workInProgressHook = nextCurrentHook : $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$workInProgressHook.next = nextCurrentHook;
    }
    return $b0f42935ea826c41$var$workInProgressHook;
}
function $b0f42935ea826c41$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $b0f42935ea826c41$var$useThenable(thenable) {
    var index = $b0f42935ea826c41$var$thenableIndexCounter;
    $b0f42935ea826c41$var$thenableIndexCounter += 1;
    null === $b0f42935ea826c41$var$thenableState && ($b0f42935ea826c41$var$thenableState = []);
    thenable = $b0f42935ea826c41$var$trackUsedThenable($b0f42935ea826c41$var$thenableState, thenable, index);
    index = $b0f42935ea826c41$var$currentlyRenderingFiber;
    null === (null === $b0f42935ea826c41$var$workInProgressHook ? index.memoizedState : $b0f42935ea826c41$var$workInProgressHook.next) && (index = index.alternate, $b0f42935ea826c41$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $b0f42935ea826c41$var$HooksDispatcherOnMount : $b0f42935ea826c41$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $b0f42935ea826c41$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $b0f42935ea826c41$var$useThenable(usable);
        if (usable.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return $b0f42935ea826c41$var$readContext(usable);
    }
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(438, String(usable)));
}
function $b0f42935ea826c41$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $b0f42935ea826c41$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $b0f42935ea826c41$var$createFunctionComponentUpdateQueue(), $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $b0f42935ea826c41$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $b0f42935ea826c41$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $b0f42935ea826c41$var$updateReducer(reducer) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    return $b0f42935ea826c41$var$updateReducerImpl(hook, $b0f42935ea826c41$var$currentHook, reducer);
}
function $b0f42935ea826c41$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($b0f42935ea826c41$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($b0f42935ea826c41$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $b0f42935ea826c41$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($b0f42935ea826c41$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $b0f42935ea826c41$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $b0f42935ea826c41$var$currentlyRenderingFiber.lanes |= revertLane, $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $b0f42935ea826c41$var$currentlyRenderingFiber.lanes |= updateLane, $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$b0f42935ea826c41$var$objectIs(pendingQueue, hook.memoizedState) && ($b0f42935ea826c41$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $b0f42935ea826c41$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $b0f42935ea826c41$var$rerenderReducer(reducer) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $b0f42935ea826c41$var$objectIs(newState, hook.memoizedState) || ($b0f42935ea826c41$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $b0f42935ea826c41$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $b0f42935ea826c41$var$currentlyRenderingFiber, hook = $b0f42935ea826c41$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $b0f42935ea826c41$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$b0f42935ea826c41$var$objectIs(($b0f42935ea826c41$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $b0f42935ea826c41$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $b0f42935ea826c41$var$updateEffect($b0f42935ea826c41$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $b0f42935ea826c41$var$workInProgressHook && $b0f42935ea826c41$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $b0f42935ea826c41$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b0f42935ea826c41$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $b0f42935ea826c41$var$workInProgressRoot) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($b0f42935ea826c41$var$renderLanes & 127) || $b0f42935ea826c41$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $b0f42935ea826c41$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $b0f42935ea826c41$var$createFunctionComponentUpdateQueue(), $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $b0f42935ea826c41$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $b0f42935ea826c41$var$checkIfSnapshotChanged(inst) && $b0f42935ea826c41$var$forceStoreRerender(fiber);
}
function $b0f42935ea826c41$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $b0f42935ea826c41$var$checkIfSnapshotChanged(inst) && $b0f42935ea826c41$var$forceStoreRerender(fiber);
    });
}
function $b0f42935ea826c41$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b0f42935ea826c41$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b0f42935ea826c41$var$forceStoreRerender(fiber) {
    var root = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $b0f42935ea826c41$var$mountStateImpl(initialState) {
    var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b0f42935ea826c41$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $b0f42935ea826c41$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b0f42935ea826c41$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $b0f42935ea826c41$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $b0f42935ea826c41$var$updateReducerImpl(hook, $b0f42935ea826c41$var$currentHook, "function" === typeof reducer ? reducer : $b0f42935ea826c41$var$basicStateReducer);
}
function $b0f42935ea826c41$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($b0f42935ea826c41$var$isRenderPhaseUpdate(fiber)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $b0f42935ea826c41$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $b0f42935ea826c41$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $b0f42935ea826c41$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T, currentTransition = {};
        $b0f42935ea826c41$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $b0f42935ea826c41$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $b0f42935ea826c41$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $b0f42935ea826c41$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $b0f42935ea826c41$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $b0f42935ea826c41$var$onActionError(actionQueue, node, error$66);
    }
}
function $b0f42935ea826c41$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $b0f42935ea826c41$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $b0f42935ea826c41$var$onActionError(actionQueue, node, error);
    }) : $b0f42935ea826c41$var$onActionSuccess(actionQueue, node, returnValue);
}
function $b0f42935ea826c41$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $b0f42935ea826c41$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $b0f42935ea826c41$var$runActionStateAction(actionQueue, nextState)));
}
function $b0f42935ea826c41$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $b0f42935ea826c41$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $b0f42935ea826c41$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $b0f42935ea826c41$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $b0f42935ea826c41$var$mountActionState(action, initialStateProp) {
    if ($b0f42935ea826c41$var$isHydrating) {
        var ssrFormState = $b0f42935ea826c41$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $b0f42935ea826c41$var$currentlyRenderingFiber;
                if ($b0f42935ea826c41$var$isHydrating) {
                    if ($b0f42935ea826c41$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $b0f42935ea826c41$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $b0f42935ea826c41$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $b0f42935ea826c41$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $b0f42935ea826c41$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $b0f42935ea826c41$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b0f42935ea826c41$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $b0f42935ea826c41$var$dispatchSetState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $b0f42935ea826c41$var$mountStateImpl(!1);
    inRootOrSingleton = $b0f42935ea826c41$var$dispatchOptimisticSetState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $b0f42935ea826c41$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $b0f42935ea826c41$var$dispatchActionState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $b0f42935ea826c41$var$updateActionState(action) {
    var stateHook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    return $b0f42935ea826c41$var$updateActionStateImpl(stateHook, $b0f42935ea826c41$var$currentHook, action);
}
function $b0f42935ea826c41$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $b0f42935ea826c41$var$updateReducerImpl(stateHook, currentStateHook, $b0f42935ea826c41$var$actionStateReducer)[0];
    stateHook = $b0f42935ea826c41$var$updateReducer($b0f42935ea826c41$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $b0f42935ea826c41$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $b0f42935ea826c41$var$SuspenseException) throw $b0f42935ea826c41$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($b0f42935ea826c41$var$currentlyRenderingFiber.flags |= 2048, $b0f42935ea826c41$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $b0f42935ea826c41$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $b0f42935ea826c41$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $b0f42935ea826c41$var$rerenderActionState(action) {
    var stateHook = $b0f42935ea826c41$var$updateWorkInProgressHook(), currentStateHook = $b0f42935ea826c41$var$currentHook;
    if (null !== currentStateHook) return $b0f42935ea826c41$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $b0f42935ea826c41$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $b0f42935ea826c41$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $b0f42935ea826c41$var$createFunctionComponentUpdateQueue(), $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $b0f42935ea826c41$var$updateRef() {
    return $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
}
function $b0f42935ea826c41$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
    $b0f42935ea826c41$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $b0f42935ea826c41$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $b0f42935ea826c41$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $b0f42935ea826c41$var$currentHook && null !== deps && $b0f42935ea826c41$var$areHookInputsEqual(deps, $b0f42935ea826c41$var$currentHook.memoizedState.deps) ? hook.memoizedState = $b0f42935ea826c41$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($b0f42935ea826c41$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $b0f42935ea826c41$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $b0f42935ea826c41$var$mountEffect(create, deps) {
    $b0f42935ea826c41$var$mountEffectImpl(8390656, 8, create, deps);
}
function $b0f42935ea826c41$var$updateEffect(create, deps) {
    $b0f42935ea826c41$var$updateEffectImpl(2048, 8, create, deps);
}
function $b0f42935ea826c41$var$useEffectEventImpl(payload) {
    $b0f42935ea826c41$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $b0f42935ea826c41$var$createFunctionComponentUpdateQueue(), $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $b0f42935ea826c41$var$updateEvent(callback) {
    var ref = $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
    $b0f42935ea826c41$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($b0f42935ea826c41$var$executionContext & 2)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $b0f42935ea826c41$var$updateInsertionEffect(create, deps) {
    return $b0f42935ea826c41$var$updateEffectImpl(4, 2, create, deps);
}
function $b0f42935ea826c41$var$updateLayoutEffect(create, deps) {
    return $b0f42935ea826c41$var$updateEffectImpl(4, 4, create, deps);
}
function $b0f42935ea826c41$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $b0f42935ea826c41$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $b0f42935ea826c41$var$updateEffectImpl(4, 4, $b0f42935ea826c41$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $b0f42935ea826c41$var$mountDebugValue() {}
function $b0f42935ea826c41$var$updateCallback(callback, deps) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b0f42935ea826c41$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $b0f42935ea826c41$var$updateMemo(nextCreate, deps) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b0f42935ea826c41$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $b0f42935ea826c41$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $b0f42935ea826c41$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $b0f42935ea826c41$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($b0f42935ea826c41$var$renderLanes & 1073741824) && 0 === ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $b0f42935ea826c41$var$requestDeferredLane();
    $b0f42935ea826c41$var$currentlyRenderingFiber.lanes |= hook;
    $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $b0f42935ea826c41$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($b0f42935ea826c41$var$objectIs(value, prevValue)) return value;
    if (null !== $b0f42935ea826c41$var$currentTreeHiddenStackCursor.current) return hook = $b0f42935ea826c41$var$mountDeferredValueImpl(hook, value, initialValue), $b0f42935ea826c41$var$objectIs(hook, prevValue) || ($b0f42935ea826c41$var$didReceiveUpdate = !0), hook;
    if (0 === ($b0f42935ea826c41$var$renderLanes & 42) || 0 !== ($b0f42935ea826c41$var$renderLanes & 1073741824) && 0 === ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 261930)) return $b0f42935ea826c41$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $b0f42935ea826c41$var$requestDeferredLane();
    $b0f42935ea826c41$var$currentlyRenderingFiber.lanes |= hook;
    $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $b0f42935ea826c41$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T, currentTransition = {};
    $b0f42935ea826c41$var$ReactSharedInternals.T = currentTransition;
    $b0f42935ea826c41$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $b0f42935ea826c41$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $b0f42935ea826c41$var$chainThenableValue(returnValue, finishedState);
            $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $b0f42935ea826c41$var$requestUpdateLane(fiber));
        } else $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, finishedState, $b0f42935ea826c41$var$requestUpdateLane(fiber));
    } catch (error) {
        $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $b0f42935ea826c41$var$requestUpdateLane());
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b0f42935ea826c41$var$noop() {}
function $b0f42935ea826c41$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(476));
    var queue = $b0f42935ea826c41$var$ensureFormComponentIsStateful(formFiber).queue;
    $b0f42935ea826c41$var$startTransition(formFiber, queue, pendingState, $b0f42935ea826c41$var$sharedNotPendingObject, null === action ? $b0f42935ea826c41$var$noop : function() {
        $b0f42935ea826c41$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $b0f42935ea826c41$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $b0f42935ea826c41$var$sharedNotPendingObject,
        baseState: $b0f42935ea826c41$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b0f42935ea826c41$var$basicStateReducer,
            lastRenderedState: $b0f42935ea826c41$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b0f42935ea826c41$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $b0f42935ea826c41$var$requestFormReset$1(formFiber) {
    var stateHook = $b0f42935ea826c41$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $b0f42935ea826c41$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $b0f42935ea826c41$var$requestUpdateLane());
}
function $b0f42935ea826c41$var$useHostTransitionStatus() {
    return $b0f42935ea826c41$var$readContext($b0f42935ea826c41$var$HostTransitionContext);
}
function $b0f42935ea826c41$var$updateId() {
    return $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
}
function $b0f42935ea826c41$var$updateRefresh() {
    return $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
}
function $b0f42935ea826c41$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $b0f42935ea826c41$var$requestUpdateLane();
                fiber = $b0f42935ea826c41$var$createUpdate(lane);
                var root$69 = $b0f42935ea826c41$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(root$69, provider, lane), $b0f42935ea826c41$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $b0f42935ea826c41$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $b0f42935ea826c41$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $b0f42935ea826c41$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $b0f42935ea826c41$var$isRenderPhaseUpdate(fiber) ? $b0f42935ea826c41$var$enqueueRenderPhaseUpdate(queue, action) : (action = $b0f42935ea826c41$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(action, fiber, lane), $b0f42935ea826c41$var$entangleTransitionUpdate(action, queue, lane)));
}
function $b0f42935ea826c41$var$dispatchSetState(fiber, queue, action) {
    var lane = $b0f42935ea826c41$var$requestUpdateLane();
    $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b0f42935ea826c41$var$isRenderPhaseUpdate(fiber)) $b0f42935ea826c41$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($b0f42935ea826c41$var$objectIs(eagerState, currentState)) return $b0f42935ea826c41$var$enqueueUpdate$1(fiber, queue, update, 0), null === $b0f42935ea826c41$var$workInProgressRoot && $b0f42935ea826c41$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $b0f42935ea826c41$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $b0f42935ea826c41$var$scheduleUpdateOnFiber(action, fiber, lane), $b0f42935ea826c41$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $b0f42935ea826c41$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $b0f42935ea826c41$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b0f42935ea826c41$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $b0f42935ea826c41$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $b0f42935ea826c41$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $b0f42935ea826c41$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $b0f42935ea826c41$var$currentlyRenderingFiber || null !== alternate && alternate === $b0f42935ea826c41$var$currentlyRenderingFiber;
}
function $b0f42935ea826c41$var$enqueueRenderPhaseUpdate(queue, update) {
    $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass = $b0f42935ea826c41$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $b0f42935ea826c41$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $b0f42935ea826c41$var$markRootEntangled(root, lane);
    }
}
var $b0f42935ea826c41$var$ContextOnlyDispatcher = {
    readContext: $b0f42935ea826c41$var$readContext,
    use: $b0f42935ea826c41$var$use,
    useCallback: $b0f42935ea826c41$var$throwInvalidHookError,
    useContext: $b0f42935ea826c41$var$throwInvalidHookError,
    useEffect: $b0f42935ea826c41$var$throwInvalidHookError,
    useImperativeHandle: $b0f42935ea826c41$var$throwInvalidHookError,
    useLayoutEffect: $b0f42935ea826c41$var$throwInvalidHookError,
    useInsertionEffect: $b0f42935ea826c41$var$throwInvalidHookError,
    useMemo: $b0f42935ea826c41$var$throwInvalidHookError,
    useReducer: $b0f42935ea826c41$var$throwInvalidHookError,
    useRef: $b0f42935ea826c41$var$throwInvalidHookError,
    useState: $b0f42935ea826c41$var$throwInvalidHookError,
    useDebugValue: $b0f42935ea826c41$var$throwInvalidHookError,
    useDeferredValue: $b0f42935ea826c41$var$throwInvalidHookError,
    useTransition: $b0f42935ea826c41$var$throwInvalidHookError,
    useSyncExternalStore: $b0f42935ea826c41$var$throwInvalidHookError,
    useId: $b0f42935ea826c41$var$throwInvalidHookError,
    useHostTransitionStatus: $b0f42935ea826c41$var$throwInvalidHookError,
    useFormState: $b0f42935ea826c41$var$throwInvalidHookError,
    useActionState: $b0f42935ea826c41$var$throwInvalidHookError,
    useOptimistic: $b0f42935ea826c41$var$throwInvalidHookError,
    useMemoCache: $b0f42935ea826c41$var$throwInvalidHookError,
    useCacheRefresh: $b0f42935ea826c41$var$throwInvalidHookError
};
$b0f42935ea826c41$var$ContextOnlyDispatcher.useEffectEvent = $b0f42935ea826c41$var$throwInvalidHookError;
var $b0f42935ea826c41$var$HooksDispatcherOnMount = {
    readContext: $b0f42935ea826c41$var$readContext,
    use: $b0f42935ea826c41$var$use,
    useCallback: function(callback, deps) {
        $b0f42935ea826c41$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $b0f42935ea826c41$var$readContext,
    useEffect: $b0f42935ea826c41$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $b0f42935ea826c41$var$mountEffectImpl(4194308, 4, $b0f42935ea826c41$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $b0f42935ea826c41$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $b0f42935ea826c41$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b0f42935ea826c41$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $b0f42935ea826c41$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $b0f42935ea826c41$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $b0f42935ea826c41$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $b0f42935ea826c41$var$dispatchReducerAction.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $b0f42935ea826c41$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $b0f42935ea826c41$var$dispatchSetState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $b0f42935ea826c41$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        return $b0f42935ea826c41$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $b0f42935ea826c41$var$mountStateImpl(!1);
        stateHook = $b0f42935ea826c41$var$startTransition.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $b0f42935ea826c41$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $b0f42935ea826c41$var$currentlyRenderingFiber, hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        if ($b0f42935ea826c41$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $b0f42935ea826c41$var$workInProgressRoot) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(349));
            0 !== ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 127) || $b0f42935ea826c41$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $b0f42935ea826c41$var$mountEffect($b0f42935ea826c41$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $b0f42935ea826c41$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b0f42935ea826c41$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook(), identifierPrefix = $b0f42935ea826c41$var$workInProgressRoot.identifierPrefix;
        if ($b0f42935ea826c41$var$isHydrating) {
            var JSCompiler_inline_result = $b0f42935ea826c41$var$treeContextOverflow;
            var idWithLeadingBit = $b0f42935ea826c41$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $b0f42935ea826c41$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $b0f42935ea826c41$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $b0f42935ea826c41$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $b0f42935ea826c41$var$useHostTransitionStatus,
    useFormState: $b0f42935ea826c41$var$mountActionState,
    useActionState: $b0f42935ea826c41$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $b0f42935ea826c41$var$dispatchOptimisticSetState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $b0f42935ea826c41$var$useMemoCache,
    useCacheRefresh: function() {
        return $b0f42935ea826c41$var$mountWorkInProgressHook().memoizedState = $b0f42935ea826c41$var$refreshCache.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($b0f42935ea826c41$var$executionContext & 2)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $b0f42935ea826c41$var$HooksDispatcherOnUpdate = {
    readContext: $b0f42935ea826c41$var$readContext,
    use: $b0f42935ea826c41$var$use,
    useCallback: $b0f42935ea826c41$var$updateCallback,
    useContext: $b0f42935ea826c41$var$readContext,
    useEffect: $b0f42935ea826c41$var$updateEffect,
    useImperativeHandle: $b0f42935ea826c41$var$updateImperativeHandle,
    useInsertionEffect: $b0f42935ea826c41$var$updateInsertionEffect,
    useLayoutEffect: $b0f42935ea826c41$var$updateLayoutEffect,
    useMemo: $b0f42935ea826c41$var$updateMemo,
    useReducer: $b0f42935ea826c41$var$updateReducer,
    useRef: $b0f42935ea826c41$var$updateRef,
    useState: function() {
        return $b0f42935ea826c41$var$updateReducer($b0f42935ea826c41$var$basicStateReducer);
    },
    useDebugValue: $b0f42935ea826c41$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
        return $b0f42935ea826c41$var$updateDeferredValueImpl(hook, $b0f42935ea826c41$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b0f42935ea826c41$var$updateReducer($b0f42935ea826c41$var$basicStateReducer)[0], start = $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b0f42935ea826c41$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b0f42935ea826c41$var$updateSyncExternalStore,
    useId: $b0f42935ea826c41$var$updateId,
    useHostTransitionStatus: $b0f42935ea826c41$var$useHostTransitionStatus,
    useFormState: $b0f42935ea826c41$var$updateActionState,
    useActionState: $b0f42935ea826c41$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
        return $b0f42935ea826c41$var$updateOptimisticImpl(hook, $b0f42935ea826c41$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $b0f42935ea826c41$var$useMemoCache,
    useCacheRefresh: $b0f42935ea826c41$var$updateRefresh
};
$b0f42935ea826c41$var$HooksDispatcherOnUpdate.useEffectEvent = $b0f42935ea826c41$var$updateEvent;
var $b0f42935ea826c41$var$HooksDispatcherOnRerender = {
    readContext: $b0f42935ea826c41$var$readContext,
    use: $b0f42935ea826c41$var$use,
    useCallback: $b0f42935ea826c41$var$updateCallback,
    useContext: $b0f42935ea826c41$var$readContext,
    useEffect: $b0f42935ea826c41$var$updateEffect,
    useImperativeHandle: $b0f42935ea826c41$var$updateImperativeHandle,
    useInsertionEffect: $b0f42935ea826c41$var$updateInsertionEffect,
    useLayoutEffect: $b0f42935ea826c41$var$updateLayoutEffect,
    useMemo: $b0f42935ea826c41$var$updateMemo,
    useReducer: $b0f42935ea826c41$var$rerenderReducer,
    useRef: $b0f42935ea826c41$var$updateRef,
    useState: function() {
        return $b0f42935ea826c41$var$rerenderReducer($b0f42935ea826c41$var$basicStateReducer);
    },
    useDebugValue: $b0f42935ea826c41$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
        return null === $b0f42935ea826c41$var$currentHook ? $b0f42935ea826c41$var$mountDeferredValueImpl(hook, value, initialValue) : $b0f42935ea826c41$var$updateDeferredValueImpl(hook, $b0f42935ea826c41$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b0f42935ea826c41$var$rerenderReducer($b0f42935ea826c41$var$basicStateReducer)[0], start = $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b0f42935ea826c41$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b0f42935ea826c41$var$updateSyncExternalStore,
    useId: $b0f42935ea826c41$var$updateId,
    useHostTransitionStatus: $b0f42935ea826c41$var$useHostTransitionStatus,
    useFormState: $b0f42935ea826c41$var$rerenderActionState,
    useActionState: $b0f42935ea826c41$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
        if (null !== $b0f42935ea826c41$var$currentHook) return $b0f42935ea826c41$var$updateOptimisticImpl(hook, $b0f42935ea826c41$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $b0f42935ea826c41$var$useMemoCache,
    useCacheRefresh: $b0f42935ea826c41$var$updateRefresh
};
$b0f42935ea826c41$var$HooksDispatcherOnRerender.useEffectEvent = $b0f42935ea826c41$var$updateEvent;
function $b0f42935ea826c41$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $b0f42935ea826c41$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $b0f42935ea826c41$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b0f42935ea826c41$var$requestUpdateLane(), update = $b0f42935ea826c41$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b0f42935ea826c41$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(payload, inst, lane), $b0f42935ea826c41$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b0f42935ea826c41$var$requestUpdateLane(), update = $b0f42935ea826c41$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b0f42935ea826c41$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(payload, inst, lane), $b0f42935ea826c41$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $b0f42935ea826c41$var$requestUpdateLane(), update = $b0f42935ea826c41$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $b0f42935ea826c41$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(callback, inst, lane), $b0f42935ea826c41$var$entangleTransitions(callback, inst, lane));
    }
};
function $b0f42935ea826c41$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$b0f42935ea826c41$var$shallowEqual(oldProps, newProps) || !$b0f42935ea826c41$var$shallowEqual(oldState, newState) : !0;
}
function $b0f42935ea826c41$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $b0f42935ea826c41$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $b0f42935ea826c41$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $b0f42935ea826c41$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $b0f42935ea826c41$var$defaultOnUncaughtError(error) {
    $b0f42935ea826c41$var$reportGlobalError(error);
}
function $b0f42935ea826c41$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $b0f42935ea826c41$var$defaultOnRecoverableError(error) {
    $b0f42935ea826c41$var$reportGlobalError(error);
}
function $b0f42935ea826c41$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $b0f42935ea826c41$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $b0f42935ea826c41$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $b0f42935ea826c41$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $b0f42935ea826c41$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $b0f42935ea826c41$var$createClassErrorUpdate(lane) {
    lane = $b0f42935ea826c41$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $b0f42935ea826c41$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $b0f42935ea826c41$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $b0f42935ea826c41$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed ? $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $b0f42935ea826c41$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $b0f42935ea826c41$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $b0f42935ea826c41$var$shellBoundary ? $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $b0f42935ea826c41$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $b0f42935ea826c41$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $b0f42935ea826c41$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $b0f42935ea826c41$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $b0f42935ea826c41$var$attachPingListener(root, value, rootRenderLanes);
        $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($b0f42935ea826c41$var$isHydrating) return returnFiber = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $b0f42935ea826c41$var$HydrationMismatchException && (root = Error($b0f42935ea826c41$var$formatProdErrorMessage(422), {
        cause: value
    }), $b0f42935ea826c41$var$queueHydrationError($b0f42935ea826c41$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $b0f42935ea826c41$var$HydrationMismatchException && (returnFiber = Error($b0f42935ea826c41$var$formatProdErrorMessage(423), {
        cause: value
    }), $b0f42935ea826c41$var$queueHydrationError($b0f42935ea826c41$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $b0f42935ea826c41$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $b0f42935ea826c41$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $b0f42935ea826c41$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($b0f42935ea826c41$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $b0f42935ea826c41$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $b0f42935ea826c41$var$workInProgressRootConcurrentErrors ? $b0f42935ea826c41$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $b0f42935ea826c41$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $b0f42935ea826c41$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $b0f42935ea826c41$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $b0f42935ea826c41$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed || !$b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $b0f42935ea826c41$var$createClassErrorUpdate(rootRenderLanes), $b0f42935ea826c41$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $b0f42935ea826c41$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $b0f42935ea826c41$var$SelectiveHydrationException = Error($b0f42935ea826c41$var$formatProdErrorMessage(461)), $b0f42935ea826c41$var$didReceiveUpdate = !1;
function $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $b0f42935ea826c41$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $b0f42935ea826c41$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $b0f42935ea826c41$var$prepareToReadContext(workInProgress);
    nextProps = $b0f42935ea826c41$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $b0f42935ea826c41$var$checkDidRenderIdHook();
    if (null !== current && !$b0f42935ea826c41$var$didReceiveUpdate) return $b0f42935ea826c41$var$bailoutHooks(current, workInProgress, renderLanes), $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b0f42935ea826c41$var$isHydrating && key && $b0f42935ea826c41$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b0f42935ea826c41$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$b0f42935ea826c41$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $b0f42935ea826c41$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $b0f42935ea826c41$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$b0f42935ea826c41$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $b0f42935ea826c41$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $b0f42935ea826c41$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $b0f42935ea826c41$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($b0f42935ea826c41$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($b0f42935ea826c41$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $b0f42935ea826c41$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($b0f42935ea826c41$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $b0f42935ea826c41$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $b0f42935ea826c41$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $b0f42935ea826c41$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $b0f42935ea826c41$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $b0f42935ea826c41$var$pushHiddenContext(workInProgress, prevState) : $b0f42935ea826c41$var$reuseHiddenContextOnStack(), $b0f42935ea826c41$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $b0f42935ea826c41$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($b0f42935ea826c41$var$pushTransition(workInProgress, prevState.cachePool), $b0f42935ea826c41$var$pushHiddenContext(workInProgress, prevState), $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $b0f42935ea826c41$var$pushTransition(workInProgress, null), $b0f42935ea826c41$var$reuseHiddenContextOnStack(), $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress));
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $b0f42935ea826c41$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $b0f42935ea826c41$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $b0f42935ea826c41$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $b0f42935ea826c41$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $b0f42935ea826c41$var$pushTransition(workInProgress, null);
    $b0f42935ea826c41$var$reuseHiddenContextOnStack();
    $b0f42935ea826c41$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $b0f42935ea826c41$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $b0f42935ea826c41$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b0f42935ea826c41$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $b0f42935ea826c41$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($b0f42935ea826c41$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $b0f42935ea826c41$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $b0f42935ea826c41$var$bailoutOffscreenComponent(null, current);
            $b0f42935ea826c41$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $b0f42935ea826c41$var$nextHydratableInstance) ? (current = $b0f42935ea826c41$var$canHydrateHydrationBoundary(current, $b0f42935ea826c41$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b0f42935ea826c41$var$treeContextProvider ? {
                    id: $b0f42935ea826c41$var$treeContextId,
                    overflow: $b0f42935ea826c41$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b0f42935ea826c41$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $b0f42935ea826c41$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $b0f42935ea826c41$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $b0f42935ea826c41$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($b0f42935ea826c41$var$formatProdErrorMessage(558));
        } else if ($b0f42935ea826c41$var$didReceiveUpdate || $b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $b0f42935ea826c41$var$didReceiveUpdate || didSuspend) {
            nextProps = $b0f42935ea826c41$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $b0f42935ea826c41$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(current, dehydrated), $b0f42935ea826c41$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $b0f42935ea826c41$var$SelectiveHydrationException;
            $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b0f42935ea826c41$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(dehydrated.nextSibling), $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$isHydrating = !0, $b0f42935ea826c41$var$hydrationErrors = null, $b0f42935ea826c41$var$rootOrSingletonContext = !1, null !== current && $b0f42935ea826c41$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b0f42935ea826c41$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $b0f42935ea826c41$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $b0f42935ea826c41$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $b0f42935ea826c41$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b0f42935ea826c41$var$prepareToReadContext(workInProgress);
    Component = $b0f42935ea826c41$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $b0f42935ea826c41$var$checkDidRenderIdHook();
    if (null !== current && !$b0f42935ea826c41$var$didReceiveUpdate) return $b0f42935ea826c41$var$bailoutHooks(current, workInProgress, renderLanes), $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b0f42935ea826c41$var$isHydrating && nextProps && $b0f42935ea826c41$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $b0f42935ea826c41$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $b0f42935ea826c41$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $b0f42935ea826c41$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $b0f42935ea826c41$var$finishRenderingHooks(current);
    Component = $b0f42935ea826c41$var$checkDidRenderIdHook();
    if (null !== current && !$b0f42935ea826c41$var$didReceiveUpdate) return $b0f42935ea826c41$var$bailoutHooks(current, workInProgress, renderLanes), $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b0f42935ea826c41$var$isHydrating && Component && $b0f42935ea826c41$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b0f42935ea826c41$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b0f42935ea826c41$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $b0f42935ea826c41$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $b0f42935ea826c41$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $b0f42935ea826c41$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $b0f42935ea826c41$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $b0f42935ea826c41$var$readContext(contextType) : $b0f42935ea826c41$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($b0f42935ea826c41$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $b0f42935ea826c41$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $b0f42935ea826c41$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $b0f42935ea826c41$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $b0f42935ea826c41$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $b0f42935ea826c41$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $b0f42935ea826c41$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $b0f42935ea826c41$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b0f42935ea826c41$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $b0f42935ea826c41$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($b0f42935ea826c41$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $b0f42935ea826c41$var$hasForceUpdate || $b0f42935ea826c41$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $b0f42935ea826c41$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $b0f42935ea826c41$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $b0f42935ea826c41$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $b0f42935ea826c41$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $b0f42935ea826c41$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $b0f42935ea826c41$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b0f42935ea826c41$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $b0f42935ea826c41$var$hasForceUpdate || null !== current && null !== current.dependencies && $b0f42935ea826c41$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($b0f42935ea826c41$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $b0f42935ea826c41$var$hasForceUpdate || $b0f42935ea826c41$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $b0f42935ea826c41$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $b0f42935ea826c41$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $b0f42935ea826c41$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $b0f42935ea826c41$var$resetHydrationState();
    workInProgress.flags |= 256;
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $b0f42935ea826c41$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $b0f42935ea826c41$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $b0f42935ea826c41$var$getSuspendedCache()
    };
}
function $b0f42935ea826c41$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $b0f42935ea826c41$var$workInProgressDeferredLane);
    return current;
}
function $b0f42935ea826c41$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($b0f42935ea826c41$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($b0f42935ea826c41$var$isHydrating) {
            showFallback ? $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $b0f42935ea826c41$var$nextHydratableInstance) ? (current = $b0f42935ea826c41$var$canHydrateHydrationBoundary(current, $b0f42935ea826c41$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b0f42935ea826c41$var$treeContextProvider ? {
                    id: $b0f42935ea826c41$var$treeContextId,
                    overflow: $b0f42935ea826c41$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b0f42935ea826c41$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress);
            $b0f42935ea826c41$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $b0f42935ea826c41$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $b0f42935ea826c41$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b0f42935ea826c41$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b0f42935ea826c41$var$SUSPENDED_MARKER, $b0f42935ea826c41$var$bailoutOffscreenComponent(null, nextProps);
        $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $b0f42935ea826c41$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $b0f42935ea826c41$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $b0f42935ea826c41$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $b0f42935ea826c41$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b0f42935ea826c41$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b0f42935ea826c41$var$SUSPENDED_MARKER, workInProgress = $b0f42935ea826c41$var$bailoutOffscreenComponent(null, nextProps));
        else if ($b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress), $b0f42935ea826c41$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($b0f42935ea826c41$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $b0f42935ea826c41$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $b0f42935ea826c41$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($b0f42935ea826c41$var$didReceiveUpdate || $b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $b0f42935ea826c41$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $b0f42935ea826c41$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $b0f42935ea826c41$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(current, nextProps), $b0f42935ea826c41$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $b0f42935ea826c41$var$SelectiveHydrationException;
            $b0f42935ea826c41$var$isSuspenseInstancePending(nextPrimaryChildren) || $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b0f42935ea826c41$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $b0f42935ea826c41$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(nextPrimaryChildren.nextSibling), $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$isHydrating = !0, $b0f42935ea826c41$var$hydrationErrors = null, $b0f42935ea826c41$var$rootOrSingletonContext = !1, null !== current && $b0f42935ea826c41$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b0f42935ea826c41$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $b0f42935ea826c41$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $b0f42935ea826c41$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $b0f42935ea826c41$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b0f42935ea826c41$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $b0f42935ea826c41$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $b0f42935ea826c41$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $b0f42935ea826c41$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $b0f42935ea826c41$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b0f42935ea826c41$var$SUSPENDED_MARKER, $b0f42935ea826c41$var$bailoutOffscreenComponent(current.child, nextProps);
    $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $b0f42935ea826c41$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $b0f42935ea826c41$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $b0f42935ea826c41$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $b0f42935ea826c41$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b0f42935ea826c41$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $b0f42935ea826c41$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $b0f42935ea826c41$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $b0f42935ea826c41$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $b0f42935ea826c41$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $b0f42935ea826c41$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, suspenseContext);
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $b0f42935ea826c41$var$isHydrating ? $b0f42935ea826c41$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $b0f42935ea826c41$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $b0f42935ea826c41$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $b0f42935ea826c41$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $b0f42935ea826c41$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $b0f42935ea826c41$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $b0f42935ea826c41$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $b0f42935ea826c41$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $b0f42935ea826c41$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $b0f42935ea826c41$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $b0f42935ea826c41$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $b0f42935ea826c41$var$checkIfContextChanged(current) ? !0 : !1;
}
function $b0f42935ea826c41$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $b0f42935ea826c41$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, current.memoizedState.cache);
            $b0f42935ea826c41$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $b0f42935ea826c41$var$pushHostContext(workInProgress);
            break;
        case 4:
            $b0f42935ea826c41$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $b0f42935ea826c41$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $b0f42935ea826c41$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $b0f42935ea826c41$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $b0f42935ea826c41$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $b0f42935ea826c41$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, current.memoizedState.cache);
    }
    return $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $b0f42935ea826c41$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $b0f42935ea826c41$var$didReceiveUpdate = !0;
        else {
            if (!$b0f42935ea826c41$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $b0f42935ea826c41$var$didReceiveUpdate = !1, $b0f42935ea826c41$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $b0f42935ea826c41$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $b0f42935ea826c41$var$didReceiveUpdate = !1, $b0f42935ea826c41$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $b0f42935ea826c41$var$pushTreeId(workInProgress, $b0f42935ea826c41$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $b0f42935ea826c41$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $b0f42935ea826c41$var$shouldConstruct(current) ? (props = $b0f42935ea826c41$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $b0f42935ea826c41$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $b0f42935ea826c41$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $b0f42935ea826c41$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $b0f42935ea826c41$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $b0f42935ea826c41$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $b0f42935ea826c41$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $b0f42935ea826c41$var$getComponentNameFromType(current) || current;
                    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $b0f42935ea826c41$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $b0f42935ea826c41$var$resolveClassComponentProps(props, workInProgress.pendingProps), $b0f42935ea826c41$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $b0f42935ea826c41$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $b0f42935ea826c41$var$cloneUpdateQueue(current, workInProgress);
                $b0f42935ea826c41$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, props);
                props !== prevState.cache && $b0f42935ea826c41$var$propagateContextChanges(workInProgress, [
                    $b0f42935ea826c41$var$CacheContext
                ], renderLanes, !0);
                $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $b0f42935ea826c41$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $b0f42935ea826c41$var$createCapturedValueAtFiber(Error($b0f42935ea826c41$var$formatProdErrorMessage(424)), workInProgress);
                        $b0f42935ea826c41$var$queueHydrationError($$typeof);
                        workInProgress = $b0f42935ea826c41$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(current.firstChild);
                        $b0f42935ea826c41$var$hydrationParentFiber = workInProgress;
                        $b0f42935ea826c41$var$isHydrating = !0;
                        $b0f42935ea826c41$var$hydrationErrors = null;
                        $b0f42935ea826c41$var$rootOrSingletonContext = !0;
                        renderLanes = $b0f42935ea826c41$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $b0f42935ea826c41$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $b0f42935ea826c41$var$markRef(current, workInProgress), null === current ? (renderLanes = $b0f42935ea826c41$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $b0f42935ea826c41$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer($b0f42935ea826c41$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress, props[$b0f42935ea826c41$var$internalPropsKey] = current, $b0f42935ea826c41$var$setInitialProperties(props, renderLanes, current), $b0f42935ea826c41$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $b0f42935ea826c41$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $b0f42935ea826c41$var$pushHostContext(workInProgress), null === current && $b0f42935ea826c41$var$isHydrating && (props = workInProgress.stateNode = $b0f42935ea826c41$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $b0f42935ea826c41$var$rootInstanceStackCursor.current), $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$rootOrSingletonContext = !0, $$typeof = $b0f42935ea826c41$var$nextHydratableInstance, $b0f42935ea826c41$var$isSingletonScope(workInProgress.type) ? ($b0f42935ea826c41$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(props.firstChild)) : $b0f42935ea826c41$var$nextHydratableInstance = $$typeof), $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $b0f42935ea826c41$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $b0f42935ea826c41$var$isHydrating) {
                if ($$typeof = props = $b0f42935ea826c41$var$nextHydratableInstance) props = $b0f42935ea826c41$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $b0f42935ea826c41$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(props.firstChild), $b0f42935ea826c41$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress);
            }
            $b0f42935ea826c41$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $b0f42935ea826c41$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $b0f42935ea826c41$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $b0f42935ea826c41$var$renderWithHooks(current, workInProgress, $b0f42935ea826c41$var$TransitionAwareHostComponent, null, null, renderLanes), $b0f42935ea826c41$var$HostTransitionContext._currentValue = $$typeof);
            $b0f42935ea826c41$var$markRef(current, workInProgress);
            $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $b0f42935ea826c41$var$isHydrating) {
                if (current = renderLanes = $b0f42935ea826c41$var$nextHydratableInstance) renderLanes = $b0f42935ea826c41$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $b0f42935ea826c41$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $b0f42935ea826c41$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $b0f42935ea826c41$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $b0f42935ea826c41$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $b0f42935ea826c41$var$pushProvider(workInProgress, workInProgress.type, props.value), $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $b0f42935ea826c41$var$prepareToReadContext(workInProgress), $$typeof = $b0f42935ea826c41$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $b0f42935ea826c41$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $b0f42935ea826c41$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $b0f42935ea826c41$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $b0f42935ea826c41$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $b0f42935ea826c41$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $b0f42935ea826c41$var$prepareToReadContext(workInProgress), props = $b0f42935ea826c41$var$readContext($b0f42935ea826c41$var$CacheContext), null === current ? ($$typeof = $b0f42935ea826c41$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $b0f42935ea826c41$var$workInProgressRoot, prevState = $b0f42935ea826c41$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $b0f42935ea826c41$var$initializeUpdateQueue(workInProgress), $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($b0f42935ea826c41$var$cloneUpdateQueue(current, workInProgress), $b0f42935ea826c41$var$processUpdateQueue(workInProgress, null, null, renderLanes), $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, props)) : (props = prevState.cache, $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, props), props !== $$typeof.cache && $b0f42935ea826c41$var$propagateContextChanges(workInProgress, [
                $b0f42935ea826c41$var$CacheContext
            ], renderLanes, !0))), $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b0f42935ea826c41$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $b0f42935ea826c41$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($b0f42935ea826c41$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $b0f42935ea826c41$var$suspendedThenable = $b0f42935ea826c41$var$noopSuspenseyCommitThenable, $b0f42935ea826c41$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $b0f42935ea826c41$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$b0f42935ea826c41$var$preloadResource(resource)) {
        if ($b0f42935ea826c41$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $b0f42935ea826c41$var$suspendedThenable = $b0f42935ea826c41$var$noopSuspenseyCommitThenable, $b0f42935ea826c41$var$SuspenseyCommitException;
    }
}
function $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $b0f42935ea826c41$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $b0f42935ea826c41$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$b0f42935ea826c41$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $b0f42935ea826c41$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $b0f42935ea826c41$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $b0f42935ea826c41$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 1:
            return $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext);
            $b0f42935ea826c41$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $b0f42935ea826c41$var$popHydrationState(workInProgress) ? $b0f42935ea826c41$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $b0f42935ea826c41$var$upgradeHydrationErrorsToRecoverable());
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($b0f42935ea826c41$var$markUpdate(workInProgress), null !== nextResource ? ($b0f42935ea826c41$var$bubbleProperties(workInProgress), $b0f42935ea826c41$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b0f42935ea826c41$var$bubbleProperties(workInProgress), $b0f42935ea826c41$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($b0f42935ea826c41$var$markUpdate(workInProgress), $b0f42935ea826c41$var$bubbleProperties(workInProgress), $b0f42935ea826c41$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b0f42935ea826c41$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $b0f42935ea826c41$var$markUpdate(workInProgress), $b0f42935ea826c41$var$bubbleProperties(workInProgress), $b0f42935ea826c41$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $b0f42935ea826c41$var$popHostContext(workInProgress);
            renderLanes = $b0f42935ea826c41$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b0f42935ea826c41$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(166));
                    $b0f42935ea826c41$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b0f42935ea826c41$var$contextStackCursor.current;
                $b0f42935ea826c41$var$popHydrationState(workInProgress) ? $b0f42935ea826c41$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $b0f42935ea826c41$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $b0f42935ea826c41$var$markUpdate(workInProgress));
            }
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $b0f42935ea826c41$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b0f42935ea826c41$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(166));
                    $b0f42935ea826c41$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $b0f42935ea826c41$var$contextStackCursor.current;
                if ($b0f42935ea826c41$var$popHydrationState(workInProgress)) $b0f42935ea826c41$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer($b0f42935ea826c41$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress;
                    nextResource[$b0f42935ea826c41$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($b0f42935ea826c41$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $b0f42935ea826c41$var$markUpdate(workInProgress);
                }
            }
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            $b0f42935ea826c41$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b0f42935ea826c41$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(166));
                current = $b0f42935ea826c41$var$rootInstanceStackCursor.current;
                if ($b0f42935ea826c41$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $b0f42935ea826c41$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $b0f42935ea826c41$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $b0f42935ea826c41$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(557));
                        current[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress;
                    } else $b0f42935ea826c41$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b0f42935ea826c41$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $b0f42935ea826c41$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $b0f42935ea826c41$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(558));
            }
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $b0f42935ea826c41$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(317));
                        type[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress;
                    } else $b0f42935ea826c41$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b0f42935ea826c41$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $b0f42935ea826c41$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $b0f42935ea826c41$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $b0f42935ea826c41$var$popHostContainer(), null === current && $b0f42935ea826c41$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 10:
            return $b0f42935ea826c41$var$popProvider(workInProgress.type), $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 19:
            $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $b0f42935ea826c41$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $b0f42935ea826c41$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$b0f42935ea826c41$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current & 1 | 2);
                            $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $b0f42935ea826c41$var$now() > $b0f42935ea826c41$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $b0f42935ea826c41$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, current), $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$b0f42935ea826c41$var$isHydrating) return $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
                    } else 2 * $b0f42935ea826c41$var$now() - newProps.renderingStartTime > $b0f42935ea826c41$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $b0f42935ea826c41$var$now(), current.sibling = null, renderLanes = $b0f42935ea826c41$var$suspenseStackCursor.current, $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $b0f42935ea826c41$var$popSuspenseHandler(workInProgress), $b0f42935ea826c41$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($b0f42935ea826c41$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $b0f42935ea826c41$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext), $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b0f42935ea826c41$var$unwindWork(current, workInProgress) {
    $b0f42935ea826c41$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext), $b0f42935ea826c41$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $b0f42935ea826c41$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(340));
                $b0f42935ea826c41$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(340));
                $b0f42935ea826c41$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseStackCursor), null;
        case 4:
            return $b0f42935ea826c41$var$popHostContainer(), null;
        case 10:
            return $b0f42935ea826c41$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $b0f42935ea826c41$var$popSuspenseHandler(workInProgress), $b0f42935ea826c41$var$popHiddenContext(), null !== current && $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $b0f42935ea826c41$var$unwindInterruptedWork(current, interruptedWork) {
    $b0f42935ea826c41$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext);
            $b0f42935ea826c41$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $b0f42935ea826c41$var$popHostContext(interruptedWork);
            break;
        case 4:
            $b0f42935ea826c41$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $b0f42935ea826c41$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $b0f42935ea826c41$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseStackCursor);
            break;
        case 10:
            $b0f42935ea826c41$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $b0f42935ea826c41$var$popSuspenseHandler(interruptedWork);
            $b0f42935ea826c41$var$popHiddenContext();
            null !== current && $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$resumedCache);
            break;
        case 24:
            $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext);
    }
}
function $b0f42935ea826c41$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $b0f42935ea826c41$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $b0f42935ea826c41$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b0f42935ea826c41$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $b0f42935ea826c41$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b0f42935ea826c41$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b0f42935ea826c41$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $b0f42935ea826c41$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $b0f42935ea826c41$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $b0f42935ea826c41$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $b0f42935ea826c41$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$b0f42935ea826c41$var$internalPropsKey] = newProps;
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $b0f42935ea826c41$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $b0f42935ea826c41$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $b0f42935ea826c41$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $b0f42935ea826c41$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $b0f42935ea826c41$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $b0f42935ea826c41$var$noop$1));
    else if (4 !== tag && (27 === tag && $b0f42935ea826c41$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($b0f42935ea826c41$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$b0f42935ea826c41$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $b0f42935ea826c41$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $b0f42935ea826c41$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($b0f42935ea826c41$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$b0f42935ea826c41$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $b0f42935ea826c41$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $b0f42935ea826c41$var$setInitialProperties(singleton, type, props);
        singleton[$b0f42935ea826c41$var$internalInstanceKey] = finishedWork;
        singleton[$b0f42935ea826c41$var$internalPropsKey] = props;
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $b0f42935ea826c41$var$offscreenSubtreeIsHidden = !1, $b0f42935ea826c41$var$offscreenSubtreeWasHidden = !1, $b0f42935ea826c41$var$needsFormReset = !1, $b0f42935ea826c41$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $b0f42935ea826c41$var$nextEffect = null;
function $b0f42935ea826c41$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $b0f42935ea826c41$var$eventsEnabled = $b0f42935ea826c41$var$_enabled;
    root = $b0f42935ea826c41$var$getActiveElementDeep(root);
    if ($b0f42935ea826c41$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $b0f42935ea826c41$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $b0f42935ea826c41$var$_enabled = !1;
    for($b0f42935ea826c41$var$nextEffect = firstChild; null !== $b0f42935ea826c41$var$nextEffect;)if (firstChild = $b0f42935ea826c41$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $b0f42935ea826c41$var$nextEffect = root;
    else for(; null !== $b0f42935ea826c41$var$nextEffect;){
        firstChild = $b0f42935ea826c41$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $b0f42935ea826c41$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $b0f42935ea826c41$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $b0f42935ea826c41$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $b0f42935ea826c41$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $b0f42935ea826c41$var$nextEffect = root;
            break;
        }
        $b0f42935ea826c41$var$nextEffect = firstChild.return;
    }
}
function $b0f42935ea826c41$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b0f42935ea826c41$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $b0f42935ea826c41$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $b0f42935ea826c41$var$commitClassCallbacks(finishedWork);
            flags & 512 && $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $b0f42935ea826c41$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $b0f42935ea826c41$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $b0f42935ea826c41$var$commitHostMount(finishedWork);
            flags & 512 && $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b0f42935ea826c41$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b0f42935ea826c41$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $b0f42935ea826c41$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $b0f42935ea826c41$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $b0f42935ea826c41$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $b0f42935ea826c41$var$offscreenSubtreeWasHidden;
                prevProps = $b0f42935ea826c41$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $b0f42935ea826c41$var$offscreenSubtreeWasHidden;
                $b0f42935ea826c41$var$offscreenSubtreeIsHidden = flags;
                ($b0f42935ea826c41$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $b0f42935ea826c41$var$offscreenSubtreeIsHidden = prevProps;
                $b0f42935ea826c41$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $b0f42935ea826c41$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $b0f42935ea826c41$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $b0f42935ea826c41$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $b0f42935ea826c41$var$hostParent = null, $b0f42935ea826c41$var$hostParentIsContainer = !1;
function $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$b0f42935ea826c41$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $b0f42935ea826c41$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($b0f42935ea826c41$var$injectedHook && "function" === typeof $b0f42935ea826c41$var$injectedHook.onCommitFiberUnmount) try {
        $b0f42935ea826c41$var$injectedHook.onCommitFiberUnmount($b0f42935ea826c41$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $b0f42935ea826c41$var$hostParent, prevHostParentIsContainer = $b0f42935ea826c41$var$hostParentIsContainer;
            $b0f42935ea826c41$var$isSingletonScope(deletedFiber.type) && ($b0f42935ea826c41$var$hostParent = deletedFiber.stateNode, $b0f42935ea826c41$var$hostParentIsContainer = !1);
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b0f42935ea826c41$var$releaseSingletonInstance(deletedFiber.stateNode);
            $b0f42935ea826c41$var$hostParent = prevHostParent;
            $b0f42935ea826c41$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $b0f42935ea826c41$var$hostParent;
            prevHostParentIsContainer = $b0f42935ea826c41$var$hostParentIsContainer;
            $b0f42935ea826c41$var$hostParent = null;
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b0f42935ea826c41$var$hostParent = prevHostParent;
            $b0f42935ea826c41$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $b0f42935ea826c41$var$hostParent) {
                if ($b0f42935ea826c41$var$hostParentIsContainer) try {
                    (9 === $b0f42935ea826c41$var$hostParent.nodeType ? $b0f42935ea826c41$var$hostParent.body : "HTML" === $b0f42935ea826c41$var$hostParent.nodeName ? $b0f42935ea826c41$var$hostParent.ownerDocument.body : $b0f42935ea826c41$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $b0f42935ea826c41$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $b0f42935ea826c41$var$hostParent && ($b0f42935ea826c41$var$hostParentIsContainer ? (finishedRoot = $b0f42935ea826c41$var$hostParent, $b0f42935ea826c41$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $b0f42935ea826c41$var$retryIfBlockedOn(finishedRoot)) : $b0f42935ea826c41$var$clearHydrationBoundary($b0f42935ea826c41$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $b0f42935ea826c41$var$hostParent;
            prevHostParentIsContainer = $b0f42935ea826c41$var$hostParentIsContainer;
            $b0f42935ea826c41$var$hostParent = deletedFiber.stateNode.containerInfo;
            $b0f42935ea826c41$var$hostParentIsContainer = !0;
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b0f42935ea826c41$var$hostParent = prevHostParent;
            $b0f42935ea826c41$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $b0f42935ea826c41$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || ($b0f42935ea826c41$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $b0f42935ea826c41$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden = (prevHostParent = $b0f42935ea826c41$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $b0f42935ea826c41$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $b0f42935ea826c41$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b0f42935ea826c41$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $b0f42935ea826c41$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $b0f42935ea826c41$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $b0f42935ea826c41$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $b0f42935ea826c41$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $b0f42935ea826c41$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($b0f42935ea826c41$var$isSingletonScope(parent.type)) {
                        $b0f42935ea826c41$var$hostParent = parent.stateNode;
                        $b0f42935ea826c41$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $b0f42935ea826c41$var$hostParent = parent.stateNode;
                    $b0f42935ea826c41$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $b0f42935ea826c41$var$hostParent = parent.stateNode.containerInfo;
                    $b0f42935ea826c41$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $b0f42935ea826c41$var$hostParent) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(160));
        $b0f42935ea826c41$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $b0f42935ea826c41$var$hostParent = null;
        $b0f42935ea826c41$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $b0f42935ea826c41$var$currentHoistableRoot = null;
function $b0f42935ea826c41$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($b0f42935ea826c41$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $b0f42935ea826c41$var$commitHookEffectListMount(3, finishedWork), $b0f42935ea826c41$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b0f42935ea826c41$var$offscreenSubtreeWasHidden || null === current || $b0f42935ea826c41$var$safelyDetachRef(current, current.return));
            flags & 64 && $b0f42935ea826c41$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $b0f42935ea826c41$var$currentHoistableRoot;
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b0f42935ea826c41$var$offscreenSubtreeWasHidden || null === current || $b0f42935ea826c41$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$b0f42935ea826c41$var$internalHoistableMarker] || currentResource[$b0f42935ea826c41$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $b0f42935ea826c41$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$b0f42935ea826c41$var$internalInstanceKey] = finishedWork;
                                        $b0f42935ea826c41$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $b0f42935ea826c41$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b0f42935ea826c41$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $b0f42935ea826c41$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b0f42935ea826c41$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$b0f42935ea826c41$var$internalInstanceKey] = finishedWork;
                                $b0f42935ea826c41$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $b0f42935ea826c41$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $b0f42935ea826c41$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $b0f42935ea826c41$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $b0f42935ea826c41$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $b0f42935ea826c41$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b0f42935ea826c41$var$offscreenSubtreeWasHidden || null === current || $b0f42935ea826c41$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $b0f42935ea826c41$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b0f42935ea826c41$var$offscreenSubtreeWasHidden || null === current || $b0f42935ea826c41$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $b0f42935ea826c41$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $b0f42935ea826c41$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($b0f42935ea826c41$var$needsFormReset = !0);
            break;
        case 6:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $b0f42935ea826c41$var$tagCaches = null;
            hoistableRoot = $b0f42935ea826c41$var$currentHoistableRoot;
            $b0f42935ea826c41$var$currentHoistableRoot = $b0f42935ea826c41$var$getHoistableRoot(root.containerInfo);
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$currentHoistableRoot = hoistableRoot;
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $b0f42935ea826c41$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $b0f42935ea826c41$var$needsFormReset && ($b0f42935ea826c41$var$needsFormReset = !1, $b0f42935ea826c41$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $b0f42935ea826c41$var$currentHoistableRoot;
            $b0f42935ea826c41$var$currentHoistableRoot = $b0f42935ea826c41$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            $b0f42935ea826c41$var$currentHoistableRoot = flags;
            break;
        case 12:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($b0f42935ea826c41$var$globalMostRecentFallbackTime = $b0f42935ea826c41$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $b0f42935ea826c41$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $b0f42935ea826c41$var$offscreenSubtreeWasHidden;
            $b0f42935ea826c41$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $b0f42935ea826c41$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $b0f42935ea826c41$var$offscreenSubtreeIsHidden || $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $b0f42935ea826c41$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $b0f42935ea826c41$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $b0f42935ea826c41$var$hideOrUnhideDehydratedBoundary(instance, !0) : $b0f42935ea826c41$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $b0f42935ea826c41$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork), $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
    }
}
function $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($b0f42935ea826c41$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $b0f42935ea826c41$var$getHostSibling(finishedWork);
                    $b0f42935ea826c41$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($b0f42935ea826c41$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $b0f42935ea826c41$var$getHostSibling(finishedWork);
                    $b0f42935ea826c41$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $b0f42935ea826c41$var$getHostSibling(finishedWork);
                    $b0f42935ea826c41$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $b0f42935ea826c41$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $b0f42935ea826c41$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $b0f42935ea826c41$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $b0f42935ea826c41$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $b0f42935ea826c41$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $b0f42935ea826c41$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $b0f42935ea826c41$var$safelyDetachRef(finishedWork, finishedWork.return);
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b0f42935ea826c41$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$b0f42935ea826c41$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $b0f42935ea826c41$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $b0f42935ea826c41$var$commitClassCallbacks(finishedWork);
                $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $b0f42935ea826c41$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $b0f42935ea826c41$var$commitHostMount(finishedWork);
                $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b0f42935ea826c41$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b0f42935ea826c41$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $b0f42935ea826c41$var$releaseCache(previousCache));
}
function $b0f42935ea826c41$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $b0f42935ea826c41$var$releaseCache(current));
}
function $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $b0f42935ea826c41$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b0f42935ea826c41$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $b0f42935ea826c41$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $b0f42935ea826c41$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b0f42935ea826c41$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $b0f42935ea826c41$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $b0f42935ea826c41$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $b0f42935ea826c41$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b0f42935ea826c41$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b0f42935ea826c41$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $b0f42935ea826c41$var$suspenseyCommitFlag = 8192;
function $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $b0f42935ea826c41$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $b0f42935ea826c41$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $b0f42935ea826c41$var$suspenseyCommitFlag && null !== fiber.memoizedState && $b0f42935ea826c41$var$suspendResource(suspendedState, $b0f42935ea826c41$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $b0f42935ea826c41$var$currentHoistableRoot;
            $b0f42935ea826c41$var$currentHoistableRoot = $b0f42935ea826c41$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $b0f42935ea826c41$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $b0f42935ea826c41$var$suspenseyCommitFlag, $b0f42935ea826c41$var$suspenseyCommitFlag = 16777216, $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $b0f42935ea826c41$var$suspenseyCommitFlag = previousHoistableRoot) : $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $b0f42935ea826c41$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b0f42935ea826c41$var$nextEffect = childToDelete;
            $b0f42935ea826c41$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b0f42935ea826c41$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b0f42935ea826c41$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $b0f42935ea826c41$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b0f42935ea826c41$var$nextEffect = childToDelete;
            $b0f42935ea826c41$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b0f42935ea826c41$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $b0f42935ea826c41$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $b0f42935ea826c41$var$nextEffect;){
        var fiber = $b0f42935ea826c41$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $b0f42935ea826c41$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $b0f42935ea826c41$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $b0f42935ea826c41$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $b0f42935ea826c41$var$nextEffect;){
            cache = $b0f42935ea826c41$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $b0f42935ea826c41$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $b0f42935ea826c41$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $b0f42935ea826c41$var$nextEffect = sibling;
                break a;
            }
            $b0f42935ea826c41$var$nextEffect = returnFiber;
        }
    }
}
var $b0f42935ea826c41$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $b0f42935ea826c41$var$readContext($b0f42935ea826c41$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $b0f42935ea826c41$var$readContext($b0f42935ea826c41$var$CacheContext).controller.signal;
    }
}, $b0f42935ea826c41$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $b0f42935ea826c41$var$executionContext = 0, $b0f42935ea826c41$var$workInProgressRoot = null, $b0f42935ea826c41$var$workInProgress = null, $b0f42935ea826c41$var$workInProgressRootRenderLanes = 0, $b0f42935ea826c41$var$workInProgressSuspendedReason = 0, $b0f42935ea826c41$var$workInProgressThrownValue = null, $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings = !1, $b0f42935ea826c41$var$workInProgressRootIsPrerendering = !1, $b0f42935ea826c41$var$workInProgressRootDidAttachPingListener = !1, $b0f42935ea826c41$var$entangledRenderLanes = 0, $b0f42935ea826c41$var$workInProgressRootExitStatus = 0, $b0f42935ea826c41$var$workInProgressRootSkippedLanes = 0, $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes = 0, $b0f42935ea826c41$var$workInProgressRootPingedLanes = 0, $b0f42935ea826c41$var$workInProgressDeferredLane = 0, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes = 0, $b0f42935ea826c41$var$workInProgressRootConcurrentErrors = null, $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = null, $b0f42935ea826c41$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $b0f42935ea826c41$var$globalMostRecentFallbackTime = 0, $b0f42935ea826c41$var$globalMostRecentTransitionTime = 0, $b0f42935ea826c41$var$workInProgressRootRenderTargetTime = Infinity, $b0f42935ea826c41$var$workInProgressTransitions = null, $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed = null, $b0f42935ea826c41$var$pendingEffectsStatus = 0, $b0f42935ea826c41$var$pendingEffectsRoot = null, $b0f42935ea826c41$var$pendingFinishedWork = null, $b0f42935ea826c41$var$pendingEffectsLanes = 0, $b0f42935ea826c41$var$pendingEffectsRemainingLanes = 0, $b0f42935ea826c41$var$pendingPassiveTransitions = null, $b0f42935ea826c41$var$pendingRecoverableErrors = null, $b0f42935ea826c41$var$nestedUpdateCount = 0, $b0f42935ea826c41$var$rootWithNestedUpdates = null;
function $b0f42935ea826c41$var$requestUpdateLane() {
    return 0 !== ($b0f42935ea826c41$var$executionContext & 2) && 0 !== $b0f42935ea826c41$var$workInProgressRootRenderLanes ? $b0f42935ea826c41$var$workInProgressRootRenderLanes & -$b0f42935ea826c41$var$workInProgressRootRenderLanes : null !== $b0f42935ea826c41$var$ReactSharedInternals.T ? $b0f42935ea826c41$var$requestTransitionLane() : $b0f42935ea826c41$var$resolveUpdatePriority();
}
function $b0f42935ea826c41$var$requestDeferredLane() {
    if (0 === $b0f42935ea826c41$var$workInProgressDeferredLane) {
        if (0 === ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 536870912) || $b0f42935ea826c41$var$isHydrating) {
            var lane = $b0f42935ea826c41$var$nextTransitionDeferredLane;
            $b0f42935ea826c41$var$nextTransitionDeferredLane <<= 1;
            0 === ($b0f42935ea826c41$var$nextTransitionDeferredLane & 3932160) && ($b0f42935ea826c41$var$nextTransitionDeferredLane = 262144);
            $b0f42935ea826c41$var$workInProgressDeferredLane = lane;
        } else $b0f42935ea826c41$var$workInProgressDeferredLane = 536870912;
    }
    lane = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $b0f42935ea826c41$var$workInProgressDeferredLane;
}
function $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $b0f42935ea826c41$var$workInProgressRoot && (2 === $b0f42935ea826c41$var$workInProgressSuspendedReason || 9 === $b0f42935ea826c41$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $b0f42935ea826c41$var$prepareFreshStack(root, 0), $b0f42935ea826c41$var$markRootSuspended(root, $b0f42935ea826c41$var$workInProgressRootRenderLanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !1);
    $b0f42935ea826c41$var$markRootUpdated$1(root, lane);
    if (0 === ($b0f42935ea826c41$var$executionContext & 2) || root !== $b0f42935ea826c41$var$workInProgressRoot) root === $b0f42935ea826c41$var$workInProgressRoot && (0 === ($b0f42935ea826c41$var$executionContext & 2) && ($b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $b0f42935ea826c41$var$workInProgressRootExitStatus && $b0f42935ea826c41$var$markRootSuspended(root, $b0f42935ea826c41$var$workInProgressRootRenderLanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !1)), $b0f42935ea826c41$var$ensureRootIsScheduled(root);
}
function $b0f42935ea826c41$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($b0f42935ea826c41$var$executionContext & 6)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $b0f42935ea826c41$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $b0f42935ea826c41$var$renderRootConcurrent(root$jscomp$0, lanes) : $b0f42935ea826c41$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $b0f42935ea826c41$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $b0f42935ea826c41$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$b0f42935ea826c41$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $b0f42935ea826c41$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $b0f42935ea826c41$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($b0f42935ea826c41$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $b0f42935ea826c41$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($b0f42935ea826c41$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $b0f42935ea826c41$var$workInProgressRootRecoverableErrors;
                            $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $b0f42935ea826c41$var$workInProgressRootRecoverableErrors ? $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $b0f42935ea826c41$var$workInProgressRootRecoverableErrors.push.apply($b0f42935ea826c41$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $b0f42935ea826c41$var$prepareFreshStack(root$jscomp$0, 0);
                $b0f42935ea826c41$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $b0f42935ea826c41$var$markRootSuspended(shouldTimeSlice, lanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !$b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $b0f42935ea826c41$var$globalMostRecentFallbackTime + 300 - $b0f42935ea826c41$var$now(), 10 < exitStatus)) {
                    $b0f42935ea826c41$var$markRootSuspended(shouldTimeSlice, lanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !$b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $b0f42935ea826c41$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $b0f42935ea826c41$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $b0f42935ea826c41$var$scheduleTimeout($b0f42935ea826c41$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $b0f42935ea826c41$var$workInProgressRootRecoverableErrors, $b0f42935ea826c41$var$workInProgressTransitions, $b0f42935ea826c41$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b0f42935ea826c41$var$workInProgressDeferredLane, $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes, $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $b0f42935ea826c41$var$commitRootWhenReady(shouldTimeSlice, forceSync, $b0f42935ea826c41$var$workInProgressRootRecoverableErrors, $b0f42935ea826c41$var$workInProgressTransitions, $b0f42935ea826c41$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b0f42935ea826c41$var$workInProgressDeferredLane, $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes, $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $b0f42935ea826c41$var$ensureRootIsScheduled(root$jscomp$0);
}
function $b0f42935ea826c41$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $b0f42935ea826c41$var$noop$1
        };
        $b0f42935ea826c41$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $b0f42935ea826c41$var$globalMostRecentFallbackTime - $b0f42935ea826c41$var$now() : (lanes & 4194048) === lanes ? $b0f42935ea826c41$var$globalMostRecentTransitionTime - $b0f42935ea826c41$var$now() : 0;
        timeoutOffset = $b0f42935ea826c41$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $b0f42935ea826c41$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($b0f42935ea826c41$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $b0f42935ea826c41$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $b0f42935ea826c41$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $b0f42935ea826c41$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$b0f42935ea826c41$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $b0f42935ea826c41$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$b0f42935ea826c41$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $b0f42935ea826c41$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $b0f42935ea826c41$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $b0f42935ea826c41$var$flushSyncWork$1() {
    return 0 === ($b0f42935ea826c41$var$executionContext & 6) ? ($b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $b0f42935ea826c41$var$resetWorkInProgressStack() {
    if (null !== $b0f42935ea826c41$var$workInProgress) {
        if (0 === $b0f42935ea826c41$var$workInProgressSuspendedReason) var interruptedWork = $b0f42935ea826c41$var$workInProgress.return;
        else interruptedWork = $b0f42935ea826c41$var$workInProgress, $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null, $b0f42935ea826c41$var$resetHooksOnUnwind(interruptedWork), $b0f42935ea826c41$var$thenableState$1 = null, $b0f42935ea826c41$var$thenableIndexCounter$1 = 0, interruptedWork = $b0f42935ea826c41$var$workInProgress;
        for(; null !== interruptedWork;)$b0f42935ea826c41$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $b0f42935ea826c41$var$workInProgress = null;
    }
}
function $b0f42935ea826c41$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $b0f42935ea826c41$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $b0f42935ea826c41$var$pendingEffectsLanes = 0;
    $b0f42935ea826c41$var$resetWorkInProgressStack();
    $b0f42935ea826c41$var$workInProgressRoot = root;
    $b0f42935ea826c41$var$workInProgress = timeoutHandle = $b0f42935ea826c41$var$createWorkInProgress(root.current, null);
    $b0f42935ea826c41$var$workInProgressRootRenderLanes = lanes;
    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
    $b0f42935ea826c41$var$workInProgressThrownValue = null;
    $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $b0f42935ea826c41$var$workInProgressRootIsPrerendering = $b0f42935ea826c41$var$checkIfRootIsPrerendering(root, lanes);
    $b0f42935ea826c41$var$workInProgressRootDidAttachPingListener = !1;
    $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes = $b0f42935ea826c41$var$workInProgressDeferredLane = $b0f42935ea826c41$var$workInProgressRootPingedLanes = $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes = $b0f42935ea826c41$var$workInProgressRootSkippedLanes = $b0f42935ea826c41$var$workInProgressRootExitStatus = 0;
    $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = $b0f42935ea826c41$var$workInProgressRootConcurrentErrors = null;
    $b0f42935ea826c41$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $b0f42935ea826c41$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $b0f42935ea826c41$var$entangledRenderLanes = lanes;
    $b0f42935ea826c41$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $b0f42935ea826c41$var$handleThrow(root, thrownValue) {
    $b0f42935ea826c41$var$currentlyRenderingFiber = null;
    $b0f42935ea826c41$var$ReactSharedInternals.H = $b0f42935ea826c41$var$ContextOnlyDispatcher;
    thrownValue === $b0f42935ea826c41$var$SuspenseException || thrownValue === $b0f42935ea826c41$var$SuspenseActionException ? (thrownValue = $b0f42935ea826c41$var$getSuspendedThenable(), $b0f42935ea826c41$var$workInProgressSuspendedReason = 3) : thrownValue === $b0f42935ea826c41$var$SuspenseyCommitException ? (thrownValue = $b0f42935ea826c41$var$getSuspendedThenable(), $b0f42935ea826c41$var$workInProgressSuspendedReason = 4) : $b0f42935ea826c41$var$workInProgressSuspendedReason = thrownValue === $b0f42935ea826c41$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $b0f42935ea826c41$var$workInProgressThrownValue = thrownValue;
    null === $b0f42935ea826c41$var$workInProgress && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 1, $b0f42935ea826c41$var$logUncaughtError(root, $b0f42935ea826c41$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $b0f42935ea826c41$var$shouldRemainOnPreviousScreen() {
    var handler = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 4194048) === $b0f42935ea826c41$var$workInProgressRootRenderLanes ? null === $b0f42935ea826c41$var$shellBoundary ? !0 : !1 : ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 62914560) === $b0f42935ea826c41$var$workInProgressRootRenderLanes || 0 !== ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 536870912) ? handler === $b0f42935ea826c41$var$shellBoundary : !1;
}
function $b0f42935ea826c41$var$pushDispatcher() {
    var prevDispatcher = $b0f42935ea826c41$var$ReactSharedInternals.H;
    $b0f42935ea826c41$var$ReactSharedInternals.H = $b0f42935ea826c41$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $b0f42935ea826c41$var$ContextOnlyDispatcher : prevDispatcher;
}
function $b0f42935ea826c41$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $b0f42935ea826c41$var$ReactSharedInternals.A;
    $b0f42935ea826c41$var$ReactSharedInternals.A = $b0f42935ea826c41$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible() {
    $b0f42935ea826c41$var$workInProgressRootExitStatus = 4;
    $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings || ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 4194048) !== $b0f42935ea826c41$var$workInProgressRootRenderLanes && null !== $b0f42935ea826c41$var$suspenseHandlerStackCursor.current || ($b0f42935ea826c41$var$workInProgressRootIsPrerendering = !0);
    0 === ($b0f42935ea826c41$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $b0f42935ea826c41$var$workInProgressRoot || $b0f42935ea826c41$var$markRootSuspended($b0f42935ea826c41$var$workInProgressRoot, $b0f42935ea826c41$var$workInProgressRootRenderLanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !1);
}
function $b0f42935ea826c41$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
    $b0f42935ea826c41$var$executionContext |= 2;
    var prevDispatcher = $b0f42935ea826c41$var$pushDispatcher(), prevAsyncDispatcher = $b0f42935ea826c41$var$pushAsyncDispatcher();
    if ($b0f42935ea826c41$var$workInProgressRoot !== root || $b0f42935ea826c41$var$workInProgressRootRenderLanes !== lanes) $b0f42935ea826c41$var$workInProgressTransitions = null, $b0f42935ea826c41$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $b0f42935ea826c41$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $b0f42935ea826c41$var$workInProgressSuspendedReason && null !== $b0f42935ea826c41$var$workInProgress) {
            var unitOfWork = $b0f42935ea826c41$var$workInProgress, thrownValue = $b0f42935ea826c41$var$workInProgressThrownValue;
            switch($b0f42935ea826c41$var$workInProgressSuspendedReason){
                case 8:
                    $b0f42935ea826c41$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $b0f42935ea826c41$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $b0f42935ea826c41$var$workInProgressSuspendedReason;
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                    $b0f42935ea826c41$var$workInProgressThrownValue = null;
                    $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $b0f42935ea826c41$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $b0f42935ea826c41$var$workInProgressSuspendedReason, $b0f42935ea826c41$var$workInProgressSuspendedReason = 0, $b0f42935ea826c41$var$workInProgressThrownValue = null, $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $b0f42935ea826c41$var$workLoopSync();
        exitStatus = $b0f42935ea826c41$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $b0f42935ea826c41$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null;
    $b0f42935ea826c41$var$executionContext = prevExecutionContext;
    $b0f42935ea826c41$var$ReactSharedInternals.H = prevDispatcher;
    $b0f42935ea826c41$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $b0f42935ea826c41$var$workInProgress && ($b0f42935ea826c41$var$workInProgressRoot = null, $b0f42935ea826c41$var$workInProgressRootRenderLanes = 0, $b0f42935ea826c41$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $b0f42935ea826c41$var$workLoopSync() {
    for(; null !== $b0f42935ea826c41$var$workInProgress;)$b0f42935ea826c41$var$performUnitOfWork($b0f42935ea826c41$var$workInProgress);
}
function $b0f42935ea826c41$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
    $b0f42935ea826c41$var$executionContext |= 2;
    var prevDispatcher = $b0f42935ea826c41$var$pushDispatcher(), prevAsyncDispatcher = $b0f42935ea826c41$var$pushAsyncDispatcher();
    $b0f42935ea826c41$var$workInProgressRoot !== root || $b0f42935ea826c41$var$workInProgressRootRenderLanes !== lanes ? ($b0f42935ea826c41$var$workInProgressTransitions = null, $b0f42935ea826c41$var$workInProgressRootRenderTargetTime = $b0f42935ea826c41$var$now() + 500, $b0f42935ea826c41$var$prepareFreshStack(root, lanes)) : $b0f42935ea826c41$var$workInProgressRootIsPrerendering = $b0f42935ea826c41$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $b0f42935ea826c41$var$workInProgressSuspendedReason && null !== $b0f42935ea826c41$var$workInProgress) {
            lanes = $b0f42935ea826c41$var$workInProgress;
            var thrownValue = $b0f42935ea826c41$var$workInProgressThrownValue;
            b: switch($b0f42935ea826c41$var$workInProgressSuspendedReason){
                case 1:
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                    $b0f42935ea826c41$var$workInProgressThrownValue = null;
                    $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($b0f42935ea826c41$var$isThenableResolved(thrownValue)) {
                        $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                        $b0f42935ea826c41$var$workInProgressThrownValue = null;
                        $b0f42935ea826c41$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $b0f42935ea826c41$var$workInProgressSuspendedReason && 9 !== $b0f42935ea826c41$var$workInProgressSuspendedReason || $b0f42935ea826c41$var$workInProgressRoot !== root || ($b0f42935ea826c41$var$workInProgressSuspendedReason = 7);
                        $b0f42935ea826c41$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $b0f42935ea826c41$var$isThenableResolved(thrownValue) ? ($b0f42935ea826c41$var$workInProgressSuspendedReason = 0, $b0f42935ea826c41$var$workInProgressThrownValue = null, $b0f42935ea826c41$var$replaySuspendedUnitOfWork(lanes)) : ($b0f42935ea826c41$var$workInProgressSuspendedReason = 0, $b0f42935ea826c41$var$workInProgressThrownValue = null, $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($b0f42935ea826c41$var$workInProgress.tag){
                        case 26:
                            resource = $b0f42935ea826c41$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $b0f42935ea826c41$var$workInProgress;
                            if (resource ? $b0f42935ea826c41$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                                $b0f42935ea826c41$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $b0f42935ea826c41$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($b0f42935ea826c41$var$workInProgress = returnFiber, $b0f42935ea826c41$var$completeUnitOfWork(returnFiber)) : $b0f42935ea826c41$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                    $b0f42935ea826c41$var$workInProgressThrownValue = null;
                    $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                    $b0f42935ea826c41$var$workInProgressThrownValue = null;
                    $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $b0f42935ea826c41$var$resetWorkInProgressStack();
                    $b0f42935ea826c41$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(462));
            }
        }
        $b0f42935ea826c41$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $b0f42935ea826c41$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null;
    $b0f42935ea826c41$var$ReactSharedInternals.H = prevDispatcher;
    $b0f42935ea826c41$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $b0f42935ea826c41$var$executionContext = prevExecutionContext;
    if (null !== $b0f42935ea826c41$var$workInProgress) return 0;
    $b0f42935ea826c41$var$workInProgressRoot = null;
    $b0f42935ea826c41$var$workInProgressRootRenderLanes = 0;
    $b0f42935ea826c41$var$finishQueueingConcurrentUpdates();
    return $b0f42935ea826c41$var$workInProgressRootExitStatus;
}
function $b0f42935ea826c41$var$workLoopConcurrentByScheduler() {
    for(; null !== $b0f42935ea826c41$var$workInProgress && !$b0f42935ea826c41$var$shouldYield();)$b0f42935ea826c41$var$performUnitOfWork($b0f42935ea826c41$var$workInProgress);
}
function $b0f42935ea826c41$var$performUnitOfWork(unitOfWork) {
    var next = $b0f42935ea826c41$var$beginWork(unitOfWork.alternate, unitOfWork, $b0f42935ea826c41$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b0f42935ea826c41$var$completeUnitOfWork(unitOfWork) : $b0f42935ea826c41$var$workInProgress = next;
}
function $b0f42935ea826c41$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $b0f42935ea826c41$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $b0f42935ea826c41$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $b0f42935ea826c41$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $b0f42935ea826c41$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $b0f42935ea826c41$var$resetHooksOnUnwind(next);
        default:
            $b0f42935ea826c41$var$unwindInterruptedWork(current, next), next = $b0f42935ea826c41$var$workInProgress = $b0f42935ea826c41$var$resetWorkInProgress(next, $b0f42935ea826c41$var$entangledRenderLanes), next = $b0f42935ea826c41$var$beginWork(current, next, $b0f42935ea826c41$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b0f42935ea826c41$var$completeUnitOfWork(unitOfWork) : $b0f42935ea826c41$var$workInProgress = next;
}
function $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null;
    $b0f42935ea826c41$var$resetHooksOnUnwind(unitOfWork);
    $b0f42935ea826c41$var$thenableState$1 = null;
    $b0f42935ea826c41$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($b0f42935ea826c41$var$throwException(root, returnFiber, unitOfWork, thrownValue, $b0f42935ea826c41$var$workInProgressRootRenderLanes)) {
            $b0f42935ea826c41$var$workInProgressRootExitStatus = 1;
            $b0f42935ea826c41$var$logUncaughtError(root, $b0f42935ea826c41$var$createCapturedValueAtFiber(thrownValue, root.current));
            $b0f42935ea826c41$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $b0f42935ea826c41$var$workInProgress = returnFiber, error;
        $b0f42935ea826c41$var$workInProgressRootExitStatus = 1;
        $b0f42935ea826c41$var$logUncaughtError(root, $b0f42935ea826c41$var$createCapturedValueAtFiber(thrownValue, root.current));
        $b0f42935ea826c41$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($b0f42935ea826c41$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($b0f42935ea826c41$var$workInProgressRootIsPrerendering || 0 !== ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $b0f42935ea826c41$var$unwindUnitOfWork(unitOfWork, root);
    } else $b0f42935ea826c41$var$completeUnitOfWork(unitOfWork);
}
function $b0f42935ea826c41$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $b0f42935ea826c41$var$unwindUnitOfWork(completedWork, $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $b0f42935ea826c41$var$completeWork(completedWork.alternate, completedWork, $b0f42935ea826c41$var$entangledRenderLanes);
        if (null !== next) {
            $b0f42935ea826c41$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $b0f42935ea826c41$var$workInProgress = completedWork;
            return;
        }
        $b0f42935ea826c41$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 5);
}
function $b0f42935ea826c41$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $b0f42935ea826c41$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $b0f42935ea826c41$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $b0f42935ea826c41$var$workInProgress = unitOfWork;
            return;
        }
        $b0f42935ea826c41$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $b0f42935ea826c41$var$workInProgressRootExitStatus = 6;
    $b0f42935ea826c41$var$workInProgress = null;
}
function $b0f42935ea826c41$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $b0f42935ea826c41$var$flushPendingEffects();
    while (0 !== $b0f42935ea826c41$var$pendingEffectsStatus);
    if (0 !== ($b0f42935ea826c41$var$executionContext & 6)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $b0f42935ea826c41$var$concurrentlyUpdatedLanes;
        $b0f42935ea826c41$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $b0f42935ea826c41$var$workInProgressRoot && ($b0f42935ea826c41$var$workInProgress = $b0f42935ea826c41$var$workInProgressRoot = null, $b0f42935ea826c41$var$workInProgressRootRenderLanes = 0);
        $b0f42935ea826c41$var$pendingFinishedWork = finishedWork;
        $b0f42935ea826c41$var$pendingEffectsRoot = root;
        $b0f42935ea826c41$var$pendingEffectsLanes = lanes;
        $b0f42935ea826c41$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $b0f42935ea826c41$var$pendingPassiveTransitions = transitions;
        $b0f42935ea826c41$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $b0f42935ea826c41$var$scheduleCallback$1($b0f42935ea826c41$var$NormalPriority$1, function() {
            $b0f42935ea826c41$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $b0f42935ea826c41$var$ReactSharedInternals.T;
            $b0f42935ea826c41$var$ReactSharedInternals.T = null;
            transitions = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
            $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $b0f42935ea826c41$var$executionContext;
            $b0f42935ea826c41$var$executionContext |= 4;
            try {
                $b0f42935ea826c41$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $b0f42935ea826c41$var$executionContext = spawnedLane, $b0f42935ea826c41$var$ReactDOMSharedInternals.p = transitions, $b0f42935ea826c41$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $b0f42935ea826c41$var$pendingEffectsStatus = 1;
        $b0f42935ea826c41$var$flushMutationEffects();
        $b0f42935ea826c41$var$flushLayoutEffects();
        $b0f42935ea826c41$var$flushSpawnedWork();
    }
}
function $b0f42935ea826c41$var$flushMutationEffects() {
    if (1 === $b0f42935ea826c41$var$pendingEffectsStatus) {
        $b0f42935ea826c41$var$pendingEffectsStatus = 0;
        var root = $b0f42935ea826c41$var$pendingEffectsRoot, finishedWork = $b0f42935ea826c41$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $b0f42935ea826c41$var$ReactSharedInternals.T;
            $b0f42935ea826c41$var$ReactSharedInternals.T = null;
            var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
            $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
            $b0f42935ea826c41$var$executionContext |= 4;
            try {
                $b0f42935ea826c41$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $b0f42935ea826c41$var$selectionInformation, curFocusedElem = $b0f42935ea826c41$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $b0f42935ea826c41$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $b0f42935ea826c41$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $b0f42935ea826c41$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $b0f42935ea826c41$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $b0f42935ea826c41$var$_enabled = !!$b0f42935ea826c41$var$eventsEnabled;
                $b0f42935ea826c41$var$selectionInformation = $b0f42935ea826c41$var$eventsEnabled = null;
            } finally{
                $b0f42935ea826c41$var$executionContext = prevExecutionContext, $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $b0f42935ea826c41$var$pendingEffectsStatus = 2;
    }
}
function $b0f42935ea826c41$var$flushLayoutEffects() {
    if (2 === $b0f42935ea826c41$var$pendingEffectsStatus) {
        $b0f42935ea826c41$var$pendingEffectsStatus = 0;
        var root = $b0f42935ea826c41$var$pendingEffectsRoot, finishedWork = $b0f42935ea826c41$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $b0f42935ea826c41$var$ReactSharedInternals.T;
            $b0f42935ea826c41$var$ReactSharedInternals.T = null;
            var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
            $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
            $b0f42935ea826c41$var$executionContext |= 4;
            try {
                $b0f42935ea826c41$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $b0f42935ea826c41$var$executionContext = prevExecutionContext, $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $b0f42935ea826c41$var$pendingEffectsStatus = 3;
    }
}
function $b0f42935ea826c41$var$flushSpawnedWork() {
    if (4 === $b0f42935ea826c41$var$pendingEffectsStatus || 3 === $b0f42935ea826c41$var$pendingEffectsStatus) {
        $b0f42935ea826c41$var$pendingEffectsStatus = 0;
        $b0f42935ea826c41$var$requestPaint();
        var root = $b0f42935ea826c41$var$pendingEffectsRoot, finishedWork = $b0f42935ea826c41$var$pendingFinishedWork, lanes = $b0f42935ea826c41$var$pendingEffectsLanes, recoverableErrors = $b0f42935ea826c41$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $b0f42935ea826c41$var$pendingEffectsStatus = 5 : ($b0f42935ea826c41$var$pendingEffectsStatus = 0, $b0f42935ea826c41$var$pendingFinishedWork = $b0f42935ea826c41$var$pendingEffectsRoot = null, $b0f42935ea826c41$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $b0f42935ea826c41$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($b0f42935ea826c41$var$injectedHook && "function" === typeof $b0f42935ea826c41$var$injectedHook.onCommitFiberRoot) try {
            $b0f42935ea826c41$var$injectedHook.onCommitFiberRoot($b0f42935ea826c41$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $b0f42935ea826c41$var$ReactSharedInternals.T;
            remainingLanes = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
            $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2;
            $b0f42935ea826c41$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $b0f42935ea826c41$var$ReactSharedInternals.T = finishedWork, $b0f42935ea826c41$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($b0f42935ea826c41$var$pendingEffectsLanes & 3) && $b0f42935ea826c41$var$flushPendingEffects();
        $b0f42935ea826c41$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $b0f42935ea826c41$var$rootWithNestedUpdates ? $b0f42935ea826c41$var$nestedUpdateCount++ : ($b0f42935ea826c41$var$nestedUpdateCount = 0, $b0f42935ea826c41$var$rootWithNestedUpdates = root) : $b0f42935ea826c41$var$nestedUpdateCount = 0;
        $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $b0f42935ea826c41$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $b0f42935ea826c41$var$releaseCache(remainingLanes)));
}
function $b0f42935ea826c41$var$flushPendingEffects() {
    $b0f42935ea826c41$var$flushMutationEffects();
    $b0f42935ea826c41$var$flushLayoutEffects();
    $b0f42935ea826c41$var$flushSpawnedWork();
    return $b0f42935ea826c41$var$flushPassiveEffects();
}
function $b0f42935ea826c41$var$flushPassiveEffects() {
    if (5 !== $b0f42935ea826c41$var$pendingEffectsStatus) return !1;
    var root = $b0f42935ea826c41$var$pendingEffectsRoot, remainingLanes = $b0f42935ea826c41$var$pendingEffectsRemainingLanes;
    $b0f42935ea826c41$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $b0f42935ea826c41$var$lanesToEventPriority($b0f42935ea826c41$var$pendingEffectsLanes), prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T, previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    try {
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $b0f42935ea826c41$var$ReactSharedInternals.T = null;
        renderPriority = $b0f42935ea826c41$var$pendingPassiveTransitions;
        $b0f42935ea826c41$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $b0f42935ea826c41$var$pendingEffectsRoot, lanes = $b0f42935ea826c41$var$pendingEffectsLanes;
        $b0f42935ea826c41$var$pendingEffectsStatus = 0;
        $b0f42935ea826c41$var$pendingFinishedWork = $b0f42935ea826c41$var$pendingEffectsRoot = null;
        $b0f42935ea826c41$var$pendingEffectsLanes = 0;
        if (0 !== ($b0f42935ea826c41$var$executionContext & 6)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(331));
        var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
        $b0f42935ea826c41$var$executionContext |= 4;
        $b0f42935ea826c41$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $b0f42935ea826c41$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $b0f42935ea826c41$var$executionContext = prevExecutionContext;
        $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($b0f42935ea826c41$var$injectedHook && "function" === typeof $b0f42935ea826c41$var$injectedHook.onPostCommitFiberRoot) try {
            $b0f42935ea826c41$var$injectedHook.onPostCommitFiberRoot($b0f42935ea826c41$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition, $b0f42935ea826c41$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $b0f42935ea826c41$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $b0f42935ea826c41$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $b0f42935ea826c41$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $b0f42935ea826c41$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($b0f42935ea826c41$var$markRootUpdated$1(rootFiber, 2), $b0f42935ea826c41$var$ensureRootIsScheduled(rootFiber));
}
function $b0f42935ea826c41$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $b0f42935ea826c41$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $b0f42935ea826c41$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed || !$b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $b0f42935ea826c41$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $b0f42935ea826c41$var$createClassErrorUpdate(2);
                instance = $b0f42935ea826c41$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($b0f42935ea826c41$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $b0f42935ea826c41$var$markRootUpdated$1(instance, 2), $b0f42935ea826c41$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $b0f42935ea826c41$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $b0f42935ea826c41$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($b0f42935ea826c41$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $b0f42935ea826c41$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $b0f42935ea826c41$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $b0f42935ea826c41$var$workInProgressRoot === root && ($b0f42935ea826c41$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $b0f42935ea826c41$var$workInProgressRootExitStatus || 3 === $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 62914560) === $b0f42935ea826c41$var$workInProgressRootRenderLanes && 300 > $b0f42935ea826c41$var$now() - $b0f42935ea826c41$var$globalMostRecentFallbackTime ? 0 === ($b0f42935ea826c41$var$executionContext & 2) && $b0f42935ea826c41$var$prepareFreshStack(root, 0) : $b0f42935ea826c41$var$workInProgressRootPingedLanes |= pingedLanes, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes === $b0f42935ea826c41$var$workInProgressRootRenderLanes && ($b0f42935ea826c41$var$workInProgressSuspendedRetryLanes = 0));
    $b0f42935ea826c41$var$ensureRootIsScheduled(root);
}
function $b0f42935ea826c41$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $b0f42935ea826c41$var$claimNextRetryLane());
    boundaryFiber = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($b0f42935ea826c41$var$markRootUpdated$1(boundaryFiber, retryLane), $b0f42935ea826c41$var$ensureRootIsScheduled(boundaryFiber));
}
function $b0f42935ea826c41$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $b0f42935ea826c41$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b0f42935ea826c41$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $b0f42935ea826c41$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b0f42935ea826c41$var$scheduleCallback$1(priorityLevel, callback) {
    return $b0f42935ea826c41$var$scheduleCallback$3(priorityLevel, callback);
}
var $b0f42935ea826c41$var$firstScheduledRoot = null, $b0f42935ea826c41$var$lastScheduledRoot = null, $b0f42935ea826c41$var$didScheduleMicrotask = !1, $b0f42935ea826c41$var$mightHavePendingSyncWork = !1, $b0f42935ea826c41$var$isFlushingWork = !1, $b0f42935ea826c41$var$currentEventTransitionLane = 0;
function $b0f42935ea826c41$var$ensureRootIsScheduled(root) {
    root !== $b0f42935ea826c41$var$lastScheduledRoot && null === root.next && (null === $b0f42935ea826c41$var$lastScheduledRoot ? $b0f42935ea826c41$var$firstScheduledRoot = $b0f42935ea826c41$var$lastScheduledRoot = root : $b0f42935ea826c41$var$lastScheduledRoot = $b0f42935ea826c41$var$lastScheduledRoot.next = root);
    $b0f42935ea826c41$var$mightHavePendingSyncWork = !0;
    $b0f42935ea826c41$var$didScheduleMicrotask || ($b0f42935ea826c41$var$didScheduleMicrotask = !0, $b0f42935ea826c41$var$scheduleImmediateRootScheduleTask());
}
function $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$b0f42935ea826c41$var$isFlushingWork && $b0f42935ea826c41$var$mightHavePendingSyncWork) {
        $b0f42935ea826c41$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $b0f42935ea826c41$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $b0f42935ea826c41$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $b0f42935ea826c41$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $b0f42935ea826c41$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $b0f42935ea826c41$var$getNextLanes(root$170, root$170 === $b0f42935ea826c41$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $b0f42935ea826c41$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $b0f42935ea826c41$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $b0f42935ea826c41$var$isFlushingWork = !1;
    }
}
function $b0f42935ea826c41$var$processRootScheduleInImmediateTask() {
    $b0f42935ea826c41$var$processRootScheduleInMicrotask();
}
function $b0f42935ea826c41$var$processRootScheduleInMicrotask() {
    $b0f42935ea826c41$var$mightHavePendingSyncWork = $b0f42935ea826c41$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $b0f42935ea826c41$var$currentEventTransitionLane && $b0f42935ea826c41$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $b0f42935ea826c41$var$currentEventTransitionLane);
    for(var currentTime = $b0f42935ea826c41$var$now(), prev = null, root = $b0f42935ea826c41$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $b0f42935ea826c41$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $b0f42935ea826c41$var$firstScheduledRoot = next : prev.next = next, null === next && ($b0f42935ea826c41$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $b0f42935ea826c41$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $b0f42935ea826c41$var$pendingEffectsStatus && 5 !== $b0f42935ea826c41$var$pendingEffectsStatus || $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $b0f42935ea826c41$var$currentEventTransitionLane && ($b0f42935ea826c41$var$currentEventTransitionLane = 0);
}
function $b0f42935ea826c41$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $b0f42935ea826c41$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $b0f42935ea826c41$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $b0f42935ea826c41$var$workInProgressRoot;
    suspendedLanes = $b0f42935ea826c41$var$workInProgressRootRenderLanes;
    suspendedLanes = $b0f42935ea826c41$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $b0f42935ea826c41$var$workInProgressSuspendedReason || 9 === $b0f42935ea826c41$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $b0f42935ea826c41$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $b0f42935ea826c41$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $b0f42935ea826c41$var$cancelCallback$1(pingedLanes);
        switch($b0f42935ea826c41$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $b0f42935ea826c41$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $b0f42935ea826c41$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $b0f42935ea826c41$var$IdlePriority;
                break;
            default:
                suspendedLanes = $b0f42935ea826c41$var$NormalPriority$1;
        }
        pingedLanes = $b0f42935ea826c41$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $b0f42935ea826c41$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $b0f42935ea826c41$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $b0f42935ea826c41$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $b0f42935ea826c41$var$pendingEffectsStatus && 5 !== $b0f42935ea826c41$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($b0f42935ea826c41$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $b0f42935ea826c41$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $b0f42935ea826c41$var$getNextLanes(root, root === $b0f42935ea826c41$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $b0f42935ea826c41$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $b0f42935ea826c41$var$scheduleTaskForRootDuringMicrotask(root, $b0f42935ea826c41$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $b0f42935ea826c41$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $b0f42935ea826c41$var$performSyncWorkOnRoot(root, lanes) {
    if ($b0f42935ea826c41$var$flushPendingEffects()) return null;
    $b0f42935ea826c41$var$performWorkOnRoot(root, lanes, !0);
}
function $b0f42935ea826c41$var$scheduleImmediateRootScheduleTask() {
    $b0f42935ea826c41$var$scheduleMicrotask(function() {
        0 !== ($b0f42935ea826c41$var$executionContext & 6) ? $b0f42935ea826c41$var$scheduleCallback$3($b0f42935ea826c41$var$ImmediatePriority, $b0f42935ea826c41$var$processRootScheduleInImmediateTask) : $b0f42935ea826c41$var$processRootScheduleInMicrotask();
    });
}
function $b0f42935ea826c41$var$requestTransitionLane() {
    if (0 === $b0f42935ea826c41$var$currentEventTransitionLane) {
        var actionScopeLane = $b0f42935ea826c41$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $b0f42935ea826c41$var$nextTransitionUpdateLane, $b0f42935ea826c41$var$nextTransitionUpdateLane <<= 1, 0 === ($b0f42935ea826c41$var$nextTransitionUpdateLane & 261888) && ($b0f42935ea826c41$var$nextTransitionUpdateLane = 256));
        $b0f42935ea826c41$var$currentEventTransitionLane = actionScopeLane;
    }
    return $b0f42935ea826c41$var$currentEventTransitionLane;
}
function $b0f42935ea826c41$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $b0f42935ea826c41$var$sanitizeURL("" + actionProp);
}
function $b0f42935ea826c41$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $b0f42935ea826c41$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $b0f42935ea826c41$var$coerceFormActionProp((nativeEventTarget[$b0f42935ea826c41$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$b0f42935ea826c41$var$internalPropsKey] || null) ? $b0f42935ea826c41$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $b0f42935ea826c41$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $b0f42935ea826c41$var$currentEventTransitionLane) {
                                var formData = submitter ? $b0f42935ea826c41$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $b0f42935ea826c41$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $b0f42935ea826c41$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $b0f42935ea826c41$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $b0f42935ea826c41$var$i$jscomp$inline_1577 = 0; $b0f42935ea826c41$var$i$jscomp$inline_1577 < $b0f42935ea826c41$var$simpleEventPluginEvents.length; $b0f42935ea826c41$var$i$jscomp$inline_1577++){
    var $b0f42935ea826c41$var$eventName$jscomp$inline_1578 = $b0f42935ea826c41$var$simpleEventPluginEvents[$b0f42935ea826c41$var$i$jscomp$inline_1577], $b0f42935ea826c41$var$domEventName$jscomp$inline_1579 = $b0f42935ea826c41$var$eventName$jscomp$inline_1578.toLowerCase(), $b0f42935ea826c41$var$capitalizedEvent$jscomp$inline_1580 = $b0f42935ea826c41$var$eventName$jscomp$inline_1578[0].toUpperCase() + $b0f42935ea826c41$var$eventName$jscomp$inline_1578.slice(1);
    $b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$domEventName$jscomp$inline_1579, "on" + $b0f42935ea826c41$var$capitalizedEvent$jscomp$inline_1580);
}
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$ANIMATION_END, "onAnimationEnd");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$ANIMATION_ITERATION, "onAnimationIteration");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$ANIMATION_START, "onAnimationStart");
$b0f42935ea826c41$var$registerSimpleEvent("dblclick", "onDoubleClick");
$b0f42935ea826c41$var$registerSimpleEvent("focusin", "onFocus");
$b0f42935ea826c41$var$registerSimpleEvent("focusout", "onBlur");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$TRANSITION_RUN, "onTransitionRun");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$TRANSITION_START, "onTransitionStart");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$TRANSITION_CANCEL, "onTransitionCancel");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$TRANSITION_END, "onTransitionEnd");
$b0f42935ea826c41$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b0f42935ea826c41$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b0f42935ea826c41$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b0f42935ea826c41$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b0f42935ea826c41$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b0f42935ea826c41$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b0f42935ea826c41$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b0f42935ea826c41$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b0f42935ea826c41$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b0f42935ea826c41$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b0f42935ea826c41$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b0f42935ea826c41$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($b0f42935ea826c41$var$mediaEventTypes));
function $b0f42935ea826c41$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b0f42935ea826c41$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b0f42935ea826c41$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $b0f42935ea826c41$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$b0f42935ea826c41$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$b0f42935ea826c41$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($b0f42935ea826c41$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $b0f42935ea826c41$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $b0f42935ea826c41$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $b0f42935ea826c41$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $b0f42935ea826c41$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$b0f42935ea826c41$var$listeningMarker]) {
        rootContainerElement[$b0f42935ea826c41$var$listeningMarker] = !0;
        $b0f42935ea826c41$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($b0f42935ea826c41$var$nonDelegatedEvents.has(domEventName) || $b0f42935ea826c41$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $b0f42935ea826c41$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$b0f42935ea826c41$var$listeningMarker] || (ownerDocument[$b0f42935ea826c41$var$listeningMarker] = !0, $b0f42935ea826c41$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $b0f42935ea826c41$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($b0f42935ea826c41$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $b0f42935ea826c41$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $b0f42935ea826c41$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $b0f42935ea826c41$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$b0f42935ea826c41$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $b0f42935ea826c41$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $b0f42935ea826c41$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $b0f42935ea826c41$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $b0f42935ea826c41$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $b0f42935ea826c41$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $b0f42935ea826c41$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticTouchEvent;
                        break;
                    case $b0f42935ea826c41$var$ANIMATION_END:
                    case $b0f42935ea826c41$var$ANIMATION_ITERATION:
                    case $b0f42935ea826c41$var$ANIMATION_START:
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticAnimationEvent;
                        break;
                    case $b0f42935ea826c41$var$TRANSITION_END:
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $b0f42935ea826c41$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($b0f42935ea826c41$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $b0f42935ea826c41$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($b0f42935ea826c41$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$b0f42935ea826c41$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $b0f42935ea826c41$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $b0f42935ea826c41$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $b0f42935ea826c41$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $b0f42935ea826c41$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $b0f42935ea826c41$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $b0f42935ea826c41$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $b0f42935ea826c41$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $b0f42935ea826c41$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $b0f42935ea826c41$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $b0f42935ea826c41$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $b0f42935ea826c41$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForChangeEvent;
                else if ($b0f42935ea826c41$var$isTextInputElement(reactName)) {
                    if ($b0f42935ea826c41$var$isInputEventSupported) getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $b0f42935ea826c41$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $b0f42935ea826c41$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForChangeEvent) : getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $b0f42935ea826c41$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $b0f42935ea826c41$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $b0f42935ea826c41$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($b0f42935ea826c41$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $b0f42935ea826c41$var$activeElement = handleEventFunc, $b0f42935ea826c41$var$activeElementInst = targetInst, $b0f42935ea826c41$var$lastSelection = null;
                    break;
                case "focusout":
                    $b0f42935ea826c41$var$lastSelection = $b0f42935ea826c41$var$activeElementInst = $b0f42935ea826c41$var$activeElement = null;
                    break;
                case "mousedown":
                    $b0f42935ea826c41$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b0f42935ea826c41$var$mouseDown = !1;
                    $b0f42935ea826c41$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($b0f42935ea826c41$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $b0f42935ea826c41$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($b0f42935ea826c41$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $b0f42935ea826c41$var$isComposing ? $b0f42935ea826c41$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($b0f42935ea826c41$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($b0f42935ea826c41$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $b0f42935ea826c41$var$isComposing && (fallbackData = $b0f42935ea826c41$var$getData()) : ($b0f42935ea826c41$var$root = nativeEventTarget, $b0f42935ea826c41$var$startText = "value" in $b0f42935ea826c41$var$root ? $b0f42935ea826c41$var$root.value : $b0f42935ea826c41$var$root.textContent, $b0f42935ea826c41$var$isComposing = !0)), handleEventFunc = $b0f42935ea826c41$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $b0f42935ea826c41$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $b0f42935ea826c41$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $b0f42935ea826c41$var$canUseTextInputEvent ? $b0f42935ea826c41$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $b0f42935ea826c41$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $b0f42935ea826c41$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $b0f42935ea826c41$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $b0f42935ea826c41$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $b0f42935ea826c41$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $b0f42935ea826c41$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $b0f42935ea826c41$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $b0f42935ea826c41$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($b0f42935ea826c41$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $b0f42935ea826c41$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($b0f42935ea826c41$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $b0f42935ea826c41$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $b0f42935ea826c41$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $b0f42935ea826c41$var$getListener(target, registrationName), null != stateNode && listeners.unshift($b0f42935ea826c41$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $b0f42935ea826c41$var$getListener(target, registrationName), null != stateNode && listeners.push($b0f42935ea826c41$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $b0f42935ea826c41$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $b0f42935ea826c41$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $b0f42935ea826c41$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($b0f42935ea826c41$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($b0f42935ea826c41$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $b0f42935ea826c41$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $b0f42935ea826c41$var$normalizeMarkupForTextOrAttribute(clientText);
    return $b0f42935ea826c41$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $b0f42935ea826c41$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $b0f42935ea826c41$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $b0f42935ea826c41$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $b0f42935ea826c41$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $b0f42935ea826c41$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $b0f42935ea826c41$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $b0f42935ea826c41$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $b0f42935ea826c41$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b0f42935ea826c41$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $b0f42935ea826c41$var$setProp(domElement, tag, "name", props.name, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($b0f42935ea826c41$var$setProp(domElement, tag, "encType", props.encType, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "method", props.method, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b0f42935ea826c41$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b0f42935ea826c41$var$noop$1);
            break;
        case "onScroll":
            null != value && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $b0f42935ea826c41$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", domElement);
            $b0f42935ea826c41$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $b0f42935ea826c41$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $b0f42935ea826c41$var$aliases.get(key) || key, $b0f42935ea826c41$var$setValueForAttribute(domElement, key, value);
    }
}
function $b0f42935ea826c41$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $b0f42935ea826c41$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $b0f42935ea826c41$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $b0f42935ea826c41$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b0f42935ea826c41$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$b0f42935ea826c41$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$b0f42935ea826c41$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $b0f42935ea826c41$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $b0f42935ea826c41$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                    default:
                        $b0f42935ea826c41$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $b0f42935ea826c41$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $b0f42935ea826c41$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $b0f42935ea826c41$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $b0f42935ea826c41$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $b0f42935ea826c41$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $b0f42935ea826c41$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(91));
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $b0f42935ea826c41$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("cancel", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $b0f42935ea826c41$var$mediaEventTypes.length; hasSrc++)$b0f42935ea826c41$var$listenToNonDelegatedEvent($b0f42935ea826c41$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", domElement), $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($b0f42935ea826c41$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $b0f42935ea826c41$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $b0f42935ea826c41$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $b0f42935ea826c41$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $b0f42935ea826c41$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $b0f42935ea826c41$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $b0f42935ea826c41$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $b0f42935ea826c41$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $b0f42935ea826c41$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $b0f42935ea826c41$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $b0f42935ea826c41$var$updateOptions(domElement, !!lastProps, tag, !0) : $b0f42935ea826c41$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $b0f42935ea826c41$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $b0f42935ea826c41$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $b0f42935ea826c41$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($b0f42935ea826c41$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $b0f42935ea826c41$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $b0f42935ea826c41$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $b0f42935ea826c41$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $b0f42935ea826c41$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $b0f42935ea826c41$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $b0f42935ea826c41$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $b0f42935ea826c41$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $b0f42935ea826c41$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $b0f42935ea826c41$var$eventsEnabled = null, $b0f42935ea826c41$var$selectionInformation = null;
function $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $b0f42935ea826c41$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $b0f42935ea826c41$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $b0f42935ea826c41$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $b0f42935ea826c41$var$currentPopstateTransitionEvent = null;
function $b0f42935ea826c41$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $b0f42935ea826c41$var$currentPopstateTransitionEvent) return !1;
        $b0f42935ea826c41$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $b0f42935ea826c41$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $b0f42935ea826c41$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $b0f42935ea826c41$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $b0f42935ea826c41$var$localPromise = "function" === typeof Promise ? Promise : void 0, $b0f42935ea826c41$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b0f42935ea826c41$var$localPromise ? function(callback) {
    return $b0f42935ea826c41$var$localPromise.resolve(null).then(callback).catch($b0f42935ea826c41$var$handleErrorInNextTick);
} : $b0f42935ea826c41$var$scheduleTimeout;
function $b0f42935ea826c41$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $b0f42935ea826c41$var$isSingletonScope(type) {
    return "head" === type;
}
function $b0f42935ea826c41$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $b0f42935ea826c41$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $b0f42935ea826c41$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $b0f42935ea826c41$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$b0f42935ea826c41$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $b0f42935ea826c41$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $b0f42935ea826c41$var$retryIfBlockedOn(hydrationInstance);
}
function $b0f42935ea826c41$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $b0f42935ea826c41$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $b0f42935ea826c41$var$clearContainerSparingly(node);
                $b0f42935ea826c41$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $b0f42935ea826c41$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$b0f42935ea826c41$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $b0f42935ea826c41$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $b0f42935ea826c41$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b0f42935ea826c41$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b0f42935ea826c41$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b0f42935ea826c41$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b0f42935ea826c41$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $b0f42935ea826c41$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $b0f42935ea826c41$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $b0f42935ea826c41$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $b0f42935ea826c41$var$previousHydratableOnEnteringScopedSingleton = null;
function $b0f42935ea826c41$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $b0f42935ea826c41$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $b0f42935ea826c41$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $b0f42935ea826c41$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(451));
    }
}
function $b0f42935ea826c41$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $b0f42935ea826c41$var$detachDeletedInstance(instance);
}
var $b0f42935ea826c41$var$preloadPropsMap = new Map(), $b0f42935ea826c41$var$preconnectsSet = new Set();
function $b0f42935ea826c41$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $b0f42935ea826c41$var$previousDispatcher = $b0f42935ea826c41$var$ReactDOMSharedInternals.d;
$b0f42935ea826c41$var$ReactDOMSharedInternals.d = {
    f: $b0f42935ea826c41$var$flushSyncWork,
    r: $b0f42935ea826c41$var$requestFormReset,
    D: $b0f42935ea826c41$var$prefetchDNS,
    C: $b0f42935ea826c41$var$preconnect,
    L: $b0f42935ea826c41$var$preload,
    m: $b0f42935ea826c41$var$preloadModule,
    X: $b0f42935ea826c41$var$preinitScript,
    S: $b0f42935ea826c41$var$preinitStyle,
    M: $b0f42935ea826c41$var$preinitModuleScript
};
function $b0f42935ea826c41$var$flushSyncWork() {
    var previousWasRendering = $b0f42935ea826c41$var$previousDispatcher.f(), wasRendering = $b0f42935ea826c41$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $b0f42935ea826c41$var$requestFormReset(form) {
    var formInst = $b0f42935ea826c41$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $b0f42935ea826c41$var$requestFormReset$1(formInst) : $b0f42935ea826c41$var$previousDispatcher.r(form);
}
var $b0f42935ea826c41$var$globalDocument = "undefined" === typeof document ? null : document;
function $b0f42935ea826c41$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $b0f42935ea826c41$var$preconnectsSet.has(limitedEscapedHref) || ($b0f42935ea826c41$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $b0f42935ea826c41$var$setInitialProperties(href, "link", rel), $b0f42935ea826c41$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $b0f42935ea826c41$var$prefetchDNS(href) {
    $b0f42935ea826c41$var$previousDispatcher.D(href);
    $b0f42935ea826c41$var$preconnectAs("dns-prefetch", href, null);
}
function $b0f42935ea826c41$var$preconnect(href, crossOrigin) {
    $b0f42935ea826c41$var$previousDispatcher.C(href, crossOrigin);
    $b0f42935ea826c41$var$preconnectAs("preconnect", href, crossOrigin);
}
function $b0f42935ea826c41$var$preload(href, as, options) {
    $b0f42935ea826c41$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $b0f42935ea826c41$var$getStyleKey(href);
                break;
            case "script":
                key = $b0f42935ea826c41$var$getScriptKey(href);
        }
        $b0f42935ea826c41$var$preloadPropsMap.has(key) || (href = $b0f42935ea826c41$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $b0f42935ea826c41$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $b0f42935ea826c41$var$setInitialProperties(as, "link", href), $b0f42935ea826c41$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $b0f42935ea826c41$var$preloadModule(href, options) {
    $b0f42935ea826c41$var$previousDispatcher.m(href, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $b0f42935ea826c41$var$getScriptKey(href);
        }
        if (!$b0f42935ea826c41$var$preloadPropsMap.has(key) && (href = $b0f42935ea826c41$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $b0f42935ea826c41$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $b0f42935ea826c41$var$setInitialProperties(as, "link", href);
            $b0f42935ea826c41$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $b0f42935ea826c41$var$preinitStyle(href, precedence, options) {
    $b0f42935ea826c41$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $b0f42935ea826c41$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $b0f42935ea826c41$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $b0f42935ea826c41$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $b0f42935ea826c41$var$preloadPropsMap.get(key)) && $b0f42935ea826c41$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $b0f42935ea826c41$var$markNodeAsHoistable(link);
                $b0f42935ea826c41$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $b0f42935ea826c41$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $b0f42935ea826c41$var$preinitScript(src, options) {
    $b0f42935ea826c41$var$previousDispatcher.X(src, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b0f42935ea826c41$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b0f42935ea826c41$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(key)), resource || (src = $b0f42935ea826c41$var$assign({
            src: src,
            async: !0
        }, options), (options = $b0f42935ea826c41$var$preloadPropsMap.get(key)) && $b0f42935ea826c41$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b0f42935ea826c41$var$markNodeAsHoistable(resource), $b0f42935ea826c41$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b0f42935ea826c41$var$preinitModuleScript(src, options) {
    $b0f42935ea826c41$var$previousDispatcher.M(src, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b0f42935ea826c41$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b0f42935ea826c41$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(key)), resource || (src = $b0f42935ea826c41$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $b0f42935ea826c41$var$preloadPropsMap.get(key)) && $b0f42935ea826c41$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b0f42935ea826c41$var$markNodeAsHoistable(resource), $b0f42935ea826c41$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b0f42935ea826c41$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $b0f42935ea826c41$var$rootInstanceStackCursor.current) ? $b0f42935ea826c41$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $b0f42935ea826c41$var$getStyleKey(pendingProps.href), pendingProps = $b0f42935ea826c41$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $b0f42935ea826c41$var$getStyleKey(pendingProps.href);
                var styles$243 = $b0f42935ea826c41$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $b0f42935ea826c41$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $b0f42935ea826c41$var$preloadPropsMap.set(type, pendingProps), styles$243 || $b0f42935ea826c41$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $b0f42935ea826c41$var$getScriptKey(pendingProps), pendingProps = $b0f42935ea826c41$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(444, type));
    }
}
function $b0f42935ea826c41$var$getStyleKey(href) {
    return 'href="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $b0f42935ea826c41$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $b0f42935ea826c41$var$stylesheetPropsFromRawProps(rawProps) {
    return $b0f42935ea826c41$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $b0f42935ea826c41$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $b0f42935ea826c41$var$setInitialProperties(key, "link", preloadProps), $b0f42935ea826c41$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $b0f42935ea826c41$var$getScriptKey(src) {
    return '[src="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $b0f42935ea826c41$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $b0f42935ea826c41$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $b0f42935ea826c41$var$markNodeAsHoistable(instance), instance;
            var styleProps = $b0f42935ea826c41$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $b0f42935ea826c41$var$markNodeAsHoistable(instance);
            $b0f42935ea826c41$var$setInitialProperties(instance, "style", styleProps);
            $b0f42935ea826c41$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $b0f42935ea826c41$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $b0f42935ea826c41$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $b0f42935ea826c41$var$stylesheetPropsFromRawProps(props);
            (styleProps = $b0f42935ea826c41$var$preloadPropsMap.get(styleProps)) && $b0f42935ea826c41$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $b0f42935ea826c41$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b0f42935ea826c41$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $b0f42935ea826c41$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $b0f42935ea826c41$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $b0f42935ea826c41$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $b0f42935ea826c41$var$preloadPropsMap.get(instance$249)) instance = $b0f42935ea826c41$var$assign({}, props), $b0f42935ea826c41$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $b0f42935ea826c41$var$markNodeAsHoistable(styleProps);
            $b0f42935ea826c41$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $b0f42935ea826c41$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $b0f42935ea826c41$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $b0f42935ea826c41$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $b0f42935ea826c41$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $b0f42935ea826c41$var$tagCaches = null;
function $b0f42935ea826c41$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $b0f42935ea826c41$var$tagCaches) {
        var cache = new Map();
        var caches = $b0f42935ea826c41$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $b0f42935ea826c41$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$b0f42935ea826c41$var$internalHoistableMarker] || node[$b0f42935ea826c41$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $b0f42935ea826c41$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $b0f42935ea826c41$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $b0f42935ea826c41$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $b0f42935ea826c41$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $b0f42935ea826c41$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $b0f42935ea826c41$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $b0f42935ea826c41$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $b0f42935ea826c41$var$stylesheetPropsFromRawProps(props);
            (key = $b0f42935ea826c41$var$preloadPropsMap.get(key)) && $b0f42935ea826c41$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $b0f42935ea826c41$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b0f42935ea826c41$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $b0f42935ea826c41$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $b0f42935ea826c41$var$estimatedBytesWithinLimit = 0;
function $b0f42935ea826c41$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $b0f42935ea826c41$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $b0f42935ea826c41$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $b0f42935ea826c41$var$estimatedBytesWithinLimit && ($b0f42935ea826c41$var$estimatedBytesWithinLimit = 62500 * $b0f42935ea826c41$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $b0f42935ea826c41$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $b0f42935ea826c41$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $b0f42935ea826c41$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $b0f42935ea826c41$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $b0f42935ea826c41$var$precedencesByRoot = null;
function $b0f42935ea826c41$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $b0f42935ea826c41$var$precedencesByRoot = new Map(), resources.forEach($b0f42935ea826c41$var$insertStylesheetIntoRoot, state), $b0f42935ea826c41$var$precedencesByRoot = null, $b0f42935ea826c41$var$onUnsuspend.call(state));
}
function $b0f42935ea826c41$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $b0f42935ea826c41$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $b0f42935ea826c41$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $b0f42935ea826c41$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $b0f42935ea826c41$var$HostTransitionContext = {
    $$typeof: $b0f42935ea826c41$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $b0f42935ea826c41$var$sharedNotPendingObject,
    _currentValue2: $b0f42935ea826c41$var$sharedNotPendingObject,
    _threadCount: 0
};
function $b0f42935ea826c41$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $b0f42935ea826c41$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b0f42935ea826c41$var$createLaneMap(0);
    this.hiddenUpdates = $b0f42935ea826c41$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $b0f42935ea826c41$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $b0f42935ea826c41$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $b0f42935ea826c41$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $b0f42935ea826c41$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $b0f42935ea826c41$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $b0f42935ea826c41$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $b0f42935ea826c41$var$emptyContextObject;
    parentComponent = $b0f42935ea826c41$var$emptyContextObject;
    return parentComponent;
}
function $b0f42935ea826c41$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $b0f42935ea826c41$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $b0f42935ea826c41$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $b0f42935ea826c41$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(element, rootFiber, lane), $b0f42935ea826c41$var$entangleTransitions(element, rootFiber, lane));
}
function $b0f42935ea826c41$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $b0f42935ea826c41$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $b0f42935ea826c41$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $b0f42935ea826c41$var$markRetryLaneImpl(fiber, retryLane);
}
function $b0f42935ea826c41$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $b0f42935ea826c41$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $b0f42935ea826c41$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $b0f42935ea826c41$var$requestUpdateLane();
        lane = $b0f42935ea826c41$var$getBumpedLaneForHydrationByLane(lane);
        var root = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, lane);
        $b0f42935ea826c41$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $b0f42935ea826c41$var$_enabled = !0;
function $b0f42935ea826c41$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T;
    $b0f42935ea826c41$var$ReactSharedInternals.T = null;
    var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    try {
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2, $b0f42935ea826c41$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b0f42935ea826c41$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T;
    $b0f42935ea826c41$var$ReactSharedInternals.T = null;
    var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    try {
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 8, $b0f42935ea826c41$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b0f42935ea826c41$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($b0f42935ea826c41$var$_enabled) {
        var blockedOn = $b0f42935ea826c41$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $b0f42935ea826c41$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b0f42935ea826c41$var$return_targetInst, targetContainer), $b0f42935ea826c41$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($b0f42935ea826c41$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($b0f42935ea826c41$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $b0f42935ea826c41$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $b0f42935ea826c41$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $b0f42935ea826c41$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $b0f42935ea826c41$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $b0f42935ea826c41$var$ensureRootIsScheduled(fiber);
                                0 === ($b0f42935ea826c41$var$executionContext & 6) && ($b0f42935ea826c41$var$workInProgressRootRenderTargetTime = $b0f42935ea826c41$var$now() + 500, $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, 2), $b0f42935ea826c41$var$flushSyncWork$1(), $b0f42935ea826c41$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $b0f42935ea826c41$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $b0f42935ea826c41$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b0f42935ea826c41$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $b0f42935ea826c41$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $b0f42935ea826c41$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $b0f42935ea826c41$var$getEventTarget(nativeEvent);
    return $b0f42935ea826c41$var$findInstanceBlockingTarget(nativeEvent);
}
var $b0f42935ea826c41$var$return_targetInst = null;
function $b0f42935ea826c41$var$findInstanceBlockingTarget(targetNode) {
    $b0f42935ea826c41$var$return_targetInst = null;
    targetNode = $b0f42935ea826c41$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $b0f42935ea826c41$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $b0f42935ea826c41$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $b0f42935ea826c41$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $b0f42935ea826c41$var$return_targetInst = targetNode;
    return null;
}
function $b0f42935ea826c41$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($b0f42935ea826c41$var$getCurrentPriorityLevel()){
                case $b0f42935ea826c41$var$ImmediatePriority:
                    return 2;
                case $b0f42935ea826c41$var$UserBlockingPriority:
                    return 8;
                case $b0f42935ea826c41$var$NormalPriority$1:
                case $b0f42935ea826c41$var$LowPriority:
                    return 32;
                case $b0f42935ea826c41$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $b0f42935ea826c41$var$hasScheduledReplayAttempt = !1, $b0f42935ea826c41$var$queuedFocus = null, $b0f42935ea826c41$var$queuedDrag = null, $b0f42935ea826c41$var$queuedMouse = null, $b0f42935ea826c41$var$queuedPointers = new Map(), $b0f42935ea826c41$var$queuedPointerCaptures = new Map(), $b0f42935ea826c41$var$queuedExplicitHydrationTargets = [], $b0f42935ea826c41$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $b0f42935ea826c41$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $b0f42935ea826c41$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $b0f42935ea826c41$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $b0f42935ea826c41$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $b0f42935ea826c41$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b0f42935ea826c41$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $b0f42935ea826c41$var$getInstanceFromNode(blockedOn), null !== blockedOn && $b0f42935ea826c41$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $b0f42935ea826c41$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $b0f42935ea826c41$var$queuedFocus = $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $b0f42935ea826c41$var$queuedDrag = $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $b0f42935ea826c41$var$queuedMouse = $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $b0f42935ea826c41$var$queuedPointers.set(pointerId, $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $b0f42935ea826c41$var$queuedPointerCaptures.set(pointerId, $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $b0f42935ea826c41$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $b0f42935ea826c41$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $b0f42935ea826c41$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $b0f42935ea826c41$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b0f42935ea826c41$var$runWithPriority(queuedTarget.priority, function() {
                        $b0f42935ea826c41$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $b0f42935ea826c41$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b0f42935ea826c41$var$runWithPriority(queuedTarget.priority, function() {
                        $b0f42935ea826c41$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $b0f42935ea826c41$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $b0f42935ea826c41$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $b0f42935ea826c41$var$currentReplayingEvent = null;
        } else return targetContainers = $b0f42935ea826c41$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $b0f42935ea826c41$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $b0f42935ea826c41$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $b0f42935ea826c41$var$replayUnblockedEvents() {
    $b0f42935ea826c41$var$hasScheduledReplayAttempt = !1;
    null !== $b0f42935ea826c41$var$queuedFocus && $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent($b0f42935ea826c41$var$queuedFocus) && ($b0f42935ea826c41$var$queuedFocus = null);
    null !== $b0f42935ea826c41$var$queuedDrag && $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent($b0f42935ea826c41$var$queuedDrag) && ($b0f42935ea826c41$var$queuedDrag = null);
    null !== $b0f42935ea826c41$var$queuedMouse && $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent($b0f42935ea826c41$var$queuedMouse) && ($b0f42935ea826c41$var$queuedMouse = null);
    $b0f42935ea826c41$var$queuedPointers.forEach($b0f42935ea826c41$var$attemptReplayContinuousQueuedEventInMap);
    $b0f42935ea826c41$var$queuedPointerCaptures.forEach($b0f42935ea826c41$var$attemptReplayContinuousQueuedEventInMap);
}
function $b0f42935ea826c41$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $b0f42935ea826c41$var$hasScheduledReplayAttempt || ($b0f42935ea826c41$var$hasScheduledReplayAttempt = !0, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, $b0f42935ea826c41$var$replayUnblockedEvents)));
}
var $b0f42935ea826c41$var$lastScheduledReplayQueue = null;
function $b0f42935ea826c41$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $b0f42935ea826c41$var$lastScheduledReplayQueue !== formReplayingQueue && ($b0f42935ea826c41$var$lastScheduledReplayQueue = formReplayingQueue, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, function() {
        $b0f42935ea826c41$var$lastScheduledReplayQueue === formReplayingQueue && ($b0f42935ea826c41$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $b0f42935ea826c41$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $b0f42935ea826c41$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $b0f42935ea826c41$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $b0f42935ea826c41$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $b0f42935ea826c41$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $b0f42935ea826c41$var$queuedFocus && $b0f42935ea826c41$var$scheduleCallbackIfUnblocked($b0f42935ea826c41$var$queuedFocus, unblocked);
    null !== $b0f42935ea826c41$var$queuedDrag && $b0f42935ea826c41$var$scheduleCallbackIfUnblocked($b0f42935ea826c41$var$queuedDrag, unblocked);
    null !== $b0f42935ea826c41$var$queuedMouse && $b0f42935ea826c41$var$scheduleCallbackIfUnblocked($b0f42935ea826c41$var$queuedMouse, unblocked);
    $b0f42935ea826c41$var$queuedPointers.forEach(unblock);
    $b0f42935ea826c41$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $b0f42935ea826c41$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $b0f42935ea826c41$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $b0f42935ea826c41$var$queuedExplicitHydrationTargets.length && (i = $b0f42935ea826c41$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$b0f42935ea826c41$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $b0f42935ea826c41$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$b0f42935ea826c41$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $b0f42935ea826c41$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$b0f42935ea826c41$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $b0f42935ea826c41$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $b0f42935ea826c41$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $b0f42935ea826c41$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $b0f42935ea826c41$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b0f42935ea826c41$var$ReactDOMHydrationRoot.prototype.render = $b0f42935ea826c41$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(409));
    var current = root.current, lane = $b0f42935ea826c41$var$requestUpdateLane();
    $b0f42935ea826c41$var$updateContainerImpl(current, lane, children, root, null, null);
};
$b0f42935ea826c41$var$ReactDOMHydrationRoot.prototype.unmount = $b0f42935ea826c41$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $b0f42935ea826c41$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $b0f42935ea826c41$var$flushSyncWork$1();
        container[$b0f42935ea826c41$var$internalContainerInstanceKey] = null;
    }
};
function $b0f42935ea826c41$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b0f42935ea826c41$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $b0f42935ea826c41$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $b0f42935ea826c41$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $b0f42935ea826c41$var$queuedExplicitHydrationTargets[i].priority; i++);
        $b0f42935ea826c41$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $b0f42935ea826c41$var$attemptExplicitHydrationTarget(target);
    }
};
var $b0f42935ea826c41$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $jXEQt.version;
if ("19.2.3" !== $b0f42935ea826c41$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(527, $b0f42935ea826c41$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.3"));
$b0f42935ea826c41$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $b0f42935ea826c41$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $b0f42935ea826c41$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $b0f42935ea826c41$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $b0f42935ea826c41$var$ReactSharedInternals,
    reconcilerVersion: "19.2.3"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b0f42935ea826c41$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b0f42935ea826c41$var$hook$jscomp$inline_2348.isDisabled && $b0f42935ea826c41$var$hook$jscomp$inline_2348.supportsFiber) try {
        $b0f42935ea826c41$var$rendererID = $b0f42935ea826c41$var$hook$jscomp$inline_2348.inject($b0f42935ea826c41$var$internals$jscomp$inline_2347), $b0f42935ea826c41$var$injectedHook = $b0f42935ea826c41$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$b0f42935ea826c41$export$882461b6382ed46c = function(container, options) {
    if (!$b0f42935ea826c41$var$isValidContainer(container)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b0f42935ea826c41$var$defaultOnUncaughtError, onCaughtError = $b0f42935ea826c41$var$defaultOnCaughtError, onRecoverableError = $b0f42935ea826c41$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $b0f42935ea826c41$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $b0f42935ea826c41$var$defaultOnDefaultTransitionIndicator);
    container[$b0f42935ea826c41$var$internalContainerInstanceKey] = options.current;
    $b0f42935ea826c41$var$listenToAllSupportedEvents(container);
    return new $b0f42935ea826c41$var$ReactDOMRoot(options);
};
$b0f42935ea826c41$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$b0f42935ea826c41$var$isValidContainer(container)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b0f42935ea826c41$var$defaultOnUncaughtError, onCaughtError = $b0f42935ea826c41$var$defaultOnCaughtError, onRecoverableError = $b0f42935ea826c41$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $b0f42935ea826c41$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $b0f42935ea826c41$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $b0f42935ea826c41$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $b0f42935ea826c41$var$requestUpdateLane();
    isStrictMode = $b0f42935ea826c41$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $b0f42935ea826c41$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $b0f42935ea826c41$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $b0f42935ea826c41$var$markRootUpdated$1(initialChildren, options);
    $b0f42935ea826c41$var$ensureRootIsScheduled(initialChildren);
    container[$b0f42935ea826c41$var$internalContainerInstanceKey] = initialChildren.current;
    $b0f42935ea826c41$var$listenToAllSupportedEvents(container);
    return new $b0f42935ea826c41$var$ReactDOMHydrationRoot(initialChildren);
};
$b0f42935ea826c41$export$83d89fbfd8236492 = "19.2.3";

});
parcelRegister("bIbqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hvKuw"));

});
parcelRegister("hvKuw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $cbf9651fe4890f47$export$c4744153514ff05d, (v) => $cbf9651fe4890f47$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7, (v) => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $cbf9651fe4890f47$export$e26fe2ed2fa76875, (v) => $cbf9651fe4890f47$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $cbf9651fe4890f47$export$502329bbf4b505b1, (v) => $cbf9651fe4890f47$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $cbf9651fe4890f47$export$6e3807111c4874c4, (v) => $cbf9651fe4890f47$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $cbf9651fe4890f47$export$c27134553091fb3a, (v) => $cbf9651fe4890f47$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $cbf9651fe4890f47$export$33ee1acdc04fd2a2, (v) => $cbf9651fe4890f47$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $cbf9651fe4890f47$export$b00a404bbd5edef2, (v) => $cbf9651fe4890f47$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $cbf9651fe4890f47$export$d66a1c1c77bd778b, (v) => $cbf9651fe4890f47$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $cbf9651fe4890f47$export$d3dfb8e4810cb555, (v) => $cbf9651fe4890f47$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $cbf9651fe4890f47$export$72fdf0e06517287b, (v) => $cbf9651fe4890f47$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $cbf9651fe4890f47$export$816d2913ae6b83b1, (v) => $cbf9651fe4890f47$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $cbf9651fe4890f47$export$61bcfe829111a1d0, (v) => $cbf9651fe4890f47$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $cbf9651fe4890f47$export$7ee8c9beb337bc3f, (v) => $cbf9651fe4890f47$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $cbf9651fe4890f47$export$b5836b71941fa3ed, (v) => $cbf9651fe4890f47$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $cbf9651fe4890f47$export$cf845f2c119da08a, (v) => $cbf9651fe4890f47$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf9651fe4890f47$export$c4744153514ff05d;
var $cbf9651fe4890f47$export$3e506c1ccc9cc1a7;
var $cbf9651fe4890f47$export$e26fe2ed2fa76875;
var $cbf9651fe4890f47$export$502329bbf4b505b1;
var $cbf9651fe4890f47$export$6e3807111c4874c4;
var $cbf9651fe4890f47$export$c27134553091fb3a;
var $cbf9651fe4890f47$export$33ee1acdc04fd2a2;
var $cbf9651fe4890f47$export$b00a404bbd5edef2;
var $cbf9651fe4890f47$export$d66a1c1c77bd778b;
var $cbf9651fe4890f47$export$d3dfb8e4810cb555;
var $cbf9651fe4890f47$export$72fdf0e06517287b;
var $cbf9651fe4890f47$export$816d2913ae6b83b1;
var $cbf9651fe4890f47$export$61bcfe829111a1d0;
var $cbf9651fe4890f47$export$7ee8c9beb337bc3f;
var $cbf9651fe4890f47$export$b5836b71941fa3ed;
var $cbf9651fe4890f47$export$cf845f2c119da08a;
"use strict";
function $cbf9651fe4890f47$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cbf9651fe4890f47$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cbf9651fe4890f47$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cbf9651fe4890f47$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cbf9651fe4890f47$var$compare(left, last)) rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cbf9651fe4890f47$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cbf9651fe4890f47$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cbf9651fe4890f47$var$localPerformance = performance;
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localPerformance.now();
    };
} else {
    var $cbf9651fe4890f47$var$localDate = Date, $cbf9651fe4890f47$var$initialTime = $cbf9651fe4890f47$var$localDate.now();
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localDate.now() - $cbf9651fe4890f47$var$initialTime;
    };
}
var $cbf9651fe4890f47$var$taskQueue = [], $cbf9651fe4890f47$var$timerQueue = [], $cbf9651fe4890f47$var$taskIdCounter = 1, $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = 3, $cbf9651fe4890f47$var$isPerformingWork = !1, $cbf9651fe4890f47$var$isHostCallbackScheduled = !1, $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$needsPaint = !1, $cbf9651fe4890f47$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cbf9651fe4890f47$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cbf9651fe4890f47$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cbf9651fe4890f47$var$advanceTimers(currentTime) {
    for(var timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue);
        else if (timer.startTime <= currentTime) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue), timer.sortIndex = timer.expirationTime, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, timer);
        else break;
        timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
    }
}
function $cbf9651fe4890f47$var$handleTimeout(currentTime) {
    $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1;
    $cbf9651fe4890f47$var$advanceTimers(currentTime);
    if (!$cbf9651fe4890f47$var$isHostCallbackScheduled) {
        if (null !== $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue)) $cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cbf9651fe4890f47$var$isMessageLoopRunning = !1, $cbf9651fe4890f47$var$taskTimeoutID = -1, $cbf9651fe4890f47$var$frameInterval = 5, $cbf9651fe4890f47$var$startTime = -1;
function $cbf9651fe4890f47$var$shouldYieldToHost() {
    return $cbf9651fe4890f47$var$needsPaint ? !0 : $cbf9651fe4890f47$export$c4744153514ff05d() - $cbf9651fe4890f47$var$startTime < $cbf9651fe4890f47$var$frameInterval ? !1 : !0;
}
function $cbf9651fe4890f47$var$performWorkUntilDeadline() {
    $cbf9651fe4890f47$var$needsPaint = !1;
    if ($cbf9651fe4890f47$var$isMessageLoopRunning) {
        var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
        $cbf9651fe4890f47$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cbf9651fe4890f47$var$isHostCallbackScheduled = !1;
                $cbf9651fe4890f47$var$isHostTimeoutScheduled && ($cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1);
                $cbf9651fe4890f47$var$isPerformingWork = !0;
                var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
                try {
                    b: {
                        $cbf9651fe4890f47$var$advanceTimers(currentTime);
                        for($cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue); null !== $cbf9651fe4890f47$var$currentTask && !($cbf9651fe4890f47$var$currentTask.expirationTime > currentTime && $cbf9651fe4890f47$var$shouldYieldToHost());){
                            var callback = $cbf9651fe4890f47$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cbf9651fe4890f47$var$currentTask.callback = null;
                                $cbf9651fe4890f47$var$currentPriorityLevel = $cbf9651fe4890f47$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cbf9651fe4890f47$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cbf9651fe4890f47$var$currentTask.callback = continuationCallback;
                                    $cbf9651fe4890f47$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cbf9651fe4890f47$var$currentTask === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                                $cbf9651fe4890f47$var$advanceTimers(currentTime);
                            } else $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                            $cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue);
                        }
                        if (null !== $cbf9651fe4890f47$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
                            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel, $cbf9651fe4890f47$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline() : $cbf9651fe4890f47$var$isMessageLoopRunning = !1;
        }
    }
}
var $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cbf9651fe4890f47$var$localSetImmediate) $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetImmediate($cbf9651fe4890f47$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cbf9651fe4890f47$var$channel = new MessageChannel(), $cbf9651fe4890f47$var$port = $cbf9651fe4890f47$var$channel.port2;
    $cbf9651fe4890f47$var$channel.port1.onmessage = $cbf9651fe4890f47$var$performWorkUntilDeadline;
    $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
        $cbf9651fe4890f47$var$port.postMessage(null);
    };
} else $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetTimeout($cbf9651fe4890f47$var$performWorkUntilDeadline, 0);
};
function $cbf9651fe4890f47$var$requestHostTimeout(callback, ms) {
    $cbf9651fe4890f47$var$taskTimeoutID = $cbf9651fe4890f47$var$localSetTimeout(function() {
        callback($cbf9651fe4890f47$export$c4744153514ff05d());
    }, ms);
}
$cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = 5;
$cbf9651fe4890f47$export$e26fe2ed2fa76875 = 1;
$cbf9651fe4890f47$export$502329bbf4b505b1 = 4;
$cbf9651fe4890f47$export$6e3807111c4874c4 = 3;
$cbf9651fe4890f47$export$c27134553091fb3a = null;
$cbf9651fe4890f47$export$33ee1acdc04fd2a2 = 2;
$cbf9651fe4890f47$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cbf9651fe4890f47$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cbf9651fe4890f47$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cbf9651fe4890f47$export$d3dfb8e4810cb555 = function() {
    return $cbf9651fe4890f47$var$currentPriorityLevel;
};
$cbf9651fe4890f47$export$72fdf0e06517287b = function(eventHandler) {
    switch($cbf9651fe4890f47$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$816d2913ae6b83b1 = function() {
    $cbf9651fe4890f47$var$needsPaint = !0;
};
$cbf9651fe4890f47$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cbf9651fe4890f47$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$timerQueue, priorityLevel), null === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && priorityLevel === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue) && ($cbf9651fe4890f47$var$isHostTimeoutScheduled ? ($cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1) : $cbf9651fe4890f47$var$isHostTimeoutScheduled = !0, $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, priorityLevel), $cbf9651fe4890f47$var$isHostCallbackScheduled || $cbf9651fe4890f47$var$isPerformingWork || ($cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cbf9651fe4890f47$export$b5836b71941fa3ed = $cbf9651fe4890f47$var$shouldYieldToHost;
$cbf9651fe4890f47$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
        $cbf9651fe4890f47$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("jXEQt", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j7kdz"));

});

parcelRegister("8vWo2", function(module, exports) {
'use strict';
function $632e82600c6e6253$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($632e82600c6e6253$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$632e82600c6e6253$var$checkDCE();

module.exports = (parcelRequire("8mkm8"));

});
parcelRegister("8mkm8", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $61602b11b686f3ac$export$69ce8ef3fe5cead0, (v) => $61602b11b686f3ac$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $61602b11b686f3ac$export$d39a5bbd09211389, (v) => $61602b11b686f3ac$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $61602b11b686f3ac$export$cd75ccfd720a3cd4, (v) => $61602b11b686f3ac$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $61602b11b686f3ac$export$a0816fa17a9e79be, (v) => $61602b11b686f3ac$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $61602b11b686f3ac$export$7292efcadded39f3, (v) => $61602b11b686f3ac$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $61602b11b686f3ac$export$da407abadb9b8f86, (v) => $61602b11b686f3ac$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $61602b11b686f3ac$export$314cfea32580671c, (v) => $61602b11b686f3ac$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $61602b11b686f3ac$export$513ccb98c53b8039, (v) => $61602b11b686f3ac$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $61602b11b686f3ac$export$dbca993bc2d264a, (v) => $61602b11b686f3ac$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $61602b11b686f3ac$export$4797a8006f0655d0, (v) => $61602b11b686f3ac$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $61602b11b686f3ac$export$c78a37762a8d58e1, (v) => $61602b11b686f3ac$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $61602b11b686f3ac$export$606f11b2eb45ecc6, (v) => $61602b11b686f3ac$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $61602b11b686f3ac$export$f7e8a0bf92324b1e, (v) => $61602b11b686f3ac$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $61602b11b686f3ac$export$83d89fbfd8236492, (v) => $61602b11b686f3ac$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $61602b11b686f3ac$export$69ce8ef3fe5cead0;
var $61602b11b686f3ac$export$d39a5bbd09211389;
var $61602b11b686f3ac$export$cd75ccfd720a3cd4;
var $61602b11b686f3ac$export$a0816fa17a9e79be;
var $61602b11b686f3ac$export$7292efcadded39f3;
var $61602b11b686f3ac$export$da407abadb9b8f86;
var $61602b11b686f3ac$export$314cfea32580671c;
var $61602b11b686f3ac$export$513ccb98c53b8039;
var $61602b11b686f3ac$export$dbca993bc2d264a;
var $61602b11b686f3ac$export$4797a8006f0655d0;
var $61602b11b686f3ac$export$c78a37762a8d58e1;
var $61602b11b686f3ac$export$606f11b2eb45ecc6;
var $61602b11b686f3ac$export$f7e8a0bf92324b1e;
var $61602b11b686f3ac$export$83d89fbfd8236492;
"use strict";

var $jXEQt = parcelRequire("jXEQt");
function $61602b11b686f3ac$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $61602b11b686f3ac$var$noop() {}
var $61602b11b686f3ac$var$Internals = {
    d: {
        f: $61602b11b686f3ac$var$noop,
        r: function() {
            throw Error($61602b11b686f3ac$var$formatProdErrorMessage(522));
        },
        D: $61602b11b686f3ac$var$noop,
        C: $61602b11b686f3ac$var$noop,
        L: $61602b11b686f3ac$var$noop,
        m: $61602b11b686f3ac$var$noop,
        X: $61602b11b686f3ac$var$noop,
        S: $61602b11b686f3ac$var$noop,
        M: $61602b11b686f3ac$var$noop
    },
    p: 0,
    findDOMNode: null
}, $61602b11b686f3ac$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $61602b11b686f3ac$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $61602b11b686f3ac$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $61602b11b686f3ac$var$ReactSharedInternals = $jXEQt.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $61602b11b686f3ac$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$61602b11b686f3ac$export$69ce8ef3fe5cead0 = $61602b11b686f3ac$var$Internals;
$61602b11b686f3ac$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($61602b11b686f3ac$var$formatProdErrorMessage(299));
    return $61602b11b686f3ac$var$createPortal$1(children, container, null, key);
};
$61602b11b686f3ac$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $61602b11b686f3ac$var$ReactSharedInternals.T, previousUpdatePriority = $61602b11b686f3ac$var$Internals.p;
    try {
        if ($61602b11b686f3ac$var$ReactSharedInternals.T = null, $61602b11b686f3ac$var$Internals.p = 2, fn) return fn();
    } finally{
        $61602b11b686f3ac$var$ReactSharedInternals.T = previousTransition, $61602b11b686f3ac$var$Internals.p = previousUpdatePriority, $61602b11b686f3ac$var$Internals.d.f();
    }
};
$61602b11b686f3ac$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $61602b11b686f3ac$var$Internals.d.C(href, options));
};
$61602b11b686f3ac$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $61602b11b686f3ac$var$Internals.d.D(href);
};
$61602b11b686f3ac$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $61602b11b686f3ac$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $61602b11b686f3ac$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $61602b11b686f3ac$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$61602b11b686f3ac$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $61602b11b686f3ac$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $61602b11b686f3ac$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $61602b11b686f3ac$var$Internals.d.M(href);
    }
};
$61602b11b686f3ac$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $61602b11b686f3ac$var$getCrossOriginStringAs(as, options.crossOrigin);
        $61602b11b686f3ac$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$61602b11b686f3ac$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $61602b11b686f3ac$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $61602b11b686f3ac$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $61602b11b686f3ac$var$Internals.d.m(href);
    }
};
$61602b11b686f3ac$export$4797a8006f0655d0 = function(form) {
    $61602b11b686f3ac$var$Internals.d.r(form);
};
$61602b11b686f3ac$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$61602b11b686f3ac$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $61602b11b686f3ac$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$61602b11b686f3ac$export$f7e8a0bf92324b1e = function() {
    return $61602b11b686f3ac$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$61602b11b686f3ac$export$83d89fbfd8236492 = "19.2.3";

});



var $56c05cee281658b4$exports = {};
'use strict';

$56c05cee281658b4$exports = (parcelRequire("ho8Ig"));



var $jXEQt = parcelRequire("jXEQt");
var $bb6cb2ce16bd7b19$exports = {};
'use strict';
function $bb6cb2ce16bd7b19$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($bb6cb2ce16bd7b19$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$bb6cb2ce16bd7b19$var$checkDCE();

$bb6cb2ce16bd7b19$exports = (parcelRequire("fbV55"));


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ /**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 
var $jXEQt = parcelRequire("jXEQt");
class $d84a2ee106960538$export$fbff1287c64b152e extends (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).Component {
    UNSAFE_componentWillMount() {
        this.attached();
    }
    componentWillUnmount() {
        this.detached();
    }
    attached() {
    // NOOP
    }
    detached() {
    // NOOP
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ /**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ // :: Utils
/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ // :: Helpers
const $e6bdec9b5bfe1ac0$var$ILogger_noop = ()=>{
// NOOP
};
function $e6bdec9b5bfe1ac0$var$ILogger_isDebugEnabled() {
    return this.debug !== $e6bdec9b5bfe1ac0$var$ILogger_noop;
}
function $e6bdec9b5bfe1ac0$var$ILogger_setDebugEnabled(value) {
    if (value) this.debug = console.debug.bind(console, this.context);
    else this.debug = $e6bdec9b5bfe1ac0$var$ILogger_noop;
}
function $e6bdec9b5bfe1ac0$var$ILogger_isInfoEnabled() {
    return this.info !== $e6bdec9b5bfe1ac0$var$ILogger_noop;
}
function $e6bdec9b5bfe1ac0$var$ILogger_setInfoEnabled(value) {
    if (value) this.info = console.info.bind(console, this.context);
    else this.info = $e6bdec9b5bfe1ac0$var$ILogger_noop;
}
function $e6bdec9b5bfe1ac0$var$ILogger_isWarnEnabled() {
    return this.warn !== $e6bdec9b5bfe1ac0$var$ILogger_noop;
}
function $e6bdec9b5bfe1ac0$var$ILogger_setWarnEnabled(value) {
    if (value) this.warn = console.warn.bind(console, this.context);
    else this.warn = $e6bdec9b5bfe1ac0$var$ILogger_noop;
}
function $e6bdec9b5bfe1ac0$var$ILogger_isErrorEnabled() {
    return this.error !== $e6bdec9b5bfe1ac0$var$ILogger_noop;
}
function $e6bdec9b5bfe1ac0$var$ILogger_setErrorEnabled(value) {
    if (value) this.error = console.error.bind(console, this.context);
    else this.error = $e6bdec9b5bfe1ac0$var$ILogger_noop;
}
function $e6bdec9b5bfe1ac0$var$ILogger_caught(error) {
    if (error instanceof Error) this.error(error.message, error.stack);
    else if (error) this.error(String(error));
}
const $e6bdec9b5bfe1ac0$export$efa9a398d6368992 = function() {
    const __instanceMap = new Map();
    let __defaultDebugFunction = $e6bdec9b5bfe1ac0$var$ILogger_noop;
    let __defaultInfoFunction = $e6bdec9b5bfe1ac0$var$ILogger_noop;
    let __defaultWarnFunction = console.warn;
    let __defaultErrorFunction = console.error;
    const me = {
        setDebugEnabled: setDebugEnabled,
        setInfoEnabled: setInfoEnabled,
        setWarnEnabled: setWarnEnabled,
        setErrorEnabled: setErrorEnabled,
        get: getOrCreate
    };
    Object.seal(me);
    return me;
    // Methods
    function setDebugEnabled(value) {
        if (value) __defaultDebugFunction = console.debug;
        else __defaultDebugFunction = $e6bdec9b5bfe1ac0$var$ILogger_noop;
        for (const logger of __instanceMap.values())logger.setDebugEnabled(value);
    }
    function setInfoEnabled(value) {
        if (value) __defaultInfoFunction = console.info;
        else __defaultInfoFunction = $e6bdec9b5bfe1ac0$var$ILogger_noop;
        for (const logger of __instanceMap.values())logger.setInfoEnabled(value);
    }
    function setWarnEnabled(value) {
        if (value) __defaultWarnFunction = console.warn;
        else __defaultWarnFunction = $e6bdec9b5bfe1ac0$var$ILogger_noop;
        for (const logger of __instanceMap.values())logger.setWarnEnabled(value);
    }
    function setErrorEnabled(value) {
        if (value) __defaultErrorFunction = console.error;
        else __defaultErrorFunction = $e6bdec9b5bfe1ac0$var$ILogger_noop;
        for (const logger of __instanceMap.values())logger.setErrorEnabled(value);
    }
    function getOrCreate(name) {
        let logger = __instanceMap.get(name);
        if (!logger) {
            const context = `[${name}]`;
            logger = {
                context: context,
                debug: __defaultDebugFunction.bind(console, context),
                info: __defaultInfoFunction.bind(console, context),
                warn: __defaultWarnFunction.bind(console, context),
                error: __defaultErrorFunction.bind(console, context),
                caught: $e6bdec9b5bfe1ac0$var$ILogger_caught,
                isDebugEnabled: $e6bdec9b5bfe1ac0$var$ILogger_isDebugEnabled,
                setDebugEnabled: $e6bdec9b5bfe1ac0$var$ILogger_setDebugEnabled,
                isInfoEnabled: $e6bdec9b5bfe1ac0$var$ILogger_isInfoEnabled,
                setInfoEnabled: $e6bdec9b5bfe1ac0$var$ILogger_setInfoEnabled,
                isWarnEnabled: $e6bdec9b5bfe1ac0$var$ILogger_isWarnEnabled,
                setWarnEnabled: $e6bdec9b5bfe1ac0$var$ILogger_setWarnEnabled,
                isErrorEnabled: $e6bdec9b5bfe1ac0$var$ILogger_isErrorEnabled,
                setErrorEnabled: $e6bdec9b5bfe1ac0$var$ILogger_setErrorEnabled
            };
            logger.caught = $e6bdec9b5bfe1ac0$var$ILogger_caught.bind(logger);
            __instanceMap.set(name, logger);
        }
        return logger;
    }
}();


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ function $5e892709dbe5636f$export$49db20642bd540b0() {
// NOOP
}
function $5e892709dbe5636f$export$583e2e01f76d1f92() {
    return '';
}
function $5e892709dbe5636f$export$3243e7273c8b7e01() {
    return false;
}
async function $5e892709dbe5636f$export$a8765dfddffd7953() {
// NOOP
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ var $46df106f4bdb7fb2$exports = {};
var $a417b04763129f1c$exports = {};
var $24222c5e026539d1$exports = {};
var $e1f29a94f3202822$exports = {};
var $2c9229a3504a6578$exports = {};
/** Detect free variable `global` from Node.js. */ var $2c9229a3504a6578$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$2c9229a3504a6578$exports = $2c9229a3504a6578$var$freeGlobal;


/** Detect free variable `self`. */ var $e1f29a94f3202822$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e1f29a94f3202822$var$root = $2c9229a3504a6578$exports || $e1f29a94f3202822$var$freeSelf || Function('return this')();
$e1f29a94f3202822$exports = $e1f29a94f3202822$var$root;


/** Built-in value references. */ var $24222c5e026539d1$var$Symbol = $e1f29a94f3202822$exports.Symbol;
$24222c5e026539d1$exports = $24222c5e026539d1$var$Symbol;


var $d5a2c4cb9feb0d76$exports = {};

/** Used for built-in method references. */ var $d5a2c4cb9feb0d76$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5a2c4cb9feb0d76$var$hasOwnProperty = $d5a2c4cb9feb0d76$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d5a2c4cb9feb0d76$var$nativeObjectToString = $d5a2c4cb9feb0d76$var$objectProto.toString;
/** Built-in value references. */ var $d5a2c4cb9feb0d76$var$symToStringTag = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d5a2c4cb9feb0d76$var$getRawTag(value) {
    var isOwn = $d5a2c4cb9feb0d76$var$hasOwnProperty.call(value, $d5a2c4cb9feb0d76$var$symToStringTag), tag = value[$d5a2c4cb9feb0d76$var$symToStringTag];
    try {
        value[$d5a2c4cb9feb0d76$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d5a2c4cb9feb0d76$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d5a2c4cb9feb0d76$var$symToStringTag] = tag;
        else delete value[$d5a2c4cb9feb0d76$var$symToStringTag];
    }
    return result;
}
$d5a2c4cb9feb0d76$exports = $d5a2c4cb9feb0d76$var$getRawTag;


var $b787ae3208ebc449$exports = {};
/** Used for built-in method references. */ var $b787ae3208ebc449$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b787ae3208ebc449$var$nativeObjectToString = $b787ae3208ebc449$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b787ae3208ebc449$var$objectToString(value) {
    return $b787ae3208ebc449$var$nativeObjectToString.call(value);
}
$b787ae3208ebc449$exports = $b787ae3208ebc449$var$objectToString;


/** `Object#toString` result references. */ var $a417b04763129f1c$var$nullTag = '[object Null]', $a417b04763129f1c$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a417b04763129f1c$var$symToStringTag = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a417b04763129f1c$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a417b04763129f1c$var$undefinedTag : $a417b04763129f1c$var$nullTag;
    return $a417b04763129f1c$var$symToStringTag && $a417b04763129f1c$var$symToStringTag in Object(value) ? $d5a2c4cb9feb0d76$exports(value) : $b787ae3208ebc449$exports(value);
}
$a417b04763129f1c$exports = $a417b04763129f1c$var$baseGetTag;


var $34a8c8cbd9ebf965$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $34a8c8cbd9ebf965$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$34a8c8cbd9ebf965$exports = $34a8c8cbd9ebf965$var$isObjectLike;


/** `Object#toString` result references. */ var $46df106f4bdb7fb2$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $46df106f4bdb7fb2$var$isBoolean(value) {
    return value === true || value === false || $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $46df106f4bdb7fb2$var$boolTag;
}
$46df106f4bdb7fb2$exports = $46df106f4bdb7fb2$var$isBoolean;


var $37811de5ea7fe4ba$exports = {};


/** `Object#toString` result references. */ var $37811de5ea7fe4ba$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $37811de5ea7fe4ba$var$isNumber(value) {
    return typeof value == 'number' || $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $37811de5ea7fe4ba$var$numberTag;
}
$37811de5ea7fe4ba$exports = $37811de5ea7fe4ba$var$isNumber;


var $16fa8ba01192b4c0$exports = {};

var $0222e83d73c8b1f6$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0222e83d73c8b1f6$var$isArray = Array.isArray;
$0222e83d73c8b1f6$exports = $0222e83d73c8b1f6$var$isArray;



/** `Object#toString` result references. */ var $16fa8ba01192b4c0$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $16fa8ba01192b4c0$var$isString(value) {
    return typeof value == 'string' || !$0222e83d73c8b1f6$exports(value) && $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $16fa8ba01192b4c0$var$stringTag;
}
$16fa8ba01192b4c0$exports = $16fa8ba01192b4c0$var$isString;



async function $7cf235746b012c49$var$asyncFunction() {
// NOOP
}
const $7cf235746b012c49$export$cb6ddc2b23bc63b2 = $7cf235746b012c49$var$asyncFunction.constructor;
class $7cf235746b012c49$export$9f655837307f39c8 {
    static isInstanceOf(instance, ctor) {
        if (instance === undefined || instance === null) return false;
        return instance.constructor === ctor;
    }
    static getName(value) {
        if (value) {
            const name = value.name;
            if (name) return name;
            const ctor = value.constructor;
            if (ctor) return ctor.name;
        }
        return undefined;
    }
    static isArray(value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($0222e83d73c8b1f6$exports)))(value);
    }
    static isFunction(value) {
        if (value) {
            const ctor = value.constructor;
            return ctor === Function || ctor === $7cf235746b012c49$export$cb6ddc2b23bc63b2;
        }
        return false;
    }
    static isSyncFunction(value) {
        if (value) return value.constructor === Function;
        return false;
    }
    static isAsyncFunction(value) {
        if (value) return value.constructor === $7cf235746b012c49$export$cb6ddc2b23bc63b2;
        return false;
    }
    static getType(item) {
        if (item !== undefined && item !== null) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($16fa8ba01192b4c0$exports)))(item)) return String;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($37811de5ea7fe4ba$exports)))(item)) return Number;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($46df106f4bdb7fb2$exports)))(item)) return Boolean;
        }
        return undefined;
    }
    static getArrayType(array) {
        if (array && array.length > 0) for (const item of array){
            if (item) return $7cf235746b012c49$export$9f655837307f39c8.getType(item);
        }
        return undefined;
    }
    static toUnknown(value, clazz) {
        if (value === undefined && value === null) return undefined;
        if (!clazz) return value;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($37811de5ea7fe4ba$exports)))(value)) {
            if (clazz === Number) return value;
            if (clazz === String) return String(value);
            if (clazz === Boolean) return value !== 0;
            return value;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($16fa8ba01192b4c0$exports)))(value)) {
            if (clazz === String) return value;
            const s = value;
            if (clazz === Number) return s.includes('.') ? Number.parseFloat(s) : Number.parseInt(s);
            if (clazz === Boolean) return 'true' === s;
            return s;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($46df106f4bdb7fb2$exports)))(value)) {
            if (clazz === Boolean) return value;
            const b = value;
            if (clazz === Number) return b ? 1 : 0;
            if (clazz === String) return b ? 'true' : 'false';
            return b;
        }
        return value;
    }
    static toString(value, defaultValue) {
        if (value !== null && value !== undefined) {
            const v = $7cf235746b012c49$export$9f655837307f39c8.toUnknown(value, String);
            return v === null || v === undefined ? defaultValue : v;
        }
        return defaultValue;
    }
    static toNumber(value, defaultValue) {
        if (value !== null && value !== undefined) {
            const v = $7cf235746b012c49$export$9f655837307f39c8.toUnknown(value, Number);
            return v === null || v === undefined ? defaultValue : v;
        }
        return defaultValue;
    }
    static toBoolean(value, defaultValue) {
        if (value) {
            const v = $7cf235746b012c49$export$9f655837307f39c8.toUnknown(value, Boolean);
            return v === null || v === undefined ? defaultValue : v;
        }
        return defaultValue;
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 
const $b2874cb6e934257b$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('SingletonServices');
const $b2874cb6e934257b$var$availableServiceMap = new Map();
const $b2874cb6e934257b$var$serviceStack = [];
let $b2874cb6e934257b$var$runBootstrap = $b2874cb6e934257b$var$doBootstrap;
async function $b2874cb6e934257b$var$noopBootstrap() {
    $b2874cb6e934257b$var$LOG.info('Initialized');
}
async function $b2874cb6e934257b$var$doBootstrap() {
    const failed = [];
    for (const service of $b2874cb6e934257b$var$availableServiceMap.keys()){
        if (!service.initialized) try {
            await service.postConstruct();
            $b2874cb6e934257b$var$serviceStack.push(service);
            $b2874cb6e934257b$var$LOG.debug(`${service.name} succesfully initialized`);
        } catch (caught) {
            $b2874cb6e934257b$var$LOG.error(`${service.name} failed to initialize`, caught);
            failed.push(service.name);
        }
    }
    //
    if (failed.length === 0) {
        $b2874cb6e934257b$var$runBootstrap = $b2874cb6e934257b$var$noopBootstrap;
        $b2874cb6e934257b$var$noopBootstrap();
    } else $b2874cb6e934257b$var$LOG.warn(`Initialized but some services failed: ${failed.join('; ')}.`);
}
async function $b2874cb6e934257b$var$startServices() {
    await $b2874cb6e934257b$var$runBootstrap();
}
async function $b2874cb6e934257b$var$stopServices() {
    let service = $b2874cb6e934257b$var$serviceStack.shift();
    while(service){
        if (service.initialized) try {
            await service.preDestroy();
        } catch (caught) {
            $b2874cb6e934257b$var$LOG.error(`Unexpected error destroying service ${service.name}`, caught);
        }
        service = $b2874cb6e934257b$var$serviceStack.shift();
    }
    $b2874cb6e934257b$var$runBootstrap = $b2874cb6e934257b$var$doBootstrap;
    $b2874cb6e934257b$var$LOG.info('Finalized');
}
let $b2874cb6e934257b$var$startCount = 0;
const $b2874cb6e934257b$export$962600625ce79e2e = {
    add (service) {
        // Map preserves order
        if (!$b2874cb6e934257b$var$availableServiceMap.has(service)) $b2874cb6e934257b$var$availableServiceMap.set(service, true);
    },
    async remove (service) {
        if ($b2874cb6e934257b$var$availableServiceMap.delete(service) && service.initialized) try {
            await service.preDestroy();
        } catch (caught) {
            $b2874cb6e934257b$var$LOG.error(`Unexpected error destroying service ${service.name}`, caught);
        }
    },
    async start () {
        try {
            await $b2874cb6e934257b$var$startServices();
        } catch (caught) {
            $b2874cb6e934257b$var$LOG.error('Starting', caught);
        }
        $b2874cb6e934257b$var$startCount++;
        return $b2874cb6e934257b$export$962600625ce79e2e.stop;
    },
    async stop () {
        if ($b2874cb6e934257b$var$startCount > 0) {
            $b2874cb6e934257b$var$startCount--;
            if ($b2874cb6e934257b$var$startCount === 0) await $b2874cb6e934257b$var$stopServices();
        }
    }
};


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ const $6ac1f5c10c6d09e1$var$indexGenMap = new Map();
class $6ac1f5c10c6d09e1$export$2f77e7adfbeab348 {
    static creator(ctor, places, name) {
        return (path, parent)=>{
            return places[name] = $6ac1f5c10c6d09e1$export$2f77e7adfbeab348.create(path, ctor, parent);
        };
    }
    static createDetached(name) {
        return new $6ac1f5c10c6d09e1$export$2f77e7adfbeab348(name, undefined, undefined, -1);
    }
    static create(name, ctor, parent) {
        return new $6ac1f5c10c6d09e1$export$2f77e7adfbeab348(name, parent ?? $6ac1f5c10c6d09e1$export$2f77e7adfbeab348.ROOT, ctor);
    }
    static{
        this.UNKNOWN = $6ac1f5c10c6d09e1$export$2f77e7adfbeab348.createDetached('unknown');
    }
    static{
        this.ROOT = $6ac1f5c10c6d09e1$export$2f77e7adfbeab348.createDetached('/');
    }
    constructor(name, parent, presenterCtor, id){
        this.name = name;
        this.parent = parent;
        this.presenterCtor = presenterCtor;
        this.path = [];
        this.id = typeof id === 'number' ? id : this.nextId();
        if (parent) {
            const pathNameBuilder = [];
            this.buildPath(pathNameBuilder, this);
            this.pathName = pathNameBuilder.join('/');
        } else {
            this.pathName = name;
            this.path.push(this);
        }
    }
    toString() {
        return this.pathName;
    }
    contains(other) {
        for(let i = 0; i < other.path.length; i++){
            const a = this.path[i];
            const b = other.path[i];
            if (a !== b) return false;
        }
        return true;
    }
    buildPath(pathNameBuilder, step) {
        if (step.parent) this.buildPath(pathNameBuilder, step.parent);
        if (step && step.id != -1) {
            pathNameBuilder.push(step.name);
            this.path.push(step);
        }
    }
    nextId() {
        let idxLevelGen = $6ac1f5c10c6d09e1$var$indexGenMap.get(this.path.length);
        if (idxLevelGen === undefined) idxLevelGen = this.path.length * 1000;
        else idxLevelGen++;
        $6ac1f5c10c6d09e1$var$indexGenMap.set(this.path.length, idxLevelGen);
        return idxLevelGen;
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 

/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ const $10ea1d39b779f060$var$UTF8_ENCODER = new TextEncoder();
const $10ea1d39b779f060$var$UTF8_DECODER = new TextDecoder('utf-8');
const $10ea1d39b779f060$var$ASCII_DECODER = new TextDecoder('ascii');
class $10ea1d39b779f060$var$AsciiCharset {
    encode(value) {
        const bytes = new Uint8Array(value.length);
        for(let i = 0; i < value.length; i++)bytes[i] = value.charCodeAt(i);
        return bytes;
    }
    decode(value) {
        return $10ea1d39b779f060$var$ASCII_DECODER.decode(value);
    }
}
class $10ea1d39b779f060$var$Utf8Charset {
    encode(value) {
        return $10ea1d39b779f060$var$UTF8_ENCODER.encode(value);
    }
    decode(value) {
        return $10ea1d39b779f060$var$UTF8_DECODER.decode(value);
    }
}
class $10ea1d39b779f060$export$86eec9f35a2cd442 {
    static{
        this.ASCII = new $10ea1d39b779f060$var$AsciiCharset();
    }
    static{
        this.UTF_8 = new $10ea1d39b779f060$var$Utf8Charset();
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 

class $925c6326a40ae566$export$409ca641343f1a97 {
    /**
     * Append request parameters from the specified String to the specified Map. It is presumed that the specified Map is not accessed from any other thread, so no synchronization
     * is performed.
     * <p>
     * <strong>IMPLEMENTATION NOTE</strong>: URL decoding is performed individually on the parsed name and value elements, rather than on the entire query string ahead of time, to
     * properly deal with the case where the name or value includes an encoded "=" or "&" character that would otherwise be interpreted as a delimiter.
     *
     * @param params
     *            Map that accumulates the resulting parameters
     * @param data
     *            Input string containing request parameters
     *
     * @exception IllegalArgumentException
     *                if the data is bad-formed
     */ static parse(params, data, encoding) {
        if (data != null && data.length > 0) {
            // use the specified encoding to extract bytes out of the
            // given string so that the encoding is not lost. If an
            // encoding is not specified, let it use platform default
            const bytes = encoding != null ? encoding.encode(data) : (0, $10ea1d39b779f060$export$86eec9f35a2cd442).ASCII.encode(data);
            this.parseParameters(params, bytes, encoding);
        }
    }
    /**
     * Convert a byte character value to hex-decimal digit value.
     *
     * @param b
     *            the character value byte
     */ static convertHexDigit(b) {
        if (b >= 48 && b <= 57) return b - 48 | 0;
        if (b >= 97 && b <= 102) return b - 97 + 10 | 0;
        if (b >= 65 && b <= 70) return b - 65 + 10 | 0;
        return 0;
    }
    /**
     * Put name and value pair in map. When name already exist, add value to array of values.
     *
     * @param uri
     *            The map to populate
     * @param params
     *            The parameter map
     * @param value
     *            The parameter value
     */ static putMapEntry(params, name, value) {
        const oldValue = params.get(name);
        if (oldValue === undefined || oldValue === null) params.set(name, value);
        else if ((0, $7cf235746b012c49$export$9f655837307f39c8).isArray(oldValue)) {
            const array = oldValue;
            array.push((0, $7cf235746b012c49$export$9f655837307f39c8).toUnknown(value, (0, $7cf235746b012c49$export$9f655837307f39c8).getArrayType(array)));
        } else {
            const array = new Array(2);
            array[0] = oldValue;
            array[1] = (0, $7cf235746b012c49$export$9f655837307f39c8).toUnknown(value, (0, $7cf235746b012c49$export$9f655837307f39c8).getType(oldValue));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            params.set(name, array);
        }
    }
    /**
     * Append request parameters from the specified String to the specified Map. It is presumed that the specified Map is not accessed from any other thread, so no synchronization
     * is performed.
     * <p>
     * <strong>IMPLEMENTATION NOTE</strong>: URL decoding is performed individually on the parsed name and value elements, rather than on the entire query string ahead of time, to
     * properly deal with the case where the name or value includes an encoded "=" or "&" character that would otherwise be interpreted as a delimiter.
     *
     * NOTE: byte array data is modified by this method. Caller beware.
     *
     * @param uri
     *            Map that accumulates the resulting parameters
     * @param data
     *            Input string containing request parameters
     * @param encoding
     *            Encoding to use for converting hex
     *
     * @exception UnsupportedEncodingException
     *                if the data is malformed
     */ static parseParameters(params, data, encoding) {
        if (data != null && data.length > 0) {
            let ix = 0;
            let ox = 0;
            let key = null;
            let value = null;
            while(ix < data.length){
                const c = data[ix++];
                switch(String.fromCharCode(c)){
                    case '&':
                        value = encoding.decode(data.subarray(0, ox));
                        if (key != null) {
                            this.putMapEntry(params, key, value);
                            key = null;
                        }
                        ox = 0;
                        break;
                    case '=':
                        if (key == null) {
                            key = encoding.decode(data.subarray(0, ox));
                            ox = 0;
                        } else data[ox++] = c;
                        break;
                    case '+':
                        data[ox++] = 32;
                        break;
                    case '%':
                        data[ox++] = (this.convertHexDigit(data[ix++]) << 4) + this.convertHexDigit(data[ix++]);
                        break;
                    default:
                        data[ox++] = c;
                }
            }
            // The last value does not end in '&'. So save it now.
            if (key != null) {
                value = encoding.decode(data.subarray(0, ox));
                this.putMapEntry(params, key, value);
            }
        }
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 
class $f1228ad0b1ba6df8$export$cc4cb4e4da24ef3b extends Object {
    appendValue(name, value) {
        const svalue = (0, $7cf235746b012c49$export$9f655837307f39c8).toString(value, undefined);
        if (svalue && svalue.length > 0) {
            if (this.query.length > 0) this.query.push('&');
            this.query.push(name);
            this.query.push('=');
            this.query.push(encodeURI(svalue.replace(/ /g, '+')));
        }
        return this;
    }
    append(parameters) {
        for (const [name, value] of parameters)if ((0, $7cf235746b012c49$export$9f655837307f39c8).isArray(value)) {
            const valueArray = value;
            for (const valueItem of valueArray)this.appendValue(name, valueItem);
        } else this.appendValue(name, value);
        return this;
    }
    toString() {
        return this.query.join('');
    }
    constructor(...args){
        super(...args), this.query = [];
    }
}



class $53ed881bf0c83c14$export$a6315278596fdad3 extends Object {
    static parse(placeStr, stepProvider = (0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).createDetached) {
        // If we have a not blank Intent, then we will proceed with Intent parsing
        if (placeStr && placeStr.length > 0) {
            // First, we are going to brake the Intent into two parts
            const parts = placeStr.split(/\?/);
            const step = stepProvider(parts[0]);
            const intent = new $53ed881bf0c83c14$export$a6315278596fdad3(step);
            if (parts.length > 1) (0, $925c6326a40ae566$export$409ca641343f1a97).parse(intent.parameters, parts[1], (0, $10ea1d39b779f060$export$86eec9f35a2cd442).UTF_8);
            return intent;
        } else return new $53ed881bf0c83c14$export$a6315278596fdad3((0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).UNKNOWN);
    }
    constructor(step){
        super();
        this.place = step;
        this.parameters = new Map();
        this.attributes = new Map();
    }
    redirect(place) {
        const other = new $53ed881bf0c83c14$export$a6315278596fdad3(place);
        other.copyParametersFromIntent(this);
        other.copyAttributesFromIntent(this);
        return other;
    }
    copyParametersFromIntent(source) {
        if (source) source.parameters.forEach((val, key)=>this.parameters.set(key, val));
    }
    copyAttributesFromIntent(source) {
        if (source) source.attributes.forEach((val, key)=>this.attributes.set(key, val));
    }
    populateAttributes(source) {
        if (source) source.forEach((val, key)=>this.attributes.set(key, val));
    }
    getParameterRawValue(name) {
        return this.parameters.get(name);
    }
    /**
     * <p>
     * Returns the value of a request parameter, or null if the parameter does not exist.
     * </p>
     * <p>
     * If you use this method with a multivalued parameter, the value returned is equal to the first value in the array.
     * </p>
     *
     * @param name
     *            a String specifying the name of the parameter
     * @return a Object representing the value of the parameter
     */ getParameterValue(name) {
        const value = this.parameters.get(name);
        if ((0, $7cf235746b012c49$export$9f655837307f39c8).isArray(value)) return value[0];
        else return value;
    }
    /**
     * <p>
     * Returns the value array of a request parameter, or undefined if the parameter does not exist.
     * </p>
     *
     * @param name
     *            a String specifying the name of the parameter
     * @return a Object representing the value of the parameter
     */ getParameterValues(name) {
        const value = this.parameters.get(name);
        if (value === undefined || value === null) return [];
        if ((0, $7cf235746b012c49$export$9f655837307f39c8).isArray(value)) return value;
        return [
            value
        ];
    }
    /**
     * <p>
     * Returns the value of a request parameter as String, or undefined if the parameter does not exist.
     * </p>
     * <p>
     * You should only use this method when you are sure the parameter has only one value. If the parameter might have more than one value, use
     * getParameterValues(name: string).
     * </p>
     * <p>
     * If you use this method with a multivalued parameter, the value returned is equal to the first value in the array.
     * </p>
     *
     * @param name
     *            a String specifying the name of the parameter
     * @return a String representing the single value of the parameter
     */ getParameterAsString(name) {
        const value = this.getParameterValue(name);
        return (0, $7cf235746b012c49$export$9f655837307f39c8).toString(value);
    }
    /**
     * <p>
     * Returns the value of a request parameter as String, or undefined if the parameter does not exist.
     * </p>
     * <p>
     * You should only use this method when you are sure the parameter has only one value. If the parameter might have more than one value, use
     * getParameterValues(name: string).
     * </p>
     * <p>
     * If you use this method with a multivalued parameter, the value returned is equal to the first value in the array.
     * </p>
     *
     * @param name
     *            a String specifying the name of the parameter
     * @param defaultValue
     *            a default value to be returned case current value is null
     * @return a String representing the single value of the parameter
     */ getParameterAsStringOrDefault(name, defaultValue) {
        const value = this.getParameterValue(name);
        return (0, $7cf235746b012c49$export$9f655837307f39c8).toString(value, defaultValue);
    }
    /**
     * <p>
     * Returns the value of a request parameter as a Number, or null if the parameter does not exist.
     * </p>
     * <p>
     * You should only use this method when you are sure the parameter has only one value. If the parameter might have more than one value, use
     * getParameterValues(name: string).
     * </p>
     * <p>
     * If you use this method with a multivalued parameter, the value returned is equal to the first value in the array.
     * </p>
     *
     * @param name
     *            a String specifying the name of the parameter
     * @return a String representing the single value of the parameter
     */ getParameterAsNumber(name) {
        const value = this.getParameterValue(name);
        return (0, $7cf235746b012c49$export$9f655837307f39c8).toNumber(value);
    }
    /**
     * <p>
     * Returns the value of a request parameter as a Number, or null if the parameter does not exist.
     * </p>
     * <p>
     * You should only use this method when you are sure the parameter has only one value. If the parameter might have more than one value, use
     * getParameterValues(name: string).
     * </p>
     * <p>
     * If you use this method with a multivalued parameter, the value returned is equal to the first value in the array.
     * </p>
     *
     * @param name
     *            a String specifying the name of the parameter
     * @param defaultValue
     *            a default value to be returned case current value is null or a invalid conversion
     * @return a String representing the single value of the parameter
     */ getParameterAsNumberOrDefault(name, defaultValue) {
        const value = this.getParameterValue(name);
        return (0, $7cf235746b012c49$export$9f655837307f39c8).toNumber(value, defaultValue);
    }
    /**
     * <p>
     * Returns the value of a request parameter as a Boolean, or null if the parameter does not exist.
     * </p>
     * <p>
     * You should only use this method when you are sure the parameter has only one value. If the parameter might have more than one value, use
     * getParameterValues(name: string).
     * </p>
     * <p>
     * If you use this method with a multivalued parameter, the value returned is equal to the first value in the array.
     * </p>
     *
     * @param name
     *            a String specifying the name of the parameter
     * @return a String representing the single value of the parameter
     */ getParameterAsBoolean(name) {
        const value = this.getParameterValue(name);
        return (0, $7cf235746b012c49$export$9f655837307f39c8).toBoolean(value);
    }
    /**
     * <p>
     * Returns the value of a request parameter as a Boolean, or null if the parameter does not exist.
     * </p>
     * <p>
     * You should only use this method when you are sure the parameter has only one value. If the parameter might have more than one value, use
     * getParameterValues(name: string).
     * </p>
     * <p>
     * If you use this method with a multivalued parameter, the value returned is equal to the first value in the array.
     * </p>
     *
     * @param name
     *            a String specifying the name of the parameter
     * @param defaultValue
     *            a default value to be returned case current value is null or a invalid conversion
     * @return a String representing the single value of the parameter
     */ getParameterAsBooleanOrDefault(name, defaultValue) {
        const value = this.getParameterValue(name);
        return (0, $7cf235746b012c49$export$9f655837307f39c8).toBoolean(value, defaultValue);
    }
    /**
     * Sets or replace a parameter value. Parameters will became part of the hash token in the history. Be careful and choose short form for names and values.
     *
     * @param name
     *            a String specifying the name of the parameter
     * @param value
     *            a a value of this parameter
     */ setParameter(name, value) {
        if (value === undefined || value === null) this.parameters.delete(name);
        else this.parameters.set(name, value);
    }
    /**
     * Returns the query string that is contained in the request path after the path walking.
     *
     * @return a String containing the query string.
     */ getQueryString() {
        if (this.parameters.size === 0) return '';
        return new (0, $f1228ad0b1ba6df8$export$cc4cb4e4da24ef3b)().append(this.parameters).toString();
    }
    toString() {
        const queryString = this.getQueryString();
        if (queryString && queryString.length > 0) return this.place.name + '?' + queryString;
        else return this.place.name;
    }
    setScopeSlot(slotId, slot) {
        if (slot) this.attributes.set(slotId, slot);
        else this.attributes.delete(slotId);
    }
    getScopeSlot(slotId) {
        const slot = this.attributes.get(slotId);
        if (slot) return slot;
        else return 0, $5e892709dbe5636f$export$49db20642bd540b0;
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ /* eslint-disable @typescript-eslint/no-unused-vars */ class $f58fa20fe931da1b$export$9572cf7a37405cc {
    static{
        this.NOOP = new $f58fa20fe931da1b$export$9572cf7a37405cc();
    }
    get location() {
        return '';
    }
    update(app, place) {
    // NOOP
    }
    addChangeListener(listener) {
        const listenerId = this.__listenerIdGen++;
        this.__changeListenerMap.set(listenerId, listener);
        return ()=>{
            this.__changeListenerMap.delete(listenerId);
        };
    }
    notifyChanges() {
        if (this.__changeListenerMap.size > 0) for (const listener of this.__changeListenerMap.values())listener(this);
    }
    constructor(){
        this.__changeListenerMap = new Map();
        this.__listenerIdGen = 0;
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ /**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ var $3a2d755df4c00d46$exports = {};

var $1f672fed7efed57e$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1f672fed7efed57e$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$1f672fed7efed57e$exports = $1f672fed7efed57e$var$isObject;


/** `Object#toString` result references. */ var $3a2d755df4c00d46$var$asyncTag = '[object AsyncFunction]', $3a2d755df4c00d46$var$funcTag = '[object Function]', $3a2d755df4c00d46$var$genTag = '[object GeneratorFunction]', $3a2d755df4c00d46$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3a2d755df4c00d46$var$isFunction(value) {
    if (!$1f672fed7efed57e$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a417b04763129f1c$exports(value);
    return tag == $3a2d755df4c00d46$var$funcTag || tag == $3a2d755df4c00d46$var$genTag || tag == $3a2d755df4c00d46$var$asyncTag || tag == $3a2d755df4c00d46$var$proxyTag;
}
$3a2d755df4c00d46$exports = $3a2d755df4c00d46$var$isFunction;


function $72d46edaac805a45$export$31eb53bd5b582a97() {
    return function(target, propertyKey, descriptor) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(descriptor.value)) {
            const instrumentedMethod = $72d46edaac805a45$var$actionFn(descriptor.value);
            Object.defineProperty(instrumentedMethod, 'name', {
                value: propertyKey + '_action',
                configurable: true
            });
            descriptor.value = instrumentedMethod;
        }
    };
}
function $72d46edaac805a45$var$actionFn(impl) {
    function onCatch(caught) {
        this.unexpected(`During execution of ${impl.name} action`, caught);
    }
    function onFinally() {
        const updateManager = this.updateManager;
        if (updateManager.isAutoUpdateEnabled()) {
            this.updateIfNotDirty(this.scope);
            updateManager.emitBeforeScopeUpdate();
        }
        this.updateHistory();
    }
    return function(...args) {
        try {
            const result = impl.call(this, ...args);
            // Result is a valid promise
            if (result && result.catch && result.finally) return result.catch(onCatch.bind(this)).finally(onFinally.bind(this));
            else {
                onFinally.call(this);
                return result;
            }
        } catch (caught) {
            // Will only be actioned on sincronus actions
            onCatch.call(this, caught);
            return Promise.resolve(void 0);
        }
    };
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ const $5d20d4717b59b132$var$COPY_INITIAL_VALUES_ACTION = Symbol('wdc-cube:initializeValues');
function $5d20d4717b59b132$export$77cea355fa80b5f4(ctor) {
    let init = (prototype, fields)=>{
        const actions = [];
        for(let index = 0; index < fields.length; index++){
            const field = fields[index];
            Reflect.defineProperty(prototype, field.key, $5d20d4717b59b132$var$buildObservedProperty(field.key));
            actions.push(`const v${index} = this.${field.key};`);
            actions.push(`Reflect.deleteProperty(this, '${field.key}');`);
            actions.push(`this.${field.key} = v${index};`);
        }
        const copyInitialValuesAction = new Function(actions.join('\n'));
        prototype[$5d20d4717b59b132$var$COPY_INITIAL_VALUES_ACTION] = copyInitialValuesAction;
        init = ()=>copyInitialValuesAction;
        return copyInitialValuesAction;
    };
    const observableScopeClass = class extends ctor {
        constructor(...args){
            super(...args);
            const me = this;
            const fields = me[$5d20d4717b59b132$export$77cea355fa80b5f4.PROPERTY_OBSERVERS_METADATA];
            if (fields) {
                const copyInitialValues = init(observableScopeClass.prototype, fields);
                copyInitialValues.call(this);
            }
        }
    };
    Reflect.defineProperty(observableScopeClass, 'name', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: `Observable${ctor.name}`
    });
    return observableScopeClass;
}
$5d20d4717b59b132$export$77cea355fa80b5f4.PROPERTY_OBSERVERS_METADATA = Symbol('wdc-cube:scope_observers');
function $5d20d4717b59b132$var$buildObservedProperty(key) {
    const privateKey = Symbol(key);
    return {
        configurable: false,
        enumerable: true,
        get: function() {
            return this[privateKey];
        },
        set: function(newValue) {
            if (this[privateKey] !== newValue) {
                this[privateKey] = newValue;
                const scope = this;
                scope.update(scope);
            }
        }
    };
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ /*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $95b38f85a298c7da$var$Reflect;
(function(Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function(factory) {
        var root = typeof globalThis === "object" ? globalThis : typeof $parcel$global === "object" ? $parcel$global : typeof self === "object" ? self : typeof this === "object" ? this : sloppyModeThis();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect !== "undefined") exporter = makeExporter(root.Reflect, exporter);
        factory(exporter, root);
        if (typeof root.Reflect === "undefined") root.Reflect = Reflect;
        function makeExporter(target, previous) {
            return function(key, value) {
                Object.defineProperty(target, key, {
                    configurable: true,
                    writable: true,
                    value: value
                });
                if (previous) previous(key, value);
            };
        }
        function functionThis() {
            try {
                return Function("return this;")();
            } catch (_) {}
        }
        function indirectEvalThis() {
            try {
                return (0, eval)("(function() { return this; })()");
            } catch (_) {}
        }
        function sloppyModeThis() {
            return functionThis() || indirectEvalThis();
        }
    })(function(exporter, root) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = ({
            __proto__: []
        }) instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate ? function() {
                return MakeDictionary(Object.create(null));
            } : supportsProto ? function() {
                return MakeDictionary({
                    __proto__: null
                });
            } : function() {
                return MakeDictionary({});
            },
            has: downLevel ? function(map, key) {
                return hasOwn.call(map, key);
            } : function(map, key) {
                return key in map;
            },
            get: downLevel ? function(map, key) {
                return hasOwn.call(map, key) ? map[key] : undefined;
            } : function(map, key) {
                return map[key];
            }
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var _Map = typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        var registrySymbol = supportsSymbol ? Symbol.for("@reflect-metadata:registry") : undefined;
        var metadataRegistry = GetOrCreateMetadataRegistry();
        var metadataProvider = CreateMetadataProvider(metadataRegistry);
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */ function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsObject(target)) throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes)) throw new TypeError();
                if (IsNull(attributes)) attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            } else {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsConstructor(target)) throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */ function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target)) throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey)) throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */ function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */ function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */ function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            var provider = GetMetadataProvider(target, propertyKey, /*Create*/ false);
            if (IsUndefined(provider)) return false;
            return provider.OrdinaryDeleteMetadata(metadataKey, target, propertyKey);
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated)) throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated)) throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var provider = GetMetadataProvider(O, P, /*Create*/ false);
            if (IsUndefined(provider)) return false;
            return ToBoolean(provider.OrdinaryHasOwnMetadata(MetadataKey, O, P));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var provider = GetMetadataProvider(O, P, /*Create*/ false);
            if (IsUndefined(provider)) return;
            return provider.OrdinaryGetOwnMetadata(MetadataKey, O, P);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var provider = GetMetadataProvider(O, P, /*Create*/ true);
            provider.OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null) return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0) return ownKeys;
            if (ownKeys.length <= 0) return parentKeys;
            var set = new _Set();
            var keys = [];
            for(var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++){
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for(var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++){
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var provider = GetMetadataProvider(O, P, /*create*/ false);
            if (!provider) return [];
            return provider.OrdinaryOwnMetadataKeys(O, P);
        }
        // 6 ECMAScript Data Types and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null) return 1 /* Null */ ;
            switch(typeof x){
                case "undefined":
                    return 0 /* Undefined */ ;
                case "boolean":
                    return 2 /* Boolean */ ;
                case "string":
                    return 3 /* String */ ;
                case "symbol":
                    return 4 /* Symbol */ ;
                case "number":
                    return 5 /* Number */ ;
                case "object":
                    return x === null ? 1 /* Null */  : 6 /* Object */ ;
                default:
                    return 6 /* Object */ ;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch(Type(input)){
                case 0 /* Undefined */ :
                    return input;
                case 1 /* Null */ :
                    return input;
                case 2 /* Boolean */ :
                    return input;
                case 3 /* String */ :
                    return input;
                case 4 /* Symbol */ :
                    return input;
                case 5 /* Number */ :
                    return input;
            }
            var hint = PreferredType === 3 /* String */  ? "string" : PreferredType === 5 /* Number */  ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result)) throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result)) return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
            } else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result)) return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */ );
            if (IsSymbol(key)) return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray ? Array.isArray(argument) : argument instanceof Object ? argument instanceof Array : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch(Type(argument)){
                case 3 /* String */ :
                    return true;
                case 4 /* Symbol */ :
                    return true;
                default:
                    return false;
            }
        }
        function SameValueZero(x, y) {
            return x === y || x !== x && y !== y;
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null) return undefined;
            if (!IsCallable(func)) throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method)) throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator)) throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f) f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype) return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype) return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype) return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function") return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O) return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // Global metadata registry
        // - Allows `import "reflect-metadata"` and `import "reflect-metadata/no-conflict"` to interoperate.
        // - Uses isolated metadata if `Reflect` is frozen before the registry can be installed.
        /**
         * Creates a registry used to allow multiple `reflect-metadata` providers.
         */ function CreateMetadataRegistry() {
            var fallback;
            if (!IsUndefined(registrySymbol) && typeof root.Reflect !== "undefined" && !(registrySymbol in root.Reflect) && typeof root.Reflect.defineMetadata === "function") // interoperate with older version of `reflect-metadata` that did not support a registry.
            fallback = CreateFallbackProvider(root.Reflect);
            var first;
            var second;
            var rest;
            var targetProviderMap = new _WeakMap();
            var registry = {
                registerProvider: registerProvider,
                getProvider: getProvider,
                setProvider: setProvider
            };
            return registry;
            function registerProvider(provider) {
                if (!Object.isExtensible(registry)) throw new Error("Cannot add provider to a frozen registry.");
                switch(true){
                    case fallback === provider:
                        break;
                    case IsUndefined(first):
                        first = provider;
                        break;
                    case first === provider:
                        break;
                    case IsUndefined(second):
                        second = provider;
                        break;
                    case second === provider:
                        break;
                    default:
                        if (rest === undefined) rest = new _Set();
                        rest.add(provider);
                        break;
                }
            }
            function getProviderNoCache(O, P) {
                if (!IsUndefined(first)) {
                    if (first.isProviderFor(O, P)) return first;
                    if (!IsUndefined(second)) {
                        if (second.isProviderFor(O, P)) return first;
                        if (!IsUndefined(rest)) {
                            var iterator = GetIterator(rest);
                            while(true){
                                var next = IteratorStep(iterator);
                                if (!next) return undefined;
                                var provider = IteratorValue(next);
                                if (provider.isProviderFor(O, P)) {
                                    IteratorClose(iterator);
                                    return provider;
                                }
                            }
                        }
                    }
                }
                if (!IsUndefined(fallback) && fallback.isProviderFor(O, P)) return fallback;
                return undefined;
            }
            function getProvider(O, P) {
                var providerMap = targetProviderMap.get(O);
                var provider;
                if (!IsUndefined(providerMap)) provider = providerMap.get(P);
                if (!IsUndefined(provider)) return provider;
                provider = getProviderNoCache(O, P);
                if (!IsUndefined(provider)) {
                    if (IsUndefined(providerMap)) {
                        providerMap = new _Map();
                        targetProviderMap.set(O, providerMap);
                    }
                    providerMap.set(P, provider);
                }
                return provider;
            }
            function hasProvider(provider) {
                if (IsUndefined(provider)) throw new TypeError();
                return first === provider || second === provider || !IsUndefined(rest) && rest.has(provider);
            }
            function setProvider(O, P, provider) {
                if (!hasProvider(provider)) throw new Error("Metadata provider not registered.");
                var existingProvider = getProvider(O, P);
                if (existingProvider !== provider) {
                    if (!IsUndefined(existingProvider)) return false;
                    var providerMap = targetProviderMap.get(O);
                    if (IsUndefined(providerMap)) {
                        providerMap = new _Map();
                        targetProviderMap.set(O, providerMap);
                    }
                    providerMap.set(P, provider);
                }
                return true;
            }
        }
        /**
         * Gets or creates the shared registry of metadata providers.
         */ function GetOrCreateMetadataRegistry() {
            var metadataRegistry;
            if (!IsUndefined(registrySymbol) && IsObject(root.Reflect) && Object.isExtensible(root.Reflect)) metadataRegistry = root.Reflect[registrySymbol];
            if (IsUndefined(metadataRegistry)) metadataRegistry = CreateMetadataRegistry();
            if (!IsUndefined(registrySymbol) && IsObject(root.Reflect) && Object.isExtensible(root.Reflect)) Object.defineProperty(root.Reflect, registrySymbol, {
                enumerable: false,
                configurable: false,
                writable: false,
                value: metadataRegistry
            });
            return metadataRegistry;
        }
        function CreateMetadataProvider(registry) {
            // [[Metadata]] internal slot
            // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
            var metadata = new _WeakMap();
            var provider = {
                isProviderFor: function(O, P) {
                    var targetMetadata = metadata.get(O);
                    if (IsUndefined(targetMetadata)) return false;
                    return targetMetadata.has(P);
                },
                OrdinaryDefineOwnMetadata: OrdinaryDefineOwnMetadata,
                OrdinaryHasOwnMetadata: OrdinaryHasOwnMetadata,
                OrdinaryGetOwnMetadata: OrdinaryGetOwnMetadata,
                OrdinaryOwnMetadataKeys: OrdinaryOwnMetadataKeys,
                OrdinaryDeleteMetadata: OrdinaryDeleteMetadata
            };
            metadataRegistry.registerProvider(provider);
            return provider;
            function GetOrCreateMetadataMap(O, P, Create) {
                var targetMetadata = metadata.get(O);
                var createdTargetMetadata = false;
                if (IsUndefined(targetMetadata)) {
                    if (!Create) return undefined;
                    targetMetadata = new _Map();
                    metadata.set(O, targetMetadata);
                    createdTargetMetadata = true;
                }
                var metadataMap = targetMetadata.get(P);
                if (IsUndefined(metadataMap)) {
                    if (!Create) return undefined;
                    metadataMap = new _Map();
                    targetMetadata.set(P, metadataMap);
                    if (!registry.setProvider(O, P, provider)) {
                        targetMetadata.delete(P);
                        if (createdTargetMetadata) metadata.delete(O);
                        throw new Error("Wrong provider for target.");
                    }
                }
                return metadataMap;
            }
            // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
            // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
            function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
                if (IsUndefined(metadataMap)) return false;
                return ToBoolean(metadataMap.has(MetadataKey));
            }
            // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
            // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
            function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
                if (IsUndefined(metadataMap)) return undefined;
                return metadataMap.get(MetadataKey);
            }
            // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
            // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
            function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
                metadataMap.set(MetadataKey, MetadataValue);
            }
            // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
            // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
            function OrdinaryOwnMetadataKeys(O, P) {
                var keys = [];
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
                if (IsUndefined(metadataMap)) return keys;
                var keysObj = metadataMap.keys();
                var iterator = GetIterator(keysObj);
                var k = 0;
                while(true){
                    var next = IteratorStep(iterator);
                    if (!next) {
                        keys.length = k;
                        return keys;
                    }
                    var nextValue = IteratorValue(next);
                    try {
                        keys[k] = nextValue;
                    } catch (e) {
                        try {
                            IteratorClose(iterator);
                        } finally{
                            throw e;
                        }
                    }
                    k++;
                }
            }
            function OrdinaryDeleteMetadata(MetadataKey, O, P) {
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
                if (IsUndefined(metadataMap)) return false;
                if (!metadataMap.delete(MetadataKey)) return false;
                if (metadataMap.size === 0) {
                    var targetMetadata = metadata.get(O);
                    if (!IsUndefined(targetMetadata)) {
                        targetMetadata.delete(P);
                        if (targetMetadata.size === 0) metadata.delete(targetMetadata);
                    }
                }
                return true;
            }
        }
        function CreateFallbackProvider(reflect) {
            var defineMetadata = reflect.defineMetadata, hasOwnMetadata = reflect.hasOwnMetadata, getOwnMetadata = reflect.getOwnMetadata, getOwnMetadataKeys = reflect.getOwnMetadataKeys, deleteMetadata = reflect.deleteMetadata;
            var metadataOwner = new _WeakMap();
            var provider = {
                isProviderFor: function(O, P) {
                    var metadataPropertySet = metadataOwner.get(O);
                    if (!IsUndefined(metadataPropertySet) && metadataPropertySet.has(P)) return true;
                    if (getOwnMetadataKeys(O, P).length) {
                        if (IsUndefined(metadataPropertySet)) {
                            metadataPropertySet = new _Set();
                            metadataOwner.set(O, metadataPropertySet);
                        }
                        metadataPropertySet.add(P);
                        return true;
                    }
                    return false;
                },
                OrdinaryDefineOwnMetadata: defineMetadata,
                OrdinaryHasOwnMetadata: hasOwnMetadata,
                OrdinaryGetOwnMetadata: getOwnMetadata,
                OrdinaryOwnMetadataKeys: getOwnMetadataKeys,
                OrdinaryDeleteMetadata: deleteMetadata
            };
            return provider;
        }
        /**
         * Gets the metadata provider for an object. If the object has no metadata provider and this is for a create operation,
         * then this module's metadata provider is assigned to the object.
         */ function GetMetadataProvider(O, P, Create) {
            var registeredProvider = metadataRegistry.getProvider(O, P);
            if (!IsUndefined(registeredProvider)) return registeredProvider;
            if (Create) {
                if (metadataRegistry.setProvider(O, P, metadataProvider)) return metadataProvider;
                throw new Error("Illegal state.");
            }
            return undefined;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ function() {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function() {
                    return this;
                };
                MapIterator.prototype[iteratorSymbol] = function() {
                    return this;
                };
                MapIterator.prototype.next = function() {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        } else this._index++;
                        return {
                            value: result,
                            done: false
                        };
                    }
                    return {
                        value: undefined,
                        done: true
                    };
                };
                MapIterator.prototype.throw = function(error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function(value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return {
                        value: value,
                        done: true
                    };
                };
                return MapIterator;
            }();
            var Map1 = /** @class */ function() {
                function Map1() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map1.prototype, "size", {
                    get: function() {
                        return this._keys.length;
                    },
                    enumerable: true,
                    configurable: true
                });
                Map1.prototype.has = function(key) {
                    return this._find(key, /*insert*/ false) >= 0;
                };
                Map1.prototype.get = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map1.prototype.set = function(key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map1.prototype.delete = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for(var i = index + 1; i < size; i++){
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (SameValueZero(key, this._cacheKey)) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map1.prototype.clear = function() {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map1.prototype.keys = function() {
                    return new MapIterator(this._keys, this._values, getKey);
                };
                Map1.prototype.values = function() {
                    return new MapIterator(this._keys, this._values, getValue);
                };
                Map1.prototype.entries = function() {
                    return new MapIterator(this._keys, this._values, getEntry);
                };
                Map1.prototype["@@iterator"] = function() {
                    return this.entries();
                };
                Map1.prototype[iteratorSymbol] = function() {
                    return this.entries();
                };
                Map1.prototype._find = function(key, insert) {
                    if (!SameValueZero(this._cacheKey, key)) {
                        this._cacheIndex = -1;
                        for(var i = 0; i < this._keys.length; i++)if (SameValueZero(this._keys[i], key)) {
                            this._cacheIndex = i;
                            break;
                        }
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map1;
            }();
            return Map1;
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [
                    key,
                    value
                ];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            var Set1 = /** @class */ function() {
                function Set1() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set1.prototype, "size", {
                    get: function() {
                        return this._map.size;
                    },
                    enumerable: true,
                    configurable: true
                });
                Set1.prototype.has = function(value) {
                    return this._map.has(value);
                };
                Set1.prototype.add = function(value) {
                    return this._map.set(value, value), this;
                };
                Set1.prototype.delete = function(value) {
                    return this._map.delete(value);
                };
                Set1.prototype.clear = function() {
                    this._map.clear();
                };
                Set1.prototype.keys = function() {
                    return this._map.keys();
                };
                Set1.prototype.values = function() {
                    return this._map.keys();
                };
                Set1.prototype.entries = function() {
                    return this._map.entries();
                };
                Set1.prototype["@@iterator"] = function() {
                    return this.keys();
                };
                Set1.prototype[iteratorSymbol] = function() {
                    return this.keys();
                };
                return Set1;
            }();
            return Set1;
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ function() {
                function WeakMap1() {
                    this._key = CreateUniqueKey();
                }
                WeakMap1.prototype.has = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap1.prototype.get = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap1.prototype.set = function(target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap1.prototype.delete = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap1.prototype.clear = function() {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap1;
            }();
            function CreateUniqueKey() {
                var key;
                do key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create) return undefined;
                    Object.defineProperty(target, rootKey, {
                        value: HashMap.create()
                    });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for(var i = 0; i < size; ++i)buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    var array = new Uint8Array(size);
                    if (typeof crypto !== "undefined") crypto.getRandomValues(array);
                    else if (typeof msCrypto !== "undefined") msCrypto.getRandomValues(array);
                    else FillRandomBytes(array, size);
                    return array;
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for(var offset = 0; offset < UUID_SIZE; ++offset){
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8) result += "-";
                    if (byte < 16) result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})($95b38f85a298c7da$var$Reflect || ($95b38f85a298c7da$var$Reflect = {}));



function $426b9d778cb7cf76$export$d1203567a167490e() {
    return (target, key)=>{
        if (typeof key !== 'string') return;
        const proto = target.constructor ? target.constructor.prototype : undefined;
        if (!proto) return;
        const type = Reflect.getMetadata('design:type', target, key);
        const properties = proto[(0, $5d20d4717b59b132$export$77cea355fa80b5f4).PROPERTY_OBSERVERS_METADATA];
        if (properties) properties.push({
            key: key,
            type: type
        });
        else proto[(0, $5d20d4717b59b132$export$77cea355fa80b5f4).PROPERTY_OBSERVERS_METADATA] = [
            {
                key: key,
                type: type
            }
        ];
    };
}




/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 
/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ class $aff1edd93ceffd77$export$69e1d4f9ece4135f {
    static naturalOrderForNumber(a, b) {
        return a - b;
    }
    static reverseOrderForNumber(a, b) {
        return b - a;
    }
}



/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 

/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 

/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 

/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 
const $7e405f4b90d74735$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('ChangeMonitor');
class $7e405f4b90d74735$export$e7322e4c1213c36c {
    static{
        this.INSTANCE = new $7e405f4b90d74735$export$e7322e4c1213c36c();
    }
    static singleton() {
        return $7e405f4b90d74735$export$e7322e4c1213c36c.INSTANCE;
    }
    constructor(){
        this.__errorCount = 0;
        this.__callbackMap = new Map();
        this.__onceCallbackMap = new Map();
    }
    bind(callback) {
        this.__callbackMap.set(callback, true);
        if (!this.__animationFrameHandler) this.launchAnimationFrame();
    }
    bindOnce(callback) {
        this.__onceCallbackMap.set(callback, true);
        this.launchAnimationFrame();
    }
    unbind(callback) {
        this.__callbackMap.delete(callback);
        this.__onceCallbackMap.delete(callback);
        if (this.__callbackMap.size === 0 && this.__onceCallbackMap.size === 0) this.clearAnimationFrame();
    }
    launchAnimationFrame() {
        if (!this.__animationFrameHandler && (this.__callbackMap.size > 0 || this.__onceCallbackMap.size > 0)) this.__animationFrameHandler = setTimeout(this.onFlush.bind(this), 16);
    }
    clearAnimationFrame() {
        if (this.__animationFrameHandler) {
            clearInterval(this.__animationFrameHandler);
            this.__animationFrameHandler = undefined;
        }
    }
    onFlush() {
        try {
            for (const callback of this.__callbackMap.keys())try {
                callback();
            } catch (caught) {
                if (this.__errorCount < 100) {
                    $7e405f4b90d74735$var$LOG.error('Updating frame - calling regular callback', caught);
                    this.__errorCount++;
                }
            }
            for (const callback of this.__onceCallbackMap.keys())try {
                callback();
            } catch (caught) {
                if (this.__errorCount < 100) {
                    $7e405f4b90d74735$var$LOG.error('Updating frame - calling once callback', caught);
                    this.__errorCount++;
                }
            }
        } finally{
            this.__onceCallbackMap.clear();
            this.__animationFrameHandler = undefined;
            this.launchAnimationFrame();
        }
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ /* eslint-disable @typescript-eslint/no-unused-vars */ function $911925771b3bcd65$export$4ebf98a2c576106f(me, fn) {
    const fnName = `${me.constructor.name}.${fn.name}`;
    const actionFn = function(...args) {
        let isNonPromise = true;
        try {
            const result = fn.call(me, ...args);
            if (result && result.catch && result.finally) {
                isNonPromise = false;
                const resultPromise = result;
                resultPromise.catch((e)=>$911925771b3bcd65$var$action_onCatch(me, fnName, e));
                resultPromise.finally(()=>$911925771b3bcd65$var$action_onFinally(me));
            }
            return result;
        } catch (e) {
            isNonPromise && $911925771b3bcd65$var$action_onCatch(me, fnName, e);
        } finally{
            isNonPromise && $911925771b3bcd65$var$action_onFinally(me);
        }
    };
    return actionFn;
}
// :: internal
function $911925771b3bcd65$var$action_onCatch(me, name, caught) {
    me.unexpected(`During execution of ${name} action`, caught);
}
function $911925771b3bcd65$var$action_onFinally(me) {
    const updateManager = me.updateManager;
    if (updateManager.isAutoUpdateEnabled()) {
        me.updateIfNotDirty(me.scope);
        updateManager.emitBeforeScopeUpdate();
    }
    me.updateHistory();
}


const $a25a305be2ca5b1d$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('Presenter');
// @Inject
const $a25a305be2ca5b1d$var$callbackManager = (0, $7e405f4b90d74735$export$e7322e4c1213c36c).singleton();
class $a25a305be2ca5b1d$export$893c88c42e3630f9 {
    constructor(owner, scope, updateManager){
        this.__updateCount = 0;
        this.__releasePhase = 0;
        this.update = this.doUpdate.bind(this);
        this.__owner = owner;
        this.__scope = scope;
        this.__beforeScopeUpdateListener = ()=>{
            try {
                this.onBeforeScopeUpdate();
            } finally{
                this.__updateCount = 0;
            }
        };
        if (updateManager) {
            this.__updateManagerOwner = false;
            this.__updateManager = updateManager;
            updateManager.hint(scope.constructor, updateManager.scope, 10);
        } else {
            this.__updateManagerOwner = true;
            this.__updateManager = new $a25a305be2ca5b1d$export$c17ff83d96d9111(scope);
        }
        this.__updateManager.addOnBeforeScopeUpdateListener(this.__beforeScopeUpdateListener);
        this.__updateManager.update(scope);
        this.__scope.update = this.update;
    }
    release() {
        try {
            this.__releasePhase = 1;
            this.__scope.update = (0, $5e892709dbe5636f$export$49db20642bd540b0);
            this.__scope.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
            if (this.__updateManagerOwner) this.__updateManager.release();
            else this.__updateManager.removeOnBeforeScopeUpdateListener(this.__beforeScopeUpdateListener);
        } finally{
            this.__releasePhase = 2;
        }
    }
    get isReleasing() {
        return this.__releasePhase === 1;
    }
    get isReleased() {
        return this.__releasePhase > 0;
    }
    get scope() {
        return this.__scope;
    }
    get owner() {
        return this.__owner;
    }
    get updateManager() {
        return this.__updateManager;
    }
    updateHistory() {
        this.__owner.updateHistory();
    }
    unexpected(message, error) {
        this.__owner.unexpected(message, error);
    }
    alert(severity, title, message, onClose) {
        this.__owner.alert(severity, title, message, onClose);
    }
    action(fn, owner = null) {
        return (0, $911925771b3bcd65$export$4ebf98a2c576106f)(this, owner ? fn.bind(owner) : fn.bind(this));
    }
    doUpdate(optionalScope) {
        this.__updateManager.update(optionalScope ?? this.scope);
        this.__updateCount++;
    }
    updateIfNotDirty(scope) {
        if (this.__updateCount === 0) this.doUpdate(scope);
    }
    onBeforeScopeUpdate() {
    // NOOP
    }
}
class $a25a305be2ca5b1d$export$c17ff83d96d9111 {
    static newUpdateRoot(scope) {
        var mgr = new $a25a305be2ca5b1d$export$c17ff83d96d9111(scope);
        return (optionalScope)=>mgr.update(optionalScope);
    }
    constructor(scope){
        this.__scopeUpdateFallback = new Map();
        this.__emitBeforeScopeUpdate = this.emitBeforeScopeUpdate.bind(this);
        this.__baseScopeUpdateRequested = false;
        this.__autoUpdateEnabled = true;
        this.__beforeScopeUpdateHandlerMap = new Map();
        this.__emittingOnBeforeScopeUpdate = false;
        this.__releasePhase = 0;
        this.update = (optionalScope)=>{
            if (!this.__baseScopeUpdateRequested) {
                const scope = optionalScope ?? this.__scope;
                if (scope === this.__scope) {
                    this.__baseScopeUpdateRequested = true;
                    this.__dirtyScopes.clear();
                    this.__cancelledScopes.clear();
                } else this.pushScope(this.__dirtyScopes, scope);
            }
            if (!this.__emittingOnBeforeScopeUpdate) $a25a305be2ca5b1d$var$callbackManager.bindOnce(this.__emitBeforeScopeUpdate);
        };
        this.__scope = scope;
        this.__dirtyScopes = new Map();
        this.__cancelledScopes = new Map();
    }
    release() {
        this.__releasePhase = 1;
        try {
            $a25a305be2ca5b1d$var$callbackManager.unbind(this.__emitBeforeScopeUpdate);
            this.__scope.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
            this.__beforeScopeUpdateHandlerMap.clear();
            this.__dirtyScopes.clear();
            this.__scopeUpdateFallback.clear();
        } finally{
            this.__releasePhase = 2;
        }
    }
    get isReleasing() {
        return this.__releasePhase === 1;
    }
    get isReleased() {
        return this.__releasePhase > 0;
    }
    get scope() {
        return this.__scope;
    }
    isDirty() {
        return this.__baseScopeUpdateRequested || this.__dirtyScopes.size > 0;
    }
    isAutoUpdateEnabled() {
        return this.__autoUpdateEnabled;
    }
    disableAutoUpdate() {
        this.__autoUpdateEnabled = false;
    }
    hint(scopeCtor, scope, maxUpdate = 10) {
        this.__scopeUpdateFallback.set(scopeCtor, {
            scope: scope,
            maxUpdate: maxUpdate
        });
    }
    removeUpdateHint(scopeCtor) {
        this.__scopeUpdateFallback.delete(scopeCtor);
    }
    addOnBeforeScopeUpdateListener(listener) {
        const count = this.__beforeScopeUpdateHandlerMap.get(listener);
        if (count === undefined) this.__beforeScopeUpdateHandlerMap.set(listener, 1);
        else this.__beforeScopeUpdateHandlerMap.set(listener, count + 1);
    }
    removeOnBeforeScopeUpdateListener(listener) {
        const count = this.__beforeScopeUpdateHandlerMap.get(listener);
        if (count != undefined && count > 0) {
            const nextCount = count - 1;
            if (nextCount === 0) this.__beforeScopeUpdateHandlerMap.delete(listener);
        }
    }
    emitBeforeScopeUpdate() {
        try {
            this.__emittingOnBeforeScopeUpdate = true;
            for (const listener of this.__beforeScopeUpdateHandlerMap.keys())try {
                listener();
            } catch (caught) {
                $a25a305be2ca5b1d$var$LOG.error('Running onBeforeScopeUpdate', caught);
            }
            if (this.__cancelledScopes.size > 0) {
                // Remove all cancelled scopes
                for (const key of this.__cancelledScopes.keys())this.__dirtyScopes.delete(key);
                this.__cancelledScopes.clear();
            }
            if (this.__baseScopeUpdateRequested || this.__dirtyScopes.size > 0) try {
                if (this.__baseScopeUpdateRequested) this.__scope.forceUpdate();
                else this.selectiveScopeUpdate();
            } catch (caught) {
                $a25a305be2ca5b1d$var$LOG.error('Updating dirty scopes', caught);
            } finally{
                this.__dirtyScopes.clear();
                this.__cancelledScopes.clear();
                this.__baseScopeUpdateRequested = false;
            }
        } finally{
            $a25a305be2ca5b1d$var$callbackManager.unbind(this.__emitBeforeScopeUpdate);
            this.__emittingOnBeforeScopeUpdate = false;
        }
    }
    selectiveScopeUpdate() {
        let updateCount = 0;
        let changesCount = 0;
        let sourceDirtyScopes = this.__dirtyScopes;
        do {
            changesCount = 0;
            if (sourceDirtyScopes.has(this.__scope.constructor)) {
                this.__scope.forceUpdate();
                updateCount++;
                break;
            } else {
                // If fallbacks were configured
                if (this.__scopeUpdateFallback.size > 0) {
                    const newDirtyScopes = new Map();
                    for (const [scopeCtor, scopeMap] of sourceDirtyScopes.entries()){
                        const scopeFallbackCfg = this.__scopeUpdateFallback.get(scopeCtor);
                        if (scopeFallbackCfg && scopeMap.size > scopeFallbackCfg.maxUpdate) {
                            scopeMap.clear();
                            scopeMap.set(scopeFallbackCfg.scope, true);
                            changesCount++;
                        }
                        newDirtyScopes.set(scopeCtor, scopeMap);
                    }
                    sourceDirtyScopes = newDirtyScopes;
                }
                if (changesCount === 0) {
                    for (const scopeMap of sourceDirtyScopes.values())for (const scope of scopeMap.keys()){
                        try {
                            scope.forceUpdate();
                        } catch (caught) {
                            $a25a305be2ca5b1d$var$LOG.info('scope.forceUpdate: ', scope, caught);
                        }
                        updateCount++;
                    }
                }
            }
        }while (changesCount > 0);
        return updateCount;
    }
    pushScope(target, scope) {
        const key = scope.constructor;
        let scopeMap = target.get(key);
        if (scopeMap) {
            const cfg = this.__scopeUpdateFallback.get(key);
            if (cfg && cfg.scope !== scope && scopeMap.size >= cfg.maxUpdate) {
                this.pushScope(target, cfg.scope);
                this.__cancelledScopes.set(key, true);
            } else scopeMap.set(scope, true);
        } else {
            scopeMap = new Map();
            scopeMap.set(scope, true);
            target.set(key, scopeMap);
        }
    }
}



const $cba1a0683916948c$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('CubePresenter');
const $cba1a0683916948c$export$e68a01be871b866f = {
    uninitialized: true,
    release: (0, $5e892709dbe5636f$export$49db20642bd540b0)
};
class $cba1a0683916948c$export$f73f61399fd7814 {
    constructor(app, scope){
        this.__updateCount = 0;
        this.__releasePhase = 0;
        this.update = this.doUpdate.bind(this);
        if ($cba1a0683916948c$export$e68a01be871b866f.uninitialized) {
            $cba1a0683916948c$export$e68a01be871b866f.release = this.internalRelease;
            $cba1a0683916948c$export$e68a01be871b866f.uninitialized = false;
        }
        this.__app = app;
        this.__scope = scope;
        this.__beforeScopeUpdateListener = ()=>{
            try {
                this.onBeforeScopeUpdate();
            } finally{
                this.__updateCount = 0;
            }
        };
        this.__updateManager = new (0, $a25a305be2ca5b1d$export$c17ff83d96d9111)(scope);
        this.__updateManager.addOnBeforeScopeUpdateListener(this.__beforeScopeUpdateListener);
        this.__updateManager.update(scope);
        this.__scope.update = this.update;
    }
    // :: IDisposable API
    internalRelease() {
        try {
            this.release();
        } finally{
            this.__releasePhase = 2;
        }
    }
    release() {
        this.__releasePhase = 1;
        this.__scope.update = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        this.__scope.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        this.__updateManager.release();
        this.__releasePhase = 2;
    }
    // :: IPresenter API
    get isReleasing() {
        return this.__releasePhase === 1;
    }
    get isReleased() {
        return this.__releasePhase > 0;
    }
    get scope() {
        return this.__scope;
    }
    get app() {
        return this.__app;
    }
    get updateManager() {
        return this.__updateManager;
    }
    unexpected(message, error) {
        this.__app.unexpected(message, error);
    }
    alert(severity, title, message, onClose) {
        this.__app.alert(severity, title, message, onClose);
    }
    action(fn, owner = null) {
        return (0, $911925771b3bcd65$export$4ebf98a2c576106f)(this, owner ? fn.bind(owner) : fn.bind(this));
    }
    doUpdate(optionalScope) {
        this.__updateManager.update(optionalScope ?? this.scope);
        this.__updateCount++;
    }
    updateIfNotDirty(scope) {
        if (this.__updateCount === 0) this.doUpdate(scope);
    }
    onBeforeScopeUpdate() {
    // NOOP
    }
    // :: ICubePresenter Api
    async applyParameters(intent, initialization, last) {
        $cba1a0683916948c$var$LOG.debug(`applyParameters(intent=${intent}, initialization=${initialization}, last=${last}`);
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    publishParameters(intent) {
    // NOOP
    }
    updateHistory() {
        this.__app.updateHistory();
    }
    async flip(place, args) {
        this.__app.flip(place, args);
    }
    async flipToIntent(intent) {
        this.__app.flipToIntent(intent);
    }
    async flipToIntentString(sIntent) {
        this.__app.flipToIntentString(sIntent);
    }
}


const $22ccdcdca8063d95$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('FlipContext');
class $22ccdcdca8063d95$export$aa77f7b4e64b9ea9 {
    constructor(app, targetIntent){
        this.__app = app;
        this.__level = 0;
        this.__sourceIntent = app.newFlipIntent(app.lastPlace);
        this.__cycleDetectionMap = new Map();
        this.__presenterMap = new Map();
        this.__targetIntent = targetIntent;
        this.__cycleDetectionMap.set(this.targetIntent.place.pathName, 1);
        this.extractPresenters(this.__presenterMap, this.__sourceIntent.place.path);
    }
    get targetIntent() {
        return this.__targetIntent;
    }
    set targetIntent(intent) {
        let cycleCount = (this.__cycleDetectionMap.get(intent.place.pathName) ?? 0) + 1;
        if (cycleCount > 5) throw new Error('Dectected a navigation cycle between ' + `source(${this.__sourceIntent})=>target(${this.__targetIntent}). ` + `The intermediate target was "${intent}"`);
        this.__targetIntent = intent;
        this.__cycleDetectionMap.set(intent.place.pathName, cycleCount);
    }
    get level() {
        return this.__level;
    }
    incrementAndGetLevel() {
        return ++this.__level;
    }
    extractPresenters(map, path) {
        for (const place of path){
            const presenter = this.__app.getPresenter(place);
            if (presenter) map.set(place.id, presenter);
        }
    }
    async step(place, atLevel) {
        let result = false;
        // Only runs if this context is the last context
        if (this.__level === atLevel) {
            const latest = this.__targetIntent.place === place;
            const presenter = this.__presenterMap.get(place.id);
            if (presenter) result = await presenter.applyParameters(this.__targetIntent, false, latest);
            else if (place.presenterCtor) {
                const presenter = new place.presenterCtor(this.__app);
                this.__presenterMap.set(place.id, presenter);
                result = await presenter.applyParameters(this.__targetIntent, true, latest);
                presenter.update();
            } else result = true;
            if (this.__level !== atLevel) result = false;
        }
        return result;
    }
    rollback() {
        for (const place of this.__sourceIntent.place.path)if (place.id !== -1) {
            const presenter = this.__presenterMap.get(place.id);
            this.__presenterMap.delete(place.id);
            if (presenter != null) presenter.applyParameters(this.__sourceIntent, false, place === this.__sourceIntent.place);
            else $22ccdcdca8063d95$var$LOG.warn(`Missing presenter for ID=${place.id}`);
        }
        if (this.__presenterMap.size > 0) {
            this.releasePresenters(this.__presenterMap);
            this.__presenterMap.clear();
        }
    }
    commit(newPresenterMap) {
        newPresenterMap.clear();
        // Keep only presenters belonging to
        const targetPlace = this.__targetIntent.place;
        // Avoid processing detached places
        if (targetPlace.id !== -1) for (const place of targetPlace.path){
            const presenter = this.__presenterMap.get(place.id);
            if (presenter) {
                // Remove presenters that will be kept
                this.__presenterMap.delete(place.id);
                newPresenterMap.set(place.id, presenter);
                continue;
            }
            $22ccdcdca8063d95$var$LOG.error(`No presenter for place=${place.toString()}`);
        }
        // Non participating paresenter on new state must be released
        if (this.__presenterMap.size > 0) this.releasePresenters(this.__presenterMap);
        return newPresenterMap;
    }
    releasePresenters(presenterInstanceMap) {
        const presenterIds = [];
        for (const presenterId of presenterInstanceMap.keys())presenterIds.push(presenterId);
        // release on reverse order (deepest level first)
        presenterIds.sort((0, $aff1edd93ceffd77$export$69e1d4f9ece4135f).reverseOrderForNumber);
        for (const presenterId of presenterIds){
            const presenter = presenterInstanceMap.get(presenterId);
            presenterInstanceMap.delete(presenterId);
            if (presenter) try {
                (0, $cba1a0683916948c$export$e68a01be871b866f).release.call(presenter);
            } catch (caught) {
                $22ccdcdca8063d95$var$LOG.error('Releasing presenter', caught);
            }
        }
    }
    removePresenter(place, presenter) {
        const otherPresenter = this.__presenterMap.get(place.id);
        if (otherPresenter === presenter) this.__presenterMap.delete(place.id);
    }
}


const $9edc54b97c5f5eb6$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('Application');
class $9edc54b97c5f5eb6$export$16975c34e60e1e61 {
    constructor(rootPlace, historyManager){
        this.__releasePhase = 0;
        this.__rootPlace = rootPlace;
        this.__lastPlace = rootPlace;
        this.__historyManager = historyManager;
        this.__presenterMap = new Map();
        this.__placeMap = new Map();
        this.__historyChangeUnregister = historyManager.addChangeListener(this.onHistoryChanged.bind(this));
    }
    release() {
        this.__releasePhase = 1;
        try {
            this.__historyChangeUnregister();
            const presenterIds = [];
            // Collect current presenters IDs
            for (const id of this.__presenterMap.keys())presenterIds.push(id);
            // Release must be made in reverse order
            presenterIds.sort((0, $aff1edd93ceffd77$export$69e1d4f9ece4135f).reverseOrderForNumber);
            // Release all presenters
            for (const presenterId of presenterIds){
                const presenter = this.__presenterMap.get(presenterId);
                if (presenter) {
                    this.__presenterMap.delete(presenterId);
                    try {
                        presenter.release();
                    } catch (caught) {
                        $9edc54b97c5f5eb6$var$LOG.error(`Releasing presenter ${presenter.constructor.name}`, caught);
                    }
                }
            }
            this.__presenterMap.clear();
        } finally{
            this.__releasePhase = 2;
        }
    }
    get isReleasing() {
        return this.__releasePhase === 1;
    }
    get isReleased() {
        return this.__releasePhase > 0;
    }
    get historyManager() {
        return this.__historyManager;
    }
    get rootPlace() {
        return this.__rootPlace;
    }
    get lastPlace() {
        return this.__lastPlace;
    }
    get fragment() {
        return this.__fragment;
    }
    get fallbackPlace() {
        return this.__rootPlace;
    }
    putPresenter(place, presenter) {
        this.__presenterMap.set(place.id, presenter);
    }
    getPresenter(place) {
        return this.__presenterMap.get(place.id);
    }
    removePresenter(place) {
        const presenter = this.__presenterMap.get(place.id);
        if (presenter) {
            if (this.__flipContext) this.__flipContext.removePresenter(place, presenter);
            this.__presenterMap.delete(place.id);
        }
        return presenter;
    }
    publishAllParameters(intent) {
        for (const presenter of this.__presenterMap.values())if (presenter.publishParameters) presenter.publishParameters(intent);
    }
    forEachPresenter(callbackfn, thisArg) {
        const me = thisArg ?? this;
        this.__presenterMap.forEach((presenter)=>{
            callbackfn.call(me, presenter);
        });
    }
    newFlipIntent(place) {
        const intent = new (0, $53ed881bf0c83c14$export$a6315278596fdad3)(place);
        intent.populateAttributes(this.__flipContext?.targetIntent.attributes);
        this.publishAllParameters(intent);
        return intent;
    }
    newIntentFromString(sIntent) {
        const defaultPlace = this.__lastPlace ?? this.rootPlace;
        let intent;
        if (sIntent) intent = (0, $53ed881bf0c83c14$export$a6315278596fdad3).parse(sIntent, (name)=>this.__placeMap.get(name) || defaultPlace);
        else intent = new (0, $53ed881bf0c83c14$export$a6315278596fdad3)(defaultPlace);
        intent.populateAttributes(this.__flipContext?.targetIntent.attributes);
        return intent;
    }
    updateHistory() {
        this.historyManager.update(this, this.lastPlace);
    }
    setPlaces(places) {
        this.__placeMap.clear();
        for (const place of Object.values(places))this.__placeMap.set(place.name, place);
    }
    async flip(place, args) {
        const intent = this.newFlipIntent(place);
        if (args?.params) for (const [name, value] of Object.entries(args.params))intent.setParameter(name, value);
        if (args?.attrs) for (const [name, value] of Object.entries(args.attrs))intent.attributes.set(name, value);
        await this.doFlipToNewPlace(intent);
    }
    async flipToIntentString(sIntent) {
        const intent = this.newIntentFromString(sIntent);
        await this.doFlipToNewPlace(intent);
    }
    async flipToIntent(intent) {
        if (intent) await this.doFlipToNewPlace(intent);
        else {
            const defaultPlace = this.__lastPlace ?? this.rootPlace;
            await this.doFlipToNewPlace(this.newFlipIntent(defaultPlace));
        }
    }
    async doFlipToNewPlace(intent) {
        let context = this.__flipContext;
        if (context) {
            context.targetIntent = intent;
            const level = context.incrementAndGetLevel();
            await this.applyPathParameters(context, level);
        } else {
            context = new (0, $22ccdcdca8063d95$export$aa77f7b4e64b9ea9)(this, intent);
            try {
                this.__flipContext = context;
                await this.applyPathParameters(context, 0);
                context.commit(this.__presenterMap);
                this.__lastPlace = context.targetIntent.place;
            } catch (caught) {
                context.rollback();
                throw caught;
            } finally{
                this.__flipContext = undefined;
                this.updateHistory();
            }
        }
    }
    async applyPathParameters(context, atLevel) {
        const intent = context.targetIntent;
        for (const place of intent.place.path){
            if (place.id != -1 && !await context.step(place, atLevel)) break;
        }
    }
    onHistoryChanged(sender) {
        const previousIntent = this.newFlipIntent(this.lastPlace);
        if (!this.__flipContext && sender.location !== previousIntent.toString()) this.flipToIntentString(sender.location).catch((caught)=>{
            $9edc54b97c5f5eb6$var$LOG.error(`Invalid history location intent=${sender.location}`, caught);
            this.flipToIntent(previousIntent).catch((caught)=>{
                $9edc54b97c5f5eb6$var$LOG.error('Problems returning to source', caught);
            });
        });
    }
    // :: Application helpers
    unexpected(message, error) {
        $9edc54b97c5f5eb6$var$LOG.error(message, error);
    }
    alert(severity, title, message, onClose) {
        switch(severity){
            case 'error':
                $9edc54b97c5f5eb6$var$LOG.error(`${title}: ${message}`);
                break;
            case 'warning':
                $9edc54b97c5f5eb6$var$LOG.warn(`${title}: ${message}`);
                break;
            case 'success':
                $9edc54b97c5f5eb6$var$LOG.info(`${title}: ${message}`);
                break;
            default:
                $9edc54b97c5f5eb6$var$LOG.debug(`${title}: ${message}`);
        }
        if (onClose) onClose().catch((caught)=>{
            $9edc54b97c5f5eb6$var$LOG.error('Closing alert', caught);
        });
    }
}




/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 





const $89dce1c0df43c9b3$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('ApplicationPresenter');
class $89dce1c0df43c9b3$export$a535e3551110f5b9 extends (0, $9edc54b97c5f5eb6$export$16975c34e60e1e61) {
    constructor(historyManager, scope){
        super((0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).ROOT, historyManager), this.__updateCount = 0, // :: IPresenter Api
        this.update = this.doUpdate.bind(this);
        this.__scope = scope;
        this.__beforeScopeUpdateListener = ()=>{
            try {
                this.onBeforeScopeUpdate();
            } finally{
                this.__updateCount = 0;
            }
        };
        this.__scopeUpdateManager = new (0, $a25a305be2ca5b1d$export$c17ff83d96d9111)(scope);
        this.__scopeUpdateManager.addOnBeforeScopeUpdateListener(this.__beforeScopeUpdateListener);
        this.__scopeUpdateManager.update(scope);
        this.__scope.update = this.update;
    }
    release() {
        this.__scope.update = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        this.__scope.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        this.__scopeUpdateManager.removeOnBeforeScopeUpdateListener(this.__beforeScopeUpdateListener);
        this.__scopeUpdateManager.release();
        super.release();
    }
    // :: Properties
    get scope() {
        return this.__scope;
    }
    get updateManager() {
        return this.__scopeUpdateManager;
    }
    // :: Application Extensions
    publishAllParameters(intent) {
        this.publishParameters(intent);
        super.publishAllParameters(intent);
    }
    async applyPathParameters(context, atLevel) {
        const intent = context.targetIntent;
        const last = intent.place.id === -1;
        const ok = await this.applyParameters(intent, false, last) && !last;
        if (!ok) return;
        await super.applyPathParameters(context, atLevel);
    }
    action(fn, owner = null) {
        return (0, $911925771b3bcd65$export$4ebf98a2c576106f)(this, owner ? fn.bind(owner) : fn.bind(this));
    }
    doUpdate(optionalScope) {
        this.__scopeUpdateManager.update(optionalScope ?? this.scope);
        this.__updateCount++;
    }
    updateIfNotDirty(scope) {
        if (this.__updateCount === 0) this.doUpdate(scope);
    }
    onBeforeScopeUpdate() {
    // NOOP
    }
    // :: ICubePresenter Api
    async kickStart(safePlace) {
        let intent = this.newIntentFromString(this.historyManager.location);
        try {
            await this.applyParameters(intent.redirect(this.rootPlace), true, true);
            if (intent.place !== this.rootPlace) {
                intent.attributes.clear();
                await this.flipToIntent(intent);
            }
        } catch (caught) {
            // Redirect to a safe place
            intent = intent.redirect(safePlace);
            intent.attributes.clear();
            await this.flipToIntent(intent);
        }
    }
    async applyParameters(intent, initialization, last) {
        $89dce1c0df43c9b3$var$LOG.debug(`applyParameters(intent=${intent}, initialization=${initialization}, last=${last}`);
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    publishParameters(intent) {
    // NOOP
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 


const $7387433882612ece$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('Scope');
function $7387433882612ece$var$syncAction(...args) {
    $7387433882612ece$var$LOG.debug('Noop Synchronous Action', args);
}
async function $7387433882612ece$var$asyncAction(...args) {
    $7387433882612ece$var$LOG.debug('Noop Asynchronous Action', args);
}
class $7387433882612ece$export$775b6bb06e53a214 {
    // Class
    static property(me, v) {
        let currentVal = v;
        return (...args)=>{
            if (args.length > 0) {
                const newVal = args[0];
                if (newVal !== currentVal) {
                    const oldVal = currentVal;
                    currentVal = newVal;
                    me.update();
                    return oldVal;
                }
            }
            return currentVal;
        };
    }
    static{
        this.SYNC_ACTION = $7387433882612ece$var$syncAction;
    }
    static{
        this.SYNC_ACTION_BOOLEAN = $7387433882612ece$var$syncAction;
    }
    static{
        this.SYNC_ACTION_NUMBER = $7387433882612ece$var$syncAction;
    }
    static{
        this.SYNC_ACTION_STRING = $7387433882612ece$var$syncAction;
    }
    static{
        this.SYNC_ACTION_DATE = $7387433882612ece$var$syncAction;
    }
    static SYNC_ACTION_ONE() {
        return $7387433882612ece$var$syncAction;
    }
    static SYNC_ACTION_TWO() {
        return $7387433882612ece$var$syncAction;
    }
    static SYNC_ACTION_THREE() {
        return $7387433882612ece$var$syncAction;
    }
    static{
        this.ASYNC_ACTION = $7387433882612ece$var$asyncAction;
    }
    static{
        this.ASYNC_ACTION_BOOLEAN = $7387433882612ece$var$asyncAction;
    }
    static{
        this.ASYNC_ACTION_NUMBER = $7387433882612ece$var$asyncAction;
    }
    static{
        this.ASYNC_ACTION_STRING = $7387433882612ece$var$asyncAction;
    }
    static{
        this.ASYNC_ACTION_DATE = $7387433882612ece$var$asyncAction;
    }
    static ASYNC_ACTION_ONE() {
        return $7387433882612ece$var$asyncAction;
    }
    static ASYNC_ACTION_TWO() {
        return $7387433882612ece$var$asyncAction;
    }
    static ASYNC_ACTION_THREE() {
        return $7387433882612ece$var$asyncAction;
    }
    // API
    updateAsRoot() {
        return this.update = (0, $a25a305be2ca5b1d$export$c17ff83d96d9111).newUpdateRoot(this);
    }
    constructor(){
        this.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        this.update = (0, $5e892709dbe5636f$export$49db20642bd540b0);
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 


const $8e5dcbc2eab77e09$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('ScopeUtils');
// :: Private static functions
function $8e5dcbc2eab77e09$var$isAnActionName(s) {
    // Made with efficience in mind
    if (s && s.length > 3) {
        const c = s.charAt(2);
        return s.charAt(0) === 'o' && s.charAt(1) == 'n' && c.toUpperCase() === c;
    }
    return false;
}
const $8e5dcbc2eab77e09$export$30afdb9417144248 = {
    isAnActionName: $8e5dcbc2eab77e09$var$isAnActionName,
    bind (scope, source) {
        const target = scope;
        for (const name of Object.keys(target))if ($8e5dcbc2eab77e09$var$isAnActionName(name)) {
            const possibleAction = source[name];
            if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(possibleAction)) target[name] = possibleAction.bind(source);
            else {
                target[name] = (0, $5e892709dbe5636f$export$a8765dfddffd7953);
                $8e5dcbc2eab77e09$var$LOG.warn(`{${scope.constructor.name}} No action found under the name of "${name}"`);
            }
        }
    }
};


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 



class $087833a4329e9d68$export$21cfd458a0199aee {
    static build(routers) {
        for (const [key, value] of Object.entries(routers))$087833a4329e9d68$var$doBuild((0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).ROOT, '/' + key, value);
    }
    static lazyBuild(routers) {
        let prepare = ()=>{
            $087833a4329e9d68$export$21cfd458a0199aee.build(routers);
        };
        return ()=>{
            prepare();
            prepare = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        };
    }
}
function $087833a4329e9d68$var$doBuild(parent, path, routers) {
    const placeCreator = routers.presenter;
    if (placeCreator && (0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(placeCreator)) {
        const place = placeCreator(path, parent);
        for (const [key, value] of Object.entries(routers))if (key !== 'presenter' && (0, (/*@__PURE__*/$parcel$interopDefault($1f672fed7efed57e$exports)))(value)) $087833a4329e9d68$var$doBuild(place, path + '/' + key, value);
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ class $22863e546644af96$export$2b76b04f92326cd {
    #scope;
    #items;
    constructor(scope, items){
        this.#scope = scope;
        this.#items = items ?? [];
    }
    #update() {
        this.#scope.update(this.#scope);
    }
    [Symbol.iterator]() {
        return this.#items[Symbol.iterator]();
    }
    keys() {
        return this.#items.keys();
    }
    values() {
        return this.#items.values();
    }
    get length() {
        return this.#items.length;
    }
    set length(value) {
        if (this.#items.length !== value) {
            this.#items.length = value;
            this.#update();
        }
    }
    at(index) {
        return this.#items.at(index);
    }
    get(idx) {
        return this.#items[idx];
    }
    set(idx, value) {
        const old = this.#items[idx];
        if (old !== value) {
            this.#items[idx] = value;
            this.#update();
        }
    }
    push(value) {
        this.#items.push(value);
        this.#update();
    }
    assign(array) {
        let changed = false;
        if (this.#items.length !== array.length) {
            this.#items.length = array.length;
            changed = true;
        }
        for(let i = 0; i < array.length; i++){
            const old = this.#items[i];
            const value = array[i];
            if (old !== value) {
                this.#items[i] = value;
                changed = true;
            }
        }
        if (changed) this.#update();
    }
    filter(predicate, thisArg) {
        return this.#items.filter(predicate, thisArg);
    }
    map(callbackfn, thisArg) {
        return this.#items.map(callbackfn, thisArg);
    }
    reduce(callbackfn, initialValue) {
        return this.#items.reduce(callbackfn, initialValue);
    }
    findIndex(predicate, thisArg) {
        return this.#items.findIndex(predicate, thisArg);
    }
    removeByIndex(index) {
        const oldLength = this.#items.length;
        this.#items.splice(index, 1);
        if (oldLength !== this.#items.length) {
            this.#update();
            return true;
        }
        return false;
    }
    removeByCriteria(predicate, thisArg) {
        if (!thisArg) thisArg = window;
        const items = [];
        let changed = false;
        for(let i = 0; i < this.#items.length; i++){
            const value = this.#items[i];
            if (predicate.call(thisArg, value, i)) changed = true;
            else items.push(value);
        }
        if (changed) {
            this.#items = items;
            this.#update();
        }
        return changed;
    }
    join(separator) {
        return this.#items.join(separator);
    }
    sort(compareFn) {
        this.#items.sort(compareFn);
        this.#update();
        return this;
    }
}



/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 



const $13583c59061cfd1f$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('React.FC');
function $13583c59061cfd1f$var$doUpdate(setValue, value) {
    //LOG.debug(`${this.constructor.name}.update()`, new Error('doUpdate'))
    setValue(value + 1);
}
function $13583c59061cfd1f$export$412eb75e83dfd80e(reactRef, scope) {
    const react = reactRef;
    const [value, setValue] = react.useState(0);
    scope.forceUpdate = $13583c59061cfd1f$var$doUpdate.bind(scope, setValue, value);
    react.useEffect(()=>{
        scope.forceUpdate = $13583c59061cfd1f$var$doUpdate.bind(scope, setValue, value);
        return ()=>{
            scope.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        };
    }, []);
    return scope;
}
function $13583c59061cfd1f$export$6f6b1bb97baa34f(react, factory) {
    const [app, setApp] = react.useState(null);
    const [value, setValue] = react.useState(0);
    let instance;
    if (app) {
        instance = app;
        instance.scope.forceUpdate = $13583c59061cfd1f$var$doUpdate.bind(instance.scope, setValue, value);
    } else {
        instance = factory();
        setApp(instance);
        instance.scope.forceUpdate = $13583c59061cfd1f$var$doUpdate.bind(instance.scope, setValue, value);
        instance.applyParameters(instance.newFlipIntent(instance.rootPlace), true, true);
    }
    react.useEffect(()=>{
        return ()=>{
            instance.scope.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
            setApp(null);
            $13583c59061cfd1f$var$LOG.debug('app.detached');
        };
    }, []);
    return instance;
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 

class $dba4c1757290c124$export$5601ec8b39a4192a extends (0, $d84a2ee106960538$export$fbff1287c64b152e) {
    attached() {
        this.props.scope.forceUpdate = this.boundForceUpdate;
    }
    detached() {
        this.props.scope.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
    }
    constructor(...args){
        super(...args), this.boundForceUpdate = this.forceUpdate.bind(this);
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ 
var $jXEQt = parcelRequire("jXEQt");
function $a21dea676972c64f$export$c737218972fbfde7({ scope: scope, optional: optional = true, view: view, ...props }) {
    if (scope) {
        if (view) {
            const ctor = view;
            return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement(ctor, {
                scope: scope,
                ...props
            });
        }
        const ctor = $a21dea676972c64f$export$918c359d6182b34e.get(scope);
        if (ctor) return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement(ctor, {
            scope: scope,
            ...props
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement('div', {
            className: props.className,
            style: props.style
        }, `View(${scope.constructor.name}) not found!`);
    }
    if (!optional) return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement('div', {
        className: props.className,
        style: props.style
    });
    return null;
}
const $a21dea676972c64f$var$VIEW_PROP_SYM = Symbol('VIEW');
class $a21dea676972c64f$export$918c359d6182b34e {
    // Static API
    static register(scopeCtor, viewCtor) {
        const dynScopeCtor = scopeCtor;
        dynScopeCtor[$a21dea676972c64f$var$VIEW_PROP_SYM] = viewCtor;
    }
    static get(scope) {
        if (scope && scope.constructor) {
            const dynScopeCtor = scope.constructor;
            return dynScopeCtor[$a21dea676972c64f$var$VIEW_PROP_SYM];
        }
        return undefined;
    }
    static createView(scope, props) {
        if (props) return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement($a21dea676972c64f$export$c737218972fbfde7, {
            scope: scope,
            ...props
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement($a21dea676972c64f$export$c737218972fbfde7, {
            scope: scope
        });
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ function $ad097dddec7c7edd$export$2e2bcd8739ae039() {
    return $ad097dddec7c7edd$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ad097dddec7c7edd$export$2e2bcd8739ae039.apply(null, arguments);
}


/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $be565bd757fdf8fd$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($be565bd757fdf8fd$export$e19cd5f9376f8cee || ($be565bd757fdf8fd$export$e19cd5f9376f8cee = {}));
var $be565bd757fdf8fd$var$readOnly = function(obj) {
    return obj;
};
function $be565bd757fdf8fd$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $be565bd757fdf8fd$var$BeforeUnloadEventType = 'beforeunload';
var $be565bd757fdf8fd$var$HashChangeEventType = 'hashchange';
var $be565bd757fdf8fd$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $be565bd757fdf8fd$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $be565bd757fdf8fd$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($be565bd757fdf8fd$var$PopStateEventType, handlePop);
    var action = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $be565bd757fdf8fd$var$createEvents();
    var blockers = $be565bd757fdf8fd$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $ad097dddec7c7edd$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $be565bd757fdf8fd$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $be565bd757fdf8fd$var$readOnly((0, $ad097dddec7c7edd$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $be565bd757fdf8fd$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $be565bd757fdf8fd$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($be565bd757fdf8fd$var$BeforeUnloadEventType, $be565bd757fdf8fd$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($be565bd757fdf8fd$var$BeforeUnloadEventType, $be565bd757fdf8fd$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $be565bd757fdf8fd$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $be565bd757fdf8fd$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $be565bd757fdf8fd$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($be565bd757fdf8fd$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($be565bd757fdf8fd$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($be565bd757fdf8fd$export$fe53371bee54353d(nextLocation) !== $be565bd757fdf8fd$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $be565bd757fdf8fd$var$createEvents();
    var blockers = $be565bd757fdf8fd$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $ad097dddec7c7edd$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $be565bd757fdf8fd$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $be565bd757fdf8fd$var$readOnly((0, $ad097dddec7c7edd$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $be565bd757fdf8fd$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $be565bd757fdf8fd$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($be565bd757fdf8fd$var$BeforeUnloadEventType, $be565bd757fdf8fd$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($be565bd757fdf8fd$var$BeforeUnloadEventType, $be565bd757fdf8fd$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $be565bd757fdf8fd$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $be565bd757fdf8fd$var$readOnly((0, $ad097dddec7c7edd$export$2e2bcd8739ae039)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $be565bd757fdf8fd$var$createKey()
        }, typeof entry === 'string' ? $be565bd757fdf8fd$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $be565bd757fdf8fd$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $be565bd757fdf8fd$var$createEvents();
    var blockers = $be565bd757fdf8fd$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $be565bd757fdf8fd$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $be565bd757fdf8fd$var$readOnly((0, $ad097dddec7c7edd$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $be565bd757fdf8fd$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $be565bd757fdf8fd$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $be565bd757fdf8fd$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $be565bd757fdf8fd$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $be565bd757fdf8fd$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $be565bd757fdf8fd$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $be565bd757fdf8fd$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $be565bd757fdf8fd$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $be565bd757fdf8fd$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}



class $acdfd7506f8bc11c$export$472e0511de4744d1 extends (0, $f58fa20fe931da1b$export$9572cf7a37405cc) {
    constructor(useHash = false){
        super();
        this.__history = useHash ? (0, $be565bd757fdf8fd$export$b71fdd3798280242)() : (0, $be565bd757fdf8fd$export$719fc203c4e16dee)();
        this.__history.listen(this.emitOnChanged.bind(this));
    }
    get location() {
        const location = this.__history.location;
        return location.pathname + location.search;
    }
    update(app, place) {
        this.clearDebounceHandler();
        this.__debounceHandler = setTimeout(this.doUpdate.bind(this, app, place), 16);
    }
    clearDebounceHandler() {
        if (this.__debounceHandler) {
            clearTimeout(this.__debounceHandler);
            this.__debounceHandler = undefined;
        }
    }
    doUpdate(app, place) {
        const currentUri = app.newFlipIntent(place);
        const oldLocation = this.__history.location;
        const qs = currentUri.getQueryString();
        const newLocation = {
            pathname: place.name,
            search: qs ? '?' + currentUri.getQueryString() : '',
            hash: ''
        };
        if (newLocation.pathname !== oldLocation.pathname || newLocation.search !== oldLocation.search) this.__history.push(newLocation);
    }
    emitOnChanged() {
        this.notifyChanges();
    }
}


/**
 * Copyright © 2025 WeDoCode Consultoria e Soluções Avançadas LTDA. All rights reserved.
 *
 * Author: Marcelo Domingos
 * Source: https://github.com/mrcdom/wdc-cube
 */ class $11416ebee592d494$export$4bf5484b9d20bfd7 {
    constructor(elm){
        this.current = elm ?? null;
    }
}



var $jXEQt = parcelRequire("jXEQt");

const $46f12576962907f4$var$Attrs = {
    initialized: Symbol('initialized')
};
const $46f12576962907f4$var$ZERO_DEPS = [];
function $46f12576962907f4$export$20f9025f645507a0(ctor, optReact) {
    const react = optReact ?? (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt)));
    const memoFactory = (props)=>new ctor(props);
    return (props)=>{
        const memo = react.useMemo(()=>memoFactory(props), $46f12576962907f4$var$ZERO_DEPS);
        const [value, setValue] = react.useState(0);
        const ctxRec = memo;
        if (ctxRec[$46f12576962907f4$var$Attrs.initialized] !== true) {
            memo.onSyncState && memo.onSyncState(props, true);
            ctxRec[$46f12576962907f4$var$Attrs.initialized] = true;
        } else memo.onSyncState && memo.onSyncState(props, false);
        const scope = $46f12576962907f4$var$props_getScope(props);
        if (scope || memo.onAttach || memo.onDetach) {
            $46f12576962907f4$var$static_bindUpdate(scope, setValue, value);
            react.useEffect(()=>{
                $46f12576962907f4$var$static_bindUpdate(scope, setValue, value);
                memo.onAttach && memo.onAttach(props);
                return ()=>{
                    $46f12576962907f4$var$static_unbindUpdate(scope);
                    memo.onDetach && memo.onDetach(props);
                };
            }, $46f12576962907f4$var$ZERO_DEPS);
        }
        return memo.render(props);
    };
}
function $46f12576962907f4$var$props_getScope(props) {
    const propsRec = props;
    if (propsRec.scope instanceof (0, $7387433882612ece$export$775b6bb06e53a214)) return propsRec.scope;
}
function $46f12576962907f4$var$static_bindUpdate(scope, setValue, value) {
    if (scope) scope.forceUpdate = $46f12576962907f4$var$scope_forceUpdate.bind(scope, setValue, value);
}
function $46f12576962907f4$var$static_unbindUpdate(scope) {
    if (scope) scope.forceUpdate = (0, $5e892709dbe5636f$export$49db20642bd540b0);
}
function $46f12576962907f4$var$scope_forceUpdate(setValue, value) {
    setValue(value + 1);
}








var $5c0c22008ac4a4e7$exports = {};
var $eb3f793683d5662a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $eb3f793683d5662a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$eb3f793683d5662a$exports = $eb3f793683d5662a$var$isObject;


var $d6af3e198bad234a$exports = {};
var $d7dbed53c82415c3$exports = {};
var $8c54acebf026b80e$exports = {};
/** Detect free variable `global` from Node.js. */ var $8c54acebf026b80e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$8c54acebf026b80e$exports = $8c54acebf026b80e$var$freeGlobal;


/** Detect free variable `self`. */ var $d7dbed53c82415c3$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $d7dbed53c82415c3$var$root = $8c54acebf026b80e$exports || $d7dbed53c82415c3$var$freeSelf || Function('return this')();
$d7dbed53c82415c3$exports = $d7dbed53c82415c3$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $d6af3e198bad234a$var$now = function() {
    return $d7dbed53c82415c3$exports.Date.now();
};
$d6af3e198bad234a$exports = $d6af3e198bad234a$var$now;


var $068ceee31a6dc62c$exports = {};
var $d118689bf9e43e6e$exports = {};
var $7cb25a303327189a$exports = {};
/** Used to match a single whitespace character. */ var $7cb25a303327189a$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $7cb25a303327189a$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $7cb25a303327189a$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$7cb25a303327189a$exports = $7cb25a303327189a$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $d118689bf9e43e6e$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $d118689bf9e43e6e$var$baseTrim(string) {
    return string ? string.slice(0, $7cb25a303327189a$exports(string) + 1).replace($d118689bf9e43e6e$var$reTrimStart, '') : string;
}
$d118689bf9e43e6e$exports = $d118689bf9e43e6e$var$baseTrim;



var $a22ddf95f6965300$exports = {};
var $d5a3f502c8fd2aa8$exports = {};
var $28100d9911bf0713$exports = {};

/** Built-in value references. */ var $28100d9911bf0713$var$Symbol = $d7dbed53c82415c3$exports.Symbol;
$28100d9911bf0713$exports = $28100d9911bf0713$var$Symbol;


var $dd031de5362e1478$exports = {};

/** Used for built-in method references. */ var $dd031de5362e1478$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dd031de5362e1478$var$hasOwnProperty = $dd031de5362e1478$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dd031de5362e1478$var$nativeObjectToString = $dd031de5362e1478$var$objectProto.toString;
/** Built-in value references. */ var $dd031de5362e1478$var$symToStringTag = $28100d9911bf0713$exports ? $28100d9911bf0713$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dd031de5362e1478$var$getRawTag(value) {
    var isOwn = $dd031de5362e1478$var$hasOwnProperty.call(value, $dd031de5362e1478$var$symToStringTag), tag = value[$dd031de5362e1478$var$symToStringTag];
    try {
        value[$dd031de5362e1478$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dd031de5362e1478$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dd031de5362e1478$var$symToStringTag] = tag;
        else delete value[$dd031de5362e1478$var$symToStringTag];
    }
    return result;
}
$dd031de5362e1478$exports = $dd031de5362e1478$var$getRawTag;


var $cb27a99150135e61$exports = {};
/** Used for built-in method references. */ var $cb27a99150135e61$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cb27a99150135e61$var$nativeObjectToString = $cb27a99150135e61$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $cb27a99150135e61$var$objectToString(value) {
    return $cb27a99150135e61$var$nativeObjectToString.call(value);
}
$cb27a99150135e61$exports = $cb27a99150135e61$var$objectToString;


/** `Object#toString` result references. */ var $d5a3f502c8fd2aa8$var$nullTag = '[object Null]', $d5a3f502c8fd2aa8$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $d5a3f502c8fd2aa8$var$symToStringTag = $28100d9911bf0713$exports ? $28100d9911bf0713$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $d5a3f502c8fd2aa8$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $d5a3f502c8fd2aa8$var$undefinedTag : $d5a3f502c8fd2aa8$var$nullTag;
    return $d5a3f502c8fd2aa8$var$symToStringTag && $d5a3f502c8fd2aa8$var$symToStringTag in Object(value) ? $dd031de5362e1478$exports(value) : $cb27a99150135e61$exports(value);
}
$d5a3f502c8fd2aa8$exports = $d5a3f502c8fd2aa8$var$baseGetTag;


var $3e9d92400c16801e$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3e9d92400c16801e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$3e9d92400c16801e$exports = $3e9d92400c16801e$var$isObjectLike;


/** `Object#toString` result references. */ var $a22ddf95f6965300$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a22ddf95f6965300$var$isSymbol(value) {
    return typeof value == 'symbol' || $3e9d92400c16801e$exports(value) && $d5a3f502c8fd2aa8$exports(value) == $a22ddf95f6965300$var$symbolTag;
}
$a22ddf95f6965300$exports = $a22ddf95f6965300$var$isSymbol;


/** Used as references for various `Number` constants. */ var $068ceee31a6dc62c$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $068ceee31a6dc62c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $068ceee31a6dc62c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $068ceee31a6dc62c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $068ceee31a6dc62c$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $068ceee31a6dc62c$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($a22ddf95f6965300$exports(value)) return $068ceee31a6dc62c$var$NAN;
    if ($eb3f793683d5662a$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $eb3f793683d5662a$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $d118689bf9e43e6e$exports(value);
    var isBinary = $068ceee31a6dc62c$var$reIsBinary.test(value);
    return isBinary || $068ceee31a6dc62c$var$reIsOctal.test(value) ? $068ceee31a6dc62c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $068ceee31a6dc62c$var$reIsBadHex.test(value) ? $068ceee31a6dc62c$var$NAN : +value;
}
$068ceee31a6dc62c$exports = $068ceee31a6dc62c$var$toNumber;


/** Error message constants. */ var $5c0c22008ac4a4e7$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c0c22008ac4a4e7$var$nativeMax = Math.max, $5c0c22008ac4a4e7$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $5c0c22008ac4a4e7$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($5c0c22008ac4a4e7$var$FUNC_ERROR_TEXT);
    wait = $068ceee31a6dc62c$exports(wait) || 0;
    if ($eb3f793683d5662a$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $5c0c22008ac4a4e7$var$nativeMax($068ceee31a6dc62c$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $5c0c22008ac4a4e7$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $d6af3e198bad234a$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($d6af3e198bad234a$exports());
    }
    function debounced() {
        var time = $d6af3e198bad234a$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$5c0c22008ac4a4e7$exports = $5c0c22008ac4a4e7$var$debounce;




const $111375feb76f4602$export$c9753d5230386a7e = {
    // :: Analise de Reacoes
    analiseReacoesTemDados: 'm1-tda',
    analiseReacoesDtInicial: 'm1-dti',
    analiseReacoesDtFinal: 'm1-dtf',
    analiseReacoesBuscaGeral: 'm1-grl',
    analiseReacoesBuscaReacoes: 'm1-rac',
    analiseReacoesBuscaMedicamentos: 'm1-mds',
    analiseReacoesStatusBula: 'm1-sbl',
    analiseReacoesGravidade: 'm1-grv',
    // :: Analise de Bulas
    analiseBulasTemDados: 'm2-tda',
    analiseBulasPrincipioAtivos: 'm2-pra',
    analiseBulasFabricantes: 'm2-fbr',
    analiseBulasMecicamentos: 'm2-mds',
    analiseBulasReacoes: 'm2-rac'
};
const $111375feb76f4602$export$f16470fa82b37ffe = {
    parentSlot: 'parent-slot',
    dialogSlot: 'dialog-slot'
};
const $111375feb76f4602$export$ab4fed16567445e2 = {
    main: (0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).ROOT,
    analiseBulas: (0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).UNKNOWN,
    analiseReacoes: (0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).UNKNOWN
};




class $bb6e76f992d97bab$export$2089ee9a829aa848 {
    _intent;
    _app;
    allow;
    constructor(app, intent){
        this.allow = true;
        this._app = app;
        this._intent = intent ? intent : app.newFlipIntent(this.place);
    }
    get place() {
        return (0, $111375feb76f4602$export$ab4fed16567445e2).main;
    }
    get targetPlace() {
        return this._intent.place;
    }
    flip() {
        return this._app.flipToIntent(this._intent);
    }
    // :: Parameters
    // :: parentSlot
    get parentSlot() {
        return this._intent.getScopeSlot((0, $111375feb76f4602$export$f16470fa82b37ffe).parentSlot) ?? (0, $5e892709dbe5636f$export$49db20642bd540b0);
    }
    set parentSlot(value) {
        this._intent.setScopeSlot((0, $111375feb76f4602$export$f16470fa82b37ffe).parentSlot, value);
    }
    // :: parentSlot
    get dialogSlot() {
        return this._intent.getScopeSlot((0, $111375feb76f4602$export$f16470fa82b37ffe).dialogSlot) ?? (0, $5e892709dbe5636f$export$49db20642bd540b0);
    }
    set dialogSlot(value) {
        this._intent.setScopeSlot((0, $111375feb76f4602$export$f16470fa82b37ffe).dialogSlot, value);
    }
}



const $835fe19408aba685$var$encoder = new TextEncoder();
const $835fe19408aba685$var$decoder = new TextDecoder();
const $835fe19408aba685$var$Utf8 = new class Utf8 {
    encode(input) {
        return $835fe19408aba685$var$encoder.encode(input);
    }
    decode(input, options) {
        return $835fe19408aba685$var$decoder.decode(input, options);
    }
};
var $835fe19408aba685$export$2e2bcd8739ae039 = $835fe19408aba685$var$Utf8;


// :: Standard - RFC 2045 - Non URL safe
let $e33253d18ff4b03e$var$getRfc2045Table = ()=>{
    const b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    const lookup = new Map(Array.from(b64chars).map((char, i)=>[
            char,
            i
        ]));
    const response = {
        b64chars: b64chars,
        lookup: lookup
    };
    $e33253d18ff4b03e$var$getRfc2045Table = ()=>response;
    return response;
};
const $e33253d18ff4b03e$var$base64Encode = (binData)=>{
    const { b64chars: b64chars } = $e33253d18ff4b03e$var$getRfc2045Table();
    let result = '';
    // Process 3 bytes at a time
    for(let i = 0; i < binData.length; i += 3){
        const chunk = binData[i] << 16 | (i + 1 < binData.length ? binData[i + 1] << 8 : 0) | (i + 2 < binData.length ? binData[i + 2] : 0);
        // Convert to 4 base64 characters
        result += b64chars[chunk >> 18 & 63];
        result += b64chars[chunk >> 12 & 63];
        result += i + 1 < binData.length ? b64chars[chunk >> 6 & 63] : '=';
        result += i + 2 < binData.length ? b64chars[chunk & 63] : '=';
    }
    return result;
};
const $e33253d18ff4b03e$var$base64Decode = (str)=>{
    const { lookup: lookup } = $e33253d18ff4b03e$var$getRfc2045Table();
    // Remove padding if present
    const unpadded = str.replace(/=+$/, '');
    const binData = new Uint8Array(Math.floor(unpadded.length * 3 / 4));
    for(let i = 0, j = 0; i < unpadded.length; i += 4){
        const chunk = lookup.get(unpadded[i]) << 18 | lookup.get(unpadded[i + 1]) << 12 | (i + 2 < unpadded.length ? lookup.get(unpadded[i + 2]) : 0) << 6 | (i + 3 < unpadded.length ? lookup.get(unpadded[i + 3]) : 0);
        binData[j++] = chunk >> 16 & 255;
        if (i + 2 < unpadded.length) binData[j++] = chunk >> 8 & 255;
        if (i + 3 < unpadded.length) binData[j++] = chunk & 255;
    }
    return binData;
};
// :: RFC 4648 - Url Safe
let $e33253d18ff4b03e$var$getRfc4648Table = ()=>{
    const b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    const lookup = new Map(Array.from(b64chars).map((char, i)=>[
            char,
            i
        ]));
    const response = {
        b64chars: b64chars,
        lookup: lookup
    };
    $e33253d18ff4b03e$var$getRfc4648Table = ()=>response;
    return response;
};
const $e33253d18ff4b03e$var$base64UrlEncode = (binData)=>{
    const { b64chars: b64chars } = $e33253d18ff4b03e$var$getRfc4648Table();
    let result = '';
    for(let i = 0; i < binData.length; i += 3){
        const chunk = binData[i] << 16 | (i + 1 < binData.length ? binData[i + 1] << 8 : 0) | (i + 2 < binData.length ? binData[i + 2] : 0);
        result += b64chars[chunk >> 18 & 63];
        result += b64chars[chunk >> 12 & 63];
        result += i + 1 < binData.length ? b64chars[chunk >> 6 & 63] : '';
        result += i + 2 < binData.length ? b64chars[chunk & 63] : '';
    }
    return result;
};
const $e33253d18ff4b03e$var$base64UrlDecode = (str)=>{
    const { lookup: lookup } = $e33253d18ff4b03e$var$getRfc4648Table();
    // Pad to multiple of 4
    const padLen = str.length % 4;
    const padded = str + '='.repeat(padLen ? 4 - padLen : 0);
    const binData = new Uint8Array(Math.floor(padded.length * 3 / 4));
    for(let i = 0, j = 0; i < padded.length; i += 4){
        const chunk = lookup.get(padded[i]) << 18 | lookup.get(padded[i + 1]) << 12 | (padded[i + 2] !== '=' ? lookup.get(padded[i + 2]) : 0) << 6 | (padded[i + 3] !== '=' ? lookup.get(padded[i + 3]) : 0);
        binData[j++] = chunk >> 16 & 255;
        if (padded[i + 2] !== '=') binData[j++] = chunk >> 8 & 255;
        if (padded[i + 3] !== '=') binData[j++] = chunk & 255;
    }
    return binData;
};
const $e33253d18ff4b03e$var$Base64 = new class {
    // RFC 2045 - URL unsafe
    encode(binData) {
        return $e33253d18ff4b03e$var$base64Encode(binData);
    }
    decode(base64String) {
        return $e33253d18ff4b03e$var$base64Decode(base64String);
    }
    // RFC 4648 - Url Safe
    encodeUrlSafe(binData) {
        return $e33253d18ff4b03e$var$base64UrlEncode(binData);
    }
    decodeUrlSafe(base64Url) {
        return $e33253d18ff4b03e$var$base64UrlDecode(base64Url);
    }
};
var $e33253d18ff4b03e$export$2e2bcd8739ae039 = $e33253d18ff4b03e$var$Base64;




class $d827abede00c186c$export$376ba4289c9c1b60 extends (0, $bb6e76f992d97bab$export$2089ee9a829aa848) {
    get place() {
        return (0, $111375feb76f4602$export$ab4fed16567445e2).analiseBulas;
    }
    // :: Property hasData
    get temDados() {
        return this._intent.getParameterAsString((0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasTemDados) === '1';
    }
    set temDados(v) {
        this._intent.setParameter((0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasTemDados, v ? 1 : null);
    }
    // :: Property Fabricantes
    get fabricantes() {
        return $d827abede00c186c$var$getParameterB64(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasFabricantes);
    }
    set fabricantes(v) {
        $d827abede00c186c$var$setParameterB64(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasFabricantes, v);
    }
    // :: Property Medicamentos
    get medicamentos() {
        return $d827abede00c186c$var$getParameterB64(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasMecicamentos);
    }
    set medicamentos(v) {
        $d827abede00c186c$var$setParameterB64(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasMecicamentos, v);
    }
    // :: Property PrincipioAtivos
    get principioAtivos() {
        return $d827abede00c186c$var$getParameterB64(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasPrincipioAtivos);
    }
    set principioAtivos(v) {
        $d827abede00c186c$var$setParameterB64(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasPrincipioAtivos, v);
    }
    // :: Property Medicamentos
    get reacoes() {
        return $d827abede00c186c$var$getParameterB64(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasReacoes);
    }
    set reacoes(v) {
        $d827abede00c186c$var$setParameterB64(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseBulasReacoes, v);
    }
}
// :: Utils
function $d827abede00c186c$var$setParameterB64(intent, name, v) {
    intent.setParameter(name, v ? (0, $e33253d18ff4b03e$export$2e2bcd8739ae039).encodeUrlSafe((0, $835fe19408aba685$export$2e2bcd8739ae039).encode(v)) : null);
}
function $d827abede00c186c$var$getParameterB64(intent, name) {
    const b64Value = intent.getParameterAsString(name);
    if (b64Value) return (0, $835fe19408aba685$export$2e2bcd8739ae039).decode((0, $e33253d18ff4b03e$export$2e2bcd8739ae039).decode(b64Value));
    return undefined;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};




const $04cc4a7986243394$export$914c54bfdf2e3a3c = (0, (/*@__PURE__*/$parcel$interopDefault($5c0c22008ac4a4e7$exports)))((0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION, 1);
const $04cc4a7986243394$export$4d6cd4ba5b74e936 = (0, (/*@__PURE__*/$parcel$interopDefault($5c0c22008ac4a4e7$exports)))((0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_STRING, 1);
class $04cc4a7986243394$export$2d23f4b21840b390 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    loading = false;
    filtro = new $04cc4a7986243394$export$df50132aa0668e0e();
    table = new $04cc4a7986243394$export$b183a948dcaa89a8();
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$2d23f4b21840b390.prototype, "loading", void 0);
$04cc4a7986243394$export$2d23f4b21840b390 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $04cc4a7986243394$export$2d23f4b21840b390);
var $04cc4a7986243394$export$2e2bcd8739ae039 = $04cc4a7986243394$export$2d23f4b21840b390;
class $04cc4a7986243394$export$df50132aa0668e0e extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    principiosAtivos = new $04cc4a7986243394$export$dfeec9d89f4ab151();
    fabricantes = new $04cc4a7986243394$export$dfeec9d89f4ab151();
    medicamentos = new $04cc4a7986243394$export$dfeec9d89f4ab151();
    reacoes = new $04cc4a7986243394$export$dfeec9d89f4ab151();
    onConsultar = $04cc4a7986243394$export$914c54bfdf2e3a3c;
    onLimpar = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
}
$04cc4a7986243394$export$df50132aa0668e0e = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $04cc4a7986243394$export$df50132aa0668e0e);
class $04cc4a7986243394$export$dfeec9d89f4ab151 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    value = [];
    options = [];
    loading = false;
    onSearchChange = $04cc4a7986243394$export$4d6cd4ba5b74e936;
    onChangeOptions = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_ONE();
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$dfeec9d89f4ab151.prototype, "value", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$dfeec9d89f4ab151.prototype, "options", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$dfeec9d89f4ab151.prototype, "loading", void 0);
$04cc4a7986243394$export$dfeec9d89f4ab151 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $04cc4a7986243394$export$dfeec9d89f4ab151);
class $04cc4a7986243394$export$b183a948dcaa89a8 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    qtdeFabricatesAnalisados = 0;
    qtdeCoberturasCompletas = 0;
    qtdeCoberturaParciais = 0;
    qtdeNaoDocumentadas = 0;
    reacaoPorFabricanteData = null;
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$b183a948dcaa89a8.prototype, "qtdeFabricatesAnalisados", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$b183a948dcaa89a8.prototype, "qtdeCoberturasCompletas", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$b183a948dcaa89a8.prototype, "qtdeCoberturaParciais", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$b183a948dcaa89a8.prototype, "qtdeNaoDocumentadas", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $04cc4a7986243394$export$b183a948dcaa89a8.prototype, "reacaoPorFabricanteData", void 0);
$04cc4a7986243394$export$b183a948dcaa89a8 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $04cc4a7986243394$export$b183a948dcaa89a8);


var $33a01a1226990eeb$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $33a01a1226990eeb$var$isNil(value) {
    return value == null;
}
$33a01a1226990eeb$exports = $33a01a1226990eeb$var$isNil;


class $18c764893a5a468b$export$58dfff088705ac55 extends Error {
    statusCode;
    constructor(statusCode, message){
        super(message);
        this.statusCode = statusCode;
    }
}
var $18c764893a5a468b$export$2e2bcd8739ae039 = $18c764893a5a468b$export$58dfff088705ac55;


const $15ce1f86191d2574$var$TOKEN_PROVIDER_NOOP = ()=>{
    return undefined;
};
class $15ce1f86191d2574$export$eca146def0f3ecb3 {
    tokenProvider = $15ce1f86191d2574$var$TOKEN_PROVIDER_NOOP;
    setTokenProvider(provider) {
        this.tokenProvider = provider;
    }
    newUrl(path) {
        return new URL(location.origin + path);
    }
    async get(url) {
        const response = await fetch(url, {
            method: 'GET'
        });
        return await $15ce1f86191d2574$var$getBody(response, 200);
    }
    async authGet(url) {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${this.getAccessToken()}`
            }
        });
        return await $15ce1f86191d2574$var$getBody(response, 200);
    }
    async post(url, requestBody) {
        const headers = {};
        const cfg = {
            method: 'POST',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) cfg.body = JSON.stringify(requestBody);
        const response = await fetch(url, cfg);
        return await $15ce1f86191d2574$var$getBody(response, 201);
    }
    async queryPost(url, requestBody) {
        const headers = {};
        const cfg = {
            method: 'POST',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) cfg.body = JSON.stringify(requestBody);
        const response = await fetch(url, cfg);
        return await $15ce1f86191d2574$var$getBody(response, 200);
    }
    async authPost(url, requestBody) {
        const headers = {
            Authorization: `Bearer ${this.getAccessToken()}`
        };
        const cfg = {
            method: 'POST',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        const response = await fetch(url, cfg);
        return await $15ce1f86191d2574$var$getBody(response, 201);
    }
    async authQueryPost(url, requestBody) {
        const headers = {
            Authorization: `Bearer ${this.getAccessToken()}`
        };
        const cfg = {
            method: 'POST',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        const response = await fetch(url, cfg);
        return await $15ce1f86191d2574$var$getBody(response, 200);
    }
    async authPut(url, requestBody) {
        const headers = {
            Authorization: `Bearer ${this.getAccessToken()}`
        };
        const cfg = {
            method: 'PUT',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        const response = await fetch(url, cfg);
        return await $15ce1f86191d2574$var$getBody(response, 200);
    }
    async authPostTextBody(url, requestBody) {
        const headers = {
            Authorization: `Bearer ${this.getAccessToken()}`
        };
        const cfg = {
            method: 'POST',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'text/plain;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        const response = await fetch(url, cfg);
        return await $15ce1f86191d2574$var$getBody(response, 201);
    }
    async delete(url, requestBody) {
        const headers = {};
        const cfg = {
            method: 'DELETE',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) cfg.body = JSON.stringify(requestBody);
        const response = await fetch(url, cfg);
        return await $15ce1f86191d2574$var$getBody(response, 200);
    }
    async authDelete(url, requestBody) {
        const headers = {
            Authorization: `Bearer ${this.getAccessToken()}`
        };
        const cfg = {
            method: 'DELETE',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        const response = await fetch(url, cfg);
        return await $15ce1f86191d2574$var$getBody(response, 200);
    }
    async authRawPost(url, requestBody) {
        const headers = {
            Authorization: `Bearer ${this.getAccessToken()}`
        };
        const cfg = {
            method: 'POST',
            headers: headers
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($33a01a1226990eeb$exports)))(requestBody)) {
            headers['Content-Type'] = 'application/json;charset=utf-8';
            cfg.body = JSON.stringify(requestBody);
        }
        return fetch(url, cfg);
    }
    getAccessToken() {
        const accessToken = this.tokenProvider();
        if (!accessToken) throw new (0, $18c764893a5a468b$export$58dfff088705ac55)(401, 'Unauthorized');
        return accessToken;
    }
}
var $15ce1f86191d2574$export$2e2bcd8739ae039 = new $15ce1f86191d2574$export$eca146def0f3ecb3();
async function $15ce1f86191d2574$var$getBody(response, checkStatusCode) {
    const body = await response.json();
    const potencialError = body;
    if (potencialError.statusCode !== undefined) throw new (0, $18c764893a5a468b$export$58dfff088705ac55)(potencialError.statusCode, potencialError.message ?? 'Unexpected code');
    if (response.status !== checkStatusCode) throw new (0, $18c764893a5a468b$export$58dfff088705ac55)(response.status, response.statusText);
    return body;
}


const $0366bcce519317a3$export$2812a1fb15aca49c = '/api/v1/bulas';


let $d4ef75020c2c1f61$var$TASK_MAP = new Map();
var $d4ef75020c2c1f61$export$2e2bcd8739ae039 = async (rq)=>{
    const taskKey = JSON.stringify(rq);
    let runningTask = $d4ef75020c2c1f61$var$TASK_MAP.get(taskKey);
    if (runningTask) return await runningTask;
    let doResolve = ()=>void 0;
    let doReject = ()=>void 0;
    runningTask = new Promise((resolve, reject)=>{
        doResolve = resolve;
        doReject = reject;
    });
    $d4ef75020c2c1f61$var$TASK_MAP.set(taskKey, runningTask);
    try {
        const url = (0, $15ce1f86191d2574$export$2e2bcd8739ae039).newUrl(`${(0, $0366bcce519317a3$export$2812a1fb15aca49c)}/reacoes`);
        $d4ef75020c2c1f61$var$arrayIsNotEmpty(rq.principios) && url.searchParams.append('principios', rq.principios.join(','));
        $d4ef75020c2c1f61$var$arrayIsNotEmpty(rq.reacoes) && url.searchParams.append('reacoes', rq.reacoes.join(','));
        $d4ef75020c2c1f61$var$arrayIsNotEmpty(rq.fabricantes) && url.searchParams.append('fabricantes', rq.fabricantes.join(','));
        $d4ef75020c2c1f61$var$arrayIsNotEmpty(rq.medicamentos) && url.searchParams.append('medicamentos', rq.medicamentos.join(','));
        const response = await (0, $15ce1f86191d2574$export$2e2bcd8739ae039).authGet(url);
        doResolve(response);
        return response;
    } catch (error) {
        doReject(error);
        throw error;
    } finally{
        $d4ef75020c2c1f61$var$TASK_MAP.delete(taskKey);
    }
};
function $d4ef75020c2c1f61$var$arrayIsNotEmpty(arr) {
    return arr ? arr.length > 0 : false;
}


var $b3760d9351cad522$export$984086cc09dfd8e0 = /*#__PURE__*/ function(Frequencia) {
    Frequencia[Frequencia["Comum"] = 0] = "Comum";
    Frequencia[Frequencia["PoucoComum"] = 1] = "PoucoComum";
    Frequencia[Frequencia["Frequente"] = 2] = "Frequente";
    Frequencia[Frequencia["Rara"] = 3] = "Rara";
    return Frequencia;
}({});
var $b3760d9351cad522$export$3f0ad58249886cc5 = /*#__PURE__*/ function(Gravidade) {
    Gravidade[Gravidade["Leve"] = 0] = "Leve";
    Gravidade[Gravidade["Moderada"] = 1] = "Moderada";
    Gravidade[Gravidade["Grave"] = 2] = "Grave";
    return Gravidade;
}({});
var $b3760d9351cad522$export$2e2bcd8739ae039 = async (rq)=>{
    const data = await (0, $d4ef75020c2c1f61$export$2e2bcd8739ae039)(rq);
    // 1. Mapa de medicamentos por id (para acesso rápido)
    const medicamentoMap = new Map();
    for (const med of data.dominios.medicamentos)medicamentoMap.set(med.id, med);
    // 2. Estrutura intermediária: Map<Reação + Fabricante, Set<medicamentoId>>
    // Usamos Set para evitar duplicatas de medicamentos
    const reacaoFabricanteMedicamentos = new Map();
    // Chave composta simples como string: `${reacaoId}|${fabricanteId}`
    for (const [idFabricante, [idMedicamento, reacoesIds]] of data.relation)for (const reacaoId of reacoesIds){
        const key = `${reacaoId}|${idFabricante}`;
        let idMedSet = reacaoFabricanteMedicamentos.get(key);
        if (!idMedSet) {
            idMedSet = new Set();
            reacaoFabricanteMedicamentos.set(key, idMedSet);
        }
        idMedSet.add(idMedicamento);
    }
    // 3. Construção das linhas da grade (uma por reação)
    const rows = [];
    for (const reacao of data.dominios.reacoes){
        const reacaoId = reacao.id;
        const medicamentosPorFabricante = [];
        // Para cada fabricante, coletamos os medicamentos relacionados a essa reação
        for (const fabricante of data.dominios.fabricantes){
            const fabId = fabricante.id;
            const key = `${reacaoId}|${fabId}`;
            const idMedSet = reacaoFabricanteMedicamentos.get(key);
            if (!idMedSet || idMedSet.size === 0) {
                medicamentosPorFabricante.push([]);
                continue;
            }
            const medicamentos = [];
            for (const medId of idMedSet){
                const medDto = medicamentoMap.get(medId);
                if (medDto) medicamentos.push({
                    id: medDto.id,
                    nome: medDto.nome
                });
            }
            medicamentosPorFabricante.push(medicamentos);
        }
        // No caso atual, qtdeCasos está sempre 0
        // Se futuramente vier do backend, pode-se calcular aqui
        rows.push({
            id: reacaoId,
            reacao: reacao.nome,
            qtdeCasos: 0,
            medicamentos: medicamentosPorFabricante
        });
    }
    // 4. Fabricantes
    const fabricantes = data.dominios.fabricantes.map((f)=>({
            id: f.id,
            nome: f.nome
        }));
    // 5. Montagem da resposta final
    return {
        duration: data.duration,
        // totais (mantidos como no original)
        qtdeFabricates: data.totais.qtdeFabricates,
        qtdeCoberturasCompletas: data.totais.qtdeCoberturasCompletas,
        qtdeCoberturaParciais: data.totais.qtdeCoberturaParciais,
        qtdeNaoDocumentadas: data.totais.qtdeNaoDocumentadas,
        // nova estrutura desejada
        grade: {
            fabricantes: fabricantes,
            rows: rows
        }
    };
};




let $e098287a2113964d$var$TASK_MAP = new Map();
const $e098287a2113964d$var$sendRequest = async (dominio, rq)=>{
    const taskKey = JSON.stringify(rq);
    let runningTask = $e098287a2113964d$var$TASK_MAP.get(taskKey);
    if (runningTask) return await runningTask;
    let doResolve = ()=>void 0;
    let doReject = ()=>void 0;
    runningTask = new Promise((resolve, reject)=>{
        doResolve = resolve;
        doReject = reject;
    });
    $e098287a2113964d$var$TASK_MAP.set(taskKey, runningTask);
    try {
        const url = (0, $15ce1f86191d2574$export$2e2bcd8739ae039).newUrl(`${(0, $0366bcce519317a3$export$2812a1fb15aca49c)}/dominios/${dominio}`);
        rq.codes && rq.codes.length > 0 && url.searchParams.append('codes', rq.codes.join(','));
        rq.text && url.searchParams.append('text', rq.text);
        rq.offset > 0 && url.searchParams.append('offset', `${rq.offset}`);
        rq.limit > 0 && url.searchParams.append('limit', `${rq.limit}`);
        const response = await (0, $15ce1f86191d2574$export$2e2bcd8739ae039).authGet(url);
        doResolve(response);
        return response;
    } catch (error) {
        doReject(error);
        throw error;
    } finally{
        $e098287a2113964d$var$TASK_MAP.delete(taskKey);
    }
};
var $e098287a2113964d$export$2e2bcd8739ae039 = {
    async fabricantes (rq) {
        return $e098287a2113964d$var$sendRequest('fabricantes', rq);
    },
    async medicamentos (rq) {
        return $e098287a2113964d$var$sendRequest('medicamentos', rq);
    },
    async principiosAtivos (rq) {
        return $e098287a2113964d$var$sendRequest('principios-ativos', rq);
    },
    async reacoes (rq) {
        return $e098287a2113964d$var$sendRequest('reacoes', rq);
    }
};


var $3ca2b7ae1bd77e45$export$2e2bcd8739ae039 = (0, $e098287a2113964d$export$2e2bcd8739ae039);




class $aa77ba30aae69335$export$2e2bcd8739ae039 extends (0, $a25a305be2ca5b1d$export$893c88c42e3630f9) {
    log;
    service;
    selectedCodeArray = new Array();
    selectedOptionMap = new Map();
    onCheckChangedListener;
    constructor(owner, scope, dominio, dominioQuery){
        super(owner, scope);
        this.log = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get(`vgm-selector-${dominio}`);
        this.service = dominioQuery;
        this.scope.onSearchChange = (0, (/*@__PURE__*/$parcel$interopDefault($5c0c22008ac4a4e7$exports)))(this.action(this.onSearchChange), 500);
        this.scope.onChangeOptions = this.action(this.onChangeOptions);
    }
    get selectedCodes() {
        return this.selectedCodeArray;
    }
    async setSelectedExistingCodes(codes) {
        $aa77ba30aae69335$var$Utils.retainMap(this.selectedOptionMap, codes);
        await this.onChangeOptions([
            ...this.selectedOptionMap.values()
        ]);
    }
    async setSelectedCodes(codes) {
        // Abaixo o valor "loading = false" eh proposital. O motio eh que
        // o componente visual possui um bug que abaca abrindo o lookup
        this.scope.loading = false;
        try {
            let codeSet = new Set(codes);
            for (const curSelCode of [
                ...this.selectedOptionMap.keys()
            ])if (codeSet.has(curSelCode)) codeSet.delete(curSelCode);
            else this.selectedOptionMap.delete(curSelCode);
            let response = {
                duration: 0,
                itens: []
            };
            if (codeSet.size > 0) // Neste caso tem algo a ser buscado no servidor
            response = await this.service({
                codes: [
                    ...codeSet
                ]
            });
            else {
                // Neste caso, já temos os dados, mas vamos só ficar com o que foi
                // solicitado
                codeSet = new Set(codes);
                for (const option of this.scope.options)if (codeSet.has(option.value)) response.itens.push({
                    id: option.value,
                    descricao: option.label
                });
            }
            this._updateAfterFetch(response);
            await this.onChangeOptions(this.scope.options);
        } finally{
            this.scope.loading = false;
        }
    }
    async forceContent(options) {
        $aa77ba30aae69335$var$Utils.retainMap(this.selectedOptionMap, options.map((o)=>o.id));
        this._updateAfterFetch({
            duration: 0,
            itens: options
        });
        await this.onChangeOptions(this.scope.options);
    }
    async onLimpar() {
        this.selectedOptionMap.clear();
        this.scope.value = [];
    }
    async onSearchChange(text) {
        this.log.debug(`onSearchChange: ${text}`);
        this.scope.loading = true;
        try {
            const response = await this.service({
                text: text,
                limit: 100
            });
            this._updateAfterFetch(response);
        } finally{
            this.scope.loading = false;
        }
    }
    _updateAfterFetch(response) {
        const newOptionMap = new Map();
        for (const item of response.itens)newOptionMap.set(item.id, {
            label: item.descricao,
            value: item.id
        });
        for (const item of this.selectedOptionMap.values())newOptionMap.set(item.value, item);
        const options = [
            ...newOptionMap.values()
        ];
        const localeOptions = {
            sensitivity: 'base'
        };
        options.sort((a, b)=>a.label.localeCompare(b.label, undefined, localeOptions));
        this.scope.options = options;
    }
    async onChangeOptions(selectedOptions) {
        this.selectedOptionMap.clear();
        this.selectedCodeArray.length = 0;
        for (const option of selectedOptions){
            this.selectedOptionMap.set(option.value, option);
            this.selectedCodeArray.push(option.value);
        }
        this.scope.value = this.selectedCodeArray;
        this.onCheckChangedListener && this.onCheckChangedListener(this.selectedCodeArray);
    }
}
const $aa77ba30aae69335$var$Utils = {
    retainMap (map, keys) {
        const tmpMap = new Set(keys);
        for (const curKey of [
            ...map.keys()
        ])if (!tmpMap.has(curKey)) map.delete(curKey);
    }
};


const $89d3fe3f861916c4$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('AnaliseBulasPresenter');
class $89d3fe3f861916c4$export$dc32248f18a293b9 extends (0, $cba1a0683916948c$export$f73f61399fd7814) {
    // :: Fields
    parentSlot = (0, $5e892709dbe5636f$export$49db20642bd540b0);
    rowIdGen = 1;
    fabricanteSelect;
    medicamentoSelect;
    principiosAtivosSelect;
    reacoesSelect;
    fabricantesManager = new $89d3fe3f861916c4$var$FabricanteManager();
    // :: Constructor
    constructor(app){
        super(app, new (0, $04cc4a7986243394$export$2d23f4b21840b390)());
        const filtroCtrl = new (0, $a25a305be2ca5b1d$export$893c88c42e3630f9)(this, this.scope.filtro);
        this.scope.filtro.onLimpar = filtroCtrl.action(this.onLimpar, this);
        this.scope.filtro.onConsultar = (0, (/*@__PURE__*/$parcel$interopDefault($5c0c22008ac4a4e7$exports)))(filtroCtrl.action(this.onConsultar, this), 100);
        this.scope.filtro.update = filtroCtrl.update;
        this.fabricantesManager.assignTableScope(this.scope.table);
        this.fabricanteSelect = new (0, $aa77ba30aae69335$export$2e2bcd8739ae039)(filtroCtrl, this.scope.filtro.fabricantes, 'fabricantes', this.fabricantesManager.fetch);
        this.fabricantesManager.assignSelectPresenter(this.fabricanteSelect);
        this.medicamentoSelect = new (0, $aa77ba30aae69335$export$2e2bcd8739ae039)(filtroCtrl, this.scope.filtro.medicamentos, 'medicamentos', (0, $3ca2b7ae1bd77e45$export$2e2bcd8739ae039).medicamentos);
        this.principiosAtivosSelect = new (0, $aa77ba30aae69335$export$2e2bcd8739ae039)(filtroCtrl, this.scope.filtro.principiosAtivos, 'principiosAtivos', (0, $3ca2b7ae1bd77e45$export$2e2bcd8739ae039).principiosAtivos);
        this.reacoesSelect = new (0, $aa77ba30aae69335$export$2e2bcd8739ae039)(filtroCtrl, this.scope.filtro.reacoes, 'reacoes', (0, $3ca2b7ae1bd77e45$export$2e2bcd8739ae039).reacoes);
        this.scope.table.update = this.update;
    }
    // :: Cube lifecycle
    async applyParameters(intent, initialization) {
        const key = new (0, $d827abede00c186c$export$376ba4289c9c1b60)(this.app, intent);
        this.parentSlot = key.parentSlot;
        this.parentSlot(this.scope);
        // Puxa configuracao do Intent
        const changed = await this.updateFilterStateFromIntent(key, initialization);
        if (changed && key.temDados) await this.onConsultar();
        return true;
    }
    publishParameters(intent) {
        const key = new (0, $d827abede00c186c$export$376ba4289c9c1b60)(this.app, intent);
        key.temDados = this.scope.table.reacaoPorFabricanteData !== null;
        key.principioAtivos = $89d3fe3f861916c4$var$Util.keysToParam(this.scope.filtro.principiosAtivos.value);
        key.fabricantes = $89d3fe3f861916c4$var$Util.keysToParam(this.scope.filtro.fabricantes.value);
        key.medicamentos = $89d3fe3f861916c4$var$Util.keysToParam(this.scope.filtro.medicamentos.value);
        key.reacoes = $89d3fe3f861916c4$var$Util.keysToParam(this.scope.filtro.reacoes.value);
    }
    // :: Listeners
    async onLimpar() {
        await this.fabricanteSelect.onLimpar();
        await this.medicamentoSelect.onLimpar();
        await this.principiosAtivosSelect.onLimpar();
        await this.reacoesSelect.onLimpar();
        this.fabricantesManager.clearData();
        this.scope.table.qtdeFabricatesAnalisados = 0;
        this.scope.table.qtdeCoberturasCompletas = 0;
        this.scope.table.qtdeCoberturaParciais = 0;
        this.scope.table.qtdeNaoDocumentadas = 0;
        this.scope.table.reacaoPorFabricanteData = null;
    }
    async onConsultar() {
        const queryRequest = {
            //fabricantes: this.fabricanteSelect.selectedCodes,
            medicamentos: this.medicamentoSelect.selectedCodes,
            principios: this.principiosAtivosSelect.selectedCodes,
            reacoes: this.reacoesSelect.selectedCodes
        };
        if ($89d3fe3f861916c4$var$LOG.isDebugEnabled()) $89d3fe3f861916c4$var$LOG.debug(`queryBulas(${JSON.stringify(queryRequest)})`);
        this.scope.loading = true;
        const data = await (0, $b3760d9351cad522$export$2e2bcd8739ae039)(queryRequest).finally(()=>this.scope.loading = false);
        await this.fabricantesManager.updateData(data);
        this.scope.table.qtdeFabricatesAnalisados = data.qtdeFabricates;
        this.scope.table.qtdeCoberturasCompletas = data.qtdeCoberturasCompletas;
        this.scope.table.qtdeCoberturaParciais = data.qtdeCoberturaParciais;
        this.scope.table.qtdeNaoDocumentadas = data.qtdeNaoDocumentadas;
        this.scope.table.reacaoPorFabricanteData = data.grade;
    }
    // :: Update ViewState from Intent
    async updateFilterStateFromIntent(key, initialization) {
        const me = this;
        const tmpKey = new (0, $d827abede00c186c$export$376ba4289c9c1b60)(this.app, new (0, $53ed881bf0c83c14$export$a6315278596fdad3)(key.place));
        let pendingTasks = [];
        let changed = initialization;
        changed = updatePrincipiosAtivos() || changed;
        changed = updateFabricantes() || changed;
        changed = updateMedicamentos() || changed;
        changed = updateReacoes() || changed;
        if (pendingTasks.length > 0) await Promise.all(pendingTasks);
        return changed;
        function updatePrincipiosAtivos() {
            tmpKey.principioAtivos = $89d3fe3f861916c4$var$Util.keysToParam(me.scope.filtro.principiosAtivos.value);
            const ov = tmpKey.principioAtivos;
            const nv = key.principioAtivos;
            if (ov !== nv) {
                pendingTasks.push(me.principiosAtivosSelect.setSelectedCodes($89d3fe3f861916c4$var$Util.paramToKeys(nv)));
                return true;
            }
            return false;
        }
        function updateFabricantes() {
            tmpKey.fabricantes = $89d3fe3f861916c4$var$Util.keysToParam(me.scope.filtro.fabricantes.value);
            const ov = tmpKey.fabricantes;
            const nv = key.fabricantes;
            if (ov !== nv) {
                pendingTasks.push(me.fabricanteSelect.setSelectedCodes($89d3fe3f861916c4$var$Util.paramToKeys(nv)));
                return true;
            }
            return false;
        }
        function updateMedicamentos() {
            tmpKey.medicamentos = $89d3fe3f861916c4$var$Util.keysToParam(me.scope.filtro.medicamentos.value);
            const ov = tmpKey.medicamentos;
            const nv = key.medicamentos;
            if (ov !== nv) {
                pendingTasks.push(me.medicamentoSelect.setSelectedCodes($89d3fe3f861916c4$var$Util.paramToKeys(nv)));
                return true;
            }
            return false;
        }
        function updateReacoes() {
            tmpKey.reacoes = $89d3fe3f861916c4$var$Util.keysToParam(me.scope.filtro.reacoes.value);
            const ov = tmpKey.reacoes;
            const nv = key.reacoes;
            if (ov !== nv) {
                pendingTasks.push(me.reacoesSelect.setSelectedCodes($89d3fe3f861916c4$var$Util.paramToKeys(nv)));
                return true;
            }
            return false;
        }
    }
}
var $89d3fe3f861916c4$export$2e2bcd8739ae039 = $89d3fe3f861916c4$export$dc32248f18a293b9;
const $89d3fe3f861916c4$var$Util = {
    keysToParam (keys) {
        return Array.isArray(keys) && keys.length > 0 ? keys.join(',') : undefined;
    },
    paramToKeys (v) {
        if (!v) return [];
        return v.split(',');
    },
    removerAcentos (str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
};
class $89d3fe3f861916c4$var$FabricanteManager {
    options = [];
    tableScope;
    selectPresenter;
    empresasOriginal = [];
    rowsOriginal = [];
    updating = false;
    fetch = async (rq)=>{
        if (this.options.length === 0) return (0, $3ca2b7ae1bd77e45$export$2e2bcd8739ae039).fabricantes(rq);
        if (!rq.text) return {
            duration: 0,
            itens: this.options
        };
        const searchText = $89d3fe3f861916c4$var$Util.removerAcentos(rq.text).toUpperCase();
        const filtedOptions = [];
        for (const option of this.options)if (option.descricaoUpper.includes(searchText)) filtedOptions.push(option);
        return {
            duration: 0,
            itens: filtedOptions
        };
    };
    assignTableScope(tableScope) {
        this.tableScope = tableScope;
    }
    assignSelectPresenter(presenter) {
        this.selectPresenter = presenter;
        this.selectPresenter.onCheckChangedListener = (codes)=>this.onCheckChanged(codes);
    }
    clearData() {
        this.updating = true;
        try {
            this.options.length = 0;
            this.empresasOriginal = [];
            this.rowsOriginal = [];
            this.selectPresenter.onLimpar();
        } finally{
            this.updating = false;
        }
    }
    async updateData(data) {
        this.updating = true;
        try {
            this.doUpdateData(data);
        } finally{
            this.updating = false;
        }
    }
    async doUpdateData(data) {
        this.empresasOriginal = data.grade.fabricantes;
        this.rowsOriginal = data.grade.rows;
        this.options.length = 0;
        for (const empresa of data.grade.fabricantes)this.options.push({
            id: empresa.id,
            descricao: empresa.nome,
            descricaoUpper: $89d3fe3f861916c4$var$Util.removerAcentos(empresa.nome.toUpperCase())
        });
        const localeOptions = {
            sensitivity: 'base'
        };
        this.options.sort((a, b)=>a.descricao.localeCompare(b.descricao, undefined, localeOptions));
        this.selectPresenter.forceContent(this.options);
        const selectedCodeSet = new Set(this.selectPresenter.selectedCodes);
        if (selectedCodeSet.size > 5) selectedCodeSet.clear();
        if (selectedCodeSet.size === 0) for(let i = 0; i < 5; i++){
            const option = this.options[i];
            if (option) selectedCodeSet.add(option.id);
            else break;
        }
        if (selectedCodeSet.size > 0) await this.selectPresenter.setSelectedExistingCodes([
            ...selectedCodeSet
        ]);
        const [newEmpresas, newRows] = this.trimData(selectedCodeSet);
        data.grade.fabricantes = newEmpresas;
        data.grade.rows = newRows;
    }
    trimData(selectedCodeSet) {
        const existingColSet = new Set();
        const newEmpresas = [];
        for(let i = 0; i < this.empresasOriginal.length; i++){
            const empresa = this.empresasOriginal[i];
            if (selectedCodeSet.has(empresa.id)) {
                newEmpresas.push(empresa);
                existingColSet.add(i);
            }
        }
        const newRows = [];
        for (const row of this.rowsOriginal){
            const newRow = {
                id: row.id,
                qtdeCasos: row.qtdeCasos,
                reacao: row.reacao,
                medicamentos: []
            };
            for(let col = 0; col < row.medicamentos.length; col++)if (existingColSet.has(col)) newRow.medicamentos.push(row.medicamentos[col]);
            newRows.push(newRow);
        }
        return [
            newEmpresas,
            newRows
        ];
    }
    onCheckChanged(codes) {
        if (this.updating) return;
        if (this.tableScope.reacaoPorFabricanteData) {
            const [newEmpresas, newRows] = this.trimData(new Set(codes));
            this.tableScope.reacaoPorFabricanteData.fabricantes = newEmpresas;
            this.tableScope.reacaoPorFabricanteData.rows = newRows;
            this.tableScope.update();
        }
    }
}






class $f25a5c3381469483$export$2e2bcd8739ae039 {
    static convertBRDateToIsoString(date) {
        let [d, m, y] = date.split(/\D/);
        return new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10)).toISOString();
    }
    static parseBrazilianDate(s) {
        if (!s || s.length < 10) return undefined;
        s = s.trim();
        if (s.length < 10) return undefined;
        if (s.charAt(2) !== '/' || s.charAt(5) !== '/') return undefined;
        const dd = Number.parseInt(s.substring(0, 2));
        const mm = Number.parseInt(s.substring(3, 5));
        const yyyy = Number.parseInt(s.substring(6, 10));
        if (Number.isNaN(dd) || Number.isNaN(mm) || Number.isNaN(yyyy)) return undefined;
        return new Date(yyyy, mm - 1, dd);
    }
    static formatBrazilianDate(dt) {
        if (!dt) return '';
        const dd = `${dt.getDate()}`.padStart(2, '0');
        const mm = `${dt.getMonth() + 1}`.padStart(2, '0');
        const yyyy = `${dt.getFullYear()}`.padStart(4, '0');
        return `${dd}/${mm}/${yyyy}`;
    }
    static parseIsoDate(s) {
        if (!s || s.length < 10) return undefined;
        s = s.trim();
        if (s.length < 10) return undefined;
        if (s.charAt(4) !== '-' || s.charAt(7) !== '-') return undefined;
        const yyyy = Number.parseInt(s.substring(0, 4));
        const mm = Number.parseInt(s.substring(5, 7));
        const dd = Number.parseInt(s.substring(8, 10));
        if (Number.isNaN(dd) || Number.isNaN(mm) || Number.isNaN(yyyy)) return undefined;
        return new Date(yyyy, mm - 1, dd);
    }
}




class $e9f42e6813ba9eb8$export$16de16cd73637494 extends (0, $bb6e76f992d97bab$export$2089ee9a829aa848) {
    get place() {
        return (0, $111375feb76f4602$export$ab4fed16567445e2).analiseReacoes;
    }
    // :: Property hasData
    get temDados() {
        return this._intent.getParameterAsString((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesTemDados) === '1';
    }
    set temDados(v) {
        this._intent.setParameter((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesTemDados, v ? 1 : null);
    }
    // :: Property dataInicial
    get dataInicial() {
        return $e9f42e6813ba9eb8$var$parseDate(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesDtInicial);
    }
    set dataInicial(v) {
        $e9f42e6813ba9eb8$var$updateDate(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesDtInicial, v);
    }
    // :: Property dataFinal
    get dataFinal() {
        return $e9f42e6813ba9eb8$var$parseDate(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesDtFinal);
    }
    set dataFinal(v) {
        $e9f42e6813ba9eb8$var$updateDate(this._intent, (0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesDtFinal, v);
    }
    // :: Busca Geral
    get buscaGeralText() {
        return this._intent.getParameterAsString((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesBuscaGeral);
    }
    set buscaGeralText(v) {
        this._intent.setParameter((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesBuscaGeral, v);
    }
    // :: Busca Reacoes
    get buscaReacaoText() {
        return this._intent.getParameterAsString((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesBuscaReacoes);
    }
    set buscaReacaoText(v) {
        this._intent.setParameter((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesBuscaReacoes, v);
    }
    // :: Busca Medicamentos
    get buscaMedicamentoText() {
        return this._intent.getParameterAsString((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesBuscaMedicamentos);
    }
    set buscaMedicamentoText(v) {
        this._intent.setParameter((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesBuscaMedicamentos, v);
    }
    // :: Status da Bula
    get statusBula() {
        return this._intent.getParameterAsNumber((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesStatusBula);
    }
    set statusBula(v) {
        this._intent.setParameter((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesStatusBula, v === 0 ? null : v);
    }
    // :: Gravidade
    get gravidade() {
        return this._intent.getParameterAsNumber((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesGravidade);
    }
    set gravidade(v) {
        this._intent.setParameter((0, $111375feb76f4602$export$c9753d5230386a7e).analiseReacoesGravidade, v === 0 ? null : v);
    }
}
// :: Utils
function $e9f42e6813ba9eb8$var$parseDate(intent, name) {
    const v = intent.getParameterAsString(name);
    return v ? (0, $f25a5c3381469483$export$2e2bcd8739ae039).parseIsoDate(v) : undefined;
}
function $e9f42e6813ba9eb8$var$updateDate(intent, name, v) {
    let data = v ? v.toISOString().substring(0, 10) : null;
    intent.setParameter(name, data);
}




class $0679dd9080d488b2$export$df50132aa0668e0e extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    buscaGeralText = '';
    buscaReacaoText = '';
    buscaMedicamentoText = '';
    statusBula = 0;
    statusBulaOptions = [];
    gravidade = 0;
    gravidadeOptions = [];
    periodo = [];
    onBuscaGeralTextChanged = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_STRING;
    onBuscaReacaoTextChanged = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_STRING;
    onBuscaMedicamentoChanged = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_STRING;
    onStatusBulaChanged = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_NUMBER;
    onGravidadeChanged = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_NUMBER;
    onPeriodoChange = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_ONE();
    onConsultar = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
    onLimpar = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$df50132aa0668e0e.prototype, "buscaGeralText", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$df50132aa0668e0e.prototype, "buscaReacaoText", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$df50132aa0668e0e.prototype, "buscaMedicamentoText", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$df50132aa0668e0e.prototype, "statusBula", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$df50132aa0668e0e.prototype, "statusBulaOptions", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$df50132aa0668e0e.prototype, "gravidade", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$df50132aa0668e0e.prototype, "gravidadeOptions", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$df50132aa0668e0e.prototype, "periodo", void 0);
$0679dd9080d488b2$export$df50132aa0668e0e = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $0679dd9080d488b2$export$df50132aa0668e0e);
class $0679dd9080d488b2$export$ad8f2ba3c90f118 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    visible = false;
    data = {
        qtdeNotificacoes: {
            valor: 0,
            reacoes: 0
        },
        qtdeForaDeBula: {
            valor: 0,
            reacoes: 0
        },
        qtdeNaoVerificada: 0,
        qtdePendentesVerificacao: 0
    };
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$ad8f2ba3c90f118.prototype, "visible", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$ad8f2ba3c90f118.prototype, "data", void 0);
$0679dd9080d488b2$export$ad8f2ba3c90f118 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $0679dd9080d488b2$export$ad8f2ba3c90f118);
class $0679dd9080d488b2$export$afbfad8885a3127d extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    uid = '';
    left = null;
    right = null;
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$afbfad8885a3127d.prototype, "left", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$afbfad8885a3127d.prototype, "right", void 0);
$0679dd9080d488b2$export$afbfad8885a3127d = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $0679dd9080d488b2$export$afbfad8885a3127d);
class $0679dd9080d488b2$export$e953a572acd241a8 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    uid = '';
    expanded = false;
    data = null;
    rows = new (0, $22863e546644af96$export$2b76b04f92326cd)(this);
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$e953a572acd241a8.prototype, "expanded", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$e953a572acd241a8.prototype, "data", void 0);
$0679dd9080d488b2$export$e953a572acd241a8 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $0679dd9080d488b2$export$e953a572acd241a8);
class $0679dd9080d488b2$export$11d5e140715afba1 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    qtdeNotificacoes = 0;
    periodoDeAnalise = '';
    rows = new (0, $22863e546644af96$export$2b76b04f92326cd)(this);
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$11d5e140715afba1.prototype, "qtdeNotificacoes", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$11d5e140715afba1.prototype, "periodoDeAnalise", void 0);
$0679dd9080d488b2$export$11d5e140715afba1 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $0679dd9080d488b2$export$11d5e140715afba1);
class $0679dd9080d488b2$export$cf06ee4686c8dee extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    filtro = new $0679dd9080d488b2$export$df50132aa0668e0e();
    loading = false;
    resumo = null;
    grade = null;
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$cf06ee4686c8dee.prototype, "loading", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$cf06ee4686c8dee.prototype, "resumo", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $0679dd9080d488b2$export$cf06ee4686c8dee.prototype, "grade", void 0);
$0679dd9080d488b2$export$cf06ee4686c8dee = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $0679dd9080d488b2$export$cf06ee4686c8dee);
var $0679dd9080d488b2$export$2e2bcd8739ae039 = $0679dd9080d488b2$export$cf06ee4686c8dee;



var $97bd6fc4b0f5d06f$export$2e2bcd8739ae039 = async (request)=>{
    const url = (0, $15ce1f86191d2574$export$2e2bcd8739ae039).newUrl('/api/v1/notificacoes/reacoes');
    request.dataInicio && url.searchParams.append('data-inicio', request.dataInicio);
    request.dataFim && url.searchParams.append('data-fim', request.dataFim);
    request.statusBulaValue && url.searchParams.append('status', `${request.statusBulaValue}`);
    request.gravidadeValue && url.searchParams.append('gravidade', `${request.gravidadeValue}`);
    request.buscaGeralText && url.searchParams.append('geral', request.buscaGeralText);
    request.buscaReacaoText && url.searchParams.append('reacao', request.buscaReacaoText);
    request.buscaMedicamentoText && url.searchParams.append('medicamento', request.buscaMedicamentoText);
    return await (0, $15ce1f86191d2574$export$2e2bcd8739ae039).authGet(url);
};


var $1cdc3e995de726fc$export$2e2bcd8739ae039 = (0, $97bd6fc4b0f5d06f$export$2e2bcd8739ae039);


const $02d98a5925a63aa6$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('AnaliseReacoesPresenter');
class $02d98a5925a63aa6$export$e6ae035d9e3d9967 extends (0, $cba1a0683916948c$export$f73f61399fd7814) {
    // :: Fields
    parentSlot = (0, $5e892709dbe5636f$export$49db20642bd540b0);
    rowIdGen = 1;
    // :: Constructor
    constructor(app){
        super(app, new (0, $0679dd9080d488b2$export$cf06ee4686c8dee)());
        const filtroCtrl = new (0, $a25a305be2ca5b1d$export$893c88c42e3630f9)(this, this.scope.filtro);
        this.scope.filtro.statusBulaOptions = $02d98a5925a63aa6$var$mkStatusBulaOptions();
        this.scope.filtro.gravidadeOptions = $02d98a5925a63aa6$var$mkGravidadeOptions();
        this.scope.filtro.onLimpar = filtroCtrl.action(this.onLimpar, this);
        this.scope.filtro.onConsultar = filtroCtrl.action(this.onConsultar, this);
        this.scope.filtro.onBuscaGeralTextChanged = filtroCtrl.action(this.onBuscaGeralTextChanged, this);
        this.scope.filtro.onBuscaReacaoTextChanged = filtroCtrl.action(this.onBuscaReacaoTextChanged, this);
        this.scope.filtro.onBuscaMedicamentoChanged = filtroCtrl.action(this.onBuscaMedicamentoTextChanged, this);
        this.scope.filtro.onStatusBulaChanged = filtroCtrl.action(this.onStatusBulaChanged, this);
        this.scope.filtro.onGravidadeChanged = filtroCtrl.action(this.onGravidadeChanged, this);
        this.scope.filtro.onPeriodoChange = filtroCtrl.action(this.onPeriodoChanged, this);
        this.scope.filtro.update = filtroCtrl.update;
    }
    // :: Cube lifecycle
    async applyParameters(intent, initialization) {
        const key = new (0, $e9f42e6813ba9eb8$export$16de16cd73637494)(this.app, intent);
        this.parentSlot = key.parentSlot;
        // Puxa configuracao da intencao
        let changed = this.updatePeriodo(key) || initialization;
        changed = this.updateBuscaGeralText(key) || changed;
        changed = this.updateBuscaReacaoText(key) || changed;
        changed = this.updateBuscaMedicamentoText(key) || changed;
        changed = this.updateStatusBulaMedicamentosGeral(key) || changed;
        changed = this.updateGravidadeMedicamentosGeral(key) || changed;
        this.parentSlot(this.scope);
        if (changed && key.temDados) await this.onConsultar();
        return true;
    }
    publishParameters(intent) {
        const key = new (0, $e9f42e6813ba9eb8$export$16de16cd73637494)(this.app, intent);
        key.dataInicial = this.scope.filtro.periodo[0];
        key.dataFinal = this.scope.filtro.periodo[1];
        key.buscaGeralText = this.scope.filtro.buscaGeralText;
        key.buscaReacaoText = this.scope.filtro.buscaReacaoText;
        key.buscaMedicamentoText = this.scope.filtro.buscaMedicamentoText;
        key.statusBula = this.scope.filtro.statusBula;
        key.gravidade = this.scope.filtro.gravidade;
        key.temDados = this.scope.grade !== null;
    }
    // :: Listeners
    async onBuscaGeralTextChanged(txt) {
        this.scope.filtro.buscaGeralText = txt;
    }
    async onBuscaReacaoTextChanged(txt) {
        this.scope.filtro.buscaReacaoText = txt;
    }
    async onBuscaMedicamentoTextChanged(txt) {
        this.scope.filtro.buscaMedicamentoText = txt;
    }
    async onStatusBulaChanged(status) {
        this.scope.filtro.statusBula = status;
    }
    async onGravidadeChanged(status) {
        this.scope.filtro.gravidade = status;
    }
    async onPeriodoChanged(periodo) {
        if (periodo.length === 1) this.scope.filtro.periodo = periodo;
        else if (periodo.length > 1) this.scope.filtro.periodo = periodo;
        this.scope.filtro.periodo = periodo;
    }
    async onLimpar() {
        this.scope.filtro.buscaGeralText = '';
        this.scope.filtro.buscaMedicamentoText = '';
        this.scope.filtro.buscaReacaoText = '';
        this.scope.filtro.statusBula = 0;
        this.scope.filtro.gravidade = 0;
        this.scope.resumo = null;
        this.scope.grade = null;
    }
    async onConsultar() {
        let dataInicial = this.scope.filtro.periodo[0] || new Date();
        let dataFinal = this.scope.filtro.periodo[1] || new Date();
        if (dataInicial.getTime() > dataFinal.getTime()) {
            let tmp = dataFinal;
            dataFinal = dataInicial;
            dataInicial = tmp;
        }
        this.scope.filtro.periodo[0] = dataInicial;
        this.scope.filtro.periodo[1] = dataFinal;
        const queryRequest = {
            dataInicio: dataInicial.toISOString().substring(0, 10),
            dataFim: dataFinal.toISOString().substring(0, 10),
            buscaGeralText: this.scope.filtro.buscaGeralText,
            buscaReacaoText: this.scope.filtro.buscaReacaoText,
            buscaMedicamentoText: this.scope.filtro.buscaMedicamentoText,
            statusBulaValue: this.scope.filtro.statusBula,
            gravidadeValue: this.scope.filtro.gravidade
        };
        if ($02d98a5925a63aa6$var$LOG.isDebugEnabled()) $02d98a5925a63aa6$var$LOG.debug(`queryReacoes(${JSON.stringify(queryRequest)})`);
        this.scope.loading = true;
        const data = await (0, $1cdc3e995de726fc$export$2e2bcd8739ae039)(queryRequest).finally(()=>this.scope.loading = false);
        data.grade.titulo.qtdeNotificacoes = data.grade.titulo.qtdeNotificacoes;
        data.grade.titulo.periodoDeAnalise = data.grade.titulo.periodoDeAnalise;
        const gradeCtrl = new (0, $a25a305be2ca5b1d$export$893c88c42e3630f9)(this, new (0, $0679dd9080d488b2$export$11d5e140715afba1)());
        this.scope.grade = gradeCtrl.scope;
        this.scope.grade.qtdeNotificacoes = data.grade.titulo.qtdeNotificacoes;
        this.scope.grade.periodoDeAnalise = data.grade.titulo.periodoDeAnalise;
        for (const rowData of data.grade.linhas){
            const rowCtrl = new (0, $a25a305be2ca5b1d$export$893c88c42e3630f9)(this, new (0, $0679dd9080d488b2$export$e953a572acd241a8)());
            rowCtrl.scope.uid = `${this.rowIdGen++}`;
            rowCtrl.scope.data = rowData;
            rowCtrl.scope.update = rowCtrl.update;
            this.scope.grade.rows.push(rowCtrl.scope);
            for (const rowDetailData of rowData.reacoes){
                const rowDeailtCtrl = new (0, $a25a305be2ca5b1d$export$893c88c42e3630f9)(this, new (0, $0679dd9080d488b2$export$afbfad8885a3127d)());
                rowDeailtCtrl.scope.uid = rowDetailData.id;
                rowDeailtCtrl.scope.left = rowDetailData.left;
                rowDeailtCtrl.scope.right = rowDetailData.right;
                rowDeailtCtrl.scope.update = rowDeailtCtrl.update;
                rowCtrl.scope.rows.push(rowDeailtCtrl.scope);
            }
        }
        this.scope.grade.update = gradeCtrl.update;
        const resumoCtrl = new (0, $a25a305be2ca5b1d$export$893c88c42e3630f9)(this, new (0, $0679dd9080d488b2$export$ad8f2ba3c90f118)());
        this.scope.resumo = resumoCtrl.scope;
        this.scope.resumo.data = data.resumo;
        this.scope.resumo.update = resumoCtrl.update;
    }
    // :: Update ViewState from Intent
    updatePeriodo(key) {
        const now = new Date();
        const defaultDataFinal = now;
        const defaultDataInicial = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
        const curDataInicial = this.scope.filtro.periodo[0];
        const currentDataFinal = this.scope.filtro.periodo[1];
        let prmDataInicial = key.dataInicial || defaultDataInicial;
        let pDataFinal = key.dataFinal || defaultDataFinal;
        if (prmDataInicial.getTime() > pDataFinal.getTime()) {
            let tmp = pDataFinal;
            pDataFinal = prmDataInicial;
            prmDataInicial = tmp;
        }
        this.scope.filtro.periodo = [
            prmDataInicial,
            pDataFinal
        ];
        let v1 = prmDataInicial ? prmDataInicial.getTime() : 0;
        let v2 = curDataInicial ? curDataInicial.getTime() : 0;
        if (v1 !== v2) return true;
        v1 = pDataFinal ? pDataFinal.getTime() : 0;
        v2 = currentDataFinal ? currentDataFinal.getTime() : 0;
        return v1 !== v2;
    }
    updateBuscaGeralText(key) {
        const ov = this.scope.filtro.buscaGeralText;
        const nv = key.buscaGeralText;
        this.scope.filtro.buscaGeralText = nv;
        return ov !== nv;
    }
    updateBuscaReacaoText(key) {
        const ov = this.scope.filtro.buscaReacaoText;
        const nv = key.buscaReacaoText;
        this.scope.filtro.buscaReacaoText = nv;
        return ov !== nv;
    }
    updateBuscaMedicamentoText(key) {
        const ov = this.scope.filtro.buscaMedicamentoText;
        const nv = key.buscaMedicamentoText;
        this.scope.filtro.buscaMedicamentoText = nv;
        return ov !== nv;
    }
    updateStatusBulaMedicamentosGeral(key) {
        const ov = this.scope.filtro.statusBula;
        const nv = key.statusBula;
        this.scope.filtro.statusBula = nv;
        return ov !== nv;
    }
    updateGravidadeMedicamentosGeral(key) {
        const ov = this.scope.filtro.gravidade;
        const nv = key.gravidade;
        this.scope.filtro.gravidade = nv;
        return ov !== nv;
    }
}
var $02d98a5925a63aa6$export$2e2bcd8739ae039 = $02d98a5925a63aa6$export$e6ae035d9e3d9967;
// :: Statics
function $02d98a5925a63aa6$var$mkStatusBulaOptions() {
    return [
        {
            value: 0,
            label: 'Todos os Status'
        },
        {
            value: 2,
            label: 'Fora da Bula'
        },
        {
            value: 3,
            label: "N\xe3o verificado"
        },
        {
            value: 4,
            label: 'Na bula'
        }
    ];
}
function $02d98a5925a63aa6$var$mkGravidadeOptions() {
    return [
        {
            value: 0,
            label: 'Todas'
        },
        {
            value: 1,
            label: "Amea\xe7a \xe0 vida"
        },
        {
            value: 2,
            label: "Anomalia cong\xeanita ou malforma\xe7\xe3o ao nascer"
        },
        {
            value: 4,
            label: "Hospitaliza\xe7\xe3o"
        },
        {
            value: 8,
            label: 'Incapacidade persistente ou significativa'
        },
        {
            value: 16,
            label: 'Outro efeito clinicamente significativo'
        },
        {
            value: 32,
            label: "Resultou em \xf3bito"
        }
    ];
}



const $e1a4a40ca595b517$var$prepare = (0, $087833a4329e9d68$export$21cfd458a0199aee).lazyBuild({
    'bulas': {
        presenter: (0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).creator((0, $89d3fe3f861916c4$export$dc32248f18a293b9), (0, $111375feb76f4602$export$ab4fed16567445e2), 'analiseBulas')
    },
    'reacoes': {
        presenter: (0, $6ac1f5c10c6d09e1$export$2f77e7adfbeab348).creator((0, $02d98a5925a63aa6$export$e6ae035d9e3d9967), (0, $111375feb76f4602$export$ab4fed16567445e2), 'analiseReacoes')
    }
});
function $e1a4a40ca595b517$export$2a47f398eeff8b01() {
    $e1a4a40ca595b517$var$prepare();
    return 0, $111375feb76f4602$export$ab4fed16567445e2;
}





class $f281847c15bd8905$export$a3fbec8e99c35ff9 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    version = '1.0.0';
    subtitle = 'DEVEL';
    title = 'unknown';
    loggedIn = false;
    avatar = 'https://picsum.photos/id/823/400';
    onBuscaTermo = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_STRING;
    quickLinkData = [];
    quickLinkVersion = 0;
    onHome = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
    onClickLogin = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
    onIndicadores = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
    onTrocaTema = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
    onAlert = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_STRING;
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$a3fbec8e99c35ff9.prototype, "version", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$a3fbec8e99c35ff9.prototype, "subtitle", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$a3fbec8e99c35ff9.prototype, "title", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$a3fbec8e99c35ff9.prototype, "loggedIn", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$a3fbec8e99c35ff9.prototype, "avatar", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$a3fbec8e99c35ff9.prototype, "quickLinkVersion", void 0);
$f281847c15bd8905$export$a3fbec8e99c35ff9 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $f281847c15bd8905$export$a3fbec8e99c35ff9);
class $f281847c15bd8905$export$4b106156bfc1c581 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    onOpenAlert = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION_ONE();
}
$f281847c15bd8905$export$4b106156bfc1c581 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $f281847c15bd8905$export$4b106156bfc1c581);
class $f281847c15bd8905$export$b09e8598ef78a5d8 extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    type = 'push';
    size = 2;
    active = true;
    version = 0;
    items = [];
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$b09e8598ef78a5d8.prototype, "type", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$b09e8598ef78a5d8.prototype, "size", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$b09e8598ef78a5d8.prototype, "active", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$b09e8598ef78a5d8.prototype, "version", void 0);
$f281847c15bd8905$export$b09e8598ef78a5d8 = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $f281847c15bd8905$export$b09e8598ef78a5d8);
class $f281847c15bd8905$export$56ecde165a7abc6a extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    title = undefined;
    minWidth = undefined;
    minHeight = undefined;
    height = undefined;
    width = undefined;
    keepOpenOnPrimaryAction = undefined;
    keepOpenOnSecondaryAction = undefined;
    focusOnPrimaryAction = undefined;
    focusOnSecondaryAction = undefined;
    primaryAction = undefined;
    secondaryAction = undefined;
    content = undefined;
    onClose = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "title", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "minWidth", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "minHeight", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "height", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "width", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "keepOpenOnPrimaryAction", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "keepOpenOnSecondaryAction", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "focusOnPrimaryAction", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "focusOnSecondaryAction", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "primaryAction", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "secondaryAction", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$56ecde165a7abc6a.prototype, "content", void 0);
$f281847c15bd8905$export$56ecde165a7abc6a = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $f281847c15bd8905$export$56ecde165a7abc6a);
class $f281847c15bd8905$export$884432535b5866ab extends $f281847c15bd8905$export$56ecde165a7abc6a {
    severity = 'info';
    message = undefined;
    onClose = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$884432535b5866ab.prototype, "severity", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$884432535b5866ab.prototype, "message", void 0);
$f281847c15bd8905$export$884432535b5866ab = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $f281847c15bd8905$export$884432535b5866ab);
class $f281847c15bd8905$export$d8d9d79b6626505f extends (0, $7387433882612ece$export$775b6bb06e53a214) {
    header = new $f281847c15bd8905$export$a3fbec8e99c35ff9();
    menu = new $f281847c15bd8905$export$b09e8598ef78a5d8();
    page = undefined;
    dialog = undefined;
    alert = undefined;
    onLogin = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
    onHome = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
    onAnaliseBulas = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
    onAnaliseReacoes = (0, $7387433882612ece$export$775b6bb06e53a214).ASYNC_ACTION;
}
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$d8d9d79b6626505f.prototype, "page", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$d8d9d79b6626505f.prototype, "dialog", void 0);
(0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $426b9d778cb7cf76$export$d1203567a167490e)()
], $f281847c15bd8905$export$d8d9d79b6626505f.prototype, "alert", void 0);
$f281847c15bd8905$export$d8d9d79b6626505f = (0, $8e874a2fb001c377$export$29e00dfd3077644b)([
    (0, $5d20d4717b59b132$export$77cea355fa80b5f4)
], $f281847c15bd8905$export$d8d9d79b6626505f);



parcelRequire("jXEQt");
function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;





var $jXEQt = parcelRequire("jXEQt");
var $ca0c2c480f9252ec$var$Xn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $ca0c2c480f9252ec$var$ls(l) {
    return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var $ca0c2c480f9252ec$var$jc = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ (function(l) {
    (function() {
        var p = {}.hasOwnProperty;
        function u() {
            for(var I = "", E = 0; E < arguments.length; E++){
                var S = arguments[E];
                S && (I = _(I, L(S)));
            }
            return I;
        }
        function L(I) {
            if (typeof I == "string" || typeof I == "number") return I;
            if (typeof I != "object") return "";
            if (Array.isArray(I)) return u.apply(null, I);
            if (I.toString !== Object.prototype.toString && !I.toString.toString().includes("[native code]")) return I.toString();
            var E = "";
            for(var S in I)p.call(I, S) && I[S] && (E = _(E, S));
            return E;
        }
        function _(I, E) {
            return E ? I ? I + " " + E : I + E : I;
        }
        l.exports ? (u.default = u, l.exports = u) : window.classNames = u;
    })();
})($ca0c2c480f9252ec$var$jc);
var $ca0c2c480f9252ec$var$lv = $ca0c2c480f9252ec$var$jc.exports;
const $ca0c2c480f9252ec$var$Oe = /* @__PURE__ */ $ca0c2c480f9252ec$var$ls($ca0c2c480f9252ec$var$lv);
function $ca0c2c480f9252ec$var$cv(l, p, u, L) {
    var _ = -1, I = l == null ? 0 : l.length;
    for(L && I && (u = l[++_]); ++_ < I;)u = p(u, l[_], _, l);
    return u;
}
var $ca0c2c480f9252ec$var$uv = $ca0c2c480f9252ec$var$cv;
function $ca0c2c480f9252ec$var$dv(l) {
    return function(p) {
        return l == null ? void 0 : l[p];
    };
}
var $ca0c2c480f9252ec$var$fv = $ca0c2c480f9252ec$var$dv, $ca0c2c480f9252ec$var$hv = $ca0c2c480f9252ec$var$fv, $ca0c2c480f9252ec$var$pv = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    \u0100: "A",
    \u0102: "A",
    \u0104: "A",
    \u0101: "a",
    \u0103: "a",
    \u0105: "a",
    \u0106: "C",
    \u0108: "C",
    \u010A: "C",
    \u010C: "C",
    \u0107: "c",
    \u0109: "c",
    \u010B: "c",
    \u010D: "c",
    \u010E: "D",
    \u0110: "D",
    \u010F: "d",
    \u0111: "d",
    \u0112: "E",
    \u0114: "E",
    \u0116: "E",
    \u0118: "E",
    \u011A: "E",
    \u0113: "e",
    \u0115: "e",
    \u0117: "e",
    \u0119: "e",
    \u011B: "e",
    \u011C: "G",
    \u011E: "G",
    \u0120: "G",
    \u0122: "G",
    \u011D: "g",
    \u011F: "g",
    \u0121: "g",
    \u0123: "g",
    \u0124: "H",
    \u0126: "H",
    \u0125: "h",
    \u0127: "h",
    \u0128: "I",
    \u012A: "I",
    \u012C: "I",
    \u012E: "I",
    \u0130: "I",
    \u0129: "i",
    \u012B: "i",
    \u012D: "i",
    \u012F: "i",
    \u0131: "i",
    \u0134: "J",
    \u0135: "j",
    \u0136: "K",
    \u0137: "k",
    \u0138: "k",
    \u0139: "L",
    \u013B: "L",
    \u013D: "L",
    \u013F: "L",
    \u0141: "L",
    \u013A: "l",
    \u013C: "l",
    \u013E: "l",
    \u0140: "l",
    \u0142: "l",
    \u0143: "N",
    \u0145: "N",
    \u0147: "N",
    \u014A: "N",
    \u0144: "n",
    \u0146: "n",
    \u0148: "n",
    \u014B: "n",
    \u014C: "O",
    \u014E: "O",
    \u0150: "O",
    \u014D: "o",
    \u014F: "o",
    \u0151: "o",
    \u0154: "R",
    \u0156: "R",
    \u0158: "R",
    \u0155: "r",
    \u0157: "r",
    \u0159: "r",
    \u015A: "S",
    \u015C: "S",
    \u015E: "S",
    \u0160: "S",
    \u015B: "s",
    \u015D: "s",
    \u015F: "s",
    \u0161: "s",
    \u0162: "T",
    \u0164: "T",
    \u0166: "T",
    \u0163: "t",
    \u0165: "t",
    \u0167: "t",
    \u0168: "U",
    \u016A: "U",
    \u016C: "U",
    \u016E: "U",
    \u0170: "U",
    \u0172: "U",
    \u0169: "u",
    \u016B: "u",
    \u016D: "u",
    \u016F: "u",
    \u0171: "u",
    \u0173: "u",
    \u0174: "W",
    \u0175: "w",
    \u0176: "Y",
    \u0177: "y",
    \u0178: "Y",
    \u0179: "Z",
    \u017B: "Z",
    \u017D: "Z",
    \u017A: "z",
    \u017C: "z",
    \u017E: "z",
    \u0132: "IJ",
    \u0133: "ij",
    \u0152: "Oe",
    \u0153: "oe",
    \u0149: "'n",
    \u017F: "s"
}, $ca0c2c480f9252ec$var$mv = $ca0c2c480f9252ec$var$hv($ca0c2c480f9252ec$var$pv), $ca0c2c480f9252ec$var$gv = $ca0c2c480f9252ec$var$mv, $ca0c2c480f9252ec$var$vv = typeof $ca0c2c480f9252ec$var$Xn == "object" && $ca0c2c480f9252ec$var$Xn && $ca0c2c480f9252ec$var$Xn.Object === Object && $ca0c2c480f9252ec$var$Xn, $ca0c2c480f9252ec$var$bv = $ca0c2c480f9252ec$var$vv, $ca0c2c480f9252ec$var$_v = $ca0c2c480f9252ec$var$bv, $ca0c2c480f9252ec$var$yv = typeof self == "object" && self && self.Object === Object && self, $ca0c2c480f9252ec$var$Av = $ca0c2c480f9252ec$var$_v || $ca0c2c480f9252ec$var$yv || Function("return this")(), $ca0c2c480f9252ec$var$wv = $ca0c2c480f9252ec$var$Av, $ca0c2c480f9252ec$var$Sv = $ca0c2c480f9252ec$var$wv, $ca0c2c480f9252ec$var$Ev = $ca0c2c480f9252ec$var$Sv.Symbol, $ca0c2c480f9252ec$var$yo = $ca0c2c480f9252ec$var$Ev;
function $ca0c2c480f9252ec$var$xv(l, p) {
    for(var u = -1, L = l == null ? 0 : l.length, _ = Array(L); ++u < L;)_[u] = p(l[u], u, l);
    return _;
}
var $ca0c2c480f9252ec$var$Cv = $ca0c2c480f9252ec$var$xv, $ca0c2c480f9252ec$var$kv = Array.isArray, $ca0c2c480f9252ec$var$Lv = $ca0c2c480f9252ec$var$kv, $ca0c2c480f9252ec$var$Sc = $ca0c2c480f9252ec$var$yo, $ca0c2c480f9252ec$var$$c = Object.prototype, $ca0c2c480f9252ec$var$Dv = $ca0c2c480f9252ec$var$$c.hasOwnProperty, $ca0c2c480f9252ec$var$Tv = $ca0c2c480f9252ec$var$$c.toString, $ca0c2c480f9252ec$var$ca = $ca0c2c480f9252ec$var$Sc ? $ca0c2c480f9252ec$var$Sc.toStringTag : void 0;
function $ca0c2c480f9252ec$var$Iv(l) {
    var p = $ca0c2c480f9252ec$var$Dv.call(l, $ca0c2c480f9252ec$var$ca), u = l[$ca0c2c480f9252ec$var$ca];
    try {
        l[$ca0c2c480f9252ec$var$ca] = void 0;
        var L = !0;
    } catch  {}
    var _ = $ca0c2c480f9252ec$var$Tv.call(l);
    return L && (p ? l[$ca0c2c480f9252ec$var$ca] = u : delete l[$ca0c2c480f9252ec$var$ca]), _;
}
var $ca0c2c480f9252ec$var$Ov = $ca0c2c480f9252ec$var$Iv, $ca0c2c480f9252ec$var$Mv = Object.prototype, $ca0c2c480f9252ec$var$Nv = $ca0c2c480f9252ec$var$Mv.toString;
function $ca0c2c480f9252ec$var$Bv(l) {
    return $ca0c2c480f9252ec$var$Nv.call(l);
}
var $ca0c2c480f9252ec$var$Pv = $ca0c2c480f9252ec$var$Bv, $ca0c2c480f9252ec$var$Ec = $ca0c2c480f9252ec$var$yo, $ca0c2c480f9252ec$var$Rv = $ca0c2c480f9252ec$var$Ov, $ca0c2c480f9252ec$var$Fv = $ca0c2c480f9252ec$var$Pv, $ca0c2c480f9252ec$var$qv = "[object Null]", $ca0c2c480f9252ec$var$Wv = "[object Undefined]", $ca0c2c480f9252ec$var$xc = $ca0c2c480f9252ec$var$Ec ? $ca0c2c480f9252ec$var$Ec.toStringTag : void 0;
function $ca0c2c480f9252ec$var$Uv(l) {
    return l == null ? l === void 0 ? $ca0c2c480f9252ec$var$Wv : $ca0c2c480f9252ec$var$qv : $ca0c2c480f9252ec$var$xc && $ca0c2c480f9252ec$var$xc in Object(l) ? $ca0c2c480f9252ec$var$Rv(l) : $ca0c2c480f9252ec$var$Fv(l);
}
var $ca0c2c480f9252ec$var$Hv = $ca0c2c480f9252ec$var$Uv;
function $ca0c2c480f9252ec$var$jv(l) {
    return l != null && typeof l == "object";
}
var $ca0c2c480f9252ec$var$$v = $ca0c2c480f9252ec$var$jv, $ca0c2c480f9252ec$var$Kv = $ca0c2c480f9252ec$var$Hv, $ca0c2c480f9252ec$var$Gv = $ca0c2c480f9252ec$var$$v, $ca0c2c480f9252ec$var$Vv = "[object Symbol]";
function $ca0c2c480f9252ec$var$Yv(l) {
    return typeof l == "symbol" || $ca0c2c480f9252ec$var$Gv(l) && $ca0c2c480f9252ec$var$Kv(l) == $ca0c2c480f9252ec$var$Vv;
}
var $ca0c2c480f9252ec$var$zv = $ca0c2c480f9252ec$var$Yv, $ca0c2c480f9252ec$var$Cc = $ca0c2c480f9252ec$var$yo, $ca0c2c480f9252ec$var$Zv = $ca0c2c480f9252ec$var$Cv, $ca0c2c480f9252ec$var$Xv = $ca0c2c480f9252ec$var$Lv, $ca0c2c480f9252ec$var$Jv = $ca0c2c480f9252ec$var$zv, $ca0c2c480f9252ec$var$Qv = 1 / 0, $ca0c2c480f9252ec$var$kc = $ca0c2c480f9252ec$var$Cc ? $ca0c2c480f9252ec$var$Cc.prototype : void 0, $ca0c2c480f9252ec$var$Lc = $ca0c2c480f9252ec$var$kc ? $ca0c2c480f9252ec$var$kc.toString : void 0;
function $ca0c2c480f9252ec$var$Kc(l) {
    if (typeof l == "string") return l;
    if ($ca0c2c480f9252ec$var$Xv(l)) return $ca0c2c480f9252ec$var$Zv(l, $ca0c2c480f9252ec$var$Kc) + "";
    if ($ca0c2c480f9252ec$var$Jv(l)) return $ca0c2c480f9252ec$var$Lc ? $ca0c2c480f9252ec$var$Lc.call(l) : "";
    var p = l + "";
    return p == "0" && 1 / l == -$ca0c2c480f9252ec$var$Qv ? "-0" : p;
}
var $ca0c2c480f9252ec$var$eb = $ca0c2c480f9252ec$var$Kc, $ca0c2c480f9252ec$var$tb = $ca0c2c480f9252ec$var$eb;
function $ca0c2c480f9252ec$var$nb(l) {
    return l == null ? "" : $ca0c2c480f9252ec$var$tb(l);
}
var $ca0c2c480f9252ec$var$Ao = $ca0c2c480f9252ec$var$nb, $ca0c2c480f9252ec$var$rb = $ca0c2c480f9252ec$var$gv, $ca0c2c480f9252ec$var$ib = $ca0c2c480f9252ec$var$Ao, $ca0c2c480f9252ec$var$ab = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, $ca0c2c480f9252ec$var$sb = "\\u0300-\\u036f", $ca0c2c480f9252ec$var$ob = "\\ufe20-\\ufe2f", $ca0c2c480f9252ec$var$lb = "\\u20d0-\\u20ff", $ca0c2c480f9252ec$var$cb = $ca0c2c480f9252ec$var$sb + $ca0c2c480f9252ec$var$ob + $ca0c2c480f9252ec$var$lb, $ca0c2c480f9252ec$var$ub = "[" + $ca0c2c480f9252ec$var$cb + "]", $ca0c2c480f9252ec$var$db = RegExp($ca0c2c480f9252ec$var$ub, "g");
function $ca0c2c480f9252ec$var$fb(l) {
    return l = $ca0c2c480f9252ec$var$ib(l), l && l.replace($ca0c2c480f9252ec$var$ab, $ca0c2c480f9252ec$var$rb).replace($ca0c2c480f9252ec$var$db, "");
}
var $ca0c2c480f9252ec$var$hb = $ca0c2c480f9252ec$var$fb, $ca0c2c480f9252ec$var$pb = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function $ca0c2c480f9252ec$var$mb(l) {
    return l.match($ca0c2c480f9252ec$var$pb) || [];
}
var $ca0c2c480f9252ec$var$gb = $ca0c2c480f9252ec$var$mb, $ca0c2c480f9252ec$var$vb = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function $ca0c2c480f9252ec$var$bb(l) {
    return $ca0c2c480f9252ec$var$vb.test(l);
}
var $ca0c2c480f9252ec$var$_b = $ca0c2c480f9252ec$var$bb, $ca0c2c480f9252ec$var$Gc = "\\ud800-\\udfff", $ca0c2c480f9252ec$var$yb = "\\u0300-\\u036f", $ca0c2c480f9252ec$var$Ab = "\\ufe20-\\ufe2f", $ca0c2c480f9252ec$var$wb = "\\u20d0-\\u20ff", $ca0c2c480f9252ec$var$Sb = $ca0c2c480f9252ec$var$yb + $ca0c2c480f9252ec$var$Ab + $ca0c2c480f9252ec$var$wb, $ca0c2c480f9252ec$var$Vc = "\\u2700-\\u27bf", $ca0c2c480f9252ec$var$Yc = "a-z\\xdf-\\xf6\\xf8-\\xff", $ca0c2c480f9252ec$var$Eb = "\\xac\\xb1\\xd7\\xf7", $ca0c2c480f9252ec$var$xb = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $ca0c2c480f9252ec$var$Cb = "\\u2000-\\u206f", $ca0c2c480f9252ec$var$kb = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $ca0c2c480f9252ec$var$zc = "A-Z\\xc0-\\xd6\\xd8-\\xde", $ca0c2c480f9252ec$var$Lb = "\\ufe0e\\ufe0f", $ca0c2c480f9252ec$var$Zc = $ca0c2c480f9252ec$var$Eb + $ca0c2c480f9252ec$var$xb + $ca0c2c480f9252ec$var$Cb + $ca0c2c480f9252ec$var$kb, $ca0c2c480f9252ec$var$Xc = "['\u2019]", $ca0c2c480f9252ec$var$Dc = "[" + $ca0c2c480f9252ec$var$Zc + "]", $ca0c2c480f9252ec$var$Db = "[" + $ca0c2c480f9252ec$var$Sb + "]", $ca0c2c480f9252ec$var$Jc = "\\d+", $ca0c2c480f9252ec$var$Tb = "[" + $ca0c2c480f9252ec$var$Vc + "]", $ca0c2c480f9252ec$var$Qc = "[" + $ca0c2c480f9252ec$var$Yc + "]", $ca0c2c480f9252ec$var$eu = "[^" + $ca0c2c480f9252ec$var$Gc + $ca0c2c480f9252ec$var$Zc + $ca0c2c480f9252ec$var$Jc + $ca0c2c480f9252ec$var$Vc + $ca0c2c480f9252ec$var$Yc + $ca0c2c480f9252ec$var$zc + "]", $ca0c2c480f9252ec$var$Ib = "\\ud83c[\\udffb-\\udfff]", $ca0c2c480f9252ec$var$Ob = "(?:" + $ca0c2c480f9252ec$var$Db + "|" + $ca0c2c480f9252ec$var$Ib + ")", $ca0c2c480f9252ec$var$Mb = "[^" + $ca0c2c480f9252ec$var$Gc + "]", $ca0c2c480f9252ec$var$tu = "(?:\\ud83c[\\udde6-\\uddff]){2}", $ca0c2c480f9252ec$var$nu = "[\\ud800-\\udbff][\\udc00-\\udfff]", $ca0c2c480f9252ec$var$Li = "[" + $ca0c2c480f9252ec$var$zc + "]", $ca0c2c480f9252ec$var$Nb = "\\u200d", $ca0c2c480f9252ec$var$Tc = "(?:" + $ca0c2c480f9252ec$var$Qc + "|" + $ca0c2c480f9252ec$var$eu + ")", $ca0c2c480f9252ec$var$Bb = "(?:" + $ca0c2c480f9252ec$var$Li + "|" + $ca0c2c480f9252ec$var$eu + ")", $ca0c2c480f9252ec$var$Ic = "(?:" + $ca0c2c480f9252ec$var$Xc + "(?:d|ll|m|re|s|t|ve))?", $ca0c2c480f9252ec$var$Oc = "(?:" + $ca0c2c480f9252ec$var$Xc + "(?:D|LL|M|RE|S|T|VE))?", $ca0c2c480f9252ec$var$ru = $ca0c2c480f9252ec$var$Ob + "?", $ca0c2c480f9252ec$var$iu = "[" + $ca0c2c480f9252ec$var$Lb + "]?", $ca0c2c480f9252ec$var$Pb = "(?:" + $ca0c2c480f9252ec$var$Nb + "(?:" + [
    $ca0c2c480f9252ec$var$Mb,
    $ca0c2c480f9252ec$var$tu,
    $ca0c2c480f9252ec$var$nu
].join("|") + ")" + $ca0c2c480f9252ec$var$iu + $ca0c2c480f9252ec$var$ru + ")*", $ca0c2c480f9252ec$var$Rb = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $ca0c2c480f9252ec$var$Fb = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $ca0c2c480f9252ec$var$qb = $ca0c2c480f9252ec$var$iu + $ca0c2c480f9252ec$var$ru + $ca0c2c480f9252ec$var$Pb, $ca0c2c480f9252ec$var$Wb = "(?:" + [
    $ca0c2c480f9252ec$var$Tb,
    $ca0c2c480f9252ec$var$tu,
    $ca0c2c480f9252ec$var$nu
].join("|") + ")" + $ca0c2c480f9252ec$var$qb, $ca0c2c480f9252ec$var$Ub = RegExp([
    $ca0c2c480f9252ec$var$Li + "?" + $ca0c2c480f9252ec$var$Qc + "+" + $ca0c2c480f9252ec$var$Ic + "(?=" + [
        $ca0c2c480f9252ec$var$Dc,
        $ca0c2c480f9252ec$var$Li,
        "$"
    ].join("|") + ")",
    $ca0c2c480f9252ec$var$Bb + "+" + $ca0c2c480f9252ec$var$Oc + "(?=" + [
        $ca0c2c480f9252ec$var$Dc,
        $ca0c2c480f9252ec$var$Li + $ca0c2c480f9252ec$var$Tc,
        "$"
    ].join("|") + ")",
    $ca0c2c480f9252ec$var$Li + "?" + $ca0c2c480f9252ec$var$Tc + "+" + $ca0c2c480f9252ec$var$Ic,
    $ca0c2c480f9252ec$var$Li + "+" + $ca0c2c480f9252ec$var$Oc,
    $ca0c2c480f9252ec$var$Fb,
    $ca0c2c480f9252ec$var$Rb,
    $ca0c2c480f9252ec$var$Jc,
    $ca0c2c480f9252ec$var$Wb
].join("|"), "g");
function $ca0c2c480f9252ec$var$Hb(l) {
    return l.match($ca0c2c480f9252ec$var$Ub) || [];
}
var $ca0c2c480f9252ec$var$jb = $ca0c2c480f9252ec$var$Hb, $ca0c2c480f9252ec$var$$b = $ca0c2c480f9252ec$var$gb, $ca0c2c480f9252ec$var$Kb = $ca0c2c480f9252ec$var$_b, $ca0c2c480f9252ec$var$Gb = $ca0c2c480f9252ec$var$Ao, $ca0c2c480f9252ec$var$Vb = $ca0c2c480f9252ec$var$jb;
function $ca0c2c480f9252ec$var$Yb(l, p, u) {
    return l = $ca0c2c480f9252ec$var$Gb(l), p = u ? void 0 : p, p === void 0 ? $ca0c2c480f9252ec$var$Kb(l) ? $ca0c2c480f9252ec$var$Vb(l) : $ca0c2c480f9252ec$var$$b(l) : l.match(p) || [];
}
var $ca0c2c480f9252ec$var$zb = $ca0c2c480f9252ec$var$Yb, $ca0c2c480f9252ec$var$Zb = $ca0c2c480f9252ec$var$uv, $ca0c2c480f9252ec$var$Xb = $ca0c2c480f9252ec$var$hb, $ca0c2c480f9252ec$var$Jb = $ca0c2c480f9252ec$var$zb, $ca0c2c480f9252ec$var$Qb = "['\u2019]", $ca0c2c480f9252ec$var$e_ = RegExp($ca0c2c480f9252ec$var$Qb, "g");
function $ca0c2c480f9252ec$var$t_(l) {
    return function(p) {
        return $ca0c2c480f9252ec$var$Zb($ca0c2c480f9252ec$var$Jb($ca0c2c480f9252ec$var$Xb(p).replace($ca0c2c480f9252ec$var$e_, "")), l, "");
    };
}
var $ca0c2c480f9252ec$var$n_ = $ca0c2c480f9252ec$var$t_, $ca0c2c480f9252ec$var$r_ = $ca0c2c480f9252ec$var$n_, $ca0c2c480f9252ec$var$i_ = $ca0c2c480f9252ec$var$r_(function(l, p, u) {
    return l + (u ? "-" : "") + p.toLowerCase();
}), $ca0c2c480f9252ec$var$a_ = $ca0c2c480f9252ec$var$i_;
const $ca0c2c480f9252ec$var$s_ = /* @__PURE__ */ $ca0c2c480f9252ec$var$ls($ca0c2c480f9252ec$var$a_), $ca0c2c480f9252ec$var$au = ({ sm: l, md: p, lg: u, xl: L })=>{
    const _ = {}, I = "col";
    for (const [E, S] of Object.entries({
        sm: l,
        md: p,
        lg: u,
        xl: L
    }))S && (typeof S == "boolean" ? _[`${I}-${E}`] = !0 : _[`${I}-${E}-${S}`] = !0);
    return Object.keys(_).length || (_.col = !0), _;
}, $ca0c2c480f9252ec$var$o_ = (l)=>{
    const p = {};
    for (const [u, L] of Object.entries(l))p[`${$ca0c2c480f9252ec$var$s_(u)}-${L}`] = !0;
    return p;
}, $ca0c2c480f9252ec$var$cs = (l)=>l ? $ca0c2c480f9252ec$var$su("m", l) : {}, $ca0c2c480f9252ec$var$wo = (l)=>$ca0c2c480f9252ec$var$su("p", l), $ca0c2c480f9252ec$var$su = (l, p)=>{
    const u = {};
    if (Number.isInteger(p)) u[`${l}-${$ca0c2c480f9252ec$var$Mc(p)}`] = !0;
    else for (const [L, _] of Object.entries(p || {}))u[`${l}${L}-${$ca0c2c480f9252ec$var$Mc(_)}`] = !0;
    return u;
}, $ca0c2c480f9252ec$var$Mc = (l)=>l < 0 ? `n${Math.abs(l)}` : `${l}`, $ca0c2c480f9252ec$export$42a852a2b6b56249 = (l)=>{
    const { className: p, style: u, children: L, fluid: _, flex: I, grow: E, column: S, fullHeight: y, justifyContent: k, alignItems: b, margin: m, padding: i } = l, s = _ ? `container-${typeof _ == "string" ? _ : "fluid"}` : "container", c = $ca0c2c480f9252ec$var$Oe(p, s, k && `justify-content-${k}`, b && `align-items-${b}`, I && "d-flex", S && "flex-column", E && "flex-grow-1", y && "min-vh-100", $ca0c2c480f9252ec$var$cs(m), $ca0c2c480f9252ec$var$wo(i));
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: c,
        style: u,
        children: L
    });
}, $ca0c2c480f9252ec$export$963a4b2511a4b70c = (l)=>{
    const { children: p, className: u, margin: L, padding: _, alignSelf: I, sm: E, md: S, lg: y, xl: k, flex: b, flexWrap: m, gap: i, ...a } = l, s = $ca0c2c480f9252ec$var$Oe(u, I && `align-self-${I}`, $ca0c2c480f9252ec$var$au({
        sm: E,
        md: S,
        lg: y,
        xl: k
    }), $ca0c2c480f9252ec$var$o_(a), $ca0c2c480f9252ec$var$cs(L), $ca0c2c480f9252ec$var$wo(_), b && "d-flex", m && "flex-wrap");
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: s,
        style: {
            gap: i
        },
        children: p
    });
}, $ca0c2c480f9252ec$export$b59bdbef9ce70de2 = (l)=>{
    const { className: p, children: u, column: L, margin: _, padding: I, noGutters: E, noWrap: S, rowCols: y, justifyContent: k, alignItems: b, gap: m } = l, i = $ca0c2c480f9252ec$var$Oe("row", p, k && `justify-content-${k}`, b && `align-items-${b}`, y && `row-cols-${y}`, E && "no-gutters", L && "flex-column", S && "flex-nowrap", $ca0c2c480f9252ec$var$cs(_), $ca0c2c480f9252ec$var$wo(I)), a = {
        ...E && {
            "--grid-gutter": 0
        },
        gap: m
    };
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: i,
        style: a,
        children: u
    });
}, $ca0c2c480f9252ec$var$bo = [
    "m",
    "mt",
    "mt-xs",
    "mt-sm",
    "mt-md",
    "mt-lg",
    "mt-xl",
    "mb",
    "mb-xs",
    "mb-sm",
    "mb-md",
    "mb-lg",
    "mb-xl",
    "mr",
    "mr-xs",
    "mr-sm",
    "mr-md",
    "mr-lg",
    "mr-xl",
    "ml",
    "ml-xs",
    "ml-sm",
    "ml-md",
    "ml-lg",
    "ml-xl",
    "mx",
    "my",
    "p",
    "pt",
    "pt-xs",
    "pt-sm",
    "pt-md",
    "pt-lg",
    "pt-xl",
    "pb",
    "pb-xs",
    "pb-sm",
    "pb-md",
    "pb-lg",
    "pb-xl",
    "pr",
    "pr-xs",
    "pr-sm",
    "pr-md",
    "pr-lg",
    "pr-xl",
    "pl",
    "pl-xs",
    "pl-sm",
    "pl-md",
    "pl-lg",
    "pl-xl",
    "px",
    "py"
], $ca0c2c480f9252ec$var$$t = (l)=>{
    let p = [];
    for (const u of $ca0c2c480f9252ec$var$bo)if (typeof l[u] == "boolean" && l[u]) p = [
        ...p,
        u
    ];
    else {
        const L = l[u];
        p = [
            ...p,
            L != null && `${u}-${+L < 0 ? `n${Math.abs(+L)}` : `${L}`}`
        ];
    }
    return p;
}, $ca0c2c480f9252ec$var$Yt = (l)=>{
    for(let p = 0; p < $ca0c2c480f9252ec$var$bo.length; p++)delete l[$ca0c2c480f9252ec$var$bo[p]];
    return l;
}, $ca0c2c480f9252ec$var$l_ = ({ badge: l, children: p })=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$42a852a2b6b56249, {
        fluid: !0,
        margin: 0,
        padding: 0,
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$b59bdbef9ce70de2, {
            children: [
                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$963a4b2511a4b70c, {
                    sm: "auto",
                    padding: {
                        r: 0
                    },
                    children: p
                }),
                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$963a4b2511a4b70c, {
                    sm: "auto",
                    padding: {
                        l: 0
                    },
                    children: l
                })
            ]
        })
    }), $ca0c2c480f9252ec$var$Nc = ({ icon: l, size: p, ...u })=>{
    const L = $ca0c2c480f9252ec$var$$t(u), _ = $ca0c2c480f9252ec$var$Yt(u), I = l.endsWith(".svg"), E = $ca0c2c480f9252ec$var$Oe(p && `fa-${p}`, !I && (l.includes("fas ") || l.includes("fab ") || l.includes("fa ")) ? l : `fas fa-${l}`, ...L);
    return I ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("img", {
        className: E,
        src: l,
        ..._
    }) : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
        className: E,
        "aria-hidden": "true",
        ..._
    });
}, $ca0c2c480f9252ec$export$f04a61298a47a40f = ({ badge: l, ...p })=>l ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$l_, {
        badge: l,
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$Nc, {
            ...p
        })
    }) : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$Nc, {
        ...p
    }), $ca0c2c480f9252ec$var$c_ = ({ type: l, src: p })=>{
    switch(l){
        case "image":
            return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("img", {
                src: p,
                alt: "Avatar"
            });
        case "icon":
            return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                icon: p,
                "aria-hidden": "true"
            });
        case "letter":
            return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)((0, $56c05cee281658b4$exports.Fragment), {
                children: p
            });
        default:
            return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                icon: "user",
                "aria-hidden": "true"
            });
    }
}, $ca0c2c480f9252ec$export$f9cf3b2fb528cec3 = (l)=>{
    const { className: p, title: u, src: L = "", type: _, size: I } = l, E = $ca0c2c480f9252ec$var$Oe("br-avatar", u, I, p), S = $ca0c2c480f9252ec$var$Oe({
        image: !_ || _ === "image" || _ === "icon",
        letter: _ === "letter"
    });
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
        className: E,
        title: u,
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
            className: S,
            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$c_, {
                type: _,
                src: L
            })
        })
    });
}, $ca0c2c480f9252ec$var$d_ = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ tagName: l, children: p, ...u }, L)=>l ? (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement(l, {
        ...u,
        ref: L
    }, p) : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)((0, $56c05cee281658b4$exports.Fragment), {
        children: p
    })), $ca0c2c480f9252ec$var$vr = (0, $jXEQt.memo)($ca0c2c480f9252ec$var$d_), $ca0c2c480f9252ec$var$lu = (l)=>(p)=>{
        l && (p.preventDefault(), p.stopPropagation(), l(p));
    }, $ca0c2c480f9252ec$var$f_ = (0, $jXEQt.memo)(({ label: l, href: p, onClick: u })=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("li", {
        className: "crumb home mr-0",
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                className: "sr-only",
                children: l
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("a", {
                className: "br-button circle small",
                onClick: $ca0c2c480f9252ec$var$lu(u),
                href: p,
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                    className: "fas fa-home"
                })
            })
        ]
    })), $ca0c2c480f9252ec$var$h_ = (0, $jXEQt.memo)(({ label: l, href: p, active: u, onClick: L })=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("li", {
        className: "crumb",
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                className: "text-center icon fas fa-chevron-right"
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$vr, {
                tagName: u ? null : "a",
                onClick: $ca0c2c480f9252ec$var$lu(L),
                href: p,
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                    children: l
                })
            })
        ]
    })), $ca0c2c480f9252ec$var$p_ = (0, $jXEQt.memo)(({ isHome: l, ...p })=>l ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$f_, {
        ...p
    }) : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$h_, {
        ...p
    })), $ca0c2c480f9252ec$var$m_ = ({ crumbs: l = [] })=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: "br-breadcrumb",
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("ul", {
            className: "crumb-list",
            children: l.map((p, u)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$p_, {
                    ...p
                }, u))
        })
    }), $ca0c2c480f9252ec$export$9de10255334e339b = (0, $jXEQt.memo)($ca0c2c480f9252ec$var$m_);
function $ca0c2c480f9252ec$var$as(l, p) {
    (0, $jXEQt.useEffect)(()=>{
        function u(L) {
            if (Array.isArray(l)) {
                let _ = !1;
                for (const I of l)I.current && I.current.contains && I.current.contains(L.target) && (_ = !0);
                _ || p();
            } else l.current && !l.current.contains(L.target) && p();
        }
        return document.addEventListener("click", u), ()=>{
            document.removeEventListener("click", u);
        };
    }, [
        l
    ]);
}
var $ca0c2c480f9252ec$var$g_ = $ca0c2c480f9252ec$var$Ao, $ca0c2c480f9252ec$var$v_ = 0;
function $ca0c2c480f9252ec$var$b_(l) {
    var p = ++$ca0c2c480f9252ec$var$v_;
    return $ca0c2c480f9252ec$var$g_(l) + p;
}
var $ca0c2c480f9252ec$var$__ = $ca0c2c480f9252ec$var$b_;
const $ca0c2c480f9252ec$var$Ti = /* @__PURE__ */ $ca0c2c480f9252ec$var$ls($ca0c2c480f9252ec$var$__), $ca0c2c480f9252ec$var$In = (l, p)=>{
    const [u, L] = (0, $jXEQt.useState)($ca0c2c480f9252ec$var$Ti(p)), [_, I] = (0, $jXEQt.useState)(l || u);
    return (0, $jXEQt.useEffect)(()=>{
        I(l || u);
    }, [
        l,
        u
    ]), _;
};
var $ca0c2c480f9252ec$var$cu = {
    exports: {}
};
(function(l, p) {
    (function(L, _) {
        l.exports = _();
    })(self, ()=>/******/ (()=>{
            var u = {
                /***/ "./node_modules/@popperjs/core/lib/popper.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        n4: ()=>/* binding */ Rr
                    });
                    function k(C) {
                        if (C == null) return window;
                        if (C.toString() !== "[object Window]") {
                            var D = C.ownerDocument;
                            return D && D.defaultView || window;
                        }
                        return C;
                    }
                    function b(C) {
                        var D = k(C).Element;
                        return C instanceof D || C instanceof Element;
                    }
                    function m(C) {
                        var D = k(C).HTMLElement;
                        return C instanceof D || C instanceof HTMLElement;
                    }
                    function i(C) {
                        if (typeof ShadowRoot > "u") return !1;
                        var D = k(C).ShadowRoot;
                        return C instanceof D || C instanceof ShadowRoot;
                    }
                    var a = Math.max, s = Math.min, c = Math.round;
                    function g() {
                        var C = navigator.userAgentData;
                        return C != null && C.brands && Array.isArray(C.brands) ? C.brands.map(function(D) {
                            return D.brand + "/" + D.version;
                        }).join(" ") : navigator.userAgent;
                    }
                    function A() {
                        return !/^((?!chrome|android).)*safari/i.test(g());
                    }
                    function F(C, D, B) {
                        D === void 0 && (D = !1), B === void 0 && (B = !1);
                        var d = C.getBoundingClientRect(), h = 1, T = 1;
                        D && m(C) && (h = C.offsetWidth > 0 && c(d.width) / C.offsetWidth || 1, T = C.offsetHeight > 0 && c(d.height) / C.offsetHeight || 1);
                        var R = b(C) ? k(C) : window, U = R.visualViewport, j = !A() && B, ce = (d.left + (j && U ? U.offsetLeft : 0)) / h, Z = (d.top + (j && U ? U.offsetTop : 0)) / T, Se = d.width / h, de = d.height / T;
                        return {
                            width: Se,
                            height: de,
                            top: Z,
                            right: ce + Se,
                            bottom: Z + de,
                            left: ce,
                            x: ce,
                            y: Z
                        };
                    }
                    function $(C) {
                        var D = k(C), B = D.pageXOffset, d = D.pageYOffset;
                        return {
                            scrollLeft: B,
                            scrollTop: d
                        };
                    }
                    function J(C) {
                        return {
                            scrollLeft: C.scrollLeft,
                            scrollTop: C.scrollTop
                        };
                    }
                    function se(C) {
                        return C === k(C) || !m(C) ? $(C) : J(C);
                    }
                    function Q(C) {
                        return C ? (C.nodeName || "").toLowerCase() : null;
                    }
                    function _e(C) {
                        return ((b(C) ? C.ownerDocument : // $FlowFixMe[prop-missing]
                        C.document) || window.document).documentElement;
                    }
                    function H(C) {
                        return F(_e(C)).left + $(C).scrollLeft;
                    }
                    function Y(C) {
                        return k(C).getComputedStyle(C);
                    }
                    function z(C) {
                        var D = Y(C), B = D.overflow, d = D.overflowX, h = D.overflowY;
                        return /auto|scroll|overlay|hidden/.test(B + h + d);
                    }
                    function V(C) {
                        var D = C.getBoundingClientRect(), B = c(D.width) / C.offsetWidth || 1, d = c(D.height) / C.offsetHeight || 1;
                        return B !== 1 || d !== 1;
                    }
                    function fe(C, D, B) {
                        B === void 0 && (B = !1);
                        var d = m(D), h = m(D) && V(D), T = _e(D), R = F(C, h, B), U = {
                            scrollLeft: 0,
                            scrollTop: 0
                        }, j = {
                            x: 0,
                            y: 0
                        };
                        return (d || !d && !B) && ((Q(D) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
                        z(T)) && (U = se(D)), m(D) ? (j = F(D, !0), j.x += D.clientLeft, j.y += D.clientTop) : T && (j.x = H(T))), {
                            x: R.left + U.scrollLeft - j.x,
                            y: R.top + U.scrollTop - j.y,
                            width: R.width,
                            height: R.height
                        };
                    }
                    function xe(C) {
                        var D = F(C), B = C.offsetWidth, d = C.offsetHeight;
                        return Math.abs(D.width - B) <= 1 && (B = D.width), Math.abs(D.height - d) <= 1 && (d = D.height), {
                            x: C.offsetLeft,
                            y: C.offsetTop,
                            width: B,
                            height: d
                        };
                    }
                    function le(C) {
                        return Q(C) === "html" ? C : // this is a quicker (but less type safe) way to save quite some bytes from the bundle
                        // $FlowFixMe[incompatible-return]
                        // $FlowFixMe[prop-missing]
                        C.assignedSlot || // step into the shadow DOM of the parent of a slotted node
                        C.parentNode || // DOM Element detected
                        (i(C) ? C.host : null) || // ShadowRoot detected
                        // $FlowFixMe[incompatible-call]: HTMLElement is a Node
                        _e(C);
                    }
                    function Ne(C) {
                        return [
                            "html",
                            "body",
                            "#document"
                        ].indexOf(Q(C)) >= 0 ? C.ownerDocument.body : m(C) && z(C) ? C : Ne(le(C));
                    }
                    function ue(C, D) {
                        var B;
                        D === void 0 && (D = []);
                        var d = Ne(C), h = d === ((B = C.ownerDocument) == null ? void 0 : B.body), T = k(d), R = h ? [
                            T
                        ].concat(T.visualViewport || [], z(d) ? d : []) : d, U = D.concat(R);
                        return h ? U : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
                        U.concat(ue(le(R)));
                    }
                    function K(C) {
                        return [
                            "table",
                            "td",
                            "th"
                        ].indexOf(Q(C)) >= 0;
                    }
                    function Ae(C) {
                        return !m(C) || // https://github.com/popperjs/popper-core/issues/837
                        Y(C).position === "fixed" ? null : C.offsetParent;
                    }
                    function we(C) {
                        var D = /firefox/i.test(g()), B = /Trident/i.test(g());
                        if (B && m(C)) {
                            var d = Y(C);
                            if (d.position === "fixed") return null;
                        }
                        var h = le(C);
                        for(i(h) && (h = h.host); m(h) && [
                            "html",
                            "body"
                        ].indexOf(Q(h)) < 0;){
                            var T = Y(h);
                            if (T.transform !== "none" || T.perspective !== "none" || T.contain === "paint" || [
                                "transform",
                                "perspective"
                            ].indexOf(T.willChange) !== -1 || D && T.willChange === "filter" || D && T.filter && T.filter !== "none") return h;
                            h = h.parentNode;
                        }
                        return null;
                    }
                    function me(C) {
                        for(var D = k(C), B = Ae(C); B && K(B) && Y(B).position === "static";)B = Ae(B);
                        return B && (Q(B) === "html" || Q(B) === "body" && Y(B).position === "static") ? D : B || we(C) || D;
                    }
                    var ve = "top", Ce = "bottom", qe = "right", Be = "left", Fe = "auto", Re = [
                        ve,
                        Ce,
                        qe,
                        Be
                    ], ge = "start", ne = "end", ut = "clippingParents", M = "viewport", P = "popper", n = "reference", ye = /* @__PURE__ */ Re.reduce(function(C, D) {
                        return C.concat([
                            D + "-" + ge,
                            D + "-" + ne
                        ]);
                    }, []), ke = /* @__PURE__ */ [].concat(Re, [
                        Fe
                    ]).reduce(function(C, D) {
                        return C.concat([
                            D,
                            D + "-" + ge,
                            D + "-" + ne
                        ]);
                    }, []), Me = "beforeRead", ht = "read", oe = "afterRead", be = "beforeMain", He = "main", Ie = "afterMain", pe = "beforeWrite", Le = "write", Te = "afterWrite", It = [
                        Me,
                        ht,
                        oe,
                        be,
                        He,
                        Ie,
                        pe,
                        Le,
                        Te
                    ];
                    function je(C) {
                        var D = /* @__PURE__ */ new Map(), B = /* @__PURE__ */ new Set(), d = [];
                        C.forEach(function(T) {
                            D.set(T.name, T);
                        });
                        function h(T) {
                            B.add(T.name);
                            var R = [].concat(T.requires || [], T.requiresIfExists || []);
                            R.forEach(function(U) {
                                if (!B.has(U)) {
                                    var j = D.get(U);
                                    j && h(j);
                                }
                            }), d.push(T);
                        }
                        return C.forEach(function(T) {
                            B.has(T.name) || h(T);
                        }), d;
                    }
                    function Ot(C) {
                        var D = je(C);
                        return It.reduce(function(B, d) {
                            return B.concat(D.filter(function(h) {
                                return h.phase === d;
                            }));
                        }, []);
                    }
                    function Kt(C) {
                        var D;
                        return function() {
                            return D || (D = new Promise(function(B) {
                                Promise.resolve().then(function() {
                                    D = void 0, B(C());
                                });
                            })), D;
                        };
                    }
                    function yt(C) {
                        var D = C.reduce(function(B, d) {
                            var h = B[d.name];
                            return B[d.name] = h ? Object.assign({}, h, d, {
                                options: Object.assign({}, h.options, d.options),
                                data: Object.assign({}, h.data, d.data)
                            }) : d, B;
                        }, {});
                        return Object.keys(D).map(function(B) {
                            return D[B];
                        });
                    }
                    var qt = {
                        placement: "bottom",
                        modifiers: [],
                        strategy: "absolute"
                    };
                    function zt() {
                        for(var C = arguments.length, D = new Array(C), B = 0; B < C; B++)D[B] = arguments[B];
                        return !D.some(function(d) {
                            return !(d && typeof d.getBoundingClientRect == "function");
                        });
                    }
                    function On(C) {
                        C === void 0 && (C = {});
                        var D = C, B = D.defaultModifiers, d = B === void 0 ? [] : B, h = D.defaultOptions, T = h === void 0 ? qt : h;
                        return function(U, j, ce) {
                            ce === void 0 && (ce = T);
                            var Z = {
                                placement: "bottom",
                                orderedModifiers: [],
                                options: Object.assign({}, qt, T),
                                modifiersData: {},
                                elements: {
                                    reference: U,
                                    popper: j
                                },
                                attributes: {},
                                styles: {}
                            }, Se = [], de = !1, he = {
                                state: Z,
                                setOptions: function(ct) {
                                    var pt = typeof ct == "function" ? ct(Z.options) : ct;
                                    ze(), Z.options = Object.assign({}, T, Z.options, pt), Z.scrollParents = {
                                        reference: b(U) ? ue(U) : U.contextElement ? ue(U.contextElement) : [],
                                        popper: ue(j)
                                    };
                                    var Lt = Ot(yt([].concat(d, Z.options.modifiers)));
                                    return Z.orderedModifiers = Lt.filter(function(Je) {
                                        return Je.enabled;
                                    }), Ue(), he.update();
                                },
                                // Sync update – it will always be executed, even if not necessary. This
                                // is useful for low frequency updates where sync behavior simplifies the
                                // logic.
                                // For high frequency updates (e.g. `resize` and `scroll` events), always
                                // prefer the async Popper#update method
                                forceUpdate: function() {
                                    if (!de) {
                                        var ct = Z.elements, pt = ct.reference, Lt = ct.popper;
                                        if (zt(pt, Lt)) {
                                            Z.rects = {
                                                reference: fe(pt, me(Lt), Z.options.strategy === "fixed"),
                                                popper: xe(Lt)
                                            }, Z.reset = !1, Z.placement = Z.options.placement, Z.orderedModifiers.forEach(function(Dt) {
                                                return Z.modifiersData[Dt.name] = Object.assign({}, Dt.data);
                                            });
                                            for(var Je = 0; Je < Z.orderedModifiers.length; Je++){
                                                if (Z.reset === !0) {
                                                    Z.reset = !1, Je = -1;
                                                    continue;
                                                }
                                                var ft = Z.orderedModifiers[Je], dt = ft.fn, kt = ft.options, Wt = kt === void 0 ? {} : kt, Nt = ft.name;
                                                typeof dt == "function" && (Z = dt({
                                                    state: Z,
                                                    options: Wt,
                                                    name: Nt,
                                                    instance: he
                                                }) || Z);
                                            }
                                        }
                                    }
                                },
                                // Async and optimistically optimized update – it will not be executed if
                                // not necessary (debounced to run at most once-per-tick)
                                update: Kt(function() {
                                    return new Promise(function(Ve) {
                                        he.forceUpdate(), Ve(Z);
                                    });
                                }),
                                destroy: function() {
                                    ze(), de = !0;
                                }
                            };
                            if (!zt(U, j)) return he;
                            he.setOptions(ce).then(function(Ve) {
                                !de && ce.onFirstUpdate && ce.onFirstUpdate(Ve);
                            });
                            function Ue() {
                                Z.orderedModifiers.forEach(function(Ve) {
                                    var ct = Ve.name, pt = Ve.options, Lt = pt === void 0 ? {} : pt, Je = Ve.effect;
                                    if (typeof Je == "function") {
                                        var ft = Je({
                                            state: Z,
                                            name: ct,
                                            instance: he,
                                            options: Lt
                                        }), dt = function() {};
                                        Se.push(ft || dt);
                                    }
                                });
                            }
                            function ze() {
                                Se.forEach(function(Ve) {
                                    return Ve();
                                }), Se = [];
                            }
                            return he;
                        };
                    }
                    var ee = {
                        passive: !0
                    };
                    function We(C) {
                        var D = C.state, B = C.instance, d = C.options, h = d.scroll, T = h === void 0 ? !0 : h, R = d.resize, U = R === void 0 ? !0 : R, j = k(D.elements.popper), ce = [].concat(D.scrollParents.reference, D.scrollParents.popper);
                        return T && ce.forEach(function(Z) {
                            Z.addEventListener("scroll", B.update, ee);
                        }), U && j.addEventListener("resize", B.update, ee), function() {
                            T && ce.forEach(function(Z) {
                                Z.removeEventListener("scroll", B.update, ee);
                            }), U && j.removeEventListener("resize", B.update, ee);
                        };
                    }
                    const Ye = {
                        name: "eventListeners",
                        enabled: !0,
                        phase: "write",
                        fn: function() {},
                        effect: We,
                        data: {}
                    };
                    function lt(C) {
                        return C.split("-")[0];
                    }
                    function wt(C) {
                        return C.split("-")[1];
                    }
                    function Mt(C) {
                        return [
                            "top",
                            "bottom"
                        ].indexOf(C) >= 0 ? "x" : "y";
                    }
                    function jt(C) {
                        var D = C.reference, B = C.element, d = C.placement, h = d ? lt(d) : null, T = d ? wt(d) : null, R = D.x + D.width / 2 - B.width / 2, U = D.y + D.height / 2 - B.height / 2, j;
                        switch(h){
                            case ve:
                                j = {
                                    x: R,
                                    y: D.y - B.height
                                };
                                break;
                            case Ce:
                                j = {
                                    x: R,
                                    y: D.y + D.height
                                };
                                break;
                            case qe:
                                j = {
                                    x: D.x + D.width,
                                    y: U
                                };
                                break;
                            case Be:
                                j = {
                                    x: D.x - B.width,
                                    y: U
                                };
                                break;
                            default:
                                j = {
                                    x: D.x,
                                    y: D.y
                                };
                        }
                        var ce = h ? Mt(h) : null;
                        if (ce != null) {
                            var Z = ce === "y" ? "height" : "width";
                            switch(T){
                                case ge:
                                    j[ce] = j[ce] - (D[Z] / 2 - B[Z] / 2);
                                    break;
                                case ne:
                                    j[ce] = j[ce] + (D[Z] / 2 - B[Z] / 2);
                                    break;
                            }
                        }
                        return j;
                    }
                    function cn(C) {
                        var D = C.state, B = C.name;
                        D.modifiersData[B] = jt({
                            reference: D.rects.reference,
                            element: D.rects.popper,
                            strategy: "absolute",
                            placement: D.placement
                        });
                    }
                    const Ii = {
                        name: "popperOffsets",
                        enabled: !0,
                        phase: "read",
                        fn: cn,
                        data: {}
                    };
                    var Ir = {
                        top: "auto",
                        right: "auto",
                        bottom: "auto",
                        left: "auto"
                    };
                    function Qr(C, D) {
                        var B = C.x, d = C.y, h = D.devicePixelRatio || 1;
                        return {
                            x: c(B * h) / h || 0,
                            y: c(d * h) / h || 0
                        };
                    }
                    function ei(C) {
                        var D, B = C.popper, d = C.popperRect, h = C.placement, T = C.variation, R = C.offsets, U = C.position, j = C.gpuAcceleration, ce = C.adaptive, Z = C.roundOffsets, Se = C.isFixed, de = R.x, he = de === void 0 ? 0 : de, Ue = R.y, ze = Ue === void 0 ? 0 : Ue, Ve = typeof Z == "function" ? Z({
                            x: he,
                            y: ze
                        }) : {
                            x: he,
                            y: ze
                        };
                        he = Ve.x, ze = Ve.y;
                        var ct = R.hasOwnProperty("x"), pt = R.hasOwnProperty("y"), Lt = Be, Je = ve, ft = window;
                        if (ce) {
                            var dt = me(B), kt = "clientHeight", Wt = "clientWidth";
                            if (dt === k(B) && (dt = _e(B), Y(dt).position !== "static" && U === "absolute" && (kt = "scrollHeight", Wt = "scrollWidth")), dt, h === ve || (h === Be || h === qe) && T === ne) {
                                Je = Ce;
                                var Nt = Se && dt === ft && ft.visualViewport ? ft.visualViewport.height : // $FlowFixMe[prop-missing]
                                dt[kt];
                                ze -= Nt - d.height, ze *= j ? 1 : -1;
                            }
                            if (h === Be || (h === ve || h === Ce) && T === ne) {
                                Lt = qe;
                                var Dt = Se && dt === ft && ft.visualViewport ? ft.visualViewport.width : // $FlowFixMe[prop-missing]
                                dt[Wt];
                                he -= Dt - d.width, he *= j ? 1 : -1;
                            }
                        }
                        var Bt = Object.assign({
                            position: U
                        }, ce && Ir), nn = Z === !0 ? Qr({
                            x: he,
                            y: ze
                        }, k(B)) : {
                            x: he,
                            y: ze
                        };
                        if (he = nn.x, ze = nn.y, j) {
                            var Xt;
                            return Object.assign({}, Bt, (Xt = {}, Xt[Je] = pt ? "0" : "", Xt[Lt] = ct ? "0" : "", Xt.transform = (ft.devicePixelRatio || 1) <= 1 ? "translate(" + he + "px, " + ze + "px)" : "translate3d(" + he + "px, " + ze + "px, 0)", Xt));
                        }
                        return Object.assign({}, Bt, (D = {}, D[Je] = pt ? ze + "px" : "", D[Lt] = ct ? he + "px" : "", D.transform = "", D));
                    }
                    function ti(C) {
                        var D = C.state, B = C.options, d = B.gpuAcceleration, h = d === void 0 ? !0 : d, T = B.adaptive, R = T === void 0 ? !0 : T, U = B.roundOffsets, j = U === void 0 ? !0 : U, ce = {
                            placement: lt(D.placement),
                            variation: wt(D.placement),
                            popper: D.elements.popper,
                            popperRect: D.rects.popper,
                            gpuAcceleration: h,
                            isFixed: D.options.strategy === "fixed"
                        };
                        D.modifiersData.popperOffsets != null && (D.styles.popper = Object.assign({}, D.styles.popper, ei(Object.assign({}, ce, {
                            offsets: D.modifiersData.popperOffsets,
                            position: D.options.strategy,
                            adaptive: R,
                            roundOffsets: j
                        })))), D.modifiersData.arrow != null && (D.styles.arrow = Object.assign({}, D.styles.arrow, ei(Object.assign({}, ce, {
                            offsets: D.modifiersData.arrow,
                            position: "absolute",
                            adaptive: !1,
                            roundOffsets: j
                        })))), D.attributes.popper = Object.assign({}, D.attributes.popper, {
                            "data-popper-placement": D.placement
                        });
                    }
                    const ni = {
                        name: "computeStyles",
                        enabled: !0,
                        phase: "beforeWrite",
                        fn: ti,
                        data: {}
                    };
                    function Oi(C) {
                        var D = C.state;
                        Object.keys(D.elements).forEach(function(B) {
                            var d = D.styles[B] || {}, h = D.attributes[B] || {}, T = D.elements[B];
                            !m(T) || !Q(T) || (Object.assign(T.style, d), Object.keys(h).forEach(function(R) {
                                var U = h[R];
                                U === !1 ? T.removeAttribute(R) : T.setAttribute(R, U === !0 ? "" : U);
                            }));
                        });
                    }
                    function _r(C) {
                        var D = C.state, B = {
                            popper: {
                                position: D.options.strategy,
                                left: "0",
                                top: "0",
                                margin: "0"
                            },
                            arrow: {
                                position: "absolute"
                            },
                            reference: {}
                        };
                        return Object.assign(D.elements.popper.style, B.popper), D.styles = B, D.elements.arrow && Object.assign(D.elements.arrow.style, B.arrow), function() {
                            Object.keys(D.elements).forEach(function(d) {
                                var h = D.elements[d], T = D.attributes[d] || {}, R = Object.keys(D.styles.hasOwnProperty(d) ? D.styles[d] : B[d]), U = R.reduce(function(j, ce) {
                                    return j[ce] = "", j;
                                }, {});
                                !m(h) || !Q(h) || (Object.assign(h.style, U), Object.keys(T).forEach(function(j) {
                                    h.removeAttribute(j);
                                }));
                            });
                        };
                    }
                    const Mi = {
                        name: "applyStyles",
                        enabled: !0,
                        phase: "write",
                        fn: Oi,
                        effect: _r,
                        requires: [
                            "computeStyles"
                        ]
                    };
                    function Ni(C, D, B) {
                        var d = lt(C), h = [
                            Be,
                            ve
                        ].indexOf(d) >= 0 ? -1 : 1, T = typeof B == "function" ? B(Object.assign({}, D, {
                            placement: C
                        })) : B, R = T[0], U = T[1];
                        return R = R || 0, U = (U || 0) * h, [
                            Be,
                            qe
                        ].indexOf(d) >= 0 ? {
                            x: U,
                            y: R
                        } : {
                            x: R,
                            y: U
                        };
                    }
                    function Bi(C) {
                        var D = C.state, B = C.options, d = C.name, h = B.offset, T = h === void 0 ? [
                            0,
                            0
                        ] : h, R = ke.reduce(function(Z, Se) {
                            return Z[Se] = Ni(Se, D.rects, T), Z;
                        }, {}), U = R[D.placement], j = U.x, ce = U.y;
                        D.modifiersData.popperOffsets != null && (D.modifiersData.popperOffsets.x += j, D.modifiersData.popperOffsets.y += ce), D.modifiersData[d] = R;
                    }
                    const Mn = {
                        name: "offset",
                        enabled: !0,
                        phase: "main",
                        requires: [
                            "popperOffsets"
                        ],
                        fn: Bi
                    };
                    var Or = {
                        left: "right",
                        right: "left",
                        bottom: "top",
                        top: "bottom"
                    };
                    function gn(C) {
                        return C.replace(/left|right|bottom|top/g, function(D) {
                            return Or[D];
                        });
                    }
                    var Nn = {
                        start: "end",
                        end: "start"
                    };
                    function Jn(C) {
                        return C.replace(/start|end/g, function(D) {
                            return Nn[D];
                        });
                    }
                    function Pi(C, D) {
                        var B = k(C), d = _e(C), h = B.visualViewport, T = d.clientWidth, R = d.clientHeight, U = 0, j = 0;
                        if (h) {
                            T = h.width, R = h.height;
                            var ce = A();
                            (ce || !ce && D === "fixed") && (U = h.offsetLeft, j = h.offsetTop);
                        }
                        return {
                            width: T,
                            height: R,
                            x: U + H(C),
                            y: j
                        };
                    }
                    function ri(C) {
                        var D, B = _e(C), d = $(C), h = (D = C.ownerDocument) == null ? void 0 : D.body, T = a(B.scrollWidth, B.clientWidth, h ? h.scrollWidth : 0, h ? h.clientWidth : 0), R = a(B.scrollHeight, B.clientHeight, h ? h.scrollHeight : 0, h ? h.clientHeight : 0), U = -d.scrollLeft + H(C), j = -d.scrollTop;
                        return Y(h || B).direction === "rtl" && (U += a(B.clientWidth, h ? h.clientWidth : 0) - T), {
                            width: T,
                            height: R,
                            x: U,
                            y: j
                        };
                    }
                    function Qn(C, D) {
                        var B = D.getRootNode && D.getRootNode();
                        if (C.contains(D)) return !0;
                        if (B && i(B)) {
                            var d = D;
                            do {
                                if (d && C.isSameNode(d)) return !0;
                                d = d.parentNode || d.host;
                            }while (d);
                        }
                        return !1;
                    }
                    function Mr(C) {
                        return Object.assign({}, C, {
                            left: C.x,
                            top: C.y,
                            right: C.x + C.width,
                            bottom: C.y + C.height
                        });
                    }
                    function Ri(C, D) {
                        var B = F(C, !1, D === "fixed");
                        return B.top = B.top + C.clientTop, B.left = B.left + C.clientLeft, B.bottom = B.top + C.clientHeight, B.right = B.left + C.clientWidth, B.width = C.clientWidth, B.height = C.clientHeight, B.x = B.left, B.y = B.top, B;
                    }
                    function Nr(C, D, B) {
                        return D === M ? Mr(Pi(C, B)) : b(D) ? Ri(D, B) : Mr(ri(_e(C)));
                    }
                    function ii(C) {
                        var D = ue(le(C)), B = [
                            "absolute",
                            "fixed"
                        ].indexOf(Y(C).position) >= 0, d = B && m(C) ? me(C) : C;
                        return b(d) ? D.filter(function(h) {
                            return b(h) && Qn(h, d) && Q(h) !== "body";
                        }) : [];
                    }
                    function ai(C, D, B, d) {
                        var h = D === "clippingParents" ? ii(C) : [].concat(D), T = [].concat(h, [
                            B
                        ]), R = T[0], U = T.reduce(function(j, ce) {
                            var Z = Nr(C, ce, d);
                            return j.top = a(Z.top, j.top), j.right = s(Z.right, j.right), j.bottom = s(Z.bottom, j.bottom), j.left = a(Z.left, j.left), j;
                        }, Nr(C, R, d));
                        return U.width = U.right - U.left, U.height = U.bottom - U.top, U.x = U.left, U.y = U.top, U;
                    }
                    function Br() {
                        return {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        };
                    }
                    function er(C) {
                        return Object.assign({}, Br(), C);
                    }
                    function si(C, D) {
                        return D.reduce(function(B, d) {
                            return B[d] = C, B;
                        }, {});
                    }
                    function tr(C, D) {
                        D === void 0 && (D = {});
                        var B = D, d = B.placement, h = d === void 0 ? C.placement : d, T = B.strategy, R = T === void 0 ? C.strategy : T, U = B.boundary, j = U === void 0 ? ut : U, ce = B.rootBoundary, Z = ce === void 0 ? M : ce, Se = B.elementContext, de = Se === void 0 ? P : Se, he = B.altBoundary, Ue = he === void 0 ? !1 : he, ze = B.padding, Ve = ze === void 0 ? 0 : ze, ct = er(typeof Ve != "number" ? Ve : si(Ve, Re)), pt = de === P ? n : P, Lt = C.rects.popper, Je = C.elements[Ue ? pt : de], ft = ai(b(Je) ? Je : Je.contextElement || _e(C.elements.popper), j, Z, R), dt = F(C.elements.reference), kt = jt({
                            reference: dt,
                            element: Lt,
                            strategy: "absolute",
                            placement: h
                        }), Wt = Mr(Object.assign({}, Lt, kt)), Nt = de === P ? Wt : dt, Dt = {
                            top: ft.top - Nt.top + ct.top,
                            bottom: Nt.bottom - ft.bottom + ct.bottom,
                            left: ft.left - Nt.left + ct.left,
                            right: Nt.right - ft.right + ct.right
                        }, Bt = C.modifiersData.offset;
                        if (de === P && Bt) {
                            var nn = Bt[h];
                            Object.keys(Dt).forEach(function(Xt) {
                                var rr = [
                                    qe,
                                    Ce
                                ].indexOf(Xt) >= 0 ? 1 : -1, ir = [
                                    ve,
                                    Ce
                                ].indexOf(Xt) >= 0 ? "y" : "x";
                                Dt[Xt] += nn[ir] * rr;
                            });
                        }
                        return Dt;
                    }
                    function oi(C, D) {
                        D === void 0 && (D = {});
                        var B = D, d = B.placement, h = B.boundary, T = B.rootBoundary, R = B.padding, U = B.flipVariations, j = B.allowedAutoPlacements, ce = j === void 0 ? ke : j, Z = wt(d), Se = Z ? U ? ye : ye.filter(function(Ue) {
                            return wt(Ue) === Z;
                        }) : Re, de = Se.filter(function(Ue) {
                            return ce.indexOf(Ue) >= 0;
                        });
                        de.length === 0 && (de = Se);
                        var he = de.reduce(function(Ue, ze) {
                            return Ue[ze] = tr(C, {
                                placement: ze,
                                boundary: h,
                                rootBoundary: T,
                                padding: R
                            })[lt(ze)], Ue;
                        }, {});
                        return Object.keys(he).sort(function(Ue, ze) {
                            return he[Ue] - he[ze];
                        });
                    }
                    function Kn(C) {
                        if (lt(C) === Fe) return [];
                        var D = gn(C);
                        return [
                            Jn(C),
                            D,
                            Jn(D)
                        ];
                    }
                    function li(C) {
                        var D = C.state, B = C.options, d = C.name;
                        if (!D.modifiersData[d]._skip) {
                            for(var h = B.mainAxis, T = h === void 0 ? !0 : h, R = B.altAxis, U = R === void 0 ? !0 : R, j = B.fallbackPlacements, ce = B.padding, Z = B.boundary, Se = B.rootBoundary, de = B.altBoundary, he = B.flipVariations, Ue = he === void 0 ? !0 : he, ze = B.allowedAutoPlacements, Ve = D.options.placement, ct = lt(Ve), pt = ct === Ve, Lt = j || (pt || !Ue ? [
                                gn(Ve)
                            ] : Kn(Ve)), Je = [
                                Ve
                            ].concat(Lt).reduce(function(Ar, Pn) {
                                return Ar.concat(lt(Pn) === Fe ? oi(D, {
                                    placement: Pn,
                                    boundary: Z,
                                    rootBoundary: Se,
                                    padding: ce,
                                    flipVariations: Ue,
                                    allowedAutoPlacements: ze
                                }) : Pn);
                            }, []), ft = D.rects.reference, dt = D.rects.popper, kt = /* @__PURE__ */ new Map(), Wt = !0, Nt = Je[0], Dt = 0; Dt < Je.length; Dt++){
                                var Bt = Je[Dt], nn = lt(Bt), Xt = wt(Bt) === ge, rr = [
                                    ve,
                                    Ce
                                ].indexOf(nn) >= 0, ir = rr ? "width" : "height", rn = tr(D, {
                                    placement: Bt,
                                    boundary: Z,
                                    rootBoundary: Se,
                                    altBoundary: de,
                                    padding: ce
                                }), it = rr ? Xt ? qe : Be : Xt ? Ce : ve;
                                ft[ir] > dt[ir] && (it = gn(it));
                                var mt = gn(it), ar = [];
                                if (T && ar.push(rn[nn] <= 0), U && ar.push(rn[it] <= 0, rn[mt] <= 0), ar.every(function(Ar) {
                                    return Ar;
                                })) {
                                    Nt = Bt, Wt = !1;
                                    break;
                                }
                                kt.set(Bt, ar);
                            }
                            if (Wt) for(var fi = Ue ? 3 : 1, ji = function(Pn) {
                                var qr = Je.find(function(Pt) {
                                    var Rn = kt.get(Pt);
                                    if (Rn) return Rn.slice(0, Pn).every(function(Fn) {
                                        return Fn;
                                    });
                                });
                                if (qr) return Nt = qr, "break";
                            }, Fr = fi; Fr > 0; Fr--){
                                var hi = ji(Fr);
                                if (hi === "break") break;
                            }
                            D.placement !== Nt && (D.modifiersData[d]._skip = !0, D.placement = Nt, D.reset = !0);
                        }
                    }
                    const Bn = {
                        name: "flip",
                        enabled: !0,
                        phase: "main",
                        fn: li,
                        requiresIfExists: [
                            "offset"
                        ],
                        data: {
                            _skip: !1
                        }
                    };
                    function Fi(C) {
                        return C === "x" ? "y" : "x";
                    }
                    function Gn(C, D, B) {
                        return a(C, s(D, B));
                    }
                    function qi(C, D, B) {
                        var d = Gn(C, D, B);
                        return d > B ? B : d;
                    }
                    function Pr(C) {
                        var D = C.state, B = C.options, d = C.name, h = B.mainAxis, T = h === void 0 ? !0 : h, R = B.altAxis, U = R === void 0 ? !1 : R, j = B.boundary, ce = B.rootBoundary, Z = B.altBoundary, Se = B.padding, de = B.tether, he = de === void 0 ? !0 : de, Ue = B.tetherOffset, ze = Ue === void 0 ? 0 : Ue, Ve = tr(D, {
                            boundary: j,
                            rootBoundary: ce,
                            padding: Se,
                            altBoundary: Z
                        }), ct = lt(D.placement), pt = wt(D.placement), Lt = !pt, Je = Mt(ct), ft = Fi(Je), dt = D.modifiersData.popperOffsets, kt = D.rects.reference, Wt = D.rects.popper, Nt = typeof ze == "function" ? ze(Object.assign({}, D.rects, {
                            placement: D.placement
                        })) : ze, Dt = typeof Nt == "number" ? {
                            mainAxis: Nt,
                            altAxis: Nt
                        } : Object.assign({
                            mainAxis: 0,
                            altAxis: 0
                        }, Nt), Bt = D.modifiersData.offset ? D.modifiersData.offset[D.placement] : null, nn = {
                            x: 0,
                            y: 0
                        };
                        if (dt) {
                            if (T) {
                                var Xt, rr = Je === "y" ? ve : Be, ir = Je === "y" ? Ce : qe, rn = Je === "y" ? "height" : "width", it = dt[Je], mt = it + Ve[rr], ar = it - Ve[ir], fi = he ? -Wt[rn] / 2 : 0, ji = pt === ge ? kt[rn] : Wt[rn], Fr = pt === ge ? -Wt[rn] : -kt[rn], hi = D.elements.arrow, Ar = he && hi ? xe(hi) : {
                                    width: 0,
                                    height: 0
                                }, Pn = D.modifiersData["arrow#persistent"] ? D.modifiersData["arrow#persistent"].padding : Br(), qr = Pn[rr], Pt = Pn[ir], Rn = Gn(0, kt[rn], Ar[rn]), Fn = Lt ? kt[rn] / 2 - fi - Rn - qr - Dt.mainAxis : ji - Rn - qr - Dt.mainAxis, pa = Lt ? -kt[rn] / 2 + fi + Rn + Pt + Dt.mainAxis : Fr + Rn + Pt + Dt.mainAxis, Wr = D.elements.arrow && me(D.elements.arrow), un = Wr ? Je === "y" ? Wr.clientTop || 0 : Wr.clientLeft || 0 : 0, $i = (Xt = Bt == null ? void 0 : Bt[Je]) != null ? Xt : 0, ma = it + Fn - $i - un, ga = it + pa - $i, Ki = Gn(he ? s(mt, ma) : mt, it, he ? a(ar, ga) : ar);
                                dt[Je] = Ki, nn[Je] = Ki - it;
                            }
                            if (U) {
                                var Gi, va = Je === "x" ? ve : Be, an = Je === "x" ? Ce : qe, sr = dt[ft], Jt = ft === "y" ? "height" : "width", ba = sr + Ve[va], Vi = sr - Ve[an], wn = [
                                    ve,
                                    Be
                                ].indexOf(ct) !== -1, Ur = (Gi = Bt == null ? void 0 : Bt[ft]) != null ? Gi : 0, pi = wn ? ba : sr - kt[Jt] - Wt[Jt] - Ur + Dt.altAxis, xt = wn ? sr + kt[Jt] + Wt[Jt] - Ur - Dt.altAxis : Vi, qn = he && wn ? qi(pi, sr, xt) : Gn(he ? pi : ba, sr, he ? xt : Vi);
                                dt[ft] = qn, nn[ft] = qn - sr;
                            }
                            D.modifiersData[d] = nn;
                        }
                    }
                    const ci = {
                        name: "preventOverflow",
                        enabled: !0,
                        phase: "main",
                        fn: Pr,
                        requiresIfExists: [
                            "offset"
                        ]
                    };
                    var ui = function(D, B) {
                        return D = typeof D == "function" ? D(Object.assign({}, B.rects, {
                            placement: B.placement
                        })) : D, er(typeof D != "number" ? D : si(D, Re));
                    };
                    function di(C) {
                        var D, B = C.state, d = C.name, h = C.options, T = B.elements.arrow, R = B.modifiersData.popperOffsets, U = lt(B.placement), j = Mt(U), ce = [
                            Be,
                            qe
                        ].indexOf(U) >= 0, Z = ce ? "height" : "width";
                        if (!(!T || !R)) {
                            var Se = ui(h.padding, B), de = xe(T), he = j === "y" ? ve : Be, Ue = j === "y" ? Ce : qe, ze = B.rects.reference[Z] + B.rects.reference[j] - R[j] - B.rects.popper[Z], Ve = R[j] - B.rects.reference[j], ct = me(T), pt = ct ? j === "y" ? ct.clientHeight || 0 : ct.clientWidth || 0 : 0, Lt = ze / 2 - Ve / 2, Je = Se[he], ft = pt - de[Z] - Se[Ue], dt = pt / 2 - de[Z] / 2 + Lt, kt = Gn(Je, dt, ft), Wt = j;
                            B.modifiersData[d] = (D = {}, D[Wt] = kt, D.centerOffset = kt - dt, D);
                        }
                    }
                    function Wi(C) {
                        var D = C.state, B = C.options, d = B.element, h = d === void 0 ? "[data-popper-arrow]" : d;
                        h != null && (typeof h == "string" && (h = D.elements.popper.querySelector(h), !h) || Qn(D.elements.popper, h) && (D.elements.arrow = h));
                    }
                    const Ui = {
                        name: "arrow",
                        enabled: !0,
                        phase: "main",
                        fn: di,
                        effect: Wi,
                        requires: [
                            "popperOffsets"
                        ],
                        requiresIfExists: [
                            "preventOverflow"
                        ]
                    };
                    function St(C, D, B) {
                        return B === void 0 && (B = {
                            x: 0,
                            y: 0
                        }), {
                            top: C.top - D.height - B.y,
                            right: C.right - D.width + B.x,
                            bottom: C.bottom - D.height + B.y,
                            left: C.left - D.width - B.x
                        };
                    }
                    function nr(C) {
                        return [
                            ve,
                            qe,
                            Ce,
                            Be
                        ].some(function(D) {
                            return C[D] >= 0;
                        });
                    }
                    function yr(C) {
                        var D = C.state, B = C.name, d = D.rects.reference, h = D.rects.popper, T = D.modifiersData.preventOverflow, R = tr(D, {
                            elementContext: "reference"
                        }), U = tr(D, {
                            altBoundary: !0
                        }), j = St(R, d), ce = St(U, h, T), Z = nr(j), Se = nr(ce);
                        D.modifiersData[B] = {
                            referenceClippingOffsets: j,
                            popperEscapeOffsets: ce,
                            isReferenceHidden: Z,
                            hasPopperEscaped: Se
                        }, D.attributes.popper = Object.assign({}, D.attributes.popper, {
                            "data-popper-reference-hidden": Z,
                            "data-popper-escaped": Se
                        });
                    }
                    var Vn = [
                        Ye,
                        Ii,
                        ni,
                        Mi,
                        Mn,
                        Bn,
                        ci,
                        Ui,
                        {
                            name: "hide",
                            enabled: !0,
                            phase: "main",
                            requiresIfExists: [
                                "preventOverflow"
                            ],
                            fn: yr
                        }
                    ], Rr = /* @__PURE__ */ On({
                        defaultModifiers: Vn
                    });
                },
                /***/ "./node_modules/flatpickr/dist/esm/utils/polyfills.js": /***/ ()=>{
                    typeof Object.assign != "function" && (Object.assign = function(E) {
                        for(var S = [], y = 1; y < arguments.length; y++)S[y - 1] = arguments[y];
                        if (!E) throw TypeError("Cannot convert undefined or null to object");
                        for(var k = function(a) {
                            a && Object.keys(a).forEach(function(s) {
                                return E[s] = a[s];
                            });
                        }, b = 0, m = S; b < m.length; b++){
                            var i = m[b];
                            k(i);
                        }
                        return E;
                    });
                },
                /***/ "./node_modules/flatpickr/dist/l10n/pt.js": /***/ function(E, S) {
                    (function(y, k) {
                        k(S);
                    })(this, function(y) {
                        var k = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
                            l10ns: {}
                        }, b = {
                            weekdays: {
                                shorthand: [
                                    "Dom",
                                    "Seg",
                                    "Ter",
                                    "Qua",
                                    "Qui",
                                    "Sex",
                                    "S\xe1b"
                                ],
                                longhand: [
                                    "Domingo",
                                    "Segunda-feira",
                                    "Ter\xe7a-feira",
                                    "Quarta-feira",
                                    "Quinta-feira",
                                    "Sexta-feira",
                                    "S\xe1bado"
                                ]
                            },
                            months: {
                                shorthand: [
                                    "Jan",
                                    "Fev",
                                    "Mar",
                                    "Abr",
                                    "Mai",
                                    "Jun",
                                    "Jul",
                                    "Ago",
                                    "Set",
                                    "Out",
                                    "Nov",
                                    "Dez"
                                ],
                                longhand: [
                                    "Janeiro",
                                    "Fevereiro",
                                    "Mar\xe7o",
                                    "Abril",
                                    "Maio",
                                    "Junho",
                                    "Julho",
                                    "Agosto",
                                    "Setembro",
                                    "Outubro",
                                    "Novembro",
                                    "Dezembro"
                                ]
                            },
                            rangeSeparator: " at\xe9 ",
                            time_24hr: !0
                        };
                        k.l10ns.pt = b;
                        var m = k.l10ns;
                        y.Portuguese = b, y.default = m, Object.defineProperty(y, "__esModule", {
                            value: !0
                        });
                    });
                },
                /***/ "./node_modules/focus-visible/dist/focus-visible.js": /***/ function() {
                    (function(E, S) {
                        S();
                    })(this, function() {
                        function E(y) {
                            var k = !0, b = !1, m = null, i = {
                                text: !0,
                                search: !0,
                                url: !0,
                                tel: !0,
                                email: !0,
                                password: !0,
                                number: !0,
                                date: !0,
                                month: !0,
                                week: !0,
                                time: !0,
                                datetime: !0,
                                "datetime-local": !0
                            };
                            function a(Y) {
                                return !!(Y && Y !== document && Y.nodeName !== "HTML" && Y.nodeName !== "BODY" && "classList" in Y && "contains" in Y.classList);
                            }
                            function s(Y) {
                                var z = Y.type, V = Y.tagName;
                                return !!(V === "INPUT" && i[z] && !Y.readOnly || V === "TEXTAREA" && !Y.readOnly || Y.isContentEditable);
                            }
                            function c(Y) {
                                Y.classList.contains("focus-visible") || (Y.classList.add("focus-visible"), Y.setAttribute("data-focus-visible-added", ""));
                            }
                            function g(Y) {
                                Y.hasAttribute("data-focus-visible-added") && (Y.classList.remove("focus-visible"), Y.removeAttribute("data-focus-visible-added"));
                            }
                            function A(Y) {
                                Y.metaKey || Y.altKey || Y.ctrlKey || (a(y.activeElement) && c(y.activeElement), k = !0);
                            }
                            function F(Y) {
                                k = !1;
                            }
                            function $(Y) {
                                a(Y.target) && (k || s(Y.target)) && c(Y.target);
                            }
                            function J(Y) {
                                a(Y.target) && (Y.target.classList.contains("focus-visible") || Y.target.hasAttribute("data-focus-visible-added")) && (b = !0, window.clearTimeout(m), m = window.setTimeout(function() {
                                    b = !1;
                                }, 100), g(Y.target));
                            }
                            function se(Y) {
                                document.visibilityState === "hidden" && (b && (k = !0), Q());
                            }
                            function Q() {
                                document.addEventListener("mousemove", H), document.addEventListener("mousedown", H), document.addEventListener("mouseup", H), document.addEventListener("pointermove", H), document.addEventListener("pointerdown", H), document.addEventListener("pointerup", H), document.addEventListener("touchmove", H), document.addEventListener("touchstart", H), document.addEventListener("touchend", H);
                            }
                            function _e() {
                                document.removeEventListener("mousemove", H), document.removeEventListener("mousedown", H), document.removeEventListener("mouseup", H), document.removeEventListener("pointermove", H), document.removeEventListener("pointerdown", H), document.removeEventListener("pointerup", H), document.removeEventListener("touchmove", H), document.removeEventListener("touchstart", H), document.removeEventListener("touchend", H);
                            }
                            function H(Y) {
                                Y.target.nodeName && Y.target.nodeName.toLowerCase() === "html" || (k = !1, _e());
                            }
                            document.addEventListener("keydown", A, !0), document.addEventListener("mousedown", F, !0), document.addEventListener("pointerdown", F, !0), document.addEventListener("touchstart", F, !0), document.addEventListener("visibilitychange", se, !0), Q(), y.addEventListener("focus", $, !0), y.addEventListener("blur", J, !0), y.nodeType === Node.DOCUMENT_FRAGMENT_NODE && y.host ? y.host.setAttribute("data-js-focus-visible", "") : y.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
                        }
                        if (typeof window < "u" && typeof document < "u") {
                            window.applyFocusVisiblePolyfill = E;
                            var S;
                            try {
                                S = new CustomEvent("focus-visible-polyfill-ready");
                            } catch  {
                                S = document.createEvent("CustomEvent"), S.initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
                            }
                            window.dispatchEvent(S);
                        }
                        typeof document < "u" && E(document);
                    });
                },
                /***/ "./src/components/accordion/accordion.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        constructor(i, a){
                            this.name = i, this.component = a, this._setBehavior();
                        }
                        _setBehavior() {
                            for (const i of this.component.querySelectorAll("button.header"))i.addEventListener("click", (a)=>{
                                this._collapse(a), this._changeIcon(a);
                            });
                        }
                        // eslint-disable-next-line complexity
                        _collapse(i) {
                            if (this.component.hasAttribute("single")) for (const a of this.component.querySelectorAll(".item"))a === i.currentTarget.parentNode ? a.hasAttribute("active") ? a.removeAttribute("active") : a.setAttribute("active", "") : a.hasAttribute("active") && a.removeAttribute("active");
                            else for (const a of this.component.querySelectorAll(".item"))a === i.currentTarget.parentNode && (a.hasAttribute("active") ? a.removeAttribute("active") : a.setAttribute("active", ""));
                        }
                        _changeIcon() {
                            for (const i of this.component.querySelectorAll(".item"))if (i.hasAttribute("active")) for (const a of i.querySelectorAll(".icon"))a.children[0].classList.remove("fa-angle-down"), a.children[0].classList.add("fa-angle-up");
                            else for (const a of i.querySelectorAll(".icon"))a.children[0].classList.remove("fa-angle-up"), a.children[0].classList.add("fa-angle-down");
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/avatar/avatar.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/partial/js/behavior/dropdown.js");
                    class b {
                        /**
               * Instancia um exemplo de comportamento dropdown
               * @param {string} name - Nome do componente
               * @param {object} component - Referência ao objeto do DOM
               */ constructor(a, s){
                            this.name = a, this.component = s, this._setBehavior();
                        }
                        /**
               * Define os comportamentos do componente
               * @private
               */ _setBehavior() {
                            this._setDropdownBehavior();
                        }
                        /**
               * Define os comportamentos do dropdown
               * @private
               */ _setDropdownBehavior() {
                            if (this.component.parentElement.dataset.toggle === "dropdown") {
                                const a = {
                                    iconToHide: "fa-caret-up",
                                    iconToShow: "fa-caret-down",
                                    trigger: this.component.parentElement,
                                    useIcons: !0
                                };
                                new k.default(a).setBehavior();
                            }
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/breadcrumb/breadcrumb.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia um componente breadcrumb
               * @param {string} name - nome do componente
               * @param {object} component - referencia ao objeto do DOM
               **/ constructor(i, a){
                            this.name = i, this.component = a, this._setBehavior();
                        }
                        /**
               * Define os comportamentos do componente
               * @private
               */ _setBehavior() {
                            this._setView(), window.addEventListener("resize", ()=>{
                                this._setView();
                            }), window.document.addEventListener("click", (i)=>{
                                !this.component.contains(i.target) && this.component.querySelector(".br-card") && this.component.querySelector(".br-card").remove();
                            });
                        }
                        /**
               * Reseta a view do breadcrumb
               */ resetBreadcrumbs() {
                            this._reset();
                            const i = this.component.querySelector(".br-card");
                            i !== null && i.remove(), this._setView();
                        }
                        /**
               * Atualiza a visualização do componente
               * @private
               */ _setView() {
                            this._reset();
                            for (const i of this.component.querySelectorAll(".crumb-list")){
                                const a = i.querySelectorAll(".crumb:not([data-active])");
                                window.innerWidth < 575 ? a.length !== 1 && (a.forEach((s)=>{
                                    s.classList.add("d-none");
                                }), this._insertExpandButton()) : (i.scrollWidth > i.offsetWidth || a.length > 5) && (a.forEach((s, c)=>{
                                    c > 0 && c < a.length - 1 && s.classList.add("d-none");
                                }), this._insertExpandButton());
                            }
                        }
                        /**
               * Insere botao de expandir
               * @private
               */ _insertExpandButton() {
                            const i = this._createCrumb(), a = this.component.querySelector(".crumb-list"), s = a.querySelectorAll(".crumb");
                            a.insertBefore(i, s[1]);
                            for (const c of this.component.querySelectorAll('[aria-current="page"]'))c.setAttribute("tabindex", "-1");
                        }
                        /**
               * Reinicia componente
               * @private
               */ _reset() {
                            this.component.querySelectorAll(".crumb-list .crumb").forEach((i)=>{
                                if (i.classList.contains("menu-mobil")) {
                                    i.remove();
                                    for (const a of this.component.querySelectorAll('[aria-current="page"]'))a.setAttribute("tabindex", "0");
                                } else i.classList.remove("d-none");
                            });
                        }
                        /**
               * Insere elementos
               * @private
               */ _createCrumb() {
                            const i = document.createElement("li");
                            i.classList.add("crumb", "menu-mobil"), i.setAttribute("data-toggle", "dropdown");
                            const a = document.createElement("button");
                            a.classList.add("br-button", "circle"), a.setAttribute("aria-label", "Abrir menu Breadcrumb");
                            const s = document.createElement("span");
                            s.classList.add("sr-only"), s.innerHTML = "Bot\xe3o Menu";
                            const c = document.createElement("i");
                            c.classList.add("fas", "fa-folder-plus");
                            const g = document.createElement("i");
                            return g.classList.add("icon", "fas", "fa-chevron-right"), i.appendChild(g), i.appendChild(a), a.appendChild(s), a.appendChild(c), i.addEventListener("click", ()=>{
                                let A = this.component.querySelector(".br-card");
                                A ? (c.classList.remove("fas", "fa-folder-minus"), c.classList.add("fas", "fa-folder-plus"), a.setAttribute("aria-label", "Breadcrumb menu fechado"), this.component.querySelector(".br-card").remove()) : (c.classList.remove("fas", "fa-folder-plus"), c.classList.add("fas", "fa-folder-minus"), a.setAttribute("aria-label", "Breadcrumb menu aberto"), A = this._createList(), this.component.appendChild(A));
                            }), i;
                        }
                        /**
               * Cria lista
               * @private
               */ _createList() {
                            const i = document.createElement("nav");
                            return i.classList.add("br-card"), this.component.querySelectorAll(".crumb-list .crumb").forEach((a)=>{
                                if (a.classList.contains("d-none")) {
                                    const s = document.createElement("div");
                                    s.classList.add("br-item"), a.classList.contains("home") || (s.appendChild(a.querySelector("a").cloneNode(!0)), i.appendChild(s));
                                }
                            }), i;
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/card/card.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/partial/js/behavior/collapse.js");
                    class b {
                        /**
               * Instancia do componente
               * @property {string} name - Nome do componente em minúsculo
               * @property {object} component - Objeto referenciando a raiz do componente DOM
               * @property {string} id - nome da id do ocmponente
               */ constructor(a, s, c){
                            this.name = a, this.component = s, this.component.setAttribute("id", `card${c}`), this._setBehavior();
                        }
                        /**
               * Define o comportamento do componente
               * @private
               */ _setBehavior() {
                            this._setFlipBehavior(), this._setDragBehavior(), this._setDisableBehavior(), this._collpaseBehavior();
                        }
                        /**
               * Define o comportamento de comprimir (collapse)
               * @private
               */ _collpaseBehavior() {
                            this.component.querySelectorAll('[data-toggle="collapse"]').forEach((a)=>{
                                const s = {
                                    iconToHide: "fa-chevron-up",
                                    iconToShow: "fa-chevron-down",
                                    trigger: a,
                                    useIcons: !0
                                };
                                new k.default(s).setBehavior();
                            });
                        }
                        /**
               * Desabilita o componente
               * @private
               */ _setDisableBehavior() {
                            if (this.component.classList.contains("disabled")) {
                                this.component.setAttribute("aria-hidden", "true");
                                const a = this.component.querySelectorAll("button"), s = this.component.querySelectorAll("input"), c = this.component.querySelectorAll("select"), g = this.component.querySelectorAll("textarea");
                                for (const A of a)A.setAttribute("disabled", "disabled");
                                for (const A of s)A.setAttribute("disabled", "disabled");
                                for (const A of c)A.setAttribute("disabled", "disabled");
                                for (const A of g)A.setAttribute("disabled", "disabled");
                            }
                        }
                        /**
               * Define o comportamento de girar (flip)
               * @private
               */ _setFlipBehavior() {
                            for (const a of this.component.querySelectorAll("button.flip"))a.addEventListener("click", ()=>{
                                this.component.getAttribute("flipped") === "off" ? this.component.setAttribute("flipped", "on") : this.component.setAttribute("flipped", "off");
                            });
                        }
                        /**
               * Define o comportamento de arrastar (drag)
               * @private
               */ _setDragBehavior() {
                            for (const a of this.component.querySelectorAll("img"))a.setAttribute("draggable", "false");
                            for (const a of this.component.querySelectorAll("a"))a.setAttribute("draggable", "false");
                            this.component.addEventListener("dragstart", (a)=>{
                                a.stopPropagation(), a.dataTransfer.setData("text/plain", this.component.getAttribute("id")), a.dropEffect = "move";
                            });
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/carousel/carousel.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>i
                    });
                    var k = y("./src/partial/js/behavior/swipe.js"), b = y("./src/components/step/step.js");
                    class m {
                        constructor(s, c){
                            this.name = s, this.component = c, this.activeStageNum = 0, this.DOMstrings = {
                                carouselNextBtn: this.component.querySelector(".carousel-btn-next"),
                                carouselPages: this.component.querySelectorAll(".carousel-page"),
                                carouselPrevBtn: this.component.querySelector(".carousel-btn-prev"),
                                carouselStage: this.component.querySelector(".carousel-stage"),
                                circular: this.component.hasAttribute("data-circular"),
                                step: this.component.querySelector(".br-step")
                            }, this.step = new b.A("br-step", this.DOMstrings.step), this._setBehavior();
                        }
                        /**
               * Remove os atributos de uma lista de elementos
               * @param {object} elemSet - Lista de elementos
               * @param {string} button - Nome do atributo
               */ removeAttributes(s, c) {
                            s.forEach((g)=>{
                                g.removeAttribute(c);
                            });
                        }
                        /**
               * Retorna o passo ativo
               */ getActiveStep() {
                            return this.step.activeStepNum;
                        }
                        /**
               * Define o passo ativo
               * @param {number} activeStepNum - número do passo
               */ setActiveStep(s) {
                            this.step.setActiveStep(s);
                        }
                        /**
               * Retorna o palco ativo
               */ getActiveStage() {
                            let s;
                            return this.DOMstrings.carouselPages.forEach((c)=>{
                                c.hasAttribute("active") && (s = c);
                            }), s;
                        }
                        /**
               * Define o palco ativo
               * @param {number} num - número do palco
               */ setActiveStage(s) {
                            this.removeAttributes(this.DOMstrings.carouselPages, "active"), this.DOMstrings.carouselPages.forEach((c, g)=>{
                                g > s ? c.style.left = "100%" : c.style.left = "-100%", g === s && (c.setAttribute("active", ""), this.activeStageNum = s);
                            }), this.disabledBtns();
                        }
                        /**
               * Desabilita os botões se o carousel não for circular
               */ disabledBtns() {
                            this.DOMstrings.circular || (this.activeStageNum === 0 ? this.DOMstrings.carouselNextBtn && (document.activeElement == this.DOMstrings.carouselPrevBtn && this.DOMstrings.carouselNextBtn.focus(), this.DOMstrings.carouselPrevBtn.setAttribute("disabled", "")) : this.DOMstrings.carouselPrevBtn.removeAttribute("disabled"), this.activeStageNum === this.DOMstrings.carouselPages.length - 1 ? this.DOMstrings.carouselNextBtn && (document.activeElement == this.DOMstrings.carouselNextBtn && this.DOMstrings.carouselPrevBtn.focus(), this.DOMstrings.carouselNextBtn.setAttribute("disabled", "")) : this.DOMstrings.carouselNextBtn.removeAttribute("disabled"));
                        }
                        /**
               * Muda a página ativa incrementalmente - ações de botões e swap
               * @param {number} num - incremento
               */ shiftPage(s) {
                            const c = this.getActiveStage(), g = this.DOMstrings.carouselPages.length - 1;
                            let A = Array.from(this.DOMstrings.carouselPages).indexOf(c);
                            s < 0 ? this.DOMstrings.circular ? A = A === 0 ? g : A -= 1 : A -= A === 0 ? 0 : 1 : this.DOMstrings.circular ? A = A === g ? 0 : A += 1 : A += A === g ? 0 : 1, this.setActiveStep(A), this.setActiveStage(A);
                        }
                        /**
               * Define os comportamentos do componente
               * @private
               */ _setBehavior() {
                            this.DOMstrings.carouselNextBtn.addEventListener("click", ()=>{
                                this.shiftPage(1);
                            }), this.DOMstrings.carouselPrevBtn.addEventListener("click", ()=>{
                                this.shiftPage(-1);
                            }), this.DOMstrings.step.addEventListener("click", ()=>{
                                this.setActiveStage(this.step.activeStepNum);
                            });
                            const s = new k.A(this.DOMstrings.carouselStage);
                            s.on("SWIPE_LEFT", ()=>{
                                this.shiftPage(1);
                            }), s.on("SWIPE_RIGHT", ()=>{
                                this.shiftPage(-1);
                            }), this.disabledBtns();
                        }
                    }
                    const i = m;
                },
                /***/ "./src/components/checkbox/checkbox.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/partial/js/behavior/checkgroup.js");
                    class b {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(a, s){
                            this.name = a, this.component = s, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            this._setCheckgroupBehavior();
                        }
                        /**
               * Define comportamentos do checkgroup
               * @private
               */ _setCheckgroupBehavior() {
                            this.component.querySelectorAll('input[type="checkbox"][data-parent]').forEach((a)=>{
                                new k.default(a).setBehavior();
                            });
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/cookiebar/cookiebar-data.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ CookiebarData: ()=>/* binding */ k
                    });
                    class k {
                        /**
               * Instancia um objeto de dados do cookiebar. Objeto contém as propriedades contidas no JSON de entrada em uma língua específica
               * @param {string} json - JSON de entrada de dados
               * @param {string} lang - Língua para filtrar o JSON de entrada
               */ constructor(m, i){
                            this.PRIORITY_LEVELS = 5, Object.assign(this, this._filterByLang(m, i)), this._setDataCoherenceByPriority(this.PRIORITY_LEVELS);
                        }
                        /**
               * Filtra um JSON pela língua correspondente
               * @param {string} json - Dados no formato JSON (array de objetos)
               * @param {string} lang - Língua para filtrar o array vindo do json
               * @returns Objeto javascript contendo as propriedade vindas do JSON filtradas pela língua
               * @private
               */ _filterByLang(m, i) {
                            const a = JSON.parse(m), s = a.filter((c)=>c.lang === i);
                            return s.length > 0 ? s[0] : a[0];
                        }
                        /**
               * Consolida os dados iniciais baseado em uma hierarquia de prioridades
               * @private
               */ _setDataCoherenceByPriority() {
                            this.selectAll = this.allOptOut ? this.selectAll : !0, this.cookieGroups.forEach((m)=>{
                                m.groupOptOut = this.allOptOut ? m.groupOptOut : !1, m.groupSelected = this.selectAll || !m.groupOptOut ? !0 : m.groupSelected, m.cookieList.forEach((i)=>{
                                    i.cookieOptOut = m.groupOptOut ? i.cookieOptOut : !1, i.cookieSelected = m.groupSelected || !i.cookieOptOut ? m.groupSelected : i.cookieSelected;
                                });
                            }), this._setIndeterminateState();
                        }
                        /**
               * Controla a configuração do estado indeterminado dos checkboxes
               * @private
               */ _setIndeterminateState() {
                            this._setGroupIndeterminateState(), this._setAllIndeterminateState();
                        }
                        /**
               * Trata a configuração do estado indeterminado dos checkboxes dos grupos de cookies
               * @private
               */ _setGroupIndeterminateState() {
                            this.cookieGroups.forEach((m)=>{
                                let i = !0, a = !0;
                                m.cookieList.forEach((s)=>{
                                    s.cookieSelected ? a = !1 : i = !1;
                                }), m.groupSelected = i ? !0 : !a, m.groupIndeterminated = !(i || a);
                            });
                        }
                        /**
               * Trata a configuração do estado indeterminado do checkbox geral
               * @private
               */ _setAllIndeterminateState() {
                            let m = !0, i = !0, a = !1;
                            this.cookieGroups.forEach((s)=>{
                                s.groupSelected ? i = !1 : m = !1, s.groupIndeterminated && (a = !0);
                            }), this.selectAll = m ? !0 : !i, this.allIndeterminated = a ? !0 : !(m || i);
                        }
                        /**
               * Calcula a quantidade de cookies selecionados em 1 grupo de cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @returns {number} - Quantidade de cookies selecionados em 1 grupo de cookies
               * @public
               */ getCookiesCheckedAmount(m) {
                            let i = 0;
                            return m.cookieList.forEach((a)=>{
                                a.cookieSelected && (i += 1);
                            }), i;
                        }
                        /**
               * Calcula a quantidade total de cookies em 1 grupo de cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @returns {number} - Quantidade total de cookies em 1 grupo de cookies
               * @public
               */ getCookiesAmount(m) {
                            let i = 0;
                            return m.cookieList.forEach(()=>{
                                i += 1;
                            }), i;
                        }
                        /**
               * Ler um arquivo json local
               * @param {string} path - Caminho para o arquivo
               * @param {function} callback - Função de callback que recebe a conteúdo do arquivo
               * @public
               * @static
               */ static loadJSON(m, i) {
                            const a = new XMLHttpRequest();
                            a.overrideMimeType("application/json"), a.open("GET", m, !0), a.onreadystatechange = ()=>{
                                a.readyState === 4 && a.status === 200 && i(a.responseText);
                            }, a.send(null);
                        }
                    }
                },
                /***/ "./src/components/cookiebar/cookiebar-labels.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ CookiebarLabels: ()=>/* binding */ k
                    });
                    class k {
                        /**
               * Instancia um objeto de labels do cookiebar
               * @param {object} data - Objeto de dados do cookiebar
               */ constructor(m){
                            this.data = m;
                        }
                        /**
               * Trata a label para a informação de atualização
               * @returns {string} - Label para a informação de atualização
               * @public
               */ setLastUpdateLabel() {
                            return this.data.lastUpdateLabel || "\xdaltima atualiza\xe7\xe3o";
                        }
                        /**
               * Trata a label para o título da lista de grupos de cookies
               * @returns {string} - Label para o título da lista de grupos de cookies
               * @public
               */ setCookieGroupsLabel() {
                            return this.data.cookieGroupsLabel || "Classes de cookies";
                        }
                        /**
               * Trata a label para o checkbox geral desselecionado
               * @returns {string} - Label para o checkbox geral desselecionado
               * @public
               */ setUnselectAllLabel() {
                            return this.data.unselectAllLabel || "Desselecionar tudo";
                        }
                        /**
               * Trata a label para o checkbox geral selecionado
               * @returns {string} - Label para o checkbox geral selecionado
               * @public
               */ setSelectAllLabel() {
                            return this.data.selectAllLabel || "Selecionar tudo";
                        }
                        /**
               * Trata a label para o checkbox geral
               * @returns {string} - Label para o checkbox geral
               * @public
               */ setCheckAllLabel() {
                            return this.data.selectAll && !this.data.allIndeterminated ? this.setUnselectAllLabel() : this.setSelectAllLabel();
                        }
                        /**
               * Trata a label para o checkbox do grupo de cookies desselecionado
               * @returns {string} - Label para o checkbox do grupo de cookies desselecionado
               * @public
               */ setUnselectAllGroupLabel() {
                            return this.data.unselectAllGroupLabel || "Desselecionar toda classe";
                        }
                        /**
               * Trata a label para o checkbox do grupo de cookies selecionado
               * @returns {string} - Label para o checkbox do grupo de cookies selecionado
               * @public
               */ setSelectAllGroupLabel() {
                            return this.data.selectAllGroupLabel || "Selecionar toda classe";
                        }
                        /**
               * Trata a label para o checkbox do grupo de cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @returns {string} - Label para checkbox do grupo de cookies
               * @public
               */ setCheckGroupLabel(m) {
                            return m.groupSelected && !m.groupIndeterminated ? this.setUnselectAllGroupLabel() : this.setSelectAllGroupLabel();
                        }
                        /**
               * Trata a label para o grupo de cookies 'opt-in'
               * @returns {string} - Label para grupo de cookies 'opt-in'
               * @public
               */ setAlwaysActiveLabel() {
                            return this.data.alwaysActiveLabel || "Sempre ativo";
                        }
                        /**
               * Trata a label para cookie habilitado
               * @returns {string} - Label para cookie habilitado
               * @publi
               */ setCheckCookieEnabledLabel() {
                            return this.data.onLabel || "Ligado";
                        }
                        /**
               * Trata a label para cookie desabilitado
               * @returns {string} - Label para cookie desabilitado
               * @public
               */ setCheckCookieDisabledLabel() {
                            return this.data.offLabel || "Desligado";
                        }
                        /**
               * Trata a label para o nome do cookie
               * @returns {string} - Label para o nome do cookie
               * @public
               */ setCookieNameLabel() {
                            return this.data.cookieNameLabel || "Cookies";
                        }
                        /**
               * Trata a label para o vencimento do cookie
               * @returns {string} - Label para o vencimento do cookie
               * @public
               */ setCookieExpiresLabel() {
                            return this.data.expiresLabel || "Vencimento";
                        }
                        /**
               * Trata a label para o domínio do cookie
               * @returns {string} - Label para o domínio do cookie
               * @public
               */ setCookieDomainLabel() {
                            return this.data.domainLabel || "Dom\xednio";
                        }
                        /**
               * Trata a label para e empresa do cookie
               * @returns {string} - Label para a empresa do cookie
               * @public
               */ setCookieEnterpriseLabel() {
                            return this.data.enterpriseLabel || "Empresa";
                        }
                        /**
               * Trata a label para a finalidade do cookie
               * @returns {string} - Label para a finalidade do cookie
               * @public
               */ setCookiePurposeLabel() {
                            return this.data.purposeLabel || "Finalidade";
                        }
                        /**
               * Trata a label para a descrição do cookie
               * @returns {string} - Label para a descrição do cookie
               * @public
               */ setCookieDescriptionLabel() {
                            return this.data.descriptionLabel || "Descri\xe7\xe3o";
                        }
                        /**
               * Trata a label para o botão de políticas/definições de cookies
               * @returns {string} - Label para o botão de políticas/definições de cookies
               * @public
               */ setPoliticsButtonLabel() {
                            return this.data.allOptOut ? this.data.optOutButton || "Definir Cookies" : this.data.optInButton || "Ver Pol\xedtica de Cookies";
                        }
                        /**
               * Trata a label para o botão de aceite
               * @returns {string} - Label para o botão de aceite
               * @public
               */ setAcceptButtonLabel() {
                            return this.data.acceptButton || "Aceitar";
                        }
                    }
                },
                /***/ "./src/components/cookiebar/cookiebar-templates.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ CookiebarTemplates: ()=>/* binding */ b
                    });
                    var k = y("./src/components/cookiebar/cookiebar-labels.js");
                    class b {
                        /**
               * Instancia um objeto template com os dados do cookiebar
               * @param {object} data - Objeto de dados do cookiebar
               */ constructor(i){
                            this.data = i, this.labels = new k.CookiebarLabels(this.data);
                        }
                        /**
               * Cria um template para a área de conteúdo global
               * @returns {string} - Elemento DOM que representa a área de conteúdo global
               * @public
               */ setGlobalContentArea() {
                            return `<div class="br-modal">
              <div class="br-card" id="card0">
                <div class="container-fluid p-1 p-2xh">
                  <div class="wrapper p-2xh">
                    ${this._setIntroductoryContentArea()}
                    <div id="info-t" class="br-modal-body">
                      ${this._setInfoText()}
                      ${this._setMainContentArea()}
                      ${this._setComplementaryContentArea()}
                    </div>
                  </div>
                  ${this._setActionArea()}
                </div>
              </div>
            </div>`;
                        }
                        /**
               * Cria um template para a área de conteúdo introdutório
               * @returns {string} - Elemento DOM que representa a área de conteúdo introdutório
               * @private
               */ _setIntroductoryContentArea() {
                            return `<div class="br-modal-header entry-content">
              ${this._setMainTitle()}
              ${this._setLastUpdate()}
              ${this._setEntryText()}
            </div>`;
                        }
                        /**
               * Cria um template para a área de conteúdo principal
               * @returns {string} - Elemento DOM que representa a área de conteúdo principal
               * @private
               */ _setMainContentArea() {
                            return `<div class="br-list main-content">
              ${this._setMainContentHeader()}
              ${this._setCookieGroups()}
              ${this.data.noteList && this.data.noteList.length ? this._setNotifications() : ""}
            </div>`;
                        }
                        /**
               * Cria um template para a área de acões
               * @returns {string} - Elemento DOM que representa a área de ações
               * @private
               */ _setActionArea() {
                            return `<div class="br-modal-footer actions justify-content-end">
              ${this._setPoliticsButton()}
              ${this._setAcceptButton()}
            </div>`;
                        }
                        /**
               * Cria um template para o título principal
               * @returns {string} - Elemento DOM que representa o título principal
               * @private
               */ _setMainTitle() {
                            return `<div class="br-modal-title">
              <div class="row">
                <div class="col-sm">
                  <h1>${this.data.mainTitle}</h1>
                </div>
                <div class="col-sm-auto order-first order-sm-last">
                  ${this._setCloseButton()}
                </div>
              </div>
            </div>`;
                        }
                        /**
               * Cria um template para informações sobre atualização
               * @returns {string} - Elemento DOM que representa a informação sobre atualização
               * @private
               */ _setLastUpdate() {
                            return `<p class="last-update">${this.labels.setLastUpdateLabel()}: <span>${this.data.lastUpdate}</span></p>`;
                        }
                        /**
               * Cria um template para o texto introdutório
               * @returns {string} - Elemento DOM que representa o texto introdutório
               * @private
               */ _setEntryText() {
                            return `<p class="entry-text">${this.data.entryText}</p>`;
                        }
                        /**
               * Cria um template para o texto descritivo
               * @returns {string} - Elemento DOM que representa o texto descritivo
               * @private
               */ _setInfoText() {
                            return `<p class="info-text">${this.data.infoText}</p>`;
                        }
                        /**
               * Cria um template para o header da área de conteúdo principal
               * @returns {string} - Elemeto DOM que representa o header da área de conteúdo principal
               * @private
               */ _setMainContentHeader() {
                            return `<div class="header">
              <div class="row justify-content-between flex-fill">
                <div class="col-12 col-sm align-self-center mb-2">
                  <div class="title">${this.labels.setCookieGroupsLabel()}</div>
                </div>
                <div class="col-12 align-self-center">
                  ${this.data.allOptOut ? this._setCheckAll() : ""}
                </div>
                <div class="col-12 text-sm-right message mt-1">
                  ${this.setAllAlertMessage()}
                </div>
              </div>
            </div>`;
                        }
                        /**
               * Cria um template para o grupo de cookies
               * @returns {string} - Elemento DOM que representa os grupos de cookies
               * @private
               */ _setCookieGroups() {
                            let i = "";
                            return this.data.cookieGroups.forEach((a, s)=>{
                                i += `<hr>
                          <div class="br-item group-info">
                            <div class="row mb-1">
                              <div class="col-12 col-sm align-self-center order-4 order-sm-1">
                                ${this._setGroupName(a)}
                              </div>
                              <div class="col align-self-center order-1 order-sm-2">
                                ${a.groupOptOut ? this._setCheckGroup(a, s) : `<span class="always-active float-sm-right">
                                      ${this.labels.setAlwaysActiveLabel()}
                                    </span>`}
                              </div>
                              <div class="col col-sm-auto align-self-center order-2 order-sm-3">
                                ${this._setGroupButton(a.groupName)}
                              </div>
                              <div class="col-12 col-sm-12 order-3 order-sm-4 text-sm-right message mt-1 mb-1">
                                ${this.setGroupAlertMessage(a)}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <p class="group-description">${this._setGroupDescription(a)}</p>
                              </div>
                            </div>
                          </div>
                          <div class="br-list cookie-info">
                            <div class="br-item">
                              <div class="row">
                                <div class="col">
                                  ${this._setCookieInfo(a, s)}
                                </div>
                              </div>
                            </div>
                          </div>`;
                            }), i;
                        }
                        /**
               * Cria um template para o nome do grupo de cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @returns {string} - Elemento DOM que representa o nome do grupo de cookies
               * @orivate
               */ _setGroupName(i) {
                            return `<span class="group-name" title="Expandir">${i.groupName}</span>
              <span class="cookies-checked" title="Expandir">(${i.groupOptOut ? `${this.data.getCookiesCheckedAmount(i)} de ` : ""}</span><span class="group-size" title="Expandir">${this.data.getCookiesAmount(i)})</span>`;
                        }
                        /**
               * Cria um template para a descrição do grupo de cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @returns {string} - Elemento DOM que representa a descrição do grupo de cookies
               * @private
               */ _setGroupDescription(i) {
                            return `<p class="group-description">${i.groupText}</p>`;
                        }
                        /**
               * Cria um template para as informações dos cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @param {number} groupIndex - Índice do grupo de cookies
               * @returns {string} - Elemento DOM que representa as informações dos cookies
               * @private
               */ _setCookieInfo(i, a) {
                            let s = "";
                            return i.cookieList.forEach((c, g)=>{
                                s += `<div class="br-card">
                            <div class="card-content">
                              <div class="row mb-1">
                                <div class="col-12 text-right">
                                  ${c.cookieOptOut ? this._setCheckCookie(a, c, g) : ""}
                                </div>
                                <div class="col-12 message text-right mb-1 mt-1">
                                  ${this.setCookieAlertMessage(c)}
                                </div>
                              </div>
                              <div class="row">
                                <div class="fixed-width cookie-term">
                                  <span>${this.labels.setCookieNameLabel()}</span>
                                </div>
                                <div class="col-12 col-sm mb-1 cookie-data">
                                  <span>${c.cookieName}</span>
                                </div>
                              </div>
                              <div class="row">
                                <div class="fixed-width cookie-term">
                                  <span>${this.labels.setCookieExpiresLabel()}</span>
                                </div>
                                <div class="col-12 col-sm mb-1 cookie-data">
                                  <span>${c.expires}</span>
                                </div>
                              </div>
                              <div class="row">
                                <div class="fixed-width cookie-term">
                                  <span>${this.labels.setCookieDomainLabel()}</span>
                                </div>
                                <div class="col-12 col-sm mb-1 cookie-data">
                                  <span>${c.domain}</span>
                                </div>
                              </div>
                              <div class="row">
                                <div class="fixed-width cookie-term">
                                  <span>${this.labels.setCookieEnterpriseLabel()}</span>
                                </div>
                                <div class="col-12 col-sm mb-1 cookie-data">
                                  <span>${c.enterprise}</span>
                                </div>
                              </div>
                              <div class="row">
                                <div class="fixed-width cookie-term">
                                  <span>${this.labels.setCookiePurposeLabel()}</span>
                                </div>
                                <div class="col-12 col-sm mb-1 cookie-data">
                                  <span>${c.purpose}</span>
                                </div>
                              </div>
                              <div class="row">
                                <div class="fixed-width cookie-term">
                                  <span>${this.labels.setCookieDescriptionLabel()}</span>
                                </div>
                                <div class="col-12 col-sm mb-1 cookie-data">
                                  <span>${c.description}</span>
                                </div>
                              </div>
                            </div>
                          </div>`;
                            }), s;
                        }
                        /**
               * Cria um template para a lista de notificações
               * @returns {string} - Elemento DOM que representa a lista de notificações
               * @private
               */ _setNotifications() {
                            return `<hr>
            <div class="br-item">
              <div class="row">
                <div class="col align-self-center">
                  <span class="group-name" title="Expandir">
                    ${this.data.noteTitle}</span>
                </div>
                <div class="col-auto">
                  ${this._setGroupButton(this.data.noteTitle)}
                </div>
              </div>
            </div>
            <div class="br-list">
              ${this._setNotificationInfo()}
            </div>
            <hr>`;
                        }
                        /**
               * Cria um template para as informações das notificações
               * @returns {string} - Elemento DOM que representa as informações das notificações
               * @private
               */ _setNotificationInfo() {
                            let i = "";
                            return this.data.noteList.forEach((a)=>{
                                i += `<div class="br-item notes">
                                  <div class="row">
                                    <div class="col">
                                      <p>${a.question}</p>
                                      <p>${a.answer}</p>
                                    </div>
                                  </div>
                                </div>`;
                            }), i;
                        }
                        /**
               * Cria um template para a área de conteúdo complementar
               * @returns {string} - Elemento DOM que representa a área de conteúdo complementar
               * @private
               */ _setComplementaryContentArea() {
                            return `<div class="br-list complementary-content">
              ${this._setLinkInfo()}
            </div>`;
                        }
                        /**
               * Cria um templata para as informações dos links
               * @returns {string} - Elemento DOM que representa as informações dos links
               * @private
               */ _setLinkInfo() {
                            let i = "";
                            return this.data.links.forEach((a)=>{
                                const s = a.target ? ' target="${linkData.target}"' : "";
                                i += `<div class="br-item text-center">
                          <div class="row">
                            <div class="col">
                              <a href="${a.url}"${s}>${a.name}<i class="fas fa-external-link-alt" aria-hidden="true"></i>
                              </a>
                            </div>
                          </div>
                        </div>`;
                            }), i;
                        }
                        /**
               * Cria um template pra o botão de políticas de cookies
               * @returns {string} - Elemento DOM que representa o botão de politicas de cookies
               * @private
               */ _setPoliticsButton() {
                            return `<button class="br-button secondary small" type="button" aria-label="${this.labels.setPoliticsButtonLabel()}">${this.labels.setPoliticsButtonLabel()}</button>`;
                        }
                        /**
               * Cria um template pra o botão de aceite
               * @returns {string} - Elemento DOM que representa o botão de aceite
               * @private
               */ _setAcceptButton() {
                            return `<button class="br-button primary small" type="button" aria-label="${this.labels.setAcceptButtonLabel()}">${this.labels.setAcceptButtonLabel()}</button>`;
                        }
                        /**
               * Cria um template para o botão de fechar
               * @returns {string} - Elemento DOM que represeta o botão de fechar
               * @private
               */ _setCloseButton() {
                            return `<button class="br-button close circle small float-right" type="button" data-dismiss="br-modal" aria-label="${this.data.closeLabel || "fechar"}">
              <i class="fas fa-times"></i>
            </button>`;
                        }
                        /**
               * Cria um template para botão de abrir/fechar do brupo de cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @returns {string} - Elemento DOM que representa o botão de abrir/fechar do grupo de cookies
               * @private
               */ _setGroupButton(i) {
                            return `<button class="br-button circle small float-right" type="button" aria-label="Expandir grupo de Cookies ${i}">
              <i class="fas fa-angle-down" aria-hidden="true"></i>
            </button>`;
                        }
                        /**
               * Cria um template para o checkbox de seleção geral
               * @returns {string} - Elemento DOM que representa o checkbox de seleção geral
               * @private
               */ _setCheckAll() {
                            return `<div class="br-checkbox">
              <input
                id="check-all"
                name="check-all"
                type="checkbox"                
                aria-label="${this.labels.setCheckAllLabel()}"
                ${this.data.selectAll ? "checked" : ""}
                ${this.data.allIndeterminated ? "indeterminate" : ""}
                data-parent="check-all"
                data-checked-label="${this.labels.setSelectAllLabel()}"
                data-unchecked-label="${this.labels.setUnselectAllLabel()}"
              />
              <label for="check-all">
                ${this.labels.setCheckAllLabel()}
              </label>
            </div>`;
                        }
                        /**
               * Cria um template para o checkbox de seleção do grupo de cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @param {number} groupIndex - Índice do grupo de cookies
               * @returns {string} - Elemento DOM que representa o checkbox de seleção do grupo de cookies
               * @private
               */ _setCheckGroup(i, a) {
                            return `<div class="br-checkbox">
              <input
                id="${`check-group-${a}`}"
                name="${`check-group-${a}`}"
                type="checkbox"                
                aria-label="${this.labels.setCheckGroupLabel(i)}"
                ${i.groupSelected ? "checked" : ""}
                ${i.groupIndeterminated ? "indeterminate" : ""}
                data-child="check-all"
                data-parent="${`check-group-${a}`}"
                data-checked-label="${this.labels.setSelectAllGroupLabel()}"
                data-unchecked-label="${this.labels.setUnselectAllGroupLabel()}"
              />
              <label for="${`check-group-${a}`}">
                ${this.labels.setCheckGroupLabel(i)}
              </label>
            </div>`;
                        }
                        /**
               * Cria um template para checkbox(switch) de seleção do cookie
               * @param {number} groupIndex - Índice do grupo de cookies
               * @param {object} cookieData - Objeto com dados de 1 cookie
               * @param {number} cookieIndex - Índice do cookie
               * @returns {string} - Elemento DOM que representa o checkbox(switch) de seleção do cookie
               * @private
               */ _setCheckCookie(i, a, s) {
                            return `<div class="br-switch small icon">
              <input
                id="${`check-cookie-${i}-${s}`}"
                name="${`check-cookie-${i}-${s}`}"
                type="checkbox"
                role="switch"
                ${a.cookieSelected ? "checked" : ""}
                data-child="${`check-group-${i}`}"
              />
              <label
                for="${`check-cookie-${i}-${s}`}"
                aria-label="${a.cookieSelected ? this.labels.setCheckCookieEnabledLabel() : this.labels.setCheckCookieDisabledLabel()}">
              </label>
              <div
                class="switch-data"
                data-enabled="${this.labels.setCheckCookieEnabledLabel()}"
                data-disabled="${this.labels.setCheckCookieDisabledLabel()}">
              </div>
            </div>`;
                        }
                        /**
               * Cria um template para a mensagem de alerta geral
               * @returns {string} - Elemento DOM que representa a mensagem de alerta geral ou uma string vazia
               * @public
               */ setAllAlertMessage() {
                            return this.data.allAlertMessage ? `<span class="feedback warning ${!this.data.selectAll || this.data.allIndeterminated ? "" : "d-none"}" role="alert" aria-live="polite">
                <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                ${this.data.allAlertMessage}
              </span>` : "";
                        }
                        /**
               * Cria um template para a mensagem de alerta para o grupo de cookies
               * @param {object} groupData - Objeto com dados de 1 grupo de cookies
               * @returns {string} - Elemento DOM que representa a mensagem de alerta para o grupo de cookies
               * @public
               */ setGroupAlertMessage(i) {
                            return i.groupAlertMessage ? `<span class="feedback warning ${!i.groupSelected || i.groupIndeterminated ? "" : "d-none"}" role="alert" aria-live="polite">
          <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
          ${i.groupAlertMessage}
        </span>` : "";
                        }
                        /**
               * Cria um template para a mensagem de alerta para o cookie
               * @param {object} cookieData - Objeto com dados de 1 cookie
               * @returns {string} - Elemento DOM que representa a mensagem de alerta para o cookie
               * @public
               */ setCookieAlertMessage(i) {
                            return i.alertMessage ? `<span class="feedback warning ${i.cookieSelected ? "d-none" : ""}" role="alert" aria-live="polite">
          <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
          ${i.alertMessage}
        </span>` : "";
                        }
                    }
                },
                /***/ "./src/components/cookiebar/cookiebar.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>/* binding */ a
                    });
                    var k = y("./src/partial/js/behavior/checkgroup.js"), b = y("./src/components/cookiebar/cookiebar-data.js"), m = y("./src/components/cookiebar/cookiebar-templates.js"), i = y("./src/components/cookiebar/selectors.js");
                    class a {
                        /**
               * Instancia um objeto cookiebar
               * @param {object} objeto - Objeto para destructuring com as propriedades abaixo
               * @property {string} name - Nome do componente em minúsculo (br-cookiebar)
               * @property {object} component - Objeto referenciando a raiz do componente DOM
               * @property {string} json - JSON de entrada com dados do cookiebar
               * @property {string} lang - Lingua para filtrar o JSON de entrada
               * @property {string} mode - Mode de renderização do cookibar ('default' | 'open')
               * @property {function} callback - Chamada no aceite do cookiebar com o JSON de saída como argumento
               */ constructor({ name: c, component: g, json: A, lang: F, mode: $ = "default", callback: J }){
                            this.name = c, this.component = g, this.data = new b.CookiebarData(A, F), this.templates = new m.CookiebarTemplates(this.data), this.mode = $, this.callback = J, this._setUp();
                        }
                        /**
               * Controla a instanciação do cookiebar
               * @private
               */ _setUp() {
                            this._buildCookiebar(), this._setAccessibility(), this._setBehavior(), this._showCookiebar();
                        }
                        /**
               * Controla a construção do cookiebar com o uso de templates
               * @private
               */ _buildCookiebar() {
                            this.component.innerHTML = this.templates.setGlobalContentArea();
                        }
                        /**
               * Configura o componente para a acessibiilidade com o leitor de tela
               * @private
               */ _setAccessibility() {
                            this.component.setAttribute("role", "dialog"), this.component.setAttribute("aria-modal", !0), this.component.setAttribute("aria-describedby", "info-t"), this.component.setAttribute("aria-label", "Componente para defini\xe7\xe3o de Cookies");
                        }
                        /**
               * Controla o comportamento dos itens interativos do cookiebar
               * @private
               */ _setBehavior() {
                            this._setAcceptButtonBehavior(), this._setPoliticsButtonBehavior(), this._setCloseButtonBehavior(), this._setToggleGroupBehavior(), this._setCheckboxBehavior(), this._setSelectionBehavior(), this._setWindowResizeBehavior();
                        }
                        /**
               * Trata o comportamento do botão de aceite do cookiebar
               * @private
               */ _setAcceptButtonBehavior() {
                            const c = this.component.querySelector(i.ACCEPT_BUTTON);
                            c.addEventListener("click", ()=>{
                                this._hideCookiebar(), document.body.style.overflowY = "auto", this.callback(this._setOutputJSON());
                            }), c.addEventListener("keydown", (g)=>{
                                g.key === "Tab" && (this.component.classList.contains("default") || this.component.focus());
                            }), this._setActionButtonResponsive(c);
                        }
                        /**
               * Trata o comportamento do botão de políticas/definições de cookies
               * @private
               */ _setPoliticsButtonBehavior() {
                            this.component.querySelectorAll(i.POLITICS_BUTTON).forEach((c)=>{
                                c.addEventListener("click", ()=>{
                                    c.classList.add("d-none"), this.component.classList.remove("default"), this.component.focus(), document.body.style.overflowY = "hidden", this._setOpenView();
                                }), this._setActionButtonResponsive(c);
                            });
                        }
                        /**
               * Trata o comportamento do botão de fechar do cookiebar no modo open
               * @orivate
               */ _setCloseButtonBehavior() {
                            this.component.querySelectorAll(i.CLOSE_BUTTON).forEach((c)=>{
                                c.addEventListener("click", ()=>{
                                    switch(this.component.classList.add("default"), this.mode){
                                        case "open":
                                            this._hideCookiebar();
                                    }
                                    this.component.querySelector(i.POLITICS_BUTTON).classList.remove("d-none"), document.body.style.overflowY = "auto", this._setDefaultView();
                                });
                            });
                        }
                        /**
               * Trata o redimensionamento da tela
               * @private
               */ _setWindowResizeBehavior() {
                            window.addEventListener("resize", ()=>{
                                this.component.classList.contains("default") || this._setOpenView(), this.component.querySelectorAll(i.ACTION_BUTTONS).forEach((c)=>{
                                    this._setActionButtonResponsive(c);
                                });
                            });
                        }
                        /**
               * Trata a responsividade de um botão de ação baseado na largura da tela
               * @param {object} button - Elemento DOM que representa um botão de ação
               * @private
               */ _setActionButtonResponsive(c) {
                            window.matchMedia("(max-width: 574px)").matches && c.classList.add("block"), window.matchMedia("(min-width: 575px)").matches && c.classList.remove("block");
                        }
                        /**
               * Trata a abertura/fechamento do grupo de cookies
               * @private
               */ _setToggleGroupBehavior() {
                            this.component.querySelectorAll(`${`${i.GROUP_BUTTON}, ${i.GROUP_NAME}, ${i.COOKIES_CHECKED}, ${i.GROUP_SIZE}`}`).forEach((c)=>{
                                c.addEventListener("click", this._handleToggleGroupClick.bind(this));
                            });
                        }
                        /**
               * Handler que trata do evento de click no grupo
               * @param {object} event - Objeto Event
               * @param {number} groupIndex - Índice do grupo
               * @private
               */ _handleToggleGroupClick(c) {
                            const g = this._getParentElementByClass(c.currentTarget, "br-item");
                            g.classList.contains("open") ? (g.classList.remove("open"), g.nextElementSibling.querySelectorAll(i.BR_SWITCH).forEach((A)=>{
                                A.setAttribute("tabindex", -1);
                            }), this._setGroupAttributes(g, `Expandir o grupo de Cookies ${g.querySelector(".group-name").innerText}`), this._toggleIcon(g, "fa-angle-up", "fa-angle-down")) : (g.classList.add("open"), g.nextElementSibling.querySelectorAll(i.BR_SWITCH).forEach((A)=>{
                                A.setAttribute("tabindex", 0);
                            }), this._setGroupAttributes(g, `Retrair o grupo de Cookies ${g.querySelector(".group-name").innerText}`), this._toggleIcon(g, "fa-angle-down", "fa-angle-up"), this._scrollUp(g));
                        }
                        /**
               * Trata do comportamento do grupo de checkboxes do cookiebar
               * @private
               */ _setCheckboxBehavior() {
                            this.component.querySelectorAll(i.PARENT_CHECKBOX).forEach((c)=>{
                                this.checkgroupBehavior = new k.default(c), this.checkgroupBehavior.setBehavior();
                            });
                        }
                        /**
               * Trata da seleção dos checkboxes
               * @private
               */ _setSelectionBehavior() {
                            this.component.querySelectorAll(i.CHECKBOX).forEach((c)=>{
                                c.addEventListener("change", this._controlSelection.bind(this));
                            });
                        }
                        /**
               * Handler para o evento change na seleção dos checkboxes
               * @param {object} event - Objeto eventDOM
               * @private
               */ _controlSelection(c) {
                            const g = c.currentTarget.id.split("-");
                            switch(g[1]){
                                case "all":
                                    this._setCheckAllBehavior(c.currentTarget);
                                    break;
                                case "group":
                                    this._setCheckgroupBehavior(c.currentTarget, g[2]);
                                    break;
                                case "cookie":
                                    this._setCheckCookieBehavior(c.currentTarget, g[2], g[3]);
                                    break;
                            }
                        }
                        /**
               * Trata a seleção do checkbox geral
               * @param {object} checkbox - Elemento DOM que represeta um checkbox geral
               * @private
               */ _setCheckAllBehavior(c) {
                            this.data.selectAll = c.checked, this.data.allIndeterminated = !!c.hasAttribute("indeterminate"), this._displayBroadAlertMessage();
                        }
                        /**
               * Trata da seleção do checkbox de grupo
               * @param {object} checkbox - Elemento DOM que represta um checkbox de grupo
               * @param {number} groupIndex - Índice do grupo
               * @private
               */ _setCheckgroupBehavior(c, g) {
                            this.data.cookieGroups[g].groupSelected = c.checked, this.data.cookieGroups[g].groupIndeterminated = !!c.hasAttribute("indeterminate"), this.data.cookieGroups[g].cookieList.forEach((A, F)=>{
                                A.cookieOptOut || (A.cookieSelected = c.checked, this._displayCookieAlertMessage(g, F));
                            }), this._displayGroupAlertMessage(g);
                        }
                        /**
               * Trata da seleção do checkbox de cookie
               * @param {object} checkbox - Elemento DOM que represeta um checkbox de cookie
               * @param {number} groupIndex - Índice do grupo
               * @param {number} cookieIndex - Índicd do cookie dentro do grupo
               * @private
               */ _setCheckCookieBehavior(c, g, A) {
                            this.data.cookieGroups[g].cookieList[A].cookieSelected = c.checked, this._displayCookieAlertMessage(g, A);
                        }
                        /**
               * Controla a apresentação da mensagem geral
               * @private
               */ _displayBroadAlertMessage() {
                            this.component.querySelectorAll(i.BROAD_ALERT).forEach((c)=>{
                                this.data.allAlertMessage && (!this.data.selectAll || this.data.allIndeterminated) ? c.classList.remove("d-none") : c.classList.add("d-none");
                            });
                        }
                        /**
               * Controla a apresentação da mensagem de grupo
               * @param {number} groupIndex - Índice do grupo
               * @private
               */ _displayGroupAlertMessage(c) {
                            this.component.querySelectorAll(i.GROUP_INFO)[c].querySelectorAll(i.GROUP_ALERT).forEach((A)=>{
                                this.data.cookieGroups[c].groupAlertMessage && (!this.data.cookieGroups[c].groupSelected || this.data.cookieGroups[c].groupIndeterminated) ? A.classList.remove("d-none") : A.classList.add("d-none");
                            });
                        }
                        /**
               * Controla a apresentação da mensagem de cookie
               * @param {number} groupIndex - Índice do grupo
               * @param {number} cookieIndex - Índice do cookie dentro do grupo
               */ _displayCookieAlertMessage(c, g) {
                            this.component.querySelectorAll(i.GROUP_INFO)[c].nextElementSibling.querySelectorAll(i.COOKIE_CARD)[g].querySelectorAll(i.COOKIE_ALERT).forEach(($)=>{
                                this.data.cookieGroups[c].cookieList[g].alertMessage && !this.data.cookieGroups[c].cookieList[g].cookieSelected ? $.classList.remove("d-none") : $.classList.add("d-none");
                            });
                        }
                        /**
               * Busca um elemento DOM pai com uma determinada classe
               * @param {object} element - Elemento DOM
               * @param {string} className - Nome de uma classe para busca
               * @returns {object} - Elemento DOM representando que contém uma determinada classe
               * @private
               */ _getParentElementByClass(c, g) {
                            for(parent = c.parentNode; !parent.classList.contains(g);)parent = parent.parentNode;
                            return parent;
                        }
                        /**
               * Troca a classe do icone
               * @param {object} element - Elemento DOM referente ao icone
               * @param {string} oldIcon - Classe do icone que será retirada
               * @param {string} newIcon - Classe do icone que será incluido
               * @private
               */ _toggleIcon(c, g, A) {
                            c.querySelectorAll(i.BUTTON_ICON).forEach((F)=>{
                                F.classList.remove(g), F.classList.add(A);
                            });
                        }
                        /**
               * Trata a label do atributo aria-label
               * @param {object} element - Elemento DOM referente ao grupo
               * @param {string} label - Label para o aria-label
               * @private
               */ _setGroupAttributes(c, g) {
                            c.querySelectorAll(`${`${i.GROUP_BUTTON}, ${i.GROUP_NAME}, ${i.COOKIES_CHECKED}, ${i.GROUP_SIZE}`}`).forEach((A)=>{
                                A.setAttribute("aria-label", g);
                            });
                        }
                        /**
               * Trata a rolagem da tela do grupo de cookies aberto
               * @param {object} element - Elemento DOM que representa a grupo de cookies
               * @private
               */ _scrollUp(c) {
                            setTimeout(()=>{
                                this.component.querySelectorAll(i.WRAPPER).forEach(()=>{
                                    setTimeout(()=>{
                                        c.scrollIntoView({
                                            behavior: "smooth",
                                            block: "start"
                                        });
                                    }, 150);
                                }, 5e3);
                            });
                        }
                        /**
               * Mostra o cookiebar na tela com foco e no modo escolhido
               * @private
               */ _showCookiebar() {
                            switch(this.component.classList.remove("d-none"), this.component.focus(), this.mode){
                                case "open":
                                    this.component.classList.remove("default"), this.component.querySelectorAll(i.POLITICS_BUTTON).forEach((c)=>{
                                        c.classList.add("d-none");
                                    }), document.body.style.overflowY = "hidden", this._setOpenView();
                            }
                        }
                        /**
               * Oculta o cookiebar na tela
               * @private
               */ _hideCookiebar() {
                            this.component.classList.add("d-none");
                        }
                        /**
               * Configura a altura da parte rolável do cookiebar de acordo com a altura da janela
               * @private
               */ _setOpenView() {
                            const c = this.component.querySelector(i.WRAPPER), g = this.component.querySelector(i.CONTAINER_FLUID), A = this.component.querySelector(i.MODAL_FOOTER), F = window.getComputedStyle(g, null).getPropertyValue("padding-top").match(/\d+/), $ = `${window.innerHeight - F * 2 - A.offsetHeight}px`;
                            c.style.height = $;
                        }
                        /**
               * Configura a altura do cookiebar no modo default
               * @private
               */ _setDefaultView() {
                            this.component.querySelector(i.WRAPPER).removeAttribute("style");
                        }
                        /**
               * Cria o JSON de saída do cookiebar
               * @returns {string} - JSON de saída do cookiebar
               * @private
               */ _setOutputJSON() {
                            return this.output = {}, this.output.selectAll = this.data.allIndeterminated ? "indeterminated" : this.data.selectAll, this.output.cookieGroups = [], this.data.cookieGroups.forEach((c)=>{
                                const g = [];
                                c.cookieList.forEach((A)=>{
                                    g.push({
                                        cookieId: A.cookieId,
                                        cookieSelected: A.cookieSelected
                                    });
                                }), this.output.cookieGroups.push({
                                    cookieList: g,
                                    groupId: c.groupId,
                                    groupSelected: c.groupIndeterminated ? "indeterminated" : c.groupSelected
                                });
                            }), JSON.stringify(this.output);
                        }
                        static createCookiebar(c, g) {
                            const A = document.createElement("div");
                            A.classList.add("br-cookiebar", "default", "d-none"), A.setAttribute("tabindex", 1), document.body.appendChild(A);
                            const F = {
                                callback: g,
                                component: A,
                                json: c,
                                lang: "pt-br",
                                mode: "default",
                                name: "br-cookiebar"
                            };
                            return new a(F);
                        }
                    }
                },
                /***/ "./src/components/cookiebar/jsonData.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ default: ()=>b
                    });
                    const b = `[
  {
    "lang": "pt-br",
    "allOptOut": true,
    "acceptButton": "Aceitar",
    "optOutButton": "Definir Cookies",
    "optInButton": "Ver Pol\xedtica de Cookies",
    "infoText": "Minim pariatur amet laboris sint consectetur enim do voluptate",
    "mainTitle": "Exercitation et proident",
    "lastUpdate": "01/02/2021",
    "entryText": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Doloribus aspernatur neque culpa nisi alias. Voluptatem dicta nihil magnam, cumque voluptatum animi distinctio molestias recusandae ipsam, sapiente unde error repellendus quibusdam?",
    "selectAll": false,
    "allAlertMessage": "Ao desativar qualquer Cookie, sua navega\xe7\xe3o poder\xe1 ser comprometida",
    "closeLabel": "fechar tela de sele\xe7\xe3o de cookies",
    "lastUpdateLabel": "\xdaltima atualiza\xe7\xe3o",
    "cookieGroupsLabel": "Classes de cookies",
    "selectAllLabel": "Selecionar tudo",
    "unselectAllLabel": "Desselecionar tudo",
    "selectAllGroupLabel": "Selecionar toda classe",
    "unselectAllGroupLabel": "Desselecionar toda classe",
    "onLabel": "Ligado",
    "offLabel": "Desligado",
    "alwaysActiveLabel": "Sempre ativo",
    "cookieNameLabel": "Cookies",
    "expiresLabel": "Vencimento",
    "domainLabel": "Dom\xednio",
    "enterpriseLabel": "Empresa",
    "purposeLabel": "Finalidade",
    "descriptionLabel": "Descri\xe7\xe3o",
    "cookieGroups": [
      {
        "groupId": "necessarios",
        "groupName": "Estritamente necess\xe1rios",
        "groupOptOut": false,
        "groupSelected": false,
        "groupAlertMessage": "Alerta group 0",
        "groupText": "Descri\xe7\xe3o do Grupo de Cookies.",
        "cookieList": [
          {
            "cookieId": "necessario-1",
            "cookieOptOut": false,
            "cookieSelected": false,
            "alertMessage": "Alerta group 0 - cookie 0",
            "cookieName": "optimizelyEndUserId",
            "expires": "30 minutos",
            "domain": "serpro.gov.br",
            "enterprise": "Serpro",
            "purpose": "Autoriza\xe7\xe3o",
            "description": "Descri\xe7\xe3o do Cookie"
          },
          {
            "cookieId": "necessario-2",
            "cookieOptOut": false,
            "cookieSelected": false,
            "alertMessage": "Alerta group 0 - cookie 1",
            "cookieName": "optimizelyEndUserId",
            "expires": "30 minutos",
            "domain": "serpro.gov.br",
            "enterprise": "Serpro",
            "purpose": "Autoriza\xe7\xe3o",
            "description": "Descri\xe7\xe3o do Cookie"
          }
        ]
      },
      {
        "groupId": "desempenho",
        "groupName": "Desempenho, funcionamento, marketing e personaliza\xe7\xe3o",
        "groupOptOut": true,
        "groupSelected": true,
        "groupAlertMessage": "Ao desativar um Cookie do grupo Desempenho, o desempenho do site pode ser comprometido.",
        "groupText": "Descri\xe7\xe3o do Grupo de Cookies.",
        "cookieList": [
          {
            "cookieId": "desempenho-2",
            "cookieOptOut": true,
            "cookieSelected": false,
            "alertMessage": "Ao desativar o Cookie desempenho 2, o desempenho do site pode ser comprometido.",
            "cookieName": "optimizelyEndUserId",
            "expires": "30 minutos",
            "domain": "serpro.gov.br",
            "enterprise": "Serpro",
            "purpose": "Autoriza\xe7\xe3o",
            "description": "Descri\xe7\xe3o do Cookie"
          },
          {
            "cookieId": "desempenho-3",
            "cookieOptOut": true,
            "cookieSelected": false,
            "cookieName": "optimizelyEndUserId",
            "expires": "30 minutos",
            "domain": "serpro.gov.br",
            "enterprise": "Serpro",
            "purpose": "Autoriza\xe7\xe3o",
            "description": "Descri\xe7\xe3o do Cookie"
          }
        ]
      },
      {
        "groupId": "experiencia",
        "groupName": "Experi\xeancia do site",
        "groupOptOut": true,
        "groupSelected": false,
        "groupAlertMessage": "Ao desativar algum Cookie do Grupo Experi\xeancia do site, sua navega\xe7\xe3o ficar\xe1 comprometida.",
        "groupText": "Descri\xe7\xe3o do Grupo de Cookies.",
        "cookieList": [
          {
            "cookieId": "experiencia-1",
            "cookieOptOut": true,
            "cookieSelected": false,
            "alertMessage": "Ao desativar o Cookie experiencia-1, sua navega\xe7\xe3o ficar\xe1 comprometida.",
            "cookieName": "optimizelyEndUserId",
            "expires": "30 minutos",
            "domain": "serpro.gov.br",
            "enterprise": "Serpro",
            "purpose": "Autoriza\xe7\xe3o",
            "description": "Descri\xe7\xe3o do Cookie"
          },
          {
            "cookieId": "experiencia-2",
            "cookieOptOut": true,
            "cookieSelected": false,
            "alertMessage": "Ao desativar o Cookie experiencia-1, sua navega\xe7\xe3o ficar\xe1 comprometida.",
            "cookieName": "optimizelyEndUserId",
            "expires": "30 minutos",
            "domain": "serpro.gov.br",
            "enterprise": "Serpro",
            "purpose": "Autoriza\xe7\xe3o",
            "description": "Descri\xe7\xe3o do Cookie"
          }
        ]
      }
    ],
    "noteTitle": "Aviso sobre cookies",
    "noteList": [
      {
        "question": "O que s\xe3o cookies?",
        "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam eius distinctio rerum ad, maxime alias vel minima, asperiores sequi eveniet non optio officiis quaerat reiciendis quae odio explicabo ut debitis?"
      },
      {
        "question": "Durabilidade?",
        "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam eius distinctio rerum ad, maxime alias vel minima, asperiores sequi eveniet non optio officiis quaerat reiciendis quae odio explicabo ut debitis?"
      },
      {
        "question": "Proveni\xeancia?",
        "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam eius distinctio rerum ad, maxime alias vel minima, asperiores sequi eveniet non optio officiis quaerat reiciendis quae odio explicabo ut debitis?"
      },
      {
        "question": "Finalidade?",
        "answer": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam eius distinctio rerum ad, maxime alias vel minima, asperiores sequi eveniet non optio officiis quaerat reiciendis quae odio explicabo ut debitis?"
      }
    ],
    "links": [
      {
        "name": "Declara\xe7\xe3o de Conformidade com os Princ\xedpios de Prote\xe7\xe3o de Dados",
        "url": "#"
      }
    ]
  }
]`;
                },
                /***/ "./src/components/cookiebar/selectors.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ ACCEPT_BUTTON: ()=>/* binding */ b,
                        /* harmony export */ ACTION_BUTTONS: ()=>/* binding */ m,
                        /* harmony export */ BROAD_ALERT: ()=>/* binding */ F,
                        /* harmony export */ BR_SWITCH: ()=>/* binding */ Q,
                        /* harmony export */ BUTTON_ICON: ()=>/* binding */ xe,
                        /* harmony export */ CHECKBOX: ()=>/* binding */ _e,
                        /* harmony export */ CLOSE_BUTTON: ()=>/* binding */ i,
                        /* harmony export */ CONTAINER_FLUID: ()=>/* binding */ a,
                        /* harmony export */ COOKIES_CHECKED: ()=>/* binding */ Y,
                        /* harmony export */ COOKIE_ALERT: ()=>/* binding */ J,
                        /* harmony export */ COOKIE_CARD: ()=>/* binding */ A,
                        /* harmony export */ GROUP_ALERT: ()=>/* binding */ $,
                        /* harmony export */ GROUP_BUTTON: ()=>/* binding */ z,
                        /* harmony export */ GROUP_INFO: ()=>/* binding */ g,
                        /* harmony export */ GROUP_NAME: ()=>/* binding */ V,
                        /* harmony export */ GROUP_SIZE: ()=>/* binding */ fe,
                        /* harmony export */ MODAL_FOOTER: ()=>/* binding */ c,
                        /* harmony export */ PARENT_CHECKBOX: ()=>/* binding */ H,
                        /* harmony export */ POLITICS_BUTTON: ()=>/* binding */ k,
                        /* harmony export */ WRAPPER: ()=>/* binding */ s
                    });
                    const k = ".actions .br-button.secondary", b = ".actions .br-button.primary", m = `${k}, ${b}`, i = ".br-modal-header .br-button.close", a = ".br-modal > .br-card .container-fluid", s = ".br-modal > .br-card .wrapper", c = ".br-modal > .br-card .br-modal-footer", g = ".main-content .group-info", A = ".main-content .cookie-info .br-card", F = ".header .row:nth-child(1) div:nth-child(3) .feedback", $ = ".row:nth-child(1) div:nth-child(4) .feedback", J = ".row:nth-child(1) div:nth-child(2) .feedback", se = '.br-checkbox input[type="checkbox"]', Q = '.br-switch input[type="checkbox"]', _e = `${se}, ${Q}`, H = ".main-content .br-checkbox input[data-parent]", Y = ".main-content .br-item .cookies-checked", z = ".main-content .br-item .br-button", V = ".main-content .br-item .group-name", fe = ".main-content .br-item .group-size", xe = ".br-button i.fas";
                },
                /***/ "./src/components/datetimepicker/datetimepicker.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        A: ()=>/* binding */ ut
                    });
                    var k = [
                        "onChange",
                        "onClose",
                        "onDayCreate",
                        "onDestroy",
                        "onKeyDown",
                        "onMonthChange",
                        "onOpen",
                        "onParseConfig",
                        "onReady",
                        "onValueUpdate",
                        "onYearChange",
                        "onPreCalendarPosition"
                    ], b = {
                        _disable: [],
                        allowInput: !1,
                        allowInvalidPreload: !1,
                        altFormat: "F j, Y",
                        altInput: !1,
                        altInputClass: "form-control input",
                        animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
                        ariaDateFormat: "F j, Y",
                        autoFillDefaultTime: !0,
                        clickOpens: !0,
                        closeOnSelect: !0,
                        conjunction: ", ",
                        dateFormat: "Y-m-d",
                        defaultHour: 12,
                        defaultMinute: 0,
                        defaultSeconds: 0,
                        disable: [],
                        disableMobile: !1,
                        enableSeconds: !1,
                        enableTime: !1,
                        errorHandler: function(M) {
                            return typeof console < "u" && console.warn(M);
                        },
                        getWeek: function(M) {
                            var P = new Date(M.getTime());
                            P.setHours(0, 0, 0, 0), P.setDate(P.getDate() + 3 - (P.getDay() + 6) % 7);
                            var n = new Date(P.getFullYear(), 0, 4);
                            return 1 + Math.round(((P.getTime() - n.getTime()) / 864e5 - 3 + (n.getDay() + 6) % 7) / 7);
                        },
                        hourIncrement: 1,
                        ignoredFocusElements: [],
                        inline: !1,
                        locale: "default",
                        minuteIncrement: 5,
                        mode: "single",
                        monthSelectorType: "dropdown",
                        nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
                        noCalendar: !1,
                        now: /* @__PURE__ */ new Date(),
                        onChange: [],
                        onClose: [],
                        onDayCreate: [],
                        onDestroy: [],
                        onKeyDown: [],
                        onMonthChange: [],
                        onOpen: [],
                        onParseConfig: [],
                        onReady: [],
                        onValueUpdate: [],
                        onYearChange: [],
                        onPreCalendarPosition: [],
                        plugins: [],
                        position: "auto",
                        positionElement: void 0,
                        prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
                        shorthandCurrentMonth: !1,
                        showMonths: 1,
                        static: !1,
                        time_24hr: !1,
                        weekNumbers: !1,
                        wrap: !1
                    }, m = {
                        weekdays: {
                            shorthand: [
                                "Sun",
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat"
                            ],
                            longhand: [
                                "Sunday",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday"
                            ]
                        },
                        months: {
                            shorthand: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec"
                            ],
                            longhand: [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ]
                        },
                        daysInMonth: [
                            31,
                            28,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ],
                        firstDayOfWeek: 0,
                        ordinal: function(M) {
                            var P = M % 100;
                            if (P > 3 && P < 21) return "th";
                            switch(P % 10){
                                case 1:
                                    return "st";
                                case 2:
                                    return "nd";
                                case 3:
                                    return "rd";
                                default:
                                    return "th";
                            }
                        },
                        rangeSeparator: " to ",
                        weekAbbreviation: "Wk",
                        scrollTitle: "Scroll to increment",
                        toggleTitle: "Click to toggle",
                        amPM: [
                            "AM",
                            "PM"
                        ],
                        yearAriaLabel: "Year",
                        monthAriaLabel: "Month",
                        hourAriaLabel: "Hour",
                        minuteAriaLabel: "Minute",
                        time_24hr: !1
                    };
                    const i = m;
                    var a = function(M, P) {
                        return P === void 0 && (P = 2), ("000" + M).slice(P * -1);
                    }, s = function(M) {
                        return M === !0 ? 1 : 0;
                    };
                    function c(M, P) {
                        var n;
                        return function() {
                            var ye = this, ke = arguments;
                            clearTimeout(n), n = setTimeout(function() {
                                return M.apply(ye, ke);
                            }, P);
                        };
                    }
                    var g = function(M) {
                        return M instanceof Array ? M : [
                            M
                        ];
                    };
                    function A(M, P, n) {
                        if (n === !0) return M.classList.add(P);
                        M.classList.remove(P);
                    }
                    function F(M, P, n) {
                        var ye = window.document.createElement(M);
                        return P = P || "", n = n || "", ye.className = P, n !== void 0 && (ye.textContent = n), ye;
                    }
                    function $(M) {
                        for(; M.firstChild;)M.removeChild(M.firstChild);
                    }
                    function J(M, P) {
                        if (P(M)) return M;
                        if (M.parentNode) return J(M.parentNode, P);
                    }
                    function se(M, P) {
                        var n = F("div", "numInputWrapper"), ye = F("input", "numInput " + M), ke = F("span", "arrowUp"), Me = F("span", "arrowDown");
                        if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? ye.type = "number" : (ye.type = "text", ye.pattern = "\\d*"), P !== void 0) for(var ht in P)ye.setAttribute(ht, P[ht]);
                        return n.appendChild(ye), n.appendChild(ke), n.appendChild(Me), n;
                    }
                    function Q(M) {
                        try {
                            if (typeof M.composedPath == "function") {
                                var P = M.composedPath();
                                return P[0];
                            }
                            return M.target;
                        } catch  {
                            return M.target;
                        }
                    }
                    var _e = function() {}, H = function(M, P, n) {
                        return n.months[P ? "shorthand" : "longhand"][M];
                    }, Y = {
                        D: _e,
                        F: function(M, P, n) {
                            M.setMonth(n.months.longhand.indexOf(P));
                        },
                        G: function(M, P) {
                            M.setHours((M.getHours() >= 12 ? 12 : 0) + parseFloat(P));
                        },
                        H: function(M, P) {
                            M.setHours(parseFloat(P));
                        },
                        J: function(M, P) {
                            M.setDate(parseFloat(P));
                        },
                        K: function(M, P, n) {
                            M.setHours(M.getHours() % 12 + 12 * s(new RegExp(n.amPM[1], "i").test(P)));
                        },
                        M: function(M, P, n) {
                            M.setMonth(n.months.shorthand.indexOf(P));
                        },
                        S: function(M, P) {
                            M.setSeconds(parseFloat(P));
                        },
                        U: function(M, P) {
                            return new Date(parseFloat(P) * 1e3);
                        },
                        W: function(M, P, n) {
                            var ye = parseInt(P), ke = new Date(M.getFullYear(), 0, 2 + (ye - 1) * 7, 0, 0, 0, 0);
                            return ke.setDate(ke.getDate() - ke.getDay() + n.firstDayOfWeek), ke;
                        },
                        Y: function(M, P) {
                            M.setFullYear(parseFloat(P));
                        },
                        Z: function(M, P) {
                            return new Date(P);
                        },
                        d: function(M, P) {
                            M.setDate(parseFloat(P));
                        },
                        h: function(M, P) {
                            M.setHours((M.getHours() >= 12 ? 12 : 0) + parseFloat(P));
                        },
                        i: function(M, P) {
                            M.setMinutes(parseFloat(P));
                        },
                        j: function(M, P) {
                            M.setDate(parseFloat(P));
                        },
                        l: _e,
                        m: function(M, P) {
                            M.setMonth(parseFloat(P) - 1);
                        },
                        n: function(M, P) {
                            M.setMonth(parseFloat(P) - 1);
                        },
                        s: function(M, P) {
                            M.setSeconds(parseFloat(P));
                        },
                        u: function(M, P) {
                            return new Date(parseFloat(P));
                        },
                        w: _e,
                        y: function(M, P) {
                            M.setFullYear(2e3 + parseFloat(P));
                        }
                    }, z = {
                        D: "",
                        F: "",
                        G: "(\\d\\d|\\d)",
                        H: "(\\d\\d|\\d)",
                        J: "(\\d\\d|\\d)\\w+",
                        K: "",
                        M: "",
                        S: "(\\d\\d|\\d)",
                        U: "(.+)",
                        W: "(\\d\\d|\\d)",
                        Y: "(\\d{4})",
                        Z: "(.+)",
                        d: "(\\d\\d|\\d)",
                        h: "(\\d\\d|\\d)",
                        i: "(\\d\\d|\\d)",
                        j: "(\\d\\d|\\d)",
                        l: "",
                        m: "(\\d\\d|\\d)",
                        n: "(\\d\\d|\\d)",
                        s: "(\\d\\d|\\d)",
                        u: "(.+)",
                        w: "(\\d\\d|\\d)",
                        y: "(\\d{2})"
                    }, V = {
                        Z: function(M) {
                            return M.toISOString();
                        },
                        D: function(M, P, n) {
                            return P.weekdays.shorthand[V.w(M, P, n)];
                        },
                        F: function(M, P, n) {
                            return H(V.n(M, P, n) - 1, !1, P);
                        },
                        G: function(M, P, n) {
                            return a(V.h(M, P, n));
                        },
                        H: function(M) {
                            return a(M.getHours());
                        },
                        J: function(M, P) {
                            return P.ordinal !== void 0 ? M.getDate() + P.ordinal(M.getDate()) : M.getDate();
                        },
                        K: function(M, P) {
                            return P.amPM[s(M.getHours() > 11)];
                        },
                        M: function(M, P) {
                            return H(M.getMonth(), !0, P);
                        },
                        S: function(M) {
                            return a(M.getSeconds());
                        },
                        U: function(M) {
                            return M.getTime() / 1e3;
                        },
                        W: function(M, P, n) {
                            return n.getWeek(M);
                        },
                        Y: function(M) {
                            return a(M.getFullYear(), 4);
                        },
                        d: function(M) {
                            return a(M.getDate());
                        },
                        h: function(M) {
                            return M.getHours() % 12 ? M.getHours() % 12 : 12;
                        },
                        i: function(M) {
                            return a(M.getMinutes());
                        },
                        j: function(M) {
                            return M.getDate();
                        },
                        l: function(M, P) {
                            return P.weekdays.longhand[M.getDay()];
                        },
                        m: function(M) {
                            return a(M.getMonth() + 1);
                        },
                        n: function(M) {
                            return M.getMonth() + 1;
                        },
                        s: function(M) {
                            return M.getSeconds();
                        },
                        u: function(M) {
                            return M.getTime();
                        },
                        w: function(M) {
                            return M.getDay();
                        },
                        y: function(M) {
                            return String(M.getFullYear()).substring(2);
                        }
                    }, fe = function(M) {
                        var P = M.config, n = P === void 0 ? b : P, ye = M.l10n, ke = ye === void 0 ? m : ye, Me = M.isMobile, ht = Me === void 0 ? !1 : Me;
                        return function(oe, be, He) {
                            var Ie = He || ke;
                            return n.formatDate !== void 0 && !ht ? n.formatDate(oe, be, Ie) : be.split("").map(function(pe, Le, Te) {
                                return V[pe] && Te[Le - 1] !== "\\" ? V[pe](oe, Ie, n) : pe !== "\\" ? pe : "";
                            }).join("");
                        };
                    }, xe = function(M) {
                        var P = M.config, n = P === void 0 ? b : P, ye = M.l10n, ke = ye === void 0 ? m : ye;
                        return function(Me, ht, oe, be) {
                            if (!(Me !== 0 && !Me)) {
                                var He = be || ke, Ie, pe = Me;
                                if (Me instanceof Date) Ie = new Date(Me.getTime());
                                else if (typeof Me != "string" && Me.toFixed !== void 0) Ie = new Date(Me);
                                else if (typeof Me == "string") {
                                    var Le = ht || (n || b).dateFormat, Te = String(Me).trim();
                                    if (Te === "today") Ie = /* @__PURE__ */ new Date(), oe = !0;
                                    else if (n && n.parseDate) Ie = n.parseDate(Me, Le);
                                    else if (/Z$/.test(Te) || /GMT$/.test(Te)) Ie = new Date(Me);
                                    else {
                                        for(var It = void 0, je = [], Ot = 0, Kt = 0, yt = ""; Ot < Le.length; Ot++){
                                            var qt = Le[Ot], zt = qt === "\\", On = Le[Ot - 1] === "\\" || zt;
                                            if (z[qt] && !On) {
                                                yt += z[qt];
                                                var ee = new RegExp(yt).exec(Me);
                                                ee && (It = !0) && je[qt !== "Y" ? "push" : "unshift"]({
                                                    fn: Y[qt],
                                                    val: ee[++Kt]
                                                });
                                            } else zt || (yt += ".");
                                        }
                                        Ie = !n || !n.noCalendar ? new Date(/* @__PURE__ */ new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(/* @__PURE__ */ new Date().setHours(0, 0, 0, 0)), je.forEach(function(We) {
                                            var Ye = We.fn, lt = We.val;
                                            return Ie = Ye(Ie, lt, He) || Ie;
                                        }), Ie = It ? Ie : void 0;
                                    }
                                }
                                if (!(Ie instanceof Date && !isNaN(Ie.getTime()))) {
                                    n.errorHandler(new Error("Invalid date provided: " + pe));
                                    return;
                                }
                                return oe === !0 && Ie.setHours(0, 0, 0, 0), Ie;
                            }
                        };
                    };
                    function le(M, P, n) {
                        return n === void 0 && (n = !0), n !== !1 ? new Date(M.getTime()).setHours(0, 0, 0, 0) - new Date(P.getTime()).setHours(0, 0, 0, 0) : M.getTime() - P.getTime();
                    }
                    var Ne = function(M, P, n) {
                        return M > Math.min(P, n) && M < Math.max(P, n);
                    }, ue = function(M, P, n) {
                        return M * 3600 + P * 60 + n;
                    }, K = function(M) {
                        var P = Math.floor(M / 3600), n = (M - P * 3600) / 60;
                        return [
                            P,
                            n,
                            M - P * 3600 - n * 60
                        ];
                    }, Ae = {
                        DAY: 864e5
                    };
                    function we(M) {
                        var P = M.defaultHour, n = M.defaultMinute, ye = M.defaultSeconds;
                        if (M.minDate !== void 0) {
                            var ke = M.minDate.getHours(), Me = M.minDate.getMinutes(), ht = M.minDate.getSeconds();
                            P < ke && (P = ke), P === ke && n < Me && (n = Me), P === ke && n === Me && ye < ht && (ye = M.minDate.getSeconds());
                        }
                        if (M.maxDate !== void 0) {
                            var oe = M.maxDate.getHours(), be = M.maxDate.getMinutes();
                            P = Math.min(P, oe), P === oe && (n = Math.min(be, n)), P === oe && n === be && (ye = M.maxDate.getSeconds());
                        }
                        return {
                            hours: P,
                            minutes: n,
                            seconds: ye
                        };
                    }
                    y("./node_modules/flatpickr/dist/esm/utils/polyfills.js");
                    var me = function() {
                        return me = Object.assign || function(M) {
                            for(var P, n = 1, ye = arguments.length; n < ye; n++){
                                P = arguments[n];
                                for(var ke in P)Object.prototype.hasOwnProperty.call(P, ke) && (M[ke] = P[ke]);
                            }
                            return M;
                        }, me.apply(this, arguments);
                    }, ve = function() {
                        for(var M = 0, P = 0, n = arguments.length; P < n; P++)M += arguments[P].length;
                        for(var ye = Array(M), ke = 0, P = 0; P < n; P++)for(var Me = arguments[P], ht = 0, oe = Me.length; ht < oe; ht++, ke++)ye[ke] = Me[ht];
                        return ye;
                    }, Ce = 300;
                    function qe(M, P) {
                        var n = {
                            config: me(me({}, b), Fe.defaultConfig),
                            l10n: i
                        };
                        n.parseDate = xe({
                            config: n.config,
                            l10n: n.l10n
                        }), n._handlers = [], n.pluginElements = [], n.loadedPlugins = [], n._bind = je, n._setHoursFromDate = Le, n._positionCalendar = er, n.changeMonth = _r, n.changeYear = gn, n.clear = Mi, n.close = Ni, n.onMouseOver = Qn, n._createElement = F, n.createDay = ee, n.destroy = Bi, n.isEnabled = Nn, n.jumpToDate = yt, n.updateValue = C, n.open = Ri, n.redraw = oi, n.set = Fi, n.setDate = qi, n.toggle = Ui;
                        function ye() {
                            n.utils = {
                                getDaysInMonth: function(d, h) {
                                    return d === void 0 && (d = n.currentMonth), h === void 0 && (h = n.currentYear), d === 1 && (h % 4 === 0 && h % 100 !== 0 || h % 400 === 0) ? 29 : n.l10n.daysInMonth[d];
                                }
                            };
                        }
                        function ke() {
                            n.element = n.input = M, n.isOpen = !1, ii(), Br(), ui(), ci(), ye(), n.isMobile || On(), Kt(), (n.selectedDates.length || n.config.noCalendar) && (n.config.enableTime && Le(n.config.noCalendar ? n.latestSelectedDateObj : void 0), C(!1)), oe();
                            var d = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                            !n.isMobile && d && er(), St("onReady");
                        }
                        function Me() {
                            var d;
                            return ((d = n.calendarContainer) === null || d === void 0 ? void 0 : d.getRootNode()).activeElement || document.activeElement;
                        }
                        function ht(d) {
                            return d.bind(n);
                        }
                        function oe() {
                            var d = n.config;
                            d.weekNumbers === !1 && d.showMonths === 1 || d.noCalendar !== !0 && window.requestAnimationFrame(function() {
                                if (n.calendarContainer !== void 0 && (n.calendarContainer.style.visibility = "hidden", n.calendarContainer.style.display = "block"), n.daysContainer !== void 0) {
                                    var h = (n.days.offsetWidth + 1) * d.showMonths;
                                    n.daysContainer.style.width = h + "px", n.calendarContainer.style.width = h + (n.weekWrapper !== void 0 ? n.weekWrapper.offsetWidth : 0) + "px", n.calendarContainer.style.removeProperty("visibility"), n.calendarContainer.style.removeProperty("display");
                                }
                            });
                        }
                        function be(d) {
                            if (n.selectedDates.length === 0) {
                                var h = n.config.minDate === void 0 || le(/* @__PURE__ */ new Date(), n.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(n.config.minDate.getTime()), T = we(n.config);
                                h.setHours(T.hours, T.minutes, T.seconds, h.getMilliseconds()), n.selectedDates = [
                                    h
                                ], n.latestSelectedDateObj = h;
                            }
                            d !== void 0 && d.type !== "blur" && B(d);
                            var R = n._input.value;
                            pe(), C(), n._input.value !== R && n._debouncedChange();
                        }
                        function He(d, h) {
                            return d % 12 + 12 * s(h === n.l10n.amPM[1]);
                        }
                        function Ie(d) {
                            switch(d % 24){
                                case 0:
                                case 12:
                                    return 12;
                                default:
                                    return d % 12;
                            }
                        }
                        function pe() {
                            if (!(n.hourElement === void 0 || n.minuteElement === void 0)) {
                                var d = (parseInt(n.hourElement.value.slice(-2), 10) || 0) % 24, h = (parseInt(n.minuteElement.value, 10) || 0) % 60, T = n.secondElement !== void 0 ? (parseInt(n.secondElement.value, 10) || 0) % 60 : 0;
                                n.amPM !== void 0 && (d = He(d, n.amPM.textContent));
                                var R = n.config.minTime !== void 0 || n.config.minDate && n.minDateHasTime && n.latestSelectedDateObj && le(n.latestSelectedDateObj, n.config.minDate, !0) === 0, U = n.config.maxTime !== void 0 || n.config.maxDate && n.maxDateHasTime && n.latestSelectedDateObj && le(n.latestSelectedDateObj, n.config.maxDate, !0) === 0;
                                if (n.config.maxTime !== void 0 && n.config.minTime !== void 0 && n.config.minTime > n.config.maxTime) {
                                    var j = ue(n.config.minTime.getHours(), n.config.minTime.getMinutes(), n.config.minTime.getSeconds()), ce = ue(n.config.maxTime.getHours(), n.config.maxTime.getMinutes(), n.config.maxTime.getSeconds()), Z = ue(d, h, T);
                                    if (Z > ce && Z < j) {
                                        var Se = K(j);
                                        d = Se[0], h = Se[1], T = Se[2];
                                    }
                                } else {
                                    if (U) {
                                        var de = n.config.maxTime !== void 0 ? n.config.maxTime : n.config.maxDate;
                                        d = Math.min(d, de.getHours()), d === de.getHours() && (h = Math.min(h, de.getMinutes())), h === de.getMinutes() && (T = Math.min(T, de.getSeconds()));
                                    }
                                    if (R) {
                                        var he = n.config.minTime !== void 0 ? n.config.minTime : n.config.minDate;
                                        d = Math.max(d, he.getHours()), d === he.getHours() && h < he.getMinutes() && (h = he.getMinutes()), h === he.getMinutes() && (T = Math.max(T, he.getSeconds()));
                                    }
                                }
                                Te(d, h, T);
                            }
                        }
                        function Le(d) {
                            var h = d || n.latestSelectedDateObj;
                            h && h instanceof Date && Te(h.getHours(), h.getMinutes(), h.getSeconds());
                        }
                        function Te(d, h, T) {
                            n.latestSelectedDateObj !== void 0 && n.latestSelectedDateObj.setHours(d % 24, h, T || 0, 0), !(!n.hourElement || !n.minuteElement || n.isMobile) && (n.hourElement.value = a(n.config.time_24hr ? d : (12 + d) % 12 + 12 * s(d % 12 === 0)), n.minuteElement.value = a(h), n.amPM !== void 0 && (n.amPM.textContent = n.l10n.amPM[s(d >= 12)]), n.secondElement !== void 0 && (n.secondElement.value = a(T)));
                        }
                        function It(d) {
                            var h = Q(d), T = parseInt(h.value) + (d.delta || 0);
                            (T / 1e3 > 1 || d.key === "Enter" && !/[^\d]/.test(T.toString())) && gn(T);
                        }
                        function je(d, h, T, R) {
                            if (h instanceof Array) return h.forEach(function(U) {
                                return je(d, U, T, R);
                            });
                            if (d instanceof Array) return d.forEach(function(U) {
                                return je(U, h, T, R);
                            });
                            d.addEventListener(h, T, R), n._handlers.push({
                                remove: function() {
                                    return d.removeEventListener(h, T, R);
                                }
                            });
                        }
                        function Ot() {
                            St("onChange");
                        }
                        function Kt() {
                            if (n.config.wrap && [
                                "open",
                                "close",
                                "toggle",
                                "clear"
                            ].forEach(function(T) {
                                Array.prototype.forEach.call(n.element.querySelectorAll("[data-" + T + "]"), function(R) {
                                    return je(R, "click", n[T]);
                                });
                            }), n.isMobile) {
                                Wi();
                                return;
                            }
                            var d = c(Mr, 50);
                            if (n._debouncedChange = c(Ot, Ce), n.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && je(n.daysContainer, "mouseover", function(T) {
                                n.config.mode === "range" && Qn(Q(T));
                            }), je(n._input, "keydown", ri), n.calendarContainer !== void 0 && je(n.calendarContainer, "keydown", ri), !n.config.inline && !n.config.static && je(window, "resize", d), window.ontouchstart !== void 0 ? je(window.document, "touchstart", Or) : je(window.document, "mousedown", Or), je(window.document, "focus", Or, {
                                capture: !0
                            }), n.config.clickOpens === !0 && (je(n._input, "focus", n.open), je(n._input, "click", n.open)), n.daysContainer !== void 0 && (je(n.monthNav, "click", D), je(n.monthNav, [
                                "keyup",
                                "increment"
                            ], It), je(n.daysContainer, "click", li)), n.timeContainer !== void 0 && n.minuteElement !== void 0 && n.hourElement !== void 0) {
                                var h = function(T) {
                                    return Q(T).select();
                                };
                                je(n.timeContainer, [
                                    "increment"
                                ], be), je(n.timeContainer, "blur", be, {
                                    capture: !0
                                }), je(n.timeContainer, "click", qt), je([
                                    n.hourElement,
                                    n.minuteElement
                                ], [
                                    "focus",
                                    "click"
                                ], h), n.secondElement !== void 0 && je(n.secondElement, "focus", function() {
                                    return n.secondElement && n.secondElement.select();
                                }), n.amPM !== void 0 && je(n.amPM, "click", function(T) {
                                    be(T);
                                });
                            }
                            n.config.allowInput && je(n._input, "blur", Pi);
                        }
                        function yt(d, h) {
                            var T = d !== void 0 ? n.parseDate(d) : n.latestSelectedDateObj || (n.config.minDate && n.config.minDate > n.now ? n.config.minDate : n.config.maxDate && n.config.maxDate < n.now ? n.config.maxDate : n.now), R = n.currentYear, U = n.currentMonth;
                            try {
                                T !== void 0 && (n.currentYear = T.getFullYear(), n.currentMonth = T.getMonth());
                            } catch (j) {
                                j.message = "Invalid date supplied: " + T, n.config.errorHandler(j);
                            }
                            h && n.currentYear !== R && (St("onYearChange"), cn()), h && (n.currentYear !== R || n.currentMonth !== U) && St("onMonthChange"), n.redraw();
                        }
                        function qt(d) {
                            var h = Q(d);
                            ~h.className.indexOf("arrow") && zt(d, h.classList.contains("arrowUp") ? 1 : -1);
                        }
                        function zt(d, h, T) {
                            var R = d && Q(d), U = T || R && R.parentNode && R.parentNode.firstChild, j = nr("increment");
                            j.delta = h, U && U.dispatchEvent(j);
                        }
                        function On() {
                            var d = window.document.createDocumentFragment();
                            if (n.calendarContainer = F("div", "flatpickr-calendar"), n.calendarContainer.tabIndex = -1, !n.config.noCalendar) {
                                if (d.appendChild(Qr()), n.innerContainer = F("div", "flatpickr-innerContainer"), n.config.weekNumbers) {
                                    var h = Oi(), T = h.weekWrapper, R = h.weekNumbers;
                                    n.innerContainer.appendChild(T), n.weekNumbers = R, n.weekWrapper = T;
                                }
                                n.rContainer = F("div", "flatpickr-rContainer"), n.rContainer.appendChild(ti()), n.daysContainer || (n.daysContainer = F("div", "flatpickr-days"), n.daysContainer.tabIndex = -1), jt(), n.rContainer.appendChild(n.daysContainer), n.innerContainer.appendChild(n.rContainer), d.appendChild(n.innerContainer);
                            }
                            n.config.enableTime && d.appendChild(ei()), A(n.calendarContainer, "rangeMode", n.config.mode === "range"), A(n.calendarContainer, "animate", n.config.animate === !0), A(n.calendarContainer, "multiMonth", n.config.showMonths > 1), n.calendarContainer.appendChild(d);
                            var U = n.config.appendTo !== void 0 && n.config.appendTo.nodeType !== void 0;
                            if ((n.config.inline || n.config.static) && (n.calendarContainer.classList.add(n.config.inline ? "inline" : "static"), n.config.inline && (!U && n.element.parentNode ? n.element.parentNode.insertBefore(n.calendarContainer, n._input.nextSibling) : n.config.appendTo !== void 0 && n.config.appendTo.appendChild(n.calendarContainer)), n.config.static)) {
                                var j = F("div", "flatpickr-wrapper");
                                n.element.parentNode && n.element.parentNode.insertBefore(j, n.element), j.appendChild(n.element), n.altInput && j.appendChild(n.altInput), j.appendChild(n.calendarContainer);
                            }
                            !n.config.static && !n.config.inline && (n.config.appendTo !== void 0 ? n.config.appendTo : window.document.body).appendChild(n.calendarContainer);
                        }
                        function ee(d, h, T, R) {
                            var U = Nn(h, !0), j = F("span", d, h.getDate().toString());
                            return j.dateObj = h, j.$i = R, j.setAttribute("aria-label", n.formatDate(h, n.config.ariaDateFormat)), d.indexOf("hidden") === -1 && le(h, n.now) === 0 && (n.todayDateElem = j, j.classList.add("today"), j.setAttribute("aria-current", "date")), U ? (j.tabIndex = -1, yr(h) && (j.classList.add("selected"), n.selectedDateElem = j, n.config.mode === "range" && (A(j, "startRange", n.selectedDates[0] && le(h, n.selectedDates[0], !0) === 0), A(j, "endRange", n.selectedDates[1] && le(h, n.selectedDates[1], !0) === 0), d === "nextMonthDay" && j.classList.add("inRange")))) : j.classList.add("flatpickr-disabled"), n.config.mode === "range" && Hi(h) && !yr(h) && j.classList.add("inRange"), n.weekNumbers && n.config.showMonths === 1 && d !== "prevMonthDay" && R % 7 === 6 && n.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + n.config.getWeek(h) + "</span>"), St("onDayCreate", j), j;
                        }
                        function We(d) {
                            d.focus(), n.config.mode === "range" && Qn(d);
                        }
                        function Ye(d) {
                            for(var h = d > 0 ? 0 : n.config.showMonths - 1, T = d > 0 ? n.config.showMonths : -1, R = h; R != T; R += d)for(var U = n.daysContainer.children[R], j = d > 0 ? 0 : U.children.length - 1, ce = d > 0 ? U.children.length : -1, Z = j; Z != ce; Z += d){
                                var Se = U.children[Z];
                                if (Se.className.indexOf("hidden") === -1 && Nn(Se.dateObj)) return Se;
                            }
                        }
                        function lt(d, h) {
                            for(var T = d.className.indexOf("Month") === -1 ? d.dateObj.getMonth() : n.currentMonth, R = h > 0 ? n.config.showMonths : -1, U = h > 0 ? 1 : -1, j = T - n.currentMonth; j != R; j += U)for(var ce = n.daysContainer.children[j], Z = T - n.currentMonth === j ? d.$i + h : h < 0 ? ce.children.length - 1 : 0, Se = ce.children.length, de = Z; de >= 0 && de < Se && de != (h > 0 ? Se : -1); de += U){
                                var he = ce.children[de];
                                if (he.className.indexOf("hidden") === -1 && Nn(he.dateObj) && Math.abs(d.$i - de) >= Math.abs(h)) return We(he);
                            }
                            n.changeMonth(U), wt(Ye(U), 0);
                        }
                        function wt(d, h) {
                            var T = Me(), R = Jn(T || document.body), U = d !== void 0 ? d : R ? T : n.selectedDateElem !== void 0 && Jn(n.selectedDateElem) ? n.selectedDateElem : n.todayDateElem !== void 0 && Jn(n.todayDateElem) ? n.todayDateElem : Ye(h > 0 ? 1 : -1);
                            U === void 0 ? n._input.focus() : R ? lt(U, h) : We(U);
                        }
                        function Mt(d, h) {
                            for(var T = (new Date(d, h, 1).getDay() - n.l10n.firstDayOfWeek + 7) % 7, R = n.utils.getDaysInMonth((h - 1 + 12) % 12, d), U = n.utils.getDaysInMonth(h, d), j = window.document.createDocumentFragment(), ce = n.config.showMonths > 1, Z = ce ? "prevMonthDay hidden" : "prevMonthDay", Se = ce ? "nextMonthDay hidden" : "nextMonthDay", de = R + 1 - T, he = 0; de <= R; de++, he++)j.appendChild(ee("flatpickr-day " + Z, new Date(d, h - 1, de), de, he));
                            for(de = 1; de <= U; de++, he++)j.appendChild(ee("flatpickr-day", new Date(d, h, de), de, he));
                            for(var Ue = U + 1; Ue <= 42 - T && (n.config.showMonths === 1 || he % 7 !== 0); Ue++, he++)j.appendChild(ee("flatpickr-day " + Se, new Date(d, h + 1, Ue % U), Ue, he));
                            var ze = F("div", "dayContainer");
                            return ze.appendChild(j), ze;
                        }
                        function jt() {
                            if (n.daysContainer !== void 0) {
                                $(n.daysContainer), n.weekNumbers && $(n.weekNumbers);
                                for(var d = document.createDocumentFragment(), h = 0; h < n.config.showMonths; h++){
                                    var T = new Date(n.currentYear, n.currentMonth, 1);
                                    T.setMonth(n.currentMonth + h), d.appendChild(Mt(T.getFullYear(), T.getMonth()));
                                }
                                n.daysContainer.appendChild(d), n.days = n.daysContainer.firstChild, n.config.mode === "range" && n.selectedDates.length === 1 && Qn();
                            }
                        }
                        function cn() {
                            if (!(n.config.showMonths > 1 || n.config.monthSelectorType !== "dropdown")) {
                                var d = function(R) {
                                    return n.config.minDate !== void 0 && n.currentYear === n.config.minDate.getFullYear() && R < n.config.minDate.getMonth() ? !1 : !(n.config.maxDate !== void 0 && n.currentYear === n.config.maxDate.getFullYear() && R > n.config.maxDate.getMonth());
                                };
                                n.monthsDropdownContainer.tabIndex = -1, n.monthsDropdownContainer.innerHTML = "";
                                for(var h = 0; h < 12; h++)if (d(h)) {
                                    var T = F("option", "flatpickr-monthDropdown-month");
                                    T.value = new Date(n.currentYear, h).getMonth().toString(), T.textContent = H(h, n.config.shorthandCurrentMonth, n.l10n), T.tabIndex = -1, n.currentMonth === h && (T.selected = !0), n.monthsDropdownContainer.appendChild(T);
                                }
                            }
                        }
                        function Ii() {
                            var d = F("div", "flatpickr-month"), h = window.document.createDocumentFragment(), T;
                            n.config.showMonths > 1 || n.config.monthSelectorType === "static" ? T = F("span", "cur-month") : (n.monthsDropdownContainer = F("select", "flatpickr-monthDropdown-months"), n.monthsDropdownContainer.setAttribute("aria-label", n.l10n.monthAriaLabel), je(n.monthsDropdownContainer, "change", function(ce) {
                                var Z = Q(ce), Se = parseInt(Z.value, 10);
                                n.changeMonth(Se - n.currentMonth), St("onMonthChange");
                            }), cn(), T = n.monthsDropdownContainer);
                            var R = se("cur-year", {
                                tabindex: "-1"
                            }), U = R.getElementsByTagName("input")[0];
                            U.setAttribute("aria-label", n.l10n.yearAriaLabel), n.config.minDate && U.setAttribute("min", n.config.minDate.getFullYear().toString()), n.config.maxDate && (U.setAttribute("max", n.config.maxDate.getFullYear().toString()), U.disabled = !!n.config.minDate && n.config.minDate.getFullYear() === n.config.maxDate.getFullYear());
                            var j = F("div", "flatpickr-current-month");
                            return j.appendChild(T), j.appendChild(R), h.appendChild(j), d.appendChild(h), {
                                container: d,
                                yearElement: U,
                                monthElement: T
                            };
                        }
                        function Ir() {
                            $(n.monthNav), n.monthNav.appendChild(n.prevMonthNav), n.config.showMonths && (n.yearElements = [], n.monthElements = []);
                            for(var d = n.config.showMonths; d--;){
                                var h = Ii();
                                n.yearElements.push(h.yearElement), n.monthElements.push(h.monthElement), n.monthNav.appendChild(h.container);
                            }
                            n.monthNav.appendChild(n.nextMonthNav);
                        }
                        function Qr() {
                            return n.monthNav = F("div", "flatpickr-months"), n.yearElements = [], n.monthElements = [], n.prevMonthNav = F("span", "flatpickr-prev-month"), n.prevMonthNav.innerHTML = n.config.prevArrow, n.nextMonthNav = F("span", "flatpickr-next-month"), n.nextMonthNav.innerHTML = n.config.nextArrow, Ir(), Object.defineProperty(n, "_hidePrevMonthArrow", {
                                get: function() {
                                    return n.__hidePrevMonthArrow;
                                },
                                set: function(d) {
                                    n.__hidePrevMonthArrow !== d && (A(n.prevMonthNav, "flatpickr-disabled", d), n.__hidePrevMonthArrow = d);
                                }
                            }), Object.defineProperty(n, "_hideNextMonthArrow", {
                                get: function() {
                                    return n.__hideNextMonthArrow;
                                },
                                set: function(d) {
                                    n.__hideNextMonthArrow !== d && (A(n.nextMonthNav, "flatpickr-disabled", d), n.__hideNextMonthArrow = d);
                                }
                            }), n.currentYearElement = n.yearElements[0], Vn(), n.monthNav;
                        }
                        function ei() {
                            n.calendarContainer.classList.add("hasTime"), n.config.noCalendar && n.calendarContainer.classList.add("noCalendar");
                            var d = we(n.config);
                            n.timeContainer = F("div", "flatpickr-time"), n.timeContainer.tabIndex = -1;
                            var h = F("span", "flatpickr-time-separator", ":"), T = se("flatpickr-hour", {
                                "aria-label": n.l10n.hourAriaLabel
                            });
                            n.hourElement = T.getElementsByTagName("input")[0];
                            var R = se("flatpickr-minute", {
                                "aria-label": n.l10n.minuteAriaLabel
                            });
                            if (n.minuteElement = R.getElementsByTagName("input")[0], n.hourElement.tabIndex = n.minuteElement.tabIndex = -1, n.hourElement.value = a(n.latestSelectedDateObj ? n.latestSelectedDateObj.getHours() : n.config.time_24hr ? d.hours : Ie(d.hours)), n.minuteElement.value = a(n.latestSelectedDateObj ? n.latestSelectedDateObj.getMinutes() : d.minutes), n.hourElement.setAttribute("step", n.config.hourIncrement.toString()), n.minuteElement.setAttribute("step", n.config.minuteIncrement.toString()), n.hourElement.setAttribute("min", n.config.time_24hr ? "0" : "1"), n.hourElement.setAttribute("max", n.config.time_24hr ? "23" : "12"), n.hourElement.setAttribute("maxlength", "2"), n.minuteElement.setAttribute("min", "0"), n.minuteElement.setAttribute("max", "59"), n.minuteElement.setAttribute("maxlength", "2"), n.timeContainer.appendChild(T), n.timeContainer.appendChild(h), n.timeContainer.appendChild(R), n.config.time_24hr && n.timeContainer.classList.add("time24hr"), n.config.enableSeconds) {
                                n.timeContainer.classList.add("hasSeconds");
                                var U = se("flatpickr-second");
                                n.secondElement = U.getElementsByTagName("input")[0], n.secondElement.value = a(n.latestSelectedDateObj ? n.latestSelectedDateObj.getSeconds() : d.seconds), n.secondElement.setAttribute("step", n.minuteElement.getAttribute("step")), n.secondElement.setAttribute("min", "0"), n.secondElement.setAttribute("max", "59"), n.secondElement.setAttribute("maxlength", "2"), n.timeContainer.appendChild(F("span", "flatpickr-time-separator", ":")), n.timeContainer.appendChild(U);
                            }
                            return n.config.time_24hr || (n.amPM = F("span", "flatpickr-am-pm", n.l10n.amPM[s((n.latestSelectedDateObj ? n.hourElement.value : n.config.defaultHour) > 11)]), n.amPM.title = n.l10n.toggleTitle, n.amPM.tabIndex = -1, n.timeContainer.appendChild(n.amPM)), n.timeContainer;
                        }
                        function ti() {
                            n.weekdayContainer ? $(n.weekdayContainer) : n.weekdayContainer = F("div", "flatpickr-weekdays");
                            for(var d = n.config.showMonths; d--;){
                                var h = F("div", "flatpickr-weekdaycontainer");
                                n.weekdayContainer.appendChild(h);
                            }
                            return ni(), n.weekdayContainer;
                        }
                        function ni() {
                            if (n.weekdayContainer) {
                                var d = n.l10n.firstDayOfWeek, h = ve(n.l10n.weekdays.shorthand);
                                d > 0 && d < h.length && (h = ve(h.splice(d, h.length), h.splice(0, d)));
                                for(var T = n.config.showMonths; T--;)n.weekdayContainer.children[T].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + h.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
                            }
                        }
                        function Oi() {
                            n.calendarContainer.classList.add("hasWeeks");
                            var d = F("div", "flatpickr-weekwrapper");
                            d.appendChild(F("span", "flatpickr-weekday", n.l10n.weekAbbreviation));
                            var h = F("div", "flatpickr-weeks");
                            return d.appendChild(h), {
                                weekWrapper: d,
                                weekNumbers: h
                            };
                        }
                        function _r(d, h) {
                            h === void 0 && (h = !0);
                            var T = h ? d : d - n.currentMonth;
                            T < 0 && n._hidePrevMonthArrow === !0 || T > 0 && n._hideNextMonthArrow === !0 || (n.currentMonth += T, (n.currentMonth < 0 || n.currentMonth > 11) && (n.currentYear += n.currentMonth > 11 ? 1 : -1, n.currentMonth = (n.currentMonth + 12) % 12, St("onYearChange"), cn()), jt(), St("onMonthChange"), Vn());
                        }
                        function Mi(d, h) {
                            if (d === void 0 && (d = !0), h === void 0 && (h = !0), n.input.value = "", n.altInput !== void 0 && (n.altInput.value = ""), n.mobileInput !== void 0 && (n.mobileInput.value = ""), n.selectedDates = [], n.latestSelectedDateObj = void 0, h === !0 && (n.currentYear = n._initialDate.getFullYear(), n.currentMonth = n._initialDate.getMonth()), n.config.enableTime === !0) {
                                var T = we(n.config), R = T.hours, U = T.minutes, j = T.seconds;
                                Te(R, U, j);
                            }
                            n.redraw(), d && St("onChange");
                        }
                        function Ni() {
                            n.isOpen = !1, n.isMobile || (n.calendarContainer !== void 0 && n.calendarContainer.classList.remove("open"), n._input !== void 0 && n._input.classList.remove("active")), St("onClose");
                        }
                        function Bi() {
                            n.config !== void 0 && St("onDestroy");
                            for(var d = n._handlers.length; d--;)n._handlers[d].remove();
                            if (n._handlers = [], n.mobileInput) n.mobileInput.parentNode && n.mobileInput.parentNode.removeChild(n.mobileInput), n.mobileInput = void 0;
                            else if (n.calendarContainer && n.calendarContainer.parentNode) {
                                if (n.config.static && n.calendarContainer.parentNode) {
                                    var h = n.calendarContainer.parentNode;
                                    if (h.lastChild && h.removeChild(h.lastChild), h.parentNode) {
                                        for(; h.firstChild;)h.parentNode.insertBefore(h.firstChild, h);
                                        h.parentNode.removeChild(h);
                                    }
                                } else n.calendarContainer.parentNode.removeChild(n.calendarContainer);
                            }
                            n.altInput && (n.input.type = "text", n.altInput.parentNode && n.altInput.parentNode.removeChild(n.altInput), delete n.altInput), n.input && (n.input.type = n.input._type, n.input.classList.remove("flatpickr-input"), n.input.removeAttribute("readonly")), [
                                "_showTimeInput",
                                "latestSelectedDateObj",
                                "_hideNextMonthArrow",
                                "_hidePrevMonthArrow",
                                "__hideNextMonthArrow",
                                "__hidePrevMonthArrow",
                                "isMobile",
                                "isOpen",
                                "selectedDateElem",
                                "minDateHasTime",
                                "maxDateHasTime",
                                "days",
                                "daysContainer",
                                "_input",
                                "_positionElement",
                                "innerContainer",
                                "rContainer",
                                "monthNav",
                                "todayDateElem",
                                "calendarContainer",
                                "weekdayContainer",
                                "prevMonthNav",
                                "nextMonthNav",
                                "monthsDropdownContainer",
                                "currentMonthElement",
                                "currentYearElement",
                                "navigationCurrentMonth",
                                "selectedDateElem",
                                "config"
                            ].forEach(function(T) {
                                try {
                                    delete n[T];
                                } catch  {}
                            });
                        }
                        function Mn(d) {
                            return n.calendarContainer.contains(d);
                        }
                        function Or(d) {
                            if (n.isOpen && !n.config.inline) {
                                var h = Q(d), T = Mn(h), R = h === n.input || h === n.altInput || n.element.contains(h) || d.path && d.path.indexOf && (~d.path.indexOf(n.input) || ~d.path.indexOf(n.altInput)), U = !R && !T && !Mn(d.relatedTarget), j = !n.config.ignoredFocusElements.some(function(ce) {
                                    return ce.contains(h);
                                });
                                U && j && (n.config.allowInput && n.setDate(n._input.value, !1, n.config.altInput ? n.config.altFormat : n.config.dateFormat), n.timeContainer !== void 0 && n.minuteElement !== void 0 && n.hourElement !== void 0 && n.input.value !== "" && n.input.value !== void 0 && be(), n.close(), n.config && n.config.mode === "range" && n.selectedDates.length === 1 && n.clear(!1));
                            }
                        }
                        function gn(d) {
                            if (!(!d || n.config.minDate && d < n.config.minDate.getFullYear() || n.config.maxDate && d > n.config.maxDate.getFullYear())) {
                                var h = d, T = n.currentYear !== h;
                                n.currentYear = h || n.currentYear, n.config.maxDate && n.currentYear === n.config.maxDate.getFullYear() ? n.currentMonth = Math.min(n.config.maxDate.getMonth(), n.currentMonth) : n.config.minDate && n.currentYear === n.config.minDate.getFullYear() && (n.currentMonth = Math.max(n.config.minDate.getMonth(), n.currentMonth)), T && (n.redraw(), St("onYearChange"), cn());
                            }
                        }
                        function Nn(d, h) {
                            var T;
                            h === void 0 && (h = !0);
                            var R = n.parseDate(d, void 0, h);
                            if (n.config.minDate && R && le(R, n.config.minDate, h !== void 0 ? h : !n.minDateHasTime) < 0 || n.config.maxDate && R && le(R, n.config.maxDate, h !== void 0 ? h : !n.maxDateHasTime) > 0) return !1;
                            if (!n.config.enable && n.config.disable.length === 0) return !0;
                            if (R === void 0) return !1;
                            for(var U = !!n.config.enable, j = (T = n.config.enable) !== null && T !== void 0 ? T : n.config.disable, ce = 0, Z = void 0; ce < j.length; ce++){
                                if (Z = j[ce], typeof Z == "function" && Z(R)) return U;
                                if (Z instanceof Date && R !== void 0 && Z.getTime() === R.getTime()) return U;
                                if (typeof Z == "string") {
                                    var Se = n.parseDate(Z, void 0, !0);
                                    return Se && Se.getTime() === R.getTime() ? U : !U;
                                } else if (typeof Z == "object" && R !== void 0 && Z.from && Z.to && R.getTime() >= Z.from.getTime() && R.getTime() <= Z.to.getTime()) return U;
                            }
                            return !U;
                        }
                        function Jn(d) {
                            return n.daysContainer !== void 0 ? d.className.indexOf("hidden") === -1 && d.className.indexOf("flatpickr-disabled") === -1 && n.daysContainer.contains(d) : !1;
                        }
                        function Pi(d) {
                            var h = d.target === n._input, T = n._input.value.trimEnd() !== Rr();
                            h && T && !(d.relatedTarget && Mn(d.relatedTarget)) && n.setDate(n._input.value, !0, d.target === n.altInput ? n.config.altFormat : n.config.dateFormat);
                        }
                        function ri(d) {
                            var h = Q(d), T = n.config.wrap ? M.contains(h) : h === n._input, R = n.config.allowInput, U = n.isOpen && (!R || !T), j = n.config.inline && T && !R;
                            if (d.keyCode === 13 && T) {
                                if (R) return n.setDate(n._input.value, !0, h === n.altInput ? n.config.altFormat : n.config.dateFormat), n.close(), h.blur();
                                n.open();
                            } else if (Mn(h) || U || j) {
                                var ce = !!n.timeContainer && n.timeContainer.contains(h);
                                switch(d.keyCode){
                                    case 13:
                                        ce ? (d.preventDefault(), be(), Kn()) : li(d);
                                        break;
                                    case 27:
                                        d.preventDefault(), Kn();
                                        break;
                                    case 8:
                                    case 46:
                                        T && !n.config.allowInput && (d.preventDefault(), n.clear());
                                        break;
                                    case 37:
                                    case 39:
                                        if (!ce && !T) {
                                            d.preventDefault();
                                            var Z = Me();
                                            if (n.daysContainer !== void 0 && (R === !1 || Z && Jn(Z))) {
                                                var Se = d.keyCode === 39 ? 1 : -1;
                                                d.ctrlKey ? (d.stopPropagation(), _r(Se), wt(Ye(1), 0)) : wt(void 0, Se);
                                            }
                                        } else n.hourElement && n.hourElement.focus();
                                        break;
                                    case 38:
                                    case 40:
                                        d.preventDefault();
                                        var de = d.keyCode === 40 ? 1 : -1;
                                        n.daysContainer && h.$i !== void 0 || h === n.input || h === n.altInput ? d.ctrlKey ? (d.stopPropagation(), gn(n.currentYear - de), wt(Ye(1), 0)) : ce || wt(void 0, de * 7) : h === n.currentYearElement ? gn(n.currentYear - de) : n.config.enableTime && (!ce && n.hourElement && n.hourElement.focus(), be(d), n._debouncedChange());
                                        break;
                                    case 9:
                                        if (ce) {
                                            var he = [
                                                n.hourElement,
                                                n.minuteElement,
                                                n.secondElement,
                                                n.amPM
                                            ].concat(n.pluginElements).filter(function(Ve) {
                                                return Ve;
                                            }), Ue = he.indexOf(h);
                                            if (Ue !== -1) {
                                                var ze = he[Ue + (d.shiftKey ? -1 : 1)];
                                                d.preventDefault(), (ze || n._input).focus();
                                            }
                                        } else !n.config.noCalendar && n.daysContainer && n.daysContainer.contains(h) && d.shiftKey && (d.preventDefault(), n._input.focus());
                                        break;
                                }
                            }
                            if (n.amPM !== void 0 && h === n.amPM) switch(d.key){
                                case n.l10n.amPM[0].charAt(0):
                                case n.l10n.amPM[0].charAt(0).toLowerCase():
                                    n.amPM.textContent = n.l10n.amPM[0], pe(), C();
                                    break;
                                case n.l10n.amPM[1].charAt(0):
                                case n.l10n.amPM[1].charAt(0).toLowerCase():
                                    n.amPM.textContent = n.l10n.amPM[1], pe(), C();
                                    break;
                            }
                            (T || Mn(h)) && St("onKeyDown", d);
                        }
                        function Qn(d, h) {
                            if (h === void 0 && (h = "flatpickr-day"), !(n.selectedDates.length !== 1 || d && (!d.classList.contains(h) || d.classList.contains("flatpickr-disabled")))) {
                                for(var T = d ? d.dateObj.getTime() : n.days.firstElementChild.dateObj.getTime(), R = n.parseDate(n.selectedDates[0], void 0, !0).getTime(), U = Math.min(T, n.selectedDates[0].getTime()), j = Math.max(T, n.selectedDates[0].getTime()), ce = !1, Z = 0, Se = 0, de = U; de < j; de += Ae.DAY)Nn(new Date(de), !0) || (ce = ce || de > U && de < j, de < R && (!Z || de > Z) ? Z = de : de > R && (!Se || de < Se) && (Se = de));
                                var he = Array.from(n.rContainer.querySelectorAll("*:nth-child(-n+" + n.config.showMonths + ") > ." + h));
                                he.forEach(function(Ue) {
                                    var ze = Ue.dateObj, Ve = ze.getTime(), ct = Z > 0 && Ve < Z || Se > 0 && Ve > Se;
                                    if (ct) {
                                        Ue.classList.add("notAllowed"), [
                                            "inRange",
                                            "startRange",
                                            "endRange"
                                        ].forEach(function(pt) {
                                            Ue.classList.remove(pt);
                                        });
                                        return;
                                    } else if (ce && !ct) return;
                                    [
                                        "startRange",
                                        "inRange",
                                        "endRange",
                                        "notAllowed"
                                    ].forEach(function(pt) {
                                        Ue.classList.remove(pt);
                                    }), d !== void 0 && (d.classList.add(T <= n.selectedDates[0].getTime() ? "startRange" : "endRange"), R < T && Ve === R ? Ue.classList.add("startRange") : R > T && Ve === R && Ue.classList.add("endRange"), Ve >= Z && (Se === 0 || Ve <= Se) && Ne(Ve, R, T) && Ue.classList.add("inRange"));
                                });
                            }
                        }
                        function Mr() {
                            n.isOpen && !n.config.static && !n.config.inline && er();
                        }
                        function Ri(d, h) {
                            if (h === void 0 && (h = n._positionElement), n.isMobile === !0) {
                                if (d) {
                                    d.preventDefault();
                                    var T = Q(d);
                                    T && T.blur();
                                }
                                n.mobileInput !== void 0 && (n.mobileInput.focus(), n.mobileInput.click()), St("onOpen");
                                return;
                            } else if (n._input.disabled || n.config.inline) return;
                            var R = n.isOpen;
                            n.isOpen = !0, R || (n.calendarContainer.classList.add("open"), n._input.classList.add("active"), St("onOpen"), er(h)), n.config.enableTime === !0 && n.config.noCalendar === !0 && n.config.allowInput === !1 && (d === void 0 || !n.timeContainer.contains(d.relatedTarget)) && setTimeout(function() {
                                return n.hourElement.select();
                            }, 50);
                        }
                        function Nr(d) {
                            return function(h) {
                                var T = n.config["_" + d + "Date"] = n.parseDate(h, n.config.dateFormat), R = n.config["_" + (d === "min" ? "max" : "min") + "Date"];
                                T !== void 0 && (n[d === "min" ? "minDateHasTime" : "maxDateHasTime"] = T.getHours() > 0 || T.getMinutes() > 0 || T.getSeconds() > 0), n.selectedDates && (n.selectedDates = n.selectedDates.filter(function(U) {
                                    return Nn(U);
                                }), !n.selectedDates.length && d === "min" && Le(T), C()), n.daysContainer && (oi(), T !== void 0 ? n.currentYearElement[d] = T.getFullYear().toString() : n.currentYearElement.removeAttribute(d), n.currentYearElement.disabled = !!R && T !== void 0 && R.getFullYear() === T.getFullYear());
                            };
                        }
                        function ii() {
                            var d = [
                                "wrap",
                                "weekNumbers",
                                "allowInput",
                                "allowInvalidPreload",
                                "clickOpens",
                                "time_24hr",
                                "enableTime",
                                "noCalendar",
                                "altInput",
                                "shorthandCurrentMonth",
                                "inline",
                                "static",
                                "enableSeconds",
                                "disableMobile"
                            ], h = me(me({}, JSON.parse(JSON.stringify(M.dataset || {}))), P), T = {};
                            n.config.parseDate = h.parseDate, n.config.formatDate = h.formatDate, Object.defineProperty(n.config, "enable", {
                                get: function() {
                                    return n.config._enable;
                                },
                                set: function(he) {
                                    n.config._enable = Pr(he);
                                }
                            }), Object.defineProperty(n.config, "disable", {
                                get: function() {
                                    return n.config._disable;
                                },
                                set: function(he) {
                                    n.config._disable = Pr(he);
                                }
                            });
                            var R = h.mode === "time";
                            if (!h.dateFormat && (h.enableTime || R)) {
                                var U = Fe.defaultConfig.dateFormat || b.dateFormat;
                                T.dateFormat = h.noCalendar || R ? "H:i" + (h.enableSeconds ? ":S" : "") : U + " H:i" + (h.enableSeconds ? ":S" : "");
                            }
                            if (h.altInput && (h.enableTime || R) && !h.altFormat) {
                                var j = Fe.defaultConfig.altFormat || b.altFormat;
                                T.altFormat = h.noCalendar || R ? "h:i" + (h.enableSeconds ? ":S K" : " K") : j + (" h:i" + (h.enableSeconds ? ":S" : "") + " K");
                            }
                            Object.defineProperty(n.config, "minDate", {
                                get: function() {
                                    return n.config._minDate;
                                },
                                set: Nr("min")
                            }), Object.defineProperty(n.config, "maxDate", {
                                get: function() {
                                    return n.config._maxDate;
                                },
                                set: Nr("max")
                            });
                            var ce = function(he) {
                                return function(Ue) {
                                    n.config[he === "min" ? "_minTime" : "_maxTime"] = n.parseDate(Ue, "H:i:S");
                                };
                            };
                            Object.defineProperty(n.config, "minTime", {
                                get: function() {
                                    return n.config._minTime;
                                },
                                set: ce("min")
                            }), Object.defineProperty(n.config, "maxTime", {
                                get: function() {
                                    return n.config._maxTime;
                                },
                                set: ce("max")
                            }), h.mode === "time" && (n.config.noCalendar = !0, n.config.enableTime = !0), Object.assign(n.config, T, h);
                            for(var Z = 0; Z < d.length; Z++)n.config[d[Z]] = n.config[d[Z]] === !0 || n.config[d[Z]] === "true";
                            k.filter(function(he) {
                                return n.config[he] !== void 0;
                            }).forEach(function(he) {
                                n.config[he] = g(n.config[he] || []).map(ht);
                            }), n.isMobile = !n.config.disableMobile && !n.config.inline && n.config.mode === "single" && !n.config.disable.length && !n.config.enable && !n.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                            for(var Z = 0; Z < n.config.plugins.length; Z++){
                                var Se = n.config.plugins[Z](n) || {};
                                for(var de in Se)k.indexOf(de) > -1 ? n.config[de] = g(Se[de]).map(ht).concat(n.config[de]) : typeof h[de] > "u" && (n.config[de] = Se[de]);
                            }
                            h.altInputClass || (n.config.altInputClass = ai().className + " " + n.config.altInputClass), St("onParseConfig");
                        }
                        function ai() {
                            return n.config.wrap ? M.querySelector("[data-input]") : M;
                        }
                        function Br() {
                            typeof n.config.locale != "object" && typeof Fe.l10ns[n.config.locale] > "u" && n.config.errorHandler(new Error("flatpickr: invalid locale " + n.config.locale)), n.l10n = me(me({}, Fe.l10ns.default), typeof n.config.locale == "object" ? n.config.locale : n.config.locale !== "default" ? Fe.l10ns[n.config.locale] : void 0), z.D = "(" + n.l10n.weekdays.shorthand.join("|") + ")", z.l = "(" + n.l10n.weekdays.longhand.join("|") + ")", z.M = "(" + n.l10n.months.shorthand.join("|") + ")", z.F = "(" + n.l10n.months.longhand.join("|") + ")", z.K = "(" + n.l10n.amPM[0] + "|" + n.l10n.amPM[1] + "|" + n.l10n.amPM[0].toLowerCase() + "|" + n.l10n.amPM[1].toLowerCase() + ")";
                            var d = me(me({}, P), JSON.parse(JSON.stringify(M.dataset || {})));
                            d.time_24hr === void 0 && Fe.defaultConfig.time_24hr === void 0 && (n.config.time_24hr = n.l10n.time_24hr), n.formatDate = fe(n), n.parseDate = xe({
                                config: n.config,
                                l10n: n.l10n
                            });
                        }
                        function er(d) {
                            if (typeof n.config.position == "function") return void n.config.position(n, d);
                            if (n.calendarContainer !== void 0) {
                                St("onPreCalendarPosition");
                                var h = d || n._positionElement, T = Array.prototype.reduce.call(n.calendarContainer.children, function(Bt, nn) {
                                    return Bt + nn.offsetHeight;
                                }, 0), R = n.calendarContainer.offsetWidth, U = n.config.position.split(" "), j = U[0], ce = U.length > 1 ? U[1] : null, Z = h.getBoundingClientRect(), Se = window.innerHeight - Z.bottom, de = j === "above" || j !== "below" && Se < T && Z.top > T, he = window.pageYOffset + Z.top + (de ? -T - 2 : h.offsetHeight + 2);
                                if (A(n.calendarContainer, "arrowTop", !de), A(n.calendarContainer, "arrowBottom", de), !n.config.inline) {
                                    var Ue = window.pageXOffset + Z.left, ze = !1, Ve = !1;
                                    ce === "center" ? (Ue -= (R - Z.width) / 2, ze = !0) : ce === "right" && (Ue -= R - Z.width, Ve = !0), A(n.calendarContainer, "arrowLeft", !ze && !Ve), A(n.calendarContainer, "arrowCenter", ze), A(n.calendarContainer, "arrowRight", Ve);
                                    var ct = window.document.body.offsetWidth - (window.pageXOffset + Z.right), pt = Ue + R > window.document.body.offsetWidth, Lt = ct + R > window.document.body.offsetWidth;
                                    if (A(n.calendarContainer, "rightMost", pt), !n.config.static) {
                                        if (n.calendarContainer.style.top = he + "px", !pt) n.calendarContainer.style.left = Ue + "px", n.calendarContainer.style.right = "auto";
                                        else if (!Lt) n.calendarContainer.style.left = "auto", n.calendarContainer.style.right = ct + "px";
                                        else {
                                            var Je = si();
                                            if (Je === void 0) return;
                                            var ft = window.document.body.offsetWidth, dt = Math.max(0, ft / 2 - R / 2), kt = ".flatpickr-calendar.centerMost:before", Wt = ".flatpickr-calendar.centerMost:after", Nt = Je.cssRules.length, Dt = "{left:" + Z.left + "px;right:auto;}";
                                            A(n.calendarContainer, "rightMost", !1), A(n.calendarContainer, "centerMost", !0), Je.insertRule(kt + "," + Wt + Dt, Nt), n.calendarContainer.style.left = dt + "px", n.calendarContainer.style.right = "auto";
                                        }
                                    }
                                }
                            }
                        }
                        function si() {
                            for(var d = null, h = 0; h < document.styleSheets.length; h++){
                                var T = document.styleSheets[h];
                                if (T.cssRules) {
                                    try {
                                        T.cssRules;
                                    } catch  {
                                        continue;
                                    }
                                    d = T;
                                    break;
                                }
                            }
                            return d ?? tr();
                        }
                        function tr() {
                            var d = document.createElement("style");
                            return document.head.appendChild(d), d.sheet;
                        }
                        function oi() {
                            n.config.noCalendar || n.isMobile || (cn(), Vn(), jt());
                        }
                        function Kn() {
                            n._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(n.close, 0) : n.close();
                        }
                        function li(d) {
                            d.preventDefault(), d.stopPropagation();
                            var h = function(he) {
                                return he.classList && he.classList.contains("flatpickr-day") && !he.classList.contains("flatpickr-disabled") && !he.classList.contains("notAllowed");
                            }, T = J(Q(d), h);
                            if (T !== void 0) {
                                var R = T, U = n.latestSelectedDateObj = new Date(R.dateObj.getTime()), j = (U.getMonth() < n.currentMonth || U.getMonth() > n.currentMonth + n.config.showMonths - 1) && n.config.mode !== "range";
                                if (n.selectedDateElem = R, n.config.mode === "single") n.selectedDates = [
                                    U
                                ];
                                else if (n.config.mode === "multiple") {
                                    var ce = yr(U);
                                    ce ? n.selectedDates.splice(parseInt(ce), 1) : n.selectedDates.push(U);
                                } else n.config.mode === "range" && (n.selectedDates.length === 2 && n.clear(!1, !1), n.latestSelectedDateObj = U, n.selectedDates.push(U), le(U, n.selectedDates[0], !0) !== 0 && n.selectedDates.sort(function(he, Ue) {
                                    return he.getTime() - Ue.getTime();
                                }));
                                if (pe(), j) {
                                    var Z = n.currentYear !== U.getFullYear();
                                    n.currentYear = U.getFullYear(), n.currentMonth = U.getMonth(), Z && (St("onYearChange"), cn()), St("onMonthChange");
                                }
                                if (Vn(), jt(), C(), !j && n.config.mode !== "range" && n.config.showMonths === 1 ? We(R) : n.selectedDateElem !== void 0 && n.hourElement === void 0 && n.selectedDateElem && n.selectedDateElem.focus(), n.hourElement !== void 0 && n.hourElement !== void 0 && n.hourElement.focus(), n.config.closeOnSelect) {
                                    var Se = n.config.mode === "single" && !n.config.enableTime, de = n.config.mode === "range" && n.selectedDates.length === 2 && !n.config.enableTime;
                                    (Se || de) && Kn();
                                }
                                Ot();
                            }
                        }
                        var Bn = {
                            locale: [
                                Br,
                                ni
                            ],
                            showMonths: [
                                Ir,
                                oe,
                                ti
                            ],
                            minDate: [
                                yt
                            ],
                            maxDate: [
                                yt
                            ],
                            positionElement: [
                                di
                            ],
                            clickOpens: [
                                function() {
                                    n.config.clickOpens === !0 ? (je(n._input, "focus", n.open), je(n._input, "click", n.open)) : (n._input.removeEventListener("focus", n.open), n._input.removeEventListener("click", n.open));
                                }
                            ]
                        };
                        function Fi(d, h) {
                            if (d !== null && typeof d == "object") {
                                Object.assign(n.config, d);
                                for(var T in d)Bn[T] !== void 0 && Bn[T].forEach(function(R) {
                                    return R();
                                });
                            } else n.config[d] = h, Bn[d] !== void 0 ? Bn[d].forEach(function(R) {
                                return R();
                            }) : k.indexOf(d) > -1 && (n.config[d] = g(h));
                            n.redraw(), C(!0);
                        }
                        function Gn(d, h) {
                            var T = [];
                            if (d instanceof Array) T = d.map(function(R) {
                                return n.parseDate(R, h);
                            });
                            else if (d instanceof Date || typeof d == "number") T = [
                                n.parseDate(d, h)
                            ];
                            else if (typeof d == "string") switch(n.config.mode){
                                case "single":
                                case "time":
                                    T = [
                                        n.parseDate(d, h)
                                    ];
                                    break;
                                case "multiple":
                                    T = d.split(n.config.conjunction).map(function(R) {
                                        return n.parseDate(R, h);
                                    });
                                    break;
                                case "range":
                                    T = d.split(n.l10n.rangeSeparator).map(function(R) {
                                        return n.parseDate(R, h);
                                    });
                                    break;
                            }
                            else n.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(d)));
                            n.selectedDates = n.config.allowInvalidPreload ? T : T.filter(function(R) {
                                return R instanceof Date && Nn(R, !1);
                            }), n.config.mode === "range" && n.selectedDates.sort(function(R, U) {
                                return R.getTime() - U.getTime();
                            });
                        }
                        function qi(d, h, T) {
                            if (h === void 0 && (h = !1), T === void 0 && (T = n.config.dateFormat), d !== 0 && !d || d instanceof Array && d.length === 0) return n.clear(h);
                            Gn(d, T), n.latestSelectedDateObj = n.selectedDates[n.selectedDates.length - 1], n.redraw(), yt(void 0, h), Le(), n.selectedDates.length === 0 && n.clear(!1), C(h), h && St("onChange");
                        }
                        function Pr(d) {
                            return d.slice().map(function(h) {
                                return typeof h == "string" || typeof h == "number" || h instanceof Date ? n.parseDate(h, void 0, !0) : h && typeof h == "object" && h.from && h.to ? {
                                    from: n.parseDate(h.from, void 0),
                                    to: n.parseDate(h.to, void 0)
                                } : h;
                            }).filter(function(h) {
                                return h;
                            });
                        }
                        function ci() {
                            n.selectedDates = [], n.now = n.parseDate(n.config.now) || /* @__PURE__ */ new Date();
                            var d = n.config.defaultDate || ((n.input.nodeName === "INPUT" || n.input.nodeName === "TEXTAREA") && n.input.placeholder && n.input.value === n.input.placeholder ? null : n.input.value);
                            d && Gn(d, n.config.dateFormat), n._initialDate = n.selectedDates.length > 0 ? n.selectedDates[0] : n.config.minDate && n.config.minDate.getTime() > n.now.getTime() ? n.config.minDate : n.config.maxDate && n.config.maxDate.getTime() < n.now.getTime() ? n.config.maxDate : n.now, n.currentYear = n._initialDate.getFullYear(), n.currentMonth = n._initialDate.getMonth(), n.selectedDates.length > 0 && (n.latestSelectedDateObj = n.selectedDates[0]), n.config.minTime !== void 0 && (n.config.minTime = n.parseDate(n.config.minTime, "H:i")), n.config.maxTime !== void 0 && (n.config.maxTime = n.parseDate(n.config.maxTime, "H:i")), n.minDateHasTime = !!n.config.minDate && (n.config.minDate.getHours() > 0 || n.config.minDate.getMinutes() > 0 || n.config.minDate.getSeconds() > 0), n.maxDateHasTime = !!n.config.maxDate && (n.config.maxDate.getHours() > 0 || n.config.maxDate.getMinutes() > 0 || n.config.maxDate.getSeconds() > 0);
                        }
                        function ui() {
                            if (n.input = ai(), !n.input) {
                                n.config.errorHandler(new Error("Invalid input element specified"));
                                return;
                            }
                            n.input._type = n.input.type, n.input.type = "text", n.input.classList.add("flatpickr-input"), n._input = n.input, n.config.altInput && (n.altInput = F(n.input.nodeName, n.config.altInputClass), n._input = n.altInput, n.altInput.placeholder = n.input.placeholder, n.altInput.disabled = n.input.disabled, n.altInput.required = n.input.required, n.altInput.tabIndex = n.input.tabIndex, n.altInput.type = "text", n.input.setAttribute("type", "hidden"), !n.config.static && n.input.parentNode && n.input.parentNode.insertBefore(n.altInput, n.input.nextSibling)), n.config.allowInput || n._input.setAttribute("readonly", "readonly"), di();
                        }
                        function di() {
                            n._positionElement = n.config.positionElement || n._input;
                        }
                        function Wi() {
                            var d = n.config.enableTime ? n.config.noCalendar ? "time" : "datetime-local" : "date";
                            n.mobileInput = F("input", n.input.className + " flatpickr-mobile"), n.mobileInput.tabIndex = 1, n.mobileInput.type = d, n.mobileInput.disabled = n.input.disabled, n.mobileInput.required = n.input.required, n.mobileInput.placeholder = n.input.placeholder, n.mobileFormatStr = d === "datetime-local" ? "Y-m-d\\TH:i:S" : d === "date" ? "Y-m-d" : "H:i:S", n.selectedDates.length > 0 && (n.mobileInput.defaultValue = n.mobileInput.value = n.formatDate(n.selectedDates[0], n.mobileFormatStr)), n.config.minDate && (n.mobileInput.min = n.formatDate(n.config.minDate, "Y-m-d")), n.config.maxDate && (n.mobileInput.max = n.formatDate(n.config.maxDate, "Y-m-d")), n.input.getAttribute("step") && (n.mobileInput.step = String(n.input.getAttribute("step"))), n.input.type = "hidden", n.altInput !== void 0 && (n.altInput.type = "hidden");
                            try {
                                n.input.parentNode && n.input.parentNode.insertBefore(n.mobileInput, n.input.nextSibling);
                            } catch  {}
                            je(n.mobileInput, "change", function(h) {
                                n.setDate(Q(h).value, !1, n.mobileFormatStr), St("onChange"), St("onClose");
                            });
                        }
                        function Ui(d) {
                            if (n.isOpen === !0) return n.close();
                            n.open(d);
                        }
                        function St(d, h) {
                            if (n.config !== void 0) {
                                var T = n.config[d];
                                if (T !== void 0 && T.length > 0) for(var R = 0; T[R] && R < T.length; R++)T[R](n.selectedDates, n.input.value, n, h);
                                d === "onChange" && (n.input.dispatchEvent(nr("change")), n.input.dispatchEvent(nr("input")));
                            }
                        }
                        function nr(d) {
                            var h = document.createEvent("Event");
                            return h.initEvent(d, !0, !0), h;
                        }
                        function yr(d) {
                            for(var h = 0; h < n.selectedDates.length; h++){
                                var T = n.selectedDates[h];
                                if (T instanceof Date && le(T, d) === 0) return "" + h;
                            }
                            return !1;
                        }
                        function Hi(d) {
                            return n.config.mode !== "range" || n.selectedDates.length < 2 ? !1 : le(d, n.selectedDates[0]) >= 0 && le(d, n.selectedDates[1]) <= 0;
                        }
                        function Vn() {
                            n.config.noCalendar || n.isMobile || !n.monthNav || (n.yearElements.forEach(function(d, h) {
                                var T = new Date(n.currentYear, n.currentMonth, 1);
                                T.setMonth(n.currentMonth + h), n.config.showMonths > 1 || n.config.monthSelectorType === "static" ? n.monthElements[h].textContent = H(T.getMonth(), n.config.shorthandCurrentMonth, n.l10n) + " " : n.monthsDropdownContainer.value = T.getMonth().toString(), d.value = T.getFullYear().toString();
                            }), n._hidePrevMonthArrow = n.config.minDate !== void 0 && (n.currentYear === n.config.minDate.getFullYear() ? n.currentMonth <= n.config.minDate.getMonth() : n.currentYear < n.config.minDate.getFullYear()), n._hideNextMonthArrow = n.config.maxDate !== void 0 && (n.currentYear === n.config.maxDate.getFullYear() ? n.currentMonth + 1 > n.config.maxDate.getMonth() : n.currentYear > n.config.maxDate.getFullYear()));
                        }
                        function Rr(d) {
                            var h = d || (n.config.altInput ? n.config.altFormat : n.config.dateFormat);
                            return n.selectedDates.map(function(T) {
                                return n.formatDate(T, h);
                            }).filter(function(T, R, U) {
                                return n.config.mode !== "range" || n.config.enableTime || U.indexOf(T) === R;
                            }).join(n.config.mode !== "range" ? n.config.conjunction : n.l10n.rangeSeparator);
                        }
                        function C(d) {
                            d === void 0 && (d = !0), n.mobileInput !== void 0 && n.mobileFormatStr && (n.mobileInput.value = n.latestSelectedDateObj !== void 0 ? n.formatDate(n.latestSelectedDateObj, n.mobileFormatStr) : ""), n.input.value = Rr(n.config.dateFormat), n.altInput !== void 0 && (n.altInput.value = Rr(n.config.altFormat)), d !== !1 && St("onValueUpdate");
                        }
                        function D(d) {
                            var h = Q(d), T = n.prevMonthNav.contains(h), R = n.nextMonthNav.contains(h);
                            T || R ? _r(T ? -1 : 1) : n.yearElements.indexOf(h) >= 0 ? h.select() : h.classList.contains("arrowUp") ? n.changeYear(n.currentYear + 1) : h.classList.contains("arrowDown") && n.changeYear(n.currentYear - 1);
                        }
                        function B(d) {
                            d.preventDefault();
                            var h = d.type === "keydown", T = Q(d), R = T;
                            n.amPM !== void 0 && T === n.amPM && (n.amPM.textContent = n.l10n.amPM[s(n.amPM.textContent === n.l10n.amPM[0])]);
                            var U = parseFloat(R.getAttribute("min")), j = parseFloat(R.getAttribute("max")), ce = parseFloat(R.getAttribute("step")), Z = parseInt(R.value, 10), Se = d.delta || (h ? d.which === 38 ? 1 : -1 : 0), de = Z + ce * Se;
                            if (typeof R.value < "u" && R.value.length === 2) {
                                var he = R === n.hourElement, Ue = R === n.minuteElement;
                                de < U ? (de = j + de + s(!he) + (s(he) && s(!n.amPM)), Ue && zt(void 0, -1, n.hourElement)) : de > j && (de = R === n.hourElement ? de - j - s(!n.amPM) : U, Ue && zt(void 0, 1, n.hourElement)), n.amPM && he && (ce === 1 ? de + Z === 23 : Math.abs(de - Z) > ce) && (n.amPM.textContent = n.l10n.amPM[s(n.amPM.textContent === n.l10n.amPM[0])]), R.value = a(de);
                            }
                        }
                        return ke(), n;
                    }
                    function Be(M, P) {
                        for(var n = Array.prototype.slice.call(M).filter(function(ht) {
                            return ht instanceof HTMLElement;
                        }), ye = [], ke = 0; ke < n.length; ke++){
                            var Me = n[ke];
                            try {
                                if (Me.getAttribute("data-fp-omit") !== null) continue;
                                Me._flatpickr !== void 0 && (Me._flatpickr.destroy(), Me._flatpickr = void 0), Me._flatpickr = qe(Me, P || {}), ye.push(Me._flatpickr);
                            } catch (ht) {
                                console.error(ht);
                            }
                        }
                        return ye.length === 1 ? ye[0] : ye;
                    }
                    typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(M) {
                        return Be(this, M);
                    }, HTMLElement.prototype.flatpickr = function(M) {
                        return Be([
                            this
                        ], M);
                    });
                    var Fe = function(M, P) {
                        return typeof M == "string" ? Be(window.document.querySelectorAll(M), P) : M instanceof Node ? Be([
                            M
                        ], P) : Be(M, P);
                    };
                    Fe.defaultConfig = {}, Fe.l10ns = {
                        en: me({}, i),
                        default: me({}, i)
                    }, Fe.localize = function(M) {
                        Fe.l10ns.default = me(me({}, Fe.l10ns.default), M);
                    }, Fe.setDefaults = function(M) {
                        Fe.defaultConfig = me(me({}, Fe.defaultConfig), M);
                    }, Fe.parseDate = xe({}), Fe.formatDate = fe({}), Fe.compareDates = le, typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(M) {
                        return Be(this, M);
                    }), Date.prototype.fp_incr = function(M) {
                        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof M == "string" ? parseInt(M, 10) : M));
                    }, typeof window < "u" && (window.flatpickr = Fe);
                    const Re = Fe, ge = y("./node_modules/flatpickr/dist/l10n/pt.js").default.pt;
                    class ne {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               * @param {string} config - atributo de configuração do componente
               * @param {object} language arquivo de linguagem do flatpick por padrão nesse componente vem portugues
               */ constructor(P, n, ye, ke = ge){
                            if (this.name = P, this.component = n, this.language = ke, this.component.querySelectorAll(".br-button").forEach((Me)=>{
                                Me.setAttribute("aria-hidden", "true"), Me.setAttribute("tab-index", "-1");
                            }), this.component.addEventListener("blur", ()=>{
                                isNaN(new Date(this.component.value)) || fp.setDate(this.component.value);
                            }), this.component.addEventListener("keyup", ()=>{
                                isNaN(new Date(this.component.value)) || (this.component.selectionStart >= 10 ? fp.setDate(this.component.value) : fp.jumpToDate(this.component.value));
                            }), Re.localize(ke), this.configAttribute = this.component.getAttribute("datetimepicker-config"), this.configAttribute) {
                                const Me = this.configAttribute.split(",");
                                this.obj = [], Me.forEach((ht)=>{
                                    const oe = ht.split(":");
                                    this.obj[oe[0]] = oe[1].replaceAll("'", "").trim(), this.saida = this.obj;
                                }, this), this.config = this.obj;
                            } else this.config = ye;
                            this._buildDateTimePicker();
                        }
                        /**
               * Adiciona máscara de data no input
               * @param {*} elm
               */ _dateInputMask(P) {
                            P.setAttribute("maxlength", 10), P.addEventListener("keypress", (n)=>{
                                (n.keyCode < 47 || n.keyCode > 57) && n.preventDefault();
                                const ye = P.value.length;
                                (ye !== 1 || ye !== 3) && n.keyCode === 47 && n.preventDefault(), ye === 2 && (P.value += "/"), ye === 5 && (P.value += "/");
                            });
                        }
                        /**
               *  Adiciona máscara de hora no input
               * @param {*} elm * Dom do elemento input
               */ _dateTimeInputMask(P) {
                            P.setAttribute("maxlength", 16), P.addEventListener("keypress", (n)=>{
                                (n.keyCode < 47 || n.keyCode > 57) && n.preventDefault();
                                const ye = P.value.length;
                                switch((ye !== 1 || ye !== 3) && n.keyCode === 47 && n.preventDefault(), ye){
                                    case 2:
                                        P.value += "/";
                                        break;
                                    case 5:
                                        P.value += "/";
                                        break;
                                    case 10:
                                        P.value += " ";
                                        break;
                                    case 13:
                                        P.value += ":";
                                        break;
                                }
                            });
                        }
                        /**
               * Coloca máscara com range de data no input
               * @param {*} elm * Dom do elemento input
               */ _dateRangeInputMask(P) {
                            P.setAttribute("maxlength", 25), P.addEventListener("keypress", (n)=>{
                                (n.keyCode < 47 || n.keyCode > 57) && n.preventDefault();
                                const ye = P.value.length;
                                (ye !== 1 || ye !== 3) && n.keyCode === 47 && n.preventDefault(), this._positionRangeMask(P, ye);
                            });
                        }
                        /**
               * Insere a máscara na Dom
               * @param {*} elm Dom do elemento input
               * @param {*} len Tamanho do elemento inserido
               */ _positionRangeMask(P, n) {
                            const ye = this.language.rangeSeparator.length, ke = 10 + ye + 2, Me = 10 + ye + 5;
                            switch(P.setAttribute("maxlength", 20 + ye), n){
                                case 2:
                                    P.value += "/";
                                    break;
                                case 5:
                                    P.value += "/";
                                    break;
                                case 10:
                                    P.value += this.language.rangeSeparator;
                                    break;
                                case ke:
                                    P.value += "/";
                                    break;
                                case Me:
                                    P.value += "/";
                                    break;
                            }
                        }
                        /**
               * Insere máscara de hora
               *
               * @param {*} elm dom do elemento input
               */ _timeInputMask(P) {
                            P.setAttribute("maxlength", 5), P.addEventListener("keypress", (n)=>{
                                (n.keyCode < 47 || n.keyCode > 57) && n.preventDefault();
                                const ye = P.value.length;
                                (ye !== 1 || ye !== 3) && n.keyCode === 47 && n.preventDefault(), ye === 2 && (P.value += ":");
                            });
                        }
                        /**
               * Formata o componente e monta instância flatpickr
               * @private
               */ _buildDateTimePicker() {
                            let P = "d/m/Y", n = !1, ye = !1;
                            switch(this.component.getAttribute("data-type")){
                                case "date":
                                    P = "d/m/Y", n = !1, ye = !1, this._dateInputMask(this.component.querySelectorAll("input")[0]);
                                    break;
                                case "time":
                                    P = "H:i", n = !0, ye = !0, this._timeInputMask(this.component.querySelectorAll("input")[0]);
                                    break;
                                case "datetime-local":
                                    P = "d/m/Y H:i", n = !0, ye = !1, this._dateTimeInputMask(this.component.querySelectorAll("input")[0]);
                                    break;
                                case "datetime-range":
                                    P = "d/m/Y", n = !1, ye = !1, this._dateRangeInputMask(this.component.querySelectorAll("input")[0]);
                                    break;
                                default:
                                    P = "d/m/Y", n = !1, ye = !1, this.component.getAttribute("data-mode") === "range" ? this._dateRangeInputMask(this.component.querySelectorAll("input")[0]) : this._dateInputMask(this.component.querySelectorAll("input")[0]);
                                    break;
                            }
                            this.config_native = {
                                allowInput: !0,
                                dateFormat: P,
                                enableTime: n,
                                minuteIncrement: 1,
                                wrap: !0
                            }, this.config_min_flat = {
                                clickOpens: !1,
                                disableMobile: "true",
                                mode: this.component.getAttribute("data-mode"),
                                nextArrow: '<button class="br-button circle small" type="button"><i class="fas fa-chevron-right"></i></button>',
                                noCalendar: ye,
                                prevArrow: '<button class="br-button circle small" type="button"><i class="fas fas fa-chevron-left"></i></button>',
                                wrap: !0
                            }, this.config_flatpick = Object.assign(this.config_native, this.config), this.config_flatpick = Object.assign(this.config_flatpick, this.config_min_flat), this.calendar = Re(this.component, Object.assign(this.config_native, this.config)), this.calendar.config.onOpen.push(()=>{
                                this.config_flatpick.allowInput ? this.component.querySelectorAll(".br-button").forEach((ke)=>{
                                    ke.setAttribute("aria-hidden", "true"), ke.setAttribute("tab-index", "-1");
                                }) : this.component.querySelectorAll(".flatpickr-calendar").forEach((ke)=>{
                                    console.log(ke), ke.setAttribute("tab-index", "-1");
                                }), document.querySelectorAll(".flatpickr-day").forEach((ke)=>{
                                    ke.setAttribute("tabindex", "1");
                                }), document.querySelectorAll(".arrowUp").forEach((ke)=>{
                                    ke.classList.add("fas", "fa-chevron-up");
                                }), document.querySelectorAll(".arrowDown").forEach((ke)=>{
                                    ke.classList.add("fas", "fa-chevron-down");
                                });
                            });
                        }
                    }
                    const ut = ne;
                },
                /***/ "./src/components/footer/footer.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia um componente BRFooter
               * @param {string} name - Nome do componente (br-footer)
               * @param {object} component - Objeto que referencia o elemento DOM do componente
               */ constructor(i, a){
                            this.name = i, this.component = a, this._setUp(), this._setBehavior();
                        }
                        /**
               * Controla a configuração inicial do footer
               */ _setUp() {
                            this.list = this.component.querySelector(".br-list.horizontal");
                        }
                        /**
               * Controla os comportamentos do footer
               * @private
               */ _setBehavior() {
                            this._setCollapseBehavior(), window.onresize = function() {
                                window.matchMedia("(min-width: 992px)").matches ? window.document.querySelectorAll(".br-footer .br-list:not(.horizontal)").forEach((i)=>{
                                    i.style.display = "block";
                                }) : (window.document.querySelectorAll(".br-footer .br-list:not(.horizontal)").forEach((i)=>{
                                    i.style.display = "none";
                                }), window.document.querySelectorAll(".br-footer i").forEach((i)=>{
                                    i.classList.remove("fa-angle-up"), i.classList.add("fa-angle-down");
                                }));
                            };
                        }
                        /**
               * Trata do comportamento de collapse do Footer
               * @private
               */ _setCollapseBehavior() {
                            this.britems = [], this.list && (this.list.querySelectorAll(".br-list").forEach((i)=>{
                                window.matchMedia("(max-width: 992px)").matches && (i.style.display = "none");
                            }), this.list.querySelectorAll(".br-item").forEach((i)=>{
                                i.addEventListener("click", (a)=>{
                                    window.matchMedia("(max-width: 992px)").matches && this._showList(a);
                                }), this.britems.push(i);
                            }), this.list.querySelectorAll(".br-item").forEach((i)=>{
                                i.addEventListener("keydown", (a)=>{
                                    a.keyCode === 13 && window.matchMedia("(max-width: 992px)").matches && this._showList(a);
                                }), this.britems.push(i);
                            }));
                        }
                        /**
               * Controla a abertura e fachamento da lista
               * @param {object} e - Objeto Event
               * @private
               */ _showList(i) {
                            parent = i.target.parentElement, parent = parent.classList.contains("col-2") ? i.target.parentElement : i.target.parentElement.parentElement, parent = parent.classList.contains("col-2") ? parent : i.target.parentElement.parentElement.parentElement, this._closeAllColumns(parent), parent.querySelectorAll(".br-list ").forEach((a)=>{
                                a.style.display = a.style.display === "block" ? "none" : "block";
                                const s = parent.querySelector("i");
                                a.style.display === "block" ? this._iconAngleUP(s) : this._iconAngleDOWN(s), this._setAriaAttributes(a, i);
                            });
                        }
                        /**
               * Fecha todas colunas do Footer
               */ _closeAllColumns(i) {
                            this.component.querySelectorAll(".br-list:not(.horizontal)").forEach((a)=>{
                                i !== a.parentElement && (a.style.display = "none", this.component.querySelectorAll(".header i").forEach((s)=>{
                                    this._iconAngleDOWN(s);
                                }));
                            });
                        }
                        /**
               *Inclui ícone 'fa-angle-up'
               * @param {objetc} iconComponent - Elemento DOM que representa um ícone
               * @private
               */ _iconAngleUP(i) {
                            i.classList.remove("fa-angle-down"), i.classList.add("fa-angle-up");
                        }
                        /**
               * Inclui ícone 'fa-angle-down'
               * @param {object} iconComponent - Elemento DOM que representa um ícone
               * @private
               */ _iconAngleDOWN(i) {
                            i.classList.remove("fa-angle-up"), i.classList.add("fa-angle-down");
                        }
                        /**
               * Define atributos ARIA para um elemento de lista com base na visibilidade de um trigger.
               * @param {object} trigger - Elemento DOM que controla a visibilidade do elemento de lista
               * @private
               */ _setAriaAttributes(i, a) {
                            this.list.querySelectorAll(".br-item").forEach(()=>{
                                const c = `list-${Math.floor(Math.random() * 1e4)}`, g = i.style.display === "block", { parentElement: A } = a.target;
                                A.setAttribute("id", c), A.setAttribute("data-visible", g), A.setAttribute("aria-expanded", g), A.setAttribute("aria-label", g ? "expandido" : "recolhido"), A.setAttribute("aria-controls", c), A.setAttribute("data-group", "group1"), A.setAttribute("data-target", c);
                            });
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/header/header.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/partial/js/behavior/tooltip.js");
                    class b {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(a, s){
                            this.name = a, this.component = s, this.componentSearch = this.component.querySelector(".header-search"), this.componentSearchInput = this.component.querySelector(".header-search input"), this.componentSearchTrigger = this.component.querySelector('[data-toggle="search"]'), this.componentSearchDismiss = this.component.querySelector('[data-dismiss="search"]'), this.hideDrop = null, this.menuTrigger = this.component.querySelector('[data-target="#main-navigation"]'), this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            this._setLogoutBehavior(), this._setSearchBehaviors(), this._setKeyboardBehaviors(), this._setDropdownBehavior(), this._setSticky();
                        }
                        /**
               * Define comportamentos de login
               * @private
               */ _setLoginBehavior() {
                            for (const a of this.component.querySelectorAll('[data-trigger="login"]'))a.addEventListener("click", ()=>{
                                const s = a.closest(".header-login");
                                s.querySelector(".header-sign-in").classList.add("d-none"), s.querySelector(".header-avatar").classList.remove("d-none");
                            });
                        }
                        /**
               * Define comportamentos de logout
               * @private
               */ _setLogoutBehavior() {
                            for (const a of this.component.querySelectorAll('[data-trigger="logout"]'))a.addEventListener("click", ()=>{
                                const s = a.closest(".header-login");
                                s.querySelector(".avatar").classList.remove("show"), s.querySelector('[data-toggle="dropdown"]').classList.remove("active"), s.querySelector(".header-sign-in").classList.remove("d-none"), s.querySelector(".header-avatar").classList.add("d-none");
                            });
                        }
                        /**
               * Define comportamentos de busca
               * @private
               */ _setSearchBehaviors() {
                            this.componentSearchTrigger && (this.componentSearchTrigger.addEventListener("focus", ()=>{
                                this._cleanDropDownHeader();
                            }), this.componentSearchTrigger.addEventListener("click", ()=>{
                                this._openSearch();
                            })), this.componentSearchDismiss && this.componentSearchDismiss.addEventListener("click", ()=>{
                                this._closeSearch();
                            });
                        }
                        /**
               * Define comportamentos do teclado
               * @private
               */ _setKeyboardBehaviors() {
                            this.componentSearchInput && this.componentSearchInput.addEventListener("keydown", (a)=>{
                                switch(a.keyCode){
                                    case 27:
                                        this._closeSearch();
                                        break;
                                }
                            });
                            for (const a of this.component.querySelectorAll('.dropdown [data-toggle="dropdown"]'))a.addEventListener("keydown", (s)=>{
                                switch(s.keyCode){
                                    case 32:
                                        s.target.parentNode.classList.contains("show") && (s.target.parentNode.click(), s.target.parentNode.classList.remove("show"), s.target.classList.remove("active"), s.stopPropagation());
                                        break;
                                }
                            });
                        }
                        /**
               * Visualização da busca
               * @private
               */ _openSearch() {
                            this.componentSearch && (this.componentSearch.classList.add("active"), this.componentSearch.querySelector("input").focus());
                        }
                        /**
               * Esconde a busca
               * @private
               */ _closeSearch() {
                            this.componentSearch && (this.componentSearch.classList.remove("active"), this._nextFocusElement().focus());
                        }
                        /**
               * Exibe notificação
               * @param {event} event - referencia ao evento
               */ handleEvent(a) {
                            const s = this.component.querySelector(".br-notification");
                            s && !s.contains(a.target) && this.activateTr !== a.target.parentNode && this._cleanDropDownHeaderRef(this.component);
                        }
                        /**
               * Define comportamentos do dropdown
               * @private
               */ _setDropdownBehavior() {
                            this.cleaned = !1;
                            let a;
                            this.activateTr = "teste";
                            for (const s of this.component.querySelectorAll('.dropdown [data-toggle="dropdown"]'))s.addEventListener("click", (c)=>(this._headerTooltip(), clearTimeout(a), this.activateTr = s, document.addEventListener("mousedown", this, !1), c.stopImmediatePropagation(), s.classList.contains("active") ? (s.classList.remove("active"), s.closest(".dropdown").classList.remove("show")) : (this._cleanDropDownHeader(), s.classList.add("active"), s.closest(".dropdown").classList.add("show"), this._nextFocusElement().addEventListener("focus", ()=>{
                                    clearTimeout(a);
                                })), c.stopPropagation(), ""));
                            this.menuTrigger.addEventListener("focus", ()=>{
                                this._cleanDropDownHeader();
                            });
                        }
                        /**
               * Define comportamentos do tooltip
               * @private
               */ _headerTooltip() {
                            this.TooltipExampleList && this.TooltipExampleList.forEach((a)=>{
                                a.component.remove(), a.popperInstance.destroy();
                            }), this.TooltipExampleList = [], this.component.querySelectorAll(".notification-tooltip").forEach((a)=>{
                                const s = a.getAttribute("data-tooltip-text"), c = {
                                    activator: a,
                                    placement: "top",
                                    textTooltip: s
                                }, g = new k.default(c);
                                this.TooltipExampleList.push(g);
                            });
                        }
                        /**
               * Limpa referencias do dorpdown
               * @private
               * @param {object} ref - Referência ao componente header
               */ _cleanDropDownHeaderRef(a) {
                            if (this.cleaned === !1) for (const s of a.querySelectorAll(".dropdown.show")){
                                s.classList.remove("show"), s.parentNode.classList.remove("show");
                                for (const c of a.querySelectorAll(".br-button"))c.classList.remove("active");
                            }
                            this.cleaned = !1;
                        }
                        /**
               * Limpa referencias do dorpdown
               * @private
               */ _cleanDropDownHeader() {
                            this._cleanDropDownHeaderRef(this.component);
                        }
                        /**
               * Define modo sticky ao header
               * @private
               */ _setSticky() {
                            this.component.hasAttribute("data-sticky") && (window.onscroll = ()=>{
                                window.pageYOffset > this.component.offsetHeight ? this.component.classList.add("sticky", "compact") : this.component.classList.remove("sticky", "compact");
                            });
                        }
                        /**
               * Foca no próximo elmento de ação
               * @private
               */ _nextFocusElement() {
                            const a = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
                            if (document.activeElement) {
                                const s = Array.prototype.filter.call(document.body.querySelectorAll(a), (g)=>g.offsetWidth > 0 || g.offsetHeight > 0 || g === document.activeElement), c = s.indexOf(document.activeElement);
                                if (c > -1) return s[c + 1] || s[0];
                            }
                            return null;
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/input/input.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(i, a){
                            this.name = i, this.component = a, this._currentFocus = -1, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            this._setPasswordViewBehavior(), this._setAutocompleteBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setPasswordViewBehavior() {
                            for (const i of this.component.querySelectorAll('input[type="password"]'))if (!i.disabled) for (const a of i.parentNode.querySelectorAll(".br-button"))a.addEventListener("click", (s)=>{
                                this._toggleShowPassword(s);
                            }, !1);
                        }
                        /**
               * Define comportamentos do componente
               * @private
               * @param {event} event - referência ao elemento que dispara a ação
               */ _toggleShowPassword(i) {
                            for (const a of i.currentTarget.querySelectorAll(".fas"))if (a.classList.contains("fa-eye")) {
                                a.classList.remove("fa-eye"), a.classList.add("fa-eye-slash");
                                for (const s of this.component.querySelectorAll('input[type="password"]'))s.setAttribute("type", "text");
                                for (const s of this.component.querySelectorAll('button[aria-label="Exibir senha"]'))s.setAttribute("aria-checked", "true");
                            } else if (a.classList.contains("fa-eye-slash")) {
                                a.classList.remove("fa-eye-slash"), a.classList.add("fa-eye");
                                for (const s of this.component.querySelectorAll('input[type="text"]'))s.setAttribute("type", "password");
                                for (const s of this.component.querySelectorAll('button[aria-label="Exibir senha"]'))s.setAttribute("aria-checked", "false");
                            }
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setAutocompleteBehavior() {
                            for (const i of this.component.querySelectorAll("input.search-autocomplete"))i.addEventListener("input", (a)=>{
                                this._clearSearchItems(), this._buildSearchItems(a.currentTarget);
                            }, !1), i.addEventListener("keydown", (a)=>{
                                this._handleArrowKeys(a);
                            }, !1);
                        }
                        /**
               * Monta os items de busca para o elemento input
               * @private
               * @param {object} element - referencia ao elemento input
               */ _buildSearchItems(i) {
                            const a = window.document.createElement("div");
                            if (a.setAttribute("class", "search-items"), this.component.appendChild(a), i.value !== "") {
                                for (const s of this.dataList)if (s.substr(0, i.value.length).toUpperCase() === i.value.toUpperCase()) {
                                    const c = window.document.createElement("div");
                                    c.innerHTML = `<strong>${s.substr(0, i.value.length)}</strong>`, c.innerHTML += s.substr(i.value.length), c.innerHTML += `<input type="hidden" value="${s}">`, c.addEventListener("click", (g)=>{
                                        for (const A of g.currentTarget.querySelectorAll('input[type="hidden"]'))i.value = A.value;
                                        this._clearSearchItems();
                                    }, !1), a.appendChild(c);
                                }
                            } else this._clearSearchItems();
                        }
                        /**
               * Limpa elementos da busca
               * @private
               */ _clearSearchItems() {
                            for (const i of this.component.querySelectorAll(".search-items")){
                                for (const a of i.querySelectorAll("div"))i.removeChild(a);
                                this.component.removeChild(i);
                            }
                        }
                        /**
               * Define comportamentos do teclado
               * @private
               * @param {event} event - referência ao elemento que dispara a ação do teclado
               */ _handleArrowKeys(i) {
                            switch(i.keyCode){
                                case 13:
                                    if (this._currentFocus > -1) {
                                        i.preventDefault();
                                        for (const a of this.component.querySelectorAll(".search-items"))for (const s of a.querySelectorAll("div.is-active"))s.click();
                                        this._currentFocus = -1;
                                    }
                                    break;
                                case 38:
                                    this._currentFocus > 0 && (this._currentFocus -= 1), this._switchFocus();
                                    break;
                                case 40:
                                    for (const a of this.component.querySelectorAll(".search-items"))this._currentFocus < a.querySelectorAll("div").length - 1 && (this._currentFocus += 1);
                                    this._switchFocus();
                                    break;
                            }
                        }
                        /**
               * Muda o foco do item de busca
               * @private
               */ _switchFocus() {
                            for (const i of this.component.querySelectorAll(".search-items"))for (const [a, s] of i.querySelectorAll("div").entries())a === this._currentFocus && s.classList.add("is-active"), a !== this._currentFocus && s.classList.remove("is-active");
                        }
                        /**
               * Preenche lista de dados
               * @private
               * @param {string[]} dataList - Lista de dados
               */ setAutocompleteData(i) {
                            this.dataList = i;
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/item/item.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(i, a){
                            this.name = i, this.component = a, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            this._setCheckboxSelection(), this._setRadioSelection();
                        }
                        /**
               * Define comportamentos do checkbox
               * @private
               */ _setCheckboxSelection() {
                            for (const i of this.component.querySelectorAll('.br-checkbox input[type="checkbox"]'))i.checked && this.component.classList.add("selected"), i.addEventListener("click", (a)=>{
                                a.currentTarget.checked ? this.component.classList.add("selected") : this.component.classList.remove("selected");
                            });
                        }
                        /**
               * Define comportamentos do radio
               * @private
               */ _setRadioSelection() {
                            for (const i of this.component.querySelectorAll('.br-radio input[type="radio"]'))i.checked && (i.setAttribute("checked", ""), this.component.classList.add("selected")), i.addEventListener("click", (a)=>{
                                for (const s of this.component.parentElement.querySelectorAll(".br-item"))for (const c of s.querySelectorAll('.br-radio input[type="radio"]'))c === a.currentTarget ? (c.setAttribute("checked", ""), s.classList.add("selected")) : (c.removeAttribute("checked"), s.classList.remove("selected"));
                            });
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/list/list.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/partial/js/behavior/collapse.js");
                    class b {
                        /**
               * Instancia um componente BRList
               * @param {string} name - Nome do componente (br-list)
               * @param {object} component - Objeto que referencia o elemento DOM do componente
               */ constructor(a, s){
                            this.name = a, this.component = s, this._setBehavior();
                        }
                        /**
               * Controla os comportamentos da list
               * @private
               */ _setBehavior() {
                            this._setCollapseBehavior();
                        }
                        /**
               * Trata do comportamento de collapse da list
               * @private
               */ _setCollapseBehavior() {
                            this.component.querySelectorAll('[data-toggle="collapse"]').forEach((a)=>{
                                const s = {
                                    iconToHide: "fa-chevron-up",
                                    iconToShow: "fa-chevron-down",
                                    trigger: a,
                                    useIcons: !0
                                };
                                new k.default(s).setBehavior();
                            });
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/menu/menu.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(i, a){
                            this.name = i, this.component = a, this.id = this.component.id, this.breakpoints = this.component.dataset.breakpoints ? this.component.dataset.breakpoints.split(" ") : [
                                "col-sm-4",
                                "col-lg-3"
                            ], this.pushShadow = "shadow-lg-right", this.trigger = document.querySelector(`[data-target="#${this.id}"]`), this.contextual = this.component.querySelector('[data-toggle="contextual"]'), this.dismiss = this.component.querySelectorAll('[data-dismiss="menu"]'), this.scrim = this.component.querySelector(".menu-scrim"), this.componentFolders = this.component.querySelectorAll(".menu-folder"), this.componentSiders = this.component.querySelectorAll(".side-menu"), this.componentItems = this.component.querySelectorAll(".menu-item"), this.elementOpenMenu = HTMLElement, this.inSubmenu = !1, this.triggerParent = HTMLElement, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            this._toggleMenu(), this._setDropMenu(), this._setSideMenu(), this._setKeyboardBehaviors(), this._setBreakpoints(), this._setView(), this._addARIAAttributes(), window.addEventListener("resize", ()=>{
                                this._setView();
                            });
                        }
                        /**
               * Define visual do componente
               * @private
               */ _setView() {
                            const i = document.querySelector("body");
                            document.querySelector(".menu-trigger") && window.innerWidth < 992 ? i.classList.add("mb-5") : i.classList.remove("mb-5");
                        }
                        /**
               * Define breakpoints do menu
               * @private
               */ _setBreakpoints() {
                            !this.component.classList.contains("push") && !this.contextual && this.component.querySelector(".menu-panel").classList.add(...this.breakpoints);
                        }
                        /**
               * Define ações do teclado
               * @private
               */ _setKeyboardBehaviors() {
                            this.component.addEventListener("keydown", (i)=>{
                                switch(i.code){
                                    case "Escape":
                                        i.preventDefault(), this.trigger && this._closeMenu();
                                        break;
                                    case "ArrowDown":
                                        i.preventDefault(), this._navigateToNextElment(i.target, 1);
                                        break;
                                    case "ArrowUp":
                                        i.preventDefault(), this._navigateToNextElment(i.target, -1);
                                        break;
                                }
                            }), this.scrim;
                        }
                        /**
               * Navega para o próximo elemento na lista com base em um operador.
               *
               * @param {HTMLElement} element - O elemento de referência a partir do qual a navegação será realizada.
               * @param {number} operator - Um operador numérico que indica a direção da navegação.
               *                             Um valor positivo indica a navegação para baixo, enquanto um valor negativo
               *                             indica a navegação para cima.
               */ _navigateToNextElment(i, a) {
                            const s = i.parentNode.closest(".side-menu.active") ? i.parentNode.closest(".side-menu.active") : i.closest(".br-menu"), c = s.classList.contains("br-menu") || s.classList.contains("menu-body") ? s.querySelectorAll(".menu-body > .menu-item, .menu-body > .menu-folder > .menu-item,.menu-body > .menu-folder.active > .side-menu.active, .menu-body > .menu-folder.active > ul > li > .menu-item") : s.querySelectorAll(".side-menu.active > .menu-item,.side-menu.active > ul > li > .menu-item"), A = Array.from(c).findIndex((F)=>F === i) + a;
                            if (A >= 0 && A < c.length) {
                                const F = c[A];
                                F.getAttribute("role") === "group" || F.getAttribute("role") === "tree" ? c[A + a].focus() : F.focus();
                            } else {
                                const F = c.length - 1;
                                c[a === 1 ? 0 : F].focus();
                            }
                        }
                        /**
               * Define comportamentos de abrir/fechar menu
               * @private
               */ _toggleMenu() {
                            const i = this.contextual ? this.contextual : this.trigger;
                            i && (i.addEventListener("keydown", (a)=>{
                                (a.code === "Enter" || a.code === "Space") && (a.preventDefault(), this.component.classList.contains("active") ? this._closeMenu() : (this._openMenu(), this._focusOnFirstVisibleItem()));
                            }), i.addEventListener("click", ()=>{
                                this.component.classList.contains("active") ? this._closeMenu() : (this._openMenu(), this._focusOnFirstVisibleItem());
                            }));
                            for (const a of this.dismiss)a.addEventListener("click", ()=>this._closeMenu());
                        }
                        /**
               *  Focar no primeiro item de nível 1 visível
               * @private
               */ _focusOnFirstVisibleItem() {
                            const i = this.component.querySelector(".menu-body .menu-item:not([hidden]):not(.inactive)");
                            if (i) {
                                i.focus(), i.scrollIntoView({
                                    block: "nearest"
                                });
                                return;
                            }
                            const a = this.component.querySelector(".menu-body > .menu-item:not([hidden]):not(.inactive)");
                            a && (a.focus(), a.scrollIntoView({
                                block: "nearest"
                            }));
                        }
                        /**
               * Define visual do menu aberto
               * @private
               */ _openMenu() {
                            this.elementOpenMenu = document.activeElement, this.component.classList.add("active"), this.component.setAttribute("aria-expanded", "true"), this.component.classList.contains("push") && this.component.classList.add(...this.breakpoints, "px-0");
                        }
                        /**
               * Define visual do menu fechado
               * @private
               */ _closeMenu() {
                            this.component.classList.remove("active"), this.component.classList.contains("push") && this.component.classList.remove(...this.breakpoints, "px-0");
                        }
                        /**
               * Configura Drop Menu para filho imediato de ".menu-folder"
               * @private
               */ _setDropMenu() {
                            for (const i of this.component.querySelectorAll(".menu-folder > a.menu-item"))this._createIcon(i, "fa-chevron-down"), i.parentNode.classList.add("drop-menu"), i.setAttribute("aria-expanded", "false"), this._handleMenuInteraction(i);
                        }
                        /**
               * Foca no próximo elemento
               * @private
               */ _focusNextElement() {
                            const i = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
                            if (document.activeElement) {
                                const a = Array.prototype.filter.call(this.component.querySelectorAll(i), (g)=>g.offsetWidth > 0 || g.offsetHeight > 0 || g === document.activeElement), s = a.indexOf(document.activeElement);
                                (a[s + 1] || a[0]).focus();
                            }
                        }
                        /**
               * Configura Side Menu para quem não for filho imediato de ".menu-folder"
               * @private
               */ _setSideMenu() {
                            for (const i of this.component.querySelectorAll("a.menu-item + ul"))i.parentNode.classList.contains("menu-folder") || (this._createIcon(i.previousElementSibling, "fa-angle-right"), i.parentNode.classList.add("side-menu"), i.parentNode.setAttribute("role", "none"), this._handleSideMenuInteraction(i.previousElementSibling));
                        }
                        /**
               * Gerencia eventos de cliques e interações por teclado no menu - tecla espaço
               * @private
               * @param {object} element - referência ao Objeto que fará a ação
               */ _handleMenuInteraction(i) {
                            i.hasAttribute("data-click-listener") || (i.addEventListener("click", ()=>{
                                this._toggleDropMenu(i);
                            }), i.addEventListener("keydown", (a)=>{
                                const s = i.closest(".menu-folder"), c = s.querySelector("a.menu-item");
                                s && ((a.key === " " || a.key === "Spacebar") && c && c.classList.contains("focus-visible") && (a.preventDefault(), this._toggleDropMenu(i)), a.key === "2" && this._toggleDropMenu(i));
                            }), i.setAttribute("data-click-listener", "true"));
                        }
                        /**
               * Muda estado do Drop Menu - aberto/fechado
               * @private
               * @param {object} element - referência ao Objeto que fará a ação
               */ _toggleDropMenu(i) {
                            i.parentNode.classList.contains("active") ? this._closeMenuElement(i) : (i.parentNode.classList.add("active"), i.setAttribute("aria-expanded", "true"), this.inSubmenu = !0, i.parentElement.querySelectorAll("ul li ul a").forEach((a)=>{
                                this.triggerParent = a.parentElement, a.addEventListener("keydown", (s)=>{
                                    const { parentElement: c } = a.parentElement;
                                    switch(s.code){
                                        case "Escape":
                                            s.preventDefault(), this._backMenu(c);
                                            break;
                                        case "Backspace":
                                            s.preventDefault(), this._backMenu(c);
                                            break;
                                        case "ArrowLeft":
                                            s.preventDefault(), this._backMenu(c);
                                            break;
                                    }
                                });
                            }));
                        }
                        _backMenu(i) {
                            i.parentElement.querySelector("[data-click-listener]").click();
                        }
                        _closeMenuElement(i) {
                            i.parentNode.classList.remove("active"), i.setAttribute("aria-expanded", "false");
                        }
                        /**
               * Gerencia eventos de cliques e interações por teclado no Side Menu - tecla espaço
               * @private
               * @param {object} element - referência ao Objeto que fará a ação
               */ _handleSideMenuInteraction(i) {
                            i.hasAttribute("data-click-listener") || (i.addEventListener("click", ()=>{
                                this.inSubmenu = !1, this._toggleSideMenu(i);
                            }), i.addEventListener("keydown", (a)=>{
                                const s = i.closest(".side-menu"), c = s.querySelector("a.menu-item");
                                s && (a.key === " " || a.key === "Spacebar") && c && c.classList.contains("focus-visible") && (a.preventDefault(), this._toggleSideMenu(i));
                            }), i.setAttribute("data-click-listener", "true"));
                        }
                        /**
               * Muda estado do Side Menu - aberto/fechado
               * @private
               * @param {object} element - referência ao Objeto que fará a ação
               */ _toggleSideMenu(i) {
                            if (this._hideItems(i), i.setAttribute("aria-expanded", "true"), this._showItems(i.parentNode), i.parentNode.classList.contains("active")) {
                                this._closeSideMenu(i), i.focus();
                                return;
                            }
                            i.parentNode.classList.add("active");
                            const a = i.nextElementSibling;
                            if (a) {
                                const s = a.querySelector(".menu-item");
                                s && s.focus();
                            }
                        }
                        /**
               * Fecha Side Menu
               * @private
               * @param {object} element - referência ao Objeto que fará a ação
               */ _closeSideMenu(i) {
                            i.parentNode.classList.remove("active"), i.setAttribute("aria-expanded", "false");
                            const a = i.parentNode.closest(".side-menu.active") ? i.parentNode.closest(".side-menu.active") : i.closest(".menu-body");
                            this._showItems(a);
                        }
                        /**
               * Esconde os elementos proximos a referencia
               * @private
               * @param {object} element - referencia ao Objeto que fará a ação
               */ _hideItems(i) {
                            for (const a of i.closest(".menu-body").querySelectorAll(".menu-item"))a.setAttribute("hidden", "");
                        }
                        /**
               * Mostra os elementos proximos a referencia
               * @private
               * @param {object} element - referência ao Objeto que fará a ação
               */ _showItems(i) {
                            for (const a of i.querySelectorAll(".menu-item"))a.removeAttribute("hidden");
                        }
                        /**
               * Cria icone filho a referencia
               * @private
               * @param {object} element - referência ao Objeto pai
               * @param {string} icon - nome da classe font awesome do ícone
               */ _createIcon(i, a) {
                            if (!i.querySelectorAll("span.support").length) {
                                const s = document.createElement("span");
                                s.classList.add("support");
                                const c = document.createElement("i");
                                c.classList.add("fas"), c.classList.add(a), c.setAttribute("aria-hidden", "true"), s.appendChild(c), i.appendChild(s);
                            }
                        }
                        /**
               * Adiciona atributos role=menu e role=menuitem com base na hierarquia dos elementos
               * @private
               */ _addARIAAttributes() {
                            const i = this.component.querySelector(".menu-body");
                            i.setAttribute("role", "tree"), this.contextual && i.setAttribute("role", "menubar"), this.component.querySelectorAll(".menu-folder:not(.drop-menu) > .menu-item").forEach(($)=>{
                                $.setAttribute("role", "tree"), this.contextual && $.setAttribute("role", "menubar");
                            }), this.component.querySelectorAll(".menu-folder.drop-menu > a.menu-item, li > a.menu-item").forEach(($)=>{
                                $.setAttribute("role", "treeitem"), this.contextual && $.setAttribute("role", "menuitem");
                            }), this.component.querySelectorAll(".side-menu > ul").forEach(($)=>{
                                const se = $.parentNode.querySelector(".menu-item .content").textContent.trim();
                                $.setAttribute("role", "group"), $.setAttribute("aria-label", se);
                            }), this.component.querySelectorAll(".menu-folder > ul").forEach(($)=>{
                                const se = $.parentNode.querySelector(".menu-item .content").textContent.trim();
                                $.setAttribute("role", "tree"), this.contextual && $.setAttribute("role", "menubar"), $.setAttribute("aria-label", se);
                            });
                            const A = this.component.querySelectorAll("li.side-menu > .menu-item");
                            for (const $ of A)$.setAttribute("aria-haspopup", "true"), $.setAttribute("aria-expanded", "false");
                            const F = this.component.querySelectorAll(".menu-folder.drop-menu > .menu-item");
                            for (const $ of F)$.setAttribute("aria-haspopup", "true"), $.setAttribute("aria-expanded", "false");
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/message/message.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(i, a){
                            this.name = i, this.component = a, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            for (const i of this.component.querySelectorAll(".br-message .close"))i.addEventListener("click", ()=>{
                                this._dismiss(this.component);
                            });
                        }
                        /**
               * Desvincula a instancia do objeto
               * @private
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ _dismiss(i) {
                            i.parentNode.removeChild(i);
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/modal/modal.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/components/scrim/scrim.js");
                    class b {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(a, s){
                            this.name = a, this.component = s, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            for (const a of window.document.querySelectorAll(".br-scrim")){
                                const s = new k.A("br-scrim", a);
                                for (const c of window.document.querySelectorAll(".br-scrim + button"))c.addEventListener("click", ()=>{
                                    s.showScrim();
                                });
                            }
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/notification/notification.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/partial/js/behavior/tooltip.js");
                    class b {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(a, s){
                            this.name = a, this.component = s, this.menuBtns = s.querySelectorAll(".contextual-btn"), this.hideEvents = [
                                "mouseleave",
                                "blur"
                            ], this._setBehavior();
                        }
                        /**
               * Esconde a notificação relativa a referência
               * @private
               * @property {object} action - Referência ao Objeto que dispara a ação
               */ _hideNotification(a) {
                            a.parentNode.parentNode.setAttribute("hidden", "");
                        }
                        /**
               * Esconde todas as notificações relativa a referência
               * @private
               * @property {object} action - Referência ao Objeto que dispara a ação
               */ _hideAllNotifications(a) {
                            a.parentNode.parentNode.parentNode.querySelectorAll(".br-item").forEach((c)=>{
                                c.setAttribute("hidden", "");
                            });
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            for (const a of this.component.querySelectorAll(".br-notification .close"))a.addEventListener("click", ()=>{
                                this._dismiss(this.component);
                            });
                            this._notificationTooltip();
                        }
                        /**
               * Define tooltip para a notificação
               * @private
               */ _notificationTooltip() {
                            const a = [];
                            window.document.querySelectorAll(":not(.br-header) .notification-tooltip").forEach((s)=>{
                                const c = s.querySelector("[data-tooltip-text]");
                                let g = "";
                                if (c) {
                                    if (g = c.getAttribute("data-tooltip-text"), g === null || typeof g > "u" || g.trim() === "") return;
                                } else return;
                                const A = {
                                    activator: s,
                                    placement: "top",
                                    textTooltip: g
                                };
                                for(parent = s.parentNode; parent; parent = parent.parentNode)if (parent.classList && parent.classList.contains("header-avatar")) return;
                                a.push(new k.default(A));
                            });
                        }
                        /**
               * Adiciona classe para refletir comportamento de fechar
               * @private
               * @property {object} componente - Referência ao Objeto
               */ _dismiss(a) {
                            a.classList.add("close");
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/pagination/pagination.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(i, a){
                            this.name = i, this.component = a, this.currentPage = 1, this._setBehaviors(), this._adaptSelectAccessibility();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehaviors() {
                            this._setKeybordBehavior(), this._setActive(), this._dropdownBehavior();
                        }
                        /**
               * Define o comportamento de algumas teclas
               * @private
               */ _setKeybordBehavior() {
                            this._setDefaultPaginationKeybordBehavior(), this._setContextualPaginationKeyboardBehavior();
                        }
                        _setDefaultPaginationKeybordBehavior() {
                            this.component.querySelectorAll("li *:first-child").forEach((i)=>{
                                i.addEventListener("keydown", (a)=>{
                                    var s;
                                    a.key === "ArrowLeft" && !i.hasAttribute("data-previous-page") && i.parentElement.previousElementSibling.children[0].focus(), a.key === "ArrowRight" && !i.hasAttribute("data-next-page") && i.parentElement.nextElementSibling.children[0].focus(), a.key === "ArrowDown" && (s = i.nextElementSibling) != null && s.classList.contains("br-list") && i.nextElementSibling.children[0].focus();
                                });
                            });
                        }
                        _setContextualPaginationKeyboardBehavior() {
                            this.component.querySelectorAll(".pagination-per-page .br-list").forEach((i)=>{
                                i.addEventListener("keydown", (a)=>{
                                    a.key === "Escape" && a.currentTarget.parentElement.focus();
                                });
                            });
                        }
                        /**
               * Define visual do componente
               * @private
               */ // eslint-disable-next-line complexity
                        _setLayout() {
                            const i = this.component.querySelector("ul"), a = this.component.querySelectorAll(".page");
                            if (a.forEach((s)=>{
                                s.classList.contains("active") && (this.currentPage = parseInt(s.innerText)), s.classList.remove("d-none");
                            }), this.currentPage === 1 ? i.querySelector("[data-previous-page]").setAttribute("disabled", "") : i.querySelector("[data-previous-page]").removeAttribute("disabled"), this.currentPage === a.length ? i.querySelector("[data-next-page").setAttribute("disabled", "") : i.querySelector("[data-next-page]").removeAttribute("disabled"), a.length > 9) {
                                if (this.currentPage < 6) {
                                    i.querySelector("[data-previous-interval]") && i.querySelector("[data-previous-interval]").remove();
                                    for(let s = 7; s < a.length - 1; s++)a[s].classList.add("d-none");
                                    i.querySelector("[data-next-interval]") || i.insertBefore(this._createIntervalElement("next"), i.children[i.children.length - 2]);
                                }
                                if (this.currentPage >= 6 && this.currentPage < a.length - 4) {
                                    for(let s = this.currentPage - 4; s > 0; s--)a[s].classList.add("d-none");
                                    i.querySelector("[data-previous-interval]") || i.insertBefore(this._createIntervalElement("previous"), i.children[2]);
                                    for(let s = this.currentPage + 2; s < a.length - 1; s++)a[s].classList.add("d-none");
                                    i.querySelector("[data-next-interval]") || i.insertBefore(this._createIntervalElement("next"), i.children[i.children.length - 2]);
                                }
                                if (this.currentPage >= a.length - 4) {
                                    i.querySelector("[data-next-interval]") && i.querySelector("[data-next-interval]").remove();
                                    for(let s = a.length - 8; s > 0; s--)a[s].classList.add("d-none");
                                    i.querySelector("[data-previous-interval]") || i.insertBefore(this._createIntervalElement("previous"), i.children[2]);
                                }
                            }
                        }
                        /**
               * Cria elemento no intervalo
               * @param {string} type - nome do tipo do elmento
               * @private
               */ _createIntervalElement(i) {
                            const a = document.createElement("li");
                            a.setAttribute(`data-${i}-interval`, "");
                            const s = document.createElement("a");
                            s.setAttribute("href", "javascript:void(0)");
                            const c = document.createElement("i");
                            return c.classList.add("fas", "fa-ellipsis-h"), s.appendChild(c), a.appendChild(s), a;
                        }
                        /**
               * Cria ação de clique na página
               * @private
               */ _setActive() {
                            for (const i of this.component.querySelectorAll(".page"))this.currentPage === Number(i.innerText) ? i.setAttribute("aria-current", "page") : i.removeAttribute("aria-current"), i.addEventListener("click", (a)=>{
                                this._selectPage(a.currentTarget);
                            });
                            for (const i of this.component.querySelectorAll(".pagination-ellipsis .br-item"))i.addEventListener("click", (a)=>{
                                this._selectPage(a.currentTarget);
                            });
                        }
                        _initializeDropdownItems() {
                            this.component.querySelectorAll(".br-list").forEach((i)=>{
                                const a = Array.from(i.querySelectorAll(".br-item"));
                                a.forEach((s)=>{
                                    s.addEventListener("keydown", (c)=>{
                                        const { key: g } = c, A = a.indexOf(s);
                                        switch(a.length, g){
                                            case "ArrowUp":
                                                c.preventDefault();
                                                const F = (A - 1 + a.length) % a.length;
                                                a[F].focus();
                                                break;
                                            case "ArrowDown":
                                                c.preventDefault();
                                                const $ = (A + 1) % a.length;
                                                a[$].focus();
                                                break;
                                        }
                                    });
                                });
                            });
                        }
                        /**
               * Cria comportamentos do dropdown
               * @private
               */ _dropdownBehavior() {
                            for (const i of this.component.querySelectorAll('[data-toggle="dropdown"]'))this._dropdownInit(i), this._dropdownToggle(i);
                        }
                        /**
               * Cria ação de clique no dropdown
               * @param {object} element - referencia ao objeto DOM
               * @private
               */ _dropdownToggle(i) {
                            i.addEventListener("click", ()=>{
                                if (i.getAttribute("aria-expanded") === "false") {
                                    this._dropdownOpen(i);
                                    return;
                                }
                                this._dropdownClose(i);
                            }), window.document.addEventListener("click", (a)=>{
                                this.component.contains(a.target) || this._dropdownClose(i);
                            }), i.nextElementSibling.addEventListener("keydown", (a)=>{
                                if (a.key === "Escape") {
                                    this._dropdownClose(i);
                                    const s = i.parentElement.querySelector("button");
                                    s && s.focus();
                                }
                                if (a.key === "Tab") {
                                    const s = a.currentTarget.querySelectorAll(".br-item");
                                    s[s.length - 1].hasAttribute("data-focus-visible-added") && this._dropdownClose(i);
                                }
                            });
                        }
                        /**
               * Inicializa elemento de dropdown
               * @param {object} element - referencia ao objeto DOM
               * @private
               */ _dropdownInit(i) {
                            i.parentElement.classList.add("dropdown"), i.nextElementSibling.setAttribute("role", "menu"), i.setAttribute("aria-haspopup", "true"), this._dropdownClose(i), this._initializeDropdownItems();
                        }
                        /**
               * Ação de abrir dropdown
               * @param {object} element - referencia ao objeto DOM
               * @private
               */ _dropdownOpen(i) {
                            i.setAttribute("aria-expanded", "true"), i.nextElementSibling.removeAttribute("hidden");
                        }
                        /**
               * Ação de fechar dropdown
               * @param {object} element - referencia ao objeto DOM
               * @private
               */ _dropdownClose(i) {
                            i.setAttribute("aria-expanded", "false"), i.nextElementSibling.setAttribute("hidden", "");
                        }
                        /**
               * Define página ativa
               * @param {object} currentPage - referencia ao objeto DOM
               * @private
               */ _selectPage(i) {
                            this.component.querySelectorAll(".page").forEach((a)=>{
                                a.classList.remove("active"), a.removeAttribute("aria-current");
                            }), this.component.querySelectorAll(".br-item").forEach((a)=>{
                                a.classList.remove("active"), a.removeAttribute("aria-current");
                            }), i.classList.add("active"), i.setAttribute("aria-current", "page"), this._setLayout();
                        }
                        _adaptSelectAccessibility() {
                            window.addEventListener("load", ()=>{
                                this.component.querySelectorAll(".pagination-per-page .br-select .br-list").forEach((i)=>{
                                    i.setAttribute("role", "menu"), i.querySelectorAll(".br-item").forEach((a)=>{
                                        a.setAttribute("role", "menuitem");
                                    });
                                });
                            });
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/scrim/scrim.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        constructor(i, a){
                            this.name = i, this.component = a, this._setType(), this._setBehavior();
                        }
                        _setType() {
                            this.component.classList.contains("foco") && (this._type = "foco"), this.component.classList.contains("legibilidade") && (this._type = "legibilidade"), this.component.classList.contains("inibicao") && (this._type = "inibicao");
                        }
                        _setBehavior() {
                            if (this.component.classList.contains("foco")) {
                                this.component.addEventListener("click", (a)=>{
                                    this.outsideclick = !0, a.target.classList.contains("br-scrim") && this.hideScrim(a);
                                });
                                const i = this.component.querySelectorAll(`[data-dismiss=${this.component.id}]`);
                                for (const a of i)a.addEventListener("click", ()=>{
                                    this.component.classList.remove("active");
                                });
                            }
                        }
                        hideScrim(i) {
                            i.currentTarget.classList.remove("active");
                        }
                        showScrim() {
                            this._type === "foco" && this.component.classList.add("active");
                        }
                    }
                    const b = k;
                    for (const m of window.document.querySelectorAll(".scrimexemplo button"))m.addEventListener("click", ()=>{
                        const i = window.document.querySelector("#scrimexample");
                        new k("br-scrim", i).showScrim();
                    });
                    for (const m of window.document.querySelectorAll("#scrimexemplo-big"))m.addEventListener("click", ()=>{
                        const i = window.document.querySelector("#scrimfocobig");
                        new k("br-scrim", i).showScrim();
                    });
                },
                /***/ "./src/components/select/select.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia o componente
               * @property {string} name - Nome do componente em minúsculo
               * @property {object} component - Objeto referenciando a raiz do componente DOM
               * @property {string} notFound - (Opcional) String contendo código html para informar que a busca não encontrou nenhuma opção.
               *                                Se não informado, será usado um código html padrão.
               */ constructor(i, a, s){
                            this.name = i, this.component = a, this.notFound = s, this.multiple = a.hasAttribute("multiple"), this._setOptionsList(), this._setBehavior();
                        }
                        /**
               * Retorna os valores dos elementos selecionados
               * @returns {Object[]} elementos selecionados
               *
               */ get selected() {
                            return this._optionSelected("value");
                        }
                        /**
               * Retorna os elementos selecionados pelo inputValue
               * @param {Object[]} elementos selecionados
               * @returns
               */ get selectedValue() {
                            return this._optionSelected("inputValue");
                        }
                        /**
               * Retorna os elementos options selecionados
               * @param {Object[]} elementos selecionados
               * @returns
               */ _optionSelected(i) {
                            let a = [];
                            for (const [s, c] of this.optionsList.entries())if (this.multiple) s > 0 && c.selected && a.push(c[i]);
                            else if (c.selected) {
                                a = c[i];
                                break;
                            }
                            return a;
                        }
                        /**
               * Remove o elemento que indica item não encontrado
               * @private
               */ _removeNotFoundElement() {
                            const i = this.component.querySelector(".br-list");
                            i.querySelector(".br-item.not-found") && i.removeChild(i.querySelector(".br-item.not-found"));
                        }
                        /**
               * Coloca o texto Item não encontrado no select
               * @private
               */ _addNotFoundElement() {
                            const a = `
      <div class="br-item not-found">
        <div class="container pl-0 pr-0">
          <div class="row">
            <div class="col-auto">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABCCAYAAACl4qNCAAAABHNCSVQICAgIfAhkiAAAGMxJREFUeF7NXQl8FOXZf2bPbLKbbLIJARJChEQSCFc4IqAY/CiIgMZardYD0R9SW/3EVlAkSoAPQaAai1awleKnrVYR0wattVKxthWUI4AYCCEkMeQix26OPWdn+jwzzGaz2WM22YDv78dv1sx7/+e5n/eVgctU4mesH+9WqlZyttaZjEIdxznNsTzn1oDbYVaoY5qAUdWDSnuKc3Xtsh7fcewyTet7Owwz2DPT5z72Y85lfRrHmSB3LIZh6kAdvZ9RGbd0HSr6Vm67cOrlN5/S1/9m92xQKrN5HjI4u2OY22ZLUGg00YxaFc27ORfPslZ1QnwrA0wb73ZdAKX6qzFLbv5b6fCpVjljGQv+mg7ApptLFh+QU9+7zqABE59XNMHpbHuDZ22Twp1UrwlqYv+mYJSPdR7ecmYg/UypPxzt+PM/7nS0mhdxVnueu7t7eH/7U8UZWhil8jgDijcr1m56I1A/xoIPjApQFwPw5raSxSvCGW9QgDHkrbnWbWv5K/CcPpzJBK7Ls0qdaR/HxP60+9CapnD6zHn7tZmu2gvPuFra5nJOpyqctrLqKhiLIipqP+eyb6/etiMoZRAFmUsWVMvpN+LARI+9ewHPqN9DORIjZwLh1EEWZ2FUmuVdR1/+U6h241/91TJbQ8NK1tKZGapupN5zTtc3mnjjjsrnXnjFX58JBft249/b20oWPR5qzIgCo8+4eyyvi/mSBz421MD9f89zjEb/VvfiF5dCEcP59jPhzR13Wc9VbWLbLSP7P8bAWqKcatEMSXz59Mq163x7QnBWIDDI3oKXSAITFTNheQXPcyNCDRqJ9wqlujIqKfv6lr8/Wk/9TXt/16iOqu/2OurqJ0ai/0j0gbKoQpuaes+ph1Z87dufqaC0oLVkcUmgcSIGjGHaqp1ue/tDkViQ3D4Ynm9TqQ3zRzycPtVWXVOMAl0rt+3lqsdo1G5NcuIjZ54o2uE9ZkJBKVENKQVF/uYSEWBiZzyewXZ2fAsoWC7XgqVx4iZqWa3JFXmhHuGFaFNSnjmz6tn/6w1OYLYWEWD0k/+3hGNtt0R4LUG7Y5QAcRMUoIm/nKMOaCxek2haWfHMc7+S08uAgYkf9VCc06Bs4jm2/2yERxnOKFDdxyfvBkDC4912YJRR+HTiKyIIVCnQEhR+M06InxIF6kFUMeRsXrh1cPqsOinhtspnNv1Famss+HCSkuGLWj9YVODd34CBiZ35TCHb2bgh3En2AoG1oUdGh39yCQChpS38ZpTaXgCBQgmEizFXBWrDgKce9pQj0YBRKDrxA5tQXbyjWuqP1GgOmGJzycIy6W8DXl3M5EeP86xdtrtFogQgEBAAAsIDggSQQCVIQYDveARIgQCxVlBoo8E4GZBS6J1Ymkv/JnTjvNgKQxbNA01SYiT2b1D7UETryqo2FeNKApcBAxOd84ADP21NsEF4ZE+oQeE+K5ECqDqxKJFVeQAS3iEgRCUCQFiHqIaEiQCgC9mXDtRxvUcyHzwM5kNHEDQNpC79CT77z1EHFQ2fznWpw58tX7nWw2nIfQOgQc+ASDUDAkY//dnbOVvDuwEXxLEIhkoEgxQ2kh9UpL8FBKg3eDznhLjxGohK7qEUaczGPX8BtqMT2M4uGHrbYohK7bcL7HLiAoxW27bk+ZeSihjRSCZ3jZJhd7d+sDh/4MBMeeIVzmn5mb8VEZWQHCFARApAGSJQCxIXRwARBV0CzQMQUguBSVLGi4KihrIQO9Y/URIoRC30VMcbcRwVcA5HnykRJaG3WHj/fSnapMQnzxRu3CLNB22bIsmuGRDFGPJWf+i2ttzUa6E+VIK6VHgAscjiVMiOqB+GAaVeCQnTkJ3hf9OmSptLT6mgjwoBR6VBSezQDfTfvMsFbpsdbk1pgHP/PAa1bTzE58+AC7oMT70rzfbwgzpXtWV7hr8PZUDA6HNXfMu5urOljkUqQXmi0PSmEoGNcaTwhqYgFqmK5AvKIFAwYLoGf7s6PJup1NE7Djg7vVcA+qWQWjoAPbwC1TBqtaA4EFDZfCN8ev2/waxkIP0xpF5crXbeYlDqtCLlcJzQTqHBNleIkniNbkrN1uKj0h5KrpqBATP9qUaMSCZ7gEHhTewJlV2BJfUI8ktsTAZAInjEjixgGBsDSlUbgop/ww0XVGyyd6jgb84lUg2BRF8/UYwgwhA8VUw0zNPVwG+zDqAlqoD8jRx8fpKHmKxMiMkcDUp8T0VtjBUoTGWIUIQiTD6p1Ol+d25z8TIPMLeWHnDzbMGAgNGNW9KJm6jn8cujzfQYhYI2JW6gByCPwSgpAv4oCKmAYEWqURvdEDtGATkoa0ZpUXsjuYNUIPRJGp74C4OKGvHvgnrduyidnbAx+22o6GBh8moOpmapICV2InS53KCMMwhs8UxSAnAom4gSrwTVKPUxp85tfCHHA0zBh/cj3ykbEDDROQ/akX1pySAU7RGiEi82JgOgHhmEwLqsuOkIssoOxglINVYrfJU9AeKQ3fSnvHrwIOz8+mNIT0awkZjKqnioWVkEIzdvBguxQiw3T5wAh3OuFijuSoCDMtFR8/Lv+ixwYMCMX8b7szn6GoxEJaI2FJiCiP05UcY7wJRHcqVTYDFnJk7rDyZCm5ONjXDdjh6nbprRCCdWrIBFu3fDv6qrhTr35ObCJ6nJaB8ZBPZ2JRQClckws/LZbV9KCyU3zYCA0Y27vxv5V7Rfg9Hbou/l9xLlgK8M4pxdAmsyZCkgOlUHbFc3sOYOODN5ugcY+tL33X8/rP74Y1iYleXZ3D/ceWdA8D48fRqIcojqnsrPh/FDh/YB5q2jR8H0g3zQjUi5IrImZlTa3aceW/NHDztDORMeMPmfqeKY47cwLDvBbW8eynY13IeUgMwZ1VT82kXfFtkqZI+gnPF1uQQASAAK1WTtEHJOirqEo6EJ++DgdE6uZ9Npk69NTxcogb5+qXj/lkNevhRDwOiuSoPEufmgjNbJ6SKidXTpIx4vf7zQE9U03bqvRBYwyfcej7FV7dvhtjX9kHfZRHWGNlPYaNEoFEDo5XIJDpDodEDej0BSiRrConPSJAhkKi6zRVCLy7Nku+Fkb5Y3MHdePRo+rDwHDpNJ8BxQ8WZnl8MoVekNxZUbt/XKAwgJTPycV2e5rLWlnLVFjHwgCJJK29vvdckoFFbma9Ff8ntJFITUQSAS63JbWyE6TYeWvcGzIW6rDeWLU6CYG8uroBMteQMKZ3qqUSV2oREplcSYGGjp7oZ2m02gIjtZ9/jSiXWkNlQ3JS4OHPiuA4W+mf5ZzPCYrRXeRUN0TzdAXoIS6hbfLthA5Ekg1ZvYqUofI8g6snXIeKW/R1p70yQlbK4o3LRaWhO5Z4ICY7rh1RRHW3k557YZeqhEVHd5oNiJaHP0ACS5XC5Z5cI7icUhGAxZ7na0UdrxN7I/dNXEjI6CmBF6wdCTFk7sRPpSq1/aKZsSwqm4DFe+Fh2ibozpzGoAqENn95QFM6DBlCoYrQJHQNBIDZc8CgTSYICjHzf24W8eesyjpZhCyRj9tFUnOXu7R8cWJuvxeyEbI3c8L36hvYNbIkAEgmAs4pNn0fikisj+WEsN6NKG4z8NqHRiNFraDKIU0RoXN+e73/5/OPstu+56nMtSBIbyeW5vBTiEVDPdxMC53OtRQ+uJwBHVkhpN7h16DoZarRuZdlf5L9a8I00+qIwxzt2x1Nl0ZFevlaK7RbAzBMck+bTwK7/k26KnwMLoSa4ZpAjMA0M20CUoAgqNAdzdTaBO0ELqyGnAMX7c82Q4kt9ECBGgwYibsvPn46Cx6aIwDT2yLSpdyLqoDE0eAl3Ibs7X1MJVI9OEv3vXoffnzldDclKSUJ/qJSWaYNOWX0Nq+Wn4HeoPbdjltZhn04EMYNykBWA1TRQUADEehLLO3gUXvz1AnySoVGqImpyAXgUMPyRELqZtys0deWTJ8lrvvQ7IyvTXFB7hupt6VCKamuC+v+SdJQ+xUgRIMC7R/qBN5Z0W+vyRDXQJHmUOrW+VwYguew7ZViKCYwGn4wHZX/aZ7aMhPt4nCCO7tf+KM/MXwqGvj8G9SJTnVQpoww8AUORVj1oGuoy+qQuWL1YD23JS6GzI+DmgnpQUMR+bKtbQXLlhm8etJc3YLzBjbz+lqan4jQ1V4F5+Dg8bw2iiGKOnjxuVAaQKRh0t+LcE1uWyoJZlAE1iFGiTdKAx6QWZQU5GEuwubrnsrW16M1cgokiWG268DT7/QrTnpuai5X/0hPDbOO91NDL77BF4A5MwOg8gVQX67MyIGKPqBOP+s2ufnyutTwoz+11y0k8OZnaffL2i12aQdxhZEh6TELzHVIhVsZ11+IsFXWoqUoYDooab0M+F3lqf3aQYCWk3rnYz1n5Y9j4PBjCz594C//5SzMGbOmUyHC2/ADHjl4Fm+Ay/8+oFTNoUaG84ASMevDsiGlpUyrDlp1cVveYB5tbSsrYPFvu3/OOv27rQYa7Y5z1LohZM6BNZGcoQztYC0VeNQKOQR1AScJLBP2uiGBKgrtZ2YBV+Y2t+N2UwgJFYGQ2YPX4qNGcUBf1QfIFpqz0CKffeMWAXDio55qrNxbh5jOSVFSKZlHjudzcTF72Ta63Zf4RmS3JFVHkp7lEDSm0MRKUAGLKHgzJKdK/ILc4WVH+wtB8JmiLQq7vOw1v7UJ/c8QLV86aYUaMzoEHd4/bx14a1VKHMFBWO+GgeLtZ+AylL7hQ0R19PgfNiC6DcQLbuFJ7BiibJ9FpF4XMevk5xf3PJrWZq4xeYoUuPJlkOFTcTIFJhLedBn2EEQ04agtPXxR5qs0i2UECLxedFymyRWdiuC4MKzDXTc+HgV544VchZpYy4Ci58d14ARlKfpUb2unpofL9UAIRAG373jwL3p1B2q5JSr6p8+mlB5RTO0jCqA8TGAgJDL3RZd7dwzg4T/kP10AmmWZkoQ/rvRyJg3OjGZzu6MOXo45Ab4PkgBgEYb1Y2NXciCv/jsucjAUObTsE1b08AydG63/9RoBZj3hQwXjM1YL+YNLIOTwMUSRXoFAD9lk4CCBQjHQ3wPiKgn/b0HmfTodvUqOsnzh4dUoaEWhlNmkAhA3LNQvnq8sO3TxtUirnu2hlwx4NPBp3+S5sLofLMN0KdURnZUFVZ7mFl3mFpYmONe0o9mTpDFs/32y/aQHVnn92U5i1bfCsKwJgwasbxfCEqUv9CxO4XSGv2psmgqDpqnBg+2/I3G0ovouJsboEPNr8VCkfP+7x0lG8B9OWyE9/A/yy4HVovlPvt7423/gRvvPUu/OPj93u995YxeXlT4YXX/xp0Po8svQWOff0foU7mmBw4iyANu/OHaAbEh+03I71Jmzr0+oqn1v1LGtRYUJrve05TopjddEAU118pATPm+Y1z7HW1n6K5MmBkiFqI5B2NzWiYaeG91a9GBBjqpATZYsHiG/32Z0YPddmJU5A/e2ZAYGbNuga27CwNGxhJxoTr1DQf48Bljb2v+/Cv3hQIQMhd5oqlfDJpIr1YmfdhmozCXzbhVz5E9g4GqUiqMtkwJGNI1uzdsFt2t8EoxreTA//8j0BdI9NSIX1k4PNT3hQza9YMBMaT4+13Xv4oRlKXwwGmo5wHewOPjvWoz7rKtt9Ag5H4QG9cie/ZTP+W//bNW62V55+QvXsyKkqufHe3Fd4vel1GC7GKHGCIMqbMnAfVNd95+t2180VYcs+P/Y7jLfynoIH56zc+CZ9i0I4hf5nceI0EijAQBrKs3+wiZ5uYeOCn+AVm1FMrzJzNFlEHFbEzBzkj8Yveu/73EQfm8VVrEYg7BEohuZI+MjUgMN4UM3fuDbCuOPhZW38Uk/qAaPnLiXh2nubBVu+xIcW1M+5brCd2BSTVPsBM/P2vf2gpO9VbWsrexsAVSfgT1ZDHeM+zv5XdoxyKkd3ZpYreFJOXNw2F/0dhUwwJf8pJC5a8gdF2sJxEmYJ+Xd+CeRJbu8u2r5JNMVdvWPOas6XFk4AW7qID1RdYGUYOyS0TaVYW7hy9nZj9ZmV+DEzvedibeOiqwHAinTbxU1DOvItyxj+vJYKiaJm3RpC1bf179u8uBDFZw92GnvquNvSToYyJNCsLd0berOz666+D517ZGzbFjFh2n182Ro73ztNIJYJjJXDBWzW+6D65c3ZAivEFJvvFjR/Yqmt7HTsLd+H+6gsGJrIzSrDYUyg/XDzYrKy/FJP20/t7Wf0EiLUata5GH1kSYPOU0YkfdR7atDAgML7XaFy9/umdztbWsI+Ft33+HzzNZQL7hQZImD2jF+8lUKREcMo3vtLAeLOy/soYEv5k9XNuLXSf48FxUR4gEhCKmKEvdx3c8KhsGZO1df0j9roL28OlkpZPPoOu8gqP887bs0oqJSUxkKr8fZAx06+dD0eOiRHJ/mplI5Yvh+7zol3Sn6IakntXx/6HPXF+3z4YOiyDhxHQwBGPmOWfPx9V85sXLLzTKd83j+3oZBdRCxU6cucLjGRgkoPvSgv/SAATnbMEJXRYW+TZe4VGzyaOv9lQvXtOYDuGrH3EfJL3DQ2ZRas+cbVbfhDOl9D17RkBDHLk6ceO6ZM0R5QiHCrC55VWl71Z2fTpU+HFXeH7yqLG3CUko3hyIMLYLJUx88uOL1b19hP5tBfsGF85M+b5wjH2uqaTmCkSsZsuSPBTAp1CrYqoryyM/fBU9bZjbr55ITz53O6g3fgzMHXjlvYLFMpc1abPn4+EENTdEDAenLlxzeuu5hb5/vkQO0Qpr8TGKC3ovacj58TsDzDe6vKCBfOhcGtwb7c/YIhikCWFPbzalHXccuCXIS/X8wCTcCkJwGukqIxnnqjDzBZT2KP7aeCx/PFdOFpZZmwTmEwJkZiCp4/4YWOgAzN2qNx0042wZovg6A1YIkUxiqh4u370rdmN78yoDrWgHmBQCUCjp7q1ZKGHrq9a8/h0sNo/xWzE4MHrUKPgeymCGa53+Z5FUwRvcagiRRZD1WNRQ6QkQSpulHm5194IDz26Jnxgxi4RT2DLLMTClPHZSzo++7ms1NKQGVuji56c6e7o/ARXMaAb+0hldmKGDD3D0cpm5YhZlKGKFMAKVc/3/QM/WwkP/iygy0qoHgmKUSdPWG359NHNcufXBxgxPuDaLWVrUEc5L27Itrd3/oW1WPwefZYzmBSTcba2heWS+ef+j4SIob/yUck70Fgvuvr9AUObHqrMvmEBZGaND5tiojEPTW5RGkdu6/yiMPRkvDrsA0ygiBq1ydq27mV03S/nneHfDyYZmS48JRaOjAm2+CW3zfHE4tPSR0Nt9TkwzpwuXMTg7uqC0lf+LHfvBgUYgX1pTes7Dq1bG+5E/LKyYLed5hRvTHZYbZvwVtY7wmVvUtLfjOQMiLVgCGAApbPD4qEkt5uFE0cPCb0lF9wknm/Bc/sTjSkwnB/Y3TIOhx1OnRBS7ISE+rLDYmptKIphlGqX0jRuacf+n/+hP8sMKmPElBomjgPnS96sjQZacPastmbfuw852s33smZLLoZ0ZWX/ucxmwW9W/9Z7/ZlvyDbSfTKkBVqra6HtH1+EbNOfCsGAUeqHN2uTx93UUnKHiGg/SkjhTxk0GN0yB7tYc17j8ZiGvZ/c4Wgz34JG5GSMfqb5m4t3GLb+D3tAyszsx7z9NpGS7MgDISQYIjiNe/dh0ntP4qJ3Q0Ybj1eipAjZpm7zWdnTYKISQJd5W5/6eLqhWxWb/pLl818EV/NkjBQSGO8+6EANZtO0Y/LAulAXO2duWL2IYd0LkM3McXf2XGsi9UceZ7pjTCrkrhHYBV0jgrdgcHiaS3qKV5D0EKR0qst3fQSIb1oqnTAghYP6onbOdgVYayl6hTnYeLmQQiseUuKszTK2S6yi0JmEs6dSQbXZjWC9x3DsI51fbepZlOwe+1YMCxhqTsoBZodVE2uTLnhGoJDVBb6Be8HZg7HVHx/4KbKwH7Ft7dNYS8cApty/phRJpNh7uO75YKMhIKwyZtinamPaL1o/vM9/clv/pjuw+8pEoErz8RhGma8MCjSfPASJr2u8y15V+2NXV/cMW1V1/669CGPBlAjRXYlh3p4Lm8Jo3beqQhNzSqE2vKPL/NGLTW9OFK3VCJewKSbC48Oc82Xz2786ci/vcM5zNF9MwrB2xIZwtCIgeE0JK3pfBlSUUabT+H/o2KtwXNxlObL93IA6k9H4igPjPcc5NWXjUIbd6LhQv9je0DwVlYUYcnxSKIGKHNDo2gCFZjiYj9WFjLsH2h/UqlCGRHUoVNHHeIXm7zHJ03bWvz1VnMRlKt8rYHzXnF93PJVnmfFoQEzCsz14EwMzDEHT2OsbNXgAyum2Odqs56tsaoOh1tGm1LJdw9pdzkkuRqUfhflro7Hd1e7uRk82KV7hhQ6yntv/MJbSiZpZG9onuOmuemVcxmHgmQoVz59sfHv6qcuEgd9h/gsitjFaPKd5sQAAAABJRU5ErkJggg==">
            </div>
            <div class="col">
              <p>N\xe3o encontramos o que voc\xea est\xe1 procurando!</p>
            </div>
          </div>
        </div>
      </div>
    `;
                            this.component.querySelector(".br-list").insertAdjacentHTML("beforeend", this.notFound ? this.notFound : a);
                        }
                        /**
               * Cria listagem de elementos do select
               * @private
               */ _setOptionsList() {
                            this.optionsList = [];
                            for (const i of this.component.querySelectorAll(".br-list .br-item"))for (const a of i.querySelectorAll(".br-radio input, .br-checkbox input")){
                                const s = {
                                    element: i,
                                    focus: !1,
                                    inputValue: a.value,
                                    selected: !1,
                                    value: a.nextElementSibling.innerText,
                                    visible: !0
                                };
                                this.optionsList.push(s);
                            }
                        }
                        /**
               * Reseta estado da lista
               * @private
               */ resetOptionsList() {
                            this._unsetSelectionBehavior(), this._setOptionsList(), this._setSelectionBehavior(), this._setAria();
                        }
                        /**
               * Define o comportamento do componente
               * @private
               */ _setBehavior() {
                            this._setSearchIcon(), this._setDropdownBehavior(), this._setKeyboardBehavior(), this._setSelectionBehavior(), this._setFilterBehavior(), this._prepareComponent();
                        }
                        /**
               * Define o comportamento de dropdown
               * @private
               */ _setDropdownBehavior() {
                            for (const i of this.component.querySelectorAll('.br-input input[type="text"]'))i.addEventListener("focus", ()=>{
                                this._resetFocus();
                            }), i.addEventListener("click", ()=>{
                                this._openSelect(), this._resetFocus();
                            });
                            for (const i of this.component.querySelectorAll(".br-input .br-button[data-trigger]"))i.addEventListener("click", ()=>{
                                for (const a of this.component.querySelectorAll(".br-list"))a.hasAttribute("expanded") ? this._closeSelect() : this._openSelect();
                            });
                            window.document.addEventListener("click", (i)=>{
                                this.component.contains(i.target) || this._closeSelect();
                            });
                        }
                        /**
               * Define o comportamento de teclado
               * @private
               */ _setKeyboardBehavior() {
                            for (const i of this.component.querySelectorAll('.br-input input[type="text"]'))i.addEventListener("keydown", this._handleKeydownOnInput.bind(this));
                            for (const i of this.component.querySelectorAll(".br-list"))i.addEventListener("keydown", this._handleKeydownOnList.bind(this));
                        }
                        _prepareComponent() {
                            const i = this.component.querySelector(".br-input"), a = this.component.querySelector(".br-input .br-button"), s = this.component.querySelector(".br-list");
                            s.setAttribute("id", `list-${Math.floor(Math.random() * 1e4)}`), s.setAttribute("role", "listbox"), s.setAttribute("tabindex", "-1"), s.setAttribute("aria-label", "Lista de Op\xe7\xf5es"), i.setAttribute("role", "combobox"), i.setAttribute("aria-expanded", !1), i.setAttribute("aria-controls", `${s.id}`), i.setAttribute("aria-autocomplete", "list"), a.setAttribute("aria-controls", `${s.id}`), a.setAttribute("aria-expanded", !1), a.setAttribute("aria-label", "Exibir lista"), this.component.querySelectorAll(".br-list .br-item").forEach((c)=>{
                                c.setAttribute("role", "option");
                            }), this.multiple && i.setAttribute("aria-multiselectable", !0);
                        }
                        /**
               * Retira o comportamento de teclado
               * @private
               */ _unsetKeyboardBehavior() {
                            for (const i of this.component.querySelectorAll('.br-input input[type="text"]'))i.removeEventListener("keydown", this._handleKeydownOnInput, !1);
                            for (const i of this.component.querySelectorAll(".br-list"))i.addEventListener("keydown", this._handleKeydownOnList.bind(this));
                        }
                        /**
               * Verifica a navegação
               * @param {object} event evento que foi ativado
               * @private
               */ _handleKeydownOnInput(i) {
                            switch(i.key){
                                case "Tab":
                                    this._closeSelect(), this._resetFocus();
                                    break;
                                case "ArrowDown":
                                    i.preventDefault(), this._openSelect(), this._getNextItem().focus();
                                    break;
                                case "ArrowUp":
                                    i.preventDefault(), this._openSelect(), this._getPreviousItem().focus();
                                    break;
                                case "Escape":
                                    this._closeSelect();
                                    break;
                                case "Enter":
                                    this.component.querySelector(".br-list").hasAttribute("expanded") ? this._closeSelect() : this._openSelect();
                                    break;
                            }
                        }
                        /**
               * Define comportamentos de teclado na lista
               * @private
               */ _handleKeydownOnList(i) {
                            switch(i.preventDefault(), i.key){
                                case "Tab":
                                    this._closeSelect(), this._resetFocus();
                                    break;
                                case "Escape":
                                    for (const a of this.component.querySelectorAll('.br-input input[type="text"]'))a.focus();
                                    this._closeSelect();
                                    break;
                                case "Enter":
                                    this._setKeyClickOnOption(i.currentTarget);
                                    break;
                                case " ":
                                    this._setKeyClickOnOption(i.currentTarget);
                                    break;
                                case "ArrowUp":
                                    this._getPreviousItem().focus();
                                    break;
                                case "ArrowDown":
                                    this._getNextItem().focus();
                                    break;
                            }
                        }
                        /**
               * Define comportamentos de teclado no option
               * @private
               */ _setKeyClickOnOption(i) {
                            for (const [a, s] of i.querySelectorAll(".br-item").entries())if (this.optionsList[a].focus) for (const c of s.querySelectorAll('.br-radio input[type="radio"], .br-checkbox input[type="checkbox"]'))c.click(), this._sendEvent();
                        }
                        /**
               * Envia o evento onchange
               * @private
               */ _sendEvent() {
                            const i = new CustomEvent("onChange", {
                                bubbles: !0,
                                detail: this.component
                            });
                            this.component.dispatchEvent(i);
                        }
                        /**
               * preseleciona o elemento apartir da classe css .selected
               * @private
               */ _setDefaultSelected() {
                            this.component.querySelectorAll(".br-list .br-item").forEach((i)=>{
                                (i.classList.contains("selected") || i.querySelector("input").hasAttribute("checked")) && this._setSelected(this._positionSelected(i), i);
                            });
                        }
                        /**
               * Retorna posição do elemento no select
               * @param {element} component elemento que vai ser pesquisado
               * @returns {integer} valor da posição
               */ _positionSelected(i) {
                            for (const [a, s] of this.component.querySelectorAll(".br-list .br-item").entries())if (s === i) return a;
                            return 0;
                        }
                        /**
               * Desfine comportamento do clique no checkbox
               * @param {int} index
               * @param {object} item -  Objeto do item clicado
               * @param {object} event  -  Objeto do evento do clique
               * @private
               */ _handleClickOnCheck(i, a, s) {
                            if (this.multiple) s.currentTarget.hasAttribute("checked") ? this._removeSelected(i, a) : this._setSelected(i, a);
                            else {
                                for (const [c, g] of this.component.querySelectorAll(".br-list .br-item").entries())this._removeSelected(c, g);
                                this._setSelected(i, a), this._closeSelect();
                            }
                            if (a.hasAttribute("data-all")) for (const c of a.querySelectorAll('.br-checkbox input[type="checkbox"]'))if (!c.hasAttribute("checked")) this._setAttribute(), a.querySelectorAll("label")[0].innerText = "Selecionar Todos";
                            else {
                                for (const g of this.component.querySelectorAll(".br-list .br-item"))for (const A of g.querySelectorAll('.br-checkbox input[type="checkbox"]'))A.hasAttribute("checked") || A.click();
                                a.querySelectorAll("label")[0].innerText = "Deselecionar Todos";
                            }
                            this._sendEvent();
                        }
                        /**
               * Define comportamentos na seleção
               * @private
               */ _setSelectionBehavior() {
                            this.selectionHandler = [], this._setDefaultSelected();
                            for (const [i, a] of this.component.querySelectorAll(".br-list .br-item").entries())for (const s of a.querySelectorAll('.br-radio input[type="radio"], .br-checkbox input[type="checkbox"]'))this.selectionHandler.push({
                                element: s,
                                handler: this._handleClickOnCheck.bind(this, i, a)
                            }), s.addEventListener("click", this.selectionHandler[i].handler);
                        }
                        /**
               * retira comportamento  de clique na seleção
               * @private
               */ _unsetSelectionBehavior() {
                            this.selectionHandler.forEach((i)=>{
                                i.element.removeEventListener("click", i.handler, !1);
                            });
                        }
                        /**
               * Define comportamentos no filtro do input
               * @private
               */ _setFilterBehavior() {
                            const i = this.component.querySelector(".br-list");
                            for (const a of this.component.querySelectorAll('.br-input input[type="text"]'))a.addEventListener("input", (s)=>{
                                if (!i.hasAttribute("expanded")) {
                                    const { value: g } = s.currentTarget;
                                    this._openSelect(), s.currentTarget.value = g;
                                }
                                let c = !0;
                                this._filter(s.currentTarget.value);
                                for (const g of this.optionsList)g.visible && (c = !1);
                                c && this._filter(s.currentTarget.value);
                            });
                        }
                        /**
               * Define filtro no list
               * @private
               */ _filter(i) {
                            let a = !1;
                            for (const [s, c] of this.component.querySelectorAll(".br-list .br-item").entries())this._removeNotFoundElement(), this.optionsList[s] && (this.optionsList[s].value.toUpperCase().indexOf(i.toUpperCase()) === -1 ? (c.classList.add("d-none"), this.optionsList[s].visible = !1) : (c.classList.remove("d-none"), this.optionsList[s].visible = !0, a = !0));
                            a === !1 ? this._addNotFoundElement() : this._removeNotFoundElement();
                        }
                        /**
               * Define atributo checked com click
               * @private
               */ _setAttribute() {
                            for (const i of this.component.querySelectorAll(".br-list .br-item"))for (const a of i.querySelectorAll('.br-checkbox input[type="checkbox"]'))a.hasAttribute("checked") && a.click();
                        }
                        /**
               * Seleciona o elemento e retira checked dos outros elementos
               * @param {integer} index Posição do elemento na lista
               * @param {*} item elemento em que vai ser selecionado
               * @private
               */ _setSelected(i, a) {
                            a.classList.add("selected"), a.setAttribute("aria-selected", !0);
                            for (const s of a.querySelectorAll(".br-radio, .br-checkbox"))for (const c of s.querySelectorAll('input[type="radio"], input[type="checkbox"]'))c.setAttribute("checked", "");
                            this.optionsList[i].selected = !0, this._setInput();
                        }
                        /**
               * Retira o estado selecionado do elemento
               * @param {integer} index Posição do elemento na lista
               * @param {*} item elemento em que vai ser desselecionado
               * @private
               */ _removeSelected(i, a) {
                            a.classList.remove("selected"), a.removeAttribute("aria-selected");
                            for (const s of a.querySelectorAll(".br-radio, .br-checkbox")){
                                for (const c of s.querySelectorAll('input[type="radio"], input[type="checkbox"'))c.removeAttribute("checked");
                                this.optionsList[i].selected = !1, this._setInput();
                            }
                        }
                        /**
               * Determina o input
               * @private
               */ _setInput() {
                            for (const i of this.component.querySelectorAll('.br-input input[type="text"]'))this.multiple ? this.selected.length === 0 ? i.value = "" : this.mountSelectedValues(i) : i.value = this.selected;
                        }
                        /**
               * Monta a string apresentada no campo input do multiselect
               * @param {object} input Referencia o elemento input do select
               */ mountSelectedValues(i) {
                            this.amountE = this.amountE > 0 ? this.amountE : 0;
                            const a = this.amountE, s = this.selected.toString().replaceAll(",", ", "), c = document.createElement("span");
                            c.innerHTML = s, document.querySelector("body").insertAdjacentElement("beforeend", c);
                            const g = this.getMaxCharacterCountBeforeOverflow(i);
                            this.amountE = a, i.title = this.selected.toString().replaceAll(",", ", ");
                            const A = this.encontrarPosicaoPorTamanho(this.selected, g - 6);
                            i.value = A, c.remove();
                        }
                        /**
               * Obtém o tamanho em pixels de um valor de texto.
               *
               * @param {string} value - O valor de texto para o qual se deseja obter o tamanho em pixels.
               * @returns {number} O tamanho em pixels do valor de texto.
               */ getPixelSize(i) {
                            const a = document.createElement("span");
                            a.style.visibility = "hidden", a.style.position = "absolute", a.style.left = "-9999px", a.style.top = "-9999px", a.style.whiteSpace = "nowrap", a.textContent = i, document.body.appendChild(a);
                            const s = a.getBoundingClientRect().width;
                            return document.body.removeChild(a), s;
                        }
                        /**
               * Retorna uma string contendo elementos de um array até o limite de caracteres especificado.
               * Se houver elementos truncados, a quantidade de elementos truncados é indicada no final da string.
               *
               * @param {Array<string>} array - O array de elementos.
               * @param {number} maxCharacterCount - O limite máximo de caracteres permitidos na string resultante.
               * @returns {string} - A string contendo os elementos até o limite de caracteres, com indicação de elementos truncados, se houver.
               */ encontrarPosicaoPorTamanho(i, a) {
                            let s = "", c = 0, g = 0;
                            for (const A of i){
                                const F = i.indexOf(A);
                                if (A.length >= a && i.length === 1) return `${A.substring(0, a)}... `;
                                if (s.length >= a) {
                                    s += `${A}, `, s = `${s.substring(0, a)}...`, c = c === 0 ? 1 : c;
                                    let $ = F - c;
                                    $ = c === 0 ? i.length - 1 : i.length - c, g = $;
                                } else {
                                    const $ = F > 0 ? `, ${A}` : `${A}`;
                                    s += `${$}`, c += 1;
                                }
                            }
                            return s = g <= 0 ? `${s}` : `${s} + (${g})`, s;
                        }
                        /**
               * Retorna a quantidade máxima de caracteres de um elemento de input antes do overflow.
               *
               * @param {HTMLElement} input - O elemento de input.
               * @returns {number} A quantidade máxima de caracteres antes do overflow.
               */ getMaxCharacterCountBeforeOverflow(i) {
                            const a = window.getComputedStyle(i), s = parseFloat(a.paddingLeft) + parseFloat(a.paddingRight), c = parseFloat(a.borderLeftWidth) + parseFloat(a.borderRightWidth), g = i.clientWidth - s - c, A = this.getAverageCharacterWidth(i);
                            return Math.floor(g / A);
                        }
                        /**
               * Retorna a largura média de um caractere dentro de um elemento de input.
               *
               * @param {HTMLElement} input - O elemento de input.
               * @returns {number} A largura média de um caractere.
               */ getAverageCharacterWidth(i) {
                            const a = document.createElement("span");
                            a.style.visibility = "hidden", a.style.position = "absolute", a.style.whiteSpace = "nowrap", a.textContent = "X", document.body.appendChild(a);
                            const s = a.offsetWidth;
                            return document.body.removeChild(a), s;
                        }
                        /**
               * Filtra um array removendo elementos que ultrapassem o tamanho do input. Adiciona "..." aos elementos truncados.
               *
               * @param {Array} array - O array a ser filtrado.
               * @param {HTMLElement} input - O elemento de input usado como referência para o tamanho máximo.
               * @returns {Array} O array filtrado.
               */ filterArrayByInputSize(i, a) {
                            const s = getMaxCharacterCountBeforeOverflow(a);
                            return i.filter((g)=>{
                                const A = g.toString();
                                if (getPixelSize(A) <= a.offsetWidth) return !0;
                                {
                                    const F = `${A.substring(0, s - 3)}...`;
                                    return a.value = F, !1;
                                }
                            });
                        }
                        /**
               * Retorna elemento posterior ao focado
               * @returns {object}
               * @private
               */ // eslint-disable-next-line complexity
                        _getNextItem() {
                            const i = this.component.querySelectorAll(".br-list .br-item");
                            let a, s;
                            for(a = 0; a < this.optionsList.length; a++)if (this.optionsList[a].focus) {
                                for(s = a + 1; s < this.optionsList.length && !this.optionsList[s].visible; s++);
                                break;
                            }
                            if (a === this.optionsList.length) {
                                for(let c = 0; c < this.optionsList.length; c++)if (this.optionsList[c].visible) return this.optionsList[c].focus = !0, i[c];
                            } else return s < this.optionsList.length ? (this.optionsList[a].focus = !1, this.optionsList[s].focus = !0, i[s]) : i[a];
                            return "";
                        }
                        /**
               * Retorna elemento anterior ao focado
               * @returns {object}
               * @private
               */ _getPreviousItem() {
                            const i = this.component.querySelectorAll(".br-list .br-item");
                            let a, s;
                            for(a = 0; a < this.optionsList.length; a++)if (this.optionsList[a].focus) {
                                for(s = a - 1; s > 0 && !this.optionsList[s].visible; s--);
                                break;
                            }
                            if (a === this.optionsList.length) {
                                for(let c = this.optionsList.length - 1; c >= 0; c--)if (this.optionsList[c].visible) return this.optionsList[c].focus = !0, i[c];
                            } else return a === 0 ? i[a] : (this.optionsList[a].focus = !1, this.optionsList[s].focus = !0, i[s]);
                            return "";
                        }
                        /**
               * Reseta valor do input
               * @private
               */ _resetInput() {
                            for (const i of this.component.querySelectorAll('.br-input input[type="text"]'))i.value = "";
                        }
                        /**
               * Reseta o focus dos elementos
               * @private
               */ _resetFocus() {
                            for (const i of this.optionsList)i.focus = !1;
                        }
                        /**
               * Reseta o focus dos elementos visiveis
               * @private
               */ _resetVisible() {
                            this._removeNotFoundElement();
                            const i = this.component.querySelectorAll(".br-list .br-item");
                            for (const [a, s] of this.optionsList.entries())s.visible = !0, i[a].classList.remove("d-none");
                        }
                        /**
               * Abre o select aberto
               * @private
               */ _openSelect() {
                            const i = this.component.querySelector(".br-input"), a = this.component.querySelector(".br-input .br-button");
                            for (const s of this.component.querySelectorAll(".br-list"))s.setAttribute("expanded", "");
                            for (const s of this.component.querySelectorAll(".br-input .br-button i"))s.classList.remove("fa-angle-down"), s.classList.add("fa-angle-up");
                            i.setAttribute("aria-expanded", !0), a.setAttribute("aria-expanded", !0), a.setAttribute("aria-label", "Ocultar lista"), this._resetInput();
                        }
                        /**
               * Fecha o select aberto
               * @private
               */ _closeSelect() {
                            const i = this.component.querySelector(".br-input"), a = this.component.querySelector(".br-input .br-button");
                            for (const s of this.component.querySelectorAll(".br-list"))s.removeAttribute("expanded");
                            for (const s of this.component.querySelectorAll(".br-input .br-button i"))s.classList.remove("fa-angle-up"), s.classList.add("fa-angle-down");
                            i.setAttribute("aria-expanded", !1), a.setAttribute("aria-expanded", !1), a.setAttribute("aria-label", "Exibir lista"), this._setInput(), this._resetFocus(), this._resetVisible();
                        }
                        /**
               * Adiciona ícone de busca
               * @private
               */ _setSearchIcon() {
                            const i = this.component.querySelector(".br-input"), a = this.component.querySelector("[data-trigger]"), s = document.createElement("i");
                            s.classList.add("fas", "fa-search"), s.setAttribute("aria-hidden", "true");
                            const c = document.createElement("div");
                            c.classList.add("input-icon"), c.appendChild(s);
                            const g = document.createElement("div");
                            g.classList.add("input-group"), g.appendChild(c), g.appendChild(i.querySelector("input")), i.appendChild(g), i.appendChild(a);
                        }
                        _setAria() {
                            const i = this.component.querySelector(".br-input"), a = this.component.querySelector(".br-list");
                            i.setAttribute("role", "combobox"), i.setAttribute("aria-expanded", !1), i.setAttribute("aria-controls", `${a.id}`), a.setAttribute("role", "listbox");
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/step/step.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        constructor(i, a){
                            this.name = i, this.component = a, this.activeStepNum = 0, this.DOMstrings = {
                                // stepsBar: this.component.querySelector('.step-progress'),
                                stepsBar: this.component,
                                stepsBarClass: "step-progress",
                                stepsBtnClass: "step-progress-btn",
                                stepsBtns: this.component.querySelectorAll(".step-progress-btn")
                            }, this.removeAttributes = (s, c)=>{
                                s.forEach((g)=>{
                                    g.removeAttribute(c);
                                });
                            }, this.findParent = (s, c)=>{
                                let g = s;
                                for(; !g.classList.contains(c);)g = g.parentNode;
                                return g;
                            }, this.getActiveStep = (s)=>Array.from(this.DOMstrings.stepsBtns).indexOf(s), this.setActiveStep = function(s) {
                                this.removeAttributes(this.DOMstrings.stepsBtns, "active"), this.removeAttributes(this.DOMstrings.stepsBtns, "aria-current"), this.DOMstrings.stepsBtns.forEach((c, g)=>{
                                    g === s && (c.removeAttribute("disabled"), c.setAttribute("active", ""), c.setAttribute("aria-current", "step"));
                                }), this.activeStepNum = s;
                            }, this.setStepsNum = ()=>{
                                this.DOMstrings.stepsBtns.forEach((s, c)=>{
                                    const g = s.querySelector(".step-icon");
                                    this.component.getAttribute("data-type") === "text" ? s.setAttribute("step-num", `${c + 1}/${this.DOMstrings.stepsBtns.length}`) : g ? s.setAttribute("step-num", "") : s.setAttribute("step-num", c + 1);
                                });
                            }, this.setStep = (s)=>{
                                const c = s <= this.DOMstrings.stepsBtns.length ? s - 1 : 0;
                                this.setActiveStep(c);
                            }, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            this.DOMstrings.stepsBar.addEventListener("click", (i)=>{
                                const a = i.target;
                                if (!a.classList.contains(`${this.DOMstrings.stepsBtnClass}`)) {
                                    i.target.parentNode.click();
                                    return;
                                }
                                const s = this.getActiveStep(a);
                                this.setActiveStep(s);
                            }), this.setStepsNum(), this.component.hasAttribute("data-initial") ? this.setStep(this.component.getAttribute("data-initial")) : this.setStep(1), !this.component.classList.contains("vertical") && this.component.hasAttribute("data-scroll");
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/tab/tab.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(i, a){
                            this.name = i, this.component = a, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            for (const i of this.component.querySelectorAll(".tab-nav"))this.height = i.clientHeight, this.scollsizes = i.scrollHeight - i.clientHeight, this.scrollHeight = Math.max(this.component.scrollWidth, document.documentElement.scrollWidth, this.component.offsetWidth, document.documentElement.offsetWidth, this.component.clientWidth, document.documentElement.clientWidth), this.leftPosition = this.component.offsetWidth - 1, i.style.setProperty("--height-nav", `${this.height}px`), i.style.setProperty("--right-gradient-nav", `${this.leftPosition}px`), this.positionScroll(i), this.navigationRight = this.navigationRight + 4, this.navigationRight <= this.lastItempos - 5 && i.classList.add("tab-nav-right"), i.onscroll = ()=>{
                                this.positionScroll(i), this.navigationLeft <= 0 ? i.classList.add("tab-nav-left") : i.classList.remove("tab-nav-left"), this.navigationRight <= this.lastItempos - 5 ? i.classList.add("tab-nav-right") : i.classList.remove("tab-nav-right");
                            };
                            for (const i of this.component.querySelectorAll('.tab-nav .tab-item:not([not-tab="true"]) button'))i.addEventListener("click", (a)=>{
                                a.currentTarget.setAttribute("aria-selected", "false"), this._switchTab(a.currentTarget.parentElement), this._switchContent(a.currentTarget.parentElement);
                            }, !1), i.addEventListener("keyup", (a)=>{
                                a.preventDefault(), this.positionKeyboard(a);
                            }), i.addEventListener("blur", ()=>{
                                this.hiddenTooltips();
                            });
                            this.tabitems = this.component.querySelectorAll("tab-item");
                        }
                        /**
               * Mapeia as teclas pressionadas
               * @param {event} event - evento que disparou a ação
               */ positionKeyboard(i) {
                            const a = {
                                end: 35,
                                home: 36,
                                left: 37,
                                right: 39,
                                space: 32,
                                tab: 9
                            }, s = i.keyCode;
                            switch(this.tabitems = this.component.querySelectorAll(".tab-item"), this.buttons = this.component.querySelectorAll("button"), s){
                                case a.end:
                                    i.preventDefault(), this.clean(), this._switchTab(this.tabitems[this.tabitems.length - 1]), this._switchContent(this.tabitems[this.tabitems.length - 1]), this.tabitems[this.tabitems.length - 1].focus();
                                    break;
                                case a.home:
                                    i.preventDefault(), this.clean(), this._switchTab(this.tabitems[0]), this._switchContent(this.tabitems[0]), this.tabitems[0].focus(), i.stopPropagation();
                                    break;
                                case a.left:
                                    i.preventDefault(), this.position(i.target, -1), i.stopPropagation();
                                    break;
                                case a.right:
                                    i.preventDefault(), this.position(i.target, 1), i.stopPropagation();
                                    break;
                                case a.tab:
                                    i.preventDefault(), this.position(i.target, 0), i.stopPropagation();
                                    break;
                                case 32:
                                    i.preventDefault(), this.hiddenTooltips(), i.target.click(), i.stopPropagation();
                                    break;
                            }
                        }
                        /**
               *  Esconde todos tooltip
               *
               */ hiddenTooltips() {
                            document.querySelectorAll(".br-tooltip").forEach((a)=>{
                                a.hidden = !0, a.style.visbility = "hidden", a.removeAttribute("data-show");
                            });
                        }
                        /**
               * Define o deslocamento da posição ativa
               * @property {object} target - referencia ao objeto DOM
               * @property {number} direction - incremento à posição
               */ positionActive(i, a) {
                            let s = 0, c = 0;
                            const g = i.parentElement.parentElement.querySelectorAll(".tab-item");
                            for (const A of g)(A.classList.contains("is-active") || A.classList.contains("active")) && (c = s), s += 1;
                            if (g.length > c + a && c + a >= 0) {
                                this._switchTab(g[c + a]), g[c + a].focus();
                                let A = "";
                                g[c + a].querySelector("button") && (A = g[c + a].querySelector("button"), A.focus());
                            }
                        }
                        /**
               * Define o deslocamento da posição ativa do tab-item interno
               * @property {object} target - referencia ao objeto DOM
               * @property {number} direction - incremento à posição
               */ position(i, a) {
                            this.positionQuery(i, a, ".tab-item");
                        }
                        /**
               * Define o deslocamento da posição ativa do elemento referenciado
               * @property {object} target - referencia ao objeto DOM
               * @property {number} direction - incremento à posição
               * @property {string} query - string de referencia
               */ positionQuery(i, a, s) {
                            let c = 0, g = 0;
                            const A = i.parentElement.parentElement.querySelectorAll(s);
                            for (const F of A)F.querySelector(".focus-visible") && (g = c), c += 1;
                            A[g + a].querySelector("button").focus(), A.length > g + a && g + a >= 0 && A[g + a].querySelector("button") && A[g + a].querySelector("button").focus();
                        }
                        /**
               * Define a posição ativa do elemento referenciado
               * @property {object} target - referencia ao objeto DOM
               */ setPosition(i) {
                            let a = 0, s = 0;
                            const c = i.parentElement.parentElement.querySelectorAll(".tab-item");
                            for (const g of c)(g.classList.contains("is-active") || g.classList.contains("active")) && (s = a), a += 1;
                            c.length > s && s >= 0 && (this.clean(), this._switchContent(c[s]));
                        }
                        /**
               * Reinicia estados
               */ clean() {
                            for (const i of event.currentTarget.parentElement.querySelectorAll("button"))i.classList.remove("focus-visible"), i.classList.remove("is-active"), i.classList.remove("active");
                            for (const i of event.currentTarget.parentElement.querySelectorAll("tab-item"))i.classList.remove("is-active"), i.classList.remove("active");
                        }
                        /**
               * Realiza rolagem até a âncora
               * @property {object} ancor - referencia ao objeto DOM
               */ positionScroll(i) {
                            this.navItems = i.querySelectorAll(".tab-item"), this.lastItempos = Math.ceil(this.navItems[this.navItems.length - 1].getBoundingClientRect().right), this.navigationLeft = Math.floor(this.navItems[0].getBoundingClientRect().left), this.navigationRight = Math.floor(i.getBoundingClientRect().right);
                        }
                        /**
               * Muda para a aba referenciada
               * @property {object} currentTab - referencia ao objeto DOM
               */ _switchTab(i) {
                            for (const a of this.component.querySelectorAll('.tab-nav .tab-item:not([not-tab="true"])'))a === i ? (a.classList.add("active"), this._selectTab(a, !0)) : (a.classList.remove("is-active"), a.classList.remove("active"), this._selectTab(a, !1));
                        }
                        /**
               * Muda para o conteudo da aba referenciada
               * @property {object} currentTab - referencia ao objeto DOM
               * @property {boolean} value - valor a ser aplicado no aria selected
               */ _selectTab(i, a) {
                            i.querySelector("button").setAttribute("aria-selected", a);
                        }
                        /**
               * Muda para o conteudo da aba referenciada
               * @property {object} currentTab - referencia ao objeto DOM
               */ _switchContent(i) {
                            for (const a of i.querySelectorAll("button"))for (const s of this.component.querySelectorAll(".tab-content .tab-panel"))a.getAttribute("data-panel") === s.getAttribute("id") || a.getAttribute("data-target") === s.getAttribute("id") ? s.classList.add("active") : (s.classList.remove("is-active"), s.classList.remove("active"));
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/table/table.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>i
                    });
                    var k = y("./src/partial/js/behavior/collapse.js"), b = y("./src/partial/js/behavior/dropdown.js");
                    class m {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               * @param {number} sequence - 'índice do componente para sobreposição'
               */ constructor(s, c, g){
                            this.name = s, this.component = c, this._header = this.component.querySelector(".header, .table-header"), this._table = this.component.querySelector("table"), this._sequence = g, this._setBehaviors();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehaviors() {
                            this._makeResponsiveTable(), this._setHeaderWidth(), this._searchBehavior(), this._dropdownBehavior(), this._collpaseBehavior(), this._densityBehavior(), this._setClickActions();
                        }
                        /**
               * Configura reponsividade da tabela
               * @private
               */ _makeResponsiveTable() {
                            const s = "responsive";
                            if (!this.component.querySelector(`.${s}`)) {
                                const c = document.createElement("div");
                                c.classList.add(s), c.appendChild(this._table), this._header.after(c);
                            }
                        }
                        /**
               * Configura rolagem
               * @private
               */ _makeScroller() {
                            const s = document.createElement("div");
                            s.classList.add("scroller");
                            for (const c of this._table.querySelectorAll("thead tr th")){
                                const g = document.createElement("div");
                                g.classList.add("item"), g.innerHTML = c.innerHTML, c.offsetWidth && (g.style.flex = `1 0 ${c.offsetWidth}px`), s.appendChild(g);
                                const A = g.querySelector(".br-checkbox");
                                if (A) {
                                    const F = A.querySelector("input"), $ = A.querySelector("label");
                                    F.id = `${F.id}-clone`, $.setAttribute("for", F.id);
                                }
                            }
                            return s;
                        }
                        /**
               * Configura largura do cabeçalho
               * @private
               */ _setHeaderWidth() {
                            for (const s of this.component.querySelectorAll(".headers > div"))for (const [c, g] of this.component.querySelectorAll("table thead tr th").entries())s.children[c].style.flex = `1 0 ${g.offsetWidth}px`;
                        }
                        /**
               * Configura coportamento do dropdown
               * @private
               */ _dropdownBehavior() {
                            this.component.querySelectorAll('[data-toggle="dropdown"]').forEach((s)=>{
                                const c = {
                                    iconToHide: "fa-chevron-up",
                                    iconToShow: "fa-chevron-down",
                                    trigger: s,
                                    useIcons: !0
                                };
                                this.dropdown = new b.default(c), this.dropdown.setBehavior();
                            });
                        }
                        /**
               * Configura comportamento de colapsar
               * @private
               */ _collpaseBehavior() {
                            this.component.querySelectorAll('[data-toggle="collapse"]').forEach((s)=>{
                                const c = {
                                    iconToHide: "fa-chevron-up",
                                    iconToShow: "fa-chevron-down",
                                    trigger: s,
                                    useIcons: !0
                                };
                                new k.default(c).setBehavior();
                            });
                        }
                        /**
               * Configura comportamento da busca
               * @private
               */ _searchBehavior() {
                            if (this.component.dataset.search) {
                                const s = this.component.querySelector('[data-toggle="search"]'), c = this.component.querySelector(".search-bar"), g = this.component.querySelector('[data-dismiss="search"]'), A = c ? c.querySelector("input") : null;
                                s && c && g && A ? (this._searchInit(s), s.addEventListener("click", ()=>this._searchOpen(s, c)), g.addEventListener("click", ()=>this._searchClose(s, c)), A.addEventListener("keydown", (F)=>{
                                    F.key === "Escape" && this._searchClose(s, c);
                                })) : console.error("Um ou mais elementos necess\xe1rios para a busca n\xe3o foram encontrados.");
                            }
                        }
                        /**
               * Inicializa a busca
               * @private
               * @param {object} trigger - Objeto referente ao elemento que dispara a ação
               */ _searchInit(s) {
                            s.setAttribute("aria-expanded", "false");
                        }
                        /**
               * Abre a busca
               * @private
               * @param {object} trigger - Objeto referente ao elemento que dispara a ação
               * @param {object} target - Objeto referente ao alvo da ação
               */ _searchOpen(s, c) {
                            s.setAttribute("aria-expanded", "true"), c.classList.add("show"), c.parentElement.classList.add("show"), c.querySelector("input").focus();
                        }
                        /**
               * Fecha a busca
               * @private
               * @param {object} trigger - Objeto referente ao elemento que dispara a ação
               * @param {object} target - Objeto referente ao alvo da ação
               */ _searchClose(s, c) {
                            c.querySelector("input").value = "", c.classList.remove("show"), c.parentElement.classList.remove("show"), s.focus(), s.setAttribute("aria-expanded", "false");
                        }
                        /**
               * Configura densidades
               * @private
               */ _densityBehavior() {
                            const s = this.component.querySelectorAll("[data-density]");
                            for (const c of s)c.addEventListener("click", (g)=>{
                                this.component.classList.remove("small", "medium", "large"), this.component.classList.add(c.dataset.density), this._hideDensityDropdown();
                            });
                        }
                        /**
               * Esconde o dropdown de  densidades
               * @private
               */ _hideDensityDropdown(s) {
                            var c = this.component.querySelector(".actions-trigger ");
                            c && c.classList.contains("dropdown") && c.classList.remove("dropdown");
                            var g = this.component.querySelector(".actions-trigger .br-list");
                            g.setAttribute("data-visible", !1), g.setAttribute("aria-expanded", !1), g.setAttribute("hidden", "");
                        }
                        /**
               * Configura ações de clique
               * @private
               */ _setClickActions() {
                            const s = this.component.querySelector('.headers [type="checkbox"]'), c = this.component.querySelectorAll('tbody [type="checkbox"]'), g = this.component.querySelector(".selected-bar"), A = this.component.querySelectorAll('[data-toggle="check-all"]');
                            for (const F of A)F.addEventListener("click", ()=>{
                                this._checkAllTable(g, c, s), F.parentElement.classList.contains("br-list");
                            });
                            if (c) for (const F of c)F.addEventListener("change", ()=>{
                                this._checkRow(F, g, c, s);
                            });
                        }
                        /**
               * Configura seleção da linha
               * @private
               * @param {object} checkbox - Objeto referente ao checkbox
               * @param {boolean} check - define se a linha deve ser selecionada
               */ _setRow(s, c) {
                            const g = s.parentNode.parentNode.parentNode;
                            c ? (g.classList.add("is-selected"), s.parentNode.classList.add("is-inverted"), s.checked = !0) : (g.classList.remove("is-selected"), s.parentNode.classList.remove("is-inverted"), s.checked = !1);
                        }
                        /**
               * Configura seleção da linha
               * @private
               * @param {object} checkbox - Objeto referente ao checkbox
               * @param {object} selectedBar - Objeto referente a barra contextual
               * @param {object} tableCheckboxes - Objeto referente a lista de checkboxes
               * @param {object} headerCheckbox - Objeto referente ao checkbox do header
               */ _checkRow(s, c, g, A) {
                            const F = s.checked;
                            this._setRow(s, F), this._setSelectedBar(F ? 1 : -1, c, g, A);
                        }
                        /**
               * Seleciona todas as linhas
               * @private
               * @param {object} tableCheckboxes - Objeto referente a lista de checkboxes
               */ _checkAllRows(s) {
                            for (const c of s)this._setRow(c, !0);
                        }
                        /**
               * Desseleciona todas as linhas
               * @private
               * @param {object} tableCheckboxes - Objeto referente a lista de checkboxes
               */ _uncheckAllRows(s) {
                            for (const c of s)this._setRow(c, !1);
                        }
                        /**
               * Seleciona toda a tabela
               * @private
               * @param {object} selectedBar - Objeto referente a barra contextual
               * @param {object} tableCheckboxes - Objeto referente a lista de checkboxes
               * @param {object} headerCheckbox - Objeto referente ao checkbox do header
               */ _checkAllTable(s, c, g) {
                            let A = c.length;
                            const F = s.querySelector(".info .count");
                            parseInt(F.innerHTML, 10) === A ? (this._uncheckAllRows(c), A = -1 * A) : this._checkAllRows(c), this._setSelectedBar(A, s, c, g);
                        }
                        /**
               * Define visualização dos itens selecionados na barra contextual
               * @private
               * @param {number} count - número de itens selecionados
               * @param {object} selectedBar - Objeto referente a barra contextual
               * @param {object} tableCheckboxes - Objeto referente a lista de checkboxes
               * @param {object} headerCheckbox - Objeto referente ao checkbox do header
               */ _setSelectedBar(s, c, g, A) {
                            const F = c.querySelector(".info .count"), $ = c.querySelector(".info .text"), J = s < 2 ? parseInt(F.innerHTML, 10) + s : s;
                            J > 0 ? (c.classList.add("show"), F.innerHTML = J, $.innerHTML = J > 1 ? "itens selecionados" : "item selecionado", A && A.parentNode.classList.add("is-checking"), J === g.length && A && (A.checked = !0, A.parentNode.classList.remove("is-checking"))) : (F.innerHTML = 0, A && (A.checked = !1, A.parentNode.classList.remove("is-checking")), c.classList.remove("show"));
                        }
                    }
                    const i = m;
                },
                /***/ "./src/components/tag/tag.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    class k {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(a, s){
                            this.name = a, this.component = s, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            this.component.classList.contains("interaction-select") && (this.component.querySelector("input").getAttribute("checked") && this.component.classList.add("selected"), this._setSelection()), this._closeTag(), this._dismissTag();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setSelection() {
                            const a = this.component.querySelector("input");
                            a.addEventListener("change", (s)=>{
                                this._toggleSelection(a, s);
                            });
                        }
                        /**
               * Muda estado do radio
               * @private
               * @param {object} input - referencia DOM ao input
               */ _toggleRadio(a) {
                            if (this.component.querySelector('[type="radio"')) {
                                const s = a.getAttribute("name");
                                for (const c of window.document.querySelectorAll(`[name=${s}]`))this._removeCheck(c);
                            }
                        }
                        /**
               * Muda estado do input
               * @private
               * @param {object} input - referencia DOM ao input
               * @param {event} event - ação que disparou o evento
               */ _toggleSelection(a, s) {
                            if (s.preventDefault(), this._toggleRadio(a), a.getAttribute("checked")) {
                                this._removeCheck(a);
                                return;
                            }
                            this._setCheck(a);
                        }
                        /**
               * Define estado do input para selecionado
               * @private
               * @param {object} input - referencia DOM ao input
               */ _setCheck(a) {
                            a.setAttribute("checked", "checked"), a.parentElement.classList.add("selected");
                        }
                        /**
               * Define estado do input para desselecionado
               * @private
               * @param {object} input - referencia DOM ao input
               */ _removeCheck(a) {
                            a.removeAttribute("checked"), a.parentElement.classList.remove("selected");
                        }
                        /**
               * Define comportamento do botão de fechar usando classe (compatibilidade)
               * @private
               */ _closeTag() {
                            const a = this.component.querySelector(".br-button.close");
                            a && a.closest(".br-tag").addEventListener("click", ()=>{
                                a.closest(".br-tag").remove();
                            });
                        }
                        /**
               * Define comportamento do botão de fechar usando data-dismiss
               * @private
               */ _dismissTag() {
                            this.component.querySelectorAll("[data-dismiss]").forEach((a)=>{
                                a.addEventListener("click", ()=>{
                                    const s = document.querySelector(`#${a.getAttribute("data-dismiss")}`);
                                    s && s.remove();
                                });
                            });
                        }
                    }
                    const b = [];
                    for (const i of window.document.querySelectorAll(".br-tag"))b.push(new k("br-tab", i));
                    const m = k;
                },
                /***/ "./src/components/textarea/textarea.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        /**
               * Instancia do objeto
               * @param {string} name - Nome do componente em minúsculo
               * @param {object} component - Objeto referenciando a raiz do componente DOM
               */ constructor(i, a){
                            this.name = i, this.component = a, this._setBehavior(), this._setKeyup();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            this.limit = this.component.querySelector(".limit"), this.current = this.component.querySelector(".current"), this.component.querySelector("textarea") !== null && (this.maximum = this.component.querySelector("textarea").getAttribute("maxlength")), this.characters = this.component.querySelector(".characters"), this.currentValue = this.component.querySelector(".current");
                        }
                        /**
               * Define ações do teclado
               * @private
               */ _setKeyup() {
                            this.component.addEventListener("keyup", ()=>{
                                this.updateAssist();
                            }), this.component.querySelector("textarea").addEventListener("focus", ()=>{
                                this.updateAssist();
                            });
                        }
                        updateAssist() {
                            const i = this.component.querySelector("textarea").textLength;
                            if (i <= this.maximum && !this.characters) {
                                this.limit && (this.limit.innerHTML = "");
                                const s = `<span aria-live="polite">Restam  <strong >${this.maximum - i}</strong > caracteres</span>`;
                                this.currentValue && (this.currentValue.innerHTML = s);
                            }
                            !this.characters && this.limit ? i === 0 && this.limit.innerHTML === "" && (this.limit.innerHTML = `<span aria-live="polite">Limite m\xe1ximo de <strong >${this.maximum}</strong> caracteres</span>`, this.currentValue.innerHTML = "") : this.characters && (this.characters.innerHTML = `<span ><strong >${i}</strong> caracteres digitados</span>`);
                        }
                    }
                    const b = k;
                },
                /***/ "./src/components/tooltip/tooltip.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./node_modules/@popperjs/core/lib/popper.js");
                    class b {
                        constructor(a, s){
                            this.name = a, this.component = s, this.activator = s.previousSibling.previousSibling;
                            const c = s.getAttribute("place"), g = [
                                "top",
                                "right",
                                "bottom",
                                "left"
                            ];
                            this.popover = s.hasAttribute("popover"), this.notification = s.classList.contains("br-notification"), this.timer = s.getAttribute("timer");
                            const A = this.notification ? "bottom" : "top";
                            this.active = s.hasAttribute("active"), this.placement = g.includes(c) ? c : A, this.popperInstance = null, this.showEvents = [
                                "mouseenter",
                                "click",
                                "focus"
                            ], this.hideEvents = [
                                "mouseleave",
                                "blur"
                            ], this.closeTimer = null, this._create(), this._setBehavior();
                        }
                        _setBehavior() {
                            this.activator && this.showEvents.forEach((a)=>{
                                this.activator.addEventListener(a, (s)=>{
                                    this._show(s);
                                });
                            }), this.popover ? this.component.querySelector(".close").addEventListener("click", (s)=>{
                                this._hide(s, this.component), this._toggleActivatorIcon();
                            }) : this.hideEvents.forEach((a)=>{
                                this.activator.addEventListener(a, (s)=>{
                                    this._hide(s, this.component);
                                });
                            });
                        }
                        _create() {
                            if (this._setLayout(), this.notification) this.component.setAttribute("notification", ""), this.popperInstance = (0, k.n4)(this.activator, this.component, {
                                modifiers: [
                                    {
                                        name: "offset",
                                        options: {
                                            offset: [
                                                0,
                                                10
                                            ]
                                        }
                                    },
                                    {
                                        name: "preventOverflow",
                                        options: {
                                            altAxis: !1,
                                            mainAxis: !0
                                        }
                                    }
                                ],
                                placement: this.placement,
                                strategy: "fixed"
                            });
                            else {
                                let a = new DOMRect();
                                const s = new DOMRect();
                                a = this.activator.getBoundingClientRect();
                                const c = document.body.clientWidth;
                                this.placement === "right" && (this.placement = a.x + a.width + s.width > c ? "top" : this.placement), this.placement === "left" && (this.placement = a.x - s.width > 0 ? this.placement : "top"), this.popperInstance = (0, k.n4)(this.activator, this.component, {
                                    modifiers: [
                                        {
                                            name: "offset",
                                            options: {
                                                offset: [
                                                    0,
                                                    8
                                                ]
                                            }
                                        },
                                        {
                                            name: "preventOverflow",
                                            options: {
                                                altAxis: !0,
                                                mainAxis: !0,
                                                tether: !1
                                            }
                                        }
                                    ],
                                    placement: this.placement
                                });
                            }
                        }
                        _show(a) {
                            this.component.style.display = "unset", this.component.setAttribute("data-show", ""), this.component.style.zIndex = 99, this._fixPosition(), this.component.style.visibility = "visible", this.timer && (clearTimeout(this.closeTimer), this.closeTimer = setTimeout(this._hide, this.timer, a, this.component));
                        }
                        _hide(a, s) {
                            s.removeAttribute("data-show"), s.style.zIndex = -1, s.style.visibility = "hidden", clearTimeout(s.closeTimer);
                        }
                        _setLayout() {
                            const a = document.createElement("div");
                            if (a.setAttribute("data-popper-arrow", ""), this.component.querySelectorAll(".arrow").length < 1 && a.classList.add("arrow"), this.component.appendChild(a), this.popover) {
                                const s = document.createElement("button");
                                s.setAttribute("type", "button"), s.classList.add("close");
                                const c = document.createElement("i");
                                c.classList.add("fas", "fa-times"), s.appendChild(c), this.component.appendChild(s);
                            }
                        }
                        _toggleActivatorIcon() {
                            const a = this.activator.querySelector("button svg");
                            a && (a.classList.toggle("fa-angle-down"), a.classList.toggle("fa-angle-up")), this.activator.toggleAttribute("active");
                        }
                        _fixPosition() {
                            this.notification && setTimeout(()=>{
                                const a = this.activator.getBoundingClientRect();
                                this.component.style = `position: fixed !important; top: ${a.top + a.height + 10}px !important; left: auto; right: 8px; display: unset; bottom: auto;`, this.component.querySelector(".arrow").style = `position: absolute; left: auto; right: ${document.body.clientWidth - a.right + a.width / 5}px !important;`;
                            }, 10);
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/upload/upload.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/components/tooltip/tooltip.js");
                    class b {
                        /**
               * @param {*} name nome do componente
               * @param {*} component componente
               * @param {*} uploadFiles  promisse de status do upload
               */ constructor(a, s, c){
                            this.name = a, this.component = s, this._inputElement = this.component.querySelector(".upload-input"), this._fileList = this.component.querySelector(".upload-list"), this._btnUpload = this.component.querySelector(".upload-button"), this._label = this.component.querySelector("label"), this._textHelp = document.querySelector(".text-base"), this._fileArray = [], this._uploadFiles = c, this._setBehavior();
                        }
                        /**
               * Define comportamentos do componente
               * @private
               */ _setBehavior() {
                            if (this._inputElement) {
                                const a = document.createElement("button");
                                if (a.className = "upload-button", a.setAttribute("type", "button"), a.setAttribute("aria-hidden", "true"), this._inputElement.getAttribute("multiple") ? a.innerHTML = '<i class="fas fa-upload" aria-hidden="true"></i><span>Selecione o(s) arquivo(s)</span>' : a.innerHTML = '<i class="fas fa-upload" aria-hidden="true"></i><span>Selecione o arquivo</span>', this.component.append(this._label), this.component.append(this._inputElement), this.component.appendChild(a), this.component.append(this._fileList), this._btnUpload = this.component.querySelector(".upload-button"), this._btnUpload.addEventListener("click", ()=>{
                                    this._clickUpload();
                                }, !1), this.component.getAttribute("disabled")) {
                                    a.setAttribute("disabled", "disabled");
                                    const s = document.createElement("span");
                                    s.classList.add("feedback", "warning", "mt-1"), s.setAttribute("role", "alert"), s.innerHTML = '<i class="fas fa-exclamation-triangle" aria-hidden="true"></i>Upload desabilitado', this.component.after(s);
                                }
                                this._fileArray = Array.from(this._inputElement.files), this._inputElement.addEventListener("change", (s)=>{
                                    this._handleFiles(s);
                                }, !1);
                            }
                            this._setDragAndDropBehavior();
                        }
                        /**
               * Define comportamento de arrastar(drag) e posicionar(drop)
               * @private
               */ _setDragAndDropBehavior() {
                            const a = this.component.querySelector(".upload-button");
                            [
                                "dragenter",
                                "dragover",
                                "dragleave",
                                "drop"
                            ].forEach((s)=>{
                                a.addEventListener(s, this._preventDefaults);
                            }), [
                                "dragenter",
                                "dragover"
                            ].forEach((s)=>{
                                a.addEventListener(s, this._hightLight.bind(this));
                            }), [
                                "dragleave",
                                "drop"
                            ].forEach((s)=>{
                                a.addEventListener(s, this._unHightLight.bind(this));
                            }), a.addEventListener("drop", this._handleDrop.bind(this));
                        }
                        /**
               * Evita os eventos padrao e propagação de evento
               * @private
               * @param {event} event - referencia ao evento
               */ _preventDefaults(a) {
                            a.preventDefault(), a.stopPropagation();
                        }
                        _hightLight() {
                            this.component.classList.add("dragging");
                        }
                        _unHightLight() {
                            this.component.classList.remove("dragging");
                        }
                        /**
               * Ação de posicionar (drop)
               * @private
               * @param {event} event - referencia ao evento
               */ _handleDrop(a) {
                            this.component.classList.remove("dragging");
                            const s = a.dataTransfer, { files: c } = s;
                            this._handleFiles(c);
                        }
                        /**
               * Testa se o objeto que disparou a ação está desabilitado
               * @private
               * @param {event} event - referencia ao evento
               */ _isDisabled(a) {
                            return !!a.target.getAttribute("disabled");
                        }
                        /**
               * Simula ação de clicar no input
               * @private
               */ _clickUpload() {
                            this._inputElement.click();
                        }
                        /**
               * Limpa mensagem de feedback
               * @private
               */ _removeMessage() {
                            for (const a of this.component.querySelectorAll(".feedback"))a.parentNode.removeChild(a), a.innerHTML = "";
                        }
                        /**
               * Remove mensagem de estado
               * @private
               */ _removeStatus() {
                            [
                                "danger",
                                "warning",
                                "info",
                                "success"
                            ].forEach((s)=>{
                                this.component.dataset.hasOwnProperty(s) && this.component.removeAttribute(`data-${s}`);
                            });
                        }
                        /**
               * Define mensagem de feedback
               * @private
               * @param {string} status - estados: danger / info / success / warning
               */ _feedback(a, s) {
                            const c = `<i class="fas fa-times-circle" aria-hidden="true"></i>${s}`, g = `data-${a}`, A = document.createElement("div");
                            switch(A.classList.add("feedback", a, "mt-1"), A.setAttribute("role", "alert"), A.setAttribute("aria-live", "assertive"), A.setAttribute("aria-label", s), a){
                                case "danger":
                                    A.innerHTML = c;
                                    break;
                                case "info":
                                    A.innerHTML = c.replace("fa-times-circle", "fa-info-circle");
                                    break;
                                case "success":
                                    A.innerHTML = c.replace("fa-times-circle", "fa-check-circle");
                                    break;
                                case "warning":
                                    A.innerHTML = c.replace("fa-times-circle", "fa-exclamation-triangle");
                                    break;
                                default:
                                    A.innerHTML = "";
                            }
                            this._removeStatus(), this.component.setAttribute(g, g), this._fileList.before(A);
                        }
                        /**
               * Adiciona arquivos a lista
               * @private
               * @param {File[]} files - lista de arquivos
               */ _concatFiles(a) {
                            const s = a.length ? Array.from(a) : Array.from(this._inputElement.files);
                            this._fileArray = this._fileArray.concat(s);
                        }
                        /**
               * Adiciona arquivos a lista
               * @private
               * @param {File[]} files - lista de arquivos
               */ _handleFiles(a) {
                            this._removeMessage(), !this._inputElement.multiple && a.length > 1 ? this._feedback("danger", "\xc9 permitido o envio de somente 1 arquivo.") : !this._inputElement.multiple && this._fileArray.length > 0 ? (this._fileArray = [], this._concatFiles(a), this._updateFileList(), this._feedback("warning", "O arquivo enviado anteriormente foi substitu\xeddo")) : (this._concatFiles(a), this._updateFileList());
                        }
                        /**
               * Atualiza lista de arquivos eliminando redundâncias
               * @private
               */ _updateFileList() {
                            if (this._removeStatus(), this.component.nextElementSibling === this._textHelp && (this._textHelp.style.display = "none"), !this._fileArray.length) this._fileList.innerHTML = "", this.component.nextElementSibling === this._textHelp && (this._textHelp.style.display = "");
                            else {
                                this._fileList.innerHTML = "";
                                for(let a = 0; a < this._fileArray.length; a++)"nowait" in this._fileArray[a] ? this._fileArray[a].nowait && this._renderItem(a) : this._fileArray[a].requested || (this.uploadLoading(), this.uploadingFile(a));
                            }
                        }
                        /**
               * Mostra mensagem de carregamento
               * @private
               */ uploadLoading() {
                            const a = document.createElement("div"), s = document.createElement("span");
                            s.classList.add("cargas"), s.innerText = "Carregando...", a.setAttribute("sm", ""), a.classList.add("my-3"), a.setAttribute("loading", ""), a.appendChild(s), this._fileList.appendChild(a);
                        }
                        /**
               * Faz upload de arquivo na posição definida
               * @private
               * @param {Number} position - numero do ínidice da posição
               */ uploadingFile(a) {
                            this._uploadFiles && (this._fileArray[a].requested = !0, this._uploadFiles().then(()=>{
                                this._fileArray[a].nowait = !0, this._updateFileList();
                            }));
                        }
                        /**
               * Renderiza item na posição definida
               * @private
               * @param {Number} position - numero do ínidice da posição
               */ _renderItem(a) {
                            const s = document.createElement("div");
                            s.className = "br-item d-flex", this._fileList.appendChild(s), s.innerHTML = "";
                            const c = document.createElement("div");
                            c.className = "name", s.appendChild(c), this._fileList.appendChild(s);
                            const g = document.createElement("div");
                            g.className = "content", g.innerHTML = this._fileArray[a].name, this._alertAddItemA11y(g, this._fileArray[a].name);
                            const A = document.createElement("div");
                            A.classList.add("br-tooltip"), A.setAttribute("role", "tooltip"), A.setAttribute("place", "top"), A.setAttribute("info", "info");
                            const F = document.createElement("span");
                            F.classList.add("text"), F.setAttribute("role", "tooltip"), F.innerHTML = this._fileArray[a].name, A.appendChild(F), s.appendChild(g), s.appendChild(c), s.appendChild(A), g.classList.add("text-primary-default", "mr-auto");
                            const $ = document.createElement("div");
                            $.className = "support mr-n2";
                            const J = document.createElement("button"), se = document.createElement("span");
                            se.className = "mr-1", se.innerHTML = this._calcSize(this._fileArray[a].size), $.appendChild(se), J.className = "br-button", J.type = "button", J.setAttribute("circle", ""), J.setAttribute("aria-label", "apagar arquivo" + this._fileArray[a].name), J.addEventListener("click", (H)=>{
                                this._removeFile(a, H);
                            }, !1);
                            const Q = document.createElement("i");
                            Q.className = "fa fa-trash", J.appendChild(Q), $.appendChild(J), s.appendChild($), this._fileArray[a].nowait = !0;
                            const _e = [];
                            for (const H of this.component.querySelectorAll(".br-tooltip"))_e.push(new k.A("br-tooltip", H));
                        }
                        _alertAddItemA11y(a, s) {}
                        /**this.component.querySelector(".br-tooltip")
               * Formata tamanho do arquivo
               * @private
               * @param {Number} nBytes - quantidade de bytes do arquivo
               */ _calcSize(a) {
                            if (a < 1024) return `${a} bytes`;
                            let s = "", c = [
                                "KB",
                                "MB",
                                "GB",
                                "TB"
                            ], g = 0, A = a / 1024;
                            for(; A >= 1 && g < c.length;)s = `${A.toFixed(2)} ${c[g]}`, A /= 1024, g++;
                            return s;
                        }
                        /**
               * Remove arquivo na posição definida
               * @private
               * @param {Number} index - numero do ínidice da posição
               * @param {event} event - evento que disparou a ação
               */ _removeFile(a, s) {
                            s.stopPropagation(), s.preventDefault(), this._removeStatus(), this._removeMessage(), this._fileArray.splice(a, 1), this._updateFileList(), this._inputElement.multiple && (this._inputElement.files = this._updateFileListItems(this._fileArray)), this._inputElement.multiple || (this._inputElement.value = "");
                        }
                        /**
               * Atualiza arquivos da lista
               * @private
               * @param {File[]} files - lista de arquivos
               */ _updateFileListItems(a) {
                            const s = new ClipboardEvent("").clipboardData || new DataTransfer();
                            for(let c = 0, g = a.length; c < g; c++)s.items.add(a[c]);
                            return s.files;
                        }
                    }
                    const m = b;
                },
                /***/ "./src/components/wizard/wizard.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>m
                    });
                    var k = y("./src/partial/js/behavior/swipe.js");
                    class b {
                        /**
               * Instância do componente
               * @param {string} name - nome do componente
               * @param {object} component - referencia ao objeto do DOM
               **/ constructor(a, s){
                            this.name = a, this.component = s, this.DOMstrings = {
                                stepFormPanelClass: "wizard-panel",
                                stepFormPanels: this.component.querySelectorAll(".wizard-panel"),
                                stepNextBtnClass: "wizard-btn-next",
                                stepPrevBtnClass: "wizard-btn-prev",
                                stepsBar: this.component.querySelector(".wizard-progress"),
                                stepsBarClass: "wizard-progress",
                                stepsBtnClass: "wizard-progress-btn",
                                stepsBtns: this.component.querySelectorAll(".wizard-progress-btn"),
                                stepsForm: this.component.querySelector(".wizard-form")
                            }, this.removeAttributes = (c, g)=>{
                                c.forEach((A)=>{
                                    A.removeAttribute(g);
                                });
                            }, this.setAttributes = (c, g, A)=>{
                                c.forEach((F)=>{
                                    F.setAttribute(g, A);
                                });
                            }, this.findParent = (c, g)=>{
                                let A = c;
                                for(; !A.classList.contains(g);)A = A.parentNode;
                                return A;
                            }, this.getActiveStep = (c)=>Array.from(this.DOMstrings.stepsBtns).indexOf(c), this.setActiveStep = function(c) {
                                this.removeAttributes(this.DOMstrings.stepsBtns, "active"), this.setAttributes(this.DOMstrings.stepsBtns, "aria-selected", "false"), this.DOMstrings.stepsBtns.forEach((g, A)=>{
                                    A === c && (g.removeAttribute("disabled"), g.setAttribute("active", ""), g.setAttribute("aria-selected", "true"));
                                });
                            }, this.setFocusOnFirstElementPanel = (c)=>{
                                c && this.DOMstrings.stepFormPanels[c].querySelectorAll(".wizard-panel-content *").forEach((A)=>{
                                    A.tabIndex >= 0 && A.focus();
                                });
                            }, this.getActivePanel = ()=>{
                                let c;
                                return this.DOMstrings.stepFormPanels.forEach((g)=>{
                                    g.hasAttribute("active") && (c = g);
                                }), c;
                            }, this.setActivePanel = (c)=>{
                                this.removeAttributes(this.DOMstrings.stepFormPanels, "active"), this.DOMstrings.stepFormPanels.forEach((g, A)=>{
                                    A === c && g.setAttribute("active", "");
                                });
                            }, this.setStepsNum = ()=>{
                                this.DOMstrings.stepsBtns.forEach((c, g)=>{
                                    c.setAttribute("step", g + 1);
                                });
                            }, this.setStep = (c)=>{
                                const g = c <= this.DOMstrings.stepsBtns.length ? c - 1 : 0;
                                this.setActivePanel(g), this.setFocusOnFirstElementPanel(g), this.setActiveStep(g);
                            }, this.collapseSteps = ()=>{
                                this.component.setAttribute("collapsed", "");
                            }, this.expandSteps = ()=>{
                                this.component.removeAttribute("collapsed");
                            }, this._setBehavior();
                        }
                        /**
               * Define os comportamentos do componente
               * @private
               */ _setBehavior() {
                            if (this.DOMstrings.stepsBar.addEventListener("click", (s)=>{
                                const c = s.target;
                                if (!c.classList.contains(`${this.DOMstrings.stepsBtnClass}`)) {
                                    s.target.parentNode.click();
                                    return;
                                }
                                const g = this.getActiveStep(c);
                                this.setActiveStep(g), this.setActivePanel(g), this.setFocusOnFirstElementPanel(g);
                            }), this.DOMstrings.stepsForm.addEventListener("click", (s)=>{
                                const c = s.target;
                                if (!(c.classList.contains(`${this.DOMstrings.stepPrevBtnClass}`) || c.classList.contains(`${this.DOMstrings.stepNextBtnClass}`))) return;
                                const g = this.findParent(c, `${this.DOMstrings.stepFormPanelClass}`);
                                let A = Array.from(this.DOMstrings.stepFormPanels).indexOf(g);
                                c.classList.contains(`${this.DOMstrings.stepPrevBtnClass}`) ? (A -= 1, g.style.left = "1%") : (A += 1, g.style.left = "-1%"), this.setActiveStep(A), this.setActivePanel(A), this.setFocusOnFirstElementPanel(A);
                            }), this.setStepsNum(), this.component.hasAttribute("step") && this.setStep(this.component.getAttribute("step")), this.component.hasAttribute("scroll") && !this.component.hasAttribute("vertical")) {
                                const s = Math.round(100 / this.DOMstrings.stepsBtns.length) - 0.5;
                                this.DOMstrings.stepsBar.style.gridTemplateColumns = `repeat(auto-fit, minmax(100px, ${s}% ))`;
                            }
                            const a = new k.A(this.DOMstrings.stepsBar);
                            this.component.hasAttribute("vertical") ? (a.on("SWIPE_LEFT", ()=>{
                                this.collapseSteps();
                            }), a.on("SWIPE_RIGHT", ()=>{
                                this.expandSteps();
                            }), this.DOMstrings.stepsForm.ontouchstart = ()=>{
                                this.collapseSteps();
                            }) : (this.DOMstrings.stepsBar.ontouchstart = ()=>{
                                this.expandSteps();
                            }, this.DOMstrings.stepsForm.ontouchstart = ()=>{
                                this.collapseSteps();
                            });
                        }
                    }
                    const m = b;
                },
                /***/ "./src/partial/js/behavior/accordion.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ default: ()=>/* binding */ b
                    });
                    var k = y("./src/partial/js/behavior/collapse.js");
                    class b extends k.default {
                        /**
               * Instancia um comportamento accordion
               * @param {object} - Objeto de configuração inicial para destructuring
               * @property {object} trigger - Elemento DOM que representa o acionador do comportmento accordion
               * @property {string} iconToShow - Classe que representa o ícone para mostrar o conteúdo (padrão: fa-chevron-down)
               * @property {string} iconToHide - Classe que representa o ícone para esconder o conteúdo (padrão: fa-chevron-up)
               * @property {boolean} useIcons - true: com ícone | false: sem ícone (padrão: true)
               */ constructor({ trigger: i, iconToShow: a = "fa-chevron-down", iconToHide: s = "fa-chevron-up", useIcons: c = !0 }){
                            super({
                                iconToHide: s,
                                iconToShow: a,
                                trigger: i,
                                useIcons: c
                            }), this._setUp();
                        }
                        /**
               * Trata a configuração inicial do comportamento accordion
               * @private
               */ _setUp() {
                            super._setUp(), this._setPriorityVisibility();
                        }
                        /**
               * Determina qual acionador vai estar visivel, caso mais de 1 acionador esteja visivel no grupo.
               * Prioridade de cima para baixo
               * @private
               */ _setPriorityVisibility() {
                            for(let i = 0; i < this._getGroup().length; i += 1)if (this._getGroup()[i].dataset.visible === "true") {
                                this._synchronizeAccordion(this._getGroup()[i]);
                                break;
                            }
                        }
                        /**
               * Handler para o evento de tecla pressionada (keydown) no acionador
               * @param {object} event - Objeto do tipo Event
               * @private
               */ _handleTriggerKeyPress(i) {
                            super._handleTriggerKeyPress(i);
                        }
                        /**
               * Configura o estado de visualização do comportamento collapse
               * @private
               */ _setVisibilityStatus() {
                            super._setVisibilityStatus();
                        }
                        /**
               * Obtém todos os acionadores pertencentes ao grupo do comportamento accordion
               * @returns {array} - Conjunto de elementos DOM representando os acionadores pertencentes ao grupo do comportamento accordion
               * @private
               */ _getGroup() {
                            return document.querySelectorAll(`[data-group="${this.trigger.getAttribute("data-group")}"]`);
                        }
                        /**
               * Handler para o evento 'change' do acionador
               * @param {object} event - Objeto do tipo Event
               * @private
               */ _handleTriggerChangeBehavior(i) {
                            i.currentTarget.hasAttribute("data-sync") ? i.currentTarget.removeAttribute("data-sync") : this._synchronizeAccordion(i.currentTarget);
                        }
                        /**
               * Sincroniza o grupo de accordion mostrando 1 elemento aberto por vez
               * @param {object} currentTrigger - Elemento DOM representando um acionador do comportamento accordion
               * @private
               */ _synchronizeAccordion(i) {
                            this._getGroup().forEach((a)=>{
                                a !== i && a.dataset.visible === "true" && (a.setAttribute("data-sync", ""), a.click());
                            });
                        }
                        /**
               * Configura o comportamento accordion
               * @public
               */ setBehavior() {
                            super.setBehavior(), this.trigger.addEventListener("change", this._handleTriggerChangeBehavior.bind(this));
                        }
                    }
                },
                /***/ "./src/partial/js/behavior/checkgroup.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ default: ()=>/* binding */ k
                    });
                    class k {
                        /**
               * Instancia um comportamento de grupo de checkbox
               * @param {object} trigger - Elemento DOM que representa o checkbox acionador do comportamento
               */ constructor(m){
                            this.parent = m, this.parent.indeterminate = this.parent.hasAttribute("indeterminate"), this.children = this._setChildren(m.dataset.parent);
                        }
                        /**
               * Pega dinamincamente o valor do atributo data-checked-label
               * @type {string} - O valor do atributo data-checked-label ou o valor da label, caso não tenha o atributo
               * @readonly
               * @public
               */ get checkedLabel() {
                            return this.parent.dataset.checkedLabel || this.parent.nextElementSibling.innerText;
                        }
                        /**
               * Pega dinamincamente o valor do atributo data-unchecked-label
               * @type {string} - O valor do atributo data-unchecked-label ou o valor da label, caso não tenha o atributo
               * @readonly
               * @public
               */ get uncheckedLabel() {
                            return this.parent.dataset.uncheckedLabel || this.parent.nextElementSibling.innerText;
                        }
                        /**
               * Configurar o comportamento do grupo de checkbox
               * @public
               */ setBehavior() {
                            this._setParentBehavior(), this._setChildBehavior();
                        }
                        /**
               * Obtem todos os checkboxes filhos do checkbox pai
               * @param {string} tag - Nome que indica a relação entre checkbox pai e checkbox filho
               * @returns {array} - Array contendo os elementos DOM que representam os checkboxes filhos.
               */ _setChildren(m) {
                            return document.querySelectorAll(`[data-child="${m}"]`);
                        }
                        /**
               * Trata do comportamento do checkbox pai
               * @private
               */ _setParentBehavior() {
                            this.parent.addEventListener("click", this._handleParentClick.bind(this)), this.parent.addEventListener("change", this._handleParentChange.bind(this));
                        }
                        /**
               * Handler que trata o evento click no parent
               * @private
               */ _handleParentClick() {
                            this.parent.hasAttribute("data-parent-sync") || this._setIndeterminateStateOnClick(), this._setParentCheckboxLabel();
                        }
                        /**
               * Trata o estado indeterminado no evento click da etapa de interação do usuário
               * @private
               */ _setIndeterminateStateOnClick() {
                            this.parent.hasAttribute("indeterminate") && (this.parent.removeAttribute("indeterminate"), this.parent.indeterminate = !1, this.parent.checked = !0);
                        }
                        /**
               * Handler que trata o evento change no parent
               * @private
               */ _handleParentChange() {
                            this.parent.hasAttribute("data-parent-sync") ? this.parent.removeAttribute("data-parent-sync") : (this._changeChildState(), this._setParentCheckboxLabel());
                        }
                        /**
               * Trata do estado do checkboxes filhos
               * @private
               */ _changeChildState() {
                            this.children.forEach((m)=>{
                                (m.checked !== this.parent.checked || m.hasAttribute("indeterminate")) && (m.removeAttribute("indeterminate"), m.indeterminate = !1, m.checked = this.parent.checked, m.dispatchEvent(new Event("change")));
                            });
                        }
                        /**
               * Trata do comportamento dos checkboxes filhos
               * @private
               */ _setChildBehavior() {
                            this.children.forEach((m)=>{
                                m.addEventListener("click", this._handleChildClick.bind(this)), m.addEventListener("change", this._handleChildChange.bind(this));
                            });
                        }
                        /**
               * Handler que trata do evento click no filho
               * @param {object} event - Objeto Event
               * @private
               */ _handleChildClick(m) {
                            m.currentTarget.setAttribute("data-child-sync", "");
                        }
                        /**
               * Handler que trata do evento change no filho
               * @param {object} event - Objeto Event
               * @private
               */ _handleChildChange(m) {
                            m.currentTarget.hasAttribute("data-child-sync") && (this._setIndeterminateStateOnChildChange(), this.parent.setAttribute("data-parent-sync", ""), this.parent.dispatchEvent(new Event("click")), this.parent.dispatchEvent(new Event("change")), m.currentTarget.removeAttribute("data-child-sync"));
                        }
                        /**
               * Trata o estado indeterminado no evento click da etapa de sincronia
               * @private
               */ _setIndeterminateStateOnChildChange() {
                            this._isAllChildrenChecked() ? (this.parent.removeAttribute("indeterminate"), this.parent.indeterminate = !1, this.parent.checked = !0) : this._isAllChildrenUnchecked() ? (this.parent.removeAttribute("indeterminate"), this.parent.indeterminate = !1, this.parent.checked = !1) : (this.parent.setAttribute("indeterminate", ""), this.parent.indeterminate = !0, this.parent.checked = !0);
                        }
                        /**
               * Verifica se todos os checkboxes filhos estão selecionados
               * @returns {boolean} - true se todos os checkboxes filhos estão selecionados
               *                      false se pelo menos 1 checkbox filho não está selecionado
               * @private
               */ _isAllChildrenChecked() {
                            let m = !0;
                            return this.children.forEach((i)=>{
                                (!i.checked || i.indeterminate) && (m = !1);
                            }), m;
                        }
                        /**
               * Verifica se todos so checkboxes filhos estão desselecionados
               * @returns {boolean} - true se todos os checkboxes filhos estão desselecionados
               *                      false se pelo menos 1 checkbox filho está selecionado
               * @private
               */ _isAllChildrenUnchecked() {
                            let m = !0;
                            return this.children.forEach((i)=>{
                                i.checked && (m = !1);
                            }), m;
                        }
                        /**
               * Configura a label do checkbox pai
               * @private
               */ _setParentCheckboxLabel() {
                            this.parent.checked && !this.parent.indeterminate ? (this.parent.nextElementSibling.innerHTML = this.uncheckedLabel, this.parent.setAttribute("aria-label", this.uncheckedLabel)) : (this.parent.nextElementSibling.innerHTML = this.checkedLabel, this.parent.setAttribute("aria-label", this.checkedLabel));
                        }
                    }
                },
                /***/ "./src/partial/js/behavior/collapse.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ default: ()=>/* binding */ k
                    });
                    class k {
                        /**
               * Instancia um comportamento collapse
               * @param {object} - Objeto de configuração inicial para destructuring
               * @property {object} trigger - Elemento DOM que representa o acionador do comportmento collapse
               * @property {string} iconToShow - Classe que representa o ícone para mostrar o conteúdo (padrão: fa-chevron-down)
               * @property {string} iconToHide - Classe que representa o ícone para esconder o conteúdo (padrão: fa-chevron-up)
               * @property {boolean} useIcons - true: com ícone | false: sem ícone (padrão: true)
               */ constructor({ trigger: m, iconToShow: i = "fa-chevron-down", iconToHide: a = "fa-chevron-up", useIcons: s = !0 }){
                            this.trigger = m, this.useIcons = s, this.breakpoint = m.getAttribute("data-breakpoint"), this.setIconToShow(i), this.setIconToHide(a), this._setTarget(), this._setUp();
                        }
                        /**
               * Determina qual elemento DOM é o alvo do comportamento collapse
               * @private
               */ _setTarget() {
                            this.target = document.querySelector(`#${this.trigger.getAttribute("data-target")}`);
                        }
                        // TODO: Melhorar a solução
                        _checkBreakpoint() {
                            this.breakpoint && window.matchMedia("(min-width: 977px)").matches && this.target.removeAttribute("hidden");
                        }
                        /**
               * Trata a configuração inicial do comportamento collapse
               * @private
               */ _setUp() {
                            this._setVisibilityStatus(), this.useIcons && this._toggleIcon(), this.trigger.setAttribute("aria-controls", `${this.trigger.getAttribute("data-target")}`), this._checkBreakpoint(), this.trigger.setAttribute("tabindex", "0");
                        }
                        /**
               * Configura o estado de visualização do comportamento collapse
               * @private
               */ _setVisibilityStatus() {
                            this._setTriggerVisibilityStatus(), this._setTargetVisibilityStatus();
                        }
                        /**
               * Trata o estado de visualização do acionador
               * @private
               */ _setTriggerVisibilityStatus() {
                            this.target && (this.target.hasAttribute("hidden") ? (this.trigger.setAttribute("data-visible", !1), this.trigger.setAttribute("aria-expanded", !1)) : (this.trigger.setAttribute("data-visible", !0), this.trigger.setAttribute("aria-expanded", !0)));
                        }
                        /**
               * Handler para o evento de tecla pressionada (keydown) no acionador
               * @private
               */ _handleTriggerKeyPress() {
                            this._handleTriggerClickBehavior();
                        }
                        /**
               * Trata o estado de visualização do alvo
               * @private
               */ _setTargetVisibilityStatus() {
                            this.target && (this.target.hasAttribute("hidden") ? this.target.setAttribute("aria-hidden", !0) : (this.target.setAttribute("aria-hidden", !1), this._focusOnFirstItem(this.target)));
                        }
                        /**
               * Handler para o evento de click no acionador do comportamento collapse
               * Lança um evento 'change' a cada troca
               * @private
               */ _handleTriggerClickBehavior() {
                            this.breakpoint ? window.matchMedia("(max-width: 977px)").matches && (this._toggleVisibility(), this.useIcons && this._toggleIcon(), this.trigger.dispatchEvent(new Event("change"))) : (this._toggleVisibility(), this.useIcons && this._toggleIcon(), this.trigger.dispatchEvent(new Event("change")));
                        }
                        /**
               * Alterna o estado de visualização do comportamento collapse
               * @private
               */ _toggleVisibility() {
                            this.target && (this.target.hasAttribute("hidden") ? this._showTarget() : this._hideTarget());
                        }
                        /**
               * Exibe o target
               * @private
               */ _showTarget() {
                            this.target.removeAttribute("hidden"), this._setVisibilityStatus(), this._focusOnFirstItem(this.target);
                        }
                        /**
               * Oculta o target
               * @private
               */ _hideTarget() {
                            this.target.setAttribute("hidden", ""), this._setVisibilityStatus();
                        }
                        /**
               * focar no primeiro elemento ao expandir
               * @private
               */ _focusOnFirstItem(m) {
                            const i = m.querySelectorAll('a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'), a = Array.from(i).find((s)=>!s.hasAttribute("hidden"));
                            a && a.scrollIntoView({
                                block: "nearest"
                            });
                        }
                        /**
               * Troca o icone do acionador após uma mudança no estado de visualização do alvo
               * Para o estado 'hidden' usa o iconToShow e para o estado 'shown' usa o iconToHide
               * @public
               */ _toggleIcon() {
                            this.trigger.querySelectorAll("i.fas").forEach((m)=>{
                                this.target && (m.classList.remove(this.target.hasAttribute("hidden") ? this.iconToHide : this.iconToShow), m.classList.add(this.target.hasAttribute("hidden") ? this.iconToShow : this.iconToHide));
                            });
                        }
                        /**
               * Configura o comportamento collapse
               * @public
               */ setBehavior() {
                            this.trigger.addEventListener("click", (m)=>{
                                m.type === "click" && this._handleTriggerClickBehavior();
                            }), this.trigger.addEventListener("keydown", (m)=>{
                                (m.key === "Enter" || m.key === " ") && (m.preventDefault(), this._handleTriggerKeyPress());
                            }), this.target.addEventListener("keydown", (m)=>{
                                m.key === "Escape" && !this.target.hasAttribute("hidden") && (m.preventDefault(), this._hideTarget(), this.trigger.focus());
                            });
                        }
                        /**
               * Determina a classe do icone para mostrar o conteúdo
               * @param {string} iconToShow - Classe que representa o ícone para mostrar o conteúdo
               * @public
               */ setIconToShow(m) {
                            this.iconToShow = m;
                        }
                        /**
               * Determina a classe do ícone para esconder o conteúdo
               * @param {string} iconToHide - Classe que representa o ícone para esconder o conteúdo
               * @public
               */ setIconToHide(m) {
                            this.iconToHide = m;
                        }
                    }
                },
                /***/ "./src/partial/js/behavior/dropdown.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ default: ()=>/* binding */ b
                    });
                    var k = y("./src/partial/js/behavior/collapse.js");
                    class b extends k.default {
                        /**
               * Instancia um comportamento accordion
               * @param {object} - Objeto de configuração inicial para destructuring
               * @property {object} trigger - Elemento DOM que representa o acionador do comportmento accordion
               * @property {string} iconToShow - Classe que representa o ícone para mostrar o conteúdo (padrão: fa-chevron-down)
               * @property {string} iconToHide - Classe que representa o ícone para esconder o conteúdo (padrão: fa-chevron-up)
               * @property {boolean} useIcons - true: com ícone | false: sem ícone (padrão: true)
               */ constructor({ trigger: i, iconToShow: a = "fa-chevron-down", iconToHide: s = "fa-chevron-up", useIcons: c = !0 }){
                            super({
                                iconToHide: s,
                                iconToShow: a,
                                trigger: i,
                                useIcons: c
                            });
                        }
                        /**
               * Trata a configuração inicial do comportamento dropdown
               * @override
               * @private
               */ _setUp() {
                            super._setUp(), this._hideDropdown(), this._initializeDropdownItems();
                        }
                        /**
               * Oculta o dropdown ao clicar fora do acionador e do alvo
               * @private
               */ _hideDropdown() {
                            document.addEventListener("mousedown", (i)=>{
                                !this.trigger.contains(i.target) && !this.target.hasAttribute("hidden") && !this.target.contains(i.target) && this.trigger.click();
                            });
                        }
                        /**
               * Marca o alvo com o atributo data-dropdown
               * @override
               * @private
               */ _setTargetVisibilityStatus() {
                            super._setTargetVisibilityStatus(), this.target.hasAttribute("hidden") ? this.target.removeAttribute("data-dropdown") : this.target.setAttribute("data-dropdown", "");
                        }
                        /**
               * Trata o estado de visualização do pai do alvo
               * @private
               */ _setParentsTargetVisibilityStatus() {
                            this.target.hasAttribute("hidden") ? this.target.parentElement.classList.remove("dropdown") : this.target.parentElement.classList.add("dropdown");
                        }
                        /**
               * Para itens pertencentes a dropdown do tipo menuitem, permite
               * o uso das teclas de seta para cima e para baixo do teclado.
               * @private
               */ _initializeDropdownItems() {
                            this.dropdownItems = Array.from(this.target.querySelectorAll('[role="menuitem"]')), this.dropdownItems.forEach((i)=>{
                                i.addEventListener("keydown", (a)=>{
                                    const s = a.key, c = this.dropdownItems.indexOf(i);
                                    switch(this.dropdownItems.length, s){
                                        case "ArrowUp":
                                            a.preventDefault();
                                            const g = (c - 1 + this.dropdownItems.length) % this.dropdownItems.length;
                                            this.dropdownItems[g].focus();
                                            break;
                                        case "ArrowDown":
                                            a.preventDefault();
                                            const A = (c + 1) % this.dropdownItems.length;
                                            this.dropdownItems[A].focus();
                                            break;
                                    }
                                });
                            });
                        }
                        /**
               * Handler para o evento de click no acionador do comportamento dropdown
               * Lança um evento 'change' a cada troca
               * @override
               * @private
               */ _handleTriggerClickBehavior() {
                            super._handleTriggerClickBehavior(), this._setParentsTargetVisibilityStatus();
                        }
                        /**
               * Configura o comportamento dropdown
               * @override
               * @public
               */ setBehavior() {
                            super.setBehavior();
                        }
                    }
                },
                /***/ "./src/partial/js/behavior/scrim.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ default: ()=>/* binding */ k
                    });
                    class k {
                        /**
               * Instancia um comportamento scrim
               * @param {object} - Objeto de configuração inicial para destructuring
               * @property {object} trigger - Elemento DOM que representa o acionador do comportmento scrim
               * @property {string} closeElement - Elemento Dom do trigger que fecha o scrim
               * @property {boolean} escEnable - Habilita a tecla ESC do teclado para fechar o scrim
               * @property {boolean} limitTabKey - Impede a navegação via tab fora da modal
               */ constructor({ trigger: m, closeElement: i = "", escEnable: a = !1, limitTabKey: s = !1 }){
                            this.trigger = m, this.escEnable = a, this.limitTabKey = s, this.closeElement = this.elementHideScrim(i), this.trigger && this.setBehavior();
                        }
                        /**
               * Alterna o estado de visualização do comportamento scrim
               * @private
               */ showScrim() {
                            if (this.trigger) {
                                if (this.trigger.classList.add("active"), this.trigger.children.length > 0) {
                                    const m = this.trigger.children[0];
                                    m.setAttribute("aria-modal", "true"), m.setAttribute("role", "dialog"), m.setAttribute("data-visible", "true");
                                }
                                this._setFocusFirstElement(), this.limitTabKey && this.limitTabNavigation();
                            }
                        }
                        /**
               * Ativa o foco para o primeiro elemento com zindex maior ou igual a zero
               * @private
               */ _setFocusFirstElement() {
                            const m = this._getInternalElementsFocusable();
                            m.length > 0 && m[0].focus();
                        }
                        /**
               * Limita a navegação via Tab
               * @private
               */ limitTabNavigation() {
                            document.addEventListener("focusin", (function(m) {
                                let i = m.target;
                                var a = !1;
                                this._getInternalElementsFocusable().forEach(function(c) {
                                    i == c && (a = !0);
                                }), a || (m.preventDefault(), this._setFocusFirstElement());
                            }).bind(this));
                        }
                        /**
               * retorna os elementos internos que podem receber o estado de foco
               * @private
               */ _getInternalElementsFocusable() {
                            return Array.from(this.trigger.querySelectorAll("*")).filter((m)=>m.tabIndex >= 0);
                        }
                        /**
               * Alterna o estado de escondido do comportamento scrim
               * @private
               */ hideScrim() {
                            this.trigger.classList.remove("active"), this.trigger.setAttribute("data-visible", !1);
                        }
                        /**
               * Seta o elemento Dom que vai fechar o scrim e adiciona o listener para fechar com ESC
               * @public
               */ elementHideScrim(m) {
                            this.hideElements(m), this.addEscapeListener();
                        }
                        /**
               * Seta o elemento Dom que vai fechar o scrim
               * @public
               */ hideElements(m) {
                            m && this.trigger.querySelectorAll([
                                m
                            ]).forEach((i)=>{
                                this.closeElement = i, this._setCloseClick();
                            }), this.trigger.querySelectorAll("[data-dismiss=true]").forEach((i)=>{
                                this.closeElement = i, this._setCloseClick();
                            });
                        }
                        /**
               * Adiciona um listener para fechar o scrim com ESC quando o escEnable estiver como true
               */ addEscapeListener() {
                            this.escEnable && document.addEventListener("keydown", (m)=>{
                                m.key === "Escape" && this.hideScrim();
                            });
                        }
                        /**
               * Adiciona listener de fechamento no elemento que fecha o scrim
               * @private
               */ _setCloseClick() {
                            this.closeElement.addEventListener("click", ()=>{
                                this.hideScrim();
                            });
                        }
                        /**
               * Configura o comportamento scrim
               * @public
               */ setBehavior() {
                            this.trigger.addEventListener("click", (m)=>{
                                m.target.getAttribute("data-scrim") && this.hideScrim();
                            });
                        }
                    }
                },
                /***/ "./src/partial/js/behavior/swipe.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ A: ()=>b
                    });
                    class k {
                        constructor(i){
                            this.evtMap = {
                                SWIPE_DOWN: [],
                                SWIPE_LEFT: [],
                                SWIPE_RIGHT: [],
                                SWIPE_UP: []
                            }, this.xDown = null, this.yDown = null, this.element = i, i.addEventListener("touchstart", (a)=>this.handleTouchStart(a), !1), i.addEventListener("touchend", (a)=>this.handleTouchEnd(a), !1);
                        }
                        on(i, a) {
                            this.evtMap[i].push(a);
                        }
                        off(i, a) {
                            this.evtMap[i] = this.evtMap[i].filter((s)=>s !== a);
                        }
                        trigger(i, a) {
                            this.evtMap[i].map((s)=>s(a));
                        }
                        handleTouchStart(i) {
                            this.xDown = i.touches[0].clientX, this.yDown = i.touches[0].clientY;
                        }
                        handleTouchEnd(i) {
                            const a = i.changedTouches[0].clientX - this.xDown, s = i.changedTouches[0].clientY - this.yDown;
                            Math.abs(a) > Math.abs(s) ? a < 0 ? this.trigger("SWIPE_LEFT") : this.trigger("SWIPE_RIGHT") : s > 0 ? this.trigger("SWIPE_DOWN") : this.trigger("SWIPE_UP");
                        }
                    }
                    const b = k;
                },
                /***/ "./src/partial/js/behavior/tooltip.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        /* harmony export */ default: ()=>m
                    });
                    var k = y("./node_modules/@popperjs/core/lib/popper.js");
                    class b {
                        /**
               * Instancia um comportamento Tooltip
               * @param {object} - Objeto de configuração inicial para tooltip
               * @property {object} component - Elemento DOM do tooltip (opcional se tiver o textTooltip)
               * @property {object} activator - Elemento DOM que representa o acionador do comportmento tooltip
               * @property {string} place -Local onde vai aparecer o tooltip ('top', 'right', 'bottom', 'left')
               * @property {string} timer - Tempo em que vai aparecer o tooltip em milisegunto (opcional)
               * @property {string} textTooltip - Texto que vai ser mostrado quando não estiver instaciado o atributo component
               * @property {string} type - Tipo de tooltip (info, warning) padrão info
               * @property {boolean} onActivator - Adiciona o tooltip dentro do elemento ativador padrão false
               */ constructor({ component: a, activator: s, place: c = "top", timer: g, active: A, textTooltip: F, type: $ = "info", onActivator: J = !1 }){
                            const se = F || a;
                            if (typeof se > "u") return;
                            this.onActivator = J, this.activator = s, this.component = a || this._setContent(se, $), this.place = this.component.getAttribute("place") === null ? this.component.getAttribute("place") : c;
                            const Q = [
                                "top",
                                "right",
                                "bottom",
                                "left"
                            ];
                            this.popover = this.component.hasAttribute("popover"), this.notification = this.component.classList.contains("br-notification"), this.timer = this.component.getAttribute("timer") ? this.component.getAttribute("timer") : g, this.active = this.component.hasAttribute("active") ? this.component.hasAttribute("active") : A, this.placement = Q.includes(c) ? c : this.notification, this.popperInstance = null, this.showEvents = [
                                "mouseenter",
                                "click",
                                "focus"
                            ], this.hideEvents = [
                                "mouseleave",
                                "blur"
                            ], this.closeTimer = null, this._create(), this._setBehavior();
                        }
                        /**
               * Instancializa o behavior
               */ _setBehavior() {
                            this.activator && this.showEvents.forEach((a)=>{
                                this.activator.addEventListener(a, (s)=>{
                                    this._show(s);
                                });
                            }), this.popover ? this.component.querySelector(".close").addEventListener("click", (s)=>{
                                this._hide(s, this.component), this._toggleActivatorIcon();
                            }) : this.hideEvents.forEach((a)=>{
                                this.activator.addEventListener(a, (s)=>{
                                    this._hide(s, this.component);
                                });
                            });
                        }
                        /**
               * Inclui o conteudo do tooltip
               * @param {*} contentText conteudo do texto do tooltip
               * @param {*} type tipo de tooltip
               * @returns  - retorna o objeto com tooltip
               */ _setContent(a, s) {
                            const c = document.createElement("div");
                            return c.setAttribute("role", "tooltip"), c.setAttribute("place", "top"), c.setAttribute(s, s), c.innerText = `${a}`, c.classList.add("br-tooltip"), c.classList.add("sample"), this.activator && this.onActivator ? this.activator.appendChild(c) : document.body.appendChild(c), c;
                        }
                        /**
               * Cria a instancia do popper
               * @private
               */ _create() {
                            this._setLayout(), this.notification ? (this.component.setAttribute("notification", ""), this.popperInstance = (0, k.n4)(this.activator, this.component, {
                                modifiers: [
                                    {
                                        name: "offset",
                                        options: {
                                            offset: [
                                                0,
                                                8
                                            ]
                                        }
                                    },
                                    {
                                        name: "preventOverflow",
                                        options: {
                                            altAxis: !1,
                                            // false by default
                                            mainAxis: !0
                                        }
                                    },
                                    {
                                        name: "flip",
                                        options: {
                                            fallbackPlacements: [
                                                "top",
                                                "right"
                                            ]
                                        }
                                    }
                                ],
                                // placement: this.placement,
                                placement: "bottom",
                                strategy: "fixed"
                            })) : this.popperInstance = (0, k.n4)(this.activator, this.component, {
                                modifiers: [
                                    {
                                        name: "offset",
                                        options: {
                                            offset: [
                                                0,
                                                8
                                            ]
                                        }
                                    },
                                    {
                                        name: "preventOverflow",
                                        options: {
                                            altAxis: !0,
                                            mainAxis: !0
                                        }
                                    },
                                    {
                                        name: "flip",
                                        options: {
                                            fallbackPlacements: [
                                                "top",
                                                "right",
                                                "bottom",
                                                "left"
                                            ]
                                        }
                                    }
                                ],
                                placement: this.placement
                            });
                        }
                        /**
               * Mostra o tooltip e define o timeout se tiver
               * @param {object} event  evento javascript
               */ _show(a) {
                            this.component.style.display = "unset", this.component.setAttribute("data-show", ""), this.component.style.zIndex = 9999, this.popperInstance.update(), this.component.style.visibility = "visible", this.timer && (clearTimeout(this.closeTimer), this.closeTimer = setTimeout(this._hide, this.timer, a, this.component));
                        }
                        /**
               * Esconde o componente
               * @private
               */ _hide(a, s) {
                            s.removeAttribute("data-show"), s.style.zIndex = -1, s.style.visibility = "hidden", clearTimeout(s.closeTimer);
                        }
                        /**
               * Cria o laytout do tooltip
               * @private
               */ _setLayout() {
                            const a = document.createElement("div");
                            if (a.setAttribute("data-popper-arrow", ""), this.component.querySelectorAll(".arrow").length < 1 && a.classList.add("arrow"), this.component.appendChild(a), this.popover) {
                                const s = document.createElement("button");
                                s.setAttribute("type", "button"), s.classList.add("close");
                                const c = document.createElement("i");
                                c.classList.add("fas", "fa-times"), s.appendChild(c), this.component.appendChild(s);
                            }
                        }
                        /**
               * Muda icone da seta
               * @private
               */ _toggleActivatorIcon() {
                            const a = this.activator.querySelector("button svg");
                            a && (a.classList.toggle("fa-angle-down"), a.classList.toggle("fa-angle-up")), this.activator.toggleAttribute("active");
                        }
                    }
                    const m = b;
                },
                /***/ "./src/partial/js/globals-class.js": /***/ (E, S, y)=>{
                    y.d(S, {
                        Dropdown: ()=>/* reexport */ qe.default,
                        Globals: ()=>/* binding */ Fe
                    });
                    var k = y("./src/components/accordion/accordion.js"), b = y("./src/components/avatar/avatar.js"), m = y("./src/components/breadcrumb/breadcrumb.js"), i = y("./src/components/card/card.js"), a = y("./src/components/carousel/carousel.js"), s = y("./src/components/checkbox/checkbox.js"), c = y("./src/components/cookiebar/cookiebar.js"), g = y("./src/components/cookiebar/jsonData.js"), A = y("./src/components/datetimepicker/datetimepicker.js"), F = y("./src/components/footer/footer.js"), $ = y("./src/components/header/header.js"), J = y("./src/components/input/input.js");
                    const Q = [
                        "Afeganist\xe3o",
                        "\xc1frica do Sul",
                        "Alb\xe2nia",
                        "Alemanha",
                        "Andorra",
                        "Angola",
                        "Anguilla",
                        "Ant\xe1rtida",
                        "Ant\xedgua e Barbuda",
                        "Antilhas Holandesas",
                        "Ar\xe1bia Saudita",
                        "Arg\xe9lia",
                        "Argentina",
                        "Arm\xeania",
                        "Aruba",
                        "Austr\xe1lia",
                        "\xc1ustria",
                        "Azerbaij\xe3o",
                        "Bahamas",
                        "Bahrein",
                        "Bangladesh",
                        "Barbados",
                        "Belarus",
                        "B\xe9lgica",
                        "Belize",
                        "Benin",
                        "Bermudas",
                        "Bol\xedvia",
                        "B\xf3snia-Herzeg\xf3vina",
                        "Botsuana",
                        "Brasil",
                        "Brunei",
                        "Bulg\xe1ria",
                        "Burkina Fasso",
                        "Burundi",
                        "But\xe3o",
                        "Cabo Verde",
                        "Camar\xf5es",
                        "Camboja",
                        "Canad\xe1",
                        "Cazaquist\xe3o",
                        "Chade",
                        "Chile",
                        "China",
                        "Chipre",
                        "Cingapura",
                        "Col\xf4mbia",
                        "Congo",
                        "Cor\xe9ia do Norte",
                        "Cor\xe9ia do Sul",
                        "Costa do Marfim",
                        "Costa Rica",
                        "Cro\xe1cia (Hrvatska)",
                        "Cuba",
                        "Dinamarca",
                        "Djibuti",
                        "Dominica",
                        "Egito",
                        "El Salvador",
                        "Emirados \xc1rabes Unidos",
                        "Equador",
                        "Eritr\xe9ia",
                        "Eslov\xe1quia",
                        "Eslov\xeania",
                        "Espanha",
                        "Estados Unidos",
                        "Est\xf4nia",
                        "Eti\xf3pia",
                        "Fiji",
                        "Filipinas",
                        "Finl\xe2ndia",
                        "Fran\xe7a",
                        "Gab\xe3o",
                        "G\xe2mbia",
                        "Gana",
                        "Ge\xf3rgia",
                        "Gibraltar",
                        "Gr\xe3-Bretanha (Reino Unido, UK)",
                        "Granada",
                        "Gr\xe9cia",
                        "Groel\xe2ndia",
                        "Guadalupe",
                        "Guam (Territ\xf3rio dos Estados Unidos)",
                        "Guatemala",
                        "Guernsey",
                        "Guiana",
                        "Guiana Francesa",
                        "Guin\xe9",
                        "Guin\xe9 Equatorial",
                        "Guin\xe9-Bissau",
                        "Haiti",
                        "Holanda",
                        "Honduras",
                        "Hong Kong",
                        "Hungria",
                        "I\xeamen",
                        "Ilha Bouvet (Territ\xf3rio da Noruega)",
                        "Ilha do Homem",
                        "Ilha Natal",
                        "Ilha Pitcairn",
                        "Ilha Reuni\xe3o",
                        "Ilhas Aland",
                        "Ilhas Cayman",
                        "Ilhas Cocos",
                        "Ilhas Comores",
                        "Ilhas Cook",
                        "Ilhas Faroes",
                        "Ilhas Falkland (Malvinas)",
                        "Ilhas Ge\xf3rgia do Sul e Sandwich do Sul",
                        "Ilhas Heard e McDonald (Territ\xf3rio da Austr\xe1lia)",
                        "Ilhas Marianas do Norte",
                        "Ilhas Marshall",
                        "Ilhas Menores dos Estados Unidos",
                        "Ilhas Norfolk",
                        "Ilhas Seychelles",
                        "Ilhas Solom\xe3o",
                        "Ilhas Svalbard e Jan Mayen",
                        "Ilhas Tokelau",
                        "Ilhas Turks e Caicos",
                        "Ilhas Virgens (Estados Unidos)",
                        "Ilhas Virgens (Inglaterra)",
                        "Ilhas Wallis e Futuna",
                        "\xedndia",
                        "Indon\xe9sia",
                        "Ir\xe3",
                        "Iraque",
                        "Irlanda",
                        "Isl\xe2ndia",
                        "Israel",
                        "It\xe1lia",
                        "Jamaica",
                        "Jap\xe3o",
                        "Jersey",
                        "Jord\xe2nia",
                        "K\xeania",
                        "Kiribati",
                        "Kuait",
                        "Laos",
                        "L\xe1tvia",
                        "Lesoto",
                        "L\xedbano",
                        "Lib\xe9ria",
                        "L\xedbia",
                        "Liechtenstein",
                        "Litu\xe2nia",
                        "Luxemburgo",
                        "Macau",
                        "Maced\xf4nia (Rep\xfablica Yugoslava)",
                        "Madagascar",
                        "Mal\xe1sia",
                        "Malaui",
                        "Maldivas",
                        "Mali",
                        "Malta",
                        "Marrocos",
                        "Martinica",
                        "Maur\xedcio",
                        "Maurit\xe2nia",
                        "Mayotte",
                        "M\xe9xico",
                        "Micron\xe9sia",
                        "Mo\xe7ambique",
                        "Moldova",
                        "M\xf4naco",
                        "Mong\xf3lia",
                        "Montenegro",
                        "Montserrat",
                        "Myanma",
                        "Nam\xedbia",
                        "Nauru",
                        "Nepal",
                        "Nicar\xe1gua",
                        "N\xedger",
                        "Nig\xe9ria",
                        "Niue",
                        "Noruega",
                        "Nova Caled\xf4nia",
                        "Nova Zel\xe2ndia",
                        "Om\xe3",
                        "Palau",
                        "Panam\xe1",
                        "Papua-Nova Guin\xe9",
                        "Paquist\xe3o",
                        "Paraguai",
                        "Peru",
                        "Polin\xe9sia Francesa",
                        "Pol\xf4nia",
                        "Porto Rico",
                        "Portugal",
                        "Qatar",
                        "Quirguist\xe3o",
                        "Rep\xfablica Centro-Africana",
                        "Rep\xfablica Democr\xe1tica do Congo",
                        "Rep\xfablica Dominicana",
                        "Rep\xfablica Tcheca",
                        "Rom\xeania",
                        "Ruanda",
                        "R\xfassia (antiga URSS) - Federa\xe7\xe3o Russa",
                        "Saara Ocidental",
                        "Saint Vincente e Granadinas",
                        "Samoa Americana",
                        "Samoa Ocidental",
                        "San Marino",
                        "Santa Helena",
                        "Santa L\xfacia",
                        "S\xe3o Bartolomeu",
                        "S\xe3o Crist\xf3v\xe3o e N\xe9vis",
                        "S\xe3o Martim",
                        "S\xe3o Tom\xe9 e Pr\xedncipe",
                        "Senegal",
                        "Serra Leoa",
                        "S\xe9rvia",
                        "S\xedria",
                        "Som\xe1lia",
                        "Sri Lanka",
                        "St. Pierre and Miquelon",
                        "Suazil\xe2ndia",
                        "Sud\xe3o",
                        "Su\xe9cia",
                        "Su\xed\xe7a",
                        "Suriname",
                        "Tadjiquist\xe3o",
                        "Tail\xe2ndia",
                        "Taiwan",
                        "Tanz\xe2nia",
                        "Territ\xf3rio Brit\xe2nico do Oceano \xedndico",
                        "Territ\xf3rios do Sul da Fran\xe7a",
                        "Territ\xf3rios Palestinos Ocupados",
                        "Timor Leste",
                        "Togo",
                        "Tonga",
                        "Trinidad and Tobago",
                        "Tun\xedsia",
                        "Turcomenist\xe3o",
                        "Turquia",
                        "Tuvalu",
                        "Ucr\xe2nia",
                        "Uganda",
                        "Uruguai",
                        "Uzbequist\xe3o",
                        "Vanuatu",
                        "Vaticano",
                        "Venezuela",
                        "Vietn\xe3",
                        "Z\xe2mbia",
                        "Zimb\xe1bue"
                    ];
                    var _e = y("./src/components/item/item.js"), H = y("./src/components/list/list.js"), Y = y("./src/components/menu/menu.js"), z = y("./src/components/message/message.js");
                    y("./src/components/modal/modal.js");
                    var V = y("./src/components/notification/notification.js"), fe = y("./src/components/pagination/pagination.js"), xe = y("./src/components/scrim/scrim.js"), le = y("./src/components/select/select.js"), Ne = y("./src/components/step/step.js"), ue = y("./src/components/tab/tab.js"), K = y("./src/components/table/table.js"), Ae = y("./src/components/tag/tag.js"), we = y("./src/components/textarea/textarea.js"), me = y("./src/components/tooltip/tooltip.js"), ve = y("./src/components/upload/upload.js"), Ce = y("./src/components/wizard/wizard.js");
                    y("./src/partial/js/behavior/accordion.js");
                    var qe = y("./src/partial/js/behavior/dropdown.js"), Be = y("./src/partial/js/behavior/scrim.js");
                    class Fe {
                        initInstanceAll() {
                            this.initInstanceAccordion(), this.initInstanceAvatar(), this.initInstanceBreadcrumb(), this.initInstanceCard(), this.initInstanceCarousel(), this.initInstanceCheckbox(), this.initInstanceCookiebar(), this.initInstanceDateTimePicker(), this.initInstanceFooter(), this.initInstanceInput(), this.initInstanceHeader(), this.initInstanceItem(), this.initInstanceList(), this.initInstanceMenu(), this.initInstanceMessage(), this.initInstanceModal(), this.initInstanceNotification(), this.initInstancePagination(), this.initInstanceScrim(), this.initInstanceSelect(), this.initInstanceStep(), this.initInstanceTable(), this.initInstanceTabs(), this.initInstanceTextarea(), this.initInstanceUpload(), this.initInstanceWizard(), this.initInstanceTooltip();
                        }
                        initInstanceAccordion() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-accordion"))ge.push(new k.A("br-accordion", ne));
                        }
                        initInstanceAvatar() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-avatar"))ge.push(new b.A("br-avatar", ne));
                        }
                        initInstanceBreadcrumb() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-breadcrumb"))ge.push(new m.A("br-breadcrumb", ne));
                        }
                        initInstanceDateTimePicker() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-datetimepicker"))ge.push(new A.A("br-datetimepicker", ne, {}));
                        }
                        initInstanceHeader() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-header"))ge.push(new $.A("br-header", ne));
                        }
                        initInstanceFooter() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-footer"))ge.push(new F.A("br-footer", ne));
                        }
                        initInstanceInput() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-input"))ge.push(new J.A("br-input", ne));
                            for (const ne of ge)ne.component.querySelectorAll("input.search-autocomplete").forEach(()=>{
                                ne.setAutocompleteData(Q);
                            });
                        }
                        initInstanceItem() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-item"))ge.push(new _e.A("br-item", ne));
                        }
                        initInstanceList() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-list:not([data-sub])"))ge.push(new H.A("br-list", ne));
                        }
                        initInstanceMenu() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-menu"))ge.push(new Y.A("br-menu", ne));
                        }
                        initInstanceMessage() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-message"))ge.push(new z.A("br-message", ne));
                        }
                        initInstanceModal() {
                            const ge = window.document.querySelector("#buttonactivatemodal");
                            if (ge) {
                                const ne = window.document.querySelector("#scrimutilexamplemodal"), ut = new Be.default({
                                    trigger: ne,
                                    escEnable: !0,
                                    limitTabKey: !0
                                });
                                ge.addEventListener("click", (M)=>{
                                    ut.showScrim();
                                });
                            }
                        }
                        initInstanceNotification() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-notification"))ge.push(new V.A("br-notification", ne));
                        }
                        initInstancePagination() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-pagination"))ge.push(new fe.A("br-pagination", ne));
                        }
                        initInstanceScrim() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-scrim"))ge.push(new xe.A("br-scrim", ne));
                            for (const ne of window.document.querySelectorAll(".bloco1 button"))ne.addEventListener("click", ()=>{
                                for (const ut of ge)ut.showScrim();
                            });
                        }
                        initInstanceSelect() {
                            for (const ge of window.document.querySelectorAll(".br-select"))new le.A("br-select", ge);
                        }
                        initInstanceTable() {
                            const ge = [];
                            for (const [ne, ut] of window.document.querySelectorAll(".br-table").entries())ge.push(new K.A("br-table", ut, ne));
                        }
                        initInstanceTag() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-tag"))ge.push(new Ae.A("br-tag", ne));
                        }
                        initInstanceTabs() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-tab"))ge.push(new ue.A("br-tab", ne));
                        }
                        initInstanceTooltip() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-tooltip"))ge.push(new me.A("br-tooltip", ne));
                        }
                        initInstanceUpload() {
                            const ge = [];
                            function ne() {
                                return new Promise((ut)=>setTimeout(ut, 500));
                            }
                            for (const ut of window.document.querySelectorAll(".br-upload"))ge.push(new ve.A("br-upload", ut, ne));
                        }
                        initInstanceStep() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-step"))ge.push(new Ne.A("br-step", ne));
                        }
                        initInstanceCard() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-card"))ge.push(new i.A("br-card", ne));
                        }
                        initInstanceCarousel() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-carousel"))ge.push(new a.A("br-carousel", ne));
                        }
                        initInstanceCheckbox() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-checkbox"))ge.push(new s.A("br-checkbox", ne));
                        }
                        initInstanceCookiebar() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-cookiebar")){
                                const ut = {
                                    // callback: (outputJSON) => { console.log(JSON.parse(outputJSON)) console.log(outputJSON) },
                                    component: ne,
                                    json: g.default,
                                    lang: "pt-br",
                                    mode: "default",
                                    name: "br-cookiebar"
                                };
                                ge.push(new c.A(ut));
                            }
                        }
                        initInstanceTextarea() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-textarea"))ge.push(new we.A("br-textarea", ne));
                        }
                        initInstanceWizard() {
                            const ge = [];
                            for (const ne of window.document.querySelectorAll(".br-wizard"))ge.push(new Ce.A("br-wizard", ne));
                        }
                    }
                }
            }, L = {};
            function _(E) {
                var S = L[E];
                if (S !== void 0) return S.exports;
                var y = L[E] = {
                    /******/ // no module.id needed
                    /******/ // no module.loaded needed
                    /******/ exports: {}
                };
                return u[E].call(y.exports, y, y.exports, _), y.exports;
            }
            _.d = (E, S)=>{
                for(var y in S)_.o(S, y) && !_.o(E, y) && Object.defineProperty(E, y, {
                    enumerable: !0,
                    get: S[y]
                });
            }, _.o = (E, S)=>Object.prototype.hasOwnProperty.call(E, S), _.r = (E)=>{
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(E, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(E, "__esModule", {
                    value: !0
                });
            };
            var I = {};
            return (()=>{
                _.r(I), _.d(I, {
                    Accordion: ()=>/* reexport */ K.default,
                    BRAccordion: ()=>/* reexport */ E.A,
                    BRAlert: ()=>/* reexport */ $.A,
                    BRBreadcrumb: ()=>/* reexport */ S.A,
                    BRCard: ()=>/* reexport */ y.A,
                    BRCarousel: ()=>/* reexport */ k.A,
                    BRCheckbox: ()=>/* reexport */ b.A,
                    BRCookiebar: ()=>/* reexport */ m.A,
                    BRDateTimePicker: ()=>/* reexport */ i.A,
                    BRFooter: ()=>/* reexport */ a.A,
                    BRHeader: ()=>/* reexport */ s.A,
                    BRInput: ()=>/* reexport */ c.A,
                    BRItem: ()=>/* reexport */ g.A,
                    BRList: ()=>/* reexport */ A.A,
                    BRMenu: ()=>/* reexport */ F.A,
                    BRModal: ()=>/* reexport */ J.A,
                    BRNotification: ()=>/* reexport */ se.A,
                    BRPagination: ()=>/* reexport */ Q.A,
                    BRScrim: ()=>/* reexport */ _e.A,
                    BRSelect: ()=>/* reexport */ H.A,
                    BRStep: ()=>/* reexport */ Y.A,
                    BRTab: ()=>/* reexport */ z.A,
                    BRTable: ()=>/* reexport */ V.A,
                    BRTag: ()=>/* reexport */ fe.A,
                    BRTextarea: ()=>/* reexport */ xe.A,
                    BRTooltip: ()=>/* reexport */ le.A,
                    BRUpload: ()=>/* reexport */ Ne.A,
                    BRWizard: ()=>/* reexport */ ue.A,
                    Checkgroup: ()=>/* reexport */ Ae.default,
                    Collapse: ()=>/* reexport */ we.default,
                    Dropdown: ()=>/* reexport */ oe.Dropdown,
                    Globals: ()=>/* reexport */ oe.Globals,
                    Scrim: ()=>/* reexport */ me.default,
                    Swipe: ()=>/* reexport */ ve.A,
                    Tooltip: ()=>/* reexport */ Ce.default,
                    behavior: ()=>/* binding */ He,
                    globals: ()=>/* binding */ be
                }), _("./node_modules/focus-visible/dist/focus-visible.js");
                var E = _("./src/components/accordion/accordion.js"), S = _("./src/components/breadcrumb/breadcrumb.js"), y = _("./src/components/card/card.js"), k = _("./src/components/carousel/carousel.js"), b = _("./src/components/checkbox/checkbox.js"), m = _("./src/components/cookiebar/cookiebar.js"), i = _("./src/components/datetimepicker/datetimepicker.js"), a = _("./src/components/footer/footer.js"), s = _("./src/components/header/header.js"), c = _("./src/components/input/input.js"), g = _("./src/components/item/item.js"), A = _("./src/components/list/list.js"), F = _("./src/components/menu/menu.js"), $ = _("./src/components/message/message.js"), J = _("./src/components/modal/modal.js"), se = _("./src/components/notification/notification.js"), Q = _("./src/components/pagination/pagination.js"), _e = _("./src/components/scrim/scrim.js"), H = _("./src/components/select/select.js"), Y = _("./src/components/step/step.js"), z = _("./src/components/tab/tab.js"), V = _("./src/components/table/table.js"), fe = _("./src/components/tag/tag.js"), xe = _("./src/components/textarea/textarea.js"), le = _("./src/components/tooltip/tooltip.js"), Ne = _("./src/components/upload/upload.js"), ue = _("./src/components/wizard/wizard.js"), K = _("./src/partial/js/behavior/accordion.js"), Ae = _("./src/partial/js/behavior/checkgroup.js"), we = _("./src/partial/js/behavior/collapse.js"), me = _("./src/partial/js/behavior/scrim.js"), ve = _("./src/partial/js/behavior/swipe.js"), Ce = _("./src/partial/js/behavior/tooltip.js");
                class qe {
                    /**
           * Instancia um exemplo de comportamento accordion
           * @param {object} element - Elemento DOM que representa um componente contento um comportamento de accordion
           */ constructor(pe){
                        this.element = pe, this._setBehavior();
                    }
                    /**
           * Inicia comportamento do exemplo
           */ _setBehavior() {
                        this._setAccordionBehavior();
                    }
                    /**
           * Encontra os data-toggle accordion  e coloca util Accordion
           */ _setAccordionBehavior() {
                        this.element.querySelectorAll('[data-toggle="accordion"]').forEach((pe)=>{
                            const Le = {
                                iconToHide: "fa-chevron-up",
                                iconToShow: "fa-chevron-down",
                                trigger: pe,
                                useIcons: !0
                            };
                            new K.default(Le).setBehavior();
                        });
                    }
                }
                const Be = qe;
                class Fe {
                    /**
           * Instancia um exemplo de comportamento checkgroup
           * @param {object} element - Elemento DOM que representa um componente contento um comportamento de checkgroup
           */ constructor(pe){
                        this.element = pe, this._setBehavior();
                    }
                    /**
           * Inicia comportamento do exemplo
           * @private
           */ _setBehavior() {
                        this._setCheckgroupBehavior();
                    }
                    /**
           * Encontra os data-toggle checkbox  com data-parent e coloca util Checkgroup
           * @private
           */ _setCheckgroupBehavior() {
                        this.element.querySelectorAll('input[type="checkbox"][data-parent]').forEach((pe)=>{
                            new Ae.default(pe).setBehavior();
                        });
                    }
                }
                const Re = Fe;
                class ge {
                    /**
           * Instancia um exemplo de comportamento collapse
           * @param {object} element - Elemento DOM que representa um componente contento um comportamento de collapse
           */ constructor(pe){
                        this.element = pe, this._setBehavior();
                    }
                    /**
           * Instancia o utilitario
           * @private
           */ _setBehavior() {
                        this._setCollapseBehavior();
                    }
                    /**
           * Instancia o utilitario no data-toggle collapse
           * @private
           */ _setCollapseBehavior() {
                        this.element.querySelectorAll('[data-toggle="collapse"]').forEach((pe)=>{
                            const Le = {
                                iconToHide: "fa-chevron-up",
                                iconToShow: "fa-chevron-down",
                                trigger: pe,
                                useIcons: !0
                            };
                            new we.default(Le).setBehavior();
                        });
                    }
                }
                const ne = ge;
                var ut = _("./src/partial/js/behavior/dropdown.js");
                class M {
                    /**
           * Instancia um exemplo de comportamento dropdown
           * @param {object} element - Elemento DOM que representa um componente contento um comportamento de dropdown
           */ constructor(pe){
                        this.element = pe, this._setBehavior();
                    }
                    /**
           * Inicia comportamento do exemplo
           */ _setBehavior() {
                        this._setDropdownBehavior();
                    }
                    /**
           * Encontra os data-toggle dropdown  e coloca util Dropdown
           */ _setDropdownBehavior() {
                        this.element.querySelectorAll('[data-toggle="dropdown"]').forEach((pe)=>{
                            const Le = {
                                iconToHide: "fa-chevron-up",
                                iconToShow: "fa-chevron-down",
                                trigger: pe,
                                useIcons: !0
                            };
                            new ut.default(Le).setBehavior();
                        });
                    }
                }
                const P = M;
                class n {
                    /**
           * Instancia um exemplo de comportamento Scrim
           * scrimToInitialize array de id_or_classe_acionador:id_or_classe_scrim para inicializar
           */ constructor({ arrayConfigScrim: pe = [] }){
                        this.arrayConfigScrim = pe, this._setBehavior();
                    }
                    /**
           * Inicia comportamento do exemplo
           * @private
           */ _setBehavior() {
                        this._setScrimBehavior();
                    }
                    /**
           * Encontra o componentes .scrimutilsample button  e coloca no evento de click o scrim
           * @private
           */ _setScrimBehavior() {
                        this.arrayConfigScrim.forEach((pe)=>{
                            for (const Le of window.document.querySelectorAll(pe.trigger_open_scrim))Le.addEventListener("click", ()=>{
                                this.openScrimExample(pe);
                            });
                        });
                    }
                    /**
           * Abre o scrim de id scrimutilexample
           */ openScrimExample(pe) {
                        const Le = window.document.querySelector(pe.scrimid);
                        new me.default({
                            closeElement: pe.trigger_close_scrim,
                            trigger: Le,
                            escEnable: !0,
                            limitTabKey: !0
                        }).showScrim();
                    }
                }
                const ye = n;
                class ke {
                    /**
           * Instancia um exemplo de comportamento tooltip
           * @param {object} element - Elemento sDOM que representa um componente contento um comportamento de tooltip
           */ constructor(pe){
                        this.element = pe;
                    }
                    /**
           * Inicia comportamento do exemplo
           * @private
           */ _setBehavior() {
                        this.TooltipExampleList = [];
                    }
                    /**
           * Encontra os data-tooltip-text  e coloca util Tooltip
           * @private
           */ run() {
                        this.TooltipExampleList = [], window.document.querySelectorAll("[data-tooltip-text]:not(.notification-tooltip)").forEach((pe)=>{
                            const Le = pe.getAttribute("data-tooltip-text"), Te = {
                                activator: pe,
                                place: "top",
                                textTooltip: Le
                            };
                            this.TooltipExampleList.push(new Ce.default(Te));
                        }), document.querySelectorAll("[data-tooltip-target]").forEach((pe)=>{
                            document.querySelectorAll(pe.getAttribute("data-tooltip-target")).forEach((Te)=>{
                                const It = Te.getAttribute("place") !== null ? Te.getAttribute("place") : "left", je = {
                                    activator: pe,
                                    component: Te,
                                    place: It,
                                    type: "warning"
                                };
                                new Ce.default(je);
                            });
                        });
                    }
                }
                const Me = ke;
                class ht {
                    initInstanceAll() {
                        this._initInstanceAccordionExample(), this._initInstanceCheckGroupExemple(), this._initInstanceCollapseExample(), this._initInstanceDropdownExample(), this._initInstanceTooltipExample(), this._initInstanceScrimExample();
                    }
                    _initInstanceCollapseExample() {
                        const pe = [];
                        window.document.querySelectorAll(".collapse-example").forEach((Le)=>{
                            pe.push(new ne(Le));
                        });
                    }
                    _initInstanceAccordionExample() {
                        const pe = [];
                        window.document.querySelectorAll(".accordion-example").forEach((Le)=>{
                            pe.push(new Be(Le));
                        });
                    }
                    _initInstanceCheckGroupExemple() {
                        const pe = [];
                        window.document.querySelectorAll(".checkgroup-example").forEach((Le)=>{
                            pe.push(new Re(Le));
                        });
                    }
                    _initInstanceDropdownExample() {
                        const pe = [];
                        window.document.querySelectorAll(".dropdown-example").forEach((Le)=>{
                            pe.push(new P(Le));
                        });
                    }
                    _initInstanceScrimExample() {
                        const pe = [
                            {
                                trigger_open_scrim: "#idbuttonscrimutil",
                                scrimid: "#scrimutilexample"
                            },
                            {
                                trigger_open_scrim: "#idbuttonscrimutil1",
                                trigger_close_scrim: "#scrimfechar",
                                scrimid: "#scrimutilfocobig"
                            }
                        ];
                        new ye({
                            arrayConfigScrim: pe
                        });
                    }
                    _initInstanceTooltipExample() {
                        new Me().run();
                    }
                }
                var oe = _("./src/partial/js/globals-class.js");
                const be = new oe.Globals(), He = new ht();
                He.initInstanceAll();
            })(), I;
        })());
})($ca0c2c480f9252ec$var$cu);
var $ca0c2c480f9252ec$var$us = $ca0c2c480f9252ec$var$cu.exports;
const $ca0c2c480f9252ec$export$1cb26bd41bda552d = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, vertical: u = !1, dashed: L = !1, size: _, ...I }, E)=>{
    const S = $ca0c2c480f9252ec$var$$t(I), y = $ca0c2c480f9252ec$var$Yt(I);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        ref: E,
        className: $ca0c2c480f9252ec$var$Oe("br-divider", u && "vertical", L && "dashed", _ === "sm" && "sm", _ === "md" && "md", _ === "lg" && "lg", ...S, l),
        ...y,
        children: p
    });
}), $ca0c2c480f9252ec$var$y_ = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, id: p, children: u, role: L = "list", title: _, horizontal: I = !1, hidden: E = !1, expanded: S, ...y }, k)=>{
    const b = $ca0c2c480f9252ec$var$In(p, "list_____"), m = $ca0c2c480f9252ec$var$$t(y), i = $ca0c2c480f9252ec$var$Yt(y), a = (0, $jXEQt.useRef)(null), s = (0, $jXEQt.useRef)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).useImperativeHandle(k, ()=>({
            get element () {
                return s.current;
            }
        })), (0, $jXEQt.useEffect)(()=>{
        s.current && !a.current && (a.current = new $ca0c2c480f9252ec$var$us.BRList("br-list", s.current));
    }, []), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        ref: s,
        id: b,
        className: $ca0c2c480f9252ec$var$Oe("br-list", I && "horizontal", l, ...m),
        ...L && {
            role: L
        },
        ...E && {
            hidden: "hidden"
        },
        ...S && {
            expanded: "expanded"
        },
        ...i,
        children: [
            _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "header",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: "title",
                            children: _
                        })
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1cb26bd41bda552d, {})
                ]
            }),
            u
        ]
    });
}), $ca0c2c480f9252ec$export$eeb4c6bba1899f38 = (0, $jXEQt.memo)($ca0c2c480f9252ec$var$y_);
$ca0c2c480f9252ec$export$eeb4c6bba1899f38.displayName = "BrList";
const $ca0c2c480f9252ec$export$30a931fe40eb4795 = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ children: l, className: p, id: u, type: L = "button", primary: _, secondary: I, circle: E, close: S = !1, inverted: y, block: k, clearBlock: b, size: m, loading: i, disabled: a, icon: s, signIn: c = !1, isItem: g = !1, isItemSelected: A = !1, onClick: F, dropdownItems: $, dropdownDirection: J = "right", ...se }, Q)=>{
    const _e = $ca0c2c480f9252ec$var$In(u, "button_____"), H = $ca0c2c480f9252ec$var$$t(se), Y = $ca0c2c480f9252ec$var$Yt(se), [z, V] = (0, $jXEQt.useState)(!1), fe = Q ?? (0, $jXEQt.useRef)(null), xe = (0, $jXEQt.useRef)(null), le = (0, $jXEQt.useCallback)((Ne)=>{
        F == null || F(Ne), V((ue)=>!ue);
    }, [
        F
    ]);
    return $ca0c2c480f9252ec$var$as([
        fe,
        xe
    ], ()=>V(!1)), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$var$vr, {
        tagName: $ && "div",
        className: $ca0c2c480f9252ec$var$Oe(z && "dropdown"),
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("button", {
                type: L,
                id: _e,
                className: $ca0c2c480f9252ec$var$Oe(!c && !g && "br-button", g && "br-item", A && "selected", c && "br-sign-in", {
                    primary: _,
                    secondary: I,
                    circle: E,
                    close: S,
                    inverted: y,
                    block: k,
                    loading: i,
                    [`auto-${b}`]: !!b,
                    large: m === "large",
                    small: m === "small"
                }, ...H, p),
                disabled: a,
                ref: fe,
                onClick: le,
                ...$ && {
                    "aria-expanded": z
                },
                ...$ && {
                    "data-visible": z
                },
                ...$ && {
                    "data-toggle": "dropdown"
                },
                ...Y,
                children: [
                    s && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                        icon: s,
                        ...!!l && {
                            mr: 1
                        }
                    }),
                    l
                ]
            }),
            $ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$eeb4c6bba1899f38, {
                ref: xe,
                className: "target",
                hidden: !z,
                role: "listbox",
                style: {
                    zIndex: 9999,
                    ...J === "left" && {
                        right: 0,
                        left: "auto"
                    }
                },
                children: $
            })
        ]
    });
}), $ca0c2c480f9252ec$export$2de34322b83831d3 = (l)=>{
    const { children: p, className: u, style: L, title: _, subtitle: I, avatar: E, footer: S, disabled: y, hover: k, fixedHeight: b, onClick: m } = l, i = $ca0c2c480f9252ec$var$Oe("br-card", {
        disabled: y,
        hover: k,
        "h-fixed": b
    }, u), a = $ca0c2c480f9252ec$var$Oe({
        "ml-3": !!E
    });
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: i,
        onClick: m,
        style: L,
        children: [
            (!!_ || !!I || !!E) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "card-header",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: "d-flex",
                    children: [
                        E && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f9cf3b2fb528cec3, {
                            ...E
                        }),
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: a,
                            children: [
                                _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    className: "text-weight-semi-bold text-up-02",
                                    children: _
                                }),
                                I && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    children: I
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: "ml-auto",
                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                circle: !0,
                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                                    icon: "ellipsis-v",
                                    "aria-hidden": "true"
                                })
                            })
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "card-content",
                children: p
            }),
            S && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "card-footer",
                children: S
            })
        ]
    });
}, $ca0c2c480f9252ec$var$A_ = {
    success: "check-circle",
    info: "info-circle",
    warning: "exclamation-triangle",
    danger: "times-circle"
}, $ca0c2c480f9252ec$export$91803f13bd898dcd = (0, $jXEQt.forwardRef)((l, p)=>{
    const { id: u, message: L, status: _ = "info", category: I = "message", title: E, inlineTitle: S, closable: y = !1, className: k } = l, [b, m] = (0, $jXEQt.useState)(!0), i = $ca0c2c480f9252ec$var$$t(l), a = S ? "span" : "p", s = /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
        className: $ca0c2c480f9252ec$var$Oe(`fas fa-${$ca0c2c480f9252ec$var$A_[_]}`, I === "message" && "fa-lg"),
        "aria-hidden": "true"
    });
    return b ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$var$vr, {
        ref: p,
        tagName: I === "feedback" ? "span" : "div",
        className: $ca0c2c480f9252ec$var$Oe(I === "feedback" && "feedback", I === "message" && "br-message", _, k, ...i),
        id: u,
        role: "alert",
        children: [
            I === "message" && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "icon",
                children: s
            }),
            I === "feedback" && s,
            I === "feedback" && L,
            I === "message" && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        className: "content",
                        children: [
                            E && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                className: "message-title mr-2",
                                children: E
                            }),
                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)(a, {
                                className: "message-body",
                                children: L
                            })
                        ]
                    }),
                    y && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "close",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                            circle: !0,
                            size: "small",
                            "aria-label": "Fechar",
                            onClick: ()=>m(!1),
                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                className: "fas fa-times",
                                "aria-hidden": "true"
                            })
                        })
                    })
                ]
            })
        ]
    }) : null;
}), $ca0c2c480f9252ec$export$27348da7e0f223b9 = (0, $jXEQt.createContext)(null), $ca0c2c480f9252ec$export$44e2ab7cbcb68241 = (l)=>{
    const { children: p, title: u, info: L, inline: _, inlineMargin: I = 3, checkAll: E, onCheckAll: S, onChange: y, feedback: k } = l, b = $ca0c2c480f9252ec$var$Oe(_ ? `d-inline-block mr-${I} mb-1` : "mb-1"), m = (E == null ? void 0 : E.checked) ?? !1, i = (0, $jXEQt.Children).map(p, (J)=>String(J.props.value)), a = m ? i : [], [s, c] = (0, $jXEQt.useState)(a);
    (0, $jXEQt.useEffect)(()=>c(a), [
        JSON.stringify(a)
    ]);
    const g = (J, se)=>{
        const Q = se ? i.filter((_e)=>_e === J || s.includes(_e)) : s.filter((_e)=>_e !== J);
        c(Q), y == null || y(Q);
    }, A = (J)=>{
        const se = J.target.checked ? i : [];
        c(se), y == null || y(se), S == null || S(J);
    }, F = s.length > 0 && s.length < (0, $jXEQt.Children).count(p), $ = s.length > 0 && s.length === (0, $jXEQt.Children).count(p);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$27348da7e0f223b9.Provider, {
        value: {
            checkedOptions: s,
            handleCheckOption: g
        },
        children: [
            u && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("p", {
                className: `label mb-${L ? 0 : 1}`,
                children: u
            }),
            L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("p", {
                className: "text-down-01",
                children: L
            }),
            E && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f08e1e7271ffbd67, {
                indeterminate: F,
                className: "mb-1",
                id: E.id ? `marcar-todas-${E.id}` : $ca0c2c480f9252ec$var$Ti("marcar-todas-"),
                label: E.label ?? "Marcar todos",
                disabled: E == null ? void 0 : E.disabled,
                checked: $,
                onChange: A
            }),
            (0, $jXEQt.Children).map(p, (J, se)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: b,
                    children: J
                }, se)),
            (k == null ? void 0 : k.message) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "mt-1",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$91803f13bd898dcd, {
                    category: "feedback",
                    ...k
                })
            })
        ]
    });
}, $ca0c2c480f9252ec$export$f08e1e7271ffbd67 = (0, $jXEQt.forwardRef)((l, p)=>{
    const { id: u = $ca0c2c480f9252ec$var$Ti("checkbox-"), label: L, className: _, indeterminate: I, ...E } = l, S = $ca0c2c480f9252ec$var$Oe("br-checkbox", !L && "hidden-label", _), y = (0, $jXEQt.useRef)(null), k = p || y, b = (0, $jXEQt.useContext)($ca0c2c480f9252ec$export$27348da7e0f223b9), m = (a)=>{
        var s;
        b && l.value && b.handleCheckOption(String(l.value), a.target.checked), (s = l.onChange) == null || s.call(l, a);
    }, i = l.checked ?? (b == null ? void 0 : b.checkedOptions.some((a)=>a === String(l.value)));
    return (0, $jXEQt.useEffect)(()=>{
        k.current && (k.current.indeterminate = !!I);
    }, [
        I,
        k
    ]), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: S,
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("input", {
                id: u,
                ref: k,
                type: "checkbox",
                "aria-label": L,
                ...I && {
                    "data-indeterminate": "true"
                },
                ...E,
                onChange: m,
                checked: i
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                className: "col pr-0",
                htmlFor: u,
                children: L || u
            })
        ]
    });
});
var $ca0c2c480f9252ec$var$fu = {
    exports: {}
};
(function(l, p) {
    (function(u, L) {
        l.exports = L();
    })($ca0c2c480f9252ec$var$Xn, function() {
        /*! *****************************************************************************
    	    Copyright (c) Microsoft Corporation.
    
    	    Permission to use, copy, modify, and/or distribute this software for any
    	    purpose with or without fee is hereby granted.
    
    	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    	    PERFORMANCE OF THIS SOFTWARE.
    	    ***************************************************************************** */ var u = function() {
            return u = Object.assign || function(k) {
                for(var b, m = 1, i = arguments.length; m < i; m++){
                    b = arguments[m];
                    for(var a in b)Object.prototype.hasOwnProperty.call(b, a) && (k[a] = b[a]);
                }
                return k;
            }, u.apply(this, arguments);
        }, L = function(y, k, b) {
            return b.months[k ? "shorthand" : "longhand"][y];
        };
        function _(y) {
            for(; y.firstChild;)y.removeChild(y.firstChild);
        }
        function I(y) {
            try {
                if (typeof y.composedPath == "function") {
                    var k = y.composedPath();
                    return k[0];
                }
                return y.target;
            } catch  {
                return y.target;
            }
        }
        var E = {
            shorthand: !1,
            dateFormat: "F Y",
            altFormat: "F Y",
            theme: "light"
        };
        function S(y) {
            var k = u(u({}, E), y);
            return function(b) {
                b.config.dateFormat = k.dateFormat, b.config.altFormat = k.altFormat;
                var m = {
                    monthsContainer: null
                };
                function i() {
                    if (b.rContainer) {
                        _(b.rContainer);
                        for(var z = 0; z < b.monthElements.length; z++){
                            var V = b.monthElements[z];
                            V.parentNode && V.parentNode.removeChild(V);
                        }
                    }
                }
                function a() {
                    b.rContainer && (m.monthsContainer = b._createElement("div", "flatpickr-monthSelect-months"), m.monthsContainer.tabIndex = -1, s(), b.rContainer.appendChild(m.monthsContainer), b.calendarContainer.classList.add("flatpickr-monthSelect-theme-" + k.theme));
                }
                function s() {
                    if (m.monthsContainer) {
                        _(m.monthsContainer);
                        for(var z = document.createDocumentFragment(), V = 0; V < 12; V++){
                            var fe = b.createDay("flatpickr-monthSelect-month", new Date(b.currentYear, V), 0, V);
                            fe.dateObj.getMonth() === /* @__PURE__ */ new Date().getMonth() && fe.dateObj.getFullYear() === /* @__PURE__ */ new Date().getFullYear() && fe.classList.add("today"), fe.textContent = L(V, k.shorthand, b.l10n), fe.addEventListener("click", F), z.appendChild(fe);
                        }
                        m.monthsContainer.appendChild(z), b.config.minDate && b.currentYear === b.config.minDate.getFullYear() ? b.prevMonthNav.classList.add("flatpickr-disabled") : b.prevMonthNav.classList.remove("flatpickr-disabled"), b.config.maxDate && b.currentYear === b.config.maxDate.getFullYear() ? b.nextMonthNav.classList.add("flatpickr-disabled") : b.nextMonthNav.classList.remove("flatpickr-disabled");
                    }
                }
                function c() {
                    b._bind(b.prevMonthNav, "click", function(z) {
                        z.preventDefault(), z.stopPropagation(), b.changeYear(b.currentYear - 1), A(), s();
                    }), b._bind(b.nextMonthNav, "click", function(z) {
                        z.preventDefault(), z.stopPropagation(), b.changeYear(b.currentYear + 1), A(), s();
                    }), b._bind(m.monthsContainer, "mouseover", function(z) {
                        b.config.mode === "range" && b.onMouseOver(I(z), "flatpickr-monthSelect-month");
                    });
                }
                function g() {
                    if (b.rContainer && b.selectedDates.length) {
                        for(var z = b.rContainer.querySelectorAll(".flatpickr-monthSelect-month.selected"), V = 0; V < z.length; V++)z[V].classList.remove("selected");
                        var fe = b.selectedDates[0].getMonth(), xe = b.rContainer.querySelector(".flatpickr-monthSelect-month:nth-child(" + (fe + 1) + ")");
                        xe && xe.classList.add("selected");
                    }
                }
                function A() {
                    var z = b.selectedDates[0];
                    if (z && (z = new Date(z), z.setFullYear(b.currentYear), b.config.minDate && z < b.config.minDate && (z = b.config.minDate), b.config.maxDate && z > b.config.maxDate && (z = b.config.maxDate), b.currentYear = z.getFullYear()), b.currentYearElement.value = String(b.currentYear), b.rContainer) {
                        var V = b.rContainer.querySelectorAll(".flatpickr-monthSelect-month");
                        V.forEach(function(fe) {
                            fe.dateObj.setFullYear(b.currentYear), b.config.minDate && fe.dateObj < b.config.minDate || b.config.maxDate && fe.dateObj > b.config.maxDate ? fe.classList.add("flatpickr-disabled") : fe.classList.remove("flatpickr-disabled");
                        });
                    }
                    g();
                }
                function F(z) {
                    z.preventDefault(), z.stopPropagation();
                    var V = I(z);
                    if (V instanceof Element && !V.classList.contains("flatpickr-disabled") && !V.classList.contains("notAllowed") && ($(V.dateObj), b.config.closeOnSelect)) {
                        var fe = b.config.mode === "single", xe = b.config.mode === "range" && b.selectedDates.length === 2;
                        (fe || xe) && b.close();
                    }
                }
                function $(z) {
                    var V = new Date(b.currentYear, z.getMonth(), z.getDate()), fe = [];
                    switch(b.config.mode){
                        case "single":
                            fe = [
                                V
                            ];
                            break;
                        case "multiple":
                            fe.push(V);
                            break;
                        case "range":
                            b.selectedDates.length === 2 ? fe = [
                                V
                            ] : (fe = b.selectedDates.concat([
                                V
                            ]), fe.sort(function(xe, le) {
                                return xe.getTime() - le.getTime();
                            }));
                            break;
                    }
                    b.setDate(fe, !0), g();
                }
                var J = {
                    37: -1,
                    39: 1,
                    40: 3,
                    38: -3
                };
                function se(z, V, fe, xe) {
                    var le = J[xe.keyCode] !== void 0;
                    if (!(!le && xe.keyCode !== 13) && !(!b.rContainer || !m.monthsContainer)) {
                        var Ne = b.rContainer.querySelector(".flatpickr-monthSelect-month.selected"), ue = Array.prototype.indexOf.call(m.monthsContainer.children, document.activeElement);
                        if (ue === -1) {
                            var K = Ne || m.monthsContainer.firstElementChild;
                            K.focus(), ue = K.$i;
                        }
                        le ? m.monthsContainer.children[(12 + ue + J[xe.keyCode]) % 12].focus() : xe.keyCode === 13 && m.monthsContainer.contains(document.activeElement) && $(document.activeElement.dateObj);
                    }
                }
                function Q() {
                    var z;
                    ((z = b.config) === null || z === void 0 ? void 0 : z.mode) === "range" && b.selectedDates.length === 1 && b.clear(!1), b.selectedDates.length || s();
                }
                function _e() {
                    k._stubbedCurrentMonth = b._initialDate.getMonth(), b._initialDate.setMonth(k._stubbedCurrentMonth), b.currentMonth = k._stubbedCurrentMonth;
                }
                function H() {
                    k._stubbedCurrentMonth && (b._initialDate.setMonth(k._stubbedCurrentMonth), b.currentMonth = k._stubbedCurrentMonth, delete k._stubbedCurrentMonth);
                }
                function Y() {
                    if (m.monthsContainer !== null) for(var z = m.monthsContainer.querySelectorAll(".flatpickr-monthSelect-month"), V = 0; V < z.length; V++)z[V].removeEventListener("click", F);
                }
                return {
                    onParseConfig: function() {
                        b.config.enableTime = !1;
                    },
                    onValueUpdate: g,
                    onKeyDown: se,
                    onReady: [
                        _e,
                        i,
                        a,
                        c,
                        g,
                        function() {
                            b.config.onClose.push(Q), b.loadedPlugins.push("monthSelect");
                        }
                    ],
                    onDestroy: [
                        H,
                        Y,
                        function() {
                            b.config.onClose = b.config.onClose.filter(function(z) {
                                return z !== Q;
                            });
                        }
                    ]
                };
            };
        }
        return S;
    });
})($ca0c2c480f9252ec$var$fu);
var $ca0c2c480f9252ec$var$w_ = $ca0c2c480f9252ec$var$fu.exports;
const $ca0c2c480f9252ec$var$S_ = /* @__PURE__ */ $ca0c2c480f9252ec$var$ls($ca0c2c480f9252ec$var$w_);
const $ca0c2c480f9252ec$var$Bc = (l)=>{
    switch(l){
        case "time":
            return "time";
        case "date-time":
            return "datetime-local";
        default:
            return "text";
    }
}, $ca0c2c480f9252ec$export$8d5bab7dcaab2bf7 = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, id: p, children: u, dataMode: L = "single", allowInput: _ = !0, keepCalendarOnFocus: I = !1, dataType: E = "date", label: S, minDate: y, maxDate: k, minuteIncrement: b, defaultHour: m, defaultMinute: i, onChange: a, onDateChange: s, onRangeChange: c, defaultValue: g, value: A = g, ...F }, $)=>{
    const J = $ca0c2c480f9252ec$var$In(p, "datetimepicker_____"), se = (0, $jXEQt.useRef)(null), Q = (0, $jXEQt.useRef)(null), [_e, H] = (0, $jXEQt.useState)(""), Y = E === "time" ? "clock" : "calendar-alt";
    (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).useImperativeHandle($, ()=>({
            get element () {
                var K;
                return (K = se.current) == null ? void 0 : K.querySelector('input[data-input="data-input"]');
            },
            get wrapper () {
                return se.current;
            },
            get inputWrapper () {
                var K1;
                return (K1 = se.current) == null ? void 0 : K1.querySelector(".br-input");
            },
            get label () {
                var K2;
                return (K2 = se.current) == null ? void 0 : K2.querySelector("label");
            },
            get button () {
                var K3;
                return (K3 = se.current) == null ? void 0 : K3.querySelector("button[data-toggle]");
            }
        })), (0, $jXEQt.useEffect)(()=>{
        E === "time" && L === "range" && console.warn('O BrDateTimePicker com dataType="time" n\xe3o suporta o dataMode="range".');
    }, [
        E,
        L
    ]);
    let z = "";
    switch(E){
        case "date":
            z = L === "range" ? "DD/MM/AAAA at\xe9 DD/MM/AAAA" : "DD/MM/AAAA";
            break;
        case "time":
            z = "HH:MM";
            break;
        case "date-time":
            z = L === "range" ? "DD/MM/AAAA HH:mm at\xe9 DD/MM/AAAA HH:mm" : "DD/MM/AAAA HH:mm";
            break;
        case "month":
            z = L === "range" ? "M\xeas/Ano at\xe9 M\xeas/Ano" : "M\xeas/Ano";
            break;
    }
    const V = (0, $jXEQt.useCallback)(()=>{
        var K;
        return (K = Q.current) == null ? void 0 : K.calendar;
    }, []), fe = (K)=>{
        var we, me, ve, Ce, qe;
        const Ae = K.target.value;
        if ((we = V()) == null || we.setDate(Ae), (me = V()) == null || me.jumpToDate(Ae, !0), H(Ae), Ae && Ae.length === K.target.maxLength) {
            const Be = (ve = V()) == null ? void 0 : ve.selectedDates, Fe = Ne(Be);
            a == null || a(Fe), s == null || s(Be == null ? void 0 : Be[0]), c == null || c(Be ?? []);
        }
        Ae || (a == null || a(""), s == null || s(void 0), c == null || c([]), (Ce = V()) == null || Ce.setDate(""), (qe = V()) == null || qe.jumpToDate("", !0));
    };
    (0, $jXEQt.useEffect)(()=>{
        var Ae;
        if (!se.current) return;
        Q.current = new $ca0c2c480f9252ec$var$us.BRDateTimePicker("br-datetimepicker", se.current, {
            defaultDate: A,
            clickOpens: I,
            allowInput: _,
            ...y && {
                minDate: y
            },
            ...k && {
                maxDate: k
            },
            ...b && {
                minuteIncrement: b
            },
            ...m && {
                defaultHour: m
            },
            ...i && {
                defaultMinute: i
            },
            ...E === "month" && {
                plugins: [
                    $ca0c2c480f9252ec$var$S_({
                        dateFormat: "F/Y"
                    })
                ]
            },
            onChange: (we, me)=>{
                var ve;
                c == null || c(we), s == null || s(we[0]), H(me), a == null || a(me), (ve = V()) == null || ve.setDate(me);
            }
        });
        const K = (Ae = V()) == null ? void 0 : Ae.input;
        K == null || K.setAttribute("maxlength", z.length.toString()), E === "date-time" && L === "range" && (K == null || K.addEventListener("keypress", (we)=>{
            var Re, ge, ne;
            (we.keyCode < 47 || we.keyCode > 57) && we.preventDefault();
            const me = (K == null ? void 0 : K.value.length) ?? 0;
            me !== 1 && me !== 3 && we.keyCode === 47 && we.preventDefault();
            const Ce = 16 + (((ge = (Re = Q.current) == null ? void 0 : Re.language.rangeSeparator) == null ? void 0 : ge.length) ?? 0) + 2, qe = Ce + 3, Be = qe + 5, Fe = Be + 3;
            switch(me){
                case 2:
                    K.value += "/";
                    break;
                case 5:
                    K.value += "/";
                    break;
                case 16:
                    K.value += (ne = Q.current) == null ? void 0 : ne.language.rangeSeparator;
                    break;
                case Ce:
                    K.value += "/";
                    break;
                case qe:
                    K.value += "/";
                    break;
                case Be:
                    K.value += " ";
                    break;
                case Fe:
                    K.value += ":";
                    break;
            }
        }));
    }, [
        y,
        k,
        b,
        m,
        i,
        E,
        L,
        I,
        _
    ]), (0, $jXEQt.useEffect)(()=>{
        var K;
        return (K = V()) == null ? void 0 : K.destroy;
    }, []);
    const xe = $ca0c2c480f9252ec$var$$t(F), le = $ca0c2c480f9252ec$var$Yt(F), Ne = (0, $jXEQt.useCallback)((K)=>{
        var we, me;
        const Ae = (we = V()) == null ? void 0 : we.config.dateFormat;
        return !Ae || !(K != null && K.length) ? "" : K.map((ve)=>{
            var Ce;
            return (Ce = V()) == null ? void 0 : Ce.formatDate(ve, Ae);
        }).filter((ve)=>typeof ve == "string").join(((me = Q.current) == null ? void 0 : me.language.rangeSeparator) ?? " at\xe9 ");
    }, []), ue = (0, $jXEQt.useCallback)(()=>{
        var K, Ae;
        (K = V()) == null || K.setDate(A ?? ""), H(Ne((Ae = V()) == null ? void 0 : Ae.selectedDates));
    }, [
        A
    ]);
    return (0, $jXEQt.useEffect)(ue, [
        ue
    ]), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: $ca0c2c480f9252ec$var$Oe("br-datetimepicker", ...xe, l),
        ref: se,
        "data-mode": L,
        "data-type": $ca0c2c480f9252ec$var$Bc(E),
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
            className: "br-input has-icon",
            children: [
                S && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                    htmlFor: J,
                    children: S
                }),
                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("input", {
                    autoComplete: "off",
                    id: J,
                    type: $ca0c2c480f9252ec$var$Bc(E),
                    placeholder: z,
                    "data-input": "data-input",
                    "data-toggle": "data-toggle",
                    ...le,
                    value: _e,
                    onChange: fe
                }),
                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                    className: "br-button circle small",
                    type: "button",
                    "aria-label": "Abrir Calend\xe1rio",
                    "data-toggle": "data-toggle",
                    disabled: F.disabled,
                    children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                        icon: Y
                    })
                }),
                u
            ]
        })
    });
}), $ca0c2c480f9252ec$var$ha = (l, p, u)=>{
    let L = {};
    (0, $jXEQt.useEffect)(()=>{
        if (p.current) {
            for(const _ in p.current)typeof p.current[_] == "function" ? L[_] = (...I)=>{
                var E, S;
                return (S = p == null ? void 0 : (E = p.current)[_]) == null ? void 0 : S.call(E, ...I);
            } : L[_] === void 0 && Object.defineProperty(L, _, {
                get: ()=>p.current[_],
                set: (I)=>p.current[_] = I
            });
            L = {
                ...L,
                ...u
            };
        }
    }, [
        p.current
    ]), (0, $jXEQt.useImperativeHandle)(l, ()=>L, [
        L
    ]);
}, $ca0c2c480f9252ec$var$E_ = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, highlighted: u, divider: L = !1, role: _ = "listItem", disabled: I = !1, target: E, collapsable: S = !1, initiallyExpanded: y = !1, link: k, subItems: b, onClick: m, ...i }, a)=>{
    const s = $ca0c2c480f9252ec$var$$t(i), c = $ca0c2c480f9252ec$var$Yt(i), g = (0, $jXEQt.useRef)(null), A = (0, $jXEQt.useRef)(null), [F, $] = (0, $jXEQt.useState)(y);
    $ca0c2c480f9252ec$var$ha(a, g, {
        get element () {
            return g.current;
        }
    }), (0, $jXEQt.useEffect)(()=>{
        g.current && !A.current && (A.current = new $ca0c2c480f9252ec$var$us.BRItem("br-item", g.current));
    }, []);
    const J = (0, $jXEQt.useCallback)((se)=>{
        m == null || m(se), $((Q)=>!Q);
    }, [
        m
    ]);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$vr, {
                ref: g,
                tagName: k ? "a" : "div",
                onClick: J,
                className: $ca0c2c480f9252ec$var$Oe("br-item", u && "highlighted", l, ...s),
                ..._ && {
                    role: _
                },
                ...I && {
                    disabled: !0
                },
                ...E && {
                    "data-target": E
                },
                ...S && {
                    "data-toggle": "collapse"
                },
                ...S && b && {
                    "data-visible": F
                },
                ...S && b && {
                    "aria-expanded": F
                },
                ...c,
                ...k && {
                    href: k
                },
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: "content",
                    children: [
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: "flex-fill",
                            children: p
                        }),
                        S && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                            className: $ca0c2c480f9252ec$var$Oe("fas", F ? "fa-chevron-up" : "fa-chevron-down"),
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1cb26bd41bda552d, {}),
            b && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$eeb4c6bba1899f38, {
                hidden: !F && S,
                "aria-hidden": !F && S,
                children: b
            })
        ]
    });
}), $ca0c2c480f9252ec$export$2777d0c1887e5f7b = (0, $jXEQt.memo)($ca0c2c480f9252ec$var$E_);
$ca0c2c480f9252ec$export$2777d0c1887e5f7b.displayName = "BrItem";
const $ca0c2c480f9252ec$export$627559ebc0a953ef = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, urlLogo: u, links: L, socialNetworks: _, userLicenseText: I, footerImages: E, inverted: S = !1, ...y }, k)=>{
    const b = $ca0c2c480f9252ec$var$$t(y), m = $ca0c2c480f9252ec$var$Yt(y);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("footer", {
        ref: k,
        className: $ca0c2c480f9252ec$var$Oe("br-footer", {
            inverted: S
        }, l, ...b),
        ...m,
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$42a852a2b6b56249, {
                fluid: "lg",
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "logo",
                        children: u && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("img", {
                            src: u,
                            alt: "Logo"
                        })
                    }),
                    L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$eeb4c6bba1899f38, {
                        horizontal: !0,
                        children: L.map((i, a)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$963a4b2511a4b70c, {
                                md: i.size || 2,
                                children: [
                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$2777d0c1887e5f7b, {
                                        link: "#",
                                        children: [
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: "content text-down-01 text-bold text-uppercase",
                                                children: i.category
                                            }),
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: "support",
                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                    className: "fas fa-angle-down",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    }),
                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$eeb4c6bba1899f38, {
                                        children: [
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1cb26bd41bda552d, {
                                                className: "d-md-none"
                                            }),
                                            i.items.map((s, c)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$2777d0c1887e5f7b, {
                                                    link: s.link,
                                                    children: s.label
                                                }, c))
                                        ]
                                    })
                                ]
                            }, a))
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "d-none d-sm-block",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$b59bdbef9ce70de2, {
                            className: "align-items-end justify-content-between",
                            padding: {
                                t: 5,
                                b: 5
                            },
                            children: [
                                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$963a4b2511a4b70c, {
                                    className: "social-network",
                                    children: [
                                        _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("p", {
                                            className: "text-up-01 text-extra-bold text-uppercase",
                                            children: "Redes Sociais"
                                        }),
                                        _ == null ? void 0 : _.map((i, a)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("a", {
                                                href: i.link,
                                                className: "mr-3",
                                                "aria-label": `Rede Social ${i.name}`,
                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                                                    icon: i.icon,
                                                    size: "2x"
                                                })
                                            }, a))
                                    ]
                                }),
                                E && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$963a4b2511a4b70c, {
                                    className: "assigns text-right",
                                    children: E == null ? void 0 : E.map((i, a)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$vr, {
                                            tagName: i.link ? "a" : "div",
                                            href: i.link,
                                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("img", {
                                                className: "ml-4",
                                                src: i.url,
                                                alt: i.name
                                            })
                                        }, a))
                                })
                            ]
                        })
                    })
                ]
            }),
            I && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1cb26bd41bda552d, {
                        my: 3
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$42a852a2b6b56249, {
                        fluid: "lg",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: "info",
                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                className: "text-down-01 text-medium pb-3",
                                children: I
                            })
                        })
                    })
                ]
            }),
            p
        ]
    });
}), $ca0c2c480f9252ec$export$920ee6a4eaf488e = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ fluid: l, className: p, children: u, id: L, urlLogo: _, signature: I, title: E, subTitle: S, compact: y = !1, density: k = "medium", quickAccessLinks: b, features: m, loggedIn: i = !1, showLoginButton: a = !0, onClickLogin: s, showSearchBar: c = !1, onSearch: g, avatar: A, showMenuButton: F = !1, menuId: $, sticky: J = !1, ...se }, Q)=>{
    var ge;
    const _e = $ca0c2c480f9252ec$var$In(L, "header_____"), H = $ca0c2c480f9252ec$var$$t(se), Y = $ca0c2c480f9252ec$var$Yt(se), [z, V] = (0, $jXEQt.useState)(!1), [fe, xe] = (0, $jXEQt.useState)(""), [le, Ne] = (0, $jXEQt.useState)(!1), [ue, K] = (0, $jXEQt.useState)(!1), Ae = (0, $jXEQt.useRef)(null), we = (0, $jXEQt.useRef)(null), me = (0, $jXEQt.useRef)(null), ve = (0, $jXEQt.useCallback)(()=>{
        V(!0);
    }, []), Ce = (0, $jXEQt.useCallback)(()=>{
        V(!1);
    }, []), qe = (0, $jXEQt.useCallback)(()=>{
        Ne((ne)=>!ne);
    }, []), Be = (0, $jXEQt.useCallback)(()=>{
        K((ne)=>!ne);
    }, []);
    $ca0c2c480f9252ec$var$as(we, ()=>{
        Ne(!1);
    }), $ca0c2c480f9252ec$var$as(me, ()=>{
        K(!1);
    });
    const Fe = (0, $jXEQt.useCallback)((ne)=>{
        ne.key === "Enter" && (g == null || g(fe));
    }, [
        g,
        fe
    ]), Re = typeof E == "string" ? E : typeof E == "object" ? (ge = E == null ? void 0 : E.props) == null ? void 0 : ge.children : "";
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("header", {
        "data-sticky": J || null,
        ref: Q,
        id: _e,
        className: $ca0c2c480f9252ec$var$Oe("br-header", {
            compact: y
        }, {
            small: k === "small"
        }, {
            large: k === "large"
        }, p, ...H),
        ...Y,
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$42a852a2b6b56249, {
                fluid: l,
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        className: "header-top",
                        children: [
                            (_ || I) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: "header-logo",
                                children: [
                                    _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("img", {
                                        src: _,
                                        alt: Re
                                    }),
                                    _ && I && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                        className: "br-divider vertical mx-half mx-sm-1"
                                    }),
                                    I && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        className: "header-sign",
                                        children: I
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: "header-actions",
                                ref: Ae,
                                children: [
                                    !!(b != null && b.length) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: $ca0c2c480f9252ec$var$Oe("header-links", "dropdown", {
                                            show: le
                                        }),
                                        children: [
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                                ref: we,
                                                onClick: qe,
                                                className: $ca0c2c480f9252ec$var$Oe("br-button", "circle", "small", {
                                                    active: le
                                                }),
                                                type: "button",
                                                "data-toggle": "dropdown",
                                                "aria-label": "Abrir Acesso R\xe1pido",
                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                    className: "fas fa-ellipsis-v",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                                className: "br-list",
                                                style: {
                                                    left: "auto",
                                                    right: 0
                                                },
                                                children: [
                                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                        className: "header",
                                                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                            className: "title",
                                                            children: "Acesso R\xe1pido"
                                                        })
                                                    }),
                                                    b == null ? void 0 : b.map((ne, ut)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("a", {
                                                            className: "br-item",
                                                            onClick: (M)=>{
                                                                ne.onClick && (M.preventDefault(), M.stopPropagation(), ne.onClick()), ne.keepExpanded || Ne(!1);
                                                            },
                                                            href: ne.href || "#",
                                                            children: ne.label
                                                        }, `quickAccessLink-${ut}`))
                                                ]
                                            })
                                        ]
                                    }),
                                    !!(b != null && b.length) && !!(m != null && m.length) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                        className: "br-divider vertical mx-half mx-sm-1"
                                    }),
                                    !!(m != null && m.length) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: $ca0c2c480f9252ec$var$Oe("header-functions", "dropdown", {
                                            show: ue
                                        }),
                                        children: [
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                                ref: me,
                                                onClick: Be,
                                                className: $ca0c2c480f9252ec$var$Oe("br-button", "circle", "small", {
                                                    active: ue
                                                }),
                                                type: "button",
                                                "data-toggle": "dropdown",
                                                "aria-label": "Abrir Funcionalidades do Sistema",
                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                    className: "fas fa-th",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                                className: "br-list",
                                                style: {
                                                    left: "auto",
                                                    right: 0
                                                },
                                                children: [
                                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                        className: "header",
                                                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                            className: "title",
                                                            children: "Funcionalidades do Sistema"
                                                        })
                                                    }),
                                                    m == null ? void 0 : m.map((ne, ut)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                            className: "align-items-center br-item",
                                                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$vr, {
                                                                tagName: ne.href && "a",
                                                                href: ne.href,
                                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("button", {
                                                                    onClick: (M)=>{
                                                                        ne.onClick && (M.preventDefault(), M.stopPropagation(), ne.onClick()), ne.keepExpanded || K(!1);
                                                                    },
                                                                    className: "br-button circle small",
                                                                    type: "button",
                                                                    "aria-label": ne.label,
                                                                    children: [
                                                                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                                            className: ne.icon.includes("fas ") ? ne.icon : `fas fa-${ne.icon}`,
                                                                            "aria-hidden": "true"
                                                                        }),
                                                                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                                                            className: "text",
                                                                            children: ne.label
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }, `feature-${ut}`))
                                                ]
                                            })
                                        ]
                                    }),
                                    c && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        className: "header-search-trigger",
                                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                            className: "br-button circle",
                                            type: "button",
                                            "aria-label": "Abrir Busca",
                                            "data-toggle": "search",
                                            "data-target": ".header-search",
                                            onClick: ve,
                                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                className: "fas fa-search",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    }),
                                    a && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: "header-login",
                                        children: [
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: $ca0c2c480f9252ec$var$Oe("header-sign-in", {
                                                    "d-none": i
                                                }),
                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                                    onClick: s,
                                                    size: "small",
                                                    "data-trigger": "login",
                                                    children: [
                                                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                            className: "fas fa-user",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                                            className: "d-sm-inline",
                                                            children: "Entrar"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: $ca0c2c480f9252ec$var$Oe({
                                                    "d-none": !i
                                                }),
                                                children: A
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        className: "header-bottom",
                        children: [
                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: "header-menu",
                                children: [
                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        className: $ca0c2c480f9252ec$var$Oe("header-menu-trigger", {
                                            "d-none": !F
                                        }),
                                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                            icon: "bars",
                                            size: "small",
                                            circle: !0,
                                            type: "button",
                                            "aria-label": "Menu",
                                            "data-toggle": "menu",
                                            "data-target": $ ? `#${$}` : "#",
                                            id: "navigation"
                                        })
                                    }),
                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: "header-info",
                                        children: [
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: "header-title",
                                                children: E
                                            }),
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: "header-subtitle",
                                                children: S
                                            })
                                        ]
                                    })
                                ]
                            }),
                            c && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: $ca0c2c480f9252ec$var$Oe("header-search", {
                                    active: z
                                }),
                                children: [
                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: "br-input has-icon",
                                        children: [
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                                                htmlFor: `searchbox-${_e}`,
                                                children: "Texto da pesquisa"
                                            }),
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("input", {
                                                id: `searchbox-${_e}`,
                                                type: "text",
                                                placeholder: "O que voc\xea procura?",
                                                value: fe,
                                                onChange: (ne)=>xe(ne.target.value),
                                                onKeyDown: Fe
                                            }),
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                                className: "br-button circle small",
                                                type: "button",
                                                "aria-label": "Pesquisar",
                                                onClick: ()=>g == null ? void 0 : g(fe),
                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                    className: "fas fa-search",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    }),
                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                        onClick: Ce,
                                        circle: !0,
                                        icon: "times",
                                        className: "search-close",
                                        type: "button",
                                        "aria-label": "Fechar Busca",
                                        "data-dismiss": "search"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            u
        ]
    });
});
function $ca0c2c480f9252ec$var$So(l, p) {
    var u = {};
    for(var L in l)Object.prototype.hasOwnProperty.call(l, L) && p.indexOf(L) < 0 && (u[L] = l[L]);
    if (l != null && typeof Object.getOwnPropertySymbols == "function") for(var _ = 0, L = Object.getOwnPropertySymbols(l); _ < L.length; _++)p.indexOf(L[_]) < 0 && Object.prototype.propertyIsEnumerable.call(l, L[_]) && (u[L[_]] = l[L[_]]);
    return u;
}
var $ca0c2c480f9252ec$var$fa;
(function(l) {
    l.event = "event", l.props = "prop";
})($ca0c2c480f9252ec$var$fa || ($ca0c2c480f9252ec$var$fa = {}));
function $ca0c2c480f9252ec$var$gr() {}
function $ca0c2c480f9252ec$var$x_(l) {
    var p, u = void 0;
    return function() {
        for(var L = [], _ = arguments.length; _--;)L[_] = arguments[_];
        return p && L.length === p.length && L.every(function(I, E) {
            return I === p[E];
        }) || (p = L, u = l.apply(void 0, L)), u;
    };
}
function $ca0c2c480f9252ec$var$Jr(l) {
    return !!(l || "").match(/\d/);
}
function $ca0c2c480f9252ec$var$Xr(l) {
    return l == null;
}
function $ca0c2c480f9252ec$var$C_(l) {
    return typeof l == "number" && isNaN(l);
}
function $ca0c2c480f9252ec$var$hu(l) {
    return $ca0c2c480f9252ec$var$Xr(l) || $ca0c2c480f9252ec$var$C_(l) || typeof l == "number" && !isFinite(l);
}
function $ca0c2c480f9252ec$var$pu(l) {
    return l.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function $ca0c2c480f9252ec$var$k_(l) {
    switch(l){
        case "lakh":
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case "wan":
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case "thousand":
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function $ca0c2c480f9252ec$var$L_(l, p, u) {
    var L = $ca0c2c480f9252ec$var$k_(u), _ = l.search(/[1-9]/);
    return _ = _ === -1 ? l.length : _, l.substring(0, _) + l.substring(_, l.length).replace(L, "$1" + p);
}
function $ca0c2c480f9252ec$var$D_(l) {
    var p = (0, $jXEQt.useRef)(l);
    p.current = l;
    var u = (0, $jXEQt.useRef)(function() {
        for(var L = [], _ = arguments.length; _--;)L[_] = arguments[_];
        return p.current.apply(p, L);
    });
    return u.current;
}
function $ca0c2c480f9252ec$var$Eo(l, p) {
    p === void 0 && (p = !0);
    var u = l[0] === "-", L = u && p;
    l = l.replace("-", "");
    var _ = l.split("."), I = _[0], E = _[1] || "";
    return {
        beforeDecimal: I,
        afterDecimal: E,
        hasNegation: u,
        addNegation: L
    };
}
function $ca0c2c480f9252ec$var$T_(l) {
    if (!l) return l;
    var p = l[0] === "-";
    p && (l = l.substring(1, l.length));
    var u = l.split("."), L = u[0].replace(/^0+/, "") || "0", _ = u[1] || "";
    return (p ? "-" : "") + L + (_ ? "." + _ : "");
}
function $ca0c2c480f9252ec$var$mu(l, p, u) {
    for(var L = "", _ = u ? "0" : "", I = 0; I <= p - 1; I++)L += l[I] || _;
    return L;
}
function $ca0c2c480f9252ec$var$Pc(l, p) {
    return Array(p + 1).join(l);
}
function $ca0c2c480f9252ec$var$gu(l) {
    var p = l + "", u = p[0] === "-" ? "-" : "";
    u && (p = p.substring(1));
    var L = p.split(/[eE]/g), _ = L[0], I = L[1];
    if (I = Number(I), !I) return u + _;
    _ = _.replace(".", "");
    var E = 1 + I, S = _.length;
    return E < 0 ? _ = "0." + $ca0c2c480f9252ec$var$Pc("0", Math.abs(E)) + _ : E >= S ? _ = _ + $ca0c2c480f9252ec$var$Pc("0", E - S) : _ = (_.substring(0, E) || "0") + "." + _.substring(E), u + _;
}
function $ca0c2c480f9252ec$var$Rc(l, p, u) {
    if ([
        "",
        "-"
    ].indexOf(l) !== -1) return l;
    var L = (l.indexOf(".") !== -1 || u) && p, _ = $ca0c2c480f9252ec$var$Eo(l), I = _.beforeDecimal, E = _.afterDecimal, S = _.hasNegation, y = parseFloat("0." + (E || "0")), k = E.length <= p ? "0." + E : y.toFixed(p), b = k.split("."), m = I;
    I && Number(b[0]) && (m = I.split("").reverse().reduce(function(c, g, A) {
        return c.length > A ? (Number(c[0]) + Number(g)).toString() + c.substring(1, c.length) : g + c;
    }, b[0]));
    var i = $ca0c2c480f9252ec$var$mu(b[1] || "", p, u), a = S ? "-" : "", s = L ? "." : "";
    return "" + a + m + s + i;
}
function $ca0c2c480f9252ec$var$Dr(l, p) {
    if (l.value = l.value, l !== null) {
        if (l.createTextRange) {
            var u = l.createTextRange();
            return u.move("character", p), u.select(), !0;
        }
        return l.selectionStart || l.selectionStart === 0 ? (l.focus(), l.setSelectionRange(p, p), !0) : (l.focus(), !1);
    }
}
var $ca0c2c480f9252ec$var$vu = $ca0c2c480f9252ec$var$x_(function(l, p) {
    for(var u = 0, L = 0, _ = l.length, I = p.length; l[u] === p[u] && u < _;)u++;
    for(; l[_ - 1 - L] === p[I - 1 - L] && I - L > u && _ - L > u;)L++;
    return {
        from: {
            start: u,
            end: _ - L
        },
        to: {
            start: u,
            end: I - L
        }
    };
}), $ca0c2c480f9252ec$var$I_ = function(l, p) {
    var u = Math.min(l.selectionStart, p);
    return {
        from: {
            start: u,
            end: l.selectionEnd
        },
        to: {
            start: u,
            end: p
        }
    };
};
function $ca0c2c480f9252ec$var$O_(l, p, u) {
    return Math.min(Math.max(l, p), u);
}
function $ca0c2c480f9252ec$var$mo(l) {
    return Math.max(l.selectionStart, l.selectionEnd);
}
function $ca0c2c480f9252ec$var$M_() {
    return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function $ca0c2c480f9252ec$var$bu(l) {
    return {
        from: {
            start: 0,
            end: 0
        },
        to: {
            start: 0,
            end: l.length
        },
        lastValue: ""
    };
}
function $ca0c2c480f9252ec$var$_u(l, p) {
    return l === void 0 && (l = " "), typeof l == "string" ? l : l[p] || " ";
}
function $ca0c2c480f9252ec$var$N_(l) {
    var p = l.currentValue, u = l.formattedValue, L = l.currentValueIndex, _ = l.formattedValueIndex;
    return p[L] === u[_];
}
function $ca0c2c480f9252ec$var$B_(l, p, u, L, _, I, E) {
    E === void 0 && (E = $ca0c2c480f9252ec$var$N_);
    var S = _.findIndex(function(J) {
        return J;
    }), y = l.slice(0, S);
    !p && !u.startsWith(y) && (p = y, u = y + u, L = L + y.length);
    for(var k = u.length, b = l.length, m = {}, i = new Array(k), a = 0; a < k; a++){
        i[a] = -1;
        for(var s = 0, c = b; s < c; s++){
            var g = E({
                currentValue: u,
                lastValue: p,
                formattedValue: l,
                currentValueIndex: a,
                formattedValueIndex: s
            });
            if (g && m[s] !== !0) {
                i[a] = s, m[s] = !0;
                break;
            }
        }
    }
    for(var A = L; A < k && (i[A] === -1 || !I(u[A]));)A++;
    var F = A === k || i[A] === -1 ? b : i[A];
    for(A = L - 1; A > 0 && i[A] === -1;)A--;
    var $ = A === -1 || i[A] === -1 ? 0 : i[A] + 1;
    return $ > F ? F : L - $ < F - L ? $ : F;
}
function $ca0c2c480f9252ec$var$ss(l, p, u, L) {
    var _ = l.length;
    if (p = $ca0c2c480f9252ec$var$O_(p, 0, _), L === "left") {
        for(; p >= 0 && !u[p];)p--;
        p === -1 && (p = u.indexOf(!0));
    } else {
        for(; p <= _ && !u[p];)p++;
        p > _ && (p = u.lastIndexOf(!0));
    }
    return p === -1 && (p = _), p;
}
function $ca0c2c480f9252ec$var$P_(l) {
    for(var p = Array.from({
        length: l.length + 1
    }).map(function() {
        return !0;
    }), u = 0, L = p.length; u < L; u++)p[u] = !!($ca0c2c480f9252ec$var$Jr(l[u]) || $ca0c2c480f9252ec$var$Jr(l[u - 1]));
    return p;
}
function $ca0c2c480f9252ec$var$yu(l, p, u, L, _, I) {
    I === void 0 && (I = $ca0c2c480f9252ec$var$gr);
    var E = $ca0c2c480f9252ec$var$D_(function(s, c) {
        var g, A;
        return $ca0c2c480f9252ec$var$hu(s) ? (A = "", g = "") : typeof s == "number" || c ? (A = typeof s == "number" ? $ca0c2c480f9252ec$var$gu(s) : s, g = L(A)) : (A = _(s, void 0), g = L(A)), {
            formattedValue: g,
            numAsString: A
        };
    }), S = (0, $jXEQt.useState)(function() {
        return E($ca0c2c480f9252ec$var$Xr(l) ? p : l, u);
    }), y = S[0], k = S[1], b = function(s, c) {
        s.formattedValue !== y.formattedValue && k({
            formattedValue: s.formattedValue,
            numAsString: s.value
        }), I(s, c);
    }, m = l, i = u;
    $ca0c2c480f9252ec$var$Xr(l) && (m = y.numAsString, i = !0);
    var a = E(m, i);
    return (0, $jXEQt.useMemo)(function() {
        k(a);
    }, [
        a.formattedValue
    ]), [
        y,
        b
    ];
}
function $ca0c2c480f9252ec$var$R_(l) {
    return l.replace(/[^0-9]/g, "");
}
function $ca0c2c480f9252ec$var$F_(l) {
    return l;
}
function $ca0c2c480f9252ec$var$Au(l) {
    var p = l.type;
    p === void 0 && (p = "text");
    var u = l.displayType;
    u === void 0 && (u = "input");
    var L = l.customInput, _ = l.renderText, I = l.getInputRef, E = l.format;
    E === void 0 && (E = $ca0c2c480f9252ec$var$F_);
    var S = l.removeFormatting;
    S === void 0 && (S = $ca0c2c480f9252ec$var$R_);
    var y = l.defaultValue, k = l.valueIsNumericString, b = l.onValueChange, m = l.isAllowed, i = l.onChange;
    i === void 0 && (i = $ca0c2c480f9252ec$var$gr);
    var a = l.onKeyDown;
    a === void 0 && (a = $ca0c2c480f9252ec$var$gr);
    var s = l.onMouseUp;
    s === void 0 && (s = $ca0c2c480f9252ec$var$gr);
    var c = l.onFocus;
    c === void 0 && (c = $ca0c2c480f9252ec$var$gr);
    var g = l.onBlur;
    g === void 0 && (g = $ca0c2c480f9252ec$var$gr);
    var A = l.value, F = l.getCaretBoundary;
    F === void 0 && (F = $ca0c2c480f9252ec$var$P_);
    var $ = l.isValidInputCharacter;
    $ === void 0 && ($ = $ca0c2c480f9252ec$var$Jr);
    var J = l.isCharacterSame, se = $ca0c2c480f9252ec$var$So(l, [
        "type",
        "displayType",
        "customInput",
        "renderText",
        "getInputRef",
        "format",
        "removeFormatting",
        "defaultValue",
        "valueIsNumericString",
        "onValueChange",
        "isAllowed",
        "onChange",
        "onKeyDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "value",
        "getCaretBoundary",
        "isValidInputCharacter",
        "isCharacterSame"
    ]), Q = $ca0c2c480f9252ec$var$yu(A, y, !!k, E, S, b), _e = Q[0], H = _e.formattedValue, Y = _e.numAsString, z = Q[1], V = (0, $jXEQt.useRef)(), fe = (0, $jXEQt.useRef)({
        formattedValue: H,
        numAsString: Y
    }), xe = function(oe, be) {
        fe.current = {
            formattedValue: oe.formattedValue,
            numAsString: oe.value
        }, z(oe, be);
    }, le = (0, $jXEQt.useState)(!1), Ne = le[0], ue = le[1], K = (0, $jXEQt.useRef)(null), Ae = (0, $jXEQt.useRef)({
        setCaretTimeout: null,
        focusTimeout: null
    });
    (0, $jXEQt.useEffect)(function() {
        return ue(!0), function() {
            clearTimeout(Ae.current.setCaretTimeout), clearTimeout(Ae.current.focusTimeout);
        };
    }, []);
    var we = E, me = function(oe, be) {
        var He = parseFloat(be);
        return {
            formattedValue: oe,
            value: be,
            floatValue: isNaN(He) ? void 0 : He
        };
    }, ve = function(oe, be, He) {
        oe.selectionStart === 0 && oe.selectionEnd === oe.value.length || ($ca0c2c480f9252ec$var$Dr(oe, be), Ae.current.setCaretTimeout = setTimeout(function() {
            oe.value === He && oe.selectionStart !== be && $ca0c2c480f9252ec$var$Dr(oe, be);
        }, 0));
    }, Ce = function(oe, be, He) {
        return $ca0c2c480f9252ec$var$ss(oe, be, F(oe), He);
    }, qe = function(oe, be, He) {
        var Ie = F(be), pe = $ca0c2c480f9252ec$var$B_(be, H, oe, He, Ie, $, J);
        return pe = $ca0c2c480f9252ec$var$ss(be, pe, Ie), pe;
    }, Be = function(oe) {
        var be = oe.formattedValue;
        be === void 0 && (be = "");
        var He = oe.input, Ie = oe.source, pe = oe.event, Le = oe.numAsString, Te;
        if (He) {
            var It = oe.inputValue || He.value, je = $ca0c2c480f9252ec$var$mo(He);
            He.value = be, Te = qe(It, be, je), Te !== void 0 && ve(He, Te, be);
        }
        be !== H && xe(me(be, Le), {
            event: pe,
            source: Ie
        });
    };
    (0, $jXEQt.useEffect)(function() {
        var oe = fe.current, be = oe.formattedValue, He = oe.numAsString;
        (H !== be || Y !== He) && xe(me(H, Y), {
            event: void 0,
            source: $ca0c2c480f9252ec$var$fa.props
        });
    }, [
        H,
        Y
    ]);
    var Fe = K.current ? $ca0c2c480f9252ec$var$mo(K.current) : void 0, Re = typeof window < "u" ? (0, $jXEQt.useLayoutEffect) : (0, $jXEQt.useEffect);
    Re(function() {
        var oe = K.current;
        if (H !== fe.current.formattedValue && oe) {
            var be = qe(fe.current.formattedValue, H, Fe);
            oe.value = H, ve(oe, be, H);
        }
    }, [
        H
    ]);
    var ge = function(oe, be, He) {
        var Ie = be.target, pe = V.current ? $ca0c2c480f9252ec$var$I_(V.current, Ie.selectionEnd) : $ca0c2c480f9252ec$var$vu(H, oe), Le = Object.assign(Object.assign({}, pe), {
            lastValue: H
        }), Te = S(oe, Le), It = we(Te);
        if (Te = S(It, void 0), m && !m(me(It, Te))) {
            var je = be.target, Ot = $ca0c2c480f9252ec$var$mo(je), Kt = qe(oe, H, Ot);
            return je.value = H, ve(je, Kt, H), !1;
        }
        return Be({
            formattedValue: It,
            numAsString: Te,
            inputValue: oe,
            event: be,
            source: He,
            input: be.target
        }), !0;
    }, ne = function(oe, be) {
        be === void 0 && (be = 0);
        var He = oe.selectionStart, Ie = oe.selectionEnd;
        V.current = {
            selectionStart: He,
            selectionEnd: Ie + be
        };
    }, ut = function(oe) {
        var be = oe.target, He = be.value, Ie = ge(He, oe, $ca0c2c480f9252ec$var$fa.event);
        Ie && i(oe), V.current = void 0;
    }, M = function(oe) {
        var be = oe.target, He = oe.key, Ie = be.selectionStart, pe = be.selectionEnd, Le = be.value;
        Le === void 0 && (Le = "");
        var Te;
        He === "ArrowLeft" || He === "Backspace" ? Te = Math.max(Ie - 1, 0) : He === "ArrowRight" ? Te = Math.min(Ie + 1, Le.length) : He === "Delete" && (Te = Ie);
        var It = 0;
        He === "Delete" && Ie === pe && (It = 1);
        var je = He === "ArrowLeft" || He === "ArrowRight";
        if (Te === void 0 || Ie !== pe && !je) {
            a(oe), ne(be, It);
            return;
        }
        var Ot = Te;
        if (je) {
            var Kt = He === "ArrowLeft" ? "left" : "right";
            Ot = Ce(Le, Te, Kt), Ot !== Te && oe.preventDefault();
        } else He === "Delete" && !$(Le[Te]) ? Ot = Ce(Le, Te, "right") : He === "Backspace" && !$(Le[Te]) && (Ot = Ce(Le, Te, "left"));
        Ot !== Te && ve(be, Ot, Le), a(oe), ne(be, It);
    }, P = function(oe) {
        var be = oe.target, He = function() {
            var Ie = be.selectionStart, pe = be.selectionEnd, Le = be.value;
            if (Le === void 0 && (Le = ""), Ie === pe) {
                var Te = Ce(Le, Ie);
                Te !== Ie && ve(be, Te, Le);
            }
        };
        He(), requestAnimationFrame(function() {
            He();
        }), s(oe), ne(be);
    }, n = function(oe) {
        oe.persist && oe.persist();
        var be = oe.target, He = oe.currentTarget;
        K.current = be, Ae.current.focusTimeout = setTimeout(function() {
            var Ie = be.selectionStart, pe = be.selectionEnd, Le = be.value;
            Le === void 0 && (Le = "");
            var Te = Ce(Le, Ie);
            Te !== Ie && !(Ie === 0 && pe === Le.length) && ve(be, Te, Le), c(Object.assign(Object.assign({}, oe), {
                currentTarget: He
            }));
        }, 0);
    }, ye = function(oe) {
        K.current = null, clearTimeout(Ae.current.focusTimeout), clearTimeout(Ae.current.setCaretTimeout), g(oe);
    }, ke = Ne && $ca0c2c480f9252ec$var$M_() ? "numeric" : void 0, Me = Object.assign({
        inputMode: ke
    }, se, {
        type: p,
        value: H,
        onChange: ut,
        onKeyDown: M,
        onMouseUp: P,
        onFocus: n,
        onBlur: ye
    });
    if (u === "text") return _ ? (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).Fragment, null, _(H, se) || null) : (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement("span", Object.assign({}, se, {
        ref: I
    }), H);
    if (L) {
        var ht = L;
        return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement(ht, Object.assign({}, Me, {
            ref: I
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement("input", Object.assign({}, Me, {
        ref: I
    }));
}
function $ca0c2c480f9252ec$var$Fc(l, p) {
    var u = p.decimalScale, L = p.fixedDecimalScale, _ = p.prefix;
    _ === void 0 && (_ = "");
    var I = p.suffix;
    I === void 0 && (I = "");
    var E = p.allowNegative, S = p.thousandsGroupStyle;
    if (S === void 0 && (S = "thousand"), l === "" || l === "-") return l;
    var y = $ca0c2c480f9252ec$var$ds(p), k = y.thousandSeparator, b = y.decimalSeparator, m = u !== 0 && l.indexOf(".") !== -1 || u && L, i = $ca0c2c480f9252ec$var$Eo(l, E), a = i.beforeDecimal, s = i.afterDecimal, c = i.addNegation;
    return u !== void 0 && (s = $ca0c2c480f9252ec$var$mu(s, u, !!L)), k && (a = $ca0c2c480f9252ec$var$L_(a, k, S)), _ && (a = _ + a), I && (s = s + I), c && (a = "-" + a), l = a + (m && b || "") + s, l;
}
function $ca0c2c480f9252ec$var$ds(l) {
    var p = l.decimalSeparator;
    p === void 0 && (p = ".");
    var u = l.thousandSeparator, L = l.allowedDecimalSeparators;
    return u === !0 && (u = ","), L || (L = [
        p,
        "."
    ]), {
        decimalSeparator: p,
        thousandSeparator: u,
        allowedDecimalSeparators: L
    };
}
function $ca0c2c480f9252ec$var$q_(l, p) {
    l === void 0 && (l = "");
    var u = new RegExp("(-)"), L = new RegExp("(-)(.)*(-)"), _ = u.test(l), I = L.test(l);
    return l = l.replace(/-/g, ""), _ && !I && p && (l = "-" + l), l;
}
function $ca0c2c480f9252ec$var$W_(l, p) {
    return new RegExp("(^-)|[0-9]|" + $ca0c2c480f9252ec$var$pu(l), p ? "g" : void 0);
}
function $ca0c2c480f9252ec$var$U_(l, p, u) {
    return l === "" ? !0 : !(p != null && p.match(/\d/)) && !(u != null && u.match(/\d/)) && typeof l == "string" && !isNaN(Number(l));
}
function $ca0c2c480f9252ec$var$H_(l, p, u) {
    var L;
    p === void 0 && (p = $ca0c2c480f9252ec$var$bu(l));
    var _ = u.allowNegative, I = u.prefix;
    I === void 0 && (I = "");
    var E = u.suffix;
    E === void 0 && (E = "");
    var S = u.decimalScale, y = p.from, k = p.to, b = k.start, m = k.end, i = $ca0c2c480f9252ec$var$ds(u), a = i.allowedDecimalSeparators, s = i.decimalSeparator, c = l[m] === s;
    if ($ca0c2c480f9252ec$var$Jr(l) && (l === I || l === E) && p.lastValue === "") return l;
    if (m - b === 1 && a.indexOf(l[b]) !== -1) {
        var g = S === 0 ? "" : s;
        l = l.substring(0, b) + g + l.substring(b + 1, l.length);
    }
    var A = function(K, Ae, we) {
        var me = !1, ve = !1;
        I.startsWith("-") ? me = !1 : K.startsWith("--") ? (me = !1, ve = !0) : E.startsWith("-") && K.length === E.length ? me = !1 : K[0] === "-" && (me = !0);
        var Ce = me ? 1 : 0;
        return ve && (Ce = 2), Ce && (K = K.substring(Ce), Ae -= Ce, we -= Ce), {
            value: K,
            start: Ae,
            end: we,
            hasNegation: me
        };
    }, F = A(l, b, m), $ = F.hasNegation;
    L = F, l = L.value, b = L.start, m = L.end;
    var J = A(p.lastValue, y.start, y.end), se = J.start, Q = J.end, _e = J.value, H = l.substring(b, m);
    l.length && _e.length && (se > _e.length - E.length || Q < I.length) && !(H && E.startsWith(H)) && (l = _e);
    var Y = 0;
    l.startsWith(I) ? Y += I.length : b < I.length && (Y = b), l = l.substring(Y), m -= Y;
    var z = l.length, V = l.length - E.length;
    l.endsWith(E) ? z = V : (m > V || m > l.length - E.length) && (z = m), l = l.substring(0, z), l = $ca0c2c480f9252ec$var$q_($ ? "-" + l : l, _), l = (l.match($ca0c2c480f9252ec$var$W_(s, !0)) || []).join("");
    var fe = l.indexOf(s);
    l = l.replace(new RegExp($ca0c2c480f9252ec$var$pu(s), "g"), function(K, Ae) {
        return Ae === fe ? "." : "";
    });
    var xe = $ca0c2c480f9252ec$var$Eo(l, _), le = xe.beforeDecimal, Ne = xe.afterDecimal, ue = xe.addNegation;
    return k.end - k.start < y.end - y.start && le === "" && c && !parseFloat(Ne) && (l = ue ? "-" : ""), l;
}
function $ca0c2c480f9252ec$var$j_(l, p) {
    var u = p.prefix;
    u === void 0 && (u = "");
    var L = p.suffix;
    L === void 0 && (L = "");
    var _ = Array.from({
        length: l.length + 1
    }).map(function() {
        return !0;
    }), I = l[0] === "-";
    _.fill(!1, 0, u.length + (I ? 1 : 0));
    var E = l.length;
    return _.fill(!1, E - L.length + 1, E + 1), _;
}
function $ca0c2c480f9252ec$var$$_(l) {
    var p = $ca0c2c480f9252ec$var$ds(l), u = p.thousandSeparator, L = p.decimalSeparator, _ = l.prefix;
    _ === void 0 && (_ = "");
    var I = l.allowNegative;
    if (I === void 0 && (I = !0), u === L) throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + u + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + L + ` (default value for decimalSeparator is .)
     `);
    return _.startsWith("-") && I && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + _ + `
      allowNegative: ` + I + `
    `), I = !1), Object.assign(Object.assign({}, l), {
        allowNegative: I
    });
}
function $ca0c2c480f9252ec$var$K_(l) {
    l = $ca0c2c480f9252ec$var$$_(l), l.decimalSeparator, l.allowedDecimalSeparators, l.thousandsGroupStyle;
    var p = l.suffix, u = l.allowNegative, L = l.allowLeadingZeros, _ = l.onKeyDown;
    _ === void 0 && (_ = $ca0c2c480f9252ec$var$gr);
    var I = l.onBlur;
    I === void 0 && (I = $ca0c2c480f9252ec$var$gr);
    var E = l.thousandSeparator, S = l.decimalScale, y = l.fixedDecimalScale, k = l.prefix;
    k === void 0 && (k = "");
    var b = l.defaultValue, m = l.value, i = l.valueIsNumericString, a = l.onValueChange, s = $ca0c2c480f9252ec$var$So(l, [
        "decimalSeparator",
        "allowedDecimalSeparators",
        "thousandsGroupStyle",
        "suffix",
        "allowNegative",
        "allowLeadingZeros",
        "onKeyDown",
        "onBlur",
        "thousandSeparator",
        "decimalScale",
        "fixedDecimalScale",
        "prefix",
        "defaultValue",
        "value",
        "valueIsNumericString",
        "onValueChange"
    ]), c = $ca0c2c480f9252ec$var$ds(l), g = c.decimalSeparator, A = c.allowedDecimalSeparators, F = function(ue) {
        return $ca0c2c480f9252ec$var$Fc(ue, l);
    }, $ = function(ue, K) {
        return $ca0c2c480f9252ec$var$H_(ue, K, l);
    }, J = $ca0c2c480f9252ec$var$Xr(m) ? b : m, se = i ?? $ca0c2c480f9252ec$var$U_(J, k, p);
    $ca0c2c480f9252ec$var$Xr(m) ? $ca0c2c480f9252ec$var$Xr(b) || (se = se || typeof b == "number") : se = se || typeof m == "number";
    var Q = function(ue) {
        return $ca0c2c480f9252ec$var$hu(ue) ? ue : (typeof ue == "number" && (ue = $ca0c2c480f9252ec$var$gu(ue)), se && typeof S == "number" ? $ca0c2c480f9252ec$var$Rc(ue, S, !!y) : ue);
    }, _e = $ca0c2c480f9252ec$var$yu(Q(m), Q(b), !!se, F, $, a), H = _e[0], Y = H.numAsString, z = H.formattedValue, V = _e[1], fe = function(ue) {
        var K = ue.target, Ae = ue.key, we = K.selectionStart, me = K.selectionEnd, ve = K.value;
        if (ve === void 0 && (ve = ""), (Ae === "Backspace" || Ae === "Delete") && me < k.length) {
            ue.preventDefault();
            return;
        }
        if (we !== me) {
            _(ue);
            return;
        }
        Ae === "Backspace" && ve[0] === "-" && we === k.length + 1 && u && $ca0c2c480f9252ec$var$Dr(K, 1), S && y && (Ae === "Backspace" && ve[we - 1] === g ? ($ca0c2c480f9252ec$var$Dr(K, we - 1), ue.preventDefault()) : Ae === "Delete" && ve[we] === g && ue.preventDefault()), A != null && A.includes(Ae) && ve[we] === g && $ca0c2c480f9252ec$var$Dr(K, we + 1);
        var Ce = E === !0 ? "," : E;
        Ae === "Backspace" && ve[we - 1] === Ce && $ca0c2c480f9252ec$var$Dr(K, we - 1), Ae === "Delete" && ve[we] === Ce && $ca0c2c480f9252ec$var$Dr(K, we + 1), _(ue);
    }, xe = function(ue) {
        var K = Y;
        if (K.match(/\d/g) || (K = ""), L || (K = $ca0c2c480f9252ec$var$T_(K)), y && S && (K = $ca0c2c480f9252ec$var$Rc(K, S, y)), K !== Y) {
            var Ae = $ca0c2c480f9252ec$var$Fc(K, l);
            V({
                formattedValue: Ae,
                value: K,
                floatValue: parseFloat(K)
            }, {
                event: ue,
                source: $ca0c2c480f9252ec$var$fa.event
            });
        }
        I(ue);
    }, le = function(ue) {
        return ue === g ? !0 : $ca0c2c480f9252ec$var$Jr(ue);
    }, Ne = function(ue) {
        var K = ue.currentValue, Ae = ue.lastValue, we = ue.formattedValue, me = ue.currentValueIndex, ve = ue.formattedValueIndex, Ce = K[me], qe = we[ve], Be = $ca0c2c480f9252ec$var$vu(Ae, K), Fe = Be.to;
        return me >= Fe.start && me < Fe.end && A && A.includes(Ce) && qe === g ? !0 : Ce === qe;
    };
    return Object.assign(Object.assign({}, s), {
        value: z,
        valueIsNumericString: !1,
        isValidInputCharacter: le,
        isCharacterSame: Ne,
        onValueChange: V,
        format: F,
        removeFormatting: $,
        getCaretBoundary: function(ue) {
            return $ca0c2c480f9252ec$var$j_(ue, l);
        },
        onKeyDown: fe,
        onBlur: xe
    });
}
function $ca0c2c480f9252ec$var$G_(l) {
    var p = $ca0c2c480f9252ec$var$K_(l);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement($ca0c2c480f9252ec$var$Au, Object.assign({}, p));
}
function $ca0c2c480f9252ec$var$V_(l, p) {
    var u = p.format, L = p.allowEmptyFormatting, _ = p.mask, I = p.patternChar;
    if (I === void 0 && (I = "#"), l === "" && !L) return "";
    for(var E = 0, S = u.split(""), y = 0, k = u.length; y < k; y++)u[y] === I && (S[y] = l[E] || $ca0c2c480f9252ec$var$_u(_, E), E += 1);
    return S.join("");
}
function $ca0c2c480f9252ec$var$Y_(l, p, u) {
    p === void 0 && (p = $ca0c2c480f9252ec$var$bu(l));
    var L = u.format, _ = u.patternChar;
    _ === void 0 && (_ = "#");
    var I = p.from, E = p.to, S = p.lastValue;
    S === void 0 && (S = "");
    var y = function(g) {
        return L[g] === _;
    }, k = function(g, A) {
        for(var F = "", $ = 0; $ < g.length; $++)y(A + $) && $ca0c2c480f9252ec$var$Jr(g[$]) && (F += g[$]);
        return F;
    }, b = function(g) {
        return g.replace(/[^0-9]/g, "");
    };
    if (!L.match(/\d/)) return b(l);
    if ((S === "" || I.end - I.start === S.length) && l.length === L.length) {
        for(var m = "", i = 0; i < l.length; i++)if (y(i)) $ca0c2c480f9252ec$var$Jr(l[i]) && (m += l[i]);
        else if (l[i] !== L[i]) return b(l);
        return m;
    }
    var a = S.substring(0, I.start), s = l.substring(E.start, E.end), c = S.substring(I.end);
    return "" + k(a, 0) + b(s) + k(c, I.end);
}
function $ca0c2c480f9252ec$var$z_(l, p) {
    var u = p.format, L = p.mask, _ = p.patternChar;
    _ === void 0 && (_ = "#");
    var I = Array.from({
        length: l.length + 1
    }).map(function() {
        return !0;
    }), E = 0, S = -1, y = {};
    u.split("").forEach(function(i, a) {
        var s = void 0;
        i === _ && (E++, s = $ca0c2c480f9252ec$var$_u(L, E - 1), S === -1 && l[a] === s && (S = a)), y[a] = s;
    });
    for(var k = function(i) {
        return u[i] === _ && l[i] !== y[i];
    }, b = 0, m = I.length; b < m; b++)I[b] = b === S || k(b) || k(b - 1);
    return I[u.indexOf(_)] = !0, I;
}
function $ca0c2c480f9252ec$var$Z_(l) {
    var p = l.mask;
    if (p) {
        var u = p === "string" ? p : p.toString();
        if (u.match(/\d/g)) throw new Error("Mask " + p + " should not contain numeric character;");
    }
}
function $ca0c2c480f9252ec$var$X_(l, p) {
    return l === "" ? !0 : !(p != null && p.match(/\d/)) && typeof l == "string" && (!!l.match(/^\d+$/) || l === "");
}
function $ca0c2c480f9252ec$var$J_(l) {
    l.mask, l.allowEmptyFormatting;
    var p = l.format, u = l.inputMode;
    u === void 0 && (u = "numeric");
    var L = l.onKeyDown;
    L === void 0 && (L = $ca0c2c480f9252ec$var$gr);
    var _ = l.patternChar;
    _ === void 0 && (_ = "#");
    var I = l.value, E = l.defaultValue, S = l.valueIsNumericString, y = $ca0c2c480f9252ec$var$So(l, [
        "mask",
        "allowEmptyFormatting",
        "format",
        "inputMode",
        "onKeyDown",
        "patternChar",
        "value",
        "defaultValue",
        "valueIsNumericString"
    ]);
    $ca0c2c480f9252ec$var$Z_(l);
    var k = function(s) {
        return $ca0c2c480f9252ec$var$z_(s, l);
    }, b = function(s) {
        var c = s.key, g = s.target, A = g.selectionStart, F = g.selectionEnd, $ = g.value;
        if (A !== F) {
            L(s);
            return;
        }
        var J = A;
        if (c === "Backspace" || c === "Delete") {
            var se = "right";
            if (c === "Backspace") {
                for(; J > 0 && p[J - 1] !== _;)J--;
                se = "left";
            } else {
                for(var Q = p.length; J < Q && p[J] !== _;)J++;
                se = "right";
            }
            J = $ca0c2c480f9252ec$var$ss($, J, k($), se);
        } else p[J] !== _ && c !== "ArrowLeft" && c !== "ArrowRight" && (J = $ca0c2c480f9252ec$var$ss($, J + 1, k($), "right"));
        J !== A && $ca0c2c480f9252ec$var$Dr(g, J), L(s);
    }, m = $ca0c2c480f9252ec$var$Xr(I) ? E : I, i = S ?? $ca0c2c480f9252ec$var$X_(m, p), a = Object.assign(Object.assign({}, l), {
        valueIsNumericString: i
    });
    return Object.assign(Object.assign({}, y), {
        value: I,
        defaultValue: E,
        valueIsNumericString: i,
        inputMode: u,
        format: function(s) {
            return $ca0c2c480f9252ec$var$V_(s, a);
        },
        removeFormatting: function(s, c) {
            return $ca0c2c480f9252ec$var$Y_(s, c, a);
        },
        getCaretBoundary: k,
        onKeyDown: b
    });
}
function $ca0c2c480f9252ec$var$Q_(l) {
    var p = $ca0c2c480f9252ec$var$J_(l);
    return (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement($ca0c2c480f9252ec$var$Au, Object.assign({}, p));
}
const $ca0c2c480f9252ec$export$1c89cc3d2b5965be = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, id: p, children: u, numeric: L, label: _, density: I = "medium", icon: E, button: S, highlight: y = !1, inline: k = !1, status: b, feedbackText: m, mask: i, maskPlaceholder: a = "_", showMaskPlaceholder: s = !0, ...c }, g)=>{
    var H;
    const A = $ca0c2c480f9252ec$var$In(p, "input_____"), F = $ca0c2c480f9252ec$var$$t(c), $ = $ca0c2c480f9252ec$var$Yt(c), J = {
        id: A,
        className: $ca0c2c480f9252ec$var$Oe(E && "has-icon"),
        ...$
    }, se = (0, $jXEQt.useRef)((H = c.value ?? c.defaultValue) == null ? void 0 : H.toString()), Q = (0, $jXEQt.useCallback)(({ formattedValue: Y }, { event: z })=>{
        var fe;
        const V = Y.replaceAll(a, "");
        se.current !== V && (se.current = V, (fe = J.onChange) == null || fe.call(J, {
            ...z,
            target: {
                ...z == null ? void 0 : z.target,
                value: V
            }
        }));
    }, [
        J.onChange,
        a
    ]), _e = (0, $jXEQt.useMemo)(()=>({
            onChange: ()=>null,
            onValueChange: Q
        }), [
        Q
    ]);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: $ca0c2c480f9252ec$var$Oe("br-input", I === "small" && "small", I === "large" && "large", y && "input-highlight", k && "input-inline", b, l, ...F),
        children: [
            _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "input-label",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                    htmlFor: A,
                    children: _
                })
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "input-content",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: "input-group",
                    children: [
                        E && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: "input-icon",
                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                                icon: E
                            })
                        }),
                        L ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$G_, {
                            getInputRef: g,
                            ...J,
                            allowNegative: !1,
                            allowLeadingZeros: !0,
                            decimalScale: 0,
                            fixedDecimalScale: !0,
                            decimalSeparator: ",",
                            ...typeof L == "object" && L,
                            ..._e
                        }) : i ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$Q_, {
                            getInputRef: g,
                            format: i,
                            ...s && {
                                mask: a
                            },
                            ...J,
                            ..._e
                        }) : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("input", {
                            ref: g,
                            ...J
                        }),
                        S,
                        m && (b ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$91803f13bd898dcd, {
                            category: "feedback",
                            status: b,
                            message: m
                        }) : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("p", {
                            className: "text-down-01",
                            children: m
                        })),
                        u
                    ]
                })
            })
        ]
    });
}), $ca0c2c480f9252ec$export$48493b3d35ec1140 = ({ label: l, large: p })=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: "d-flex flex-column align-items-center",
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: $ca0c2c480f9252ec$var$Oe("loading", p && "medium")
            }),
            l && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                className: "rotulo mt-1",
                children: l
            })
        ]
    }), $ca0c2c480f9252ec$export$e9d14a770cefd3e1 = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, id: p, children: u, density: L = "medium", ..._ }, I)=>{
    const E = $ca0c2c480f9252ec$var$In(p, "magicbutton_____"), S = $ca0c2c480f9252ec$var$$t(_), y = $ca0c2c480f9252ec$var$Yt(_), k = (0, $jXEQt.useRef)(null), b = (0, $jXEQt.useRef)(null);
    return $ca0c2c480f9252ec$var$ha(I, b, {
        get element () {
            return b.current;
        }
    }), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        ref: k,
        className: $ca0c2c480f9252ec$var$Oe("br-magic-button", L, l, ...S),
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
            id: E,
            ref: b,
            ...y,
            children: u
        })
    });
}), $ca0c2c480f9252ec$export$52797c36be27ec5f = ()=>{
    const [l, p] = (0, $jXEQt.useState)(window.innerWidth);
    return (0, $jXEQt.useEffect)(()=>{
        function u() {
            p(window.innerWidth);
        }
        return window.addEventListener("resize", u), ()=>window.removeEventListener("resize", u);
    }, []), l;
}, $ca0c2c480f9252ec$var$Eu = (l)=>!!(l != null && l.length) && (l == null ? void 0 : l.some((p)=>(p == null ? void 0 : p.active) || $ca0c2c480f9252ec$var$Eu(p == null ? void 0 : p.submenu))), $ca0c2c480f9252ec$var$go = (l)=>{
    var p, u, L;
    return ((p = l == null ? void 0 : l.parentElement) == null ? void 0 : p.closest(".side-menu")) || ((u = l == null ? void 0 : l.parentElement) == null ? void 0 : u.closest(".menu-folder")) || ((L = l == null ? void 0 : l.parentElement) == null ? void 0 : L.closest(".menu-body"));
}, $ca0c2c480f9252ec$var$xu = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, id: u, label: L, level: _ = 2, href: I, icon: E, submenu: S, divider: y = !1, expanded: k = !1, active: b = !1, danger: m = !1, keepMenuActive: i = !1, onClick: a, menuType: s = "normal", refMenuObject: c, ...g }, A)=>{
    const F = $ca0c2c480f9252ec$var$In(u, "menuitem_____"), $ = $ca0c2c480f9252ec$var$$t(g), J = $ca0c2c480f9252ec$var$Yt(g), se = A ?? (0, $jXEQt.useRef)(null), Q = se.current, _e = (0, $jXEQt.useMemo)(()=>$ca0c2c480f9252ec$var$Eu(S), [
        S
    ]), H = $ca0c2c480f9252ec$export$52797c36be27ec5f();
    return (0, $jXEQt.useEffect)(()=>{
        var Y, z;
        if (Q && b) {
            Q.removeAttribute("hidden"), Q.classList.add("active");
            const V = $ca0c2c480f9252ec$var$go(Q), fe = Array.from(((Y = V != null && V.classList.contains("menu-folder") ? $ca0c2c480f9252ec$var$go(V) : V) == null ? void 0 : Y.querySelectorAll(".menu-item")) ?? []);
            fe == null || fe.forEach((ue)=>{
                ue !== Q && (ue.removeAttribute("hidden"), ue.classList.remove("active"));
            });
            let xe = [], le = V;
            for(; le;)V != null && V.classList.contains("side-menu") && V !== le && le.querySelectorAll(".menu-item").forEach((ue)=>{
                fe.includes(ue) || ue.setAttribute("hidden", "");
            }), xe.push(le), le = $ca0c2c480f9252ec$var$go(le);
            const Ne = (z = Q.closest(".menu-body")) == null ? void 0 : z.querySelectorAll(".menu-folder, .side-menu");
            Ne == null || Ne.forEach((ue)=>{
                xe.includes(ue) ? ue.classList.add("active") : ue.classList.remove("active");
            });
        }
    }, [
        Q,
        b
    ]), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$var$vr, {
        ...!!(S != null && S.length) && _ === 2 && {
            tagName: "div"
        },
        className: $ca0c2c480f9252ec$var$Oe(!!(S != null && S.length) && "menu-folder drop-menu", _e && "active"),
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$var$vr, {
                ref: se,
                id: F,
                tagName: k ? "div" : "a",
                className: $ca0c2c480f9252ec$var$Oe("menu-item", y && "divider", l, ...$, b && "active", m && "text-danger", _ > 2 && _e && "side-menu-init-open"),
                ...I && !k && {
                    href: I
                },
                ...!!(S != null && S.length) && !k && {
                    href: "#",
                    onClick: (Y)=>Y.preventDefault()
                },
                ...a && {
                    href: I ?? "#",
                    onClick: (Y)=>{
                        var z;
                        Y.preventDefault(), Y.stopPropagation(), a == null || a(), !i && !(S != null && S.length) && ([
                            "normal",
                            "contextual"
                        ].includes(s) || H < 576) && ((z = c == null ? void 0 : c.current) == null || z._closeMenu());
                    }
                },
                ...J,
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                        className: "icon",
                        children: E && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                            className: E.includes("fas ") ? E : `fas fa-${E}`,
                            "aria-hidden": "true"
                        })
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                        className: "content",
                        children: L
                    })
                ]
            }),
            !!(S != null && S.length) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("ul", {
                children: S.map((Y, z)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("li", {
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$xu, {
                            href: Y.link,
                            icon: Y.icon,
                            label: Y.label,
                            submenu: Y.submenu,
                            level: _ + 1,
                            divider: Y.divider,
                            expanded: Y.expanded,
                            active: Y.active,
                            danger: Y.danger,
                            keepMenuActive: Y.keepMenuActive,
                            onClick: Y == null ? void 0 : Y.onClick,
                            menuType: s,
                            refMenuObject: c
                        })
                    }, z))
            }),
            p
        ]
    });
}), $ca0c2c480f9252ec$export$72175f23bf9e372f = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, id: u, data: L, logos: _, externalLinks: I, socialNetworks: E, info: S, systemLogoUrl: y, systemName: k, contextualTriggerTitle: b, type: m = "normal", density: i = "normal", sm: a, md: s = 4, lg: c = 3, xl: g = 2, startActive: A, closable: F = !1, shadow: $, showFooter: J, ...se }, Q)=>{
    const _e = $ca0c2c480f9252ec$var$In(u, "menu_____"), H = $ca0c2c480f9252ec$var$$t(se);
    (m === "normal" || m === "contextual") && H.forEach((le, Ne)=>{
        le && le.startsWith("m") && delete H[Ne];
    });
    const Y = $ca0c2c480f9252ec$var$Yt(se), z = (0, $jXEQt.useMemo)(()=>$ca0c2c480f9252ec$var$au({
            sm: a,
            md: s,
            lg: c,
            xl: g
        }), [
        a,
        s,
        c,
        g
    ]), V = (0, $jXEQt.useRef)(), fe = (0, $jXEQt.useRef)(null), xe = (0, $jXEQt.useRef)(null);
    return $ca0c2c480f9252ec$var$ha(Q, fe, {
        get element () {
            return fe.current;
        }
    }), (0, $jXEQt.useEffect)(()=>{
        var le, Ne, ue;
        if (fe.current) {
            if (V.current || (V.current = new $ca0c2c480f9252ec$var$us.BRMenu("br-menu", fe.current)), V.current.component = fe.current, V.current.breakpoints = Object.keys(z), V.current._setBreakpoints(), V.current._setDropMenu(), V.current._setSideMenu(), m === "contextual") {
                (le = fe.current.querySelector(".menu-panel")) == null || le.classList.remove(...Object.keys(z)), xe.current && (xe.current.hasAttribute("data-click-listener") || (xe.current.addEventListener("click", ()=>{
                    var Ae;
                    (Ae = fe.current) != null && Ae.classList.contains("active") ? V.current._closeMenu() : V.current._openMenu();
                }), (Ne = xe.current) == null || Ne.setAttribute("data-click-listener", "")));
                const K = (ue = xe.current) == null ? void 0 : ue.offsetHeight;
                document.body.setAttribute("style", `padding-bottom: ${K}px; margin-bottom: 0 !important;`);
            } else document.body.removeAttribute("style");
            return ()=>{
                document.body.removeAttribute("style");
            };
        }
    }, [
        fe.current,
        xe.current,
        V.current,
        L,
        m,
        A,
        z
    ]), (0, $jXEQt.useEffect)(()=>{
        document.querySelectorAll(".side-menu-init-open").forEach((le)=>{
            const Ne = le;
            Ne.click(), Ne.blur(), Ne.classList.remove("side-menu-init-open");
        });
    }, []), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
        children: [
            m === "contextual" && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("style", {
                children: `@media (min-width: 992px) {
  .br-menu.contextual .menu-container {
    display: none;
  }
  .br-menu.contextual.active,
  .br-menu.contextual .menu-trigger {
    position: fixed;
  }
}`
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                "data-breakpoints": Object.keys(z).join(" "),
                ref: fe,
                id: _e,
                className: $ca0c2c480f9252ec$var$Oe("br-menu", m === "push" && "push", m === "contextual" && "contextual", i === "small" && "small", i === "large" && "large", A && "active", A && m === "push" && "px-0", A && m === "push" && z, l, ...H),
                ...Y,
                children: [
                    m === "contextual" && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "menu-trigger",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("button", {
                            ref: xe,
                            className: "br-button primary block py-4",
                            type: "button",
                            children: [
                                b && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: "mr-1",
                                    children: b
                                }),
                                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                    className: "fas fa-chevron-up ml-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        className: $ca0c2c480f9252ec$var$Oe("menu-container", m === "contextual" && $ && "shadow-lg-up"),
                        children: [
                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: $ca0c2c480f9252ec$var$Oe("menu-panel", $ && "h-auto position-static shadow-lg-right", m === "normal" && z),
                                children: [
                                    (y || k || F) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: "menu-header",
                                        children: [
                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                                className: "menu-title",
                                                children: [
                                                    y && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("img", {
                                                        src: y,
                                                        alt: k
                                                    }),
                                                    y && k && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                                        className: "br-divider vertical mx-2"
                                                    }),
                                                    k && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                                        children: k
                                                    })
                                                ]
                                            }),
                                            F && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: "menu-close",
                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                                    className: "br-button circle",
                                                    type: "button",
                                                    "aria-label": "Fechar o menu",
                                                    "data-dismiss": "menu",
                                                    children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                        className: "fas fa-times",
                                                        "aria-hidden": "true"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        className: "menu-body",
                                        children: !!(L != null && L.length) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)((0, $56c05cee281658b4$exports.Fragment), {
                                            children: L.map((le, Ne)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$xu, {
                                                    href: le.link,
                                                    icon: le.icon,
                                                    label: le.label,
                                                    submenu: le.submenu,
                                                    level: 2,
                                                    divider: le.divider,
                                                    expanded: le.expanded,
                                                    active: le.active,
                                                    danger: le.danger,
                                                    keepMenuActive: le.keepMenuActive,
                                                    onClick: le == null ? void 0 : le.onClick,
                                                    menuType: m,
                                                    refMenuObject: V
                                                }, Ne))
                                        })
                                    }),
                                    !(typeof J == "boolean" && !J) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: $ca0c2c480f9252ec$var$Oe("menu-footer", {
                                            "d-sm-block": J
                                        }),
                                        children: [
                                            _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: "menu-logos",
                                                children: _.map((le, Ne)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("img", {
                                                        src: le.src,
                                                        alt: le.alt
                                                    }, Ne))
                                            }),
                                            I && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: "menu-links",
                                                children: I.map((le, Ne)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("a", {
                                                        href: le.link,
                                                        children: [
                                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                                                className: "mr-1",
                                                                children: le.label
                                                            }),
                                                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                                className: "fas fa-external-link-square-alt",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    }, Ne))
                                            }),
                                            E && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                                className: "menu-social",
                                                children: [
                                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                        className: "text-semi-bold mb-1",
                                                        children: "Redes Sociais"
                                                    }),
                                                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                        className: "sharegroup",
                                                        children: E.map((le, Ne)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                                className: "share",
                                                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("a", {
                                                                    className: "br-button circle",
                                                                    href: le.link,
                                                                    "aria-label": `Compartilhar por ${le.name}`,
                                                                    children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("i", {
                                                                        className: le.icon,
                                                                        "aria-hidden": "true"
                                                                    })
                                                                })
                                                            }, Ne))
                                                    })
                                                ]
                                            }),
                                            S && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                className: "menu-info",
                                                children: S
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                className: "menu-scrim",
                                "data-dismiss": "menu",
                                tabIndex: 0
                            })
                        ]
                    }),
                    p
                ]
            })
        ]
    });
});
let $ca0c2c480f9252ec$var$rs = 0;
const $ca0c2c480f9252ec$var$ty = ()=>{
    $ca0c2c480f9252ec$var$rs++, document.body.classList.add("overflow-hidden");
}, $ca0c2c480f9252ec$var$qc = ()=>{
    $ca0c2c480f9252ec$var$rs > 0 && $ca0c2c480f9252ec$var$rs--, $ca0c2c480f9252ec$var$rs === 0 && document.body.classList.remove("overflow-hidden");
}, $ca0c2c480f9252ec$var$ny = (l)=>{
    (0, $jXEQt.useEffect)(()=>(l ? $ca0c2c480f9252ec$var$ty() : $ca0c2c480f9252ec$var$qc(), $ca0c2c480f9252ec$var$qc), [
        l
    ]);
}, $ca0c2c480f9252ec$var$ry = ({ primaryAction: l, secondaryAction: p, keepOpenOnPrimaryAction: u, keepOpenOnSecondaryAction: L, focusOnPrimaryAction: _, focusOnSecondaryAction: I, onClose: E, formId: S })=>{
    const k = $ca0c2c480f9252ec$var$Oe("br-modal-footer px-2", `justify-content-${l && p ? "end" : "center"}`), b = (0, $jXEQt.useRef)(null), m = (0, $jXEQt.useRef)(null);
    (0, $jXEQt.useEffect)(()=>{
        var c, g, A, F;
        _ ? m.current && document.activeElement !== m.current && (m.current.contentEditable = "true", (g = (c = m.current).focus) == null || g.call(c), m.current.contentEditable = "false") : I && b.current && document.activeElement !== b.current && (b.current.contentEditable = "true", (F = (A = b.current) == null ? void 0 : A.focus) == null || F.call(A), b.current.contentEditable = "false");
    }, [
        m,
        b
    ]);
    const i = ()=>{
        l != null && l.action && l.action(), !u && (E == null || E());
    }, a = ()=>{
        p != null && p.action && p.action(), !L && (E == null || E());
    }, s = S ? {
        type: "submit"
    } : {
        type: "button",
        onClick: i
    };
    return l || p ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: k,
        children: [
            !!p && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                ref: b,
                secondary: !0,
                size: "small",
                mt: 1,
                ml: 1,
                onClick: a,
                disabled: p.disabled,
                block: !0,
                clearBlock: "md",
                children: p.label || "Cancelar"
            }),
            !!l && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                ref: m,
                primary: !0,
                size: "small",
                mt: 1,
                ml: 1,
                disabled: l.disabled,
                block: !0,
                clearBlock: "md",
                ...s,
                children: l.label || "Confirmar"
            })
        ]
    }) : null;
}, $ca0c2c480f9252ec$export$9bf5abad0301adc = (l)=>{
    const { children: p, title: u, showClose: L, primaryAction: _, secondaryAction: I, isOpen: E, keepOpenOnPrimaryAction: S, keepOpenOnSecondaryAction: y, focusOnPrimaryAction: k, focusOnSecondaryAction: b, onClose: m, minWidth: i, minHeight: a, height: s, width: c, formId: g } = l, A = $ca0c2c480f9252ec$var$Oe("br-scrim", "foco", {
        active: !0
    }), F = $ca0c2c480f9252ec$export$52797c36be27ec5f() < 1024, $ = (Q)=>{
        Q.target === Q.currentTarget && (m == null || m());
    }, J = g ? "form" : (0, $jXEQt.Fragment), se = g ? {
        id: g,
        onSubmit: _ == null ? void 0 : _.action
    } : {};
    return $ca0c2c480f9252ec$var$ny(E), E ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)(J, {
        ...se,
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
            className: A,
            onClick: $,
            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "br-modal p-0 auto",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: "br-card py-2",
                    style: {
                        flexDirection: "column"
                    },
                    children: [
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: "br-modal-header",
                            children: [
                                u && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    className: "br-modal-title px-2",
                                    title: u,
                                    children: u
                                }),
                                (L || u) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                    circle: !0,
                                    close: !0,
                                    size: "small",
                                    "aria-label": "Fechar",
                                    onClick: m,
                                    children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                                        icon: "times",
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: "mb-2 px-2",
                            style: {
                                overflowY: "auto",
                                width: F ? "95vw" : c,
                                minWidth: F ? "95vw" : i,
                                height: s,
                                minHeight: a,
                                maxHeight: "calc(100vh - 200px)"
                            },
                            children: p
                        }),
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$ry, {
                            formId: g,
                            primaryAction: _,
                            secondaryAction: I,
                            keepOpenOnPrimaryAction: S,
                            keepOpenOnSecondaryAction: y,
                            focusOnPrimaryAction: k,
                            focusOnSecondaryAction: b,
                            onClose: m
                        })
                    ]
                })
            })
        })
    }) : null;
};
var $ca0c2c480f9252ec$var$os = {
    exports: {}
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ $ca0c2c480f9252ec$var$os.exports;
(function(l, p) {
    (function() {
        var u, L = "4.17.21", _ = 200, I = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", E = "Expected a function", S = "Invalid `variable` option passed into `_.template`", y = "__lodash_hash_undefined__", k = 500, b = "__lodash_placeholder__", m = 1, i = 2, a = 4, s = 1, c = 2, g = 1, A = 2, F = 4, $ = 8, J = 16, se = 32, Q = 64, _e = 128, H = 256, Y = 512, z = 30, V = "...", fe = 800, xe = 16, le = 1, Ne = 2, ue = 3, K = 1 / 0, Ae = 9007199254740991, we = 17976931348623157e292, me = 0 / 0, ve = 4294967295, Ce = ve - 1, qe = ve >>> 1, Be = [
            [
                "ary",
                _e
            ],
            [
                "bind",
                g
            ],
            [
                "bindKey",
                A
            ],
            [
                "curry",
                $
            ],
            [
                "curryRight",
                J
            ],
            [
                "flip",
                Y
            ],
            [
                "partial",
                se
            ],
            [
                "partialRight",
                Q
            ],
            [
                "rearg",
                H
            ]
        ], Fe = "[object Arguments]", Re = "[object Array]", ge = "[object AsyncFunction]", ne = "[object Boolean]", ut = "[object Date]", M = "[object DOMException]", P = "[object Error]", n = "[object Function]", ye = "[object GeneratorFunction]", ke = "[object Map]", Me = "[object Number]", ht = "[object Null]", oe = "[object Object]", be = "[object Promise]", He = "[object Proxy]", Ie = "[object RegExp]", pe = "[object Set]", Le = "[object String]", Te = "[object Symbol]", It = "[object Undefined]", je = "[object WeakMap]", Ot = "[object WeakSet]", Kt = "[object ArrayBuffer]", yt = "[object DataView]", qt = "[object Float32Array]", zt = "[object Float64Array]", On = "[object Int8Array]", ee = "[object Int16Array]", We = "[object Int32Array]", Ye = "[object Uint8Array]", lt = "[object Uint8ClampedArray]", wt = "[object Uint16Array]", Mt = "[object Uint32Array]", jt = /\b__p \+= '';/g, cn = /\b(__p \+=) '' \+/g, Ii = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ir = /&(?:amp|lt|gt|quot|#39);/g, Qr = /[&<>"']/g, ei = RegExp(Ir.source), ti = RegExp(Qr.source), ni = /<%-([\s\S]+?)%>/g, Oi = /<%([\s\S]+?)%>/g, _r = /<%=([\s\S]+?)%>/g, Mi = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ni = /^\w*$/, Bi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Mn = /[\\^$.*+?()[\]{}|]/g, Or = RegExp(Mn.source), gn = /^\s+/, Nn = /\s/, Jn = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Pi = /\{\n\/\* \[wrapped with (.+)\] \*/, ri = /,? & /, Qn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Mr = /[()=,{}\[\]\/\s]/, Ri = /\\(\\)?/g, Nr = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ii = /\w*$/, ai = /^[-+]0x[0-9a-f]+$/i, Br = /^0b[01]+$/i, er = /^\[object .+?Constructor\]$/, si = /^0o[0-7]+$/i, tr = /^(?:0|[1-9]\d*)$/, oi = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Kn = /($^)/, li = /['\n\r\u2028\u2029\\]/g, Bn = "\\ud800-\\udfff", Fi = "\\u0300-\\u036f", Gn = "\\ufe20-\\ufe2f", qi = "\\u20d0-\\u20ff", Pr = Fi + Gn + qi, ci = "\\u2700-\\u27bf", ui = "a-z\\xdf-\\xf6\\xf8-\\xff", di = "\\xac\\xb1\\xd7\\xf7", Wi = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ui = "\\u2000-\\u206f", St = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", nr = "A-Z\\xc0-\\xd6\\xd8-\\xde", yr = "\\ufe0e\\ufe0f", Hi = di + Wi + Ui + St, Vn = "['\u2019]", Rr = "[" + Bn + "]", C = "[" + Hi + "]", D = "[" + Pr + "]", B = "\\d+", d = "[" + ci + "]", h = "[" + ui + "]", T = "[^" + Bn + Hi + B + ci + ui + nr + "]", R = "\\ud83c[\\udffb-\\udfff]", U = "(?:" + D + "|" + R + ")", j = "[^" + Bn + "]", ce = "(?:\\ud83c[\\udde6-\\uddff]){2}", Z = "[\\ud800-\\udbff][\\udc00-\\udfff]", Se = "[" + nr + "]", de = "\\u200d", he = "(?:" + h + "|" + T + ")", Ue = "(?:" + Se + "|" + T + ")", ze = "(?:" + Vn + "(?:d|ll|m|re|s|t|ve))?", Ve = "(?:" + Vn + "(?:D|LL|M|RE|S|T|VE))?", ct = U + "?", pt = "[" + yr + "]?", Lt = "(?:" + de + "(?:" + [
            j,
            ce,
            Z
        ].join("|") + ")" + pt + ct + ")*", Je = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ft = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", dt = pt + ct + Lt, kt = "(?:" + [
            d,
            ce,
            Z
        ].join("|") + ")" + dt, Wt = "(?:" + [
            j + D + "?",
            D,
            ce,
            Z,
            Rr
        ].join("|") + ")", Nt = RegExp(Vn, "g"), Dt = RegExp(D, "g"), Bt = RegExp(R + "(?=" + R + ")|" + Wt + dt, "g"), nn = RegExp([
            Se + "?" + h + "+" + ze + "(?=" + [
                C,
                Se,
                "$"
            ].join("|") + ")",
            Ue + "+" + Ve + "(?=" + [
                C,
                Se + he,
                "$"
            ].join("|") + ")",
            Se + "?" + he + "+" + ze,
            Se + "+" + Ve,
            ft,
            Je,
            B,
            kt
        ].join("|"), "g"), Xt = RegExp("[" + de + Bn + Pr + yr + "]"), rr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ir = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], rn = -1, it = {};
        it[qt] = it[zt] = it[On] = it[ee] = it[We] = it[Ye] = it[lt] = it[wt] = it[Mt] = !0, it[Fe] = it[Re] = it[Kt] = it[ne] = it[yt] = it[ut] = it[P] = it[n] = it[ke] = it[Me] = it[oe] = it[Ie] = it[pe] = it[Le] = it[je] = !1;
        var mt = {};
        mt[Fe] = mt[Re] = mt[Kt] = mt[yt] = mt[ne] = mt[ut] = mt[qt] = mt[zt] = mt[On] = mt[ee] = mt[We] = mt[ke] = mt[Me] = mt[oe] = mt[Ie] = mt[pe] = mt[Le] = mt[Te] = mt[Ye] = mt[lt] = mt[wt] = mt[Mt] = !0, mt[P] = mt[n] = mt[je] = !1;
        var ar = {
            // Latin-1 Supplement block.
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "A",
            "\xc5": "A",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "a",
            "\xe5": "a",
            "\xc7": "C",
            "\xe7": "c",
            "\xd0": "D",
            "\xf0": "d",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xd1": "N",
            "\xf1": "n",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "O",
            "\xd8": "O",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "o",
            "\xf8": "o",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "U",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "u",
            "\xdd": "Y",
            "\xfd": "y",
            "\xff": "y",
            "\xc6": "Ae",
            "\xe6": "ae",
            "\xde": "Th",
            "\xfe": "th",
            "\xdf": "ss",
            // Latin Extended-A block.
            \u0100: "A",
            \u0102: "A",
            \u0104: "A",
            \u0101: "a",
            \u0103: "a",
            \u0105: "a",
            \u0106: "C",
            \u0108: "C",
            \u010A: "C",
            \u010C: "C",
            \u0107: "c",
            \u0109: "c",
            \u010B: "c",
            \u010D: "c",
            \u010E: "D",
            \u0110: "D",
            \u010F: "d",
            \u0111: "d",
            \u0112: "E",
            \u0114: "E",
            \u0116: "E",
            \u0118: "E",
            \u011A: "E",
            \u0113: "e",
            \u0115: "e",
            \u0117: "e",
            \u0119: "e",
            \u011B: "e",
            \u011C: "G",
            \u011E: "G",
            \u0120: "G",
            \u0122: "G",
            \u011D: "g",
            \u011F: "g",
            \u0121: "g",
            \u0123: "g",
            \u0124: "H",
            \u0126: "H",
            \u0125: "h",
            \u0127: "h",
            \u0128: "I",
            \u012A: "I",
            \u012C: "I",
            \u012E: "I",
            \u0130: "I",
            \u0129: "i",
            \u012B: "i",
            \u012D: "i",
            \u012F: "i",
            \u0131: "i",
            \u0134: "J",
            \u0135: "j",
            \u0136: "K",
            \u0137: "k",
            \u0138: "k",
            \u0139: "L",
            \u013B: "L",
            \u013D: "L",
            \u013F: "L",
            \u0141: "L",
            \u013A: "l",
            \u013C: "l",
            \u013E: "l",
            \u0140: "l",
            \u0142: "l",
            \u0143: "N",
            \u0145: "N",
            \u0147: "N",
            \u014A: "N",
            \u0144: "n",
            \u0146: "n",
            \u0148: "n",
            \u014B: "n",
            \u014C: "O",
            \u014E: "O",
            \u0150: "O",
            \u014D: "o",
            \u014F: "o",
            \u0151: "o",
            \u0154: "R",
            \u0156: "R",
            \u0158: "R",
            \u0155: "r",
            \u0157: "r",
            \u0159: "r",
            \u015A: "S",
            \u015C: "S",
            \u015E: "S",
            \u0160: "S",
            \u015B: "s",
            \u015D: "s",
            \u015F: "s",
            \u0161: "s",
            \u0162: "T",
            \u0164: "T",
            \u0166: "T",
            \u0163: "t",
            \u0165: "t",
            \u0167: "t",
            \u0168: "U",
            \u016A: "U",
            \u016C: "U",
            \u016E: "U",
            \u0170: "U",
            \u0172: "U",
            \u0169: "u",
            \u016B: "u",
            \u016D: "u",
            \u016F: "u",
            \u0171: "u",
            \u0173: "u",
            \u0174: "W",
            \u0175: "w",
            \u0176: "Y",
            \u0177: "y",
            \u0178: "Y",
            \u0179: "Z",
            \u017B: "Z",
            \u017D: "Z",
            \u017A: "z",
            \u017C: "z",
            \u017E: "z",
            \u0132: "IJ",
            \u0133: "ij",
            \u0152: "Oe",
            \u0153: "oe",
            \u0149: "'n",
            \u017F: "s"
        }, fi = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, ji = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }, Fr = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, hi = parseFloat, Ar = parseInt, Pn = typeof $ca0c2c480f9252ec$var$Xn == "object" && $ca0c2c480f9252ec$var$Xn && $ca0c2c480f9252ec$var$Xn.Object === Object && $ca0c2c480f9252ec$var$Xn, qr = typeof self == "object" && self && self.Object === Object && self, Pt = Pn || qr || Function("return this")(), Rn = p && !p.nodeType && p, Fn = Rn && !0 && l && !l.nodeType && l, pa = Fn && Fn.exports === Rn, Wr = pa && Pn.process, un = function() {
            try {
                var q = Fn && Fn.require && Fn.require("util").types;
                return q || Wr && Wr.binding && Wr.binding("util");
            } catch  {}
        }(), $i = un && un.isArrayBuffer, ma = un && un.isDate, ga = un && un.isMap, Ki = un && un.isRegExp, Gi = un && un.isSet, va = un && un.isTypedArray;
        function an(q, X, G) {
            switch(G.length){
                case 0:
                    return q.call(X);
                case 1:
                    return q.call(X, G[0]);
                case 2:
                    return q.call(X, G[0], G[1]);
                case 3:
                    return q.call(X, G[0], G[1], G[2]);
            }
            return q.apply(X, G);
        }
        function sr(q, X, G, De) {
            for(var Ze = -1, gt = q == null ? 0 : q.length; ++Ze < gt;){
                var Gt = q[Ze];
                X(De, Gt, G(Gt), q);
            }
            return De;
        }
        function Jt(q, X) {
            for(var G = -1, De = q == null ? 0 : q.length; ++G < De && X(q[G], G, q) !== !1;);
            return q;
        }
        function ba(q, X) {
            for(var G = q == null ? 0 : q.length; G-- && X(q[G], G, q) !== !1;);
            return q;
        }
        function Vi(q, X) {
            for(var G = -1, De = q == null ? 0 : q.length; ++G < De;)if (!X(q[G], G, q)) return !1;
            return !0;
        }
        function wn(q, X) {
            for(var G = -1, De = q == null ? 0 : q.length, Ze = 0, gt = []; ++G < De;){
                var Gt = q[G];
                X(Gt, G, q) && (gt[Ze++] = Gt);
            }
            return gt;
        }
        function Ur(q, X) {
            var G = q == null ? 0 : q.length;
            return !!G && mi(q, X, 0) > -1;
        }
        function pi(q, X, G) {
            for(var De = -1, Ze = q == null ? 0 : q.length; ++De < Ze;)if (G(X, q[De])) return !0;
            return !1;
        }
        function xt(q, X) {
            for(var G = -1, De = q == null ? 0 : q.length, Ze = Array(De); ++G < De;)Ze[G] = X(q[G], G, q);
            return Ze;
        }
        function qn(q, X) {
            for(var G = -1, De = X.length, Ze = q.length; ++G < De;)q[Ze + G] = X[G];
            return q;
        }
        function fs(q, X, G, De) {
            var Ze = -1, gt = q == null ? 0 : q.length;
            for(De && gt && (G = q[++Ze]); ++Ze < gt;)G = X(G, q[Ze], Ze, q);
            return G;
        }
        function ku(q, X, G, De) {
            var Ze = q == null ? 0 : q.length;
            for(De && Ze && (G = q[--Ze]); Ze--;)G = X(G, q[Ze], Ze, q);
            return G;
        }
        function hs(q, X) {
            for(var G = -1, De = q == null ? 0 : q.length; ++G < De;)if (X(q[G], G, q)) return !0;
            return !1;
        }
        var Lu = ps("length");
        function Du(q) {
            return q.split("");
        }
        function Tu(q) {
            return q.match(Qn) || [];
        }
        function xo(q, X, G) {
            var De;
            return G(q, function(Ze, gt, Gt) {
                if (X(Ze, gt, Gt)) return De = gt, !1;
            }), De;
        }
        function _a(q, X, G, De) {
            for(var Ze = q.length, gt = G + (De ? 1 : -1); De ? gt-- : ++gt < Ze;)if (X(q[gt], gt, q)) return gt;
            return -1;
        }
        function mi(q, X, G) {
            return X === X ? Hu(q, X, G) : _a(q, Co, G);
        }
        function Iu(q, X, G, De) {
            for(var Ze = G - 1, gt = q.length; ++Ze < gt;)if (De(q[Ze], X)) return Ze;
            return -1;
        }
        function Co(q) {
            return q !== q;
        }
        function ko(q, X) {
            var G = q == null ? 0 : q.length;
            return G ? gs(q, X) / G : me;
        }
        function ps(q) {
            return function(X) {
                return X == null ? u : X[q];
            };
        }
        function ms(q) {
            return function(X) {
                return q == null ? u : q[X];
            };
        }
        function Lo(q, X, G, De, Ze) {
            return Ze(q, function(gt, Gt, Ct) {
                G = De ? (De = !1, gt) : X(G, gt, Gt, Ct);
            }), G;
        }
        function Ou(q, X) {
            var G = q.length;
            for(q.sort(X); G--;)q[G] = q[G].value;
            return q;
        }
        function gs(q, X) {
            for(var G, De = -1, Ze = q.length; ++De < Ze;){
                var gt = X(q[De]);
                gt !== u && (G = G === u ? gt : G + gt);
            }
            return G;
        }
        function vs(q, X) {
            for(var G = -1, De = Array(q); ++G < q;)De[G] = X(G);
            return De;
        }
        function Mu(q, X) {
            return xt(X, function(G) {
                return [
                    G,
                    q[G]
                ];
            });
        }
        function Do(q) {
            return q && q.slice(0, Mo(q) + 1).replace(gn, "");
        }
        function vn(q) {
            return function(X) {
                return q(X);
            };
        }
        function bs(q, X) {
            return xt(X, function(G) {
                return q[G];
            });
        }
        function Yi(q, X) {
            return q.has(X);
        }
        function To(q, X) {
            for(var G = -1, De = q.length; ++G < De && mi(X, q[G], 0) > -1;);
            return G;
        }
        function Io(q, X) {
            for(var G = q.length; G-- && mi(X, q[G], 0) > -1;);
            return G;
        }
        function Nu(q, X) {
            for(var G = q.length, De = 0; G--;)q[G] === X && ++De;
            return De;
        }
        var Bu = ms(ar), Pu = ms(fi);
        function Ru(q) {
            return "\\" + Fr[q];
        }
        function Fu(q, X) {
            return q == null ? u : q[X];
        }
        function gi(q) {
            return Xt.test(q);
        }
        function qu(q) {
            return rr.test(q);
        }
        function Wu(q) {
            for(var X, G = []; !(X = q.next()).done;)G.push(X.value);
            return G;
        }
        function _s(q) {
            var X = -1, G = Array(q.size);
            return q.forEach(function(De, Ze) {
                G[++X] = [
                    Ze,
                    De
                ];
            }), G;
        }
        function Oo(q, X) {
            return function(G) {
                return q(X(G));
            };
        }
        function wr(q, X) {
            for(var G = -1, De = q.length, Ze = 0, gt = []; ++G < De;){
                var Gt = q[G];
                (Gt === X || Gt === b) && (q[G] = b, gt[Ze++] = G);
            }
            return gt;
        }
        function ya(q) {
            var X = -1, G = Array(q.size);
            return q.forEach(function(De) {
                G[++X] = De;
            }), G;
        }
        function Uu(q) {
            var X = -1, G = Array(q.size);
            return q.forEach(function(De) {
                G[++X] = [
                    De,
                    De
                ];
            }), G;
        }
        function Hu(q, X, G) {
            for(var De = G - 1, Ze = q.length; ++De < Ze;)if (q[De] === X) return De;
            return -1;
        }
        function ju(q, X, G) {
            for(var De = G + 1; De--;)if (q[De] === X) return De;
            return De;
        }
        function vi(q) {
            return gi(q) ? Ku(q) : Lu(q);
        }
        function Wn(q) {
            return gi(q) ? Gu(q) : Du(q);
        }
        function Mo(q) {
            for(var X = q.length; X-- && Nn.test(q.charAt(X)););
            return X;
        }
        var $u = ms(ji);
        function Ku(q) {
            for(var X = Bt.lastIndex = 0; Bt.test(q);)++X;
            return X;
        }
        function Gu(q) {
            return q.match(Bt) || [];
        }
        function Vu(q) {
            return q.match(nn) || [];
        }
        var Yu = function q(X) {
            X = X == null ? Pt : bi.defaults(Pt.Object(), X, bi.pick(Pt, ir));
            var G = X.Array, De = X.Date, Ze = X.Error, gt = X.Function, Gt = X.Math, Ct = X.Object, ys = X.RegExp, zu = X.String, Sn = X.TypeError, Aa = G.prototype, Zu = gt.prototype, _i = Ct.prototype, wa = X["__core-js_shared__"], Sa = Zu.toString, At = _i.hasOwnProperty, Xu = 0, No = function() {
                var e = /[^.]+$/.exec(wa && wa.keys && wa.keys.IE_PROTO || "");
                return e ? "Symbol(src)_1." + e : "";
            }(), Ea = _i.toString, Ju = Sa.call(Ct), Qu = Pt._, ed = ys("^" + Sa.call(At).replace(Mn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), xa = pa ? X.Buffer : u, Sr = X.Symbol, Ca = X.Uint8Array, Bo = xa ? xa.allocUnsafe : u, ka = Oo(Ct.getPrototypeOf, Ct), Po = Ct.create, Ro = _i.propertyIsEnumerable, La = Aa.splice, Fo = Sr ? Sr.isConcatSpreadable : u, zi = Sr ? Sr.iterator : u, Hr = Sr ? Sr.toStringTag : u, Da = function() {
                try {
                    var e = Vr(Ct, "defineProperty");
                    return e({}, "", {}), e;
                } catch  {}
            }(), td = X.clearTimeout !== Pt.clearTimeout && X.clearTimeout, nd = De && De.now !== Pt.Date.now && De.now, rd = X.setTimeout !== Pt.setTimeout && X.setTimeout, Ta = Gt.ceil, Ia = Gt.floor, As = Ct.getOwnPropertySymbols, id = xa ? xa.isBuffer : u, qo = X.isFinite, ad = Aa.join, sd = Oo(Ct.keys, Ct), Vt = Gt.max, en = Gt.min, od = De.now, ld = X.parseInt, Wo = Gt.random, cd = Aa.reverse, ws = Vr(X, "DataView"), Zi = Vr(X, "Map"), Ss = Vr(X, "Promise"), yi = Vr(X, "Set"), Xi = Vr(X, "WeakMap"), Ji = Vr(Ct, "create"), Oa = Xi && new Xi(), Ai = {}, ud = Yr(ws), dd = Yr(Zi), fd = Yr(Ss), hd = Yr(yi), pd = Yr(Xi), Ma = Sr ? Sr.prototype : u, Qi = Ma ? Ma.valueOf : u, Uo = Ma ? Ma.toString : u;
            function v(e) {
                if (Rt(e) && !Xe(e) && !(e instanceof st)) {
                    if (e instanceof En) return e;
                    if (At.call(e, "__wrapped__")) return Hl(e);
                }
                return new En(e);
            }
            var wi = function() {
                function e() {}
                return function(t) {
                    if (!Tt(t)) return {};
                    if (Po) return Po(t);
                    e.prototype = t;
                    var r = new e();
                    return e.prototype = u, r;
                };
            }();
            function Na() {}
            function En(e, t) {
                this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = u;
            }
            v.templateSettings = {
                /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */ escape: ni,
                /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */ evaluate: Oi,
                /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */ interpolate: _r,
                /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */ variable: "",
                /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */ imports: {
                    /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */ _: v
                }
            }, v.prototype = Na.prototype, v.prototype.constructor = v, En.prototype = wi(Na.prototype), En.prototype.constructor = En;
            function st(e) {
                this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ve, this.__views__ = [];
            }
            function md() {
                var e = new st(this.__wrapped__);
                return e.__actions__ = dn(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = dn(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = dn(this.__views__), e;
            }
            function gd() {
                if (this.__filtered__) {
                    var e = new st(this);
                    e.__dir__ = -1, e.__filtered__ = !0;
                } else e = this.clone(), e.__dir__ *= -1;
                return e;
            }
            function vd() {
                var e = this.__wrapped__.value(), t = this.__dir__, r = Xe(e), o = t < 0, f = r ? e.length : 0, w = Tf(0, f, this.__views__), O = w.start, N = w.end, W = N - O, te = o ? N : O - 1, re = this.__iteratees__, ie = re.length, Ee = 0, Pe = en(W, this.__takeCount__);
                if (!r || !o && f == W && Pe == W) return dl(e, this.__actions__);
                var Ke = [];
                e: for(; W-- && Ee < Pe;){
                    te += t;
                    for(var et = -1, Ge = e[te]; ++et < ie;){
                        var at = re[et], ot = at.iteratee, yn = at.type, ln = ot(Ge);
                        if (yn == Ne) Ge = ln;
                        else if (!ln) {
                            if (yn == le) continue e;
                            break e;
                        }
                    }
                    Ke[Ee++] = Ge;
                }
                return Ke;
            }
            st.prototype = wi(Na.prototype), st.prototype.constructor = st;
            function jr(e) {
                var t = -1, r = e == null ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var o = e[t];
                    this.set(o[0], o[1]);
                }
            }
            function bd() {
                this.__data__ = Ji ? Ji(null) : {}, this.size = 0;
            }
            function _d(e) {
                var t = this.has(e) && delete this.__data__[e];
                return this.size -= t ? 1 : 0, t;
            }
            function yd(e) {
                var t = this.__data__;
                if (Ji) {
                    var r = t[e];
                    return r === y ? u : r;
                }
                return At.call(t, e) ? t[e] : u;
            }
            function Ad(e) {
                var t = this.__data__;
                return Ji ? t[e] !== u : At.call(t, e);
            }
            function wd(e, t) {
                var r = this.__data__;
                return this.size += this.has(e) ? 0 : 1, r[e] = Ji && t === u ? y : t, this;
            }
            jr.prototype.clear = bd, jr.prototype.delete = _d, jr.prototype.get = yd, jr.prototype.has = Ad, jr.prototype.set = wd;
            function or(e) {
                var t = -1, r = e == null ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var o = e[t];
                    this.set(o[0], o[1]);
                }
            }
            function Sd() {
                this.__data__ = [], this.size = 0;
            }
            function Ed(e) {
                var t = this.__data__, r = Ba(t, e);
                if (r < 0) return !1;
                var o = t.length - 1;
                return r == o ? t.pop() : La.call(t, r, 1), --this.size, !0;
            }
            function xd(e) {
                var t = this.__data__, r = Ba(t, e);
                return r < 0 ? u : t[r][1];
            }
            function Cd(e) {
                return Ba(this.__data__, e) > -1;
            }
            function kd(e, t) {
                var r = this.__data__, o = Ba(r, e);
                return o < 0 ? (++this.size, r.push([
                    e,
                    t
                ])) : r[o][1] = t, this;
            }
            or.prototype.clear = Sd, or.prototype.delete = Ed, or.prototype.get = xd, or.prototype.has = Cd, or.prototype.set = kd;
            function lr(e) {
                var t = -1, r = e == null ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var o = e[t];
                    this.set(o[0], o[1]);
                }
            }
            function Ld() {
                this.size = 0, this.__data__ = {
                    hash: new jr(),
                    map: new (Zi || or)(),
                    string: new jr()
                };
            }
            function Dd(e) {
                var t = Va(this, e).delete(e);
                return this.size -= t ? 1 : 0, t;
            }
            function Td(e) {
                return Va(this, e).get(e);
            }
            function Id(e) {
                return Va(this, e).has(e);
            }
            function Od(e, t) {
                var r = Va(this, e), o = r.size;
                return r.set(e, t), this.size += r.size == o ? 0 : 1, this;
            }
            lr.prototype.clear = Ld, lr.prototype.delete = Dd, lr.prototype.get = Td, lr.prototype.has = Id, lr.prototype.set = Od;
            function $r(e) {
                var t = -1, r = e == null ? 0 : e.length;
                for(this.__data__ = new lr(); ++t < r;)this.add(e[t]);
            }
            function Md(e) {
                return this.__data__.set(e, y), this;
            }
            function Nd(e) {
                return this.__data__.has(e);
            }
            $r.prototype.add = $r.prototype.push = Md, $r.prototype.has = Nd;
            function Un(e) {
                var t = this.__data__ = new or(e);
                this.size = t.size;
            }
            function Bd() {
                this.__data__ = new or(), this.size = 0;
            }
            function Pd(e) {
                var t = this.__data__, r = t.delete(e);
                return this.size = t.size, r;
            }
            function Rd(e) {
                return this.__data__.get(e);
            }
            function Fd(e) {
                return this.__data__.has(e);
            }
            function qd(e, t) {
                var r = this.__data__;
                if (r instanceof or) {
                    var o = r.__data__;
                    if (!Zi || o.length < _ - 1) return o.push([
                        e,
                        t
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new lr(o);
                }
                return r.set(e, t), this.size = r.size, this;
            }
            Un.prototype.clear = Bd, Un.prototype.delete = Pd, Un.prototype.get = Rd, Un.prototype.has = Fd, Un.prototype.set = qd;
            function Ho(e, t) {
                var r = Xe(e), o = !r && zr(e), f = !r && !o && Lr(e), w = !r && !o && !f && Ci(e), O = r || o || f || w, N = O ? vs(e.length, zu) : [], W = N.length;
                for(var te in e)(t || At.call(e, te)) && !(O && // Safari 9 has enumerable `arguments.length` in strict mode.
                (te == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
                f && (te == "offset" || te == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
                w && (te == "buffer" || te == "byteLength" || te == "byteOffset") || // Skip index properties.
                fr(te, W))) && N.push(te);
                return N;
            }
            function jo(e) {
                var t = e.length;
                return t ? e[Ns(0, t - 1)] : u;
            }
            function Wd(e, t) {
                return Ya(dn(e), Kr(t, 0, e.length));
            }
            function Ud(e) {
                return Ya(dn(e));
            }
            function Es(e, t, r) {
                (r !== u && !Hn(e[t], r) || r === u && !(t in e)) && cr(e, t, r);
            }
            function ea(e, t, r) {
                var o = e[t];
                (!(At.call(e, t) && Hn(o, r)) || r === u && !(t in e)) && cr(e, t, r);
            }
            function Ba(e, t) {
                for(var r = e.length; r--;)if (Hn(e[r][0], t)) return r;
                return -1;
            }
            function Hd(e, t, r, o) {
                return Er(e, function(f, w, O) {
                    t(o, f, r(f), O);
                }), o;
            }
            function $o(e, t) {
                return e && zn(t, Zt(t), e);
            }
            function jd(e, t) {
                return e && zn(t, hn(t), e);
            }
            function cr(e, t, r) {
                t == "__proto__" && Da ? Da(e, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: r,
                    writable: !0
                }) : e[t] = r;
            }
            function xs(e, t) {
                for(var r = -1, o = t.length, f = G(o), w = e == null; ++r < o;)f[r] = w ? u : ao(e, t[r]);
                return f;
            }
            function Kr(e, t, r) {
                return e === e && (r !== u && (e = e <= r ? e : r), t !== u && (e = e >= t ? e : t)), e;
            }
            function xn(e, t, r, o, f, w) {
                var O, N = t & m, W = t & i, te = t & a;
                if (r && (O = f ? r(e, o, f, w) : r(e)), O !== u) return O;
                if (!Tt(e)) return e;
                var re = Xe(e);
                if (re) {
                    if (O = Of(e), !N) return dn(e, O);
                } else {
                    var ie = tn(e), Ee = ie == n || ie == ye;
                    if (Lr(e)) return pl(e, N);
                    if (ie == oe || ie == Fe || Ee && !f) {
                        if (O = W || Ee ? {} : Ml(e), !N) return W ? Af(e, jd(O, e)) : yf(e, $o(O, e));
                    } else {
                        if (!mt[ie]) return f ? e : {};
                        O = Mf(e, ie, N);
                    }
                }
                w || (w = new Un());
                var Pe = w.get(e);
                if (Pe) return Pe;
                w.set(e, O), lc(e) ? e.forEach(function(Ge) {
                    O.add(xn(Ge, t, r, Ge, e, w));
                }) : sc(e) && e.forEach(function(Ge, at) {
                    O.set(at, xn(Ge, t, r, at, e, w));
                });
                var Ke = te ? W ? Ks : $s : W ? hn : Zt, et = re ? u : Ke(e);
                return Jt(et || e, function(Ge, at) {
                    et && (at = Ge, Ge = e[at]), ea(O, at, xn(Ge, t, r, at, e, w));
                }), O;
            }
            function $d(e) {
                var t = Zt(e);
                return function(r) {
                    return Ko(r, e, t);
                };
            }
            function Ko(e, t, r) {
                var o = r.length;
                if (e == null) return !o;
                for(e = Ct(e); o--;){
                    var f = r[o], w = t[f], O = e[f];
                    if (O === u && !(f in e) || !w(O)) return !1;
                }
                return !0;
            }
            function Go(e, t, r) {
                if (typeof e != "function") throw new Sn(E);
                return oa(function() {
                    e.apply(u, r);
                }, t);
            }
            function ta(e, t, r, o) {
                var f = -1, w = Ur, O = !0, N = e.length, W = [], te = t.length;
                if (!N) return W;
                r && (t = xt(t, vn(r))), o ? (w = pi, O = !1) : t.length >= _ && (w = Yi, O = !1, t = new $r(t));
                e: for(; ++f < N;){
                    var re = e[f], ie = r == null ? re : r(re);
                    if (re = o || re !== 0 ? re : 0, O && ie === ie) {
                        for(var Ee = te; Ee--;)if (t[Ee] === ie) continue e;
                        W.push(re);
                    } else w(t, ie, o) || W.push(re);
                }
                return W;
            }
            var Er = _l(Yn), Vo = _l(ks, !0);
            function Kd(e, t) {
                var r = !0;
                return Er(e, function(o, f, w) {
                    return r = !!t(o, f, w), r;
                }), r;
            }
            function Pa(e, t, r) {
                for(var o = -1, f = e.length; ++o < f;){
                    var w = e[o], O = t(w);
                    if (O != null && (N === u ? O === O && !_n(O) : r(O, N))) var N = O, W = w;
                }
                return W;
            }
            function Gd(e, t, r, o) {
                var f = e.length;
                for(r = Qe(r), r < 0 && (r = -r > f ? 0 : f + r), o = o === u || o > f ? f : Qe(o), o < 0 && (o += f), o = r > o ? 0 : uc(o); r < o;)e[r++] = t;
                return e;
            }
            function Yo(e, t) {
                var r = [];
                return Er(e, function(o, f, w) {
                    t(o, f, w) && r.push(o);
                }), r;
            }
            function Qt(e, t, r, o, f) {
                var w = -1, O = e.length;
                for(r || (r = Bf), f || (f = []); ++w < O;){
                    var N = e[w];
                    t > 0 && r(N) ? t > 1 ? Qt(N, t - 1, r, o, f) : qn(f, N) : o || (f[f.length] = N);
                }
                return f;
            }
            var Cs = yl(), zo = yl(!0);
            function Yn(e, t) {
                return e && Cs(e, t, Zt);
            }
            function ks(e, t) {
                return e && zo(e, t, Zt);
            }
            function Ra(e, t) {
                return wn(t, function(r) {
                    return hr(e[r]);
                });
            }
            function Gr(e, t) {
                t = Cr(t, e);
                for(var r = 0, o = t.length; e != null && r < o;)e = e[Zn(t[r++])];
                return r && r == o ? e : u;
            }
            function Zo(e, t, r) {
                var o = t(e);
                return Xe(e) ? o : qn(o, r(e));
            }
            function sn(e) {
                return e == null ? e === u ? It : ht : Hr && Hr in Ct(e) ? Df(e) : Hf(e);
            }
            function Ls(e, t) {
                return e > t;
            }
            function Vd(e, t) {
                return e != null && At.call(e, t);
            }
            function Yd(e, t) {
                return e != null && t in Ct(e);
            }
            function zd(e, t, r) {
                return e >= en(t, r) && e < Vt(t, r);
            }
            function Ds(e, t, r) {
                for(var o = r ? pi : Ur, f = e[0].length, w = e.length, O = w, N = G(w), W = 1 / 0, te = []; O--;){
                    var re = e[O];
                    O && t && (re = xt(re, vn(t))), W = en(re.length, W), N[O] = !r && (t || f >= 120 && re.length >= 120) ? new $r(O && re) : u;
                }
                re = e[0];
                var ie = -1, Ee = N[0];
                e: for(; ++ie < f && te.length < W;){
                    var Pe = re[ie], Ke = t ? t(Pe) : Pe;
                    if (Pe = r || Pe !== 0 ? Pe : 0, !(Ee ? Yi(Ee, Ke) : o(te, Ke, r))) {
                        for(O = w; --O;){
                            var et = N[O];
                            if (!(et ? Yi(et, Ke) : o(e[O], Ke, r))) continue e;
                        }
                        Ee && Ee.push(Ke), te.push(Pe);
                    }
                }
                return te;
            }
            function Zd(e, t, r, o) {
                return Yn(e, function(f, w, O) {
                    t(o, r(f), w, O);
                }), o;
            }
            function na(e, t, r) {
                t = Cr(t, e), e = Rl(e, t);
                var o = e == null ? e : e[Zn(kn(t))];
                return o == null ? u : an(o, e, r);
            }
            function Xo(e) {
                return Rt(e) && sn(e) == Fe;
            }
            function Xd(e) {
                return Rt(e) && sn(e) == Kt;
            }
            function Jd(e) {
                return Rt(e) && sn(e) == ut;
            }
            function ra(e, t, r, o, f) {
                return e === t ? !0 : e == null || t == null || !Rt(e) && !Rt(t) ? e !== e && t !== t : Qd(e, t, r, o, ra, f);
            }
            function Qd(e, t, r, o, f, w) {
                var O = Xe(e), N = Xe(t), W = O ? Re : tn(e), te = N ? Re : tn(t);
                W = W == Fe ? oe : W, te = te == Fe ? oe : te;
                var re = W == oe, ie = te == oe, Ee = W == te;
                if (Ee && Lr(e)) {
                    if (!Lr(t)) return !1;
                    O = !0, re = !1;
                }
                if (Ee && !re) return w || (w = new Un()), O || Ci(e) ? Tl(e, t, r, o, f, w) : kf(e, t, W, r, o, f, w);
                if (!(r & s)) {
                    var Pe = re && At.call(e, "__wrapped__"), Ke = ie && At.call(t, "__wrapped__");
                    if (Pe || Ke) {
                        var et = Pe ? e.value() : e, Ge = Ke ? t.value() : t;
                        return w || (w = new Un()), f(et, Ge, r, o, w);
                    }
                }
                return Ee ? (w || (w = new Un()), Lf(e, t, r, o, f, w)) : !1;
            }
            function ef(e) {
                return Rt(e) && tn(e) == ke;
            }
            function Ts(e, t, r, o) {
                var f = r.length, w = f, O = !o;
                if (e == null) return !w;
                for(e = Ct(e); f--;){
                    var N = r[f];
                    if (O && N[2] ? N[1] !== e[N[0]] : !(N[0] in e)) return !1;
                }
                for(; ++f < w;){
                    N = r[f];
                    var W = N[0], te = e[W], re = N[1];
                    if (O && N[2]) {
                        if (te === u && !(W in e)) return !1;
                    } else {
                        var ie = new Un();
                        if (o) var Ee = o(te, re, W, e, t, ie);
                        if (!(Ee === u ? ra(re, te, s | c, o, ie) : Ee)) return !1;
                    }
                }
                return !0;
            }
            function Jo(e) {
                if (!Tt(e) || Rf(e)) return !1;
                var t = hr(e) ? ed : er;
                return t.test(Yr(e));
            }
            function tf(e) {
                return Rt(e) && sn(e) == Ie;
            }
            function nf(e) {
                return Rt(e) && tn(e) == pe;
            }
            function rf(e) {
                return Rt(e) && es(e.length) && !!it[sn(e)];
            }
            function Qo(e) {
                return typeof e == "function" ? e : e == null ? pn : typeof e == "object" ? Xe(e) ? nl(e[0], e[1]) : tl(e) : Ac(e);
            }
            function Is(e) {
                if (!sa(e)) return sd(e);
                var t = [];
                for(var r in Ct(e))At.call(e, r) && r != "constructor" && t.push(r);
                return t;
            }
            function af(e) {
                if (!Tt(e)) return Uf(e);
                var t = sa(e), r = [];
                for(var o in e)o == "constructor" && (t || !At.call(e, o)) || r.push(o);
                return r;
            }
            function Os(e, t) {
                return e < t;
            }
            function el(e, t) {
                var r = -1, o = fn(e) ? G(e.length) : [];
                return Er(e, function(f, w, O) {
                    o[++r] = t(f, w, O);
                }), o;
            }
            function tl(e) {
                var t = Vs(e);
                return t.length == 1 && t[0][2] ? Bl(t[0][0], t[0][1]) : function(r) {
                    return r === e || Ts(r, e, t);
                };
            }
            function nl(e, t) {
                return zs(e) && Nl(t) ? Bl(Zn(e), t) : function(r) {
                    var o = ao(r, e);
                    return o === u && o === t ? so(r, e) : ra(t, o, s | c);
                };
            }
            function Fa(e, t, r, o, f) {
                e !== t && Cs(t, function(w, O) {
                    if (f || (f = new Un()), Tt(w)) sf(e, t, O, r, Fa, o, f);
                    else {
                        var N = o ? o(Xs(e, O), w, O + "", e, t, f) : u;
                        N === u && (N = w), Es(e, O, N);
                    }
                }, hn);
            }
            function sf(e, t, r, o, f, w, O) {
                var N = Xs(e, r), W = Xs(t, r), te = O.get(W);
                if (te) {
                    Es(e, r, te);
                    return;
                }
                var re = w ? w(N, W, r + "", e, t, O) : u, ie = re === u;
                if (ie) {
                    var Ee = Xe(W), Pe = !Ee && Lr(W), Ke = !Ee && !Pe && Ci(W);
                    re = W, Ee || Pe || Ke ? Xe(N) ? re = N : Ut(N) ? re = dn(N) : Pe ? (ie = !1, re = pl(W, !0)) : Ke ? (ie = !1, re = ml(W, !0)) : re = [] : la(W) || zr(W) ? (re = N, zr(N) ? re = dc(N) : (!Tt(N) || hr(N)) && (re = Ml(W))) : ie = !1;
                }
                ie && (O.set(W, re), f(re, W, o, w, O), O.delete(W)), Es(e, r, re);
            }
            function rl(e, t) {
                var r = e.length;
                if (r) return t += t < 0 ? r : 0, fr(t, r) ? e[t] : u;
            }
            function il(e, t, r) {
                t.length ? t = xt(t, function(w) {
                    return Xe(w) ? function(O) {
                        return Gr(O, w.length === 1 ? w[0] : w);
                    } : w;
                }) : t = [
                    pn
                ];
                var o = -1;
                t = xt(t, vn($e()));
                var f = el(e, function(w, O, N) {
                    var W = xt(t, function(te) {
                        return te(w);
                    });
                    return {
                        criteria: W,
                        index: ++o,
                        value: w
                    };
                });
                return Ou(f, function(w, O) {
                    return _f(w, O, r);
                });
            }
            function of(e, t) {
                return al(e, t, function(r, o) {
                    return so(e, o);
                });
            }
            function al(e, t, r) {
                for(var o = -1, f = t.length, w = {}; ++o < f;){
                    var O = t[o], N = Gr(e, O);
                    r(N, O) && ia(w, Cr(O, e), N);
                }
                return w;
            }
            function lf(e) {
                return function(t) {
                    return Gr(t, e);
                };
            }
            function Ms(e, t, r, o) {
                var f = o ? Iu : mi, w = -1, O = t.length, N = e;
                for(e === t && (t = dn(t)), r && (N = xt(e, vn(r))); ++w < O;)for(var W = 0, te = t[w], re = r ? r(te) : te; (W = f(N, re, W, o)) > -1;)N !== e && La.call(N, W, 1), La.call(e, W, 1);
                return e;
            }
            function sl(e, t) {
                for(var r = e ? t.length : 0, o = r - 1; r--;){
                    var f = t[r];
                    if (r == o || f !== w) {
                        var w = f;
                        fr(f) ? La.call(e, f, 1) : Rs(e, f);
                    }
                }
                return e;
            }
            function Ns(e, t) {
                return e + Ia(Wo() * (t - e + 1));
            }
            function cf(e, t, r, o) {
                for(var f = -1, w = Vt(Ta((t - e) / (r || 1)), 0), O = G(w); w--;)O[o ? w : ++f] = e, e += r;
                return O;
            }
            function Bs(e, t) {
                var r = "";
                if (!e || t < 1 || t > Ae) return r;
                do t % 2 && (r += e), t = Ia(t / 2), t && (e += e);
                while (t);
                return r;
            }
            function tt(e, t) {
                return Js(Pl(e, t, pn), e + "");
            }
            function uf(e) {
                return jo(ki(e));
            }
            function df(e, t) {
                var r = ki(e);
                return Ya(r, Kr(t, 0, r.length));
            }
            function ia(e, t, r, o) {
                if (!Tt(e)) return e;
                t = Cr(t, e);
                for(var f = -1, w = t.length, O = w - 1, N = e; N != null && ++f < w;){
                    var W = Zn(t[f]), te = r;
                    if (W === "__proto__" || W === "constructor" || W === "prototype") return e;
                    if (f != O) {
                        var re = N[W];
                        te = o ? o(re, W, N) : u, te === u && (te = Tt(re) ? re : fr(t[f + 1]) ? [] : {});
                    }
                    ea(N, W, te), N = N[W];
                }
                return e;
            }
            var ol = Oa ? function(e, t) {
                return Oa.set(e, t), e;
            } : pn, ff = Da ? function(e, t) {
                return Da(e, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: lo(t),
                    writable: !0
                });
            } : pn;
            function hf(e) {
                return Ya(ki(e));
            }
            function Cn(e, t, r) {
                var o = -1, f = e.length;
                t < 0 && (t = -t > f ? 0 : f + t), r = r > f ? f : r, r < 0 && (r += f), f = t > r ? 0 : r - t >>> 0, t >>>= 0;
                for(var w = G(f); ++o < f;)w[o] = e[o + t];
                return w;
            }
            function pf(e, t) {
                var r;
                return Er(e, function(o, f, w) {
                    return r = t(o, f, w), !r;
                }), !!r;
            }
            function qa(e, t, r) {
                var o = 0, f = e == null ? o : e.length;
                if (typeof t == "number" && t === t && f <= qe) {
                    for(; o < f;){
                        var w = o + f >>> 1, O = e[w];
                        O !== null && !_n(O) && (r ? O <= t : O < t) ? o = w + 1 : f = w;
                    }
                    return f;
                }
                return Ps(e, t, pn, r);
            }
            function Ps(e, t, r, o) {
                var f = 0, w = e == null ? 0 : e.length;
                if (w === 0) return 0;
                t = r(t);
                for(var O = t !== t, N = t === null, W = _n(t), te = t === u; f < w;){
                    var re = Ia((f + w) / 2), ie = r(e[re]), Ee = ie !== u, Pe = ie === null, Ke = ie === ie, et = _n(ie);
                    if (O) var Ge = o || Ke;
                    else te ? Ge = Ke && (o || Ee) : N ? Ge = Ke && Ee && (o || !Pe) : W ? Ge = Ke && Ee && !Pe && (o || !et) : Pe || et ? Ge = !1 : Ge = o ? ie <= t : ie < t;
                    Ge ? f = re + 1 : w = re;
                }
                return en(w, Ce);
            }
            function ll(e, t) {
                for(var r = -1, o = e.length, f = 0, w = []; ++r < o;){
                    var O = e[r], N = t ? t(O) : O;
                    if (!r || !Hn(N, W)) {
                        var W = N;
                        w[f++] = O === 0 ? 0 : O;
                    }
                }
                return w;
            }
            function cl(e) {
                return typeof e == "number" ? e : _n(e) ? me : +e;
            }
            function bn(e) {
                if (typeof e == "string") return e;
                if (Xe(e)) return xt(e, bn) + "";
                if (_n(e)) return Uo ? Uo.call(e) : "";
                var t = e + "";
                return t == "0" && 1 / e == -K ? "-0" : t;
            }
            function xr(e, t, r) {
                var o = -1, f = Ur, w = e.length, O = !0, N = [], W = N;
                if (r) O = !1, f = pi;
                else if (w >= _) {
                    var te = t ? null : xf(e);
                    if (te) return ya(te);
                    O = !1, f = Yi, W = new $r();
                } else W = t ? [] : N;
                e: for(; ++o < w;){
                    var re = e[o], ie = t ? t(re) : re;
                    if (re = r || re !== 0 ? re : 0, O && ie === ie) {
                        for(var Ee = W.length; Ee--;)if (W[Ee] === ie) continue e;
                        t && W.push(ie), N.push(re);
                    } else f(W, ie, r) || (W !== N && W.push(ie), N.push(re));
                }
                return N;
            }
            function Rs(e, t) {
                return t = Cr(t, e), e = Rl(e, t), e == null || delete e[Zn(kn(t))];
            }
            function ul(e, t, r, o) {
                return ia(e, t, r(Gr(e, t)), o);
            }
            function Wa(e, t, r, o) {
                for(var f = e.length, w = o ? f : -1; (o ? w-- : ++w < f) && t(e[w], w, e););
                return r ? Cn(e, o ? 0 : w, o ? w + 1 : f) : Cn(e, o ? w + 1 : 0, o ? f : w);
            }
            function dl(e, t) {
                var r = e;
                return r instanceof st && (r = r.value()), fs(t, function(o, f) {
                    return f.func.apply(f.thisArg, qn([
                        o
                    ], f.args));
                }, r);
            }
            function Fs(e, t, r) {
                var o = e.length;
                if (o < 2) return o ? xr(e[0]) : [];
                for(var f = -1, w = G(o); ++f < o;)for(var O = e[f], N = -1; ++N < o;)N != f && (w[f] = ta(w[f] || O, e[N], t, r));
                return xr(Qt(w, 1), t, r);
            }
            function fl(e, t, r) {
                for(var o = -1, f = e.length, w = t.length, O = {}; ++o < f;){
                    var N = o < w ? t[o] : u;
                    r(O, e[o], N);
                }
                return O;
            }
            function qs(e) {
                return Ut(e) ? e : [];
            }
            function Ws(e) {
                return typeof e == "function" ? e : pn;
            }
            function Cr(e, t) {
                return Xe(e) ? e : zs(e, t) ? [
                    e
                ] : Ul(vt(e));
            }
            var mf = tt;
            function kr(e, t, r) {
                var o = e.length;
                return r = r === u ? o : r, !t && r >= o ? e : Cn(e, t, r);
            }
            var hl = td || function(e) {
                return Pt.clearTimeout(e);
            };
            function pl(e, t) {
                if (t) return e.slice();
                var r = e.length, o = Bo ? Bo(r) : new e.constructor(r);
                return e.copy(o), o;
            }
            function Us(e) {
                var t = new e.constructor(e.byteLength);
                return new Ca(t).set(new Ca(e)), t;
            }
            function gf(e, t) {
                var r = t ? Us(e.buffer) : e.buffer;
                return new e.constructor(r, e.byteOffset, e.byteLength);
            }
            function vf(e) {
                var t = new e.constructor(e.source, ii.exec(e));
                return t.lastIndex = e.lastIndex, t;
            }
            function bf(e) {
                return Qi ? Ct(Qi.call(e)) : {};
            }
            function ml(e, t) {
                var r = t ? Us(e.buffer) : e.buffer;
                return new e.constructor(r, e.byteOffset, e.length);
            }
            function gl(e, t) {
                if (e !== t) {
                    var r = e !== u, o = e === null, f = e === e, w = _n(e), O = t !== u, N = t === null, W = t === t, te = _n(t);
                    if (!N && !te && !w && e > t || w && O && W && !N && !te || o && O && W || !r && W || !f) return 1;
                    if (!o && !w && !te && e < t || te && r && f && !o && !w || N && r && f || !O && f || !W) return -1;
                }
                return 0;
            }
            function _f(e, t, r) {
                for(var o = -1, f = e.criteria, w = t.criteria, O = f.length, N = r.length; ++o < O;){
                    var W = gl(f[o], w[o]);
                    if (W) {
                        if (o >= N) return W;
                        var te = r[o];
                        return W * (te == "desc" ? -1 : 1);
                    }
                }
                return e.index - t.index;
            }
            function vl(e, t, r, o) {
                for(var f = -1, w = e.length, O = r.length, N = -1, W = t.length, te = Vt(w - O, 0), re = G(W + te), ie = !o; ++N < W;)re[N] = t[N];
                for(; ++f < O;)(ie || f < w) && (re[r[f]] = e[f]);
                for(; te--;)re[N++] = e[f++];
                return re;
            }
            function bl(e, t, r, o) {
                for(var f = -1, w = e.length, O = -1, N = r.length, W = -1, te = t.length, re = Vt(w - N, 0), ie = G(re + te), Ee = !o; ++f < re;)ie[f] = e[f];
                for(var Pe = f; ++W < te;)ie[Pe + W] = t[W];
                for(; ++O < N;)(Ee || f < w) && (ie[Pe + r[O]] = e[f++]);
                return ie;
            }
            function dn(e, t) {
                var r = -1, o = e.length;
                for(t || (t = G(o)); ++r < o;)t[r] = e[r];
                return t;
            }
            function zn(e, t, r, o) {
                var f = !r;
                r || (r = {});
                for(var w = -1, O = t.length; ++w < O;){
                    var N = t[w], W = o ? o(r[N], e[N], N, r, e) : u;
                    W === u && (W = e[N]), f ? cr(r, N, W) : ea(r, N, W);
                }
                return r;
            }
            function yf(e, t) {
                return zn(e, Ys(e), t);
            }
            function Af(e, t) {
                return zn(e, Il(e), t);
            }
            function Ua(e, t) {
                return function(r, o) {
                    var f = Xe(r) ? sr : Hd, w = t ? t() : {};
                    return f(r, e, $e(o, 2), w);
                };
            }
            function Si(e) {
                return tt(function(t, r) {
                    var o = -1, f = r.length, w = f > 1 ? r[f - 1] : u, O = f > 2 ? r[2] : u;
                    for(w = e.length > 3 && typeof w == "function" ? (f--, w) : u, O && on(r[0], r[1], O) && (w = f < 3 ? u : w, f = 1), t = Ct(t); ++o < f;){
                        var N = r[o];
                        N && e(t, N, o, w);
                    }
                    return t;
                });
            }
            function _l(e, t) {
                return function(r, o) {
                    if (r == null) return r;
                    if (!fn(r)) return e(r, o);
                    for(var f = r.length, w = t ? f : -1, O = Ct(r); (t ? w-- : ++w < f) && o(O[w], w, O) !== !1;);
                    return r;
                };
            }
            function yl(e) {
                return function(t, r, o) {
                    for(var f = -1, w = Ct(t), O = o(t), N = O.length; N--;){
                        var W = O[e ? N : ++f];
                        if (r(w[W], W, w) === !1) break;
                    }
                    return t;
                };
            }
            function wf(e, t, r) {
                var o = t & g, f = aa(e);
                function w() {
                    var O = this && this !== Pt && this instanceof w ? f : e;
                    return O.apply(o ? r : this, arguments);
                }
                return w;
            }
            function Al(e) {
                return function(t) {
                    t = vt(t);
                    var r = gi(t) ? Wn(t) : u, o = r ? r[0] : t.charAt(0), f = r ? kr(r, 1).join("") : t.slice(1);
                    return o[e]() + f;
                };
            }
            function Ei(e) {
                return function(t) {
                    return fs(_c(bc(t).replace(Nt, "")), e, "");
                };
            }
            function aa(e) {
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return new e();
                        case 1:
                            return new e(t[0]);
                        case 2:
                            return new e(t[0], t[1]);
                        case 3:
                            return new e(t[0], t[1], t[2]);
                        case 4:
                            return new e(t[0], t[1], t[2], t[3]);
                        case 5:
                            return new e(t[0], t[1], t[2], t[3], t[4]);
                        case 6:
                            return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                        case 7:
                            return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var r = wi(e.prototype), o = e.apply(r, t);
                    return Tt(o) ? o : r;
                };
            }
            function Sf(e, t, r) {
                var o = aa(e);
                function f() {
                    for(var w = arguments.length, O = G(w), N = w, W = xi(f); N--;)O[N] = arguments[N];
                    var te = w < 3 && O[0] !== W && O[w - 1] !== W ? [] : wr(O, W);
                    if (w -= te.length, w < r) return Cl(e, t, Ha, f.placeholder, u, O, te, u, u, r - w);
                    var re = this && this !== Pt && this instanceof f ? o : e;
                    return an(re, this, O);
                }
                return f;
            }
            function wl(e) {
                return function(t, r, o) {
                    var f = Ct(t);
                    if (!fn(t)) {
                        var w = $e(r, 3);
                        t = Zt(t), r = function(N) {
                            return w(f[N], N, f);
                        };
                    }
                    var O = e(t, r, o);
                    return O > -1 ? f[w ? t[O] : O] : u;
                };
            }
            function Sl(e) {
                return dr(function(t) {
                    var r = t.length, o = r, f = En.prototype.thru;
                    for(e && t.reverse(); o--;){
                        var w = t[o];
                        if (typeof w != "function") throw new Sn(E);
                        if (f && !O && Ga(w) == "wrapper") var O = new En([], !0);
                    }
                    for(o = O ? o : r; ++o < r;){
                        w = t[o];
                        var N = Ga(w), W = N == "wrapper" ? Gs(w) : u;
                        W && Zs(W[0]) && W[1] == (_e | $ | se | H) && !W[4].length && W[9] == 1 ? O = O[Ga(W[0])].apply(O, W[3]) : O = w.length == 1 && Zs(w) ? O[N]() : O.thru(w);
                    }
                    return function() {
                        var te = arguments, re = te[0];
                        if (O && te.length == 1 && Xe(re)) return O.plant(re).value();
                        for(var ie = 0, Ee = r ? t[ie].apply(this, te) : re; ++ie < r;)Ee = t[ie].call(this, Ee);
                        return Ee;
                    };
                });
            }
            function Ha(e, t, r, o, f, w, O, N, W, te) {
                var re = t & _e, ie = t & g, Ee = t & A, Pe = t & ($ | J), Ke = t & Y, et = Ee ? u : aa(e);
                function Ge() {
                    for(var at = arguments.length, ot = G(at), yn = at; yn--;)ot[yn] = arguments[yn];
                    if (Pe) var ln = xi(Ge), An = Nu(ot, ln);
                    if (o && (ot = vl(ot, o, f, Pe)), w && (ot = bl(ot, w, O, Pe)), at -= An, Pe && at < te) {
                        var Ht = wr(ot, ln);
                        return Cl(e, t, Ha, Ge.placeholder, r, ot, Ht, N, W, te - at);
                    }
                    var jn = ie ? r : this, mr = Ee ? jn[e] : e;
                    return at = ot.length, N ? ot = jf(ot, N) : Ke && at > 1 && ot.reverse(), re && W < at && (ot.length = W), this && this !== Pt && this instanceof Ge && (mr = et || aa(mr)), mr.apply(jn, ot);
                }
                return Ge;
            }
            function El(e, t) {
                return function(r, o) {
                    return Zd(r, e, t(o), {});
                };
            }
            function ja(e, t) {
                return function(r, o) {
                    var f;
                    if (r === u && o === u) return t;
                    if (r !== u && (f = r), o !== u) {
                        if (f === u) return o;
                        typeof r == "string" || typeof o == "string" ? (r = bn(r), o = bn(o)) : (r = cl(r), o = cl(o)), f = e(r, o);
                    }
                    return f;
                };
            }
            function Hs(e) {
                return dr(function(t) {
                    return t = xt(t, vn($e())), tt(function(r) {
                        var o = this;
                        return e(t, function(f) {
                            return an(f, o, r);
                        });
                    });
                });
            }
            function $a(e, t) {
                t = t === u ? " " : bn(t);
                var r = t.length;
                if (r < 2) return r ? Bs(t, e) : t;
                var o = Bs(t, Ta(e / vi(t)));
                return gi(t) ? kr(Wn(o), 0, e).join("") : o.slice(0, e);
            }
            function Ef(e, t, r, o) {
                var f = t & g, w = aa(e);
                function O() {
                    for(var N = -1, W = arguments.length, te = -1, re = o.length, ie = G(re + W), Ee = this && this !== Pt && this instanceof O ? w : e; ++te < re;)ie[te] = o[te];
                    for(; W--;)ie[te++] = arguments[++N];
                    return an(Ee, f ? r : this, ie);
                }
                return O;
            }
            function xl(e) {
                return function(t, r, o) {
                    return o && typeof o != "number" && on(t, r, o) && (r = o = u), t = pr(t), r === u ? (r = t, t = 0) : r = pr(r), o = o === u ? t < r ? 1 : -1 : pr(o), cf(t, r, o, e);
                };
            }
            function Ka(e) {
                return function(t, r) {
                    return typeof t == "string" && typeof r == "string" || (t = Ln(t), r = Ln(r)), e(t, r);
                };
            }
            function Cl(e, t, r, o, f, w, O, N, W, te) {
                var re = t & $, ie = re ? O : u, Ee = re ? u : O, Pe = re ? w : u, Ke = re ? u : w;
                t |= re ? se : Q, t &= ~(re ? Q : se), t & F || (t &= ~(g | A));
                var et = [
                    e,
                    t,
                    f,
                    Pe,
                    ie,
                    Ke,
                    Ee,
                    N,
                    W,
                    te
                ], Ge = r.apply(u, et);
                return Zs(e) && Fl(Ge, et), Ge.placeholder = o, ql(Ge, e, t);
            }
            function js(e) {
                var t = Gt[e];
                return function(r, o) {
                    if (r = Ln(r), o = o == null ? 0 : en(Qe(o), 292), o && qo(r)) {
                        var f = (vt(r) + "e").split("e"), w = t(f[0] + "e" + (+f[1] + o));
                        return f = (vt(w) + "e").split("e"), +(f[0] + "e" + (+f[1] - o));
                    }
                    return t(r);
                };
            }
            var xf = yi && 1 / ya(new yi([
                ,
                -0
            ]))[1] == K ? function(e) {
                return new yi(e);
            } : fo;
            function kl(e) {
                return function(t) {
                    var r = tn(t);
                    return r == ke ? _s(t) : r == pe ? Uu(t) : Mu(t, e(t));
                };
            }
            function ur(e, t, r, o, f, w, O, N) {
                var W = t & A;
                if (!W && typeof e != "function") throw new Sn(E);
                var te = o ? o.length : 0;
                if (te || (t &= ~(se | Q), o = f = u), O = O === u ? O : Vt(Qe(O), 0), N = N === u ? N : Qe(N), te -= f ? f.length : 0, t & Q) {
                    var re = o, ie = f;
                    o = f = u;
                }
                var Ee = W ? u : Gs(e), Pe = [
                    e,
                    t,
                    r,
                    o,
                    f,
                    re,
                    ie,
                    w,
                    O,
                    N
                ];
                if (Ee && Wf(Pe, Ee), e = Pe[0], t = Pe[1], r = Pe[2], o = Pe[3], f = Pe[4], N = Pe[9] = Pe[9] === u ? W ? 0 : e.length : Vt(Pe[9] - te, 0), !N && t & ($ | J) && (t &= ~($ | J)), !t || t == g) var Ke = wf(e, t, r);
                else t == $ || t == J ? Ke = Sf(e, t, N) : (t == se || t == (g | se)) && !f.length ? Ke = Ef(e, t, r, o) : Ke = Ha.apply(u, Pe);
                var et = Ee ? ol : Fl;
                return ql(et(Ke, Pe), e, t);
            }
            function Ll(e, t, r, o) {
                return e === u || Hn(e, _i[r]) && !At.call(o, r) ? t : e;
            }
            function Dl(e, t, r, o, f, w) {
                return Tt(e) && Tt(t) && (w.set(t, e), Fa(e, t, u, Dl, w), w.delete(t)), e;
            }
            function Cf(e) {
                return la(e) ? u : e;
            }
            function Tl(e, t, r, o, f, w) {
                var O = r & s, N = e.length, W = t.length;
                if (N != W && !(O && W > N)) return !1;
                var te = w.get(e), re = w.get(t);
                if (te && re) return te == t && re == e;
                var ie = -1, Ee = !0, Pe = r & c ? new $r() : u;
                for(w.set(e, t), w.set(t, e); ++ie < N;){
                    var Ke = e[ie], et = t[ie];
                    if (o) var Ge = O ? o(et, Ke, ie, t, e, w) : o(Ke, et, ie, e, t, w);
                    if (Ge !== u) {
                        if (Ge) continue;
                        Ee = !1;
                        break;
                    }
                    if (Pe) {
                        if (!hs(t, function(at, ot) {
                            if (!Yi(Pe, ot) && (Ke === at || f(Ke, at, r, o, w))) return Pe.push(ot);
                        })) {
                            Ee = !1;
                            break;
                        }
                    } else if (!(Ke === et || f(Ke, et, r, o, w))) {
                        Ee = !1;
                        break;
                    }
                }
                return w.delete(e), w.delete(t), Ee;
            }
            function kf(e, t, r, o, f, w, O) {
                switch(r){
                    case yt:
                        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                        e = e.buffer, t = t.buffer;
                    case Kt:
                        return !(e.byteLength != t.byteLength || !w(new Ca(e), new Ca(t)));
                    case ne:
                    case ut:
                    case Me:
                        return Hn(+e, +t);
                    case P:
                        return e.name == t.name && e.message == t.message;
                    case Ie:
                    case Le:
                        return e == t + "";
                    case ke:
                        var N = _s;
                    case pe:
                        var W = o & s;
                        if (N || (N = ya), e.size != t.size && !W) return !1;
                        var te = O.get(e);
                        if (te) return te == t;
                        o |= c, O.set(e, t);
                        var re = Tl(N(e), N(t), o, f, w, O);
                        return O.delete(e), re;
                    case Te:
                        if (Qi) return Qi.call(e) == Qi.call(t);
                }
                return !1;
            }
            function Lf(e, t, r, o, f, w) {
                var O = r & s, N = $s(e), W = N.length, te = $s(t), re = te.length;
                if (W != re && !O) return !1;
                for(var ie = W; ie--;){
                    var Ee = N[ie];
                    if (!(O ? Ee in t : At.call(t, Ee))) return !1;
                }
                var Pe = w.get(e), Ke = w.get(t);
                if (Pe && Ke) return Pe == t && Ke == e;
                var et = !0;
                w.set(e, t), w.set(t, e);
                for(var Ge = O; ++ie < W;){
                    Ee = N[ie];
                    var at = e[Ee], ot = t[Ee];
                    if (o) var yn = O ? o(ot, at, Ee, t, e, w) : o(at, ot, Ee, e, t, w);
                    if (!(yn === u ? at === ot || f(at, ot, r, o, w) : yn)) {
                        et = !1;
                        break;
                    }
                    Ge || (Ge = Ee == "constructor");
                }
                if (et && !Ge) {
                    var ln = e.constructor, An = t.constructor;
                    ln != An && "constructor" in e && "constructor" in t && !(typeof ln == "function" && ln instanceof ln && typeof An == "function" && An instanceof An) && (et = !1);
                }
                return w.delete(e), w.delete(t), et;
            }
            function dr(e) {
                return Js(Pl(e, u, Kl), e + "");
            }
            function $s(e) {
                return Zo(e, Zt, Ys);
            }
            function Ks(e) {
                return Zo(e, hn, Il);
            }
            var Gs = Oa ? function(e) {
                return Oa.get(e);
            } : fo;
            function Ga(e) {
                for(var t = e.name + "", r = Ai[t], o = At.call(Ai, t) ? r.length : 0; o--;){
                    var f = r[o], w = f.func;
                    if (w == null || w == e) return f.name;
                }
                return t;
            }
            function xi(e) {
                var t = At.call(v, "placeholder") ? v : e;
                return t.placeholder;
            }
            function $e() {
                var e = v.iteratee || co;
                return e = e === co ? Qo : e, arguments.length ? e(arguments[0], arguments[1]) : e;
            }
            function Va(e, t) {
                var r = e.__data__;
                return Pf(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
            }
            function Vs(e) {
                for(var t = Zt(e), r = t.length; r--;){
                    var o = t[r], f = e[o];
                    t[r] = [
                        o,
                        f,
                        Nl(f)
                    ];
                }
                return t;
            }
            function Vr(e, t) {
                var r = Fu(e, t);
                return Jo(r) ? r : u;
            }
            function Df(e) {
                var t = At.call(e, Hr), r = e[Hr];
                try {
                    e[Hr] = u;
                    var o = !0;
                } catch  {}
                var f = Ea.call(e);
                return o && (t ? e[Hr] = r : delete e[Hr]), f;
            }
            var Ys = As ? function(e) {
                return e == null ? [] : (e = Ct(e), wn(As(e), function(t) {
                    return Ro.call(e, t);
                }));
            } : ho, Il = As ? function(e) {
                for(var t = []; e;)qn(t, Ys(e)), e = ka(e);
                return t;
            } : ho, tn = sn;
            (ws && tn(new ws(new ArrayBuffer(1))) != yt || Zi && tn(new Zi()) != ke || Ss && tn(Ss.resolve()) != be || yi && tn(new yi()) != pe || Xi && tn(new Xi()) != je) && (tn = function(e) {
                var t = sn(e), r = t == oe ? e.constructor : u, o = r ? Yr(r) : "";
                if (o) switch(o){
                    case ud:
                        return yt;
                    case dd:
                        return ke;
                    case fd:
                        return be;
                    case hd:
                        return pe;
                    case pd:
                        return je;
                }
                return t;
            });
            function Tf(e, t, r) {
                for(var o = -1, f = r.length; ++o < f;){
                    var w = r[o], O = w.size;
                    switch(w.type){
                        case "drop":
                            e += O;
                            break;
                        case "dropRight":
                            t -= O;
                            break;
                        case "take":
                            t = en(t, e + O);
                            break;
                        case "takeRight":
                            e = Vt(e, t - O);
                            break;
                    }
                }
                return {
                    start: e,
                    end: t
                };
            }
            function If(e) {
                var t = e.match(Pi);
                return t ? t[1].split(ri) : [];
            }
            function Ol(e, t, r) {
                t = Cr(t, e);
                for(var o = -1, f = t.length, w = !1; ++o < f;){
                    var O = Zn(t[o]);
                    if (!(w = e != null && r(e, O))) break;
                    e = e[O];
                }
                return w || ++o != f ? w : (f = e == null ? 0 : e.length, !!f && es(f) && fr(O, f) && (Xe(e) || zr(e)));
            }
            function Of(e) {
                var t = e.length, r = new e.constructor(t);
                return t && typeof e[0] == "string" && At.call(e, "index") && (r.index = e.index, r.input = e.input), r;
            }
            function Ml(e) {
                return typeof e.constructor == "function" && !sa(e) ? wi(ka(e)) : {};
            }
            function Mf(e, t, r) {
                var o = e.constructor;
                switch(t){
                    case Kt:
                        return Us(e);
                    case ne:
                    case ut:
                        return new o(+e);
                    case yt:
                        return gf(e, r);
                    case qt:
                    case zt:
                    case On:
                    case ee:
                    case We:
                    case Ye:
                    case lt:
                    case wt:
                    case Mt:
                        return ml(e, r);
                    case ke:
                        return new o();
                    case Me:
                    case Le:
                        return new o(e);
                    case Ie:
                        return vf(e);
                    case pe:
                        return new o();
                    case Te:
                        return bf(e);
                }
            }
            function Nf(e, t) {
                var r = t.length;
                if (!r) return e;
                var o = r - 1;
                return t[o] = (r > 1 ? "& " : "") + t[o], t = t.join(r > 2 ? ", " : " "), e.replace(Jn, `{
/* [wrapped with ` + t + `] */
`);
            }
            function Bf(e) {
                return Xe(e) || zr(e) || !!(Fo && e && e[Fo]);
            }
            function fr(e, t) {
                var r = typeof e;
                return t = t ?? Ae, !!t && (r == "number" || r != "symbol" && tr.test(e)) && e > -1 && e % 1 == 0 && e < t;
            }
            function on(e, t, r) {
                if (!Tt(r)) return !1;
                var o = typeof t;
                return (o == "number" ? fn(r) && fr(t, r.length) : o == "string" && t in r) ? Hn(r[t], e) : !1;
            }
            function zs(e, t) {
                if (Xe(e)) return !1;
                var r = typeof e;
                return r == "number" || r == "symbol" || r == "boolean" || e == null || _n(e) ? !0 : Ni.test(e) || !Mi.test(e) || t != null && e in Ct(t);
            }
            function Pf(e) {
                var t = typeof e;
                return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
            }
            function Zs(e) {
                var t = Ga(e), r = v[t];
                if (typeof r != "function" || !(t in st.prototype)) return !1;
                if (e === r) return !0;
                var o = Gs(r);
                return !!o && e === o[0];
            }
            function Rf(e) {
                return !!No && No in e;
            }
            var Ff = wa ? hr : po;
            function sa(e) {
                var t = e && e.constructor, r = typeof t == "function" && t.prototype || _i;
                return e === r;
            }
            function Nl(e) {
                return e === e && !Tt(e);
            }
            function Bl(e, t) {
                return function(r) {
                    return r == null ? !1 : r[e] === t && (t !== u || e in Ct(r));
                };
            }
            function qf(e) {
                var t = Ja(e, function(o) {
                    return r.size === k && r.clear(), o;
                }), r = t.cache;
                return t;
            }
            function Wf(e, t) {
                var r = e[1], o = t[1], f = r | o, w = f < (g | A | _e), O = o == _e && r == $ || o == _e && r == H && e[7].length <= t[8] || o == (_e | H) && t[7].length <= t[8] && r == $;
                if (!(w || O)) return e;
                o & g && (e[2] = t[2], f |= r & g ? 0 : F);
                var N = t[3];
                if (N) {
                    var W = e[3];
                    e[3] = W ? vl(W, N, t[4]) : N, e[4] = W ? wr(e[3], b) : t[4];
                }
                return N = t[5], N && (W = e[5], e[5] = W ? bl(W, N, t[6]) : N, e[6] = W ? wr(e[5], b) : t[6]), N = t[7], N && (e[7] = N), o & _e && (e[8] = e[8] == null ? t[8] : en(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = f, e;
            }
            function Uf(e) {
                var t = [];
                if (e != null) for(var r in Ct(e))t.push(r);
                return t;
            }
            function Hf(e) {
                return Ea.call(e);
            }
            function Pl(e, t, r) {
                return t = Vt(t === u ? e.length - 1 : t, 0), function() {
                    for(var o = arguments, f = -1, w = Vt(o.length - t, 0), O = G(w); ++f < w;)O[f] = o[t + f];
                    f = -1;
                    for(var N = G(t + 1); ++f < t;)N[f] = o[f];
                    return N[t] = r(O), an(e, this, N);
                };
            }
            function Rl(e, t) {
                return t.length < 2 ? e : Gr(e, Cn(t, 0, -1));
            }
            function jf(e, t) {
                for(var r = e.length, o = en(t.length, r), f = dn(e); o--;){
                    var w = t[o];
                    e[o] = fr(w, r) ? f[w] : u;
                }
                return e;
            }
            function Xs(e, t) {
                if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__") return e[t];
            }
            var Fl = Wl(ol), oa = rd || function(e, t) {
                return Pt.setTimeout(e, t);
            }, Js = Wl(ff);
            function ql(e, t, r) {
                var o = t + "";
                return Js(e, Nf(o, $f(If(o), r)));
            }
            function Wl(e) {
                var t = 0, r = 0;
                return function() {
                    var o = od(), f = xe - (o - r);
                    if (r = o, f > 0) {
                        if (++t >= fe) return arguments[0];
                    } else t = 0;
                    return e.apply(u, arguments);
                };
            }
            function Ya(e, t) {
                var r = -1, o = e.length, f = o - 1;
                for(t = t === u ? o : t; ++r < t;){
                    var w = Ns(r, f), O = e[w];
                    e[w] = e[r], e[r] = O;
                }
                return e.length = t, e;
            }
            var Ul = qf(function(e) {
                var t = [];
                return e.charCodeAt(0) === 46 && t.push(""), e.replace(Bi, function(r, o, f, w) {
                    t.push(f ? w.replace(Ri, "$1") : o || r);
                }), t;
            });
            function Zn(e) {
                if (typeof e == "string" || _n(e)) return e;
                var t = e + "";
                return t == "0" && 1 / e == -K ? "-0" : t;
            }
            function Yr(e) {
                if (e != null) {
                    try {
                        return Sa.call(e);
                    } catch  {}
                    try {
                        return e + "";
                    } catch  {}
                }
                return "";
            }
            function $f(e, t) {
                return Jt(Be, function(r) {
                    var o = "_." + r[0];
                    t & r[1] && !Ur(e, o) && e.push(o);
                }), e.sort();
            }
            function Hl(e) {
                if (e instanceof st) return e.clone();
                var t = new En(e.__wrapped__, e.__chain__);
                return t.__actions__ = dn(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
            }
            function Kf(e, t, r) {
                (r ? on(e, t, r) : t === u) ? t = 1 : t = Vt(Qe(t), 0);
                var o = e == null ? 0 : e.length;
                if (!o || t < 1) return [];
                for(var f = 0, w = 0, O = G(Ta(o / t)); f < o;)O[w++] = Cn(e, f, f += t);
                return O;
            }
            function Gf(e) {
                for(var t = -1, r = e == null ? 0 : e.length, o = 0, f = []; ++t < r;){
                    var w = e[t];
                    w && (f[o++] = w);
                }
                return f;
            }
            function Vf() {
                var e = arguments.length;
                if (!e) return [];
                for(var t = G(e - 1), r = arguments[0], o = e; o--;)t[o - 1] = arguments[o];
                return qn(Xe(r) ? dn(r) : [
                    r
                ], Qt(t, 1));
            }
            var Yf = tt(function(e, t) {
                return Ut(e) ? ta(e, Qt(t, 1, Ut, !0)) : [];
            }), zf = tt(function(e, t) {
                var r = kn(t);
                return Ut(r) && (r = u), Ut(e) ? ta(e, Qt(t, 1, Ut, !0), $e(r, 2)) : [];
            }), Zf = tt(function(e, t) {
                var r = kn(t);
                return Ut(r) && (r = u), Ut(e) ? ta(e, Qt(t, 1, Ut, !0), u, r) : [];
            });
            function Xf(e, t, r) {
                var o = e == null ? 0 : e.length;
                return o ? (t = r || t === u ? 1 : Qe(t), Cn(e, t < 0 ? 0 : t, o)) : [];
            }
            function Jf(e, t, r) {
                var o = e == null ? 0 : e.length;
                return o ? (t = r || t === u ? 1 : Qe(t), t = o - t, Cn(e, 0, t < 0 ? 0 : t)) : [];
            }
            function Qf(e, t) {
                return e && e.length ? Wa(e, $e(t, 3), !0, !0) : [];
            }
            function eh(e, t) {
                return e && e.length ? Wa(e, $e(t, 3), !0) : [];
            }
            function th(e, t, r, o) {
                var f = e == null ? 0 : e.length;
                return f ? (r && typeof r != "number" && on(e, t, r) && (r = 0, o = f), Gd(e, t, r, o)) : [];
            }
            function jl(e, t, r) {
                var o = e == null ? 0 : e.length;
                if (!o) return -1;
                var f = r == null ? 0 : Qe(r);
                return f < 0 && (f = Vt(o + f, 0)), _a(e, $e(t, 3), f);
            }
            function $l(e, t, r) {
                var o = e == null ? 0 : e.length;
                if (!o) return -1;
                var f = o - 1;
                return r !== u && (f = Qe(r), f = r < 0 ? Vt(o + f, 0) : en(f, o - 1)), _a(e, $e(t, 3), f, !0);
            }
            function Kl(e) {
                var t = e == null ? 0 : e.length;
                return t ? Qt(e, 1) : [];
            }
            function nh(e) {
                var t = e == null ? 0 : e.length;
                return t ? Qt(e, K) : [];
            }
            function rh(e, t) {
                var r = e == null ? 0 : e.length;
                return r ? (t = t === u ? 1 : Qe(t), Qt(e, t)) : [];
            }
            function ih(e) {
                for(var t = -1, r = e == null ? 0 : e.length, o = {}; ++t < r;){
                    var f = e[t];
                    o[f[0]] = f[1];
                }
                return o;
            }
            function Gl(e) {
                return e && e.length ? e[0] : u;
            }
            function ah(e, t, r) {
                var o = e == null ? 0 : e.length;
                if (!o) return -1;
                var f = r == null ? 0 : Qe(r);
                return f < 0 && (f = Vt(o + f, 0)), mi(e, t, f);
            }
            function sh(e) {
                var t = e == null ? 0 : e.length;
                return t ? Cn(e, 0, -1) : [];
            }
            var oh = tt(function(e) {
                var t = xt(e, qs);
                return t.length && t[0] === e[0] ? Ds(t) : [];
            }), lh = tt(function(e) {
                var t = kn(e), r = xt(e, qs);
                return t === kn(r) ? t = u : r.pop(), r.length && r[0] === e[0] ? Ds(r, $e(t, 2)) : [];
            }), ch = tt(function(e) {
                var t = kn(e), r = xt(e, qs);
                return t = typeof t == "function" ? t : u, t && r.pop(), r.length && r[0] === e[0] ? Ds(r, u, t) : [];
            });
            function uh(e, t) {
                return e == null ? "" : ad.call(e, t);
            }
            function kn(e) {
                var t = e == null ? 0 : e.length;
                return t ? e[t - 1] : u;
            }
            function dh(e, t, r) {
                var o = e == null ? 0 : e.length;
                if (!o) return -1;
                var f = o;
                return r !== u && (f = Qe(r), f = f < 0 ? Vt(o + f, 0) : en(f, o - 1)), t === t ? ju(e, t, f) : _a(e, Co, f, !0);
            }
            function fh(e, t) {
                return e && e.length ? rl(e, Qe(t)) : u;
            }
            var hh = tt(Vl);
            function Vl(e, t) {
                return e && e.length && t && t.length ? Ms(e, t) : e;
            }
            function ph(e, t, r) {
                return e && e.length && t && t.length ? Ms(e, t, $e(r, 2)) : e;
            }
            function mh(e, t, r) {
                return e && e.length && t && t.length ? Ms(e, t, u, r) : e;
            }
            var gh = dr(function(e, t) {
                var r = e == null ? 0 : e.length, o = xs(e, t);
                return sl(e, xt(t, function(f) {
                    return fr(f, r) ? +f : f;
                }).sort(gl)), o;
            });
            function vh(e, t) {
                var r = [];
                if (!(e && e.length)) return r;
                var o = -1, f = [], w = e.length;
                for(t = $e(t, 3); ++o < w;){
                    var O = e[o];
                    t(O, o, e) && (r.push(O), f.push(o));
                }
                return sl(e, f), r;
            }
            function Qs(e) {
                return e == null ? e : cd.call(e);
            }
            function bh(e, t, r) {
                var o = e == null ? 0 : e.length;
                return o ? (r && typeof r != "number" && on(e, t, r) ? (t = 0, r = o) : (t = t == null ? 0 : Qe(t), r = r === u ? o : Qe(r)), Cn(e, t, r)) : [];
            }
            function _h(e, t) {
                return qa(e, t);
            }
            function yh(e, t, r) {
                return Ps(e, t, $e(r, 2));
            }
            function Ah(e, t) {
                var r = e == null ? 0 : e.length;
                if (r) {
                    var o = qa(e, t);
                    if (o < r && Hn(e[o], t)) return o;
                }
                return -1;
            }
            function wh(e, t) {
                return qa(e, t, !0);
            }
            function Sh(e, t, r) {
                return Ps(e, t, $e(r, 2), !0);
            }
            function Eh(e, t) {
                var r = e == null ? 0 : e.length;
                if (r) {
                    var o = qa(e, t, !0) - 1;
                    if (Hn(e[o], t)) return o;
                }
                return -1;
            }
            function xh(e) {
                return e && e.length ? ll(e) : [];
            }
            function Ch(e, t) {
                return e && e.length ? ll(e, $e(t, 2)) : [];
            }
            function kh(e) {
                var t = e == null ? 0 : e.length;
                return t ? Cn(e, 1, t) : [];
            }
            function Lh(e, t, r) {
                return e && e.length ? (t = r || t === u ? 1 : Qe(t), Cn(e, 0, t < 0 ? 0 : t)) : [];
            }
            function Dh(e, t, r) {
                var o = e == null ? 0 : e.length;
                return o ? (t = r || t === u ? 1 : Qe(t), t = o - t, Cn(e, t < 0 ? 0 : t, o)) : [];
            }
            function Th(e, t) {
                return e && e.length ? Wa(e, $e(t, 3), !1, !0) : [];
            }
            function Ih(e, t) {
                return e && e.length ? Wa(e, $e(t, 3)) : [];
            }
            var Oh = tt(function(e) {
                return xr(Qt(e, 1, Ut, !0));
            }), Mh = tt(function(e) {
                var t = kn(e);
                return Ut(t) && (t = u), xr(Qt(e, 1, Ut, !0), $e(t, 2));
            }), Nh = tt(function(e) {
                var t = kn(e);
                return t = typeof t == "function" ? t : u, xr(Qt(e, 1, Ut, !0), u, t);
            });
            function Bh(e) {
                return e && e.length ? xr(e) : [];
            }
            function Ph(e, t) {
                return e && e.length ? xr(e, $e(t, 2)) : [];
            }
            function Rh(e, t) {
                return t = typeof t == "function" ? t : u, e && e.length ? xr(e, u, t) : [];
            }
            function eo(e) {
                if (!(e && e.length)) return [];
                var t = 0;
                return e = wn(e, function(r) {
                    if (Ut(r)) return t = Vt(r.length, t), !0;
                }), vs(t, function(r) {
                    return xt(e, ps(r));
                });
            }
            function Yl(e, t) {
                if (!(e && e.length)) return [];
                var r = eo(e);
                return t == null ? r : xt(r, function(o) {
                    return an(t, u, o);
                });
            }
            var Fh = tt(function(e, t) {
                return Ut(e) ? ta(e, t) : [];
            }), qh = tt(function(e) {
                return Fs(wn(e, Ut));
            }), Wh = tt(function(e) {
                var t = kn(e);
                return Ut(t) && (t = u), Fs(wn(e, Ut), $e(t, 2));
            }), Uh = tt(function(e) {
                var t = kn(e);
                return t = typeof t == "function" ? t : u, Fs(wn(e, Ut), u, t);
            }), Hh = tt(eo);
            function jh(e, t) {
                return fl(e || [], t || [], ea);
            }
            function $h(e, t) {
                return fl(e || [], t || [], ia);
            }
            var Kh = tt(function(e) {
                var t = e.length, r = t > 1 ? e[t - 1] : u;
                return r = typeof r == "function" ? (e.pop(), r) : u, Yl(e, r);
            });
            function zl(e) {
                var t = v(e);
                return t.__chain__ = !0, t;
            }
            function Gh(e, t) {
                return t(e), e;
            }
            function za(e, t) {
                return t(e);
            }
            var Vh = dr(function(e) {
                var t = e.length, r = t ? e[0] : 0, o = this.__wrapped__, f = function(w) {
                    return xs(w, e);
                };
                return t > 1 || this.__actions__.length || !(o instanceof st) || !fr(r) ? this.thru(f) : (o = o.slice(r, +r + (t ? 1 : 0)), o.__actions__.push({
                    func: za,
                    args: [
                        f
                    ],
                    thisArg: u
                }), new En(o, this.__chain__).thru(function(w) {
                    return t && !w.length && w.push(u), w;
                }));
            });
            function Yh() {
                return zl(this);
            }
            function zh() {
                return new En(this.value(), this.__chain__);
            }
            function Zh() {
                this.__values__ === u && (this.__values__ = cc(this.value()));
                var e = this.__index__ >= this.__values__.length, t = e ? u : this.__values__[this.__index__++];
                return {
                    done: e,
                    value: t
                };
            }
            function Xh() {
                return this;
            }
            function Jh(e) {
                for(var t, r = this; r instanceof Na;){
                    var o = Hl(r);
                    o.__index__ = 0, o.__values__ = u, t ? f.__wrapped__ = o : t = o;
                    var f = o;
                    r = r.__wrapped__;
                }
                return f.__wrapped__ = e, t;
            }
            function Qh() {
                var e = this.__wrapped__;
                if (e instanceof st) {
                    var t = e;
                    return this.__actions__.length && (t = new st(this)), t = t.reverse(), t.__actions__.push({
                        func: za,
                        args: [
                            Qs
                        ],
                        thisArg: u
                    }), new En(t, this.__chain__);
                }
                return this.thru(Qs);
            }
            function ep() {
                return dl(this.__wrapped__, this.__actions__);
            }
            var tp = Ua(function(e, t, r) {
                At.call(e, r) ? ++e[r] : cr(e, r, 1);
            });
            function np(e, t, r) {
                var o = Xe(e) ? Vi : Kd;
                return r && on(e, t, r) && (t = u), o(e, $e(t, 3));
            }
            function rp(e, t) {
                var r = Xe(e) ? wn : Yo;
                return r(e, $e(t, 3));
            }
            var ip = wl(jl), ap = wl($l);
            function sp(e, t) {
                return Qt(Za(e, t), 1);
            }
            function op(e, t) {
                return Qt(Za(e, t), K);
            }
            function lp(e, t, r) {
                return r = r === u ? 1 : Qe(r), Qt(Za(e, t), r);
            }
            function Zl(e, t) {
                var r = Xe(e) ? Jt : Er;
                return r(e, $e(t, 3));
            }
            function Xl(e, t) {
                var r = Xe(e) ? ba : Vo;
                return r(e, $e(t, 3));
            }
            var cp = Ua(function(e, t, r) {
                At.call(e, r) ? e[r].push(t) : cr(e, r, [
                    t
                ]);
            });
            function up(e, t, r, o) {
                e = fn(e) ? e : ki(e), r = r && !o ? Qe(r) : 0;
                var f = e.length;
                return r < 0 && (r = Vt(f + r, 0)), ts(e) ? r <= f && e.indexOf(t, r) > -1 : !!f && mi(e, t, r) > -1;
            }
            var dp = tt(function(e, t, r) {
                var o = -1, f = typeof t == "function", w = fn(e) ? G(e.length) : [];
                return Er(e, function(O) {
                    w[++o] = f ? an(t, O, r) : na(O, t, r);
                }), w;
            }), hp = Ua(function(e, t, r) {
                cr(e, r, t);
            });
            function Za(e, t) {
                var r = Xe(e) ? xt : el;
                return r(e, $e(t, 3));
            }
            function pp(e, t, r, o) {
                return e == null ? [] : (Xe(t) || (t = t == null ? [] : [
                    t
                ]), r = o ? u : r, Xe(r) || (r = r == null ? [] : [
                    r
                ]), il(e, t, r));
            }
            var mp = Ua(function(e, t, r) {
                e[r ? 0 : 1].push(t);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function gp(e, t, r) {
                var o = Xe(e) ? fs : Lo, f = arguments.length < 3;
                return o(e, $e(t, 4), r, f, Er);
            }
            function vp(e, t, r) {
                var o = Xe(e) ? ku : Lo, f = arguments.length < 3;
                return o(e, $e(t, 4), r, f, Vo);
            }
            function bp(e, t) {
                var r = Xe(e) ? wn : Yo;
                return r(e, Qa($e(t, 3)));
            }
            function _p(e) {
                var t = Xe(e) ? jo : uf;
                return t(e);
            }
            function yp(e, t, r) {
                (r ? on(e, t, r) : t === u) ? t = 1 : t = Qe(t);
                var o = Xe(e) ? Wd : df;
                return o(e, t);
            }
            function Ap(e) {
                var t = Xe(e) ? Ud : hf;
                return t(e);
            }
            function wp(e) {
                if (e == null) return 0;
                if (fn(e)) return ts(e) ? vi(e) : e.length;
                var t = tn(e);
                return t == ke || t == pe ? e.size : Is(e).length;
            }
            function Sp(e, t, r) {
                var o = Xe(e) ? hs : pf;
                return r && on(e, t, r) && (t = u), o(e, $e(t, 3));
            }
            var Ep = tt(function(e, t) {
                if (e == null) return [];
                var r = t.length;
                return r > 1 && on(e, t[0], t[1]) ? t = [] : r > 2 && on(t[0], t[1], t[2]) && (t = [
                    t[0]
                ]), il(e, Qt(t, 1), []);
            }), Xa = nd || function() {
                return Pt.Date.now();
            };
            function xp(e, t) {
                if (typeof t != "function") throw new Sn(E);
                return e = Qe(e), function() {
                    if (--e < 1) return t.apply(this, arguments);
                };
            }
            function Jl(e, t, r) {
                return t = r ? u : t, t = e && t == null ? e.length : t, ur(e, _e, u, u, u, u, t);
            }
            function Ql(e, t) {
                var r;
                if (typeof t != "function") throw new Sn(E);
                return e = Qe(e), function() {
                    return --e > 0 && (r = t.apply(this, arguments)), e <= 1 && (t = u), r;
                };
            }
            var to = tt(function(e, t, r) {
                var o = g;
                if (r.length) {
                    var f = wr(r, xi(to));
                    o |= se;
                }
                return ur(e, o, t, r, f);
            }), ec = tt(function(e, t, r) {
                var o = g | A;
                if (r.length) {
                    var f = wr(r, xi(ec));
                    o |= se;
                }
                return ur(t, o, e, r, f);
            });
            function tc(e, t, r) {
                t = r ? u : t;
                var o = ur(e, $, u, u, u, u, u, t);
                return o.placeholder = tc.placeholder, o;
            }
            function nc(e, t, r) {
                t = r ? u : t;
                var o = ur(e, J, u, u, u, u, u, t);
                return o.placeholder = nc.placeholder, o;
            }
            function rc(e, t, r) {
                var o, f, w, O, N, W, te = 0, re = !1, ie = !1, Ee = !0;
                if (typeof e != "function") throw new Sn(E);
                t = Ln(t) || 0, Tt(r) && (re = !!r.leading, ie = "maxWait" in r, w = ie ? Vt(Ln(r.maxWait) || 0, t) : w, Ee = "trailing" in r ? !!r.trailing : Ee);
                function Pe(Ht) {
                    var jn = o, mr = f;
                    return o = f = u, te = Ht, O = e.apply(mr, jn), O;
                }
                function Ke(Ht) {
                    return te = Ht, N = oa(at, t), re ? Pe(Ht) : O;
                }
                function et(Ht) {
                    var jn = Ht - W, mr = Ht - te, wc = t - jn;
                    return ie ? en(wc, w - mr) : wc;
                }
                function Ge(Ht) {
                    var jn = Ht - W, mr = Ht - te;
                    return W === u || jn >= t || jn < 0 || ie && mr >= w;
                }
                function at() {
                    var Ht = Xa();
                    if (Ge(Ht)) return ot(Ht);
                    N = oa(at, et(Ht));
                }
                function ot(Ht) {
                    return N = u, Ee && o ? Pe(Ht) : (o = f = u, O);
                }
                function yn() {
                    N !== u && hl(N), te = 0, o = W = f = N = u;
                }
                function ln() {
                    return N === u ? O : ot(Xa());
                }
                function An() {
                    var Ht = Xa(), jn = Ge(Ht);
                    if (o = arguments, f = this, W = Ht, jn) {
                        if (N === u) return Ke(W);
                        if (ie) return hl(N), N = oa(at, t), Pe(W);
                    }
                    return N === u && (N = oa(at, t)), O;
                }
                return An.cancel = yn, An.flush = ln, An;
            }
            var Cp = tt(function(e, t) {
                return Go(e, 1, t);
            }), kp = tt(function(e, t, r) {
                return Go(e, Ln(t) || 0, r);
            });
            function Lp(e) {
                return ur(e, Y);
            }
            function Ja(e, t) {
                if (typeof e != "function" || t != null && typeof t != "function") throw new Sn(E);
                var r = function() {
                    var o = arguments, f = t ? t.apply(this, o) : o[0], w = r.cache;
                    if (w.has(f)) return w.get(f);
                    var O = e.apply(this, o);
                    return r.cache = w.set(f, O) || w, O;
                };
                return r.cache = new (Ja.Cache || lr)(), r;
            }
            Ja.Cache = lr;
            function Qa(e) {
                if (typeof e != "function") throw new Sn(E);
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return !e.call(this);
                        case 1:
                            return !e.call(this, t[0]);
                        case 2:
                            return !e.call(this, t[0], t[1]);
                        case 3:
                            return !e.call(this, t[0], t[1], t[2]);
                    }
                    return !e.apply(this, t);
                };
            }
            function Dp(e) {
                return Ql(2, e);
            }
            var Tp = mf(function(e, t) {
                t = t.length == 1 && Xe(t[0]) ? xt(t[0], vn($e())) : xt(Qt(t, 1), vn($e()));
                var r = t.length;
                return tt(function(o) {
                    for(var f = -1, w = en(o.length, r); ++f < w;)o[f] = t[f].call(this, o[f]);
                    return an(e, this, o);
                });
            }), no = tt(function(e, t) {
                var r = wr(t, xi(no));
                return ur(e, se, u, t, r);
            }), ic = tt(function(e, t) {
                var r = wr(t, xi(ic));
                return ur(e, Q, u, t, r);
            }), Ip = dr(function(e, t) {
                return ur(e, H, u, u, u, t);
            });
            function Op(e, t) {
                if (typeof e != "function") throw new Sn(E);
                return t = t === u ? t : Qe(t), tt(e, t);
            }
            function Mp(e, t) {
                if (typeof e != "function") throw new Sn(E);
                return t = t == null ? 0 : Vt(Qe(t), 0), tt(function(r) {
                    var o = r[t], f = kr(r, 0, t);
                    return o && qn(f, o), an(e, this, f);
                });
            }
            function Np(e, t, r) {
                var o = !0, f = !0;
                if (typeof e != "function") throw new Sn(E);
                return Tt(r) && (o = "leading" in r ? !!r.leading : o, f = "trailing" in r ? !!r.trailing : f), rc(e, t, {
                    leading: o,
                    maxWait: t,
                    trailing: f
                });
            }
            function Bp(e) {
                return Jl(e, 1);
            }
            function Pp(e, t) {
                return no(Ws(t), e);
            }
            function Rp() {
                if (!arguments.length) return [];
                var e = arguments[0];
                return Xe(e) ? e : [
                    e
                ];
            }
            function Fp(e) {
                return xn(e, a);
            }
            function qp(e, t) {
                return t = typeof t == "function" ? t : u, xn(e, a, t);
            }
            function Wp(e) {
                return xn(e, m | a);
            }
            function Up(e, t) {
                return t = typeof t == "function" ? t : u, xn(e, m | a, t);
            }
            function Hp(e, t) {
                return t == null || Ko(e, t, Zt(t));
            }
            function Hn(e, t) {
                return e === t || e !== e && t !== t;
            }
            var jp = Ka(Ls), $p = Ka(function(e, t) {
                return e >= t;
            }), zr = Xo(function() {
                return arguments;
            }()) ? Xo : function(e) {
                return Rt(e) && At.call(e, "callee") && !Ro.call(e, "callee");
            }, Xe = G.isArray, Kp = $i ? vn($i) : Xd;
            function fn(e) {
                return e != null && es(e.length) && !hr(e);
            }
            function Ut(e) {
                return Rt(e) && fn(e);
            }
            function Gp(e) {
                return e === !0 || e === !1 || Rt(e) && sn(e) == ne;
            }
            var Lr = id || po, Vp = ma ? vn(ma) : Jd;
            function Yp(e) {
                return Rt(e) && e.nodeType === 1 && !la(e);
            }
            function zp(e) {
                if (e == null) return !0;
                if (fn(e) && (Xe(e) || typeof e == "string" || typeof e.splice == "function" || Lr(e) || Ci(e) || zr(e))) return !e.length;
                var t = tn(e);
                if (t == ke || t == pe) return !e.size;
                if (sa(e)) return !Is(e).length;
                for(var r in e)if (At.call(e, r)) return !1;
                return !0;
            }
            function Zp(e, t) {
                return ra(e, t);
            }
            function Xp(e, t, r) {
                r = typeof r == "function" ? r : u;
                var o = r ? r(e, t) : u;
                return o === u ? ra(e, t, u, r) : !!o;
            }
            function ro(e) {
                if (!Rt(e)) return !1;
                var t = sn(e);
                return t == P || t == M || typeof e.message == "string" && typeof e.name == "string" && !la(e);
            }
            function Jp(e) {
                return typeof e == "number" && qo(e);
            }
            function hr(e) {
                if (!Tt(e)) return !1;
                var t = sn(e);
                return t == n || t == ye || t == ge || t == He;
            }
            function ac(e) {
                return typeof e == "number" && e == Qe(e);
            }
            function es(e) {
                return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ae;
            }
            function Tt(e) {
                var t = typeof e;
                return e != null && (t == "object" || t == "function");
            }
            function Rt(e) {
                return e != null && typeof e == "object";
            }
            var sc = ga ? vn(ga) : ef;
            function Qp(e, t) {
                return e === t || Ts(e, t, Vs(t));
            }
            function em(e, t, r) {
                return r = typeof r == "function" ? r : u, Ts(e, t, Vs(t), r);
            }
            function tm(e) {
                return oc(e) && e != +e;
            }
            function nm(e) {
                if (Ff(e)) throw new Ze(I);
                return Jo(e);
            }
            function rm(e) {
                return e === null;
            }
            function im(e) {
                return e == null;
            }
            function oc(e) {
                return typeof e == "number" || Rt(e) && sn(e) == Me;
            }
            function la(e) {
                if (!Rt(e) || sn(e) != oe) return !1;
                var t = ka(e);
                if (t === null) return !0;
                var r = At.call(t, "constructor") && t.constructor;
                return typeof r == "function" && r instanceof r && Sa.call(r) == Ju;
            }
            var io = Ki ? vn(Ki) : tf;
            function am(e) {
                return ac(e) && e >= -Ae && e <= Ae;
            }
            var lc = Gi ? vn(Gi) : nf;
            function ts(e) {
                return typeof e == "string" || !Xe(e) && Rt(e) && sn(e) == Le;
            }
            function _n(e) {
                return typeof e == "symbol" || Rt(e) && sn(e) == Te;
            }
            var Ci = va ? vn(va) : rf;
            function sm(e) {
                return e === u;
            }
            function om(e) {
                return Rt(e) && tn(e) == je;
            }
            function lm(e) {
                return Rt(e) && sn(e) == Ot;
            }
            var cm = Ka(Os), um = Ka(function(e, t) {
                return e <= t;
            });
            function cc(e) {
                if (!e) return [];
                if (fn(e)) return ts(e) ? Wn(e) : dn(e);
                if (zi && e[zi]) return Wu(e[zi]());
                var t = tn(e), r = t == ke ? _s : t == pe ? ya : ki;
                return r(e);
            }
            function pr(e) {
                if (!e) return e === 0 ? e : 0;
                if (e = Ln(e), e === K || e === -K) {
                    var t = e < 0 ? -1 : 1;
                    return t * we;
                }
                return e === e ? e : 0;
            }
            function Qe(e) {
                var t = pr(e), r = t % 1;
                return t === t ? r ? t - r : t : 0;
            }
            function uc(e) {
                return e ? Kr(Qe(e), 0, ve) : 0;
            }
            function Ln(e) {
                if (typeof e == "number") return e;
                if (_n(e)) return me;
                if (Tt(e)) {
                    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
                    e = Tt(t) ? t + "" : t;
                }
                if (typeof e != "string") return e === 0 ? e : +e;
                e = Do(e);
                var r = Br.test(e);
                return r || si.test(e) ? Ar(e.slice(2), r ? 2 : 8) : ai.test(e) ? me : +e;
            }
            function dc(e) {
                return zn(e, hn(e));
            }
            function dm(e) {
                return e ? Kr(Qe(e), -Ae, Ae) : e === 0 ? e : 0;
            }
            function vt(e) {
                return e == null ? "" : bn(e);
            }
            var fm = Si(function(e, t) {
                if (sa(t) || fn(t)) {
                    zn(t, Zt(t), e);
                    return;
                }
                for(var r in t)At.call(t, r) && ea(e, r, t[r]);
            }), fc = Si(function(e, t) {
                zn(t, hn(t), e);
            }), ns = Si(function(e, t, r, o) {
                zn(t, hn(t), e, o);
            }), hm = Si(function(e, t, r, o) {
                zn(t, Zt(t), e, o);
            }), pm = dr(xs);
            function mm(e, t) {
                var r = wi(e);
                return t == null ? r : $o(r, t);
            }
            var gm = tt(function(e, t) {
                e = Ct(e);
                var r = -1, o = t.length, f = o > 2 ? t[2] : u;
                for(f && on(t[0], t[1], f) && (o = 1); ++r < o;)for(var w = t[r], O = hn(w), N = -1, W = O.length; ++N < W;){
                    var te = O[N], re = e[te];
                    (re === u || Hn(re, _i[te]) && !At.call(e, te)) && (e[te] = w[te]);
                }
                return e;
            }), vm = tt(function(e) {
                return e.push(u, Dl), an(hc, u, e);
            });
            function bm(e, t) {
                return xo(e, $e(t, 3), Yn);
            }
            function _m(e, t) {
                return xo(e, $e(t, 3), ks);
            }
            function ym(e, t) {
                return e == null ? e : Cs(e, $e(t, 3), hn);
            }
            function Am(e, t) {
                return e == null ? e : zo(e, $e(t, 3), hn);
            }
            function wm(e, t) {
                return e && Yn(e, $e(t, 3));
            }
            function Sm(e, t) {
                return e && ks(e, $e(t, 3));
            }
            function Em(e) {
                return e == null ? [] : Ra(e, Zt(e));
            }
            function xm(e) {
                return e == null ? [] : Ra(e, hn(e));
            }
            function ao(e, t, r) {
                var o = e == null ? u : Gr(e, t);
                return o === u ? r : o;
            }
            function Cm(e, t) {
                return e != null && Ol(e, t, Vd);
            }
            function so(e, t) {
                return e != null && Ol(e, t, Yd);
            }
            var km = El(function(e, t, r) {
                t != null && typeof t.toString != "function" && (t = Ea.call(t)), e[t] = r;
            }, lo(pn)), Lm = El(function(e, t, r) {
                t != null && typeof t.toString != "function" && (t = Ea.call(t)), At.call(e, t) ? e[t].push(r) : e[t] = [
                    r
                ];
            }, $e), Dm = tt(na);
            function Zt(e) {
                return fn(e) ? Ho(e) : Is(e);
            }
            function hn(e) {
                return fn(e) ? Ho(e, !0) : af(e);
            }
            function Tm(e, t) {
                var r = {};
                return t = $e(t, 3), Yn(e, function(o, f, w) {
                    cr(r, t(o, f, w), o);
                }), r;
            }
            function Im(e, t) {
                var r = {};
                return t = $e(t, 3), Yn(e, function(o, f, w) {
                    cr(r, f, t(o, f, w));
                }), r;
            }
            var Om = Si(function(e, t, r) {
                Fa(e, t, r);
            }), hc = Si(function(e, t, r, o) {
                Fa(e, t, r, o);
            }), Mm = dr(function(e, t) {
                var r = {};
                if (e == null) return r;
                var o = !1;
                t = xt(t, function(w) {
                    return w = Cr(w, e), o || (o = w.length > 1), w;
                }), zn(e, Ks(e), r), o && (r = xn(r, m | i | a, Cf));
                for(var f = t.length; f--;)Rs(r, t[f]);
                return r;
            });
            function Nm(e, t) {
                return pc(e, Qa($e(t)));
            }
            var Bm = dr(function(e, t) {
                return e == null ? {} : of(e, t);
            });
            function pc(e, t) {
                if (e == null) return {};
                var r = xt(Ks(e), function(o) {
                    return [
                        o
                    ];
                });
                return t = $e(t), al(e, r, function(o, f) {
                    return t(o, f[0]);
                });
            }
            function Pm(e, t, r) {
                t = Cr(t, e);
                var o = -1, f = t.length;
                for(f || (f = 1, e = u); ++o < f;){
                    var w = e == null ? u : e[Zn(t[o])];
                    w === u && (o = f, w = r), e = hr(w) ? w.call(e) : w;
                }
                return e;
            }
            function Rm(e, t, r) {
                return e == null ? e : ia(e, t, r);
            }
            function Fm(e, t, r, o) {
                return o = typeof o == "function" ? o : u, e == null ? e : ia(e, t, r, o);
            }
            var mc = kl(Zt), gc = kl(hn);
            function qm(e, t, r) {
                var o = Xe(e), f = o || Lr(e) || Ci(e);
                if (t = $e(t, 4), r == null) {
                    var w = e && e.constructor;
                    f ? r = o ? new w() : [] : Tt(e) ? r = hr(w) ? wi(ka(e)) : {} : r = {};
                }
                return (f ? Jt : Yn)(e, function(O, N, W) {
                    return t(r, O, N, W);
                }), r;
            }
            function Wm(e, t) {
                return e == null ? !0 : Rs(e, t);
            }
            function Um(e, t, r) {
                return e == null ? e : ul(e, t, Ws(r));
            }
            function Hm(e, t, r, o) {
                return o = typeof o == "function" ? o : u, e == null ? e : ul(e, t, Ws(r), o);
            }
            function ki(e) {
                return e == null ? [] : bs(e, Zt(e));
            }
            function jm(e) {
                return e == null ? [] : bs(e, hn(e));
            }
            function $m(e, t, r) {
                return r === u && (r = t, t = u), r !== u && (r = Ln(r), r = r === r ? r : 0), t !== u && (t = Ln(t), t = t === t ? t : 0), Kr(Ln(e), t, r);
            }
            function Km(e, t, r) {
                return t = pr(t), r === u ? (r = t, t = 0) : r = pr(r), e = Ln(e), zd(e, t, r);
            }
            function Gm(e, t, r) {
                if (r && typeof r != "boolean" && on(e, t, r) && (t = r = u), r === u && (typeof t == "boolean" ? (r = t, t = u) : typeof e == "boolean" && (r = e, e = u)), e === u && t === u ? (e = 0, t = 1) : (e = pr(e), t === u ? (t = e, e = 0) : t = pr(t)), e > t) {
                    var o = e;
                    e = t, t = o;
                }
                if (r || e % 1 || t % 1) {
                    var f = Wo();
                    return en(e + f * (t - e + hi("1e-" + ((f + "").length - 1))), t);
                }
                return Ns(e, t);
            }
            var Vm = Ei(function(e, t, r) {
                return t = t.toLowerCase(), e + (r ? vc(t) : t);
            });
            function vc(e) {
                return oo(vt(e).toLowerCase());
            }
            function bc(e) {
                return e = vt(e), e && e.replace(oi, Bu).replace(Dt, "");
            }
            function Ym(e, t, r) {
                e = vt(e), t = bn(t);
                var o = e.length;
                r = r === u ? o : Kr(Qe(r), 0, o);
                var f = r;
                return r -= t.length, r >= 0 && e.slice(r, f) == t;
            }
            function zm(e) {
                return e = vt(e), e && ti.test(e) ? e.replace(Qr, Pu) : e;
            }
            function Zm(e) {
                return e = vt(e), e && Or.test(e) ? e.replace(Mn, "\\$&") : e;
            }
            var Xm = Ei(function(e, t, r) {
                return e + (r ? "-" : "") + t.toLowerCase();
            }), Jm = Ei(function(e, t, r) {
                return e + (r ? " " : "") + t.toLowerCase();
            }), Qm = Al("toLowerCase");
            function eg(e, t, r) {
                e = vt(e), t = Qe(t);
                var o = t ? vi(e) : 0;
                if (!t || o >= t) return e;
                var f = (t - o) / 2;
                return $a(Ia(f), r) + e + $a(Ta(f), r);
            }
            function tg(e, t, r) {
                e = vt(e), t = Qe(t);
                var o = t ? vi(e) : 0;
                return t && o < t ? e + $a(t - o, r) : e;
            }
            function ng(e, t, r) {
                e = vt(e), t = Qe(t);
                var o = t ? vi(e) : 0;
                return t && o < t ? $a(t - o, r) + e : e;
            }
            function rg(e, t, r) {
                return r || t == null ? t = 0 : t && (t = +t), ld(vt(e).replace(gn, ""), t || 0);
            }
            function ig(e, t, r) {
                return (r ? on(e, t, r) : t === u) ? t = 1 : t = Qe(t), Bs(vt(e), t);
            }
            function ag() {
                var e = arguments, t = vt(e[0]);
                return e.length < 3 ? t : t.replace(e[1], e[2]);
            }
            var sg = Ei(function(e, t, r) {
                return e + (r ? "_" : "") + t.toLowerCase();
            });
            function og(e, t, r) {
                return r && typeof r != "number" && on(e, t, r) && (t = r = u), r = r === u ? ve : r >>> 0, r ? (e = vt(e), e && (typeof t == "string" || t != null && !io(t)) && (t = bn(t), !t && gi(e)) ? kr(Wn(e), 0, r) : e.split(t, r)) : [];
            }
            var lg = Ei(function(e, t, r) {
                return e + (r ? " " : "") + oo(t);
            });
            function cg(e, t, r) {
                return e = vt(e), r = r == null ? 0 : Kr(Qe(r), 0, e.length), t = bn(t), e.slice(r, r + t.length) == t;
            }
            function ug(e, t, r) {
                var o = v.templateSettings;
                r && on(e, t, r) && (t = u), e = vt(e), t = ns({}, t, o, Ll);
                var f = ns({}, t.imports, o.imports, Ll), w = Zt(f), O = bs(f, w), N, W, te = 0, re = t.interpolate || Kn, ie = "__p += '", Ee = ys((t.escape || Kn).source + "|" + re.source + "|" + (re === _r ? Nr : Kn).source + "|" + (t.evaluate || Kn).source + "|$", "g"), Pe = "//# sourceURL=" + (At.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++rn + "]") + `
`;
                e.replace(Ee, function(Ge, at, ot, yn, ln, An) {
                    return ot || (ot = yn), ie += e.slice(te, An).replace(li, Ru), at && (N = !0, ie += `' +
__e(` + at + `) +
'`), ln && (W = !0, ie += `';
` + ln + `;
__p += '`), ot && (ie += `' +
((__t = (` + ot + `)) == null ? '' : __t) +
'`), te = An + Ge.length, Ge;
                }), ie += `';
`;
                var Ke = At.call(t, "variable") && t.variable;
                if (!Ke) ie = `with (obj) {
` + ie + `
}
`;
                else if (Mr.test(Ke)) throw new Ze(S);
                ie = (W ? ie.replace(jt, "") : ie).replace(cn, "$1").replace(Ii, "$1;"), ie = "function(" + (Ke || "obj") + `) {
` + (Ke ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (N ? ", __e = _.escape" : "") + (W ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ie + `return __p
}`;
                var et = yc(function() {
                    return gt(w, Pe + "return " + ie).apply(u, O);
                });
                if (et.source = ie, ro(et)) throw et;
                return et;
            }
            function dg(e) {
                return vt(e).toLowerCase();
            }
            function fg(e) {
                return vt(e).toUpperCase();
            }
            function hg(e, t, r) {
                if (e = vt(e), e && (r || t === u)) return Do(e);
                if (!e || !(t = bn(t))) return e;
                var o = Wn(e), f = Wn(t), w = To(o, f), O = Io(o, f) + 1;
                return kr(o, w, O).join("");
            }
            function pg(e, t, r) {
                if (e = vt(e), e && (r || t === u)) return e.slice(0, Mo(e) + 1);
                if (!e || !(t = bn(t))) return e;
                var o = Wn(e), f = Io(o, Wn(t)) + 1;
                return kr(o, 0, f).join("");
            }
            function mg(e, t, r) {
                if (e = vt(e), e && (r || t === u)) return e.replace(gn, "");
                if (!e || !(t = bn(t))) return e;
                var o = Wn(e), f = To(o, Wn(t));
                return kr(o, f).join("");
            }
            function gg(e, t) {
                var r = z, o = V;
                if (Tt(t)) {
                    var f = "separator" in t ? t.separator : f;
                    r = "length" in t ? Qe(t.length) : r, o = "omission" in t ? bn(t.omission) : o;
                }
                e = vt(e);
                var w = e.length;
                if (gi(e)) {
                    var O = Wn(e);
                    w = O.length;
                }
                if (r >= w) return e;
                var N = r - vi(o);
                if (N < 1) return o;
                var W = O ? kr(O, 0, N).join("") : e.slice(0, N);
                if (f === u) return W + o;
                if (O && (N += W.length - N), io(f)) {
                    if (e.slice(N).search(f)) {
                        var te, re = W;
                        for(f.global || (f = ys(f.source, vt(ii.exec(f)) + "g")), f.lastIndex = 0; te = f.exec(re);)var ie = te.index;
                        W = W.slice(0, ie === u ? N : ie);
                    }
                } else if (e.indexOf(bn(f), N) != N) {
                    var Ee = W.lastIndexOf(f);
                    Ee > -1 && (W = W.slice(0, Ee));
                }
                return W + o;
            }
            function vg(e) {
                return e = vt(e), e && ei.test(e) ? e.replace(Ir, $u) : e;
            }
            var bg = Ei(function(e, t, r) {
                return e + (r ? " " : "") + t.toUpperCase();
            }), oo = Al("toUpperCase");
            function _c(e, t, r) {
                return e = vt(e), t = r ? u : t, t === u ? qu(e) ? Vu(e) : Tu(e) : e.match(t) || [];
            }
            var yc = tt(function(e, t) {
                try {
                    return an(e, u, t);
                } catch (r) {
                    return ro(r) ? r : new Ze(r);
                }
            }), _g = dr(function(e, t) {
                return Jt(t, function(r) {
                    r = Zn(r), cr(e, r, to(e[r], e));
                }), e;
            });
            function yg(e) {
                var t = e == null ? 0 : e.length, r = $e();
                return e = t ? xt(e, function(o) {
                    if (typeof o[1] != "function") throw new Sn(E);
                    return [
                        r(o[0]),
                        o[1]
                    ];
                }) : [], tt(function(o) {
                    for(var f = -1; ++f < t;){
                        var w = e[f];
                        if (an(w[0], this, o)) return an(w[1], this, o);
                    }
                });
            }
            function Ag(e) {
                return $d(xn(e, m));
            }
            function lo(e) {
                return function() {
                    return e;
                };
            }
            function wg(e, t) {
                return e == null || e !== e ? t : e;
            }
            var Sg = Sl(), Eg = Sl(!0);
            function pn(e) {
                return e;
            }
            function co(e) {
                return Qo(typeof e == "function" ? e : xn(e, m));
            }
            function xg(e) {
                return tl(xn(e, m));
            }
            function Cg(e, t) {
                return nl(e, xn(t, m));
            }
            var kg = tt(function(e, t) {
                return function(r) {
                    return na(r, e, t);
                };
            }), Lg = tt(function(e, t) {
                return function(r) {
                    return na(e, r, t);
                };
            });
            function uo(e, t, r) {
                var o = Zt(t), f = Ra(t, o);
                r == null && !(Tt(t) && (f.length || !o.length)) && (r = t, t = e, e = this, f = Ra(t, Zt(t)));
                var w = !(Tt(r) && "chain" in r) || !!r.chain, O = hr(e);
                return Jt(f, function(N) {
                    var W = t[N];
                    e[N] = W, O && (e.prototype[N] = function() {
                        var te = this.__chain__;
                        if (w || te) {
                            var re = e(this.__wrapped__), ie = re.__actions__ = dn(this.__actions__);
                            return ie.push({
                                func: W,
                                args: arguments,
                                thisArg: e
                            }), re.__chain__ = te, re;
                        }
                        return W.apply(e, qn([
                            this.value()
                        ], arguments));
                    });
                }), e;
            }
            function Dg() {
                return Pt._ === this && (Pt._ = Qu), this;
            }
            function fo() {}
            function Tg(e) {
                return e = Qe(e), tt(function(t) {
                    return rl(t, e);
                });
            }
            var Ig = Hs(xt), Og = Hs(Vi), Mg = Hs(hs);
            function Ac(e) {
                return zs(e) ? ps(Zn(e)) : lf(e);
            }
            function Ng(e) {
                return function(t) {
                    return e == null ? u : Gr(e, t);
                };
            }
            var Bg = xl(), Pg = xl(!0);
            function ho() {
                return [];
            }
            function po() {
                return !1;
            }
            function Rg() {
                return {};
            }
            function Fg() {
                return "";
            }
            function qg() {
                return !0;
            }
            function Wg(e, t) {
                if (e = Qe(e), e < 1 || e > Ae) return [];
                var r = ve, o = en(e, ve);
                t = $e(t), e -= ve;
                for(var f = vs(o, t); ++r < e;)t(r);
                return f;
            }
            function Ug(e) {
                return Xe(e) ? xt(e, Zn) : _n(e) ? [
                    e
                ] : dn(Ul(vt(e)));
            }
            function Hg(e) {
                var t = ++Xu;
                return vt(e) + t;
            }
            var jg = ja(function(e, t) {
                return e + t;
            }, 0), $g = js("ceil"), Kg = ja(function(e, t) {
                return e / t;
            }, 1), Gg = js("floor");
            function Vg(e) {
                return e && e.length ? Pa(e, pn, Ls) : u;
            }
            function Yg(e, t) {
                return e && e.length ? Pa(e, $e(t, 2), Ls) : u;
            }
            function zg(e) {
                return ko(e, pn);
            }
            function Zg(e, t) {
                return ko(e, $e(t, 2));
            }
            function Xg(e) {
                return e && e.length ? Pa(e, pn, Os) : u;
            }
            function Jg(e, t) {
                return e && e.length ? Pa(e, $e(t, 2), Os) : u;
            }
            var Qg = ja(function(e, t) {
                return e * t;
            }, 1), ev = js("round"), tv = ja(function(e, t) {
                return e - t;
            }, 0);
            function nv(e) {
                return e && e.length ? gs(e, pn) : 0;
            }
            function rv(e, t) {
                return e && e.length ? gs(e, $e(t, 2)) : 0;
            }
            return v.after = xp, v.ary = Jl, v.assign = fm, v.assignIn = fc, v.assignInWith = ns, v.assignWith = hm, v.at = pm, v.before = Ql, v.bind = to, v.bindAll = _g, v.bindKey = ec, v.castArray = Rp, v.chain = zl, v.chunk = Kf, v.compact = Gf, v.concat = Vf, v.cond = yg, v.conforms = Ag, v.constant = lo, v.countBy = tp, v.create = mm, v.curry = tc, v.curryRight = nc, v.debounce = rc, v.defaults = gm, v.defaultsDeep = vm, v.defer = Cp, v.delay = kp, v.difference = Yf, v.differenceBy = zf, v.differenceWith = Zf, v.drop = Xf, v.dropRight = Jf, v.dropRightWhile = Qf, v.dropWhile = eh, v.fill = th, v.filter = rp, v.flatMap = sp, v.flatMapDeep = op, v.flatMapDepth = lp, v.flatten = Kl, v.flattenDeep = nh, v.flattenDepth = rh, v.flip = Lp, v.flow = Sg, v.flowRight = Eg, v.fromPairs = ih, v.functions = Em, v.functionsIn = xm, v.groupBy = cp, v.initial = sh, v.intersection = oh, v.intersectionBy = lh, v.intersectionWith = ch, v.invert = km, v.invertBy = Lm, v.invokeMap = dp, v.iteratee = co, v.keyBy = hp, v.keys = Zt, v.keysIn = hn, v.map = Za, v.mapKeys = Tm, v.mapValues = Im, v.matches = xg, v.matchesProperty = Cg, v.memoize = Ja, v.merge = Om, v.mergeWith = hc, v.method = kg, v.methodOf = Lg, v.mixin = uo, v.negate = Qa, v.nthArg = Tg, v.omit = Mm, v.omitBy = Nm, v.once = Dp, v.orderBy = pp, v.over = Ig, v.overArgs = Tp, v.overEvery = Og, v.overSome = Mg, v.partial = no, v.partialRight = ic, v.partition = mp, v.pick = Bm, v.pickBy = pc, v.property = Ac, v.propertyOf = Ng, v.pull = hh, v.pullAll = Vl, v.pullAllBy = ph, v.pullAllWith = mh, v.pullAt = gh, v.range = Bg, v.rangeRight = Pg, v.rearg = Ip, v.reject = bp, v.remove = vh, v.rest = Op, v.reverse = Qs, v.sampleSize = yp, v.set = Rm, v.setWith = Fm, v.shuffle = Ap, v.slice = bh, v.sortBy = Ep, v.sortedUniq = xh, v.sortedUniqBy = Ch, v.split = og, v.spread = Mp, v.tail = kh, v.take = Lh, v.takeRight = Dh, v.takeRightWhile = Th, v.takeWhile = Ih, v.tap = Gh, v.throttle = Np, v.thru = za, v.toArray = cc, v.toPairs = mc, v.toPairsIn = gc, v.toPath = Ug, v.toPlainObject = dc, v.transform = qm, v.unary = Bp, v.union = Oh, v.unionBy = Mh, v.unionWith = Nh, v.uniq = Bh, v.uniqBy = Ph, v.uniqWith = Rh, v.unset = Wm, v.unzip = eo, v.unzipWith = Yl, v.update = Um, v.updateWith = Hm, v.values = ki, v.valuesIn = jm, v.without = Fh, v.words = _c, v.wrap = Pp, v.xor = qh, v.xorBy = Wh, v.xorWith = Uh, v.zip = Hh, v.zipObject = jh, v.zipObjectDeep = $h, v.zipWith = Kh, v.entries = mc, v.entriesIn = gc, v.extend = fc, v.extendWith = ns, uo(v, v), v.add = jg, v.attempt = yc, v.camelCase = Vm, v.capitalize = vc, v.ceil = $g, v.clamp = $m, v.clone = Fp, v.cloneDeep = Wp, v.cloneDeepWith = Up, v.cloneWith = qp, v.conformsTo = Hp, v.deburr = bc, v.defaultTo = wg, v.divide = Kg, v.endsWith = Ym, v.eq = Hn, v.escape = zm, v.escapeRegExp = Zm, v.every = np, v.find = ip, v.findIndex = jl, v.findKey = bm, v.findLast = ap, v.findLastIndex = $l, v.findLastKey = _m, v.floor = Gg, v.forEach = Zl, v.forEachRight = Xl, v.forIn = ym, v.forInRight = Am, v.forOwn = wm, v.forOwnRight = Sm, v.get = ao, v.gt = jp, v.gte = $p, v.has = Cm, v.hasIn = so, v.head = Gl, v.identity = pn, v.includes = up, v.indexOf = ah, v.inRange = Km, v.invoke = Dm, v.isArguments = zr, v.isArray = Xe, v.isArrayBuffer = Kp, v.isArrayLike = fn, v.isArrayLikeObject = Ut, v.isBoolean = Gp, v.isBuffer = Lr, v.isDate = Vp, v.isElement = Yp, v.isEmpty = zp, v.isEqual = Zp, v.isEqualWith = Xp, v.isError = ro, v.isFinite = Jp, v.isFunction = hr, v.isInteger = ac, v.isLength = es, v.isMap = sc, v.isMatch = Qp, v.isMatchWith = em, v.isNaN = tm, v.isNative = nm, v.isNil = im, v.isNull = rm, v.isNumber = oc, v.isObject = Tt, v.isObjectLike = Rt, v.isPlainObject = la, v.isRegExp = io, v.isSafeInteger = am, v.isSet = lc, v.isString = ts, v.isSymbol = _n, v.isTypedArray = Ci, v.isUndefined = sm, v.isWeakMap = om, v.isWeakSet = lm, v.join = uh, v.kebabCase = Xm, v.last = kn, v.lastIndexOf = dh, v.lowerCase = Jm, v.lowerFirst = Qm, v.lt = cm, v.lte = um, v.max = Vg, v.maxBy = Yg, v.mean = zg, v.meanBy = Zg, v.min = Xg, v.minBy = Jg, v.stubArray = ho, v.stubFalse = po, v.stubObject = Rg, v.stubString = Fg, v.stubTrue = qg, v.multiply = Qg, v.nth = fh, v.noConflict = Dg, v.noop = fo, v.now = Xa, v.pad = eg, v.padEnd = tg, v.padStart = ng, v.parseInt = rg, v.random = Gm, v.reduce = gp, v.reduceRight = vp, v.repeat = ig, v.replace = ag, v.result = Pm, v.round = ev, v.runInContext = q, v.sample = _p, v.size = wp, v.snakeCase = sg, v.some = Sp, v.sortedIndex = _h, v.sortedIndexBy = yh, v.sortedIndexOf = Ah, v.sortedLastIndex = wh, v.sortedLastIndexBy = Sh, v.sortedLastIndexOf = Eh, v.startCase = lg, v.startsWith = cg, v.subtract = tv, v.sum = nv, v.sumBy = rv, v.template = ug, v.times = Wg, v.toFinite = pr, v.toInteger = Qe, v.toLength = uc, v.toLower = dg, v.toNumber = Ln, v.toSafeInteger = dm, v.toString = vt, v.toUpper = fg, v.trim = hg, v.trimEnd = pg, v.trimStart = mg, v.truncate = gg, v.unescape = vg, v.uniqueId = Hg, v.upperCase = bg, v.upperFirst = oo, v.each = Zl, v.eachRight = Xl, v.first = Gl, uo(v, function() {
                var e = {};
                return Yn(v, function(t, r) {
                    At.call(v.prototype, r) || (e[r] = t);
                }), e;
            }(), {
                chain: !1
            }), v.VERSION = L, Jt([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(e) {
                v[e].placeholder = v;
            }), Jt([
                "drop",
                "take"
            ], function(e, t) {
                st.prototype[e] = function(r) {
                    r = r === u ? 1 : Vt(Qe(r), 0);
                    var o = this.__filtered__ && !t ? new st(this) : this.clone();
                    return o.__filtered__ ? o.__takeCount__ = en(r, o.__takeCount__) : o.__views__.push({
                        size: en(r, ve),
                        type: e + (o.__dir__ < 0 ? "Right" : "")
                    }), o;
                }, st.prototype[e + "Right"] = function(r) {
                    return this.reverse()[e](r).reverse();
                };
            }), Jt([
                "filter",
                "map",
                "takeWhile"
            ], function(e, t) {
                var r = t + 1, o = r == le || r == ue;
                st.prototype[e] = function(f) {
                    var w = this.clone();
                    return w.__iteratees__.push({
                        iteratee: $e(f, 3),
                        type: r
                    }), w.__filtered__ = w.__filtered__ || o, w;
                };
            }), Jt([
                "head",
                "last"
            ], function(e, t) {
                var r = "take" + (t ? "Right" : "");
                st.prototype[e] = function() {
                    return this[r](1).value()[0];
                };
            }), Jt([
                "initial",
                "tail"
            ], function(e, t) {
                var r = "drop" + (t ? "" : "Right");
                st.prototype[e] = function() {
                    return this.__filtered__ ? new st(this) : this[r](1);
                };
            }), st.prototype.compact = function() {
                return this.filter(pn);
            }, st.prototype.find = function(e) {
                return this.filter(e).head();
            }, st.prototype.findLast = function(e) {
                return this.reverse().find(e);
            }, st.prototype.invokeMap = tt(function(e, t) {
                return typeof e == "function" ? new st(this) : this.map(function(r) {
                    return na(r, e, t);
                });
            }), st.prototype.reject = function(e) {
                return this.filter(Qa($e(e)));
            }, st.prototype.slice = function(e, t) {
                e = Qe(e);
                var r = this;
                return r.__filtered__ && (e > 0 || t < 0) ? new st(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), t !== u && (t = Qe(t), r = t < 0 ? r.dropRight(-t) : r.take(t - e)), r);
            }, st.prototype.takeRightWhile = function(e) {
                return this.reverse().takeWhile(e).reverse();
            }, st.prototype.toArray = function() {
                return this.take(ve);
            }, Yn(st.prototype, function(e, t) {
                var r = /^(?:filter|find|map|reject)|While$/.test(t), o = /^(?:head|last)$/.test(t), f = v[o ? "take" + (t == "last" ? "Right" : "") : t], w = o || /^find/.test(t);
                f && (v.prototype[t] = function() {
                    var O = this.__wrapped__, N = o ? [
                        1
                    ] : arguments, W = O instanceof st, te = N[0], re = W || Xe(O), ie = function(at) {
                        var ot = f.apply(v, qn([
                            at
                        ], N));
                        return o && Ee ? ot[0] : ot;
                    };
                    re && r && typeof te == "function" && te.length != 1 && (W = re = !1);
                    var Ee = this.__chain__, Pe = !!this.__actions__.length, Ke = w && !Ee, et = W && !Pe;
                    if (!w && re) {
                        O = et ? O : new st(this);
                        var Ge = e.apply(O, N);
                        return Ge.__actions__.push({
                            func: za,
                            args: [
                                ie
                            ],
                            thisArg: u
                        }), new En(Ge, Ee);
                    }
                    return Ke && et ? e.apply(this, N) : (Ge = this.thru(ie), Ke ? o ? Ge.value()[0] : Ge.value() : Ge);
                });
            }), Jt([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(e) {
                var t = Aa[e], r = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", o = /^(?:pop|shift)$/.test(e);
                v.prototype[e] = function() {
                    var f = arguments;
                    if (o && !this.__chain__) {
                        var w = this.value();
                        return t.apply(Xe(w) ? w : [], f);
                    }
                    return this[r](function(O) {
                        return t.apply(Xe(O) ? O : [], f);
                    });
                };
            }), Yn(st.prototype, function(e, t) {
                var r = v[t];
                if (r) {
                    var o = r.name + "";
                    At.call(Ai, o) || (Ai[o] = []), Ai[o].push({
                        name: t,
                        func: r
                    });
                }
            }), Ai[Ha(u, A).name] = [
                {
                    name: "wrapper",
                    func: u
                }
            ], st.prototype.clone = md, st.prototype.reverse = gd, st.prototype.value = vd, v.prototype.at = Vh, v.prototype.chain = Yh, v.prototype.commit = zh, v.prototype.next = Zh, v.prototype.plant = Jh, v.prototype.reverse = Qh, v.prototype.toJSON = v.prototype.valueOf = v.prototype.value = ep, v.prototype.first = v.prototype.head, zi && (v.prototype[zi] = Xh), v;
        }, bi = Yu();
        Fn ? ((Fn.exports = bi)._ = bi, Rn._ = bi) : Pt._ = bi;
    }).call($ca0c2c480f9252ec$var$Xn);
})($ca0c2c480f9252ec$var$os, $ca0c2c480f9252ec$var$os.exports);
var $ca0c2c480f9252ec$var$iy = $ca0c2c480f9252ec$var$os.exports;
const $ca0c2c480f9252ec$export$61ffd420179cbfa2 = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, id: u, label: L, name: _, value: I, checked: E, state: S, disabled: y = !1, inline: k = !1, ...b }, m)=>{
    const i = $ca0c2c480f9252ec$var$In(u, "radio_____"), a = $ca0c2c480f9252ec$var$$t(b), s = $ca0c2c480f9252ec$var$Yt(b);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$vr, {
        ...k && {
            tagName: "div"
        },
        className: $ca0c2c480f9252ec$var$Oe(k && "d-inline-block", k && "mr-5"),
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
            className: $ca0c2c480f9252ec$var$Oe("br-radio", y && "disabled", S === "invalid" && "invalid", S === "valid" && "valid", l, ...a),
            children: [
                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("input", {
                    ref: m,
                    id: i,
                    type: "radio",
                    name: _,
                    value: I,
                    checked: E,
                    disabled: y,
                    ...s
                }),
                L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                    htmlFor: i,
                    children: L
                }),
                p
            ]
        })
    });
}), $ca0c2c480f9252ec$var$sy = ({ className: l, children: p, id: u, label: L, emptyOptionsMessage: _, options: I, value: E, onChange: S, onChangeOptions: y, onSearchChange: k, searchDebounceTimeout: b = 500, externalFiltering: m = !1, isLoading: i = !1, placeholder: a, type: s = "single", selectAllText: c = "Selecionar todos", hideSelectAll: g = !1, disabled: A = !1, clearable: F = !1, onClear: $, ...J }, se)=>{
    const Q = $ca0c2c480f9252ec$var$In(u, "select_____"), _e = $ca0c2c480f9252ec$var$$t(J), H = $ca0c2c480f9252ec$var$Yt(J), [Y, z] = (0, $jXEQt.useState)(!1), [V, fe] = (0, $jXEQt.useState)(""), [xe, le] = (0, $jXEQt.useState)([]), Ne = (0, $jXEQt.useRef)(E);
    (0, $jXEQt.useEffect)(()=>{
        Ne.current = E;
    }, [
        JSON.stringify(E)
    ]);
    const ue = (0, $jXEQt.useMemo)(()=>{
        var ee;
        return E === null ? void 0 : E === void 0 && Ne.current === void 0 ? s === "multiple" ? xe.map((We)=>We.value) : (ee = xe[0]) == null ? void 0 : ee.value : E === void 0 ? void 0 : Array.isArray(E) ? E.map(String) : String(E);
    }, [
        s,
        JSON.stringify(xe),
        JSON.stringify(E)
    ]), [K, Ae] = (0, $jXEQt.useState)(ue), [we, me] = (0, $jXEQt.useState)(s === "multiple" ? -2 : -1), ve = (0, $jXEQt.useRef)(null), Ce = (0, $jXEQt.useRef)(null), qe = (0, $jXEQt.useRef)(null);
    $ca0c2c480f9252ec$var$ha(se, Ce);
    const Be = (0, $jXEQt.useCallback)(()=>{
        me(s === "multiple" ? -2 : -1);
    }, [
        s
    ]);
    (0, $jXEQt.useEffect)(Be, [
        Be
    ]);
    const Fe = (0, $jXEQt.useCallback)((ee)=>!V.trim() || m ? !0 : ee.label.toLowerCase().indexOf(V.toLowerCase()) !== -1 || String(ee.value).toLowerCase().indexOf(V.toLowerCase()) !== -1, [
        m,
        V
    ]), Re = (0, $jXEQt.useMemo)(()=>I.filter(Fe), [
        I,
        Fe
    ]), ge = (ee)=>{
        var Ye, lt;
        const We = (lt = (Ye = qe.current) == null ? void 0 : Ye.element) == null ? void 0 : lt.querySelectorAll(".br-item")[ee];
        return We instanceof HTMLElement ? We : null;
    }, ne = (ee)=>{
        var We, Ye;
        (Ye = (We = ge(ee)) == null ? void 0 : We.querySelector("input")) == null || Ye.focus();
    }, ut = (ee)=>{
        var We;
        (We = qe.current) == null || We.element.scrollTo({
            top: ee
        });
    }, M = (ee)=>{
        var We;
        return (We = ge(ee)) == null ? void 0 : We.offsetTop;
    }, P = (ee)=>ut(M(ee)), n = ()=>{
        var ee;
        return (ee = ve.current) == null ? void 0 : ee.querySelector("input");
    }, ye = ()=>{
        var ee;
        return (ee = n()) == null ? void 0 : ee.focus();
    }, ke = ()=>{
        var ee;
        return (ee = n()) == null ? void 0 : ee.select();
    }, Me = (0, $jXEQt.useCallback)(()=>Array.isArray(K) ? Re.every((ee)=>K.includes(String(ee.value))) : !1, [
        JSON.stringify(K),
        Re
    ]), ht = (0, $jXEQt.useCallback)(()=>Array.isArray(K) ? !Me() && Re.some((ee)=>K.includes(String(ee.value))) : !1, [
        Me,
        JSON.stringify(K),
        Re
    ]), oe = (0, $jXEQt.useCallback)(()=>{
        let ee = s === "multiple" ? -2 : -1;
        if (typeof K == "string") {
            const We = Re.findIndex((Ye)=>String(Ye.value) === K);
            We !== -1 && (ee = We);
        } else if (Array.isArray(K) && K.length) {
            const We = Re.findIndex((Ye)=>K.includes(String(Ye.value)));
            Me() || We !== -1 && (ee = We);
        }
        me(ee), window.setTimeout(()=>{
            ee < 0 ? ut(0) : P(ee);
        });
    }, [
        Me,
        Re,
        JSON.stringify(K),
        s
    ]), be = (0, $jXEQt.useCallback)(()=>{
        z((ee)=>(ee || oe(), !ee));
    }, [
        oe
    ]), He = (0, $jXEQt.useCallback)(()=>{
        z(!0), oe(), window.setTimeout(()=>{
            ye(), ke();
        }, 1);
    }, [
        oe
    ]), Ie = (0, $jXEQt.useMemo)(()=>k && $ca0c2c480f9252ec$var$iy.debounce(k, b), [
        k,
        b
    ]), pe = (0, $jXEQt.useCallback)(()=>{
        fe(""), z(!1), Be();
    }, [
        Be
    ]);
    $ca0c2c480f9252ec$var$as(Ce, pe);
    const Le = (0, $jXEQt.useCallback)((ee)=>{
        fe(ee.target.value), Ie == null || Ie(ee.target.value), Be(), z(!0);
    }, [
        Ie,
        Be
    ]), Te = (0, $jXEQt.useCallback)((ee)=>{
        var lt, wt;
        const We = Array.isArray(ee) ? ee : [
            ee
        ], Ye = [];
        We.forEach((Mt)=>{
            const jt = Re.find((cn)=>String(cn.value) === Mt) ?? xe.find((cn)=>String(cn.value) === Mt);
            jt && Ye.push({
                label: jt.label,
                value: Mt
            });
        }), JSON.stringify(xe) !== JSON.stringify(Ye) && (le(Ye), typeof ((lt = Re[0]) == null ? void 0 : lt.value) == "string" && (y == null || y(Ye)), typeof ((wt = Re[0]) == null ? void 0 : wt.value) == "number" && (y == null || y(Ye.map((Mt)=>({
                ...Mt,
                value: Number(Mt.value)
            })))));
    }, [
        Re,
        JSON.stringify(xe),
        y
    ]), It = (0, $jXEQt.useCallback)((ee)=>{
        var We, Ye;
        Ae(ee), Te(ee), z(!1), fe(""), typeof ((We = Re[0]) == null ? void 0 : We.value) == "string" && (S == null || S(ee)), typeof ((Ye = Re[0]) == null ? void 0 : Ye.value) == "number" && (S == null || S(+ee));
    }, [
        Re,
        S,
        Te
    ]), je = (0, $jXEQt.useCallback)((ee, We)=>{
        var wt, Mt;
        let Ye;
        if (!Array.isArray(K)) return;
        if (ee) {
            if (K.indexOf(We) !== -1) return;
            Ye = [
                ...K,
                We
            ];
        } else Ye = K.filter((jt)=>jt !== We);
        Ae(Ye), Te(Ye), typeof ((wt = Re[0]) == null ? void 0 : wt.value) == "string" && (S == null || S(Ye)), typeof ((Mt = Re[0]) == null ? void 0 : Mt.value) == "number" && (S == null || S(Ye.map(Number)));
        const lt = Re.findIndex((jt)=>String(jt.value) === We);
        me(lt);
    }, [
        JSON.stringify(K),
        Re,
        S,
        Te
    ]), Ot = (0, $jXEQt.useCallback)((ee)=>{
        var wt, Mt;
        if (!Array.isArray(K)) return;
        const We = Re.map((jt)=>String(jt.value)), Ye = K.filter((jt)=>!We.includes(jt)), lt = ee ? [
            ...Ye,
            ...We
        ] : Ye;
        Ae(lt), Te(lt), typeof ((wt = Re[0]) == null ? void 0 : wt.value) == "string" && (S == null || S(lt)), typeof ((Mt = Re[0]) == null ? void 0 : Mt.value) == "number" && (S == null || S(lt.map(Number))), me(-1);
    }, [
        JSON.stringify(K),
        Re,
        S,
        Te
    ]);
    (0, $jXEQt.useEffect)(()=>{
        Ae(ue), typeof ue == "string" || Array.isArray(ue) && ue.length ? Te(ue) : Te([]);
    }, [
        JSON.stringify(ue),
        Te
    ]);
    const Kt = (0, $jXEQt.useMemo)(()=>{
        if (!xe.length) return "";
        const [ee] = xe;
        let We = ee.label;
        return xe.length >= 2 && (We += `+ (${xe.length - 1})`), We;
    }, [
        JSON.stringify(xe)
    ]), yt = (0, $jXEQt.useMemo)(()=>s === "multiple" && !!c && !g, [
        g,
        c,
        s
    ]), qt = (0, $jXEQt.useCallback)((ee)=>ee.target instanceof HTMLInputElement && ee.target.getAttribute("type") === "text", []), zt = (0, $jXEQt.useCallback)((ee)=>{
        var We, Ye, lt, wt;
        if (ee.key === "Enter") {
            if (ee.preventDefault(), ee.target instanceof HTMLElement && !qt(ee) && ee.target.click(), !qt(ee)) return;
            we >= 0 && yt ? (Ye = (We = ge(we + 1)) == null ? void 0 : We.querySelector("input")) == null || Ye.click() : we >= 0 && !yt && ((wt = (lt = ge(we)) == null ? void 0 : lt.querySelector("input")) == null || wt.click());
        } else if (ee.key === "ArrowDown") {
            if (ee.preventDefault(), z(!0), we === Re.length - 1) return;
            if (s === "multiple" && !yt && we === -2) {
                ne(0), me(0);
                return;
            }
            ne(s === "multiple" && yt ? we + 2 : we + 1), me(we + 1);
        } else if (ee.key === "ArrowUp") {
            if (ee.preventDefault(), z(!0), s === "multiple" && yt && we <= -1 || s === "multiple" && !yt && we <= 0 || s === "single" && we <= 0) {
                ye(), window.setTimeout(()=>ut(0)), me(s === "multiple" ? -2 : -1);
                return;
            }
            ne(s === "multiple" && yt ? we : we - 1), me(we - 1);
        } else ee.key === " " && ee.target instanceof HTMLElement && !qt(ee) ? (ee.preventDefault(), ee.target.click()) : ee.key === "Escape" || ee.key === "Tab" ? pe() : ee.key === "Home" && !qt(ee) ? (ee.preventDefault(), ne(0), me(yt ? -1 : 0)) : ee.key === "End" && !qt(ee) && (ee.preventDefault(), ne(yt ? Re.length : Re.length - 1), me(Re.length - 1));
    }, [
        qt,
        pe,
        we,
        Re,
        yt,
        s
    ]), On = (0, $jXEQt.useCallback)(()=>{
        $ == null || $(), Te([]), Ae(s === "single" ? "" : []);
    }, [
        $,
        Te,
        s
    ]);
    return (0, $jXEQt.useEffect)(()=>{
        i && !A && z(!0);
    }, [
        i,
        A
    ]), (0, $jXEQt.useEffect)(()=>{
        A && z(!1);
    }, [
        A
    ]), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        ref: Ce,
        ...H,
        className: $ca0c2c480f9252ec$var$Oe("br-select", l, ..._e),
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                ref: ve,
                className: "br-input",
                children: [
                    L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                        htmlFor: Q,
                        children: L
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("input", {
                        onFocus: He,
                        id: `${Q}_____select`,
                        type: "text",
                        "data-value": E,
                        "data-displayvalue": Kt,
                        value: Y ? V : Kt,
                        onChange: Le,
                        placeholder: a,
                        onKeyDown: zt,
                        disabled: A,
                        className: $ca0c2c480f9252ec$var$Oe({
                            disabled: A
                        }),
                        autoComplete: "off"
                    }),
                    Kt && F && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                        icon: "times",
                        className: "mr-5",
                        size: "small",
                        circle: !0,
                        "aria-label": "Limpar",
                        disabled: A,
                        onClick: On,
                        onKeyDown: zt
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                        icon: "angle-down",
                        size: "small",
                        circle: !0,
                        "aria-label": "Exibir lista",
                        tabIndex: -1,
                        disabled: A,
                        "data-trigger": "data-trigger",
                        onClick: be,
                        onKeyDown: zt
                    })
                ]
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$eeb4c6bba1899f38, {
                tabIndex: 0,
                role: "combobox",
                expanded: Y || i,
                ref: qe,
                onKeyDown: zt,
                children: [
                    !i && s === "multiple" && yt && !!Re.length && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$2777d0c1887e5f7b, {
                        tabIndex: -1,
                        divider: !0,
                        "data-all": "data-all",
                        role: "option",
                        className: $ca0c2c480f9252ec$var$Oe({
                            selected: Me(),
                            "focus-visible": we === -1
                        }),
                        onClick: (ee)=>{
                            ee.preventDefault(), ee.stopPropagation(), Ot(!Me());
                        },
                        style: {
                            position: "relative",
                            cursor: "pointer"
                        },
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f08e1e7271ffbd67, {
                            id: `${Q}____`,
                            tabIndex: -1,
                            label: c,
                            checked: Me(),
                            indeterminate: ht(),
                            readOnly: !0
                        })
                    }),
                    i && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$2777d0c1887e5f7b, {
                        divider: !0,
                        role: "status",
                        "aria-label": "Carregando",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$48493b3d35ec1140, {})
                    }),
                    !i && !Re.length && _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$2777d0c1887e5f7b, {
                        role: "note",
                        divider: !0,
                        "aria-label": _,
                        children: _
                    }),
                    !i && Re.map((ee, We)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)($ca0c2c480f9252ec$export$2777d0c1887e5f7b, {
                            p: s === "single" ? 0 : void 0,
                            onClick: (Ye)=>{
                                Ye.preventDefault(), Ye.stopPropagation(), s === "single" ? It(String(ee.value)) : je(!(K != null && K.includes(String(ee.value))), String(ee.value));
                            },
                            divider: !0,
                            role: "option",
                            className: $ca0c2c480f9252ec$var$Oe({
                                selected: K === String(ee.value) || Array.isArray(K) && K.length > 0 && K.indexOf(String(ee.value)) !== -1,
                                "focus-visible": We === we
                            }),
                            ...We === we && {
                                "data-focus-visible": "data-focus-visible"
                            },
                            style: {
                                position: "relative",
                                cursor: "pointer"
                            },
                            children: [
                                s === "single" && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$61ffd420179cbfa2, {
                                    id: `${Q}____${ee.value}`,
                                    name: Q,
                                    label: ee.label,
                                    checked: K === String(ee.value),
                                    value: String(ee.value),
                                    readOnly: !0,
                                    style: {
                                        top: 0,
                                        height: "100%"
                                    }
                                }),
                                s === "multiple" && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f08e1e7271ffbd67, {
                                    id: `${Q}____${ee.value}`,
                                    tabIndex: -1,
                                    name: String(ee.value),
                                    label: ee.label,
                                    checked: (K == null ? void 0 : K.length) > 0 && (K == null ? void 0 : K.indexOf(String(ee.value))) !== -1,
                                    value: String(ee.value),
                                    readOnly: !0,
                                    style: {
                                        top: 0,
                                        height: "100%"
                                    }
                                })
                            ]
                        }, ee.value))
                ]
            }),
            p
        ]
    });
}, $ca0c2c480f9252ec$var$oy = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef($ca0c2c480f9252ec$var$sy), $ca0c2c480f9252ec$export$472b15cae7bbc1c1 = (0, $jXEQt.memo)($ca0c2c480f9252ec$var$oy);
$ca0c2c480f9252ec$export$472b15cae7bbc1c1.displayName = "BrSelect";
const $ca0c2c480f9252ec$export$b24dcdfd84a7a52a = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, id: p, total: u, current: L = 1, perPage: _ = 20, perPageOptions: I, perPageOptionsDisabled: E = !1, onPageChange: S, onPerPageChange: y, showTotalizers: k = !1, showGoToPage: b = !1, darkMode: m = !1, itemTitleSingular: i = "item", itemTitlePlural: a = "itens", ...s }, c)=>{
    const g = $ca0c2c480f9252ec$var$In(p, "pagination_____"), A = $ca0c2c480f9252ec$var$$t(s), F = $ca0c2c480f9252ec$var$Yt(s), $ = Math.ceil(u / _), J = (L - 1) * _ + 1, se = Math.min(L * _, u), Q = (H)=>{
        H >= 1 && H <= $ && H !== L && (S == null || S(H));
    }, _e = (H)=>{
        H !== _ && (y == null || y(H));
    };
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("nav", {
        ref: c,
        id: g,
        className: $ca0c2c480f9252ec$var$Oe("br-pagination", m && "dark-mode", ...A, l),
        "aria-label": "pagina\xe7\xe3o",
        "data-total": u,
        "data-current": L,
        "data-per-page": _,
        ...F,
        children: [
            !!(I != null && I.length) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "pagination-per-page",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$472b15cae7bbc1c1, {
                    label: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                        className: $ca0c2c480f9252ec$var$Oe(E && "disabled"),
                        children: "Exibir"
                    }),
                    options: I.map((H)=>({
                            label: String(H),
                            value: H
                        })),
                    value: _,
                    placeholder: String(_),
                    onChange: _e,
                    disabled: E
                })
            }),
            !!(I != null && I.length) && k && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1cb26bd41bda552d, {
                className: "d-none d-sm-block mx-3"
            }),
            k && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "pagination-information d-none d-sm-flex",
                children: u ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
                    children: [
                        u > 1 && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
                            children: [
                                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: "current",
                                    children: J
                                }),
                                "\u2013",
                                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: "per-page",
                                    children: se
                                }),
                                "\xa0de\xa0"
                            ]
                        }),
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                            className: "total",
                            children: u
                        }),
                        "\xa0",
                        u > 1 ? a : i
                    ]
                }) : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                    className: "empty",
                    children: "Nenhum item"
                })
            }),
            b && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "pagination-go-to-page d-none d-sm-flex ml-auto",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$472b15cae7bbc1c1, {
                    label: $ ? "P\xe1gina" : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                        className: "disabled",
                        children: "P\xe1gina"
                    }),
                    disabled: !$,
                    options: Array.from({
                        length: $
                    }, (H, Y)=>({
                            label: String(Y + 1),
                            value: Y + 1
                        })),
                    value: L,
                    placeholder: String(L),
                    onChange: Q
                })
            }),
            b && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1cb26bd41bda552d, {
                className: "d-none d-sm-block mx-3"
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                className: "pagination-arrows ml-auto ml-sm-0",
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                        circle: !0,
                        type: "button",
                        "aria-label": "Voltar p\xe1gina",
                        disabled: L <= 1,
                        onClick: ()=>Q(L - 1),
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                            icon: "angle-left"
                        })
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                        circle: !0,
                        type: "button",
                        "aria-label": "P\xe1gina seguinte",
                        disabled: L >= $,
                        onClick: ()=>Q(L + 1),
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                            icon: "angle-right"
                        })
                    })
                ]
            })
        ]
    });
}), $ca0c2c480f9252ec$export$da7d31d33770ea05 = (l)=>{
    const { name: p, title: u, info: L, disabled: _, inline: I, inlineMargin: E = 3, options: S, value: y, onChange: k } = l, b = $ca0c2c480f9252ec$var$Oe("br-radio", _ && "disabled", I && `d-inline-block mr-${E}`);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
        children: [
            u && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("p", {
                className: `label mb-${L ? 1 : 3}`,
                children: u
            }),
            L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("p", {
                className: "help-text",
                children: L
            }),
            S.map((m)=>{
                const i = `${p}-${m.id ? m.id : $ca0c2c480f9252ec$var$Ti("name-")}`;
                return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: b,
                    children: [
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("input", {
                            id: i,
                            type: "radio",
                            name: p,
                            value: m.value,
                            checked: m.value === y,
                            onChange: k,
                            disabled: m.disabled
                        }),
                        m.label && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                            htmlFor: i,
                            children: m.label
                        })
                    ]
                }, i);
            })
        ]
    });
}, $ca0c2c480f9252ec$export$943ea52c7c20a95c = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ label: l, placeholder: p, options: u, value: L, onChange: _, onMouseOver: I, onMouseOut: E, onFocus: S, onBlur: y, ...k }, b)=>{
    const m = $ca0c2c480f9252ec$var$Ti("select-"), [i, a] = (0, $jXEQt.useState)(L);
    (0, $jXEQt.useEffect)(()=>a(L), [
        L
    ]);
    const s = (0, $jXEQt.useMemo)(()=>({
            backgroundColor: "var(--background-light)",
            borderColor: "var(--border-color-alternative)",
            borderRadius: "var(--surface-rounder-sm)",
            borderStyle: "var(--border-style)",
            borderWidth: "var(--border-width)",
            color: "var(--color-light)",
            fontSize: "var(--font-size-scale-up-01)",
            height: "var(--input-size)",
            marginTop: "var(--spacing-scale-half)",
            paddingBottom: 0,
            paddingLeft: "var(--spacing-scale-2x)",
            paddingRight: "var(--spacing-scale-2x)",
            paddingTop: 0,
            width: "100%",
            fontStyle: i ? "normal" : "italic",
            fontWeight: i ? "var(--font-weight-medium)" : "var(--font-weight-regular)",
            outline: "none"
        }), [
        i
    ]), c = (0, $jXEQt.useCallback)(()=>A({
            ...s
        }), [
        s
    ]), [g, A] = (0, $jXEQt.useState)(s), F = (0, $jXEQt.useCallback)((H)=>{
        const Y = H.currentTarget.value;
        a(Y), _ == null || _(H);
    }, [
        _
    ]), $ = (0, $jXEQt.useCallback)((H)=>{
        A({
            ...s,
            backgroundImage: "linear-gradient(rgba(var(--color-rgb), var(--hover)),rgba(var(--color-rgb), var(--hover)))"
        }), I == null || I(H);
    }, [
        s,
        I
    ]), J = (0, $jXEQt.useCallback)((H)=>{
        c(), E == null || E(H);
    }, [
        c,
        E
    ]), se = (0, $jXEQt.useCallback)((H)=>{
        A({
            ...s,
            borderColor: "var(--focus) !important",
            boxShadow: "0 0 0 var(--surface-width-md) var(--focus)",
            outline: "none"
        }), S == null || S(H);
    }, [
        s,
        S
    ]), Q = (0, $jXEQt.useCallback)((H)=>{
        c(), y == null || y(H);
    }, [
        c,
        y
    ]), _e = (0, $jXEQt.useMemo)(()=>u.map((H)=>typeof H == "string" ? /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("option", {
                style: {
                    fontStyle: "normal"
                },
                className: "text-weight-semi-bold",
                value: H,
                children: H
            }, H) : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("option", {
                style: {
                    fontStyle: "normal"
                },
                className: "text-weight-semi-bold",
                value: H.value,
                children: H.label
            }, H.value)), [
        u
    ]);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: "br-input",
        children: [
            l && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                htmlFor: m,
                children: l
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("select", {
                ref: b,
                style: g,
                id: m,
                value: i,
                onChange: F,
                onMouseOver: $,
                onMouseOut: J,
                onFocus: se,
                onBlur: Q,
                ...k,
                children: [
                    p && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("option", {
                        style: {
                            fontStyle: "italic"
                        },
                        value: "",
                        children: p
                    }),
                    _e
                ]
            })
        ]
    });
}), $ca0c2c480f9252ec$var$cy = `.br-skeleton{background:var(--background-alternative);background:linear-gradient(110deg,var(--interactive-dark) 8%,var(--background-alternative) 18%,var(--interactive-dark) 33%);background-size:200% 100%;animation:1.5s shine linear infinite}.br-skeleton.circular{border-radius:50%}@keyframes shine{to{background-position-x:-200%}}
`;
function $ca0c2c480f9252ec$export$8ae416b7a4094b13({ width: l = "100%", height: p, variant: u = "rectangular", className: L }) {
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("style", {
                children: $ca0c2c480f9252ec$var$cy
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                style: {
                    width: l,
                    height: p
                },
                className: $ca0c2c480f9252ec$var$Oe("br-skeleton", L, u === "circular" && "circular")
            })
        ]
    });
}
const $ca0c2c480f9252ec$export$a360cb965241c5e5 = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, data: u, full: L = !1, ..._ }, I)=>{
    const E = $ca0c2c480f9252ec$var$$t(_), S = $ca0c2c480f9252ec$var$Yt(_);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("nav", {
        ref: I,
        className: $ca0c2c480f9252ec$var$Oe("br-skiplink", L && "full", l, ...E),
        ...S,
        children: [
            u.map((y, k)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("a", {
                    className: "br-item",
                    href: y.link,
                    accessKey: String(k),
                    children: [
                        y.label,
                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                            className: "br-tag text ml-1",
                            children: k
                        })
                    ]
                }, k)),
            p
        ]
    });
}), $ca0c2c480f9252ec$export$de3e26636298e5a = (l)=>{
    const { children: p, dense: u, items: L, activeIndex: _, onChange: I } = l;
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: $ca0c2c480f9252ec$var$Oe("br-tab", u && "large"),
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("nav", {
                className: "tab-nav",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("ul", {
                    children: L.length && L.map((E, S)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("li", {
                            className: $ca0c2c480f9252ec$var$Oe("tab-item", {
                                "is-active": S === _
                            }),
                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                type: "button",
                                "aria-label": E,
                                onClick: ()=>I(S),
                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: "name",
                                    children: E
                                })
                            })
                        }, S))
                })
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "tab-content",
                children: p
            })
        ]
    });
}, $ca0c2c480f9252ec$export$48c0f5a482c2b4b = (l)=>{
    const { children: p, index: u, activeIndex: L, ..._ } = l, I = $ca0c2c480f9252ec$var$Oe("tab-panel", {
        "is-active": u === L
    });
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: I,
        ..._,
        children: p
    });
};
function $ca0c2c480f9252ec$var$uy(l) {
    return l ? l === "asc" ? "sort-up" : "sort-down" : "sort";
}
function $ca0c2c480f9252ec$var$dy(l) {
    return l ? l === "asc" ? "desc" : null : "asc";
}
function $ca0c2c480f9252ec$var$fy(l) {
    return l === "asc" ? "ascending" : l === "desc" ? "descending" : "none";
}
function $ca0c2c480f9252ec$var$hy({ data: l, columns: p, title: u, expandable: L, selectable: _, id: I, selectedRows: E, isLoading: S, loadingMode: y = "default", loadingSkeletonRows: k = 1, loadingSkeletonHeight: b = 40, loadingContent: m, emptyContent: i, handleSelectAll: a, handleRowSelect: s, onRowCollapse: c, onRowExpand: g, renderExpandedContent: A }) {
    const [F, $] = (0, $jXEQt.useState)(/* @__PURE__ */ new Set()), J = l.length > 0 && E.length === l.length, se = E.length > 0 && E.length < l.length, Q = (0, $jXEQt.useMemo)(()=>p.length + (_ ? 1 : 0) + (L ? 1 : 0), [
        p.length,
        _,
        L
    ]), _e = (H, Y)=>{
        const z = new Set(F), V = F.has(Y);
        V ? z.delete(Y) : z.add(Y), $(z), V ? c == null || c(H) : g == null || g(H);
    };
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("table", {
        children: [
            u && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("caption", {
                children: u
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("thead", {
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("tr", {
                    children: [
                        L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                            style: {
                                width: 80
                            },
                            className: "column-collapse",
                            scope: "col",
                            "aria-hidden": "true"
                        }),
                        _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("th", {
                            className: "column-checkbox",
                            scope: "col",
                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f08e1e7271ffbd67, {
                                id: `check-all-${I}`,
                                checked: J,
                                indeterminate: se,
                                onChange: (H)=>a(H.target.checked),
                                "aria-label": "Selecionar tudo",
                                disabled: S
                            })
                        }),
                        p.map((H, Y)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("th", {
                                scope: "col",
                                align: H.align,
                                style: {
                                    width: H.width
                                },
                                className: $ca0c2c480f9252ec$var$Oe({
                                    "text-bold": H.boldHeading
                                }),
                                "aria-sort": H.sortable ? $ca0c2c480f9252ec$var$fy(H.sortable.direction) : void 0,
                                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                    className: $ca0c2c480f9252ec$var$Oe("d-flex", "align-items-center", H.align === "center" && "justify-content-center", H.align === "right" && "justify-content-end"),
                                    children: [
                                        H.title,
                                        H.sortable && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                            icon: $ca0c2c480f9252ec$var$uy(H.sortable.direction),
                                            circle: !0,
                                            size: "small",
                                            "aria-label": `Ordenar por ${H.title}`,
                                            title: `Ordenar por ${H.title}`,
                                            className: "ml-1",
                                            disabled: S,
                                            onClick: ()=>{
                                                var z, V;
                                                H.sortable && ((V = (z = H.sortable).onSortChange) == null || V.call(z, $ca0c2c480f9252ec$var$dy(H.sortable.direction)));
                                            }
                                        })
                                    ]
                                })
                            }, `header-${Y}-${String(H.key)}`))
                    ]
                })
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("tbody", {
                children: [
                    S && y === "default" && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("tr", {
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                            colSpan: Q,
                            align: "center",
                            children: m || /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$48493b3d35ec1140, {})
                        })
                    }),
                    S && y === "skeleton" && Array.from({
                        length: k
                    }, (H, Y)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("tr", {
                            children: [
                                L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                                    children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$8ae416b7a4094b13, {
                                        width: 32,
                                        height: b
                                    })
                                }),
                                _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                                    children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$8ae416b7a4094b13, {
                                        height: b
                                    })
                                }),
                                Array.from({
                                    length: p.length
                                }).map((z, V)=>{
                                    var fe, xe, le, Ne;
                                    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                                        "data-th": (fe = p[V]) == null ? void 0 : fe.title,
                                        align: (xe = p[V]) == null ? void 0 : xe.align,
                                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$8ae416b7a4094b13, {
                                            width: !((le = p[V]) != null && le.title) && Number.isInteger((Ne = p[V]) == null ? void 0 : Ne.width) ? p[V].width : void 0,
                                            height: b
                                        })
                                    }, `skeleton-cell-${Y}-${V}`);
                                })
                            ]
                        }, `skeleton-row-${Y}`)),
                    !S && !l.length && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("tr", {
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                            colSpan: Q,
                            align: "center",
                            children: i || "Nenhum dado dispon\xedvel."
                        })
                    }),
                    !S && l.map((H, Y)=>{
                        var z;
                        return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).Fragment, {
                            children: [
                                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("tr", {
                                    children: [
                                        L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                                icon: F.has(Y) ? "chevron-up" : "chevron-down",
                                                circle: !0,
                                                size: "small",
                                                type: "button",
                                                "aria-label": `Expandir/Retrair ${H[(z = p[0]) == null ? void 0 : z.key] ?? "linha"}`,
                                                onClick: ()=>_e(H, Y)
                                            })
                                        }),
                                        _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f08e1e7271ffbd67, {
                                                id: `check-line-${Y}-${I}`,
                                                checked: E.includes(H),
                                                onChange: (V)=>s(H, V.target.checked),
                                                "aria-label": `Selecionar linha ${Y + 1}`
                                            })
                                        }),
                                        p.map((V, fe)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                                                "data-th": V.title,
                                                align: V.align,
                                                style: {
                                                    width: V.width
                                                },
                                                children: V.render ? V.render(H[V.key], H, Y) : String(H[V.key] ?? "")
                                            }, `cell-${Y}-${fe}-${String(V.key)}`))
                                    ]
                                }),
                                L && F.has(Y) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("tr", {
                                    className: "collapse",
                                    children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("td", {
                                        id: `collapse-${Y}-${I}`,
                                        "aria-hidden": "false",
                                        hidden: !1,
                                        colSpan: p.length + (_ ? 1 : 0) + (L ? 1 : 0),
                                        children: A == null ? void 0 : A(H)
                                    })
                                })
                            ]
                        }, `row-${Y}`);
                    })
                ]
            })
        ]
    });
}
function $ca0c2c480f9252ec$var$py({ title: l, tableActions: p, searchable: u, selectable: L, selectedActions: _, selectedRows: I, onSearch: E }) {
    const [S, y] = (0, $jXEQt.useState)(!1), [k, b] = (0, $jXEQt.useState)(""), m = (0, $jXEQt.useRef)(null), i = (0, $jXEQt.useCallback)(()=>E == null ? void 0 : E(k), [
        E,
        k
    ]), a = (0, $jXEQt.useCallback)(()=>{
        y(!1), b(""), k && (E == null || E(""));
    }, [
        E,
        k
    ]), s = (0, $jXEQt.useCallback)((c)=>{
        c.key === "Enter" && i(), c.key === "Escape" && a();
    }, [
        a,
        i
    ]);
    return (0, $jXEQt.useEffect)(()=>{
        var c;
        u && S && ((c = m.current) == null || c.focus());
    }, [
        u,
        S
    ]), !l && !(p != null && p.length) && !u && !(L && I.length > 0) ? null : /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: "table-header",
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                className: "top-bar",
                children: [
                    l && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "table-title",
                        children: l
                    }),
                    !!(p != null && p.length) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "actions-trigger text-nowrap",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                            icon: "ellipsis-v",
                            circle: !0,
                            type: "button",
                            title: "Ver mais op\xe7\xf5es",
                            "aria-label": "Ver mais op\xe7\xf5es",
                            dropdownItems: p.map((c, g)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                            "aria-selected": !0,
                                            onClick: (A)=>{
                                                c.keepExpanded && (A.preventDefault(), A.stopPropagation()), c.onClick();
                                            },
                                            isItem: !0,
                                            isItemSelected: c.selected,
                                            children: c.label
                                        }),
                                        g + 1 === p.length && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1cb26bd41bda552d, {})
                                    ]
                                }, g))
                        })
                    }),
                    u && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "search-trigger",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                            icon: "search",
                            "data-toggle": "search",
                            circle: !0,
                            type: "button",
                            "aria-label": "Abrir busca",
                            onClick: ()=>y(!0)
                        })
                    })
                ]
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                className: $ca0c2c480f9252ec$var$Oe("search-bar", "bg-secondary-01", {
                    show: u && S
                }),
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1c89cc3d2b5965be, {
                        ref: m,
                        label: "Buscar na tabela",
                        placeholder: "Buscar na tabela",
                        value: k,
                        onChange: (c)=>b(c.target.value),
                        onKeyUp: s,
                        button: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                            icon: "search",
                            type: "submit",
                            onClick: i,
                            "aria-label": "Pesquisar"
                        })
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                        icon: "times",
                        circle: !0,
                        type: "button",
                        "aria-label": "Fechar busca",
                        onClick: a
                    })
                ]
            }),
            L && I.length > 0 && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                className: $ca0c2c480f9252ec$var$Oe("selected-bar", {
                    show: I.length > 0
                }),
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        className: "info",
                        children: [
                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                className: "count",
                                children: I.length
                            }),
                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                className: "text",
                                children: [
                                    I.length > 1 ? "itens" : "item",
                                    " selecionado",
                                    I.length > 1 ? "s" : ""
                                ]
                            })
                        ]
                    }),
                    !!(_ != null && _.length) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: "actions-trigger text-nowrap",
                        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                            icon: "ellipsis-v",
                            circle: !0,
                            inverted: !0,
                            type: "button",
                            title: "Ver mais op\xe7\xf5es de a\xe7\xe3o",
                            "aria-label": "Ver mais op\xe7\xf5es de a\xe7\xe3o",
                            dropdownDirection: "left",
                            dropdownItems: _.map((c, g)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$30a931fe40eb4795, {
                                            onClick: (A)=>{
                                                c.keepExpanded && (A.preventDefault(), A.stopPropagation()), c.onClick(I);
                                            },
                                            isItem: !0,
                                            isItemSelected: c.selected,
                                            children: c.label
                                        }),
                                        g + 1 === _.length && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$1cb26bd41bda552d, {})
                                    ]
                                }, g))
                        })
                    })
                ]
            })
        ]
    });
}
const $ca0c2c480f9252ec$export$7923588490c50f77 = (l)=>{
    const { className: p, id: u, data: L, columns: _, title: I, selectable: E = !1, expandable: S = !1, searchable: y = !1, density: k = "medium", tableActions: b, selectedActions: m, paginationProps: i, isLoading: a = !1, loadingMode: s = "default", loadingSkeletonRows: c = 1, loadingSkeletonHeight: g = 40, loadingContent: A, emptyContent: F, renderExpandedContent: $, onRowSelect: J, onRowExpand: se, onRowCollapse: Q, onSearch: _e, ...H } = l, Y = $ca0c2c480f9252ec$var$In(u, "table_____"), z = $ca0c2c480f9252ec$var$$t(H), V = $ca0c2c480f9252ec$var$Yt(H), fe = (i == null ? void 0 : i.page) ?? 1, [xe, le] = (0, $jXEQt.useState)(fe), Ne = (i == null ? void 0 : i.perPage) ?? 20, [ue, K] = (0, $jXEQt.useState)(Ne), Ae = (i == null ? void 0 : i.total) ?? L.length, [we, me] = (0, $jXEQt.useState)([]);
    (0, $jXEQt.useEffect)(()=>K(Ne), [
        Ne
    ]), (0, $jXEQt.useEffect)(()=>le(fe), [
        fe
    ]);
    const ve = (qe)=>{
        const Be = qe ? [
            ...L
        ] : [];
        me(Be), J == null || J(Be);
    }, Ce = (qe, Be)=>{
        const Fe = Be ? [
            ...we,
            qe
        ] : we.filter((Re)=>Re !== qe);
        me(Fe), J == null || J(Fe);
    };
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        id: Y,
        className: $ca0c2c480f9252ec$var$Oe("br-table", p, {
            [k]: k !== "medium"
        }, ...z),
        "data-search": y,
        "data-selection": E,
        "data-collapse": S,
        ...V,
        children: [
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$py, {
                title: I,
                searchable: y,
                selectable: E,
                selectedActions: m,
                tableActions: b,
                selectedRows: we,
                onSearch: _e
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$var$hy, {
                data: L,
                columns: _,
                title: I,
                expandable: S,
                selectable: E,
                id: Y,
                selectedRows: we,
                isLoading: a,
                loadingMode: s,
                loadingSkeletonRows: c,
                loadingSkeletonHeight: g,
                loadingContent: A,
                emptyContent: F,
                handleSelectAll: ve,
                handleRowSelect: Ce,
                onRowCollapse: Q,
                onRowExpand: se,
                renderExpandedContent: $
            }),
            i && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "table-footer",
                children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$b24dcdfd84a7a52a, {
                    total: Ae,
                    current: xe,
                    perPage: ue,
                    onPageChange: (qe)=>{
                        var Be;
                        le(qe), (Be = i == null ? void 0 : i.onPageChange) == null || Be.call(i, qe);
                    },
                    onPerPageChange: (qe)=>{
                        var Be, Fe;
                        K(qe), (Be = i == null ? void 0 : i.onPerPageChange) == null || Be.call(i, qe), le(1), (Fe = i == null ? void 0 : i.onPageChange) == null || Fe.call(i, 1);
                    },
                    perPageOptions: i == null ? void 0 : i.perPageOptions,
                    perPageOptionsDisabled: a || !Ae,
                    showTotalizers: !a && Ae > 0 && (i == null ? void 0 : i.showTotalizers),
                    itemTitleSingular: i.itemTitleSingular,
                    itemTitlePlural: i.itemTitlePlural,
                    showGoToPage: !0
                })
            })
        ]
    });
}, $ca0c2c480f9252ec$var$my = "_clickableTag_18bzx_1", $ca0c2c480f9252ec$var$gy = {
    clickableTag: $ca0c2c480f9252ec$var$my
}, $ca0c2c480f9252ec$var$vy = (l)=>{
    const p = +l;
    return l.length <= 3 ? p : Number.isInteger(p) ? "999+" : p.toLocaleString("pt-br").slice(0, 3) + " ...";
}, $ca0c2c480f9252ec$var$Wc = (l)=>[
        "text",
        "icon",
        "interaction"
    ].includes(l), $ca0c2c480f9252ec$export$4cbe3e0258659240 = (l)=>{
    const { value: p, type: u = "text", color: L = "primary-default", size: _, icon: I, style: E, className: S, onClick: y, checked: k, onChange: b } = l, m = $ca0c2c480f9252ec$var$Oe("br-tag", u, L, !!_ && _, !!y && $ca0c2c480f9252ec$var$gy.clickableTag, u === "interaction" && "interaction-select", S), i = u === "count" && p ? $ca0c2c480f9252ec$var$vy(p) : p;
    switch(u){
        case "status":
            return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                style: E,
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                        className: m
                    }),
                    i && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                        children: i
                    })
                ]
            });
        case "interaction":
            return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                className: m,
                style: E,
                children: [
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("input", {
                        id: "tag",
                        type: "checkbox",
                        checked: k,
                        onChange: b,
                        tabIndex: 0
                    }),
                    /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("label", {
                        htmlFor: "tag",
                        children: [
                            !!I && $ca0c2c480f9252ec$var$Wc(u) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                                icon: I
                            }),
                            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                children: i
                            })
                        ]
                    })
                ]
            });
        default:
            return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                className: m,
                style: E,
                children: [
                    !!I && $ca0c2c480f9252ec$var$Wc(u) && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)($ca0c2c480f9252ec$export$f04a61298a47a40f, {
                        icon: I
                    }),
                    i && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                        children: i
                    })
                ]
            });
    }
}, $ca0c2c480f9252ec$export$9ecc2c9a322d03a = (l)=>{
    const { className: p, id: u, label: L, info: _, density: I, ...E } = l, S = u || $ca0c2c480f9252ec$var$Ti("textarea-"), y = $ca0c2c480f9252ec$var$Oe("br-textarea", I, p);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        className: y,
        children: [
            L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("label", {
                htmlFor: S,
                children: L
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("textarea", {
                id: S,
                ...E
            }),
            _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("p", {
                className: "text-base mt-1",
                children: _
            })
        ]
    });
}, $ca0c2c480f9252ec$var$by = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, title: u, showHeader: L = !0, ..._ }, I)=>{
    const E = $ca0c2c480f9252ec$var$$t(_), S = $ca0c2c480f9252ec$var$Yt(_);
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
        ref: I,
        className: $ca0c2c480f9252ec$var$Oe("wizard-panel-content", l, ...E),
        ...S,
        children: [
            L && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "h3",
                children: u
            }),
            /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                className: "text",
                tabIndex: 0,
                children: p
            })
        ]
    });
}), $ca0c2c480f9252ec$export$83d5a2f963cd783c = (0, $jXEQt.memo)($ca0c2c480f9252ec$var$by);
$ca0c2c480f9252ec$export$83d5a2f963cd783c.displayName = "BrWizardPanel";
const $ca0c2c480f9252ec$var$_y = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ className: l, children: p, vertical: u = !1, height: L = "400px", showCancelButton: _ = !1, cancelButtonText: I = "Cancelar", prevButtonText: E = "Voltar", nextButtonText: S = "Avan\xe7ar", concludeButtonText: y = "Concluir", initialStep: k = 1, onConclude: b, onCancel: m, onChange: i, ...a }, s)=>{
    var Ae, we, me;
    const c = $ca0c2c480f9252ec$var$$t(a), g = $ca0c2c480f9252ec$var$Yt(a), A = (0, $jXEQt.useRef)(null), F = (0, $jXEQt.useRef)(null), $ = (0, $jXEQt.useRef)(null), J = (0, $jXEQt.useRef)(null), se = (0, $jXEQt.useRef)(null);
    $ca0c2c480f9252ec$var$ha(s, A);
    const [Q, _e] = (0, $jXEQt.useState)(k || 1), H = (0, $jXEQt.useRef)(k || 1);
    (0, $jXEQt.useEffect)(()=>{
        H.current = Q;
    }, [
        Q
    ]);
    const Y = (0, $jXEQt.useCallback)((ve)=>{
        _e(ve), i == null || i(ve);
    }, [
        i
    ]), z = (0, $jXEQt.useCallback)(()=>{
        _e(H.current + 1), i == null || i(H.current + 1);
    }, [
        i
    ]), V = (0, $jXEQt.useCallback)(()=>{
        _e(H.current - 1), i == null || i(H.current - 1);
    }, [
        i
    ]), fe = (Ae = (0, $jXEQt.Children).toArray(p)) == null ? void 0 : Ae[Q - 1], xe = !!(fe != null && fe.props.disabled), le = (we = (0, $jXEQt.Children).toArray(p)) == null ? void 0 : we[Q], Ne = !!(le != null && le.props.disabled), ue = Q > 1 ? (me = (0, $jXEQt.Children).toArray(p)) == null ? void 0 : me[Q - 2] : null, K = !!(ue != null && ue.props.disabled);
    return (0, $jXEQt.useImperativeHandle)(s, ()=>({
            get div () {
                return F.current;
            },
            get wrapper () {
                return A.current;
            },
            get wizardProgress () {
                return $.current;
            },
            get wizardForm () {
                return J.current;
            },
            get concludeButton () {
                return se.current;
            }
        })), /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
        ref: F,
        style: {
            height: L
        },
        children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
            ref: A,
            className: $ca0c2c480f9252ec$var$Oe("br-wizard", l, ...c),
            ...g,
            ...u && {
                vertical: "vertical"
            },
            collapsed: "collapsed",
            step: String(k),
            children: [
                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                    ref: $,
                    className: "wizard-progress",
                    children: (0, $jXEQt.Children).map(p, (ve, Ce)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                            className: "wizard-progress-btn",
                            type: "button",
                            disabled: ve.props.disabled,
                            title: ve.props.title,
                            step: Ce + 1,
                            onClick: ()=>Y(Ce + 1),
                            ...Q === Ce + 1 && {
                                active: "active"
                            },
                            children: /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("span", {
                                className: "info",
                                children: ve.props.title
                            })
                        }, ve.props.title))
                }),
                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: "wizard-form",
                    ref: J,
                    children: (0, $jXEQt.Children).map(p, (ve, Ce)=>/* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: "wizard-panel",
                            ...Q === Ce + 1 && {
                                active: "active"
                            },
                            children: [
                                ve,
                                /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                    className: "wizard-panel-btn",
                                    children: [
                                        _ && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                            className: "br-button wizard-btn-canc",
                                            type: "button",
                                            onClick: (qe)=>{
                                                m && m(qe);
                                            },
                                            children: I
                                        }),
                                        Ce < (0, $jXEQt.Children).count(p) - 1 && Ce === Q - 1 && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                            onClick: z,
                                            disabled: Ne,
                                            className: "br-button primary wizard-btn-next",
                                            type: "button",
                                            children: S
                                        }),
                                        Ce === (0, $jXEQt.Children).count(p) - 1 && Ce === Q - 1 && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                            className: "br-button primary wizard-btn",
                                            type: "button",
                                            ref: se,
                                            disabled: Ne || xe,
                                            onClick: (qe)=>{
                                                b && b(qe);
                                            },
                                            children: y
                                        }),
                                        Ce > 0 && !K && Ce === Q - 1 && /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)("button", {
                                            onClick: V,
                                            className: "br-button secondary wizard-btn-prev",
                                            type: "button",
                                            children: E
                                        })
                                    ]
                                })
                            ]
                        }, Ce))
                })
            ]
        })
    });
}), $ca0c2c480f9252ec$export$72b9a1acad6938d6 = Object.assign($ca0c2c480f9252ec$var$_y, {
    Panel: $ca0c2c480f9252ec$export$83d5a2f963cd783c
}), $ca0c2c480f9252ec$export$1c6175f3aa4394b7 = (l)=>{
    const { size: p, align: u, weight: L, color: _, className: I, children: E, margin: S, htmlElement: y, ...k } = l, b = _ || "default", m = $ca0c2c480f9252ec$var$Oe(I, $ca0c2c480f9252ec$var$cs(S), {
        [`text-${p}`]: !!p,
        [`text-${L}`]: !!L,
        [`text-${_}`]: !!_,
        [`text-${u}`]: !!u,
        [`ebr-clickable-${b}`]: !!k.onClick,
        "ebr-clickable-text": !!k.onClick
    });
    return /* @__PURE__ */ (0, $56c05cee281658b4$exports.jsx)(y || "div", {
        className: m,
        ...k,
        children: E
    });
};



parcelRequire("jXEQt");




parcelRequire("jXEQt");

function $a3a6c95bac9dc356$export$2e2bcd8739ae039({ className: className, children: children, ...others }) {
    return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("button", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)('button-as-link', className),
        ...others,
        children: children
    });
}


function $f7a40adbe7185f47$var$textBody(color, weight) {
    return `text-${color}-${weight}`;
}
function $f7a40adbe7185f47$var$textColor(color, weight) {
    return `text-${color}-${weight}`;
}
function $f7a40adbe7185f47$var$borderColor(color, weight) {
    return `border-${color}-${weight}`;
}
function $f7a40adbe7185f47$var$bgColor(color, weight) {
    return `border-${color}-${weight}`;
}
function $f7a40adbe7185f47$var$order(v) {
    return `order-${v}`;
}
var $f7a40adbe7185f47$export$2e2bcd8739ae039 = {
    // Gov-br
    row: 'row',
    colMd: 'col-md',
    brModalBody: 'br-modal-body',
    brCard: 'br-card',
    brCardHeader: 'card-header',
    brCardContent: 'card-content',
    // Icons
    iconCharBar: 'chart-bar',
    iconAdjust: 'adjust',
    bgColor: // Background
    $f7a40adbe7185f47$var$bgColor,
    borderColor: // Border
    $f7a40adbe7185f47$var$borderColor,
    // Custom
    reset: 'reset',
    textXs: 'text-xs',
    textSm: 'text-sm',
    textLg: 'text-lg',
    textGray400: $f7a40adbe7185f47$var$textBody('gray', 400),
    textGray500: $f7a40adbe7185f47$var$textBody('gray', 500),
    textGray600: $f7a40adbe7185f47$var$textBody('gray', 600),
    textGray900: $f7a40adbe7185f47$var$textBody('gray', 900),
    textColor: $f7a40adbe7185f47$var$textColor,
    // Alinhamento
    textCenter: 'text-center',
    textJustify: 'text-justify',
    textLeft: 'text-left',
    textRight: 'text-right',
    // Wrap e overflow
    textWrap: 'text-wrap',
    textNoWrap: 'text-nowrap',
    textTruncate: 'text-truncate',
    textBreak: 'text-break',
    textBreakAll: 'text-break-all',
    // Transformacao
    textLowercase: 'text-lowercase',
    textUppercase: 'text-uppercase',
    textCapitalize: 'text-capitalize',
    // Peso
    textWeightThin: 'text-weight-thin',
    textWeightExtraLight: 'text-weight-extra-light',
    textWeightLight: 'text-weight-light',
    textWeightRegular: 'text-weight-regular',
    textWeightMedium: 'text-weight-medium',
    textWeightSemiBold: 'text-weight-semi-bold',
    textWeightBold: 'text-weight-bold',
    textWeightExtraBold: 'text-weight-extra-bold',
    textWeightBlack: 'text-weight-black',
    fontMono: 'font-mono',
    // Tamanho
    textBase: 'text-base',
    textUp01: 'text-up-01',
    textUp02: 'text-up-02',
    textUp03: 'text-up-03',
    textUp04: 'text-up-04',
    textUp05: 'text-up-05',
    textUp06: 'text-up-06',
    textUp07: 'text-up-07',
    textDown01: 'text-down-01',
    textDown02: 'text-down-02',
    textDown03: 'text-down-03',
    // Display
    dNone: 'd-none',
    dBlock: 'd-block',
    dFlex: 'd-flex',
    dInline: 'd-inline',
    dInlineBlock: 'd-inline-block',
    dInlineFlex: 'd-inline-flex',
    dFlexV: 'd-flex flex-row',
    dFlexH: 'd-flex flex-column',
    flexRow: 'flex-row',
    flexRowReverse: 'flex-row-reverse',
    flexColumn: 'flex-column',
    flexColumnReverse: 'flex-column-reverse',
    flexColumnGapBase: 'flex-column-gap-base',
    flexGrow0: 'flex-grow-0',
    flexGrow1: 'flex-grow-1',
    flexShrink0: 'flex-shrink-0',
    flexShrink1: 'flex-shrink-1',
    order: $f7a40adbe7185f47$var$order,
    alignContentStart: 'align-content-start',
    alignContentEnd: 'align-content-end',
    alignContentCenter: 'align-content-center',
    alignContentBetween: 'align-content-between',
    alignContentAround: 'align-content-around',
    alignContentEvenly: 'align-content-evenly',
    alignContentStretch: 'align-content-stretch',
    // Padding
    p: (v)=>`p-${v}`,
    pSm: (v)=>`p-sm-${v}`,
    pMd: (v)=>`p-md-${v}`,
    pLg: (v)=>`p-lg-${v}`,
    pXl: (v)=>`p-xl-${v}`,
    // Padding X
    px: (v)=>`px-${v}`,
    pxSm: (v)=>`px-sm-${v}`,
    pxMd: (v)=>`px-md-${v}`,
    pxLg: (v)=>`px-lg-${v}`,
    pxXl: (v)=>`px-xl-${v}`,
    // Padding Y
    py: (v)=>`py-${v}`,
    pySm: (v)=>`py-sm-${v}`,
    pyMd: (v)=>`py-md-${v}`,
    pyLg: (v)=>`py-lg-${v}`,
    pyXl: (v)=>`py-xl-${v}`,
    // Padding Right
    pr: (v)=>`pr-${v}`,
    prSm: (v)=>`pr-sm-${v}`,
    prMd: (v)=>`pr-md-${v}`,
    prLg: (v)=>`pr-lg-${v}`,
    prXl: (v)=>`pr-xl-${v}`,
    // Padding Top
    pt: (v)=>`pt-${v}`,
    ptSm: (v)=>`pt-sm-${v}`,
    ptMd: (v)=>`pt-md-${v}`,
    ptLg: (v)=>`pt-lg-${v}`,
    ptXl: (v)=>`pt-xl-${v}`,
    // Padding Left
    pl: (v)=>`pl-${v}`,
    plSm: (v)=>`pl-sm-${v}`,
    plMd: (v)=>`pl-md-${v}`,
    plLg: (v)=>`pl-lg-${v}`,
    plXl: (v)=>`pl-xl-${v}`,
    // Padding Bottom
    pb: (v)=>`pb-${v}`,
    pbSm: (v)=>`pb-sm-${v}`,
    pbMd: (v)=>`pb-md-${v}`,
    pbLg: (v)=>`pb-lg-${v}`,
    pbXl: (v)=>`pb-xl-${v}`,
    // Margin
    mInherited: 'm-inherit',
    m: (v)=>`m-${v}`,
    mSm: (v)=>`m-sm-${v}`,
    mMd: (v)=>`m-md-${v}`,
    mLg: (v)=>`m-lg-${v}`,
    mXl: (v)=>`m-xl-${v}`,
    // Margin X
    mx: (v)=>`mx-${v}`,
    mxSm: (v)=>`mx-sm-${v}`,
    mxMd: (v)=>`mx-md-${v}`,
    mxLg: (v)=>`mx-lg-${v}`,
    mxXl: (v)=>`mx-xl-${v}`,
    // Margin Y
    my: (v)=>`my-${v}`,
    mySm: (v)=>`my-sm-${v}`,
    myMd: (v)=>`my-md-${v}`,
    myLg: (v)=>`my-lg-${v}`,
    myXl: (v)=>`my-xl-${v}`,
    // Margin Right
    mr: (v)=>`mr-${v}`,
    mrSm: (v)=>`mr-sm-${v}`,
    mrMd: (v)=>`mr-md-${v}`,
    mrLg: (v)=>`mr-lg-${v}`,
    mrXl: (v)=>`mr-xl-${v}`,
    // Margin Top
    mt: (v)=>`mt-${v}`,
    mtSm: (v)=>`mt-sm-${v}`,
    mtMd: (v)=>`mt-md-${v}`,
    mtLg: (v)=>`mt-lg-${v}`,
    mtXl: (v)=>`mt-xl-${v}`,
    // Margin Bottom
    mb: (v)=>`mb-${v}`,
    mbSm: (v)=>`mb-sm-${v}`,
    mbMd: (v)=>`mb-md-${v}`,
    mbLg: (v)=>`mb-lg-${v}`,
    mbXl: (v)=>`mb-xl-${v}`,
    // Margin Left
    ml: (v)=>`ml-${v}`,
    mlSm: (v)=>`ml-sm-${v}`,
    mlMd: (v)=>`ml-md-${v}`,
    mlLg: (v)=>`ml-lg-${v}`,
    mlXl: (v)=>`ml-xl-${v}`,
    noGridGlutter: 'no-grid-glutter',
    placeHolder: 'place-holder',
    primeiroBrCardNoShadow: 'primeiro-br-card-no-shadow',
    bgTransparent: 'bg-transparent',
    noBgButton: 'border-solid-none bg-transparent',
    lifeshubList: 'lifeshub-list',
    textPrimary: 'text-primary'
};


var $91f579cc1f13880c$exports = {};
$91f579cc1f13880c$exports = import.meta.resolve("g9CfW");


var $4e9068e4e3b78b74$exports = {};
$4e9068e4e3b78b74$exports = import.meta.resolve("n9g5R");


var $1655eba3420e770d$exports = {};
$1655eba3420e770d$exports = import.meta.resolve("GFVzj");


var $98bd310c1bdda38b$exports = {};
$98bd310c1bdda38b$exports = import.meta.resolve("aUEWo");


var $58a30ad276d1264a$exports = {};
$58a30ad276d1264a$exports = import.meta.resolve("9rPf4");


var $8a082047e0b6c976$exports = {};
$8a082047e0b6c976$exports = import.meta.resolve("lOedZ");


var $f9cf5edd7e994729$exports = {};
$f9cf5edd7e994729$exports = import.meta.resolve("eTHMB");


var $855588606239f696$exports = {};
$855588606239f696$exports = import.meta.resolve("7vffY");


var $33a27b078192c7bd$exports = {};
$33a27b078192c7bd$exports = import.meta.resolve("6P4Ro");


var $157e239588b0a4da$exports = {};
$157e239588b0a4da$exports = import.meta.resolve("hk5By");


var $37319ef540769647$exports = {};
$37319ef540769647$exports = import.meta.resolve("kLamC");


var $8850084af2922936$exports = {};
$8850084af2922936$exports = import.meta.resolve("55cPQ");


var $fd8640ac4e3047b7$export$2e2bcd8739ae039 = {
    lifeshubLogoUrl: (/*@__PURE__*/$parcel$interopDefault($91f579cc1f13880c$exports)),
    filterIconUrl: // Lucide
    (/*@__PURE__*/$parcel$interopDefault($4e9068e4e3b78b74$exports)),
    trendingUpIconUrl: (/*@__PURE__*/$parcel$interopDefault($1655eba3420e770d$exports)),
    circleAlertIconUrl: (/*@__PURE__*/$parcel$interopDefault($98bd310c1bdda38b$exports)),
    eyeIconUrl: (/*@__PURE__*/$parcel$interopDefault($58a30ad276d1264a$exports)),
    bookOpenIconUrl: (/*@__PURE__*/$parcel$interopDefault($8a082047e0b6c976$exports)),
    chevronRightconUrl: (/*@__PURE__*/$parcel$interopDefault($f9cf5edd7e994729$exports)),
    chevronDownconUrl: (/*@__PURE__*/$parcel$interopDefault($855588606239f696$exports)),
    buildingUrl: (/*@__PURE__*/$parcel$interopDefault($33a27b078192c7bd$exports)),
    circleCheckBigUrl: (/*@__PURE__*/$parcel$interopDefault($157e239588b0a4da$exports)),
    triangleAlertUrl: (/*@__PURE__*/$parcel$interopDefault($37319ef540769647$exports)),
    circleXUrl: (/*@__PURE__*/$parcel$interopDefault($8850084af2922936$exports))
};


const $c0b7e8591917d393$var$styles = {
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingRight: '1rem'
    },
    logoImage: {
        height: '45px',
        objectFit: 'contain'
    },
    appTitle: {
        fontSize: '1.6rem',
        fontWeight: 700,
        color: 'var(--primary-color)',
        textDecoration: 'none',
        letterSpacing: '-0.5px'
    },
    subTitle: {
        fontSize: '0.9rem',
        opacity: 0.85,
        color: '#555'
    },
    version: {
        fontSize: '0.8rem',
        alignSelf: 'center',
        color: '#999'
    }
};
class $c0b7e8591917d393$var$HeaderClass {
    scope;
    quickLinkData = [];
    quickLinkVersion = -1;
    render({ className: className, fluid: fluid, scope: scope }) {
        this.scope = scope;
        if (this.quickLinkVersion !== scope.quickLinkVersion) {
            this.quickLinkData = this.quickAccessLinksAdaptor(scope.quickLinkData);
            this.quickLinkVersion = scope.quickLinkVersion;
        }
        // Componente customizado para o topo: Título à esquerda, Logo à direita
        const CustomHeaderContent = /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
            style: $c0b7e8591917d393$var$styles.headerContainer,
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $a3a6c95bac9dc356$export$2e2bcd8739ae039), {
                            onClick: this.scope.onHome,
                            style: $c0b7e8591917d393$var$styles.appTitle,
                            children: "BulaCerta AI"
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $f7a40adbe7185f47$export$2e2bcd8739ae039).textBase, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).textWeightRegular, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).dFlex),
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    style: $c0b7e8591917d393$var$styles.subTitle,
                                    children: "Plataforma Inteligente para Consulta Segura de Medicamentos"
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$1cb26bd41bda552d), {
                                    vertical: true,
                                    ml: 2,
                                    mr: 2
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                    style: $c0b7e8591917d393$var$styles.version,
                                    children: [
                                        "v",
                                        scope.version
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).flexGrow1
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                    src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).lifeshubLogoUrl,
                    alt: "Lifeshub",
                    style: $c0b7e8591917d393$var$styles.logoImage
                })
            ]
        });
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$920ee6a4eaf488e), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('lifeshub-header', className),
            fluid: fluid,
            showMenuButton: true,
            showSearchBar: false,
            signature: '',
            menuId: "main-navigation",
            title: CustomHeaderContent,
            subTitle: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $56c05cee281658b4$exports.Fragment), {}),
            loggedIn: scope.loggedIn,
            onClickLogin: this.scope.onClickLogin,
            onSearch: this.scope.onBuscaTermo
        });
    }
    quickAccessLinksAdaptor(src) {
        const tgt = [];
        for (const srcItem of src)tgt.push({
            label: srcItem.label,
            onClick: srcItem.onClick
        });
        return tgt;
    }
}
var $c0b7e8591917d393$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($c0b7e8591917d393$var$HeaderClass);



var $b5f54964a8cb3bf0$exports = {};

var $f947b9da0dfccaa9$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $f947b9da0dfccaa9$var$isArray = Array.isArray;
$f947b9da0dfccaa9$exports = $f947b9da0dfccaa9$var$isArray;



/** `Object#toString` result references. */ var $b5f54964a8cb3bf0$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $b5f54964a8cb3bf0$var$isString(value) {
    return typeof value == 'string' || !$f947b9da0dfccaa9$exports(value) && $3e9d92400c16801e$exports(value) && $d5a3f502c8fd2aa8$exports(value) == $b5f54964a8cb3bf0$var$stringTag;
}
$b5f54964a8cb3bf0$exports = $b5f54964a8cb3bf0$var$isString;


parcelRequire("jXEQt");



const $b845e4351d80ca9d$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('main/Menu');
class $b845e4351d80ca9d$var$MenuViewClass {
    scope;
    menuVersion = -1;
    menuData = [];
    render({ scope: scope }) {
        this.scope = scope;
        if (this.menuVersion !== scope.version) {
            this.menuData = this.#loadMenuData(scope.items);
            this.menuVersion, scope.version;
        }
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$72175f23bf9e372f), {
            closable: true,
            shadow: true,
            showFooter: true,
            type: scope.type,
            startActive: scope.active,
            md: scope.size,
            lg: scope.size,
            xl: scope.size,
            systemName: "BulaCerta AI",
            id: "main-navigation",
            data: this.menuData,
            externalLinks: [
                {
                    link: 'https://www.lifeshub.com.br/',
                    label: 'Lifeshub Official'
                },
                {
                    link: 'https://www.lifeshub.com.br/contato',
                    label: "Suporte T\xe9cnico"
                }
            ],
            socialNetworks: [
                {
                    link: 'https://www.linkedin.com/company/lifeshub/',
                    icon: 'fab fa-linkedin-in',
                    name: 'Linkedin'
                },
                {
                    link: 'https://www.instagram.com/lifeshub/',
                    icon: 'fab fa-instagram',
                    name: 'Instagram'
                }
            ],
            info: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: "text-center",
                    style: {
                        fontSize: '0.8rem',
                        color: '#666'
                    },
                    children: [
                        "Desenvolvido por ",
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                            children: "Lifeshub Group"
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                        "\xa9 2025 Todos os direitos reservados."
                    ]
                })
            })
        });
    }
    #loadMenuData(src) {
        const tgt = [];
        for(let i = 0; i < src.length; i++){
            const srcItem = src[i];
            const tgtItem = tgt[i] = {};
            if ((0, (/*@__PURE__*/$parcel$interopDefault($b5f54964a8cb3bf0$exports)))(srcItem.label)) tgtItem.label = srcItem.label;
            else if (srcItem.label) tgtItem.label = /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $a21dea676972c64f$export$c737218972fbfde7), {
                scope: srcItem.label
            });
            tgtItem.icon = srcItem.icon;
            tgtItem.divider = srcItem.divider;
            tgtItem.expanded = srcItem.expanded;
            tgtItem.active = srcItem.active;
            tgtItem.danger = srcItem.danger;
            tgtItem.keepMenuActive = srcItem.keepMenuActive;
            if (srcItem.onClick) tgtItem.onClick = ()=>srcItem.onClick().catch($b845e4351d80ca9d$var$LOG.caught);
            if (srcItem.submenu) tgtItem.submenu = this.#loadMenuData(srcItem.submenu);
        }
        return tgt;
    }
}
var $b845e4351d80ca9d$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($b845e4351d80ca9d$var$MenuViewClass);



parcelRequire("jXEQt");




class $301f349653467cf9$export$b6db24f06366ab7f {
    scope;
    render({ scope: scope }) {
        this.scope = scope;
        const brModalProps = {
            isOpen: true
        };
        brModalProps.title = scope.title;
        brModalProps.minWidth = scope.minWidth;
        brModalProps.minHeight = scope.minHeight;
        brModalProps.height = scope.height;
        brModalProps.width = scope.width;
        brModalProps.keepOpenOnPrimaryAction = scope.keepOpenOnPrimaryAction;
        brModalProps.keepOpenOnSecondaryAction = scope.keepOpenOnSecondaryAction;
        brModalProps.focusOnPrimaryAction = scope.focusOnPrimaryAction;
        brModalProps.focusOnSecondaryAction = scope.focusOnSecondaryAction;
        brModalProps.primaryAction = scope.primaryAction;
        brModalProps.secondaryAction = scope.secondaryAction;
        brModalProps.onClose = this.scope.onClose;
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $f7a40adbe7185f47$export$2e2bcd8739ae039).placeHolder, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).primeiroBrCardNoShadow),
            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$9bf5abad0301adc), {
                ...brModalProps,
                children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).brModalBody,
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $a21dea676972c64f$export$c737218972fbfde7), {
                        scope: scope.content
                    })
                })
            })
        });
    }
}
var $301f349653467cf9$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($301f349653467cf9$export$b6db24f06366ab7f);



parcelRequire("jXEQt");




class $1ba3da3445baa92a$export$234dd10cc15431f6 {
    scope;
    render({ scope: scope }) {
        this.scope = scope;
        const brModalProps = {
            isOpen: true
        };
        brModalProps.title = scope.title;
        brModalProps.minWidth = scope.minWidth;
        brModalProps.minHeight = scope.minHeight;
        brModalProps.height = scope.height;
        brModalProps.width = scope.width;
        brModalProps.keepOpenOnPrimaryAction = scope.keepOpenOnPrimaryAction;
        brModalProps.keepOpenOnSecondaryAction = scope.keepOpenOnSecondaryAction;
        brModalProps.focusOnPrimaryAction = scope.focusOnPrimaryAction;
        brModalProps.focusOnSecondaryAction = scope.focusOnSecondaryAction;
        brModalProps.primaryAction = scope.primaryAction;
        brModalProps.secondaryAction = scope.secondaryAction;
        brModalProps.onClose = this.scope.onClose;
        let contentElm = scope.content ? /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $a21dea676972c64f$export$c737218972fbfde7), {
            scope: scope.content
        }) : this.messageRender(scope);
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $f7a40adbe7185f47$export$2e2bcd8739ae039).placeHolder, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).primeiroBrCardNoShadow),
            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$9bf5abad0301adc), {
                ...brModalProps,
                children: contentElm
            })
        });
    }
    messageRender(scope) {
        const status = scope.severity;
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
            className: (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).brModalBody,
            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$91803f13bd898dcd), {
                status: status,
                category: "message",
                closable: false,
                message: scope.message
            })
        });
    }
}
var $1ba3da3445baa92a$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($1ba3da3445baa92a$export$234dd10cc15431f6);


class $63e4627a3b25d412$var$MainViewClass {
    fluid = true;
    scope;
    render({ className: className, scope: scope }) {
        this.scope = scope;
        let dialogElm = undefined;
        if (scope.dialog) dialogElm = /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $301f349653467cf9$export$2e2bcd8739ae039), {
            scope: scope.dialog
        });
        let alertElm = undefined;
        if (scope.alert) alertElm = /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $1ba3da3445baa92a$export$2e2bcd8739ae039), {
            scope: scope.alert
        });
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className),
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $c0b7e8591917d393$export$2e2bcd8739ae039), {
                    fluid: this.fluid,
                    scope: scope.header
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$42a852a2b6b56249), {
                    fluid: this.fluid,
                    margin: {
                        t: 3,
                        b: 6
                    },
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
                        children: [
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $b845e4351d80ca9d$export$2e2bcd8739ae039), {
                                scope: scope.menu
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $a21dea676972c64f$export$c737218972fbfde7), {
                                    scope: scope.page
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$627559ebc0a953ef), {
                    userLicenseText: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        style: {
                            textAlign: 'center',
                            width: '100%'
                        },
                        children: [
                            "BulaCerta AI - Uma solu\xe7\xe3o ",
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                                children: "Lifeshub Group SA"
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                style: {
                                    fontSize: '0.8em'
                                },
                                children: "Dados baseados em regula\xe7\xf5es da ANVISA - Atualizado diariamente."
                            })
                        ]
                    })
                }),
                dialogElm,
                alertElm
            ]
        });
    }
}
var $63e4627a3b25d412$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($63e4627a3b25d412$var$MainViewClass);





parcelRequire("jXEQt");




class $f030e98c93e62c85$export$84060015ea90518f {
    render({ className: className }) {
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$42a852a2b6b56249), {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className),
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("h1", {
                            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)((0, $f7a40adbe7185f47$export$2e2bcd8739ae039).textUp04, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).textWeightBold, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).mb('4x'), (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).textPrimary),
                            children: "Bem-vindo ao BulaCerta AI"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
                    children: [
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                            md: 8,
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("p", {
                                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)((0, $f7a40adbe7185f47$export$2e2bcd8739ae039).textLg, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).mb('2x')),
                                    children: "Uma plataforma inteligente que transforma a maneira como profissionais de sa\xfade e pacientes acessam informa\xe7\xf5es farmac\xeauticas."
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("p", {
                                    children: [
                                        "O ",
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                                            children: "BulaCerta AI"
                                        }),
                                        " utiliza algoritmos avan\xe7ados de Intelig\xeancia Artificial e Large Language Models (LLMs) para extrair e organizar dados diretamente de bulas regulamentadas pela ANVISA. Nossa solu\xe7\xe3o vai al\xe9m da simples leitura: ela interpreta d\xfavidas em linguagem natural sobre",
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                                            children: "posologia, intera\xe7\xf5es medicamentosas, contraindica\xe7\xf5es e efeitos colaterais"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("p", {
                                    children: [
                                        "Desenvolvido pela ",
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                                            children: "Lifeshub"
                                        }),
                                        ", o sistema visa reduzir erros m\xe9dicos, otimizar a tomada de decis\xe3o cl\xednica e aumentar a seguran\xe7a do paciente, centralizando informa\xe7\xf5es cr\xedticas em uma interface acess\xedvel e intuitiva."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                            md: 4,
                            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$2de34322b83831d3), {
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)((0, $f7a40adbe7185f47$export$2e2bcd8739ae039).textWeightSemiBold, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).textUp01, (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).mb('base')),
                                        children: "Destaques da Plataforma"
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("ul", {
                                        className: (0, $f7a40adbe7185f47$export$2e2bcd8739ae039).lifeshubList,
                                        children: [
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("li", {
                                                children: [
                                                    "\uD83D\uDD0D ",
                                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                                                        children: "Consulta Inteligente:"
                                                    }),
                                                    " Respostas diretas baseadas em bulas oficiais."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("li", {
                                                children: [
                                                    "\uD83D\uDC8A ",
                                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                                                        children: "Seguran\xe7a:"
                                                    }),
                                                    " Detec\xe7\xe3o de riscos e intera\xe7\xf5es."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("li", {
                                                children: [
                                                    "\uD83D\uDCF1 ",
                                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                                                        children: "Acessibilidade:"
                                                    }),
                                                    " Dispon\xedvel Web e Mobile."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("li", {
                                                children: [
                                                    "\uD83D\uDD17 ",
                                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("strong", {
                                                        children: "Integra\xe7\xe3o:"
                                                    }),
                                                    " APIs para sistemas hospitalares."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $f030e98c93e62c85$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($f030e98c93e62c85$export$84060015ea90518f);


function $40c142f37dcabbfe$export$9be1907ba6822108(rr) {
    rr((0, $f281847c15bd8905$export$d8d9d79b6626505f), (0, $63e4627a3b25d412$export$2e2bcd8739ae039));
    rr((0, $f281847c15bd8905$export$4b106156bfc1c581), (0, $f030e98c93e62c85$export$2e2bcd8739ae039));
    rr((0, $f281847c15bd8905$export$884432535b5866ab), (0, $1ba3da3445baa92a$export$2e2bcd8739ae039));
    rr((0, $f281847c15bd8905$export$56ecde165a7abc6a), (0, $301f349653467cf9$export$2e2bcd8739ae039));
}




parcelRequire("jXEQt");





var $af7573fe26133bc6$export$2e2bcd8739ae039 = {
    ...(0, $f7a40adbe7185f47$export$2e2bcd8739ae039),
    flatCard: 'HKLrkZ-flat-card',
    totalCardFabricantes: 'HKLrkZ-total-card-fabricantes',
    // Matrix
    matrixContainer: 'HKLrkZ-matrix-container',
    matrixGrid: 'HKLrkZ-matrix-grid',
    matrixVerticalTextHeader: 'HKLrkZ-vertical-text',
    matrixCornerHeader: 'HKLrkZ-corner-header',
    matrixCellMedBadge: 'HKLrkZ-med-badge',
    matrixMedMissing: 'HKLrkZ-med-missing'
};



parcelRequire("jXEQt");






parcelRequire("jXEQt");



class $2c5e7040b9a5cfbd$var$DominioSelectViewClass {
    scope;
    // :: Listener adapters
    onChangeOptions = (selectedOptions)=>{
        this.scope.onChangeOptions(selectedOptions);
    };
    render({ scope: scope, className: className, label: label, placeholder: placeholder }) {
        this.scope = scope;
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$472b15cae7bbc1c1), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(className),
            type: "multiple",
            searchDebounceTimeout: 0,
            label: label,
            value: scope.value,
            placeholder: placeholder,
            options: scope.options,
            externalFiltering: true,
            isLoading: scope.loading,
            selectAllText: '',
            onChangeOptions: this.onChangeOptions,
            onSearchChange: scope.onSearchChange
        });
    }
}
var $2c5e7040b9a5cfbd$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($2c5e7040b9a5cfbd$var$DominioSelectViewClass);


const $dd49b4553b97181c$var$styles = {
    lblFilter1: {
        alignItems: 'center'
    },
    lblFilter2: {
        marginLeft: '5pt'
    },
    pnlActions: {
        padding: '10px'
    },
    btnLimpar: {
        alignSelf: 'baseline',
        marginTop: '8pt'
    },
    btnBuscar: {
        alignSelf: 'baseline',
        marginTop: '8pt'
    },
    inpPeriodo: {
        alignSelf: 'stretch',
        flexGrow: 1
    },
    flexCenteredLayout: {
        display: 'flex',
        alignItems: 'center'
    },
    flexGrow: {
        flexGrow: 1
    }
};
class $dd49b4553b97181c$var$FiltroViewClass {
    scope;
    render({ className: className, scope: scope }) {
        this.scope = scope;
        const msgSelectPlaceHolder = 'Digite algo para pesquisar';
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(className),
            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).brCard,
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).brCardContent,
                        children: [
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).textUp02, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).textWeightSemiBold, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).dFlexV),
                                style: $dd49b4553b97181c$var$styles.lblFilter1,
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                        width: 20,
                                        height: 20,
                                        src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).filterIconUrl
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                        style: $dd49b4553b97181c$var$styles.lblFilter2,
                                        children: "Filtros"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $2c5e7040b9a5cfbd$export$2e2bcd8739ae039), {
                                            label: "Princ\xedpios ativos (*)",
                                            placeholder: msgSelectPlaceHolder,
                                            scope: scope.principiosAtivos
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $2c5e7040b9a5cfbd$export$2e2bcd8739ae039), {
                                            label: "Fabricantes",
                                            placeholder: msgSelectPlaceHolder,
                                            scope: scope.fabricantes
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $2c5e7040b9a5cfbd$export$2e2bcd8739ae039), {
                                            label: "Medicamentos",
                                            placeholder: msgSelectPlaceHolder,
                                            scope: scope.medicamentos
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $2c5e7040b9a5cfbd$export$2e2bcd8739ae039), {
                                            label: "Rea\xe7\xf5es",
                                            placeholder: msgSelectPlaceHolder,
                                            scope: scope.reacoes
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).dFlexV, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).flexColumnGapBase),
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        style: $dd49b4553b97181c$var$styles.flexGrow,
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$30a931fe40eb4795), {
                                        secondary: true,
                                        style: $dd49b4553b97181c$var$styles.btnLimpar,
                                        onClick: scope.onLimpar,
                                        children: "Limpar filtros"
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$30a931fe40eb4795), {
                                        primary: true,
                                        style: $dd49b4553b97181c$var$styles.btnBuscar,
                                        onClick: scope.onConsultar,
                                        children: "Buscar"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    }
}
var $dd49b4553b97181c$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($dd49b4553b97181c$var$FiltroViewClass);



parcelRequire("jXEQt");




const $727f2959f710f9c9$var$styles = {
    flatCard: {
        padding: 0,
        border: 'none',
        boxShadow: 'none'
    },
    gap2x: {
        columnGap: 'var(--spacing-scale-2x)'
    }
};
class $727f2959f710f9c9$var$CompareTableViewClass {
    scope;
    render({ scope: scope, className: className }) {
        this.scope = scope;
        if (!scope.reacaoPorFabricanteData) return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $56c05cee281658b4$exports.Fragment), {});
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(className),
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).dFlex, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).flexColumnGapBase, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).mb('base')),
                    children: [
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)($727f2959f710f9c9$var$ValueCard, {
                            title: "Fabricantes Analisados",
                            label: "Bulas comparadas",
                            iconUrl: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).buildingUrl,
                            value: scope.qtdeFabricatesAnalisados
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)($727f2959f710f9c9$var$ValueCard, {
                            title: "Cobertura Completa",
                            label: "Rea\xe7\xf5es em todas as bulas",
                            iconUrl: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).circleCheckBigUrl,
                            value: scope.qtdeCoberturasCompletas
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)($727f2959f710f9c9$var$ValueCard, {
                            title: "Cobertura Parcial",
                            label: "Inconsist\xeancias detectadas",
                            iconUrl: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).triangleAlertUrl,
                            value: scope.qtdeCoberturaParciais
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)($727f2959f710f9c9$var$ValueCard, {
                            title: "N\xe3o Documentadas",
                            label: "Rea\xe7\xf5es ausentes em bulas",
                            iconUrl: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).circleXUrl,
                            value: scope.qtdeNaoDocumentadas
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).flatCard, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).mt('base'), className),
                    style: $727f2959f710f9c9$var$styles.flatCard,
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).matrixContainer,
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("table", {
                            className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).matrixGrid,
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("th", {
                                                children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                    className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).matrixCornerHeader,
                                                    children: "Rea\xe7\xe3o Adversa"
                                                })
                                            }),
                                            scope.reacaoPorFabricanteData.fabricantes.map((item)=>/*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("th", {
                                                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                                        className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).matrixVerticalTextHeader,
                                                        title: item.nome,
                                                        children: item.nome
                                                    })
                                                }, item.id))
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("tbody", {
                                    children: scope.reacaoPorFabricanteData.rows.map((item)=>/*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("th", {
                                                    children: item.reacao
                                                }),
                                                item.medicamentos.map((medicamentosReagentes, idx)=>/*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("td", {
                                                        children: medicamentosReagentes.length > 0 ? // CASO TENHA MEDICAMENTO: Badge Azul
                                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                                            className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).matrixCellMedBadge,
                                                            title: medicamentosReagentes.map((m)=>m.nome).join('\n'),
                                                            children: [
                                                                medicamentosReagentes[0].nome,
                                                                medicamentosReagentes.length > 1 && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("small", {
                                                                    children: [
                                                                        " (+",
                                                                        medicamentosReagentes.length - 1,
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        }) : // CASO NÃO TENHA: Traço sutil
                                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                                            className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).matrixMedMissing,
                                                            children: "\u2014"
                                                        })
                                                    }, idx))
                                            ]
                                        }, item.id))
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
}
var $727f2959f710f9c9$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($727f2959f710f9c9$var$CompareTableViewClass);
function $727f2959f710f9c9$var$ValueCard({ className: className, title: title, label: label, iconUrl: iconUrl, value: value }) {
    return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).flatCard, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).p('base'), className),
        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).brCardContent, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).totalCardFabricantes),
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).dFlex, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).alignContentCenter),
                    style: $727f2959f710f9c9$var$styles.gap2x,
                    children: [
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).textBase, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).textWeightBold, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).flexGrow1),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                            src: iconUrl,
                            width: "16",
                            height: "16",
                            alt: "icon"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).textUp02, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).textWeightBold),
                    children: value
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).textDown02),
                    children: label
                })
            ]
        })
    });
}


class $a2ed52be1c0df308$var$AnaliseBulasViewClass {
    scope;
    render({ className: className, scope: scope }) {
        this.scope = scope;
        const gradeElm = scope.loading ? /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
            className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).mLg('10xh'),
            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$48493b3d35ec1140), {
                large: true,
                label: "Processando dados..."
            })
        }) : /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $727f2959f710f9c9$export$2e2bcd8739ae039), {
            className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).mt('2xh'),
            scope: scope.table
        });
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$42a852a2b6b56249), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(className),
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).brCardHeader,
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: (0, $af7573fe26133bc6$export$2e2bcd8739ae039).dFlex,
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $af7573fe26133bc6$export$2e2bcd8739ae039).textWeightSemiBold, (0, $af7573fe26133bc6$export$2e2bcd8739ae039).textUp02),
                                    children: "An\xe1lise Comparativa por Princ\xedpio Ativo"
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    children: "Confer\xeancia de Rea\xe7\xf5es Adversas e Conformidade Regulat\xf3ria"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $dd49b4553b97181c$export$2e2bcd8739ae039), {
                    scope: scope.filtro
                }),
                gradeElm
            ]
        });
    }
}
var $a2ed52be1c0df308$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($a2ed52be1c0df308$var$AnaliseBulasViewClass);


function $69e76fc3320da60c$export$9be1907ba6822108(rr) {
    rr((0, $04cc4a7986243394$export$2e2bcd8739ae039), (0, $a2ed52be1c0df308$export$2e2bcd8739ae039));
}





parcelRequire("jXEQt");




var $86645d3d703ed072$export$2e2bcd8739ae039 = {
    ...(0, $f7a40adbe7185f47$export$2e2bcd8739ae039),
    consultaReacoesCardTotalReacoes: 'tSYxvF-reacoes-card-total-reacoes',
    consultaReacoesGrade: 'tSYxvF-reacoes-grade',
    gradeRowHead: 'tSYxvF-row-head',
    gradeMostLeftColumn: 'tSYxvF-most-left-column',
    gradeGravidadeSim: 'tSYxvF-gravidade-sim',
    gradeGravidadeNao: 'tSYxvF-gravidade-nao',
    gradeConferenciaForaBula: 'tSYxvF-conferencia-fora-bula',
    gradeConferenciaNaBula: 'tSYxvF-conferencia-na-bula',
    gradeConferenciaNaoVerificado: 'tSYxvF-conferencia-nao-verificado',
    gradeDefechoMorte: 'tSYxvF-defecho-morte'
};



parcelRequire("jXEQt");





const $5fc3b9702954e589$var$styles = {
    lblFilter1: {
        alignItems: 'center'
    },
    lblFilter2: {
        marginLeft: '5pt'
    },
    pnlActions: {
        padding: '10px'
    },
    btnLimpar: {
        alignSelf: 'baseline',
        marginTop: '8pt'
    },
    btnBuscar: {
        alignSelf: 'baseline',
        marginTop: '8pt'
    },
    inpPeriodo: {
        alignSelf: 'stretch',
        flexGrow: 1
    },
    flexCenteredLayout: {
        display: 'flex',
        alignItems: 'center'
    },
    flexGrow: {
        flexGrow: 1
    }
};
class $5fc3b9702954e589$var$FiltroViewClass {
    scope;
    // :: Listener adapters
    onBuscaGeralTextChanged = (e)=>{
        this.scope.onBuscaGeralTextChanged(e.target.value);
    };
    onBuscaReacaoTextChanged = (e)=>{
        this.scope.onBuscaReacaoTextChanged(e.target.value);
    };
    onBuscaMedicamentoChanged = (e)=>{
        this.scope.onBuscaMedicamentoChanged(e.target.value);
    };
    onStatusBulaChanged = (value)=>{
        this.scope.onStatusBulaChanged(value);
    };
    onGravidadeChanged = (value)=>{
        this.scope.onGravidadeChanged(value);
    };
    onPeriodoChange = (range)=>{
        this.scope.onPeriodoChange(range);
    };
    render({ className: className, scope: scope }) {
        this.scope = scope;
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(className),
            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).brCard,
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).brCardContent,
                        children: [
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp02, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightSemiBold, (0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexV),
                                style: $5fc3b9702954e589$var$styles.lblFilter1,
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                        width: 20,
                                        height: 20,
                                        src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).filterIconUrl
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                        style: $5fc3b9702954e589$var$styles.lblFilter2,
                                        children: "Filtros Avan\xe7ados de An\xe1lise"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
                                className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).flexColumnGapBase,
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$1c89cc3d2b5965be), {
                                            label: "Buscar Geral",
                                            placeholder: "Medicamento, ATC, paciente...",
                                            value: scope.buscaGeralText,
                                            onChange: this.onBuscaGeralTextChanged
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$1c89cc3d2b5965be), {
                                            label: "Buscar Rea\xe7\xe3o (MedDRA)",
                                            placeholder: "PT, LLT ou nome da rea\xe7\xe3o...",
                                            value: scope.buscaReacaoText,
                                            onChange: this.onBuscaReacaoTextChanged
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$1c89cc3d2b5965be), {
                                            label: "Medicamento (WHO Drug)",
                                            placeholder: "Nome ou princ\xedpio ativo...",
                                            value: scope.buscaMedicamentoText,
                                            onChange: this.onBuscaMedicamentoChanged
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
                                            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$472b15cae7bbc1c1), {
                                                className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).colMd,
                                                label: "Status bula",
                                                placeholder: "Selecione o Status",
                                                type: "single",
                                                value: scope.statusBula,
                                                options: scope.statusBulaOptions,
                                                onChange: this.onStatusBulaChanged
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
                                            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$472b15cae7bbc1c1), {
                                                className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).colMd,
                                                label: "Gravidade",
                                                placeholder: "Selecione uma gravidade",
                                                type: "single",
                                                value: scope.gravidade,
                                                options: scope.gravidadeOptions,
                                                onChange: this.onGravidadeChanged
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$8d5bab7dcaab2bf7), {
                                            label: "Per\xedodo",
                                            dataMode: "range",
                                            dataType: "date",
                                            placeholder: "exemplo: 01/02/2025 at\xe9 03/02/2025",
                                            style: $5fc3b9702954e589$var$styles.inpPeriodo,
                                            value: scope.periodo,
                                            onRangeChange: this.onPeriodoChange
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexV, (0, $86645d3d703ed072$export$2e2bcd8739ae039).flexColumnGapBase),
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        style: $5fc3b9702954e589$var$styles.flexGrow,
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$30a931fe40eb4795), {
                                        secondary: true,
                                        style: $5fc3b9702954e589$var$styles.btnLimpar,
                                        onClick: scope.onLimpar,
                                        children: "Limpar filtros"
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$30a931fe40eb4795), {
                                        primary: true,
                                        style: $5fc3b9702954e589$var$styles.btnBuscar,
                                        onClick: scope.onConsultar,
                                        children: "Buscar"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    }
}
var $5fc3b9702954e589$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($5fc3b9702954e589$var$FiltroViewClass);



parcelRequire("jXEQt");





const $30182bbc05aa4947$var$styles = {
    flexCenteredLayout: {
        display: 'flex',
        alignItems: 'center'
    },
    flexGrow: {
        flexGrow: 1
    }
};
class $30182bbc05aa4947$var$ResumoViewClass {
    scope;
    render({ className: className, scope: scope }) {
        this.scope = scope;
        const resumo = scope.data;
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$b59bdbef9ce70de2), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(className),
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).brCard,
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).brCardContent, (0, $86645d3d703ed072$export$2e2bcd8739ae039).consultaReacoesCardTotalReacoes),
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                    style: $30182bbc05aa4947$var$styles.flexCenteredLayout,
                                    children: [
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textBase, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightBold),
                                            style: $30182bbc05aa4947$var$styles.flexGrow,
                                            children: "Notifica\xe7\xf5es"
                                        }),
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                            width: 16,
                                            height: 16,
                                            src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).trendingUpIconUrl
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp03,
                                    children: resumo.qtdeNotificacoes.valor
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textDown02,
                                    children: [
                                        resumo.qtdeNotificacoes.reacoes,
                                        " rea\xe7\xf5es (MedDRA)"
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).brCard,
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).brCardContent, (0, $86645d3d703ed072$export$2e2bcd8739ae039).consultaReacoesCardTotalReacoes),
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                    style: $30182bbc05aa4947$var$styles.flexCenteredLayout,
                                    children: [
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textBase, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightBold),
                                            style: $30182bbc05aa4947$var$styles.flexGrow,
                                            children: "Fora da Bula"
                                        }),
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                            width: 16,
                                            height: 16,
                                            src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).circleAlertIconUrl
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp03,
                                    children: resumo.qtdeForaDeBula.valor
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textDown02,
                                    children: [
                                        resumo.qtdeForaDeBula.reacoes,
                                        " rea\xe7\xf5es n\xe3o documentadas"
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).brCard,
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).brCardContent, (0, $86645d3d703ed072$export$2e2bcd8739ae039).consultaReacoesCardTotalReacoes),
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                    style: $30182bbc05aa4947$var$styles.flexCenteredLayout,
                                    children: [
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textBase, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightBold),
                                            style: $30182bbc05aa4947$var$styles.flexGrow,
                                            children: "N\xe3o Verificadas"
                                        }),
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                            width: 16,
                                            height: 16,
                                            src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).eyeIconUrl
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp03,
                                    children: resumo.qtdeNaoVerificada
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textDown02,
                                    children: "Modelo n\xe3o conseguiu verificar"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$963a4b2511a4b70c), {
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).brCard,
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).brCardContent, (0, $86645d3d703ed072$export$2e2bcd8739ae039).consultaReacoesCardTotalReacoes),
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                    style: $30182bbc05aa4947$var$styles.flexCenteredLayout,
                                    children: [
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textBase, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightBold),
                                            style: $30182bbc05aa4947$var$styles.flexGrow,
                                            children: "Pendentes de Verifica\xe7\xe3o"
                                        }),
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                            width: 16,
                                            height: 16,
                                            src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).eyeIconUrl
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp03,
                                    children: resumo.qtdePendentesVerificacao
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textDown02,
                                    children: "Erros de busca ou lacunas"
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
}
var $30182bbc05aa4947$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($30182bbc05aa4947$var$ResumoViewClass);



parcelRequire("jXEQt");




parcelRequire("jXEQt");






parcelRequire("jXEQt");




const $1a4a5c35f2a4548e$var$styles = {
    self: {
        columnGap: 'var(--spacing-scale-2x)'
    },
    mb0: {
        marginBottom: 0
    }
};
class $1a4a5c35f2a4548e$var$GradeRowDetailViewClass {
    scope;
    render({ scope: scope }) {
        this.scope = scope;
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).row, (0, $86645d3d703ed072$export$2e2bcd8739ae039).noGridGlutter, (0, $86645d3d703ed072$export$2e2bcd8739ae039).m('half')),
            style: $1a4a5c35f2a4548e$var$styles.self,
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)($1a4a5c35f2a4548e$var$DetailCard, {
                    data: scope.left
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)($1a4a5c35f2a4548e$var$DetailCard, {
                    data: scope.right
                })
            ]
        });
    }
}
var $1a4a5c35f2a4548e$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($1a4a5c35f2a4548e$var$GradeRowDetailViewClass);
function $1a4a5c35f2a4548e$var$DetailCard({ data: data }) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($eb3f793683d5662a$exports)))(data) || !data.llt) return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).colMd,
        children: "\xa0"
    });
    const hasGravidadeSim = data.statusGravidade === 2;
    const hasGravidadeNao = data.statusGravidade === 3;
    const hasConferenciaFB = data.statusConferencia === 2;
    const hasConferenciaNV = data.statusConferencia === 3;
    const hasConferenciaNB = data.statusConferencia === 4;
    const hasObito = data.obtito;
    const hasObitoOther = !hasObito;
    //Sel.mt('base')
    return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).brCard, (0, $86645d3d703ed072$export$2e2bcd8739ae039).colMd),
        style: $1a4a5c35f2a4548e$var$styles.mb0,
        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).m('base'), (0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexV),
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexH, (0, $86645d3d703ed072$export$2e2bcd8739ae039).flexGrow1),
                    children: [
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightMedium, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textSm, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textBreakAll),
                            children: data.nome
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textXs, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textGray500, (0, $86645d3d703ed072$export$2e2bcd8739ae039).fontMono, (0, $86645d3d703ed072$export$2e2bcd8739ae039).mt('half')),
                            children: [
                                "PT: ",
                                data.pt
                            ]
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textXs, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textGray500, (0, $86645d3d703ed072$export$2e2bcd8739ae039).fontMono),
                            children: [
                                "LLT: ",
                                data.llt
                            ]
                        }),
                        hasGravidadeSim && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeGravidadeSim, (0, $86645d3d703ed072$export$2e2bcd8739ae039).mt('half')),
                            children: [
                                "Gravidade:",
                                data.gravidadeCount,
                                "/",
                                data.gravidadeCountMax
                            ]
                        }),
                        hasGravidadeNao && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeGravidadeNao, (0, $86645d3d703ed072$export$2e2bcd8739ae039).mt('half')),
                            children: "Gravidade: N\xe3o"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexH, (0, $86645d3d703ed072$export$2e2bcd8739ae039).alignContentCenter),
                    children: [
                        hasConferenciaFB && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeConferenciaForaBula,
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                    src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).circleAlertIconUrl,
                                    width: "16",
                                    height: "16"
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    children: "Fora da Bula"
                                })
                            ]
                        }),
                        hasConferenciaNV && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeConferenciaNaoVerificado,
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                    src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).eyeIconUrl,
                                    width: "16",
                                    height: "16"
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    children: "N\xe3o verificado"
                                })
                            ]
                        }),
                        hasConferenciaNB && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeConferenciaNaBula,
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                    src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).bookOpenIconUrl,
                                    width: "16",
                                    height: "16"
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    children: "Na Bula"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).flexGrow1
                        }),
                        hasObito && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeDefechoMorte, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textCenter),
                            children: "Morte"
                        }),
                        hasObitoOther && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                            children: "\xa0"
                        })
                    ]
                })
            ]
        })
    });
}


const $f32a5790813dd61e$var$styles = {
    gradSubband: {
        backgroundColor: 'rgb(249 250 251)',
        padding: 5
    },
    rowGapHalf: {
        rowGap: 'var(--spacing-scale-half)'
    },
    rowGapBase: {
        rowGap: 'var(--spacing-scale-base)'
    }
};
class $f32a5790813dd61e$var$GradeRowViewClass {
    scope;
    onToggleExpandedClick = ()=>{
        this.scope.expanded = !this.scope.expanded;
    };
    render({ scope: scope }) {
        this.scope = scope;
        const item = scope.data;
        const openCloseIcon = item.mostraDetalheReacoes ? (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).chevronDownconUrl : (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).chevronRightconUrl;
        const showDetail = scope.expanded && scope.rows.length > 0;
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("tr", {
                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeRowHead,
                    onClick: this.onToggleExpandedClick,
                    children: [
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("td", {
                            className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeMostLeftColumn,
                            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("button", {
                                className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).noBgButton,
                                children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                    src: openCloseIcon,
                                    width: "16",
                                    height: "16"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("td", {
                            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textSm, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textBreakAll),
                                        children: item.nome
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textSm, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textGray500),
                                        children: item.nomeQuimico
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("td", {
                            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexH,
                                style: $f32a5790813dd61e$var$styles.rowGapHalf,
                                children: [
                                    item.statusNaBula > 0 && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeConferenciaNaBula,
                                        children: [
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                                src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).eyeIconUrl,
                                                width: "16",
                                                height: "16"
                                            }),
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                                children: [
                                                    item.statusForaDaBula,
                                                    " na nula"
                                                ]
                                            })
                                        ]
                                    }),
                                    item.statusForaDaBula > 0 && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeConferenciaForaBula,
                                        children: [
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                                src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).bookOpenIconUrl,
                                                width: "16",
                                                height: "16"
                                            }),
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                                children: [
                                                    item.statusForaDaBula,
                                                    " fora da bula"
                                                ]
                                            })
                                        ]
                                    }),
                                    item.statusConferencia > 0 && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeConferenciaNaoVerificado,
                                        children: [
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("img", {
                                                src: (0, $fd8640ac4e3047b7$export$2e2bcd8739ae039).circleAlertIconUrl,
                                                width: "16",
                                                height: "16"
                                            }),
                                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                                children: [
                                                    item.statusConferencia,
                                                    " n\xe3o verificado(s)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("td", {
                            children: [
                                item.statusGravidade > 0 && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).gradeGravidadeSim, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textXs, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightSemiBold),
                                    children: item.statusGravidade
                                }),
                                item.statusGravidade === 0 && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    children: "\xa0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("td", {
                            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                                className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexH, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp01),
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textNoWrap,
                                        children: [
                                            item.qtdeCasos,
                                            " casos"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textNoWrap,
                                        children: [
                                            item.qtdeReacoes,
                                            " rea\xe7\xf5es"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                showDetail && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("td", {
                        colSpan: 8,
                        style: $f32a5790813dd61e$var$styles.gradSubband,
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexH,
                            style: $f32a5790813dd61e$var$styles.rowGapBase,
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightLight, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp02, (0, $86645d3d703ed072$export$2e2bcd8739ae039).mt('1')),
                                    children: "Detalhes das Rea\xe7\xf5es (MedDRA):"
                                }),
                                scope.rows.map((rowScope)=>/*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $1a4a5c35f2a4548e$export$2e2bcd8739ae039), {
                                        scope: rowScope
                                    }, rowScope.uid))
                            ]
                        })
                    })
                })
            ]
        });
    }
}
var $f32a5790813dd61e$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($f32a5790813dd61e$var$GradeRowViewClass);


class $124e7ff3209ce902$var$GradeViewClass {
    scope;
    render({ className: className, scope: scope }) {
        this.scope = scope;
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).brCard, className),
            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).brCardContent,
                children: [
                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlexH,
                        children: [
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp02, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightSemiBold),
                                children: "Notifica\xe7\xf5es de Rea\xe7\xf5es Adversas"
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).textBase,
                                children: [
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("span", {
                                        children: [
                                            "\u2022 Per\xedodo de an\xe1lise: ",
                                            scope.periodoDeAnalise
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("span", {
                                        children: "\u2022 Clique para expandir detalhes das rea\xe7\xf5es"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("table", {
                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).consultaReacoesGrade,
                        children: [
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("th", {}),
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("th", {
                                            children: "Medicamento (WHO Drug)"
                                        }),
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("th", {
                                            children: "Status Confer\xeancia"
                                        }),
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("th", {
                                            children: "Gravidade"
                                        }),
                                        /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("th", {
                                            children: "Casos"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("tbody", {
                                children: scope.rows.map((rowScope)=>/*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $f32a5790813dd61e$export$2e2bcd8739ae039), {
                                        scope: rowScope
                                    }, rowScope.uid))
                            })
                        ]
                    })
                ]
            })
        });
    }
}
var $124e7ff3209ce902$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($124e7ff3209ce902$var$GradeViewClass);



class $e7c993a1a04ffdd0$var$AnaliseReacoesViewClass {
    scope;
    render({ className: className, scope: scope }) {
        this.scope = scope;
        const gradeElm = scope.loading ? /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
            className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).mLg('10xh'),
            children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $ca0c2c480f9252ec$export$48493b3d35ec1140), {
                large: true,
                label: "Buscando dados..."
            })
        }) : /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $56c05cee281658b4$exports.Fragment), {
            children: [
                (0, (/*@__PURE__*/$parcel$interopDefault($eb3f793683d5662a$exports)))(scope.resumo) && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $30182bbc05aa4947$export$2e2bcd8739ae039), {
                    scope: scope.resumo
                }),
                (0, (/*@__PURE__*/$parcel$interopDefault($eb3f793683d5662a$exports)))(scope.grade) && /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $124e7ff3209ce902$export$2e2bcd8739ae039), {
                    scope: scope.grade
                })
            ]
        });
        return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)((0, $ca0c2c480f9252ec$export$42a852a2b6b56249), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(className),
            children: [
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                    className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).brCardHeader,
                    children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                        className: (0, $86645d3d703ed072$export$2e2bcd8739ae039).dFlex,
                        children: /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((0, $86645d3d703ed072$export$2e2bcd8739ae039).textWeightSemiBold, (0, $86645d3d703ed072$export$2e2bcd8739ae039).textUp02),
                                    children: "Monitoramento de Rea\xe7\xf5es Adversas"
                                }),
                                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("div", {
                                    children: "MedDRA \u2022 WHO Drug \u2022 Confer\xeancia de Bula Automatizada"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $5fc3b9702954e589$export$2e2bcd8739ae039), {
                    scope: scope.filtro
                }),
                gradeElm
            ]
        });
    }
}
var $e7c993a1a04ffdd0$export$2e2bcd8739ae039 = (0, $46f12576962907f4$export$20f9025f645507a0)($e7c993a1a04ffdd0$var$AnaliseReacoesViewClass);


function $c5e98b3ed231863b$export$9be1907ba6822108(rr) {
    rr((0, $0679dd9080d488b2$export$2e2bcd8739ae039), (0, $e7c993a1a04ffdd0$export$2e2bcd8739ae039));
}


function $c0c521a359bc2b24$export$da1e94225714e87d() {
    const rr = (0, $a21dea676972c64f$export$918c359d6182b34e).register;
    (0, $40c142f37dcabbfe$export$9be1907ba6822108)(rr);
    (0, $69e76fc3320da60c$export$9be1907ba6822108)(rr);
    (0, $c5e98b3ed231863b$export$9be1907ba6822108)(rr);
}






// sessionStorage = data is cleared when the page session ends.
// localStorage = data is bounded to the site, it does not expires

class $4b83de36aa04307d$export$b9721ef022f71a68 extends Error {
}
$4b83de36aa04307d$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $4b83de36aa04307d$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $4b83de36aa04307d$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $4b83de36aa04307d$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $4b83de36aa04307d$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $4b83de36aa04307d$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $4b83de36aa04307d$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $4b83de36aa04307d$var$base64UrlDecode(part);
    } catch (e) {
        throw new $4b83de36aa04307d$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $4b83de36aa04307d$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}






const $55b463131d86c963$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('AppStorage');
const $55b463131d86c963$var$EXPIRATION_DATE_IN_MILLIS = Date.now();
class $55b463131d86c963$export$4ddd19fa511f0c3c {
    __eventIdGen = 0;
    __tokenAbouteToExpireMap = new Map();
    __tokenAboutToExpireTimeHandler = (0, $5e892709dbe5636f$export$49db20642bd540b0);
    __rememberMeProp = $55b463131d86c963$var$newLocalStorageBoolProperty('3ae9b5f1');
    __accesssTokenProp = $55b463131d86c963$var$newStorageStringProperty('a9c07324');
    get rememberMe() {
        return this.__rememberMeProp.get();
    }
    get accessTokenExpiration() {
        try {
            const accessToken = this.accessToken;
            if (!accessToken) return $55b463131d86c963$var$EXPIRATION_DATE_IN_MILLIS;
            const info = $55b463131d86c963$var$decodeAccessToken(accessToken);
            return info.exp * 1000;
        } catch (err) {
            $55b463131d86c963$var$LOG.error('[accessTokenExpirationDate]', err);
            return $55b463131d86c963$var$EXPIRATION_DATE_IN_MILLIS;
        }
    }
    get accessToken() {
        return this.__accesssTokenProp.get();
    }
    clearAccessToken() {
        this.__rememberMeProp.clear();
        this.__accesssTokenProp.clear();
        this.__tokenAboutToExpireTimeHandler();
        this.__tokenAboutToExpireTimeHandler = (0, $5e892709dbe5636f$export$49db20642bd540b0);
    }
    setAuthorization(value, rememberMe) {
        this.__rememberMeProp.set(rememberMe, false);
        const token = this.__accesssTokenProp.get();
        this.launchTokenExpirationTimeout(token);
    }
    setAccessToken(value, rememberMe) {
        this.clearAccessToken();
        if (!value || !value.token) return;
        this.__accesssTokenProp.set(value.token, rememberMe);
        this.setAuthorization(value, rememberMe);
    }
    onAccessTokenAboutToExpire(listener) {
        const eventId = this.__eventIdGen++;
        this.__tokenAbouteToExpireMap.set(eventId, listener);
        const accessToken = this.accessToken;
        if (accessToken) this.launchTokenExpirationTimeout(accessToken);
        else {
            this.__tokenAboutToExpireTimeHandler();
            this.__tokenAboutToExpireTimeHandler = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        }
        return ()=>{
            this.__tokenAbouteToExpireMap.delete(eventId);
        };
    }
    launchTokenExpirationTimeout(accessToken) {
        this.__tokenAboutToExpireTimeHandler();
        this.__tokenAboutToExpireTimeHandler = (0, $5e892709dbe5636f$export$49db20642bd540b0);
        const info = $55b463131d86c963$var$decodeAccessToken(accessToken);
        const millisToExpire = $55b463131d86c963$var$differenceInMilliseconds(info.exp * 1000, Date.now());
        if (millisToExpire > 0) {
            const refreshToken = ()=>{
                for (const listener of this.__tokenAbouteToExpireMap.values())try {
                    listener(this, accessToken);
                } catch (err) {
                    $55b463131d86c963$var$LOG.error(`Processing listner ${listener}`, err);
                }
            };
            const oneHourInMillis = $55b463131d86c963$var$minutesToMilliseconds(60);
            if (millisToExpire < oneHourInMillis) // Do it now
            refreshToken();
            // And, refresh at fix rate of one hour
            this.__tokenAboutToExpireTimeHandler = $55b463131d86c963$var$scheduleAtFixRate(refreshToken, oneHourInMillis);
        }
    }
}
const $55b463131d86c963$var$APP_STORAGE_INSTANCE = new $55b463131d86c963$export$4ddd19fa511f0c3c();
(0, $15ce1f86191d2574$export$2e2bcd8739ae039).setTokenProvider(()=>$55b463131d86c963$var$APP_STORAGE_INSTANCE.accessToken);
var $55b463131d86c963$export$2e2bcd8739ae039 = $55b463131d86c963$var$APP_STORAGE_INSTANCE;
// :: Internal
function $55b463131d86c963$var$decodeAccessToken(accessToken) {
    return (0, $4b83de36aa04307d$export$fa1e2fb699b7861e)(accessToken);
}
function $55b463131d86c963$var$scheduleAtFixRate(listner, interval) {
    const ctx = {
        handler: undefined,
        stoped: false
    };
    const relauchListener = ()=>{
        if (ctx.stoped) return;
        try {
            ctx.handler = undefined;
            listner();
        } catch (err) {
            $55b463131d86c963$var$LOG.error('[scheduleAtFixRate]', err);
        } finally{
            ctx.handler = setTimeout(relauchListener, interval);
        }
    };
    ctx.handler = setTimeout(relauchListener, interval);
    return ()=>{
        ctx.stoped = true;
        if (ctx.handler) {
            clearTimeout(ctx.handler);
            ctx.handler = undefined;
        }
    };
}
function $55b463131d86c963$var$newLocalStorageBoolProperty(uid) {
    return {
        set: (value)=>{
            localStorage.setItem(uid, value ? 'true' : 'false');
        },
        get: ()=>{
            return localStorage.getItem(uid) === 'true';
        },
        clear: ()=>{
            localStorage.removeItem(uid);
        }
    };
}
function $55b463131d86c963$var$newStorageStringProperty(uid) {
    return {
        set: (value, rememberMe)=>{
            if (rememberMe) {
                if (value) localStorage.setItem(uid, `${value}`);
                else localStorage.removeItem(uid);
                sessionStorage.removeItem(uid);
            } else {
                if (value) sessionStorage.setItem(uid, `${value}`);
                else sessionStorage.removeItem(uid);
                localStorage.removeItem(uid);
            }
        },
        get: ()=>{
            return localStorage.getItem(uid) || sessionStorage.getItem(uid) || '';
        },
        clear: ()=>{
            localStorage.removeItem(uid);
            sessionStorage.removeItem(uid);
        }
    };
}
function $55b463131d86c963$var$differenceInMilliseconds(a, b) {
    return a - b;
}
function $55b463131d86c963$var$minutesToMilliseconds(minutes) {
    return minutes * 60000;
}


const $d9ee15751ed09862$var$LOG = (0, $e6bdec9b5bfe1ac0$export$efa9a398d6368992).get('MainPresenter');
const $d9ee15751ed09862$var$ANONYMOUS_TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsaWZlc2h1Yi5jb20uYnIiLCJpYXQiOjE3NjY3OTEwNTgsImV4cCI6MTc5ODMyNzA1OCwiYXVkIjoibGlmZXNodWIuY29tLmJyIiwic3ViIjoiYW5vbnltb3VzIiwiR2l2ZW5OYW1lIjoiU29tZW9uZSIsIlJvbGUiOiJVc2VyIn0.rW2RF1DlXW0BOO961Y4DgFmwQsdcVlpkWtqYDmRfvmw";
class $d9ee15751ed09862$export$c530141ca755a31f extends (0, $89dce1c0df43c9b3$export$a535e3551110f5b9) {
    // :: Instance
    homeScope = new (0, $f281847c15bd8905$export$4b106156bfc1c581)();
    menuManager = new $d9ee15751ed09862$var$MenuManager(this);
    stopServices = (0, $5e892709dbe5636f$export$a8765dfddffd7953);
    constructor(historyManager){
        super(historyManager, new (0, $f281847c15bd8905$export$d8d9d79b6626505f)());
        this.scope.header.update = this.update;
        this.scope.menu.update = this.update;
        this.homeScope.update = this.update;
        this.setPlaces((0, $111375feb76f4602$export$ab4fed16567445e2));
    }
    initialize() {
        this.scope.onLogin = this.action(this.onLogin);
        this.scope.onHome = this.action(this.onHome.onClick);
        this.scope.onAnaliseBulas = this.action(this.onAnaliseBulas.onClick);
        this.scope.onAnaliseReacoes = this.action(this.onAnaliseReacoes.onClick);
        this.scope.update = this.update;
        this.scope.header.version = '1.0.0';
        this.scope.header.title = 'Busca Certa I.A.';
        this.scope.header.subtitle = 'FAPESC / Lifeshub';
        this.scope.header.onHome = this.action(this.onHome.onClick);
        this.scope.header.onClickLogin = this.action(this.onLogin);
        this.scope.header.onAlert = this.action(this.onOpenAlert);
        this.scope.header.onIndicadores = this.action(this.onIndicadores);
        this.scope.header.onTrocaTema = this.action(this.onTrocaTema);
        this.scope.header.update = this.update;
        this.scope.menu.version = 0;
        this.scope.menu.items = [];
        this.scope.menu.update = this.update;
        this.homeScope.onOpenAlert = this.action(this.onOpenAlert);
        this.homeScope.update = this.update;
        this.scope.page = this.homeScope;
        return this.bootstrap();
    }
    release() {
        this.stopServices().catch(()=>void 0);
        super.release();
    }
    bootstrap() {
        let initialized = false;
        const bootstrap = async ()=>{
            try {
                await this.kickStart((0, $111375feb76f4602$export$ab4fed16567445e2).main);
                initialized = true;
            } catch (error) {
                $d9ee15751ed09862$var$LOG.error('Initializing', error);
                this.release();
            }
        };
        bootstrap().catch($d9ee15751ed09862$var$LOG.caught);
        return ()=>{
            if (initialized) this.release();
        };
    }
    async applyParameters(intent, initialization, last) {
        const keys = new (0, $bb6e76f992d97bab$export$2089ee9a829aa848)(this, intent);
        if (initialization) {
            await this.intializeState(keys);
            try {
                const targetUri = this.newIntentFromString(this.historyManager.location);
                if (targetUri.toString() !== intent.toString()) {
                    await this.flipToIntent(targetUri);
                    return false;
                }
            } catch (caught) {
                this.unexpected('Navigation from history', caught);
            }
        }
        if (last) this.pageSlot(undefined);
        else {
            keys.parentSlot = this.pageSlot;
            keys.dialogSlot = this.dialogSlot;
        }
        this.menuManager.ativateItemByPlace(intent.place);
        return true;
    }
    async intializeState(keys) {
        this.stopServices = await (0, $b2874cb6e934257b$export$962600625ce79e2e).start();
        this.scope.header.loggedIn = true;
        (0, $55b463131d86c963$export$2e2bcd8739ae039).setAccessToken({
            token: $d9ee15751ed09862$var$ANONYMOUS_TOKEN
        }, false);
        this.buildMenu();
        this.scope.header.quickLinkData = [
            {
                label: this.onAnaliseBulas.label,
                onClick: this.onAnaliseBulas.onClick
            },
            {
                label: this.onAnaliseReacoes.label,
                onClick: this.onAnaliseReacoes.onClick
            }
        ];
        this.scope.header.quickLinkVersion++;
        $d9ee15751ed09862$var$LOG.info(`Initialized(${keys.toString()})`);
    }
    // :: Helper API
    unexpected(message, error) {
        super.unexpected(message, error);
        this.alert('error', 'Unexpected error', message);
    }
    alert(severity, title, message, onClose) {
        const alertScope = new (0, $f281847c15bd8905$export$884432535b5866ab)();
        alertScope.severity = severity;
        alertScope.title = title;
        alertScope.message = message;
        alertScope.minWidth = 300;
        const saveClose = this.action(this.onCloseAlert);
        if (onClose) alertScope.onClose = ()=>saveClose(onClose);
        else alertScope.onClose = saveClose;
        alertScope.primaryAction = {
            label: 'Fechar',
            action: alertScope.onClose
        };
        alertScope.update = this.update;
        this.scope.alert = alertScope;
    }
    // :: View Actions
    pageSlot = (scope)=>{
        this.scope.page = scope ?? this.homeScope;
    };
    dialogSlot = (scope)=>{
        if (this.scope.dialog !== scope) {
            this.scope.dialog = scope;
            if (this.scope.dialog && !this.scope.dialog.onClose) $d9ee15751ed09862$var$LOG.error(`Missing onClose action on scope ${this.scope.dialog.constructor.name}`);
        }
    };
    onCloseAlert = async (onClose)=>{
        this.scope.alert = undefined;
        if (onClose) await onClose();
    };
    onHome = this.menuManager.addItem((0, $111375feb76f4602$export$ab4fed16567445e2).main, {
        label: "P\xe1gina Inicial",
        icon: 'home',
        divider: true,
        onClick: async ()=>{
            this.scope.page = this.homeScope;
            await this.flip(this.rootPlace);
        }
    });
    onAnaliseBulas = this.menuManager.addItem((0, $111375feb76f4602$export$ab4fed16567445e2).analiseBulas, {
        label: "An\xe1lise de Bulas",
        icon: 'medkit',
        onClick: async ()=>{
            await this.flip((0, $111375feb76f4602$export$ab4fed16567445e2).analiseBulas);
        }
    });
    onAnaliseReacoes = this.menuManager.addItem((0, $111375feb76f4602$export$ab4fed16567445e2).analiseReacoes, {
        label: "An\xe1lise de Rea\xe7\xf5es",
        icon: 'hospital',
        onClick: async ()=>{
            await this.flip((0, $111375feb76f4602$export$ab4fed16567445e2).analiseReacoes);
        }
    });
    onLogin = async ()=>{
        this.scope.header.loggedIn = true;
        this.alert('info', 'Working in progress...', 'No implementation to this action, yet.');
    };
    onIndicadores = async ()=>{
        this.alert('info', "Informa\xe7\xe3o", 'Implementar Indicadores', this.onCloseAlert);
    };
    onTrocaTema = async ()=>{
        this.alert('success', "Informa\xe7\xe3o", 'Implementar troca de tema', this.onCloseAlert);
    };
    onOpenAlert = async (severity)=>{
        $d9ee15751ed09862$var$LOG.info('onAlert clicked');
        this.alert(severity, 'Some title', 'Some message', async ()=>{
            $d9ee15751ed09862$var$LOG.info(`Alert with severity ${severity} was closed`);
        });
    };
    buildMenu() {
        this.scope.menu.version++;
        this.scope.menu.items = [
            this.onHome,
            this.onAnaliseBulas
        ];
    }
}
class $d9ee15751ed09862$var$MenuManager {
    owner;
    activableMenuItenMap = new Map();
    constructor(owner){
        this.owner = owner;
    }
    addItem(place, item) {
        if (item.onClick) {
            this.activableMenuItenMap.set(place, item);
            const realOnClick = item.onClick;
            item.onClick = this.owner.action(async ()=>{
                try {
                    await realOnClick();
                } finally{
                    this.doActivateItem(item);
                }
            });
        }
        return item;
    }
    ativateItemByPlace(place) {
        const item = this.activableMenuItenMap.get(place);
        item && this.doActivateItem(item);
    }
    doActivateItem(itemToBeActivate) {
        for (const item of this.activableMenuItenMap.values())item.active = itemToBeActivate === item;
        this.owner.scope.menu.version++;
    }
}



(0, $c0c521a359bc2b24$export$da1e94225714e87d)();
(0, $e1a4a40ca595b517$export$2a47f398eeff8b01)();
const $a227dccff722c2f9$var$MainPresenterFactory = ()=>new (0, $d9ee15751ed09862$export$c530141ca755a31f)(new (0, $acdfd7506f8bc11c$export$472e0511de4744d1)(true));
function $a227dccff722c2f9$var$App() {
    const presenter = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).useMemo($a227dccff722c2f9$var$MainPresenterFactory, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).useEffect(()=>{
        const handleOnComponentWillUnmount = presenter.initialize();
        return ()=>{
            handleOnComponentWillUnmount();
        };
    }, [
        presenter
    ]);
    return /*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)((0, $63e4627a3b25d412$export$2e2bcd8739ae039), {
        scope: presenter.scope
    });
}
const $a227dccff722c2f9$var$rootElm = document.getElementById('root');
if ($a227dccff722c2f9$var$rootElm) {
    const root = (0, $bb6cb2ce16bd7b19$exports.createRoot)($a227dccff722c2f9$var$rootElm);
    root.render(/*#__PURE__*/ (0, $56c05cee281658b4$exports.jsx)($a227dccff722c2f9$var$App, {}));
}


//# sourceMappingURL=site.f6470c7b.js.map
